(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.m.kN === region.j.kN)
	{
		return 'on line ' + region.m.kN;
	}
	return 'on lines ' + region.m.kN + ' through ' + region.j.kN;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nB,
		impl.pQ,
		impl.pF,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		nZ: func(record.nZ),
		pC: record.pC,
		pb: record.pb
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.nZ;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.pC;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.pb) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nB,
		impl.pQ,
		impl.pF,
		function(sendToApp, initialModel) {
			var view = impl.pS;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nB,
		impl.pQ,
		impl.pF,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.iL && impl.iL(sendToApp)
			var view = impl.pS;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.getElementById("elmIsolationContainer");
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.f3);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.i4) && (_VirtualDom_doc.title = title = doc.i4);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.oZ;
	var onUrlRequest = impl.o_;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		iL: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.pd === next.pd
							&& curr.nw === next.nw
							&& curr.o7.a === next.o7.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		nB: function(flags)
		{
			return A3(impl.nB, flags, _Browser_getUrl(), key);
		},
		pS: impl.pS,
		pQ: impl.pQ,
		pF: impl.pF
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { nt: 'hidden', mK: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { nt: 'mozHidden', mK: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { nt: 'msHidden', mK: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { nt: 'webkitHidden', mK: 'webkitvisibilitychange' }
		: { nt: 'hidden', mK: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		lK: _Browser_getScene(),
		mf: {
			mj: _Browser_window.pageXOffset,
			mk: _Browser_window.pageYOffset,
			dX: _Browser_doc.documentElement.clientWidth,
			gW: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		dX: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		gW: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			lK: {
				dX: node.scrollWidth,
				gW: node.scrollHeight
			},
			mf: {
				mj: node.scrollLeft,
				mk: node.scrollTop,
				dX: node.clientWidth,
				gW: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			lK: _Browser_getScene(),
			mf: {
				mj: x,
				mk: y,
				dX: _Browser_doc.documentElement.clientWidth,
				gW: _Browser_doc.documentElement.clientHeight
			},
			m6: {
				mj: x + rect.left,
				mk: y + rect.top,
				dX: rect.width,
				gW: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.na.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.na.b, xhr)); });
		$elm$core$Maybe$isJust(request.pP) && _Http_track(router, xhr, request.pP.a);

		try {
			xhr.open(request.e1, request.i7, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.i7));
		}

		_Http_configureRequest(xhr, request);

		request.f3.a && xhr.setRequestHeader('Content-Type', request.f3.a);
		xhr.send(request.f3.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ns; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.pL.a || 0;
	xhr.responseType = request.na.d;
	xhr.withCredentials = request.mv;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		i7: xhr.responseURL,
		pA: xhr.status,
		pB: xhr.statusText,
		ns: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			px: event.loaded,
			aR: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			ph: event.loaded,
			aR: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.kS) { flags += 'm'; }
	if (options.jD) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });
var $author$project$Msg$OnUrlChange = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$OnUrlRequest = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.s) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.w),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.w);
		} else {
			var treeLen = builder.s * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.y) : builder.y;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.s);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.w) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.w);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{y: nodeList, s: (len / $elm$core$Array$branchFactor) | 0, w: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ng: fragment, nw: host, o5: path, o7: port_, pd: protocol, lA: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Msg$GotLogoutResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$Login = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$NotAuthorized = function (a) {
	return {$: 4, a: a};
};
var $author$project$Msg$NotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$OfferDetails = function (a) {
	return {$: 11, a: a};
};
var $author$project$Msg$Payment = function (a) {
	return {$: 9, a: a};
};
var $author$project$Msg$PolicyDetails = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$Search = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.pA));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Env$logoutPath = function (_v0) {
	var environment = _v0;
	return environment.dd;
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {lG: reqs, l4: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.pP;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.lG));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.l4)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					mv: r.mv,
					f3: r.f3,
					na: A2(_Http_mapExpect, func, r.na),
					ns: r.ns,
					e1: r.e1,
					pL: r.pL,
					pP: r.pP,
					i7: r.i7
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{mv: true, f3: r.f3, na: r.na, ns: r.ns, e1: r.e1, pL: r.pL, pP: r.pP, i7: r.i7}));
};
var $author$project$Utils$executeLogout = F3(
	function (env, urlExtractor, tagger) {
		return $elm$http$Http$riskyRequest(
			{
				f3: $elm$http$Http$emptyBody,
				na: $elm$http$Http$expectWhatever(tagger),
				ns: _List_Nil,
				e1: 'POST',
				pL: $elm$core$Maybe$Nothing,
				pP: $elm$core$Maybe$Nothing,
				i7: _Utils_ap(
					urlExtractor(env),
					$author$project$Env$logoutPath(env))
			});
	});
var $author$project$Env$languageOverride = function (_v0) {
	var environment = _v0;
	return environment.c8;
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Env$newApiUrl = function (_v0) {
	var environment = _v0;
	return environment.df;
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Page$Login$Msg$GotAuthCheckResult = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Task$fail = _Scheduler_fail;
var $dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors = function (successOrError) {
	if (!successOrError.$) {
		var value = successOrError.a;
		return $elm$core$Task$succeed(value);
	} else {
		var _v1 = successOrError.a;
		var possiblyParsedData = _v1.a;
		var graphqlErrorGraphqlErrorList = _v1.b;
		return $elm$core$Task$fail(
			A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, graphqlErrorGraphqlErrorList));
	}
};
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {$: 2};
var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $dillonkearns$elm_graphql$Graphql$Http$jsonResolver = function (decoder) {
	return $elm$http$Http$stringResolver(
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
				case 2:
					return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
				case 3:
					var metadata = response.a;
					var body = response.b;
					return $elm$core$Result$Err(
						A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
				default:
					var metadata = response.a;
					var body = response.b;
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
					}
			}
		});
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.de;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{y: nodeList, s: nodeListSize, w: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {e: index, de: match, og: number, l3: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{jD: false, kS: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {bG: charsProcessed, bR: hash, bp: seed, cm: shift};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
	var acc = (!(!data.bR)) ? (data.bp ^ A2(
		$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
		A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
			15,
			A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.bR)))) : data.bp;
	var h0 = acc ^ data.bG;
	var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(
	function (h1, k1) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
			5,
			A2(
				$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
				13,
				h1 ^ A2(
					$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
					$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
						15,
						A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(
	function (c, data) {
		var res = data.bR | ((255 & $elm$core$Char$toCode(c)) << data.cm);
		var _v0 = data.cm;
		if (_v0 === 24) {
			return {
				bG: data.bG + 1,
				bR: 0,
				bp: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.bp, res),
				cm: 0
			};
		} else {
			return {bG: data.bG + 1, bR: res, bp: data.bp, cm: data.cm + 8};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(
	function (seed, str) {
		return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(
			A3(
				$elm$core$String$foldl,
				$dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold,
				A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0),
				str));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
	var serializeJson = function (json) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$List,
						$elm$core$List$map($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$Object,
						$elm$core$List$map(
							$elm$core$Tuple$mapSecond($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json))),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))
				]));
		var _v2 = A2($elm$json$Json$Decode$decodeValue, decoder, json);
		if (!_v2.$) {
			var v = _v2.a;
			return $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(v);
		} else {
			return A2($elm$json$Json$Encode$encode, 0, json);
		}
	};
	switch (value.$) {
		case 0:
			var enumValue = value.a;
			return enumValue;
		case 1:
			var json = value.a;
			return serializeJson(json);
		case 2:
			var values = value.a;
			return '[' + (A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
		default:
			var keyValuePairs = value.a;
			return '{' + (A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var objectValue = _v1.b;
						return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
					},
					keyValuePairs)) + '}');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
	if (!args.b) {
		return '';
	} else {
		var nonemptyArgs = args;
		return '(' + (A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
	return A2(
		$elm$core$Maybe$map,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0),
		function () {
			if (!field.$) {
				var name = field.a;
				var _arguments = field.b;
				var children = field.c;
				return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
			} else {
				var typeString = field.a.mc;
				var fieldName = field.a.kg;
				var _arguments = field.b;
				return (fieldName === '__typename') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$concat(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[typeString]),
							$elm$core$List$singleton(
								$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
			}
		}());
};
var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
	if (!field.$) {
		var fieldName = field.a;
		var argumentList = field.b;
		var fieldList = field.c;
		return fieldName;
	} else {
		var typeString = field.a.mc;
		var fieldName = field.a.kg;
		var argumentList = field.b;
		return fieldName;
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
	return A2(
		$elm$core$Maybe$map,
		function (aliasHash) {
			return _Utils_ap(
				$dillonkearns$elm_graphql$Graphql$RawField$name(field),
				$elm$core$String$fromInt(aliasHash));
		},
		$dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
};
var $j_maas$elm_ordered_containers$OrderedDict$OrderedDict = $elm$core$Basics$identity;
var $j_maas$elm_ordered_containers$OrderedDict$empty = {p: $elm$core$Dict$empty, o2: _List_Nil};
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields = function (rawFields) {
	var compositeCount = $elm$core$List$length(
		A2(
			$elm$core$List$filterMap,
			function (field) {
				if (!field.$) {
					return $elm$core$Maybe$Just(0);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			rawFields));
	if (compositeCount <= 1) {
		return $elm$core$Set$empty;
	} else {
		var levelBelowNodes = A2(
			$elm$core$List$concatMap,
			function (field) {
				if (field.$ === 1) {
					return _List_Nil;
				} else {
					var children = field.c;
					return children;
				}
			},
			rawFields);
		var fieldTypes = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, acc) {
					var fieldName = _v1.a;
					var fieldType = _v1.b;
					return A3(
						$elm$core$Dict$update,
						fieldName,
						function (maybeFieldTypes) {
							if (maybeFieldTypes.$ === 1) {
								return $elm$core$Maybe$Just(
									$elm$core$Set$singleton(fieldType));
							} else {
								var fieldTypes_ = maybeFieldTypes.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$Set$insert, fieldType, fieldTypes_));
							}
						},
						acc);
				}),
			$elm$core$Dict$empty,
			A2(
				$elm$core$List$filterMap,
				function (field) {
					if (field.$ === 1) {
						var typeString = field.a.mc;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$dillonkearns$elm_graphql$Graphql$RawField$name(field),
								typeString));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				levelBelowNodes));
		return $elm$core$Set$fromList(
			$elm$core$Dict$keys(
				A2(
					$elm$core$Dict$filter,
					F2(
						function (fieldType, fields) {
							return function (size) {
								return size > 1;
							}(
								$elm$core$Set$size(fields));
						}),
					fieldTypes)));
	}
};
var $j_maas$elm_ordered_containers$OrderedDict$get = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return A2($elm$core$Dict$get, key, orderedDict.p);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $j_maas$elm_ordered_containers$OrderedDict$insert = F3(
	function (key, value, _v0) {
		var orderedDict = _v0;
		var filteredOrder = A2($elm$core$Dict$member, key, orderedDict.p) ? A2(
			$elm$core$List$filter,
			function (k) {
				return !_Utils_eq(k, key);
			},
			orderedDict.o2) : orderedDict.o2;
		var newOrder = _Utils_ap(
			filteredOrder,
			_List_fromArray(
				[key]));
		return {
			p: A3($elm$core$Dict$insert, key, value, orderedDict.p),
			o2: newOrder
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$remove = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return {
			p: A2($elm$core$Dict$remove, key, orderedDict.p),
			o2: A2($elm$core$Dict$member, key, orderedDict.p) ? A2(
				$elm$core$List$filter,
				function (k) {
					return !_Utils_eq(k, key);
				},
				orderedDict.o2) : orderedDict.o2
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$update = F3(
	function (key, alter, original) {
		var orderedDict = original;
		var _v0 = A2($elm$core$Dict$get, key, orderedDict.p);
		if (!_v0.$) {
			var oldItem = _v0.a;
			var _v1 = alter(
				$elm$core$Maybe$Just(oldItem));
			if (!_v1.$) {
				var newItem = _v1.a;
				return {
					p: A3(
						$elm$core$Dict$update,
						key,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(newItem)),
						orderedDict.p),
					o2: orderedDict.o2
				};
			} else {
				return A2($j_maas$elm_ordered_containers$OrderedDict$remove, key, original);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var newItem = _v2.a;
				return A3($j_maas$elm_ordered_containers$OrderedDict$insert, key, newItem, original);
			} else {
				return original;
			}
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing = F2(
	function (forceHashing, rawFields) {
		var fieldCounts = A3(
			$elm$core$List$foldl,
			F2(
				function (fld, acc) {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						fld,
						function (val) {
							return $elm$core$Maybe$Just(
								function () {
									if (val.$ === 1) {
										return 0;
									} else {
										var count = val.a;
										return count + 1;
									}
								}());
						},
						acc);
				}),
			$j_maas$elm_ordered_containers$OrderedDict$empty,
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$RawField$name, rawFields));
		var conflictingTypeFields = $dillonkearns$elm_graphql$Graphql$Document$Field$findConflictingTypeFields(rawFields);
		return A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_Tuple3(
					field,
					A2(
						$elm$core$Set$member,
						$dillonkearns$elm_graphql$Graphql$RawField$name(field),
						forceHashing) ? $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field) : ((!A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$j_maas$elm_ordered_containers$OrderedDict$get,
							$dillonkearns$elm_graphql$Graphql$RawField$name(field),
							fieldCounts))) ? $elm$core$Maybe$Nothing : $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field)),
					conflictingTypeFields);
			},
			rawFields);
	});
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
	return A2($elm$core$String$repeat, indentationLevel, '  ');
};
var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$RawField$name(field),
		$dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields = function (rawFields) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (field, mergedSoFar) {
				if (!field.$) {
					var newChildren = field.c;
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							if (maybeChildrenSoFar.$ === 1) {
								return $elm$core$Maybe$Just(field);
							} else {
								if (!maybeChildrenSoFar.a.$) {
									var _v2 = maybeChildrenSoFar.a;
									var existingFieldName = _v2.a;
									var existingArgs = _v2.b;
									var existingChildren = _v2.c;
									return $elm$core$Maybe$Just(
										A3(
											$dillonkearns$elm_graphql$Graphql$RawField$Composite,
											existingFieldName,
											existingArgs,
											_Utils_ap(existingChildren, newChildren)));
								} else {
									return $elm$core$Maybe$Just(field);
								}
							}
						},
						mergedSoFar);
				} else {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							return $elm$core$Maybe$Just(
								A2($elm$core$Maybe$withDefault, field, maybeChildrenSoFar));
						},
						mergedSoFar);
				}
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		rawFields);
};
var $j_maas$elm_ordered_containers$OrderedDict$values = function (_v0) {
	var orderedDict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (key) {
			return A2($elm$core$Dict$get, key, orderedDict.p);
		},
		orderedDict.o2);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields = function (children) {
	return $j_maas$elm_ordered_containers$OrderedDict$values(
		$dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields(children));
};
var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2(
	$dillonkearns$elm_graphql$Graphql$RawField$Leaf,
	{kg: '__typename', mc: ''},
	_List_Nil);
var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
	return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F4(
	function (forceHashing, aliasName, mIndentationLevel, field) {
		var prefix = function () {
			if (!aliasName.$) {
				var aliasName_ = aliasName.a;
				return _Utils_ap(
					aliasName_,
					function () {
						if (!mIndentationLevel.$) {
							return ': ';
						} else {
							return ':';
						}
					}());
			} else {
				return '';
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (string) {
				return _Utils_ap(
					$dillonkearns$elm_graphql$Graphql$Document$Indent$generate(
						A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)),
					_Utils_ap(prefix, string));
			},
			function () {
				if (!field.$) {
					var fieldName = field.a;
					var args = field.b;
					var children = field.c;
					if (mIndentationLevel.$ === 1) {
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, forceHashing, $elm$core$Maybe$Nothing, children)))) + '}');
					} else {
						var indentationLevel = mIndentationLevel.a;
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A3(
								$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp,
								forceHashing,
								$elm$core$Maybe$Just(indentationLevel),
								children)))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
					}
				} else {
					var fieldName = field.a.kg;
					var args = field.b;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							fieldName,
							$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
				}
			}());
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp = F3(
	function (forceHashing, indentationLevel, children) {
		return A2(
			$elm$core$String$join,
			function () {
				if (!indentationLevel.$) {
					return '\n';
				} else {
					return ' ';
				}
			}(),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var maybeAlias = _v0.b;
						var conflictingTypeFields = _v0.c;
						return A4(
							$dillonkearns$elm_graphql$Graphql$Document$Field$serialize,
							conflictingTypeFields,
							maybeAlias,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$add(1),
								indentationLevel),
							field);
					},
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing,
						forceHashing,
						$dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(
							$dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields(children))))));
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(
	function (indentationLevel, children) {
		return A3($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildrenHelp, $elm$core$Set$empty, indentationLevel, children);
	});
var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(
	function (operationType, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {\n{1}\n}',
			_List_fromArray(
				[
					operationType,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(
	function (operationType, operationName, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {\n{2}\n}',
			_List_fromArray(
				[
					operationType,
					operationName,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(
	function (old, _new) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(old),
			$elm$core$String$join(_new));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(
	function (queryParams, url) {
		return $elm$core$List$isEmpty(queryParams) ? url : (url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(
	function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
		var _v0 = function () {
			if (!maybeOperationName.$) {
				var operationName = maybeOperationName.a;
				return _Utils_Tuple2(
					A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument),
					_List_fromArray(
						[
							_Utils_Tuple2('operationName', operationName)
						]));
			} else {
				return _Utils_Tuple2(
					$dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument),
					_List_Nil);
			}
		}();
		var serializedQueryForGetRequest = _v0.a;
		var operationNameParamForGetRequest = _v0.b;
		var urlForGetRequest = A2(
			$dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams,
			_Utils_ap(
				queryParams,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('query', serializedQueryForGetRequest),
					operationNameParamForGetRequest)),
			url);
		if (_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(1)) || ((_Utils_cmp(
			$elm$core$String$length(urlForGetRequest),
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1) && (!_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(0))))) {
			var _v2 = function () {
				if (!maybeOperationName.$) {
					var operationName = maybeOperationName.a;
					return _Utils_Tuple2(
						A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operationName',
								$elm$json$Json$Encode$string(operationName))
							]));
				} else {
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument),
						_List_Nil);
				}
			}();
			var serializedQuery = _v2.a;
			var operationNameParamForPostRequest = _v2.b;
			return {
				f3: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedQuery)),
							operationNameParamForPostRequest))),
				e1: 1,
				i7: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, queryParams, url)
			};
		} else {
			return {f3: $elm$http$Http$emptyBody, e1: 0, i7: urlForGetRequest};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(
	function (message, locations, details) {
		return {m3: details, nR: locations, nZ: message};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(
	function (line, column) {
		return {jN: column, kN: line};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location,
	A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'locations',
					$elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$remove('locations'),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$remove('message'),
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Tuple$pair(data),
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
	nullJsonValue:
	while (true) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
		if (!_v0.$) {
			var value = _v0.a;
			return value;
		} else {
			var $temp$a = 0;
			a = $temp$a;
			continue nullJsonValue;
		}
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2(
					$elm$json$Json$Decode$map,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				$elm$json$Json$Decode$succeed(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(
						$dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder),
				A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
	var request = _v0;
	var _v1 = request.m3;
	if (!_v1.$) {
		var forcedRequestMethod = _v1.a;
		var querySelectionSet = _v1.b;
		var queryRequestDetails = A5(
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build,
			function () {
				if (!forcedRequestMethod.$) {
					if (!forcedRequestMethod.a) {
						var _v4 = forcedRequestMethod.a;
						return $elm$core$Maybe$Just(0);
					} else {
						var _v5 = forcedRequestMethod.a;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Just(1);
				}
			}(),
			request.cH,
			request.bl,
			request.bh,
			querySelectionSet);
		return {
			f3: queryRequestDetails.f3,
			B: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.na),
			ns: request.ns,
			e1: function () {
				var _v2 = queryRequestDetails.e1;
				if (!_v2) {
					return 'GET';
				} else {
					return 'Post';
				}
			}(),
			pL: request.pL,
			i7: queryRequestDetails.i7
		};
	} else {
		var mutationSelectionSet = _v1.a;
		var serializedMutation = function () {
			var _v7 = request.bh;
			if (!_v7.$) {
				var operationName = _v7.a;
				return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
			} else {
				return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
			}
		}();
		return {
			f3: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedMutation))
							]),
						function () {
							var _v6 = request.bh;
							if (!_v6.$) {
								var operationName = _v6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'operationName',
										$elm$json$Json$Encode$string(operationName))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			B: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.na),
			ns: request.ns,
			e1: 'POST',
			pL: request.pL,
			i7: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.bl, request.cH)
		};
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$resolver = function (request) {
	return $dillonkearns$elm_graphql$Graphql$Http$jsonResolver(
		$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(request).B);
};
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$riskyTask = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{mv: true, f3: r.f3, na: r.pp, ns: r.ns, e1: r.e1, pL: r.pL, pP: $elm$core$Maybe$Nothing, i7: r.i7});
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{mv: false, f3: r.f3, na: r.pp, ns: r.ns, e1: r.e1, pL: r.pL, pP: $elm$core$Maybe$Nothing, i7: r.i7});
};
var $dillonkearns$elm_graphql$Graphql$Http$toTask = function (fullRequest) {
	var request = fullRequest;
	return A2(
		$elm$core$Task$andThen,
		$dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors,
		A2(
			$elm$core$Task$mapError,
			$dillonkearns$elm_graphql$Graphql$Http$HttpError,
			function (readyRequest) {
				return (request.bu ? $elm$http$Http$riskyTask : $elm$http$Http$task)(
					{
						f3: readyRequest.f3,
						ns: readyRequest.ns,
						e1: readyRequest.e1,
						pp: $dillonkearns$elm_graphql$Graphql$Http$resolver(fullRequest),
						pL: readyRequest.pL,
						i7: readyRequest.i7
					});
			}(
				$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest))));
};
var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
var $dillonkearns$elm_graphql$Graphql$Http$withCredentials = function (_v0) {
	var request = _v0;
	return _Utils_update(
		request,
		{bu: true});
};
var $dillonkearns$elm_graphql$Graphql$Http$withOperationName = F2(
	function (operationName, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				bh: $elm$core$Maybe$Just(operationName)
			});
	});
var $author$project$Api$executeNewGraphqlOperation = F5(
	function (env, operationName, operation, selectionSet, tagger) {
		return A2(
			$elm$core$Task$attempt,
			tagger,
			$dillonkearns$elm_graphql$Graphql$Http$toTask(
				A2(
					$dillonkearns$elm_graphql$Graphql$Http$withOperationName,
					operationName,
					$dillonkearns$elm_graphql$Graphql$Http$withCredentials(
						A2(
							operation,
							$author$project$Env$newApiUrl(env) + '/graphql',
							selectionSet)))));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(
	function (fieldName, args, fields) {
		return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(
	function (fieldName, args, _v0, decoderTransform) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)
				]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						fieldName,
						decoderTransform(decoder)),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(
							A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)),
						decoderTransform(decoder))
					])));
	});
var $author$project$New$Gql$Platform$Query$permissions = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'permissions', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$User$BackofficeUserData = function (permissions) {
	return {dk: permissions};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(
	function (details, args) {
		return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(
	function (typeString, fieldName, args, decoder) {
		var newLeaf = A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf,
			{kg: fieldName, mc: typeString},
			args);
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[newLeaf]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, fieldName, decoder),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf),
						decoder)
					])));
	});
var $author$project$New$Gql$Platform$Object$PermissionsOutput$permissions = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'permissions',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		_List_Nil,
		$elm$json$Json$Decode$succeed(constructor));
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(
	function (_v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
	});
var $author$project$Page$Login$Gql$permissionsSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PermissionsOutput$permissions,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$User$BackofficeUserData));
var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($elm$json$Json$Decode$field, 'data', decoder_);
};
var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(
	function (baseUrl, query) {
		return {
			cH: baseUrl,
			m3: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
			na: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
			ns: _List_Nil,
			bh: $elm$core$Maybe$Nothing,
			bl: _List_Nil,
			pL: $elm$core$Maybe$Nothing,
			bu: false
		};
	});
var $author$project$Page$Login$Effect$runEffect = F2(
	function (env, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'permissions',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$New$Gql$Platform$Query$permissions($author$project$Page$Login$Gql$permissionsSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Login$Msg$GotAuthCheckResult));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$NotAuthorized$Effect$runEffect = $elm$core$Platform$Cmd$none;
var $author$project$Page$NotFound$Effect$runEffect = $elm$core$Platform$Cmd$none;
var $author$project$Page$OfferDetails$Msg$EmailSent = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedClaimHistory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedClaimHistoryPricingAction = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedCoverSelection = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedCustomerId = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedNewOffer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedOffer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$OfferDetails$Msg$FetchedPaymentMethod = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$OfferDetails$Msg$GotCurrentDate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$OfferDetails$Msg$OfferCoverageEffectiveDateAmended = function (a) {
	return {$: 9, a: a};
};
var $author$project$Common$Gql$CoverSelection$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Gql$CustomerId$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Gql$PaymentMethod$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$OfferDetails$Msg$SaveGreatLakesOptInConsentResponse = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {jM: col, mS: contextStack, pc: problem, pv: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.pv, s.jM, x, s.mR));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.f, s.iP);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jM: 1, mR: s.mR, k: s.k, f: s.f + 1, pv: s.pv + 1, iP: s.iP}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jM: s.jM + 1, mR: s.mR, k: s.k, f: newOffset, pv: s.pv, iP: s.iP}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.pc;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.iP),
			s.f) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.f, s1.f, s0.iP),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.f, s.pv, s.jM, s.iP);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{jM: newCol, mR: s.mR, k: s.k, f: newOffset, pv: newRow, iP: s.iP});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('month ' + ($elm$core$String$fromInt(mn) + ' is out of range')) + (' (1 to 12)' + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))) : ((!A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Err(
			'Invalid date: ' + (('day ' + ($elm$core$String$fromInt(d) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(
				A2(
					$justinmimbs$date$Date$daysInMonth,
					y,
					$justinmimbs$date$Date$numberToMonth(mn))) + ')')) + ((' for ' + $justinmimbs$date$Date$monthToName(
				$justinmimbs$date$Date$numberToMonth(mn))) + ((((mn === 2) && (d === 29)) ? (' (' + ($elm$core$String$fromInt(y) + ' is not a leap year)')) : '') + ('; received (year ' + ($elm$core$String$fromInt(y) + (', month ' + ($elm$core$String$fromInt(mn) + (', day ' + ($elm$core$String$fromInt(d) + ')'))))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, daysInYear, od)) ? $elm$core$Result$Err(
			'Invalid ordinal date: ' + (('ordinal-day ' + ($elm$core$String$fromInt(od) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(daysInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(y)) + ('; received (year ' + ($elm$core$String$fromInt(y) + (', ordinal-day ' + ($elm$core$String$fromInt(od) + ')')))))))) : $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		var weeksInYear = $justinmimbs$date$Date$is53WeekYear(wy) ? 53 : 52;
		return (!A3($justinmimbs$date$Date$isBetweenInt, 1, weeksInYear, wn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('week ' + ($elm$core$String$fromInt(wn) + ' is out of range')) + ((' (1 to ' + ($elm$core$String$fromInt(weeksInYear) + ')')) + ((' for ' + $elm$core$String$fromInt(wy)) + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')')))))))))) : ((!A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn)) ? $elm$core$Result$Err(
			'Invalid week date: ' + (('weekday ' + ($elm$core$String$fromInt(wdn) + ' is out of range')) + (' (1 to 7)' + ('; received (year ' + ($elm$core$String$fromInt(wy) + (', week ' + ($elm$core$String$fromInt(wn) + (', weekday ' + ($elm$core$String$fromInt(wdn) + ')'))))))))) : $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {jM: col, pc: problem, pv: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.pv, p.jM, p.pc);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{jM: 1, mR: _List_Nil, k: 1, f: 0, pv: 1, iP: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {mZ: d, n2: m, pW: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		$8: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		pW: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.pW, 0, date.$8);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.mZ;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.n2;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.$8;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		mg: 1 + (((rd - week1Day1) / 7) | 0),
		mh: wy,
		pT: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.mg;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.mh;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.e2(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.hy(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.e2(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.gp(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bt(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bt(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bt(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.jk(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bt(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bt(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.iP);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.f, offset) < 0,
					0,
					{jM: col, mR: s0.mR, k: s0.k, f: offset, pv: row, iP: s0.iP});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.f, s.pv, s.jM, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.f, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	gp: $justinmimbs$date$Date$withOrdinalSuffix,
	hy: $justinmimbs$date$Date$monthToName,
	e2: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	jk: $justinmimbs$date$Date$weekdayToName,
	bt: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$NewScalarCodecs$codecDate = function () {
	var resultDecoder = function (res) {
		if (!res.$) {
			var date = res.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var err = res.a;
			return $elm$json$Json$Decode$fail(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'wrong format from server: {}',
					_List_fromArray(
						[err])));
		}
	};
	return {
		B: A2(
			$elm$json$Json$Decode$andThen,
			resultDecoder,
			A2($elm$json$Json$Decode$map, $justinmimbs$date$Date$fromIsoString, $elm$json$Json$Decode$string)),
		at: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string)
	};
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.m, posixMinutes) < 0) {
					return posixMinutes + era.f;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		mZ: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		n2: month,
		pW: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).mZ;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).n2;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).pW;
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$round = _Basics_round;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$NewScalarCodecs$codecDateTime = {
	B: A2(
		$elm$json$Json$Decode$andThen,
		function (maybeTime) {
			if (!maybeTime.$) {
				var time = maybeTime.a;
				return $elm$json$Json$Decode$succeed(time);
			} else {
				return $elm$json$Json$Decode$fail('Cannot be converted to POSIX time.');
			}
		},
		A2(
			$elm$json$Json$Decode$map,
			A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $elm$core$Result$toMaybe),
			$elm$json$Json$Decode$string)),
	at: A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string)
};
var $prikhi$decimal$Decimal$Decimal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$Negative = 1;
var $cmditch$elm_bigint$BigInt$Positive = 0;
var $cmditch$elm_bigint$BigInt$Magnitude = $elm$core$Basics$identity;
var $elm_community$maybe_extra$Maybe$Extra$combineHelp = F2(
	function (list, acc) {
		combineHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				if (!head.$) {
					var a = head.a;
					var $temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					list = $temp$list;
					acc = $temp$acc;
					continue combineHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$combine = function (list) {
	return A2($elm_community$maybe_extra$Maybe$Extra$combineHelp, list, _List_Nil);
};
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$emptyZero = function (_v0) {
	var xs = _v0;
	var _v1 = A2(
		$elm_community$list_extra$List$Extra$dropWhile,
		$elm$core$Basics$eq(0),
		xs);
	if (!_v1.b) {
		return _List_Nil;
	} else {
		return xs;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var $cmditch$elm_bigint$BigInt$fromString_ = function (x) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeL, $cmditch$elm_bigint$BigInt$emptyZero, $elm$core$Basics$identity),
		$elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$reverse,
					A2($elm$core$Basics$composeR, $elm$core$String$fromList, $elm$core$String$toInt)),
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					$cmditch$elm_bigint$Constants$maxDigitMagnitude,
					$elm$core$List$reverse(x)))));
};
var $cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var $cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var $cmditch$elm_bigint$BigInt$Zer = {$: 2};
var $cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if ($elm$core$List$isEmpty(digits)) {
			return $cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return $cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return $cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return $cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var $elm$core$String$toLower = _String_toLower;
var $cmditch$elm_bigint$BigInt$fromString = function (x) {
	var _v0 = $elm$core$String$toList(
		$elm$core$String$toLower(x));
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		switch (_v0.a) {
			case '-':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(1),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			case '+':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(0),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			default:
				var xs = _v0;
				return A2(
					$elm$core$Maybe$map,
					$cmditch$elm_bigint$BigInt$mkBigInt(0),
					$cmditch$elm_bigint$BigInt$fromString_(xs));
		}
	}
};
var $prikhi$decimal$Decimal$fromString = function (str) {
	var stringToDecimal = function (s) {
		var stringIntToDecimal = F2(
			function (s_, e) {
				var _v8 = $cmditch$elm_bigint$BigInt$fromString(s_);
				if (_v8.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var a = _v8.a;
					return $elm$core$Maybe$Just(
						A2($prikhi$decimal$Decimal$Decimal, a, e));
				}
			});
		var _v6 = A2($elm$core$String$split, '.', s);
		_v6$2:
		while (true) {
			if (_v6.b) {
				if (_v6.b.b) {
					if (!_v6.b.b.b) {
						var a = _v6.a;
						var _v7 = _v6.b;
						var b = _v7.a;
						return A2(
							stringIntToDecimal,
							_Utils_ap(a, b),
							-$elm$core$String$length(b));
					} else {
						break _v6$2;
					}
				} else {
					var a = _v6.a;
					return A2(stringIntToDecimal, a, 0);
				}
			} else {
				break _v6$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var splitMantissaExponent = function (s) {
		var _v4 = A2(
			$elm$core$String$split,
			'e',
			$elm$core$String$toLower(s));
		_v4$2:
		while (true) {
			if (_v4.b) {
				if (!_v4.b.b) {
					var s1 = _v4.a;
					return _Utils_Tuple2(
						stringToDecimal(s1),
						$elm$core$Maybe$Just(0));
				} else {
					if (!_v4.b.b.b) {
						var s1 = _v4.a;
						var _v5 = _v4.b;
						var s2 = _v5.a;
						return _Utils_Tuple2(
							stringToDecimal(s1),
							$elm$core$String$toInt(s2));
					} else {
						break _v4$2;
					}
				}
			} else {
				break _v4$2;
			}
		}
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	};
	var makeMantissa = function (s) {
		var _v2 = A2($elm$core$String$split, '.', s);
		_v2$2:
		while (true) {
			if (_v2.b) {
				if (!_v2.b.b) {
					var s1 = _v2.a;
					return stringToDecimal(s1);
				} else {
					if (!_v2.b.b.b) {
						var s1 = _v2.a;
						var _v3 = _v2.b;
						var s2 = _v3.a;
						return stringToDecimal(
							A2(
								$elm$core$String$join,
								'',
								_List_fromArray(
									[s1, s2])));
					} else {
						break _v2$2;
					}
				}
			} else {
				break _v2$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var _v0 = splitMantissaExponent(str);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var m = _v1.a;
		var a = _v1.b;
		var e = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2($prikhi$decimal$Decimal$Decimal, m, e + a));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = $elm$core$Basics$identity;
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _v0 = $elm_community$list_extra$List$Extra$last(digits);
	if (_v0.$ === 1) {
		return false;
	} else {
		var x = _v0.a;
		return x < 0;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigIntNotNormalised = F2(
	function (s, digits) {
		return A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, s, digits);
	});
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $cmditch$elm_bigint$BigInt$dropZeroes = $elm_community$list_extra$List$Extra$dropWhileRight(
	$elm$core$Basics$eq(0));
var $elm$core$Basics$pow = _Basics_pow;
var $cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude);
var $cmditch$elm_bigint$BigInt$baseDigit = $cmditch$elm_bigint$Constants$maxDigitValue + 1;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		$elm$core$Tuple$mapFirst,
		$elm$core$Basics$add(-1),
		$cmditch$elm_bigint$BigInt$normaliseDigit(x + $cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / $cmditch$elm_bigint$BigInt$baseDigit) | 0, x % $cmditch$elm_bigint$BigInt$baseDigit);
};
var $cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, $cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _v1 = $cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _v1.a;
				var x_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					x_,
					A2($cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_v0) {
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$dropZeroes(
		A2($cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var $cmditch$elm_bigint$BigInt$reverseMagnitude = $elm$core$List$map($elm$core$Basics$negate);
var $cmditch$elm_bigint$BigInt$Zero = 2;
var $cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$normalise = function (_v0) {
	normalise:
	while (true) {
		var s = _v0.a;
		var digits = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
		var normalisedMag = _v1;
		if ($cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
			var $temp$_v0 = A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				$cmditch$elm_bigint$BigInt$signNegate(s),
				$cmditch$elm_bigint$BigInt$reverseMagnitude(normalisedMag));
			_v0 = $temp$_v0;
			continue normalise;
		} else {
			return A2($cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
		}
	}
};
var $cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _v0 = A2($elm$core$Basics$compare, x, 0);
	switch (_v0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return $cmditch$elm_bigint$BigInt$normalise(
		A2(
			$cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			$cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					$elm$core$Basics$abs(x)
				])));
};
var $cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _v0 = _Utils_Tuple2(xs, ys);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return A2($elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					return 2;
				} else {
					var _v1 = _v0.a;
					var x_ = _v1.a;
					var xss = _v1.b;
					var _v2 = _v0.b;
					var y_ = _v2.a;
					var yss = _v2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$orderNegate = function (x) {
	switch (x) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _v0 = _Utils_Tuple2(int1, int2);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_v0.b.$ === 1) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return $cmditch$elm_bigint$BigInt$orderNegate(
						A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2));
				} else {
					return 0;
				}
			default:
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						return 0;
					case 2:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 1;
					default:
						var _v4 = _v0.a;
						return 2;
				}
		}
	});
var $cmditch$elm_bigint$BigInt$lt = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$compare, x, y);
	});
var $cmditch$elm_bigint$BigInt$gte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$lt, x, y);
	});
var $prikhi$decimal$Decimal$insert_decimal_period = F2(
	function (pos, s) {
		var extra_zeros = pos - $elm$core$String$length(s);
		var padded_s = (extra_zeros >= 0) ? _Utils_ap(
			A2($elm$core$String$repeat, extra_zeros + 1, '0'),
			s) : s;
		var before = A2($elm$core$String$dropRight, pos, padded_s);
		var after = A2($elm$core$String$right, pos, padded_s);
		return before + ('.' + after);
	});
var $cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var $cmditch$elm_bigint$BigInt$fillZeroes = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$String$padLeft, $cmditch$elm_bigint$Constants$maxDigitMagnitude, '0'),
	$elm$core$String$fromInt);
var $cmditch$elm_bigint$BigInt$revMagnitudeToString = function (_v0) {
	var digits = _v0;
	var _v1 = $elm$core$List$reverse(digits);
	if (!_v1.b) {
		return '0';
	} else {
		var x = _v1.a;
		var xs = _v1.b;
		return $elm$core$String$concat(
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(x),
				A2($elm$core$List$map, $cmditch$elm_bigint$BigInt$fillZeroes, xs)));
	}
};
var $cmditch$elm_bigint$BigInt$toString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
	}
};
var $prikhi$decimal$Decimal$toString = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	var sign = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? '' : '-';
	var add_zeros = function (n) {
		return A2($elm$core$String$repeat, n, '0');
	};
	var abs_m = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? m : $cmditch$elm_bigint$BigInt$negate(m);
	var s = $cmditch$elm_bigint$BigInt$toString(abs_m);
	var _v1 = A2($elm$core$Basics$compare, e, 0);
	switch (_v1) {
		case 1:
			return _Utils_ap(sign, s);
		case 2:
			return _Utils_ap(
				sign,
				_Utils_ap(
					s,
					add_zeros(e)));
		default:
			return _Utils_ap(
				sign,
				A2($prikhi$decimal$Decimal$insert_decimal_period, 0 - e, s));
	}
};
var $author$project$NewScalarCodecs$codecDecimal = {
	B: A2(
		$elm$json$Json$Decode$andThen,
		function (maybeDecimal) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Cannot be converted to Decimal'),
				A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, maybeDecimal));
		},
		A2($elm$json$Json$Decode$map, $prikhi$decimal$Decimal$fromString, $elm$json$Json$Decode$string)),
	at: A2($elm$core$Basics$composeR, $prikhi$decimal$Decimal$toString, $elm$json$Json$Encode$string)
};
var $author$project$NewScalarCodecs$codecGqlDecimal = {
	B: A2(
		$elm$json$Json$Decode$andThen,
		function (maybeDecimal) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Cannot be converted to Decimal'),
				A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, maybeDecimal));
		},
		A2($elm$json$Json$Decode$map, $prikhi$decimal$Decimal$fromString, $elm$json$Json$Decode$string)),
	at: A2($elm$core$Basics$composeR, $prikhi$decimal$Decimal$toString, $elm$json$Json$Encode$string)
};
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$regex$Regex$contains = _Regex_contains;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $author$project$NewScalarCodecs$maybeDecoder = function (res) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Decode$fail('wrong uuid format'),
		A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, res));
};
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$NewScalarCodecs$codecUuid = {
	B: A2(
		$elm$json$Json$Decode$andThen,
		$author$project$NewScalarCodecs$maybeDecoder,
		A2($elm$json$Json$Decode$map, $danyx23$elm_uuid$Uuid$fromString, $elm$json$Json$Decode$string)),
	at: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string)
};
var $author$project$New$Gql$Platform$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$New$Gql$Platform$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$NewScalarCodecs$codecs = $author$project$New$Gql$Platform$Scalar$defineCodecs(
	{mN: $author$project$NewScalarCodecs$codecDate, O: $author$project$NewScalarCodecs$codecDateTime, mO: $author$project$NewScalarCodecs$codecDecimal, mP: $author$project$NewScalarCodecs$codecGqlDecimal, u: $author$project$NewScalarCodecs$codecUuid});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (actualValue) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(key, actualValue));
					},
					value);
			},
			maybeValues));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
};
var $author$project$New$Gql$Platform$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).at,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$New$Gql$Platform$InputObject$encodeAmendOfferCoverageEffectiveDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oi))),
				_Utils_Tuple2(
				'coverageEffectiveDate',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.mN;
						},
						$author$project$NewScalarCodecs$codecs)(input____.mV)))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(
	function (fieldName, raw, encode) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
			fieldName,
			encode(raw));
	});
var $author$project$New$Gql$Platform$Mutation$amendOfferCoverageEffectiveDate = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'amendOfferCoverageEffectiveDate',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeAmendOfferCoverageEffectiveDateInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateArguments = F2(
	function (offerId, coverageEffectiveDate) {
		return {
			nD: {mV: coverageEffectiveDate, oi: offerId}
		};
	});
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$CurrentDateStillValid = 2;
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$OutOfFutureRange = 1;
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$PastCoverageEffectiveDate = 0;
var $author$project$Common$AmendOfferCoverageEffectiveDateResult$Success = {$: 0};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(
	function (fragmentTypeName, _v0) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(
	function (typeSpecificSelections, typeName) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?',
			_List_fromArray(
				[
					typeName,
					A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (_v0) {
							var fragmentType = _v0.a;
							var fields = _v0.b;
							var decoder = _v0.c;
							return fragmentType;
						},
						typeSpecificSelections))
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
	var selections = A2(
		$elm$core$List$map,
		function (_v1) {
			var typeName = _v1.a;
			var fields = _v1.b;
			var decoder = _v1.c;
			return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
		},
		typeSpecificSelections);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections),
		A2(
			$elm$json$Json$Decode$andThen,
			function (typeName) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail(
						A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)),
					A2(
						$elm$core$Dict$get,
						typeName,
						$elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var thisTypeName = _v0.a;
									var fields = _v0.b;
									var decoder = _v0.c;
									return _Utils_Tuple2(thisTypeName, decoder);
								},
								typeSpecificSelections))));
			},
			A2(
				$elm$json$Json$Decode$field,
				$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename),
				$elm$json$Json$Decode$string)));
};
var $author$project$New$Gql$Platform$Union$AmendOfferCoverageEffectiveDateOutput$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AmendOfferCoverageEffectiveDateOk', selections____.ol),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PastCoverageEffectiveDateErr', selections____.oT),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OutOfFutureRangeErr', selections____.oS),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CurrentDateStillValidErr', selections____.oK)
			]));
};
var $author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateSelectionSet = $author$project$New$Gql$Platform$Union$AmendOfferCoverageEffectiveDateOutput$fragments(
	{
		ol: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$AmendOfferCoverageEffectiveDateResult$Success),
		oK: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			$author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure(2)),
		oS: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			$author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure(1)),
		oT: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
			$author$project$Common$AmendOfferCoverageEffectiveDateResult$Failure(0))
	});
var $author$project$New$Gql$Platform$Query$ClaimsHistoryRequiredArguments = function (input) {
	return {nD: input};
};
var $author$project$Common$Gql$ClaimHistory$claimHistoryByQuoteIdRequiredArguments = function (quoteId) {
	return $author$project$New$Gql$Platform$Query$ClaimsHistoryRequiredArguments(
		{pf: quoteId});
};
var $author$project$New$Gql$Platform$InputObject$encodeClaimsHistoryInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'quoteId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.pf)))
			]));
};
var $author$project$New$Gql$Platform$Query$claimsHistory = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'claimsHistory',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeClaimsHistoryInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$ClaimHistory$ClaimHistory = F6(
	function (id, sincoInfo, sincoNumber, claimDeclaredWithFaultByCustomer, claimDeclaredBySinco, actionNeeded) {
		return {fN: actionNeeded, jG: claimDeclaredBySinco, f8: claimDeclaredWithFaultByCustomer, kv: id, lW: sincoInfo, lX: sincoNumber};
	});
var $author$project$Common$Count$Unknown = {$: 2};
var $author$project$Common$Count$default = $author$project$Common$Count$Unknown;
var $author$project$Common$PricingAction$PricingAction = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$PricingAction$default = $author$project$Common$PricingAction$PricingAction('');
var $author$project$New$Gql$Platform$Object$ClaimsHistory$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(
	function (constant, _v0) {
		var objectFields = _v0.a;
		var objectDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			objectFields,
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$apR,
				$elm$json$Json$Decode$succeed(constant),
				objectDecoder));
	});
var $author$project$New$Gql$Platform$Object$ClaimsHistory$sincoNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'sincoNumber', _List_Nil, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$New$Gql$Platform$Object$ClaimsHistory$sincoReturnCode = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'sincoReturnCode',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$ClaimsHistory$totalClaimsFound = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'totalClaimsFound',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$Atleast$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$New$Gql$Platform$Object$Exactly$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$New$Gql$Platform$Union$ClaimsCount$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Exactly', selections____.oN),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Atleast', selections____.op)
			]));
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(
	function (mapFunction, _v0) {
		var selectionFields = _v0.a;
		var selectionDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			selectionFields,
			A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
	});
var $author$project$Common$Gql$ClaimHistory$totalClaimsFoundSelectionSet = $author$project$New$Gql$Platform$Union$ClaimsCount$fragments(
	{
		op: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$New$Gql$Platform$Object$Atleast$count),
		oN: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Basics$identity, $author$project$New$Gql$Platform$Object$Exactly$count)
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault = function (_default) {
	return $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
		$elm$core$Maybe$withDefault(_default));
};
var $author$project$Common$Gql$ClaimHistory$claimHistorySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$author$project$Common$PricingAction$default,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$ClaimsHistory$totalClaimsFound($author$project$Common$Gql$ClaimHistory$totalClaimsFoundSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			$author$project$Common$Count$default,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$ClaimsHistory$sincoNumber,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$ClaimsHistory$sincoReturnCode),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$ClaimsHistory$documentId,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ClaimHistory$ClaimHistory)))))));
var $author$project$New$Gql$Platform$Object$ClaimsHistoryOutput$claimsHistory = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsHistory',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Gql$ClaimHistory$claimsHistoryOutputSelectionSet = $author$project$New$Gql$Platform$Object$ClaimsHistoryOutput$claimsHistory($author$project$Common$Gql$ClaimHistory$claimHistorySelectionSet);
var $author$project$Env$apiUrl = function (_v0) {
	var environment = _v0;
	return environment.cF;
};
var $author$project$Api$executeGraphqlOperation = F4(
	function (env, operation, selectionSet, tagger) {
		return A2(
			$elm$core$Task$attempt,
			tagger,
			$dillonkearns$elm_graphql$Graphql$Http$toTask(
				$dillonkearns$elm_graphql$Graphql$Http$withCredentials(
					A2(
						operation,
						$author$project$Env$apiUrl(env),
						selectionSet))));
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {$: 1};
var $author$project$New$Gql$Platform$InputObject$CoverSelectionInputRequiredFields = function (offerOrPolicyIdentifier) {
	return {H: offerOrPolicyIdentifier};
};
var $author$project$New$Gql$Platform$Query$CoverSelectionRequiredArguments = function (input) {
	return {nD: input};
};
var $author$project$New$Gql$Platform$InputObject$OfferIdentifier = F2(
	function (offerId, offerCfid) {
		return {oh: offerCfid, oi: offerId};
	});
var $author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier = F2(
	function (offer, policy) {
		return {G: offer, l: policy};
	});
var $author$project$New$Gql$Platform$InputObject$PolicyIdentifier = function (policyId) {
	return {o6: policyId};
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
	return {$: 0, a: a};
};
var $author$project$New$Gql$Platform$InputObject$buildCoverSelectionInput = function (required____) {
	return {H: required____.H};
};
var $author$project$Common$Gql$CoverSelection$buildCoverContinuityQueryArg = function (args) {
	var buildPolicyInput = function (policyId) {
		return A2(
			$author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$New$Gql$Platform$InputObject$PolicyIdentifier(
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(policyId))));
	};
	var buildOfferInput = function (offerId) {
		return function (offerIdentifier) {
			return A2($author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier, offerIdentifier, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
		}(
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				A2(
					$author$project$New$Gql$Platform$InputObject$OfferIdentifier,
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerId),
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent)));
	};
	var input = function () {
		if (!args.$) {
			var policyId = args.a;
			return buildPolicyInput(policyId);
		} else {
			var offerId = args.a;
			return buildOfferInput(offerId);
		}
	}();
	var buildCoverSelectionInput = function (coverContinuityArg) {
		return $author$project$New$Gql$Platform$Query$CoverSelectionRequiredArguments(
			$author$project$New$Gql$Platform$InputObject$buildCoverSelectionInput(
				$author$project$New$Gql$Platform$InputObject$CoverSelectionInputRequiredFields(coverContinuityArg)));
	};
	return buildCoverSelectionInput(input);
};
var $author$project$New$Gql$Platform$Object$CoverSelectionOutput$coverSelection = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'coverSelection', _List_Nil, object____, $elm$core$Basics$identity);
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(
	function (optionalValue, toValue) {
		switch (optionalValue.$) {
			case 0:
				var value = optionalValue.a;
				return $elm$core$Maybe$Just(
					toValue(value));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
		}
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$string(value));
};
var $author$project$New$Gql$Platform$InputObject$encodeOfferIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.oi,
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs))),
				_Utils_Tuple2(
				'offerCfid',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.oh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePolicyIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o6,
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeOfferOrPolicyIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.G, $author$project$New$Gql$Platform$InputObject$encodeOfferIdentifier)),
				_Utils_Tuple2(
				'policy',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l, $author$project$New$Gql$Platform$InputObject$encodePolicyIdentifier))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeCoverSelectionInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerOrPolicyIdentifier',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeOfferOrPolicyIdentifier(input____.H)))
			]));
};
var $author$project$New$Gql$Platform$Query$coverSelection = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'coverSelection',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeCoverSelectionInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$CoverSelection$ancillaries = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'ancillaries', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$CoverSelection$AncillaryProducts = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Common$CoverSelection$ancillaryProducts = $author$project$Common$CoverSelection$AncillaryProducts;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$AnimalCrash = 2;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$DriverAccident50k = 4;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$HailDamage = 3;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$RoadsideAssistancePremium = 0;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$SubstitutionVehicle = 1;
var $author$project$New$Gql$Platform$Enum$AncillaryCoverType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ROADSIDE_ASSISTANCE_PREMIUM':
				return $elm$json$Json$Decode$succeed(0);
			case 'SUBSTITUTION_VEHICLE':
				return $elm$json$Json$Decode$succeed(1);
			case 'ANIMAL_CRASH':
				return $elm$json$Json$Decode$succeed(2);
			case 'HAIL_DAMAGE':
				return $elm$json$Json$Decode$succeed(3);
			case 'DRIVER_ACCIDENT_50K':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid AncillaryCoverType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$AncillaryCover$coverName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.AncillaryCoverType.AncillaryCoverType', 'coverName', _List_Nil, $author$project$New$Gql$Platform$Enum$AncillaryCoverType$decoder);
var $author$project$Common$CoverSelection$AnimalCrash = 3;
var $author$project$Common$CoverSelection$DriverAccident50k = 4;
var $author$project$Common$CoverSelection$HailDamage = 2;
var $author$project$Common$CoverSelection$NotReleasedYet = 5;
var $author$project$Common$CoverSelection$RoadsideAssistance = 0;
var $author$project$Common$CoverSelection$SubstitutionVehicle = 1;
var $author$project$Env$envName = function (_v0) {
	var environment = _v0;
	return environment.cT;
};
var $author$project$Env$isProduction = function (environment) {
	var _v0 = $author$project$Env$envName(environment);
	if (_v0 === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Gql$CoverSelection$decodeAncillaryType = F2(
	function (env, ancillaryType) {
		switch (ancillaryType) {
			case 0:
				return 0;
			case 1:
				return 1;
			case 2:
				return 3;
			case 3:
				return 2;
			default:
				return $author$project$Env$isProduction(env) ? 5 : 4;
		}
	});
var $author$project$Common$Price$Euro = 0;
var $author$project$Common$Price$Price = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Common$Price$new = F2(
	function (amount, currency) {
		return A2($author$project$Common$Price$Price, amount, currency);
	});
var $author$project$Common$Price$euro = function (amount) {
	return A2($author$project$Common$Price$new, amount, 0);
};
var $author$project$New$Gql$Platform$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$New$Gql$Platform$Object$AncillaryCover$grossPrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'grossPrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$Pyxis$Components$IconSet$Icon = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$IconSet$svgCar = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.78 10l-4.1-1.1-1.1-1.9c-.54-.93-1.53-1.5-2.6-1.5H5.84c-.8 0-1.56.32-2.12.88l-2.5 2.5c-.76.76-1.05 1.86-.78 2.9l.67 2.5c.26.98.99 1.74 1.92 2.06L3 16c0 1.66 1.34 3 3 3s3-1.34 3-3c0 .17-.02.34-.05.5h7.1c-.03-.16-.05-.33-.05-.5 0 1.66 1.34 3 3 3s3-1.34 3-3c0 .11-.02.22-.03.33 1.18-.4 2.03-1.51 2.03-2.83v-.6a3 3 0 0 0-2.22-2.9zM6 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-3.5c0 .37-.21.67-.5.85.01.01.01.03.02.04A2.97 2.97 0 0 0 19 13c-1.11 0-2.06.61-2.58 1.5H8.58C8.06 13.61 7.11 13 6 13a2.97 2.97 0 0 0-2.52 1.39c.01-.01.02-.03.02-.05a1.01 1.01 0 0 1-.45-.58l-.67-2.5a1.03 1.03 0 0 1 .26-.97l2.5-2.5c.18-.19.44-.29.7-.29h8.14c.36 0 .69.19.87.5l1.1 1.9c.27.46.7.79 1.21.93l4.1 1.1c.44.12.74.52.74.97v.6zm-8.8-5H8.4c-.55 0-1 .45-1 1s.45 1 1 1h4.8c.55 0 1-.45 1-1s-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$car = {eY: 'car', a: $author$project$Pyxis$Components$IconSet$svgCar};
var $author$project$Translations$coversAncillaryRoadsideAssistencePremium = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Premium roadside assistance';
	} else {
		return 'Asistencia en carretera premium';
	}
};
var $author$project$Translations$coversAncillarySubstitutionVehicle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Substitution vehicle';
	} else {
		return 'Vehículo de sustitución';
	}
};
var $author$project$Translations$coversAnimalCrash = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Damage by animal crash';
	} else {
		return 'Daños por colisión con animales';
	}
};
var $author$project$Translations$coversDriverAccident50k = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Driver Accident with a 50k limit';
	} else {
		return 'Accidente de conductor con límite 50000';
	}
};
var $author$project$Translations$coversHailDamage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Damage by hailstones';
	} else {
		return 'Daños por pedrisco o granizo';
	}
};
var $author$project$Pyxis$Components$IconSet$svgLock = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M18 10V7c0-3.31-2.69-6-6-6S6 3.69 6 7v3c-1.66 0-3 1.34-3 3v7c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-7c0-1.66-1.34-3-3-3zM8 7a4 4 0 1 1 8 0v3H8V7zm11 13c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v7z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$lock = {eY: 'lock', a: $author$project$Pyxis$Components$IconSet$svgLock};
var $author$project$Pyxis$Components$IconSet$svgVehicleCollisionKasko = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 7c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1zm4 0a1.01 1.01 0 0 1-.5-.13 1.01 1.01 0 0 1-.37-1.37l1.5-2.6A1.01 1.01 0 0 1 23 2.53a1.01 1.01 0 0 1 .37 1.37l-1.5 2.6A1.02 1.02 0 0 1 21 7zm-8 0c-.35 0-.68-.18-.87-.5l-1.5-2.6c-.27-.48-.11-1.09.37-1.36.48-.28 1.09-.11 1.37.37l1.5 2.6c.28.48.11 1.09-.37 1.37-.16.08-.33.12-.5.12zm8.77 6l-2.4-.64 1.43-.83c.61-.35 1.3-.53 2-.53h.2c.55 0 1-.45 1-1 0-.56-.45-1-1-1h-.2c-1.05 0-2.09.27-3 .8l-2.5 1.45-.72-1.25c-.54-.93-1.53-1.5-2.6-1.5H5.84c-.8 0-1.56.31-2.12.88l-2.5 2.49c-.76.76-1.05 1.87-.78 2.9l.67 2.5c.27.98 1 1.75 1.92 2.07a2.99 2.99 0 0 0 5.92.16h7.1A2.98 2.98 0 0 0 19 22c1.54 0 2.81-1.17 2.98-2.67A3 3 0 0 0 24 16.5v-.61c0-1.35-.92-2.54-2.23-2.89zM6.86 19.5c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm13 0c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm2.14-3c0 .36-.2.68-.49.86C20.97 16.54 20.05 16 19 16c-1.11 0-2.08.6-2.6 1.5H8.6C8.08 16.6 7.11 16 6 16c-1.05 0-1.97.54-2.51 1.35-.21-.13-.38-.34-.44-.59l-.67-2.51c-.1-.34 0-.71.25-.96l2.5-2.5a.99.99 0 0 1 .71-.29h8.14c.35 0 .69.19.86.5l1.1 1.9a2.01 2.01 0 0 0 1.22.93l4.09 1.1c.44.12.75.51.75.96v.61zm-8.8-5H8.4a.99.99 0 0 0-1 1c0 .55.44 1 1 1h4.8c.55 0 1-.45 1-1 0-.56-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$vehicleCollisionKasko = {eY: 'vehicle-collision-kasko', a: $author$project$Pyxis$Components$IconSet$svgVehicleCollisionKasko};
var $author$project$Pyxis$Components$IconSet$svgVehicleNaturalEvents = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.11 23a1.01 1.01 0 0 1-.5-.13 1.01 1.01 0 0 1-.37-1.37l2.02-3.5H10c-.36 0-.69-.19-.87-.5s-.18-.69 0-1l2.89-5a1.01 1.01 0 0 1 1.37-.37 1.01 1.01 0 0 1 .37 1.37L11.73 16H15c.36 0 .69.19.87.5s.18.69 0 1l-2.89 5c-.19.32-.52.5-.87.5zm6.88-15.86c0-.05.01-.09.01-.14 0-3.31-2.69-6-6-6-2.62 0-4.85 1.69-5.66 4.03C7.22 5.03 7.12 5 7 5c-2.76 0-5 2.24-5 5s2.24 5 5 5h.69l1.15-2H7a3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 2.93-3l.27.03 1.52.1.5-1.44C9.78 4.08 11.3 3 13 3c2.19 0 3.98 1.77 4 3.96 0 .04-.01.09-.01.13l-.04 1.59 1.54.4C19.38 9.3 20 10.1 20 11c0 1.1-.9 2-2 2h-2.29c-.06.17-.13.34-.22.5l-.87 1.5H18a4 4 0 0 0 4-4 3.99 3.99 0 0 0-3.01-3.86z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$vehicleNaturalEvents = {eY: 'vehicle-natural-events', a: $author$project$Pyxis$Components$IconSet$svgVehicleNaturalEvents};
var $author$project$Pyxis$Components$IconSet$svgVehicleRoadsideAssistance = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23.59 11.8l-2.48-4.3c-.54-.93-1.53-1.5-2.6-1.5H15c-1.11 0-2 .89-2 2v2.59l-7.29-7.3c-.29-.28-.72-.37-1.09-.21C4.24 3.23 4 3.6 4 4v4.28c-.6.34-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V6.41l6.09 6.09H2c-1.11 0-2 .89-2 2v2a2 2 0 0 0 2 2h.05A2.98 2.98 0 0 0 5 21a2.99 2.99 0 0 0 2.95-2.5H13h2 .05A2.98 2.98 0 0 0 18 21a2.99 2.99 0 0 0 2.95-2.5H22c1.1 0 2-.9 2-2v-3.2a2.94 2.94 0 0 0-.41-1.5zM5.86 18.5c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm7.14-2H7.6C7.08 15.6 6.11 15 5 15s-2.08.6-2.6 1.5H2v-2h11v2zm5.86 2c-.17.3-.49.5-.86.5s-.7-.2-.86-.5c-.09-.15-.14-.32-.14-.5 0-.55.44-1 1-1 .55 0 1 .45 1 1 0 .18-.05.35-.14.5zm3.14-2h-1.4c-.52-.9-1.49-1.5-2.6-1.5s-2.08.6-2.6 1.5H15v-4V8h3.51c.36 0 .69.19.87.5l2.48 4.3c.09.15.14.33.14.5v3.2z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$vehicleRoadsideAssistance = {eY: 'vehicle-roadside-assistance', a: $author$project$Pyxis$Components$IconSet$svgVehicleRoadsideAssistance};
var $author$project$Common$CoverSelection$newAncillary = F2(
	function (ancillaryType, grossPrice) {
		var icon = function () {
			switch (ancillaryType) {
				case 0:
					return $author$project$Pyxis$Components$IconSet$vehicleRoadsideAssistance;
				case 1:
					return $author$project$Pyxis$Components$IconSet$car;
				case 2:
					return $author$project$Pyxis$Components$IconSet$vehicleNaturalEvents;
				case 3:
					return $author$project$Pyxis$Components$IconSet$vehicleCollisionKasko;
				case 4:
					return $author$project$Pyxis$Components$IconSet$vehicleCollisionKasko;
				default:
					return $author$project$Pyxis$Components$IconSet$lock;
			}
		}();
		var i18nDescription = function () {
			switch (ancillaryType) {
				case 0:
					return $author$project$Translations$coversAncillaryRoadsideAssistencePremium;
				case 1:
					return $author$project$Translations$coversAncillarySubstitutionVehicle;
				case 2:
					return $author$project$Translations$coversHailDamage;
				case 3:
					return $author$project$Translations$coversAnimalCrash;
				case 4:
					return $author$project$Translations$coversDriverAccident50k;
				default:
					return $elm$core$Basics$always('Should not be visible');
			}
		}();
		return {c$: grossPrice, nz: i18nDescription, ku: icon, eX: ancillaryType};
	});
var $author$project$Common$Gql$CoverSelection$ancillarySelectionSet = function (env) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$AncillaryCover$grossPrice),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Common$Gql$CoverSelection$decodeAncillaryType(env),
				$author$project$New$Gql$Platform$Object$AncillaryCover$coverName),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$newAncillary)));
};
var $author$project$New$Gql$Platform$Object$AncillaryCovers$selected = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'selected',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$AncillaryCovers$unselected = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'unselected',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Common$Gql$CoverSelection$ancillaryCoversSelectionSet = function (env) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AncillaryCovers$unselected(
			$author$project$Common$Gql$CoverSelection$ancillarySelectionSet(env)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AncillaryCovers$selected(
				$author$project$Common$Gql$CoverSelection$ancillarySelectionSet(env)),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$ancillaryProducts)));
};
var $author$project$New$Gql$Platform$Union$Ancillaries$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AncillaryCovers', selections____.on),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreAncillary', selections____.oU)
			]));
};
var $author$project$Common$CoverSelection$PreAncillaries = {$: 0};
var $author$project$Common$CoverSelection$preAncillaries = $author$project$Common$CoverSelection$PreAncillaries;
var $author$project$Common$Gql$CoverSelection$preAncillarySelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$preAncillaries);
var $author$project$Common$Gql$CoverSelection$ancillariesSelectionSet = function (env) {
	return $author$project$New$Gql$Platform$Union$Ancillaries$fragments(
		{
			on: $author$project$Common$Gql$CoverSelection$ancillaryCoversSelectionSet(env),
			oU: $author$project$Common$Gql$CoverSelection$preAncillarySelectionSet
		});
};
var $author$project$New$Gql$Platform$Object$CoverSelection$bundlePrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'bundlePrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$New$Gql$Platform$Enum$BundleSlug$TercerosAmpliado = 1;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TercerosBasico = 0;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia = 2;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia300 = 3;
var $author$project$New$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia500 = 4;
var $author$project$New$Gql$Platform$Enum$BundleSlug$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TERCEROS_BASICO':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERCEROS_AMPLIADO':
				return $elm$json$Json$Decode$succeed(1);
			case 'TODO_RIESGO_CON_FRANQUICIA':
				return $elm$json$Json$Decode$succeed(2);
			case 'TODO_RIESGO_CON_FRANQUICIA_300':
				return $elm$json$Json$Decode$succeed(3);
			case 'TODO_RIESGO_CON_FRANQUICIA_500':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BundleSlug type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$CoverSelection$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$CoverSelection$chosenExcess = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Decimal)',
	'chosenExcess',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B));
var $author$project$Common$Product$TercerosAmpliado = 1;
var $author$project$Common$Product$TercerosBasico = 0;
var $author$project$Common$Product$TodoRiesgoConFranquicia = 2;
var $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug = function (bundleSlug) {
	switch (bundleSlug) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Common$CoverSelection$CoverSelection = F4(
	function (bundle, bundleGrossPrice, chosenExcess, ancillaries) {
		return {mx: ancillaries, f4: bundle, f5: bundleGrossPrice, f7: chosenExcess};
	});
var $author$project$Common$CoverSelection$new = $author$project$Common$CoverSelection$CoverSelection;
var $author$project$Common$Gql$CoverSelection$coverSelectionSet = function (env) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$CoverSelection$ancillaries(
			$author$project$Common$Gql$CoverSelection$ancillariesSelectionSet(env)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Maybe$map($author$project$Common$Price$euro),
				$author$project$New$Gql$Platform$Object$CoverSelection$chosenExcess),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$CoverSelection$bundlePrice),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$CoverSelection$bundleSlug),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverSelection$new)))));
};
var $author$project$Common$Gql$CoverSelection$getCoverSelection = F2(
	function (env, queryArg) {
		return A2(
			$author$project$New$Gql$Platform$Query$coverSelection,
			$author$project$Common$Gql$CoverSelection$buildCoverContinuityQueryArg(queryArg),
			$author$project$New$Gql$Platform$Object$CoverSelectionOutput$coverSelection(
				$author$project$Common$Gql$CoverSelection$coverSelectionSet(env)));
	});
var $author$project$New$Gql$Platform$InputObject$GetCustomerIdInputRequiredFields = function (offerOrPolicyIdentifier) {
	return {H: offerOrPolicyIdentifier};
};
var $author$project$New$Gql$Platform$Query$GetCustomerIdRequiredArguments = function (input) {
	return {nD: input};
};
var $author$project$New$Gql$Platform$InputObject$buildGetCustomerIdInput = function (required____) {
	return {H: required____.H};
};
var $author$project$Common$Gql$CustomerId$buildCustomerIdQueryArg = function (args) {
	var buildPolicyInput = function (policyId) {
		return A2(
			$author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$New$Gql$Platform$InputObject$PolicyIdentifier(
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(policyId))));
	};
	var buildOfferInput = function (offerId) {
		return function (offerIdentifier) {
			return A2($author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier, offerIdentifier, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
		}(
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				A2(
					$author$project$New$Gql$Platform$InputObject$OfferIdentifier,
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerId),
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent)));
	};
	var input = function () {
		if (!args.$) {
			var policyId = args.a;
			return buildPolicyInput(policyId);
		} else {
			var offerId = args.a;
			return buildOfferInput(offerId);
		}
	}();
	var buildGetCustomerIdInput = function (getCustomerIdArg) {
		return $author$project$New$Gql$Platform$Query$GetCustomerIdRequiredArguments(
			$author$project$New$Gql$Platform$InputObject$buildGetCustomerIdInput(
				$author$project$New$Gql$Platform$InputObject$GetCustomerIdInputRequiredFields(getCustomerIdArg)));
	};
	return buildGetCustomerIdInput(input);
};
var $author$project$New$Gql$Platform$Object$GetCustomerIdOutput$customerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'customerId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$InputObject$encodeGetCustomerIdInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerOrPolicyIdentifier',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeOfferOrPolicyIdentifier(input____.H)))
			]));
};
var $author$project$New$Gql$Platform$Query$getCustomerId = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'getCustomerId',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeGetCustomerIdInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Gql$CustomerId$getCustomerId = function (customerIdQueryArg) {
	return A2(
		$author$project$New$Gql$Platform$Query$getCustomerId,
		$author$project$Common$Gql$CustomerId$buildCustomerIdQueryArg(customerIdQueryArg),
		$author$project$New$Gql$Platform$Object$GetCustomerIdOutput$customerId);
};
var $author$project$Common$Gql$NewOffer$offerByCfidRequiredArguments = function (cfid) {
	return {
		nD: {
			oj: {
				oh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid),
				oi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			}
		}
	};
};
var $author$project$New$Gql$Platform$InputObject$encodeOfferDetailsInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerIdentifier',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeOfferIdentifier(input____.oj)))
			]));
};
var $author$project$New$Gql$Platform$Query$offerDetails = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'offerDetails',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeOfferDetailsInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$Offer$additionalDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'additionalDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Person$AdditionalDriver = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Common$Person$PersonData = F4(
	function (firstName, lastName, documentId, dateOfBirth) {
		return {aD: dateOfBirth, aF: documentId, aG: firstName, aM: lastName};
	});
var $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Date)',
	'dateOfBirth',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B));
var $justinmimbs$date$Date$fromRataDie = function (rd) {
	return rd;
};
var $author$project$Common$Locale$defaultDate = $justinmimbs$date$Date$fromRataDie(1);
var $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$documentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'documentId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$NewOffer$additionalDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$dateOfBirth),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$documentId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialAdditionalDriver$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$NewOffer$additionalDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$NewOffer$additionalDriverPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$AdditionalDriver)));
var $author$project$New$Gql$Platform$Object$Offer$applicationId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'applicationId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$OfferDetailsOutput$availableActions = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'availableActions', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Offer$AvailableOfferDetailsActions = F6(
	function (purchase, amendStartDate, complete, edit, editCover, editAncillaryCovers) {
		return {js: amendStartDate, jO: complete, j6: edit, j7: editAncillaryCovers, j9: editCover, lz: purchase};
	});
var $author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$amendOfferStartDate = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'amendOfferStartDate',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$New$Gql$Platform$Object$EditAncillaryCoversLinkActionParameters$link = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'link', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$EditCoverLinkActionParameters$link = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'link', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$AmendOfferStartDateActionParameters$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$CompleteOfferLinkActionParameters$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$EditOfferLinkActionParameters$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$PurchaseOfferButtonActionParameters$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showCompleteOfferLink = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'showCompleteOfferLink',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showEditAncillaryCoversLink = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'showEditAncillaryCoversLink',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showEditCoverLink = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'showEditCoverLink',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showEditOfferLink = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'showEditOfferLink',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showPurchaseOfferButton = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'showPurchaseOfferButton',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Gql$NewOffer$availableOfferDetailsPageActionsSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm_community$maybe_extra$Maybe$Extra$join,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$map($elm$url$Url$fromString),
			$author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showEditAncillaryCoversLink($author$project$New$Gql$Platform$Object$EditAncillaryCoversLinkActionParameters$link))),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showEditCoverLink($author$project$New$Gql$Platform$Object$EditCoverLinkActionParameters$link),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showEditOfferLink($author$project$New$Gql$Platform$Object$EditOfferLinkActionParameters$offerId),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showCompleteOfferLink($author$project$New$Gql$Platform$Object$CompleteOfferLinkActionParameters$offerId),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$amendOfferStartDate($author$project$New$Gql$Platform$Object$AmendOfferStartDateActionParameters$offerId),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$AvailableOfferDetailsPageActions$showPurchaseOfferButton($author$project$New$Gql$Platform$Object$PurchaseOfferButtonActionParameters$offerId),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$AvailableOfferDetailsActions)))))));
var $author$project$New$Gql$Platform$Object$Product$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$Offer$claimsDeclaredWithFault = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsDeclaredWithFault',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$OfferDetailsOutput$coverContinuityInfo = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'coverContinuityInfo', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Offer$creationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'creationDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$Offer$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Offer$ComebackLinkStatusCorrect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$Offer$ComebackLinkStatusIncorrect = {$: 1};
var $author$project$Common$Offer$ComebackLinkStatusNotPresent = {$: 0};
var $author$project$New$Gql$Platform$Object$OfferDetailsOutput$comebackLink = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'comebackLink',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Common$ComebackLink$ComebackLink = $elm$core$Basics$identity;
var $author$project$Common$ComebackLink$new = F2(
	function (url, nonce) {
		return {hH: nonce, i7: url, fH: $elm$core$Maybe$Nothing, fI: $elm$core$Maybe$Nothing, fJ: $elm$core$Maybe$Nothing};
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {a4: frag, bi: params, aV: unvisited, pR: value, bs: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aV;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.pR);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.pR);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.o5),
					$elm$url$Url$Parser$prepareQuery(url.lA),
					url.ng,
					$elm$core$Basics$identity)));
	});
var $author$project$Common$ComebackLink$nonceQueryParamKey = 'nonce';
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.bs;
		var unvisited = _v1.aV;
		var params = _v1.bi;
		var frag = _v1.a4;
		var value = _v1.pR;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bs;
		var unvisited = _v0.aV;
		var params = _v0.bi;
		var frag = _v0.a4;
		var value = _v0.pR;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Common$ComebackLink$offerComeback = A2(
	$elm$url$Url$Parser$questionMark,
	$elm$url$Url$Parser$s('offer_comeback'),
	$elm$url$Url$Parser$Query$string($author$project$Common$ComebackLink$nonceQueryParamKey));
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Common$ComebackLink$rastreatorOfferComeback = A2(
	$elm$url$Url$Parser$questionMark,
	$elm$url$Url$Parser$s('rtr_offer_landing'),
	$elm$url$Url$Parser$Query$string($author$project$Common$ComebackLink$nonceQueryParamKey));
var $author$project$Common$ComebackLink$renewalOfferComeback = A2(
	$elm$url$Url$Parser$questionMark,
	$elm$url$Url$Parser$s('renovacion'),
	$elm$url$Url$Parser$Query$string($author$project$Common$ComebackLink$nonceQueryParamKey));
var $author$project$Common$ComebackLink$urlParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[$author$project$Common$ComebackLink$offerComeback, $author$project$Common$ComebackLink$renewalOfferComeback, $author$project$Common$ComebackLink$rastreatorOfferComeback]));
var $author$project$Common$ComebackLink$tryFrom = function (unknownValue) {
	var _v0 = $elm$url$Url$fromString(unknownValue);
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('The string provided as a Comeback Link is not a valid url');
	} else {
		var url = _v0.a;
		return A2(
			$elm$core$Result$fromMaybe,
			'The string provided as a Comeback Link has an unexpected shape',
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$ComebackLink$new(url),
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2($elm$url$Url$Parser$parse, $author$project$Common$ComebackLink$urlParser, url))));
	}
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Common$Gql$NewOffer$decodeComebackLink = function () {
	var tryToComebackLink = A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$author$project$Common$Offer$ComebackLinkStatusNotPresent,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$ComebackLink$tryFrom,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map($author$project$Common$Offer$ComebackLinkStatusCorrect),
				$elm$core$Result$withDefault($author$project$Common$Offer$ComebackLinkStatusIncorrect))));
	return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, tryToComebackLink, $author$project$New$Gql$Platform$Object$OfferDetailsOutput$comebackLink);
}();
var $author$project$Common$Source$Acierto = 0;
var $author$project$Common$Source$Check24 = 1;
var $author$project$Common$Source$Prima = 2;
var $author$project$Common$Source$Rastreator = 3;
var $author$project$Common$Gql$Source$decodeFromApplicationSource = function (source) {
	switch (source) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 3:
			return 3;
		case 4:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Common$Offer$Available = 8;
var $author$project$Common$Offer$Blocked = 5;
var $author$project$Common$Offer$Expired = 4;
var $author$project$Common$Offer$MissingDocuments = 2;
var $author$project$Common$Offer$NewPrice = 0;
var $author$project$Common$Offer$NewProduct = 1;
var $author$project$Common$Offer$Purchased = 7;
var $author$project$Common$Offer$Requoted = 6;
var $author$project$Common$Offer$StartDateExpired = 3;
var $author$project$Common$Gql$NewOffer$decodeOfferStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		default:
			return 8;
	}
};
var $author$project$Common$Offer$AmendStartDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Offer$Complete = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$Offer$Edit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Common$Offer$EditAncillaryCovers = function (a) {
	return {$: 5, a: a};
};
var $author$project$Common$Offer$EditCover = function (a) {
	return {$: 4, a: a};
};
var $author$project$Common$Offer$Purchase = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Offer$fromAvailableOfferDetailsActions = function (actions) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = actions.lz;
				if (!_v0.$) {
					var id_ = _v0.a;
					return _List_fromArray(
						[
							$author$project$Common$Offer$Purchase(id_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = actions.js;
				if (!_v1.$) {
					var id_ = _v1.a;
					return _List_fromArray(
						[
							$author$project$Common$Offer$AmendStartDate(id_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = actions.jO;
				if (!_v2.$) {
					var id_ = _v2.a;
					return _List_fromArray(
						[
							$author$project$Common$Offer$Complete(id_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = actions.j6;
				if (!_v3.$) {
					var id_ = _v3.a;
					return _List_fromArray(
						[
							$author$project$Common$Offer$Edit(id_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = actions.j9;
				if (!_v4.$) {
					var link = _v4.a;
					return _List_fromArray(
						[
							$author$project$Common$Offer$EditCover(link)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = actions.j7;
				if (!_v5.$) {
					var url = _v5.a;
					return _List_fromArray(
						[
							$author$project$Common$Offer$EditAncillaryCovers(
							$elm$core$Maybe$Just(url))
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$New$Gql$Platform$Object$Offer$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$New$Gql$Platform$Object$Offer$isAGreatLakesRenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isAGreatLakesRenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$Offer$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$Offer$mainDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'mainDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Person$Driver = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$New$Gql$Platform$Object$PartialMainDriver$address = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Address$Address = F4(
	function (streetName, streetNumber, province, postalCode) {
		return {o8: postalCode, pe: province, pD: streetName, pE: streetNumber};
	});
var $author$project$New$Gql$Platform$Object$PartialAddress$postalCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'postalCode', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialAddress$province = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'province', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialAddress$streetName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialAddress$streetNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$NewOffer$addressSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PartialAddress$postalCode,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PartialAddress$province,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialAddress$streetNumber),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialAddress$streetName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Address$Address)))));
var $author$project$New$Gql$Platform$Object$PartialMainDriver$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$PartialMainDriver$documentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'documentId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialMainDriver$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialMainDriver$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$NewOffer$mainDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PartialMainDriver$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialMainDriver$documentId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialMainDriver$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialMainDriver$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$NewOffer$mainDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PartialMainDriver$address($author$project$Common$Gql$NewOffer$addressSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$NewOffer$mainDriverPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Common$ApplicationId$ApplicationId = $elm$core$Basics$identity;
var $author$project$Common$ApplicationId$new = $elm$core$Basics$identity;
var $author$project$Common$Offer$Offer = $elm$core$Basics$identity;
var $author$project$Common$Offer$new = function (id) {
	return function (customerFacingId) {
		return function (applicationId) {
			return function (quoteId) {
				return function (creationDate) {
					return function (startDate) {
						return function (status) {
							return function (quoteIdForClaimsHistoryQuery) {
								return function (mainDriver) {
									return function (policyHolder) {
										return function (additionalDriver) {
											return function (vehicleOwner) {
												return function (vehicle) {
													return function (claimsDeclaredWithFault) {
														return function (availableActions) {
															return function (product) {
																return function (coverContinuity) {
																	return function (selectedBundle) {
																		return function (isRenewal) {
																			return function (source) {
																				return function (comebackLink) {
																					return function (requiresGreatLakesOptIn) {
																						return function (isGreatLakesRenewal) {
																							return {jq: additionalDriver, jt: applicationId, aY: availableActions, f9: claimsDeclaredWithFault, ge: comebackLink, jX: coverContinuity, gh: creationDate, mY: customerFacingId, kv: id, g6: isGreatLakesRenewal, ha: isRenewal, kP: mainDriver, io: policyHolder, dx: product, pf: quoteId, iz: quoteIdForClaimsHistoryQuery, iH: requiresGreatLakesOptIn, iK: selectedBundle, iO: source, l_: startDate, iR: status, je: vehicle, me: vehicleOwner};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Common$QuoteId$QuoteId = $elm$core$Basics$identity;
var $author$project$Common$QuoteId$new = $elm$core$Basics$identity;
var $author$project$Common$Count$Minimum = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Count$minimum = $author$project$Common$Count$Minimum;
var $author$project$Common$Gql$ClaimsCount$newAtLeastTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$minimum, $author$project$New$Gql$Platform$Object$Atleast$count);
var $author$project$Common$Count$Exact = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Count$exact = $author$project$Common$Count$Exact;
var $author$project$Common$Gql$ClaimsCount$newCountTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$exact, $author$project$New$Gql$Platform$Object$Exactly$count);
var $author$project$Common$Gql$ClaimsCount$newClaimsDeclaredWithFaultSelectionSet = $author$project$New$Gql$Platform$Union$ClaimsCount$fragments(
	{op: $author$project$Common$Gql$ClaimsCount$newAtLeastTotalClaimsDeclaredWithFaultSelectionSet, oN: $author$project$Common$Gql$ClaimsCount$newCountTotalClaimsDeclaredWithFaultSelectionSet});
var $author$project$New$Gql$Platform$Union$CoverContinuityInfo$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoPreviousCoverage', selections____.k7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TercerosBasicoSelected', selections____.ll),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageWithNoContinuityInformation', selections____.lc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoveragePendingContinuityInformation', selections____.lb),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTercerosAmpliado', selections____.k8),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTodoRiesgo', selections____.k9),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaBasicoCoverage', selections____.le),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaAmpliadoCoverage', selections____.ld),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaTodoRiesgoCoverage', selections____.lf),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageGivenOnCheck24', selections____.la)
			]));
};
var $author$project$Common$CoverContinuity$NoPreviousCoverage = {$: 0};
var $author$project$Common$CoverContinuity$newCoverContinuityWithNoPreviousPolicy = $author$project$Common$CoverContinuity$NoPreviousCoverage;
var $author$project$Common$Gql$CoverContinuity$onNewNoPreviousCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityWithNoPreviousPolicy);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$ExternalCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$CoverContinuity$ExternalCompanyInfo = $elm$core$Basics$identity;
var $author$project$Common$CoverContinuity$SelectedTercerosAmpliado = function (a) {
	return {$: 4, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTercerosAmpliado = F2(
	function (companyName, hadLunas) {
		return $author$project$Common$CoverContinuity$SelectedTercerosAmpliado(
			{
				K: $author$project$Common$CoverContinuity$ExternalCompany(companyName),
				aK: hadLunas
			});
	});
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTercerosAmpliado)));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$SelectedTodoRiesgo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTodoRiesgo = F3(
	function (companyName, hadLunas, hadDanosProprios) {
		return $author$project$Common$CoverContinuity$SelectedTodoRiesgo(
			{
				K: $author$project$Common$CoverContinuity$ExternalCompany(companyName),
				eF: hadDanosProprios,
				aK: hadLunas
			});
	});
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTodoRiesgo))));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'bundleName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$PreviousCoverageGivenOnCheck24 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverageGivenOnCheck24 = F2(
	function (companyName, bundleName) {
		return $author$project$Common$CoverContinuity$PreviousCoverageGivenOnCheck24(
			{
				f4: bundleName,
				K: $author$project$Common$CoverContinuity$ExternalCompany(companyName)
			});
	});
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageGivenOnCheck24SelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageGivenOnCheck24)));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$PreviousExternalCoveragePendingCoverContinuityInformation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Common$CoverContinuity$newCoverContinuityPendingInfo = A2($elm$core$Basics$composeL, $author$project$Common$CoverContinuity$PreviousExternalCoveragePendingCoverContinuityInformation, $elm$core$Basics$identity);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoveragePendingContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityPendingInfo));
var $author$project$New$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$PreviousExternalCoverageWithNoCoverContinuityInformation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$CoverContinuity$newPreviousExternalCoverageWithNoCoverContinuityInformation = A2($elm$core$Basics$composeL, $author$project$Common$CoverContinuity$PreviousExternalCoverageWithNoCoverContinuityInformation, $elm$core$Basics$identity);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageWithNoContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageWithNoCoverContinuityInformation));
var $author$project$New$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$Prima = {$: 0};
var $author$project$Common$CoverContinuity$newPrimaCoverContinuityTercerosAmpliado = function (hadLunas) {
	return $author$project$Common$CoverContinuity$SelectedTercerosAmpliado(
		{K: $author$project$Common$CoverContinuity$Prima, aK: hadLunas});
};
var $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaAmpliadoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTercerosAmpliado));
var $author$project$Common$CoverContinuity$TercerosBasicoSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$CoverContinuity$newPrimaTercerosBasicoSelected = $author$project$Common$CoverContinuity$TercerosBasicoSelected($author$project$Common$CoverContinuity$Prima);
var $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaBasicoCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaTercerosBasicoSelected);
var $author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$CoverContinuity$newPrimaCoverContinuityTodoRiesgo = F2(
	function (hadLunas, hadDanosProprios) {
		return $author$project$Common$CoverContinuity$SelectedTodoRiesgo(
			{K: $author$project$Common$CoverContinuity$Prima, eF: hadDanosProprios, aK: hadLunas});
	});
var $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaTodoRiesgoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTodoRiesgo)));
var $author$project$New$Gql$Platform$Object$TercerosBasicoSelected$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$CoverContinuity$newPreviousExternalTercerosBasicoSelected = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $author$project$Common$CoverContinuity$TercerosBasicoSelected, $author$project$Common$CoverContinuity$ExternalCompany),
	$elm$core$Basics$identity);
var $author$project$Common$Gql$CoverContinuity$onNewTercerosBasicoSelectedSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$TercerosBasicoSelected$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalTercerosBasicoSelected));
var $author$project$Common$Gql$CoverContinuity$newCoverContinuitySelectionSet = $author$project$New$Gql$Platform$Union$CoverContinuityInfo$fragments(
	{k7: $author$project$Common$Gql$CoverContinuity$onNewNoPreviousCoverageSelectionSet, k8: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet, k9: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet, la: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageGivenOnCheck24SelectionSet, lb: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoveragePendingContinuityInformationSelectionSet, lc: $author$project$Common$Gql$CoverContinuity$onNewPreviousExternalCoverageWithNoContinuityInformationSelectionSet, ld: $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaAmpliadoCoverageSelectionSet, le: $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaBasicoCoverageSelectionSet, lf: $author$project$Common$Gql$CoverContinuity$onNewPreviousPrimaTodoRiesgoCoverageSelectionSet, ll: $author$project$Common$Gql$CoverContinuity$onNewTercerosBasicoSelectedSelectionSet});
var $author$project$Common$Product$OfferProduct = F3(
	function (issuingCompany, bundleSlug, annualPrice) {
		return {mz: annualPrice, mJ: bundleSlug, a8: issuingCompany};
	});
var $author$project$Common$IssuingCompany$GreatLakes = 1;
var $author$project$Common$IssuingCompany$Iptiq = 0;
var $author$project$Common$Gql$IssuingCompany$decodeIssuingCompany = function (issuingCompany) {
	if (!issuingCompany) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$IssuingCompany$GreatLakes = 1;
var $author$project$New$Gql$Platform$Enum$IssuingCompany$Iptiq = 0;
var $author$project$New$Gql$Platform$Enum$IssuingCompany$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'IPTIQ':
				return $elm$json$Json$Decode$succeed(0);
			case 'GREAT_LAKES':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid IssuingCompany type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Product$issuingCompany = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.IssuingCompany.IssuingCompany', 'issuingCompany', _List_Nil, $author$project$New$Gql$Platform$Enum$IssuingCompany$decoder);
var $author$project$Common$Product$AnnualPrice = F5(
	function (gross, taxes, net, taxIps, taxSurcharges) {
		return {nl: gross, n8: net, pI: taxIps, pJ: taxSurcharges, i0: taxes};
	});
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$gross = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'gross',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$net = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'net',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxIps = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'taxIps',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxSurcharges = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'taxSurcharges',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'taxes',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$Common$Gql$OfferProduct$newPriceBreakdownSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxSurcharges),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxIps),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$net),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxes),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$gross),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$AnnualPrice))))));
var $author$project$New$Gql$Platform$Object$Product$priceBreakdown = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'priceBreakdown', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$IssuingCompany$toString = function (issuingCompany) {
	if (!issuingCompany) {
		return 'Iptiq';
	} else {
		return 'Great Lakes';
	}
};
var $author$project$Common$Gql$OfferProduct$newOfferProductSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$Product$priceBreakdown($author$project$Common$Gql$OfferProduct$newPriceBreakdownSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$Product$bundleSlug),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$author$project$Common$IssuingCompany$toString,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$IssuingCompany$decodeIssuingCompany, $author$project$New$Gql$Platform$Object$Product$issuingCompany)),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$OfferProduct))));
var $author$project$New$Gql$Platform$Enum$VehicleModification$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'TINTED_WINDOWS';
		case 1:
			return 'XENON_HEADLIGHTS';
		case 2:
			return 'TOWBALL';
		case 3:
			return 'RIMS';
		case 4:
			return 'SKIRTS';
		case 5:
			return 'SPOILERS';
		case 6:
			return 'EXHAUST_PIPE';
		case 7:
			return 'ENGINE';
		default:
			return 'OTHER';
	}
};
var $author$project$Common$Gql$Vehicle$decodeModification = $author$project$New$Gql$Platform$Enum$VehicleModification$toString;
var $author$project$Common$Gql$Vehicle$decodeModifications = $elm$core$List$map($author$project$Common$Gql$Vehicle$decodeModification);
var $author$project$New$Gql$Platform$Enum$FuelType$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'DIESEL';
		case 1:
			return 'GASOLINE';
		case 2:
			return 'ELECTRIC';
		case 3:
			return 'LIQUID_GAS';
		case 4:
			return 'HYDROGEN';
		case 5:
			return 'HYBRID_ELECTRIC_GASOLINE';
		case 6:
			return 'HYBRID_ELECTRIC_DIESEL';
		case 7:
			return 'HYBRID_PLUGIN_ELECTRIC_GASOLINE';
		case 8:
			return 'HYBRID_PLUGIN_ELECTRIC_DIESEL';
		case 9:
			return 'BIO_ETHANOL';
		case 10:
			return 'ELECTRIC_WITH_GASOLINE_BATTERY';
		case 11:
			return 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL';
		default:
			return 'MILD_HYBRID_ELECTRIC_GASOLINE';
	}
};
var $author$project$Common$Gql$Vehicle$decodeNewFuelType = function (fuelType) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$New$Gql$Platform$Enum$FuelType$toString, fuelType));
};
var $author$project$Common$Gql$Vehicle$decodeNewMileage = function (mileage) {
	if (!mileage.$) {
		switch (mileage.a) {
			case 0:
				var _v1 = mileage.a;
				return 'Up to 2000';
			case 1:
				var _v2 = mileage.a;
				return '2000 - 4000';
			case 2:
				var _v3 = mileage.a;
				return '4000 - 6000';
			case 3:
				var _v4 = mileage.a;
				return '6000 - 8000';
			case 4:
				var _v5 = mileage.a;
				return '8000 - 10000';
			case 5:
				var _v6 = mileage.a;
				return '10000 - 12000';
			case 6:
				var _v7 = mileage.a;
				return '12000 - 14000';
			case 7:
				var _v8 = mileage.a;
				return '14000 - 16000';
			case 8:
				var _v9 = mileage.a;
				return '16000 - 18000';
			case 9:
				var _v10 = mileage.a;
				return '18000 - 20000';
			case 10:
				var _v11 = mileage.a;
				return '20000 - 22000';
			case 11:
				var _v12 = mileage.a;
				return '22000 - 24000';
			case 12:
				var _v13 = mileage.a;
				return '24000 - 26000';
			case 13:
				var _v14 = mileage.a;
				return '26000 - 28000';
			case 14:
				var _v15 = mileage.a;
				return '28000 - 30000';
			case 15:
				var _v16 = mileage.a;
				return '30000 - 32000';
			case 16:
				var _v17 = mileage.a;
				return '32000 - 34000';
			case 17:
				var _v18 = mileage.a;
				return '34000 - 36000';
			case 18:
				var _v19 = mileage.a;
				return '36000 - 38000';
			case 19:
				var _v20 = mileage.a;
				return '38000 - 40000';
			case 20:
				var _v21 = mileage.a;
				return '40000 - 45000';
			case 21:
				var _v22 = mileage.a;
				return '45000 - 50000';
			case 22:
				var _v23 = mileage.a;
				return 'More than 50000';
			case 23:
				var _v24 = mileage.a;
				return 'Up to 6000';
			case 24:
				var _v25 = mileage.a;
				return '6000 - 10000';
			case 25:
				var _v26 = mileage.a;
				return '10000 - 14000';
			case 26:
				var _v27 = mileage.a;
				return '14000 - 20000';
			case 27:
				var _v28 = mileage.a;
				return '20000 - 30000';
			default:
				var _v29 = mileage.a;
				return '30000 - 50000';
		}
	} else {
		return '';
	}
};
var $author$project$New$Gql$Platform$Enum$VehicleUse$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'OCCASIONAL';
		case 1:
			return 'HABITUAL';
		case 2:
			return 'PROFESSIONAL_OCCASIONAL';
		default:
			return 'PROFESSIONAL_HABITUAL';
	}
};
var $author$project$Common$Gql$Vehicle$decodeNewUsage = function (usage) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$New$Gql$Platform$Enum$VehicleUse$toString, usage));
};
var $author$project$New$Gql$Platform$Object$PartialVehicle$enginePower = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'enginePower',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$New$Gql$Platform$Enum$Mileage$From10To12 = 5;
var $author$project$New$Gql$Platform$Enum$Mileage$From10To14 = 25;
var $author$project$New$Gql$Platform$Enum$Mileage$From12To14 = 6;
var $author$project$New$Gql$Platform$Enum$Mileage$From14To16 = 7;
var $author$project$New$Gql$Platform$Enum$Mileage$From14To20 = 26;
var $author$project$New$Gql$Platform$Enum$Mileage$From16To18 = 8;
var $author$project$New$Gql$Platform$Enum$Mileage$From18To20 = 9;
var $author$project$New$Gql$Platform$Enum$Mileage$From20To22 = 10;
var $author$project$New$Gql$Platform$Enum$Mileage$From20To30 = 27;
var $author$project$New$Gql$Platform$Enum$Mileage$From22To24 = 11;
var $author$project$New$Gql$Platform$Enum$Mileage$From24To26 = 12;
var $author$project$New$Gql$Platform$Enum$Mileage$From26To28 = 13;
var $author$project$New$Gql$Platform$Enum$Mileage$From28To30 = 14;
var $author$project$New$Gql$Platform$Enum$Mileage$From2To4 = 1;
var $author$project$New$Gql$Platform$Enum$Mileage$From30To32 = 15;
var $author$project$New$Gql$Platform$Enum$Mileage$From30To50 = 28;
var $author$project$New$Gql$Platform$Enum$Mileage$From32To34 = 16;
var $author$project$New$Gql$Platform$Enum$Mileage$From34To36 = 17;
var $author$project$New$Gql$Platform$Enum$Mileage$From36To38 = 18;
var $author$project$New$Gql$Platform$Enum$Mileage$From38To40 = 19;
var $author$project$New$Gql$Platform$Enum$Mileage$From40To45 = 20;
var $author$project$New$Gql$Platform$Enum$Mileage$From45To50 = 21;
var $author$project$New$Gql$Platform$Enum$Mileage$From4To6 = 2;
var $author$project$New$Gql$Platform$Enum$Mileage$From6To10 = 24;
var $author$project$New$Gql$Platform$Enum$Mileage$From6To8 = 3;
var $author$project$New$Gql$Platform$Enum$Mileage$From8To10 = 4;
var $author$project$New$Gql$Platform$Enum$Mileage$MoreThan50 = 22;
var $author$project$New$Gql$Platform$Enum$Mileage$UpTo2 = 0;
var $author$project$New$Gql$Platform$Enum$Mileage$UpTo6 = 23;
var $author$project$New$Gql$Platform$Enum$Mileage$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'UP_TO_2':
				return $elm$json$Json$Decode$succeed(0);
			case 'FROM_2_TO_4':
				return $elm$json$Json$Decode$succeed(1);
			case 'FROM_4_TO_6':
				return $elm$json$Json$Decode$succeed(2);
			case 'FROM_6_TO_8':
				return $elm$json$Json$Decode$succeed(3);
			case 'FROM_8_TO_10':
				return $elm$json$Json$Decode$succeed(4);
			case 'FROM_10_TO_12':
				return $elm$json$Json$Decode$succeed(5);
			case 'FROM_12_TO_14':
				return $elm$json$Json$Decode$succeed(6);
			case 'FROM_14_TO_16':
				return $elm$json$Json$Decode$succeed(7);
			case 'FROM_16_TO_18':
				return $elm$json$Json$Decode$succeed(8);
			case 'FROM_18_TO_20':
				return $elm$json$Json$Decode$succeed(9);
			case 'FROM_20_TO_22':
				return $elm$json$Json$Decode$succeed(10);
			case 'FROM_22_TO_24':
				return $elm$json$Json$Decode$succeed(11);
			case 'FROM_24_TO_26':
				return $elm$json$Json$Decode$succeed(12);
			case 'FROM_26_TO_28':
				return $elm$json$Json$Decode$succeed(13);
			case 'FROM_28_TO_30':
				return $elm$json$Json$Decode$succeed(14);
			case 'FROM_30_TO_32':
				return $elm$json$Json$Decode$succeed(15);
			case 'FROM_32_TO_34':
				return $elm$json$Json$Decode$succeed(16);
			case 'FROM_34_TO_36':
				return $elm$json$Json$Decode$succeed(17);
			case 'FROM_36_TO_38':
				return $elm$json$Json$Decode$succeed(18);
			case 'FROM_38_TO_40':
				return $elm$json$Json$Decode$succeed(19);
			case 'FROM_40_TO_45':
				return $elm$json$Json$Decode$succeed(20);
			case 'FROM_45_TO_50':
				return $elm$json$Json$Decode$succeed(21);
			case 'MORE_THAN_50':
				return $elm$json$Json$Decode$succeed(22);
			case 'UP_TO_6':
				return $elm$json$Json$Decode$succeed(23);
			case 'FROM_6_TO_10':
				return $elm$json$Json$Decode$succeed(24);
			case 'FROM_10_TO_14':
				return $elm$json$Json$Decode$succeed(25);
			case 'FROM_14_TO_20':
				return $elm$json$Json$Decode$succeed(26);
			case 'FROM_20_TO_30':
				return $elm$json$Json$Decode$succeed(27);
			case 'FROM_30_TO_50':
				return $elm$json$Json$Decode$succeed(28);
			default:
				return $elm$json$Json$Decode$fail('Invalid Mileage type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialVehicle$expectedMileage = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.Mileage.Mileage)',
	'expectedMileage',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$Mileage$decoder));
var $author$project$New$Gql$Platform$Enum$FuelType$BioEthanol = 9;
var $author$project$New$Gql$Platform$Enum$FuelType$Diesel = 0;
var $author$project$New$Gql$Platform$Enum$FuelType$Electric = 2;
var $author$project$New$Gql$Platform$Enum$FuelType$ElectricWithGasolineBattery = 10;
var $author$project$New$Gql$Platform$Enum$FuelType$ElectricWithHydrogenFuelCell = 11;
var $author$project$New$Gql$Platform$Enum$FuelType$Gasoline = 1;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridElectricDiesel = 6;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridElectricGasoline = 5;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridPluginElectricDiesel = 8;
var $author$project$New$Gql$Platform$Enum$FuelType$HybridPluginElectricGasoline = 7;
var $author$project$New$Gql$Platform$Enum$FuelType$Hydrogen = 4;
var $author$project$New$Gql$Platform$Enum$FuelType$LiquidGas = 3;
var $author$project$New$Gql$Platform$Enum$FuelType$MildHybridElectricGasoline = 12;
var $author$project$New$Gql$Platform$Enum$FuelType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DIESEL':
				return $elm$json$Json$Decode$succeed(0);
			case 'GASOLINE':
				return $elm$json$Json$Decode$succeed(1);
			case 'ELECTRIC':
				return $elm$json$Json$Decode$succeed(2);
			case 'LIQUID_GAS':
				return $elm$json$Json$Decode$succeed(3);
			case 'HYDROGEN':
				return $elm$json$Json$Decode$succeed(4);
			case 'HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(5);
			case 'HYBRID_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(6);
			case 'HYBRID_PLUGIN_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'HYBRID_PLUGIN_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(8);
			case 'BIO_ETHANOL':
				return $elm$json$Json$Decode$succeed(9);
			case 'ELECTRIC_WITH_GASOLINE_BATTERY':
				return $elm$json$Json$Decode$succeed(10);
			case 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL':
				return $elm$json$Json$Decode$succeed(11);
			case 'MILD_HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(12);
			default:
				return $elm$json$Json$Decode$fail('Invalid FuelType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialVehicle$fuelType = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.FuelType.FuelType)',
	'fuelType',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$FuelType$decoder));
var $author$project$New$Gql$Platform$Object$PartialVehicle$maker = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'maker', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialVehicle$model = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'model', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Enum$VehicleModification$Engine = 7;
var $author$project$New$Gql$Platform$Enum$VehicleModification$ExhaustPipe = 6;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Other = 8;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Rims = 3;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Skirts = 4;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Spoilers = 5;
var $author$project$New$Gql$Platform$Enum$VehicleModification$TintedWindows = 0;
var $author$project$New$Gql$Platform$Enum$VehicleModification$Towball = 2;
var $author$project$New$Gql$Platform$Enum$VehicleModification$XenonHeadlights = 1;
var $author$project$New$Gql$Platform$Enum$VehicleModification$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TINTED_WINDOWS':
				return $elm$json$Json$Decode$succeed(0);
			case 'XENON_HEADLIGHTS':
				return $elm$json$Json$Decode$succeed(1);
			case 'TOWBALL':
				return $elm$json$Json$Decode$succeed(2);
			case 'RIMS':
				return $elm$json$Json$Decode$succeed(3);
			case 'SKIRTS':
				return $elm$json$Json$Decode$succeed(4);
			case 'SPOILERS':
				return $elm$json$Json$Decode$succeed(5);
			case 'EXHAUST_PIPE':
				return $elm$json$Json$Decode$succeed(6);
			case 'ENGINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'OTHER':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Invalid VehicleModification type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialVehicle$modifications = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.VehicleModification.VehicleModification)',
	'modifications',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$New$Gql$Platform$Enum$VehicleModification$decoder));
var $author$project$Common$Vehicle$Vehicle = $elm$core$Basics$identity;
var $author$project$Common$Vehicle$new = function (model) {
	return function (maker) {
		return function (plateNumber) {
			return function (mileage) {
				return function (registrationDate) {
					return function (usage) {
						return function (fuelType) {
							return function (version) {
								return function (enginePower) {
									return function (accessories) {
										return {fL: accessories, gB: enginePower, gL: fuelType, ho: maker, hu: mileage, hx: model, $9: plateNumber, iD: registrationDate, i8: usage, jj: version};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Object$PartialVehicle$plateNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'plateNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialVehicle$registrationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'registrationDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Enum$VehicleUse$Habitual = 1;
var $author$project$New$Gql$Platform$Enum$VehicleUse$Occasional = 0;
var $author$project$New$Gql$Platform$Enum$VehicleUse$ProfessionalHabitual = 3;
var $author$project$New$Gql$Platform$Enum$VehicleUse$ProfessionalOccasional = 2;
var $author$project$New$Gql$Platform$Enum$VehicleUse$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'OCCASIONAL':
				return $elm$json$Json$Decode$succeed(0);
			case 'HABITUAL':
				return $elm$json$Json$Decode$succeed(1);
			case 'PROFESSIONAL_OCCASIONAL':
				return $elm$json$Json$Decode$succeed(2);
			case 'PROFESSIONAL_HABITUAL':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid VehicleUse type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialVehicle$usage = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.VehicleUse.VehicleUse)',
	'usage',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$VehicleUse$decoder));
var $author$project$New$Gql$Platform$Object$PartialVehicle$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Vehicle$newPartialVehicleSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeModifications, $author$project$New$Gql$Platform$Object$PartialVehicle$modifications),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PartialVehicle$enginePower,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PartialVehicle$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewFuelType, $author$project$New$Gql$Platform$Object$PartialVehicle$fuelType),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewUsage, $author$project$New$Gql$Platform$Object$PartialVehicle$usage),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialVehicle$registrationDate),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewMileage, $author$project$New$Gql$Platform$Object$PartialVehicle$expectedMileage),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialVehicle$plateNumber),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$New$Gql$Platform$Object$PartialVehicle$maker,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$PartialVehicle$model,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Vehicle$new)))))))))));
var $author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offer', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Offer$policyHolder = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policyHolder', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Person$Dni = 0;
var $author$project$Common$Person$PolicyHolder = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$New$Gql$Platform$Object$PartialPolicyHolder$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Address$defaultAddress = A4($author$project$Common$Address$Address, '', '', '', '');
var $author$project$Common$Person$Contacts = F2(
	function (email, phoneNumber) {
		return {ew: email, il: phoneNumber};
	});
var $author$project$New$Gql$Platform$Object$PartialPolicyHolder$email = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'email',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialPolicyHolder$phoneNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'phoneNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$NewOffer$policyHolderContactsSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialPolicyHolder$phoneNumber),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialPolicyHolder$email),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Contacts)));
var $author$project$New$Gql$Platform$Object$PartialPolicyHolder$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Date)',
	'dateOfBirth',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B));
var $author$project$New$Gql$Platform$Object$PartialPolicyHolder$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PartialPolicyHolder$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialPolicyHolder$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$NewOffer$policyHolderPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$New$Gql$Platform$Object$PartialPolicyHolder$dateOfBirth),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PartialPolicyHolder$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialPolicyHolder$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialPolicyHolder$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$NewOffer$policyHolderSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	0,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$NewOffer$policyHolderContactsSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$New$Gql$Platform$Object$PartialPolicyHolder$address($author$project$Common$Gql$NewOffer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$NewOffer$policyHolderPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PolicyHolder)))));
var $author$project$New$Gql$Platform$Object$Offer$quoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'quoteId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$Offer$quoteIdForClaimsHistoryQuery = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'quoteIdForClaimsHistoryQuery',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$Offer$requiresGreatLakesOptInConsent = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'requiresGreatLakesOptInConsent', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$Offer$selectedProduct = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'selectedProduct', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Acierto = 0;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Check24 = 1;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Prima = 2;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$PrimaDts = 4;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$Rastreator = 3;
var $author$project$New$Gql$Platform$Enum$ApplicationSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ACIERTO':
				return $elm$json$Json$Decode$succeed(0);
			case 'CHECK_24':
				return $elm$json$Json$Decode$succeed(1);
			case 'PRIMA':
				return $elm$json$Json$Decode$succeed(2);
			case 'RASTREATOR':
				return $elm$json$Json$Decode$succeed(3);
			case 'PRIMA_DTS':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid ApplicationSource type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Offer$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ApplicationSource.ApplicationSource', 'source', _List_Nil, $author$project$New$Gql$Platform$Enum$ApplicationSource$decoder);
var $author$project$New$Gql$Platform$Object$Offer$startDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'startDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$Available = 8;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$Blocked = 5;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$Expired = 4;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$MissingDocuments = 2;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$NewPrice = 0;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$NewProduct = 1;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$Purchased = 7;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$Requoted = 6;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$StartDateExpired = 3;
var $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NEW_PRICE':
				return $elm$json$Json$Decode$succeed(0);
			case 'NEW_PRODUCT':
				return $elm$json$Json$Decode$succeed(1);
			case 'MISSING_DOCUMENTS':
				return $elm$json$Json$Decode$succeed(2);
			case 'START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(3);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(4);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(5);
			case 'REQUOTED':
				return $elm$json$Json$Decode$succeed(6);
			case 'PURCHASED':
				return $elm$json$Json$Decode$succeed(7);
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Invalid OfferDetailsPageStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Offer$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.OfferDetailsPageStatus.OfferDetailsPageStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$OfferDetailsPageStatus$decoder);
var $author$project$New$Gql$Platform$Object$Offer$vehicle = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicle', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Offer$vehicleOwner = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleOwner', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Person$VehicleOwner = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$New$Gql$Platform$Object$PartialVehicleOwner$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$PartialVehicleOwner$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Date)',
	'dateOfBirth',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B));
var $author$project$New$Gql$Platform$Object$PartialVehicleOwner$documentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'documentId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialVehicleOwner$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$PartialVehicleOwner$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$NewOffer$vehicleOwnerPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$Locale$defaultDate, $author$project$New$Gql$Platform$Object$PartialVehicleOwner$dateOfBirth),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialVehicleOwner$documentId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialVehicleOwner$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$PartialVehicleOwner$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$NewOffer$vehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
		$author$project$Common$Address$defaultAddress,
		$author$project$New$Gql$Platform$Object$PartialVehicleOwner$address($author$project$Common$Gql$NewOffer$addressSelectionSet)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$NewOffer$vehicleOwnerPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$VehicleOwner)));
var $author$project$Common$Gql$NewOffer$offerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$isAGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Common$Gql$NewOffer$decodeComebackLink,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Source$decodeFromApplicationSource, $author$project$New$Gql$Platform$Object$Offer$source)),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$isARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								$author$project$Common$Gql$BundleSlug$decodeNewBundleSlug,
								$author$project$New$Gql$Platform$Object$Offer$selectedProduct($author$project$New$Gql$Platform$Object$Product$bundleSlug))),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$OfferDetailsOutput$coverContinuityInfo($author$project$Common$Gql$CoverContinuity$newCoverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
									$author$project$New$Gql$Platform$Object$Offer$selectedProduct($author$project$Common$Gql$OfferProduct$newOfferProductSelectionSet)),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
										$author$project$Common$Offer$fromAvailableOfferDetailsActions,
										$author$project$New$Gql$Platform$Object$OfferDetailsOutput$availableActions($author$project$Common$Gql$NewOffer$availableOfferDetailsPageActionsSelectionSet)),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
												$author$project$Common$Count$default,
												$author$project$New$Gql$Platform$Object$Offer$claimsDeclaredWithFault($author$project$Common$Gql$ClaimsCount$newClaimsDeclaredWithFaultSelectionSet))),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
												$author$project$New$Gql$Platform$Object$Offer$vehicle($author$project$Common$Gql$Vehicle$newPartialVehicleSelectionSet)),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
													$author$project$New$Gql$Platform$Object$Offer$vehicleOwner($author$project$Common$Gql$NewOffer$vehicleOwnerSelectionSet)),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
														$author$project$New$Gql$Platform$Object$Offer$additionalDriver($author$project$Common$Gql$NewOffer$additionalDriverSelectionSet)),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
															$author$project$New$Gql$Platform$Object$Offer$policyHolder($author$project$Common$Gql$NewOffer$policyHolderSelectionSet)),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer(
																$author$project$New$Gql$Platform$Object$Offer$mainDriver($author$project$Common$Gql$NewOffer$mainDriverSelectionSet)),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	$elm$core$Maybe$Just,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$author$project$Common$QuoteId$new,
																		$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$quoteIdForClaimsHistoryQuery))),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																		$author$project$Common$Gql$NewOffer$decodeOfferStatus,
																		$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$status)),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$startDate),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$creationDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																					$author$project$Common$QuoteId$new,
																					$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$quoteId)),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																						$author$project$Common$ApplicationId$new,
																						$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$applicationId)),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$customerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$New$Gql$Platform$Object$OfferDetailsOutput$offer($author$project$New$Gql$Platform$Object$Offer$id),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Common$Gql$NewOffer$getOfferDetails = function (queryArg) {
	return A2(
		$author$project$New$Gql$Platform$Query$offerDetails,
		$author$project$Common$Gql$NewOffer$offerByCfidRequiredArguments(queryArg),
		$author$project$Common$Gql$NewOffer$offerSelectionSet);
};
var $author$project$New$Gql$Platform$InputObject$GetPreviousPaymentMethodInputRequiredFields = function (renewalOfferOrPolicyIdentifier) {
	return {dz: renewalOfferOrPolicyIdentifier};
};
var $author$project$New$Gql$Platform$Query$GetPreviousPaymentMethodRequiredArguments = function (input) {
	return {nD: input};
};
var $author$project$New$Gql$Platform$InputObject$buildGetPreviousPaymentMethodInput = function (required____) {
	return {dz: required____.dz};
};
var $author$project$Common$Gql$PaymentMethod$buildPaymentMethodArg = function (args) {
	var buildPolicyInput = function (policyId) {
		return A2(
			$author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$New$Gql$Platform$InputObject$PolicyIdentifier(
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(policyId))));
	};
	var buildOfferInput = function (offerId) {
		return function (offerIdentifier) {
			return A2($author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier, offerIdentifier, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
		}(
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				A2(
					$author$project$New$Gql$Platform$InputObject$OfferIdentifier,
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(offerId),
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent)));
	};
	var input = function () {
		if (!args.$) {
			var policyId = args.a;
			return buildPolicyInput(policyId);
		} else {
			var offerId = args.a;
			return buildOfferInput(offerId);
		}
	}();
	var buildGetPreviousPaymentMethodInput = function (getPreviousPaymentMethodArg) {
		return $author$project$New$Gql$Platform$Query$GetPreviousPaymentMethodRequiredArguments(
			$author$project$New$Gql$Platform$InputObject$buildGetPreviousPaymentMethodInput(
				$author$project$New$Gql$Platform$InputObject$GetPreviousPaymentMethodInputRequiredFields(getPreviousPaymentMethodArg)));
	};
	return buildGetPreviousPaymentMethodInput(input);
};
var $author$project$New$Gql$Platform$InputObject$encodeGetPreviousPaymentMethodInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'renewalOfferOrPolicyIdentifier',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeOfferOrPolicyIdentifier(input____.dz)))
			]));
};
var $author$project$New$Gql$Platform$Query$getPreviousPaymentMethod = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'getPreviousPaymentMethod',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeGetPreviousPaymentMethodInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Union$PaymentMethod$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CreditCard', selections____.oJ)
			]));
};
var $author$project$Common$PaymentMethod$PaymentMethod = F4(
	function (brand, cardNumber, cardValidity, expirationDate) {
		return {bB: brand, cL: cardNumber, eb: cardValidity, cW: expirationDate};
	});
var $author$project$New$Gql$Platform$Object$CreditCard$brand = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'brand', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$CreditCard$cardNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'cardNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$PaymentMethod$Expired = 1;
var $author$project$Common$PaymentMethod$Valid = 0;
var $author$project$Common$Gql$PaymentMethod$decodeValidity = function (cardValidity) {
	if (cardValidity === 1) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$New$Gql$Platform$Object$CreditCard$expirationDate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'expirationDate', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$PaymentMethod$Maestro = {$: 2};
var $author$project$Common$PaymentMethod$MasterCard = {$: 1};
var $author$project$Common$PaymentMethod$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Common$PaymentMethod$Visa = {$: 0};
var $author$project$New$Gql$Platform$Union$Brand$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Visa', selections____.o$),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Mastercard', selections____.oQ),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Maestro', selections____.oP),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'OtherCard', selections____.oR)
			]));
};
var $author$project$New$Gql$Platform$Object$OtherCard$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$PaymentMethod$onBrandSelectionSet = $author$project$New$Gql$Platform$Union$Brand$fragments(
	{
		oP: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$Maestro),
		oQ: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$MasterCard),
		oR: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$PaymentMethod$Other, $author$project$New$Gql$Platform$Object$OtherCard$name),
		o$: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$Visa)
	});
var $author$project$New$Gql$Platform$Enum$CreditCardValidity$Expired = 1;
var $author$project$New$Gql$Platform$Enum$CreditCardValidity$Valid = 0;
var $author$project$New$Gql$Platform$Enum$CreditCardValidity$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'VALID':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid CreditCardValidity type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$CreditCard$validity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.CreditCardValidity.CreditCardValidity', 'validity', _List_Nil, $author$project$New$Gql$Platform$Enum$CreditCardValidity$decoder);
var $author$project$Common$Gql$PaymentMethod$onCreditCardSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$CreditCard$expirationDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PaymentMethod$decodeValidity, $author$project$New$Gql$Platform$Object$CreditCard$validity),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$CreditCard$cardNumber,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$CreditCard$brand($author$project$Common$Gql$PaymentMethod$onBrandSelectionSet),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$PaymentMethod$PaymentMethod)))));
var $author$project$Common$Gql$PaymentMethod$paymentMethodSelectionSet = $author$project$New$Gql$Platform$Union$PaymentMethod$fragments(
	{oJ: $author$project$Common$Gql$PaymentMethod$onCreditCardSelectionSet});
var $author$project$New$Gql$Platform$Object$GetPreviousPaymentMethodOutput$previousPaymentMethod = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'previousPaymentMethod', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$PaymentMethod$getPreviousPaymentMethodSelectionSet = $author$project$New$Gql$Platform$Object$GetPreviousPaymentMethodOutput$previousPaymentMethod($author$project$Common$Gql$PaymentMethod$paymentMethodSelectionSet);
var $author$project$Common$Gql$PaymentMethod$getPaymentMethod = function (paymentMethodArg) {
	return A2(
		$author$project$New$Gql$Platform$Query$getPreviousPaymentMethod,
		$author$project$Common$Gql$PaymentMethod$buildPaymentMethodArg(paymentMethodArg),
		$author$project$Common$Gql$PaymentMethod$getPreviousPaymentMethodSelectionSet);
};
var $author$project$Env$isStaging = function (environment) {
	var _v0 = $author$project$Env$envName(environment);
	if (_v0 === 1) {
		return true;
	} else {
		return false;
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(
	function (baseUrl, mutationSelectionSet) {
		return {
			cH: baseUrl,
			m3: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
			na: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
			ns: _List_Nil,
			bh: $elm$core$Maybe$Nothing,
			bl: _List_Nil,
			pL: $elm$core$Maybe$Nothing,
			bu: false
		};
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Gql$Platform$Query$OfferV2RequiredArguments = function (identifier) {
	return {bT: identifier};
};
var $author$project$Common$Gql$Offer$offerByCfidRequiredArguments = function (cfid) {
	return $author$project$Gql$Platform$Query$OfferV2RequiredArguments(
		{
			mY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid),
			oi: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		});
};
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Scalar$CreditCardLastFourDigits = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$DateTime = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$GqlDecimal = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$Id = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$NaiveDate = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$NonEmptyString = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$Uuid = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$YearMonth = $elm$core$Basics$identity;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			function (bool) {
				return bool ? 'true' : 'false';
			},
			$elm$json$Json$Decode$bool)
		]));
var $author$project$Gql$Platform$Scalar$defaultCodecs = {
	jJ: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	O: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	mP: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	jK: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	cN: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v4) {
			var raw = _v4;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	bH: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v5) {
			var raw = _v5;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	u: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v6) {
			var raw = _v6;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	jL: {
		B: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		at: function (_v7) {
			var raw = _v7;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$Gql$Platform$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$Gql$Platform$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$ScalarCodecs$codecs = function () {
	var resultDecoder = function (res) {
		if (!res.$) {
			var date = res.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var err = res.a;
			return $elm$json$Json$Decode$fail(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'wrong format from server: {}',
					_List_fromArray(
						[err])));
		}
	};
	var maybeDecoder = function (res) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('wrong uuid format'),
			A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, res));
	};
	return $author$project$Gql$Platform$Scalar$defineCodecs(
		{
			jJ: {B: $elm$json$Json$Decode$string, at: $elm$json$Json$Encode$string},
			O: {
				B: A2(
					$elm$json$Json$Decode$andThen,
					function (maybeDateTime) {
						if (!maybeDateTime.$) {
							var dateTime = maybeDateTime.a;
							return $elm$json$Json$Decode$succeed(dateTime);
						} else {
							return $elm$json$Json$Decode$fail('Cannot be converted to POSIX time.');
						}
					},
					A2(
						$elm$json$Json$Decode$map,
						A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime, $elm$core$Result$toMaybe),
						$elm$json$Json$Decode$string)),
				at: A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string)
			},
			mP: {
				B: A2(
					$elm$json$Json$Decode$andThen,
					function (maybeDecimal) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Decode$fail('Cannot be converted to Decimal'),
							A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, maybeDecimal));
					},
					A2($elm$json$Json$Decode$map, $prikhi$decimal$Decimal$fromString, $elm$json$Json$Decode$string)),
				at: A2($elm$core$Basics$composeR, $prikhi$decimal$Decimal$toString, $elm$json$Json$Encode$string)
			},
			jK: $author$project$Gql$Platform$Scalar$defaultCodecs.jK,
			cN: {
				B: A2(
					$elm$json$Json$Decode$andThen,
					resultDecoder,
					A2($elm$json$Json$Decode$map, $justinmimbs$date$Date$fromIsoString, $elm$json$Json$Decode$string)),
				at: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toIsoString, $elm$json$Json$Encode$string)
			},
			bH: $author$project$Gql$Platform$Scalar$defaultCodecs.bH,
			u: {
				B: A2(
					$elm$json$Json$Decode$andThen,
					maybeDecoder,
					A2($elm$json$Json$Decode$map, $danyx23$elm_uuid$Uuid$fromString, $elm$json$Json$Decode$string)),
				at: A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string)
			},
			jL: $author$project$Gql$Platform$Scalar$defaultCodecs.jL
		});
}();
var $author$project$Gql$Platform$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedQuoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'blockedQuoteId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Gql$Platform$Enum$BackofficeBlockedOfferStatus$Blocked = 0;
var $author$project$Gql$Platform$Enum$BackofficeBlockedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'BLOCKED') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('Invalid BackofficeBlockedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeBlockedOfferStatus.BackofficeBlockedOfferStatus', 'blockedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeBlockedOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Union$BackofficeCoverContinuitySummary$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoPreviousCoverage', selections____.k7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TercerosBasicoSelected', selections____.ll),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageWithNoContinuityInformation', selections____.lc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoveragePendingContinuityInformation', selections____.lb),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTercerosAmpliado', selections____.k8),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageAndSelectedTodoRiesgo', selections____.k9),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaBasicoCoverage', selections____.le),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaAmpliadoCoverage', selections____.ld),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousPrimaTodoRiesgoCoverage', selections____.lf),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PreviousExternalCoverageGivenOnCheck24', selections____.la)
			]));
};
var $author$project$Common$Gql$CoverContinuity$onNoPreviousCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityWithNoPreviousPolicy);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$hadLunas,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTercerosAmpliado$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTercerosAmpliado)));
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$hadLunas,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$PreviousExternalCoverageAndSelectedTodoRiesgo$companyName,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverContinuityTodoRiesgo))));
var $author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'bundleName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageGivenOnCheck24SelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$bundleName,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousExternalCoverageGivenOnCheck24$companyName,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageGivenOnCheck24)));
var $author$project$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoveragePendingContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoveragePendingContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newCoverContinuityPendingInfo));
var $author$project$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageWithNoContinuityInformationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousExternalCoverageWithNoContinuityInformation$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalCoverageWithNoCoverContinuityInformation));
var $author$project$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onPreviousPrimaAmpliadoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousPrimaAmpliadoCoverage$hadLunas,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTercerosAmpliado));
var $author$project$Common$Gql$CoverContinuity$onPreviousPrimaBasicoCoverageSelectionSet = $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaTercerosBasicoSelected);
var $author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadDanosPropios', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'hadLunas', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$CoverContinuity$onPreviousPrimaTodoRiesgoCoverageSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadDanosPropios,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$PreviousPrimaTodoRiesgoCoverage$hadLunas,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPrimaCoverContinuityTodoRiesgo)));
var $author$project$Gql$Platform$Object$TercerosBasicoSelected$companyName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'companyName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$CoverContinuity$onTercerosBasicoSelectedSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$TercerosBasicoSelected$companyName,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$CoverContinuity$newPreviousExternalTercerosBasicoSelected));
var $author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet = $author$project$Gql$Platform$Union$BackofficeCoverContinuitySummary$fragments(
	{k7: $author$project$Common$Gql$CoverContinuity$onNoPreviousCoverageSelectionSet, k8: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTercerosAmpliadoSelectionSet, k9: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageAndSelectedTodoRiesgoSelectionSet, la: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageGivenOnCheck24SelectionSet, lb: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoveragePendingContinuityInformationSelectionSet, lc: $author$project$Common$Gql$CoverContinuity$onPreviousExternalCoverageWithNoContinuityInformationSelectionSet, ld: $author$project$Common$Gql$CoverContinuity$onPreviousPrimaAmpliadoCoverageSelectionSet, le: $author$project$Common$Gql$CoverContinuity$onPreviousPrimaBasicoCoverageSelectionSet, lf: $author$project$Common$Gql$CoverContinuity$onPreviousPrimaTodoRiesgoCoverageSelectionSet, ll: $author$project$Common$Gql$CoverContinuity$onTercerosBasicoSelectedSelectionSet});
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'applicationId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$decodeApplicationId = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$ApplicationId$new, $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationId);
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Acierto = 2;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Check24 = 3;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Prima = 0;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$Rastreator = 1;
var $author$project$Gql$Platform$Enum$BackofficeApplicationSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'PRIMA':
				return $elm$json$Json$Decode$succeed(0);
			case 'RASTREATOR':
				return $elm$json$Json$Decode$succeed(1);
			case 'ACIERTO':
				return $elm$json$Json$Decode$succeed(2);
			case 'CHECK_24':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeApplicationSource type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationSource = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeApplicationSource.BackofficeApplicationSource', 'applicationSource', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeApplicationSource$decoder);
var $author$project$Common$Gql$ApplicationSource$decodeApplicationSource = function (applicationSource) {
	switch (applicationSource) {
		case 2:
			return 0;
		case 3:
			return 1;
		case 0:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Common$Gql$Offer$decodeApplicationSource = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$ApplicationSource$decodeApplicationSource, $author$project$Gql$Platform$Object$BackofficeOfferDetails$applicationSource);
var $author$project$Gql$Platform$Object$BackofficeAmendOfferStartDate$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$decodeAmendStartDateAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeAmendOfferStartDate$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$AmendStartDate));
var $author$project$Gql$Platform$Object$BackofficeCompleteOffer$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$decodeCompleteAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeCompleteOffer$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$Complete));
var $author$project$Gql$Platform$Object$BackofficeEditOffer$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$decodeEditAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeEditOffer$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$Edit));
var $author$project$Gql$Platform$Object$BackofficeShowEditCoverLink$link = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'link', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$decodeEditCoverAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeShowEditCoverLink$link,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$EditCover));
var $author$project$Gql$Platform$Object$BackofficePurchaseOffer$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$decodePurchaseAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePurchaseOffer$offerId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$Purchase));
var $author$project$Gql$Platform$Object$BackofficeShowEditAncillaryCoversLink$link = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'link', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$decodeShowEditAncillaryCoversAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$url$Url$fromString, $author$project$Gql$Platform$Object$BackofficeShowEditAncillaryCoversLink$link),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$EditAncillaryCovers));
var $author$project$Gql$Platform$Union$BackofficeOfferAction$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficePurchaseOffer', selections____.ox),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeAmendOfferStartDate', selections____.oq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeCompleteOffer', selections____.os),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeEditOffer', selections____.ou),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeShowEditCoverLink', selections____.oD),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeShowEditAncillaryCoversLink', selections____.oC)
			]));
};
var $author$project$Common$Gql$Offer$decodeAvailableActions = $author$project$Gql$Platform$Union$BackofficeOfferAction$fragments(
	{oq: $author$project$Common$Gql$Offer$decodeAmendStartDateAction, os: $author$project$Common$Gql$Offer$decodeCompleteAction, ou: $author$project$Common$Gql$Offer$decodeEditAction, ox: $author$project$Common$Gql$Offer$decodePurchaseAction, oC: $author$project$Common$Gql$Offer$decodeShowEditAncillaryCoversAction, oD: $author$project$Common$Gql$Offer$decodeEditCoverAction});
var $author$project$Common$Gql$Offer$decodeBlockedOfferStatus = function (_v0) {
	return 5;
};
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$comebackLink = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'comebackLink',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$decodeComebackLink = function () {
	var tryToComebackLink = A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$author$project$Common$Offer$ComebackLinkStatusNotPresent,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$ComebackLink$tryFrom,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$map($author$project$Common$Offer$ComebackLinkStatusCorrect),
				$elm$core$Result$withDefault($author$project$Common$Offer$ComebackLinkStatusIncorrect))));
	return A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, tryToComebackLink, $author$project$Gql$Platform$Object$BackofficeOfferDetails$comebackLink);
}();
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$creationAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'creationAt',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).O.B);
var $author$project$Common$Gql$Offer$decodeCreationDate = $author$project$Gql$Platform$Object$BackofficeOfferDetails$creationAt;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$decodeCustomerFacingId = $author$project$Gql$Platform$Object$BackofficeOfferDetails$customerFacingId;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$LessThanOne = 0;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$LessThanTwo = 1;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$MoreThanTwo = 3;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$OneToThree = 2;
var $author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'LESS_THAN_ONE':
				return $elm$json$Json$Decode$succeed(0);
			case 'LESS_THAN_TWO':
				return $elm$json$Json$Decode$succeed(1);
			case 'ONE_TO_THREE':
				return $elm$json$Json$Decode$succeed(2);
			case 'MORE_THAN_TWO':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid AdditionalDriverDrivingLicenseYears type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$drivingLicenseYears = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.AdditionalDriverDrivingLicenseYears.AdditionalDriverDrivingLicenseYears)',
	'drivingLicenseYears',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$decoder));
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B));
var $author$project$Common$DefaultValues$date = $justinmimbs$date$Date$fromRataDie(1);
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$documentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'documentId',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$fullAdditionalDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$DefaultValues$date, $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$documentId),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$AdditionalDriverDrivingLicenseYears$LessThanOne = 0;
var $author$project$Common$AdditionalDriverDrivingLicenseYears$LessThanTwo = 1;
var $author$project$Common$AdditionalDriverDrivingLicenseYears$MoreThanTwo = 3;
var $author$project$Common$AdditionalDriverDrivingLicenseYears$OneToThree = 2;
var $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$decodeAdditionalDriverDrivingLicenseYears = function (drivingLicenseYears) {
	switch (drivingLicenseYears) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$maybeDecodeAdditionalDriverDrivingLicenseYears = function (drivingLicenseYears) {
	return A2($elm$core$Maybe$map, $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$decodeAdditionalDriverDrivingLicenseYears, drivingLicenseYears);
};
var $author$project$Common$Gql$Offer$fullAdditionalDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$maybeDecodeAdditionalDriverDrivingLicenseYears, $author$project$Gql$Platform$Object$BackofficeFullOccasionalDriverData$drivingLicenseYears),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$fullAdditionalDriverPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$AdditionalDriver)));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$occasionalDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'occasionalDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullAdditionalDriver = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$occasionalDriver($author$project$Common$Gql$Offer$fullAdditionalDriverSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$claimsDeclaredWithFault = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsDeclaredWithFault',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$AtLeast$atLeast = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'atLeast', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Common$Gql$ClaimsCount$atLeastTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$minimum, $author$project$Gql$Platform$Object$AtLeast$atLeast);
var $author$project$Gql$Platform$Object$Count$count = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'count', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Common$Gql$ClaimsCount$countTotalClaimsDeclaredWithFaultSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Count$exact, $author$project$Gql$Platform$Object$Count$count);
var $author$project$Gql$Platform$Union$TotalClaimsCount$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Count', selections____.oI),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AtLeast', selections____.oo)
			]));
};
var $author$project$Common$Gql$ClaimsCount$claimsDeclaredWithFaultSelectionSet = $author$project$Gql$Platform$Union$TotalClaimsCount$fragments(
	{oo: $author$project$Common$Gql$ClaimsCount$atLeastTotalClaimsDeclaredWithFaultSelectionSet, oI: $author$project$Common$Gql$ClaimsCount$countTotalClaimsDeclaredWithFaultSelectionSet});
var $author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
	$author$project$Common$Count$default,
	$author$project$Gql$Platform$Object$BackofficeFullCustomerData$claimsDeclaredWithFault($author$project$Common$Gql$ClaimsCount$claimsDeclaredWithFaultSelectionSet));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$address = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeAddress$postalCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'postalCode', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeAddress$province = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'province', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeAddress$streetName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeAddress$streetNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$addressSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeAddress$postalCode,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeAddress$province,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeAddress$streetNumber),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeAddress$streetName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Address$Address)))));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$drivingLicenseDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'drivingLicenseDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$isLicenseMoreThanTwoYearsOld = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'isLicenseMoreThanTwoYearsOld',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Common$Person$MainDriverDrivingLicenseData = F2(
	function (drivingLicenseDate, isMoreThanTwoYearsOld) {
		return {et: drivingLicenseDate, eR: isMoreThanTwoYearsOld};
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Common$Person$newMainDriverDrivingLicenseData = F2(
	function (drivingLicenseDate, isMoreThanTwoYearsOld) {
		return A3($elm$core$Maybe$map2, $author$project$Common$Person$MainDriverDrivingLicenseData, drivingLicenseDate, isMoreThanTwoYearsOld);
	});
var $author$project$Common$Gql$Offer$decodeMaybeFullMainDriverDrivingLicenseData = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$isLicenseMoreThanTwoYearsOld,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$drivingLicenseDate,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$newMainDriverDrivingLicenseData)));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDate',
	'birthDate',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B);
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$fullMainDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$birthDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$recentInsuranceCompanyName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'recentInsuranceCompanyName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$fullMainDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Common$Gql$Offer$decodeMaybeFullMainDriverDrivingLicenseData,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficeFullMainDriverData$recentInsuranceCompanyName),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullMainDriverData$address($author$project$Common$Gql$Offer$addressSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$fullMainDriverPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$mainDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'mainDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullMainDriver = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$mainDriver($author$project$Common$Gql$Offer$fullMainDriverSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'email', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$phoneNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phoneNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$contactSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$phoneNumber,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$email,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Contacts)));
var $author$project$Common$Person$Nie = 1;
var $author$project$Common$Gql$Offer$decodeDocumentKind = function (status) {
	if (!status) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Gql$Platform$Enum$DocumentKind$Dni = 0;
var $author$project$Gql$Platform$Enum$DocumentKind$Nie = 1;
var $author$project$Gql$Platform$Enum$DocumentKind$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DNI':
				return $elm$json$Json$Decode$succeed(0);
			case 'NIE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid DocumentKind type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentKind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.DocumentKind.DocumentKind', 'documentKind', _List_Nil, $author$project$Gql$Platform$Enum$DocumentKind$decoder);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDate',
	'birthDate',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$fullPolicyHolderPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$birthDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$fullPolicyHolderSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeDocumentKind, $author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$documentKind),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$contactSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficeFullPolicyholderData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$fullPolicyHolderPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PolicyHolder)))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$policyholder = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policyholder', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullPolicyHolder = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$policyholder($author$project$Common$Gql$Offer$fullPolicyHolderSelectionSet);
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'TINTED_WINDOWS';
		case 1:
			return 'XENON_HEADLIGHTS';
		case 2:
			return 'TOW_BALL';
		case 3:
			return 'RIMS';
		case 4:
			return 'SKIRTS';
		case 5:
			return 'SPOILERS';
		case 6:
			return 'EXHAUST_PIPE';
		case 7:
			return 'ENGINE';
		default:
			return 'OTHER';
	}
};
var $author$project$Common$Gql$Vehicle$decodeAccessory = function (accessory) {
	return $author$project$Gql$Platform$Enum$BackofficeVehicleModification$toString(accessory);
};
var $author$project$Common$Gql$Vehicle$decodeAccessories = function (accessories) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (accs) {
				return A2($elm$core$List$map, $author$project$Common$Gql$Vehicle$decodeAccessory, accs);
			},
			accessories));
};
var $author$project$Gql$Platform$Enum$BackofficeFuelType$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'DIESEL';
		case 1:
			return 'GASOLINE';
		case 2:
			return 'ELECTRIC';
		case 3:
			return 'LIQUID_GAS';
		case 4:
			return 'HYDROGEN';
		case 5:
			return 'HYBRID_ELECTRIC_GASOLINE';
		case 6:
			return 'HYBRID_ELECTRIC_DIESEL';
		case 7:
			return 'HYBRID_PLUGIN_ELECTRIC_GASOLINE';
		case 8:
			return 'HYBRID_PLUGIN_ELECTRIC_DIESEL';
		case 9:
			return 'BIO_ETHANOL';
		case 10:
			return 'ELECTRIC_WITH_GASOLINE_BATTERY';
		case 11:
			return 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL';
		default:
			return 'MILD_HYBRID_ELECTRIC_GASOLINE';
	}
};
var $author$project$Common$Gql$Vehicle$decodeFuelType = function (fuelType) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Gql$Platform$Enum$BackofficeFuelType$toString, fuelType));
};
var $author$project$Common$Gql$Vehicle$decodeMileage = function (mileage) {
	switch (mileage) {
		case 0:
			return 'Up to 2000';
		case 1:
			return '2000 - 4000';
		case 2:
			return '4000 - 6000';
		case 3:
			return '6000 - 8000';
		case 4:
			return '8000 - 10000';
		case 5:
			return '10000 - 12000';
		case 6:
			return '12000 - 14000';
		case 7:
			return '14000 - 16000';
		case 8:
			return '16000 - 18000';
		case 9:
			return '18000 - 20000';
		case 10:
			return '20000 - 22000';
		case 11:
			return '22000 - 24000';
		case 12:
			return '24000 - 26000';
		case 13:
			return '26000 - 28000';
		case 14:
			return '28000 - 30000';
		case 15:
			return '30000 - 32000';
		case 16:
			return '32000 - 34000';
		case 17:
			return '34000 - 36000';
		case 18:
			return '36000 - 38000';
		case 19:
			return '38000 - 40000';
		case 20:
			return '40000 - 45000';
		case 21:
			return '45000 - 50000';
		case 22:
			return 'More than 50000';
		case 23:
			return 'Missing Data';
		case 24:
			return 'Up to 6000';
		case 25:
			return '6000 - 10000';
		case 26:
			return '10000 - 14000';
		case 27:
			return '14000 - 20000';
		case 28:
			return '20000 - 30000';
		default:
			return '30000 - 50000';
	}
};
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'OCCASIONAL';
		case 1:
			return 'HABITUAL';
		case 2:
			return 'PROFESSIONAL_OCCASIONAL';
		case 3:
			return 'PROFESSIONAL_HABITUAL';
		default:
			return 'MISSING_DATA';
	}
};
var $author$project$Common$Gql$Vehicle$decodeUsage = function (usage) {
	return $author$project$Gql$Platform$Enum$BackofficeVehicleUse$toString(usage);
};
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$enginePower = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'enginePower',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Gql$Platform$Enum$BackofficeMileage$From10To12 = 5;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From10To14 = 26;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From12To14 = 6;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From14To16 = 7;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From14To20 = 27;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From16To18 = 8;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From18To20 = 9;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From20To22 = 10;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From20To30 = 28;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From22To24 = 11;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From24To26 = 12;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From26To28 = 13;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From28To30 = 14;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From2To4 = 1;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From30To32 = 15;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From30To50 = 29;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From32To34 = 16;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From34To36 = 17;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From36To38 = 18;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From38To40 = 19;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From40To45 = 20;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From45To50 = 21;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From4To6 = 2;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From6To10 = 25;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From6To8 = 3;
var $author$project$Gql$Platform$Enum$BackofficeMileage$From8To10 = 4;
var $author$project$Gql$Platform$Enum$BackofficeMileage$MissingData = 23;
var $author$project$Gql$Platform$Enum$BackofficeMileage$MoreThan50 = 22;
var $author$project$Gql$Platform$Enum$BackofficeMileage$UpTo2 = 0;
var $author$project$Gql$Platform$Enum$BackofficeMileage$UpTo6 = 24;
var $author$project$Gql$Platform$Enum$BackofficeMileage$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'UP_TO_2':
				return $elm$json$Json$Decode$succeed(0);
			case 'FROM_2_TO_4':
				return $elm$json$Json$Decode$succeed(1);
			case 'FROM_4_TO_6':
				return $elm$json$Json$Decode$succeed(2);
			case 'FROM_6_TO_8':
				return $elm$json$Json$Decode$succeed(3);
			case 'FROM_8_TO_10':
				return $elm$json$Json$Decode$succeed(4);
			case 'FROM_10_TO_12':
				return $elm$json$Json$Decode$succeed(5);
			case 'FROM_12_TO_14':
				return $elm$json$Json$Decode$succeed(6);
			case 'FROM_14_TO_16':
				return $elm$json$Json$Decode$succeed(7);
			case 'FROM_16_TO_18':
				return $elm$json$Json$Decode$succeed(8);
			case 'FROM_18_TO_20':
				return $elm$json$Json$Decode$succeed(9);
			case 'FROM_20_TO_22':
				return $elm$json$Json$Decode$succeed(10);
			case 'FROM_22_TO_24':
				return $elm$json$Json$Decode$succeed(11);
			case 'FROM_24_TO_26':
				return $elm$json$Json$Decode$succeed(12);
			case 'FROM_26_TO_28':
				return $elm$json$Json$Decode$succeed(13);
			case 'FROM_28_TO_30':
				return $elm$json$Json$Decode$succeed(14);
			case 'FROM_30_TO_32':
				return $elm$json$Json$Decode$succeed(15);
			case 'FROM_32_TO_34':
				return $elm$json$Json$Decode$succeed(16);
			case 'FROM_34_TO_36':
				return $elm$json$Json$Decode$succeed(17);
			case 'FROM_36_TO_38':
				return $elm$json$Json$Decode$succeed(18);
			case 'FROM_38_TO_40':
				return $elm$json$Json$Decode$succeed(19);
			case 'FROM_40_TO_45':
				return $elm$json$Json$Decode$succeed(20);
			case 'FROM_45_TO_50':
				return $elm$json$Json$Decode$succeed(21);
			case 'MORE_THAN_50':
				return $elm$json$Json$Decode$succeed(22);
			case 'MISSING_DATA':
				return $elm$json$Json$Decode$succeed(23);
			case 'UP_TO_6':
				return $elm$json$Json$Decode$succeed(24);
			case 'FROM_6_TO_10':
				return $elm$json$Json$Decode$succeed(25);
			case 'FROM_10_TO_14':
				return $elm$json$Json$Decode$succeed(26);
			case 'FROM_14_TO_20':
				return $elm$json$Json$Decode$succeed(27);
			case 'FROM_20_TO_30':
				return $elm$json$Json$Decode$succeed(28);
			case 'FROM_30_TO_50':
				return $elm$json$Json$Decode$succeed(29);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeMileage type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$expectedMileage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeMileage.BackofficeMileage', 'expectedMileage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeMileage$decoder);
var $author$project$Gql$Platform$Enum$BackofficeFuelType$BioEthanol = 9;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Diesel = 0;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Electric = 2;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$ElectricWithGasolineBattery = 10;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$ElectricWithHydrogenFuelCell = 11;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Gasoline = 1;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridElectricDiesel = 6;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridElectricGasoline = 5;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridPluginElectricDiesel = 8;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$HybridPluginElectricGasoline = 7;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$Hydrogen = 4;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$LiquidGas = 3;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$MildHybridElectricGasoline = 12;
var $author$project$Gql$Platform$Enum$BackofficeFuelType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DIESEL':
				return $elm$json$Json$Decode$succeed(0);
			case 'GASOLINE':
				return $elm$json$Json$Decode$succeed(1);
			case 'ELECTRIC':
				return $elm$json$Json$Decode$succeed(2);
			case 'LIQUID_GAS':
				return $elm$json$Json$Decode$succeed(3);
			case 'HYDROGEN':
				return $elm$json$Json$Decode$succeed(4);
			case 'HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(5);
			case 'HYBRID_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(6);
			case 'HYBRID_PLUGIN_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'HYBRID_PLUGIN_ELECTRIC_DIESEL':
				return $elm$json$Json$Decode$succeed(8);
			case 'BIO_ETHANOL':
				return $elm$json$Json$Decode$succeed(9);
			case 'ELECTRIC_WITH_GASOLINE_BATTERY':
				return $elm$json$Json$Decode$succeed(10);
			case 'ELECTRIC_WITH_HYDROGEN_FUEL_CELL':
				return $elm$json$Json$Decode$succeed(11);
			case 'MILD_HYBRID_ELECTRIC_GASOLINE':
				return $elm$json$Json$Decode$succeed(12);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeFuelType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$fuelType = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.BackofficeFuelType.BackofficeFuelType)',
	'fuelType',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$BackofficeFuelType$decoder));
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$maker = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'maker', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$model = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'model', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Engine = 7;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$ExhaustPipe = 6;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Other = 8;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Rims = 3;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Skirts = 4;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$Spoilers = 5;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$TintedWindows = 0;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$TowBall = 2;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$XenonHeadlights = 1;
var $author$project$Gql$Platform$Enum$BackofficeVehicleModification$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TINTED_WINDOWS':
				return $elm$json$Json$Decode$succeed(0);
			case 'XENON_HEADLIGHTS':
				return $elm$json$Json$Decode$succeed(1);
			case 'TOW_BALL':
				return $elm$json$Json$Decode$succeed(2);
			case 'RIMS':
				return $elm$json$Json$Decode$succeed(3);
			case 'SKIRTS':
				return $elm$json$Json$Decode$succeed(4);
			case 'SPOILERS':
				return $elm$json$Json$Decode$succeed(5);
			case 'EXHAUST_PIPE':
				return $elm$json$Json$Decode$succeed(6);
			case 'ENGINE':
				return $elm$json$Json$Decode$succeed(7);
			case 'OTHER':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeVehicleModification type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$modifications = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe (List Enum.BackofficeVehicleModification.BackofficeVehicleModification))',
	'modifications',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Gql$Platform$Enum$BackofficeVehicleModification$decoder)));
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$plateNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'plateNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$registrationDate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'registrationDate', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$Habitual = 1;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$MissingData = 4;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$Occasional = 0;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$ProfessionalHabitual = 3;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$ProfessionalOccasional = 2;
var $author$project$Gql$Platform$Enum$BackofficeVehicleUse$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'OCCASIONAL':
				return $elm$json$Json$Decode$succeed(0);
			case 'HABITUAL':
				return $elm$json$Json$Decode$succeed(1);
			case 'PROFESSIONAL_OCCASIONAL':
				return $elm$json$Json$Decode$succeed(2);
			case 'PROFESSIONAL_HABITUAL':
				return $elm$json$Json$Decode$succeed(3);
			case 'MISSING_DATA':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeVehicleUse type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$usage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeVehicleUse.BackofficeVehicleUse', 'usage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeVehicleUse$decoder);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleData$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Vehicle$fullVehicleSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeAccessories, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$modifications),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullVehicleData$enginePower,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullVehicleData$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeFuelType, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$fuelType),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeUsage, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$usage),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeFullVehicleData$registrationDate,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeMileage, $author$project$Gql$Platform$Object$BackofficeFullVehicleData$expectedMileage),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeFullVehicleData$plateNumber,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeFullVehicleData$maker,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeFullVehicleData$model,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Vehicle$new)))))))))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicle = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicle', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullVehicle = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicle($author$project$Common$Gql$Vehicle$fullVehicleSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B));
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Offer$fullVehicleOwnerPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$DefaultValues$date, $author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$fullVehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficeFullVehicleOwnerData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$fullVehicleOwnerPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicleOwner = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleOwner', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFullVehicleOwner = $author$project$Gql$Platform$Object$BackofficeFullCustomerData$vehicleOwner($author$project$Common$Gql$Offer$fullVehicleOwnerSelectionSet);
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$offerId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'offerId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$decodeId = $author$project$Gql$Platform$Object$BackofficeOfferDetails$offerId;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$Offer$decodeIsARenewal = $author$project$Gql$Platform$Object$BackofficeOfferDetails$isARenewal;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$quoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'quoteId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$decodeQuoteId = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeOfferDetails$quoteId);
var $author$project$Common$Gql$BundleSlug$decodeBackofficeBundleSlug = function (bundleSlug) {
	switch (bundleSlug) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TercerosAmpliado = 1;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TercerosBasico = 0;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TodoRiesgoConFranquicia = 2;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TodoRiesgoConFranquicia300 = 3;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$TodoRiesgoConFranquicia500 = 4;
var $author$project$Gql$Platform$Enum$BackofficeBundleSlug$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TERCEROS_BASICO':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERCEROS_AMPLIADO':
				return $elm$json$Json$Decode$succeed(1);
			case 'TODO_RIESGO_CON_FRANQUICIA':
				return $elm$json$Json$Decode$succeed(2);
			case 'TODO_RIESGO_CON_FRANQUICIA_300':
				return $elm$json$Json$Decode$succeed(3);
			case 'TODO_RIESGO_CON_FRANQUICIA_500':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeBundleSlug type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedBundle = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeBundleSlug.BackofficeBundleSlug', 'selectedBundle', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeBundleSlug$decoder);
var $author$project$Common$Gql$Offer$decodeSelectedBundle = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeBackofficeBundleSlug, $author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedBundle);
var $prikhi$decimal$Decimal$fromIntWithExponent = F2(
	function (n, e) {
		return A2(
			$prikhi$decimal$Decimal$Decimal,
			$cmditch$elm_bigint$BigInt$fromInt(n),
			e);
	});
var $prikhi$decimal$Decimal$fromInt = function (n) {
	return A2($prikhi$decimal$Decimal$fromIntWithExponent, n, 0);
};
var $author$project$Common$Price$euroFromInt = A2($elm$core$Basics$composeL, $author$project$Common$Price$euro, $prikhi$decimal$Decimal$fromInt);
var $author$project$Common$Product$baseOfferProductFixture = A3(
	$author$project$Common$Product$OfferProduct,
	'iptQ',
	0,
	{
		nl: $author$project$Common$Price$euroFromInt(40),
		n8: $author$project$Common$Price$euroFromInt(36),
		pI: $author$project$Common$Price$euroFromInt(4),
		pJ: $author$project$Common$Price$euroFromInt(3),
		i0: $author$project$Common$Price$euroFromInt(10)
	});
var $author$project$Gql$Platform$Object$BackofficeOfferProduct$annualPrice = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'annualPrice', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeOfferProduct$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeBundleSlug.BackofficeBundleSlug', 'bundleSlug', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeBundleSlug$decoder);
var $author$project$Gql$Platform$Object$BackofficeOfferProduct$issuingCompany = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'issuingCompany', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$gross = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'gross',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$net = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'net',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxIps = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxIps',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxSurcharges = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxSurcharges',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxes',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Common$Gql$OfferProduct$offerAnnualPriceV2Set = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxSurcharges),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxIps),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$net),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$taxes),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$BackofficeAnnualPrice$gross),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$AnnualPrice))))));
var $author$project$Common$Gql$OfferProduct$offerProductV2SelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeOfferProduct$annualPrice($author$project$Common$Gql$OfferProduct$offerAnnualPriceV2Set),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeBackofficeBundleSlug, $author$project$Gql$Platform$Object$BackofficeOfferProduct$bundleSlug),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeOfferProduct$issuingCompany,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$OfferProduct))));
var $author$project$Common$Gql$Offer$offerProductSelectionSet = $author$project$Common$Gql$OfferProduct$offerProductV2SelectionSet;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedProducts = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'selectedProducts',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Common$Gql$Offer$decodeSelectedProducts = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
	$author$project$Common$Product$baseOfferProductFixture,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$List$head,
		$author$project$Gql$Platform$Object$BackofficeOfferDetails$selectedProducts($author$project$Common$Gql$Offer$offerProductSelectionSet)));
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$startAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.DateTime',
	'startAt',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).O.B);
var $author$project$Common$Gql$Offer$decodeStartDate = $author$project$Gql$Platform$Object$BackofficeOfferDetails$startAt;
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isGreatLakesRenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {aC: clock, mZ: day, n2: month, fA: time, pW: year};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = 2;
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {gi: current, ac: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {iQ: standardOffset, jo: zoneRules};
	});
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.m <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.f, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $elm$core$List$sortBy = _List_sortBy;
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var standard = _v0.aS;
		var save = _v0.L;
		switch (clock) {
			case 0:
				return 0;
			case 1:
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var year = _v0.pW;
	var month = _v0.n2;
	var day = _v0.mZ;
	var time = _v0.fA;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.aC, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.m;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								aC: rule.aC,
								L: rule.L,
								m: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.mZ;
										switch (_v2.$) {
											case 0:
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.n2, day);
											case 1:
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.n2, after));
											case 2:
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.n2, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.n2));
										}
									}()) + rule.fA
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.kk, year) < 1) && (_Utils_cmp(year, rule.l7) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.pW - 1, until.pW));
		var initialOffset = {L: 0, aS: standardOffset};
		var initialChange = {
			f: standardOffset,
			m: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {L: transition.L, aS: standardOffset};
					if (_Utils_cmp(
						transition.m + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aC, previousOffset),
						initialChange.m) < 1) {
						var updatedInitialChange = {f: standardOffset + transition.L, m: initialChange.m};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.m + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aC, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								f: standardOffset + transition.L,
								m: transition.m + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aC, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var standardOffset = _v0.iQ;
		var zoneRules = _v0.jo;
		if (!zoneRules.$) {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						f: standardOffset + save,
						m: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{L: save, aS: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.ac);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.gi, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.ac;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.gi;
			}
		}();
		var initialOffset = {
			L: function () {
				var _v4 = initialState.jo;
				if (!_v4.$) {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			aS: initialState.iQ
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.f;
			},
			initialOffset.aS + initialOffset.L,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, 0, 1, 0, 0),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, 0, 1, 0, 0),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.aS + initialOffset.L, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 3, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {aC: clock, mZ: day, kk: from, n2: month, L: save, fA: time, l7: to};
	});
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$Specification$Standard = 1;
var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 12),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $author$project$Common$Locale$customerTimeZone = $justinmimbs$timezone_data$TimeZone$europe__madrid(0);
var $author$project$Common$Locale$posixToCustomerDate = function (time) {
	return A2($justinmimbs$date$Date$fromPosix, $author$project$Common$Locale$customerTimeZone, time);
};
var $author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'requiresGreatLakesOptInConsent', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Common$Gql$Offer$backofficeBlockedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeBlockedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeBlockedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeBlockedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	$elm$core$Maybe$Just,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedQuoteId)),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeBlockedOfferStatus, $author$project$Gql$Platform$Object$BackofficeBlockedOffer$blockedStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeBlockedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$Available = 0;
var $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$Expired = 1;
var $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeCompletedProvisionalOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$completedProvisionalStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeCompletedProvisionalOfferStatus.BackofficeCompletedProvisionalOfferStatus', 'completedProvisionalStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeCompletedProvisionalOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeCompletedProvisionalOfferStatus = function (status) {
	if (!status) {
		return 8;
	} else {
		return 4;
	}
};
var $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$backofficeCompletedProvisionalOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
																$elm$core$Maybe$Nothing,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeCompletedProvisionalOfferStatus, $author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$completedProvisionalStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeCompletedProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeFinalizedOfferStatus = function (status) {
	switch (status) {
		case 2:
			return 8;
		case 5:
			return 4;
		case 4:
			return 2;
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 3;
	}
};
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$Available = 2;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$Expired = 5;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$MissingDocuments = 4;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$NewPrice = 0;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$NewProduct = 1;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$StartDateExpired = 3;
var $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NEW_PRICE':
				return $elm$json$Json$Decode$succeed(0);
			case 'NEW_PRODUCT':
				return $elm$json$Json$Decode$succeed(1);
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(2);
			case 'START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(3);
			case 'MISSING_DOCUMENTS':
				return $elm$json$Json$Decode$succeed(4);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeFinalizedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$finalizedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeFinalizedOfferStatus.BackofficeFinalizedOfferStatus', 'finalizedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeFinalizedOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$quoteIdForClaimsHistory = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'quoteIdForClaimsHistory',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Offer$backofficeFinalizedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	$elm$core$Maybe$Just,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$quoteIdForClaimsHistory)),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeFinalizedOfferStatus, $author$project$Gql$Platform$Object$BackofficeFinalizedOffer$finalizedStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeFinalizedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$occasionalDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'occasionalDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$drivingLicenseYears = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.AdditionalDriverDrivingLicenseYears.AdditionalDriverDrivingLicenseYears)',
	'drivingLicenseYears',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$AdditionalDriverDrivingLicenseYears$decoder));
var $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B));
var $author$project$Common$Gql$Offer$partialAdditionalDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$DefaultValues$date, $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			'',
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				'',
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$partialOccasionalDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$AdditionalDriverDrivingLicenseYears$maybeDecodeAdditionalDriverDrivingLicenseYears, $author$project$Gql$Platform$Object$BackofficePartialOccasionalDriverData$drivingLicenseYears),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$partialAdditionalDriverPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$AdditionalDriver)));
var $author$project$Common$Gql$Offer$decodePartialAdditionalDriver = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$occasionalDriver($author$project$Common$Gql$Offer$partialOccasionalDriverSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$claimsDeclaredWithFault = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsDeclaredWithFault',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Gql$Offer$decodePartialClaimsDeclaredWithFault = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
	$author$project$Common$Count$default,
	$author$project$Gql$Platform$Object$BackofficePartialCustomerData$claimsDeclaredWithFault($author$project$Common$Gql$ClaimsCount$claimsDeclaredWithFaultSelectionSet));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$mainDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'mainDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$address = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$drivingLicenseDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'drivingLicenseDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$isLicenseMoreThanTwoYearsOld = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'isLicenseMoreThanTwoYearsOld',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Common$Gql$Offer$decodeMaybePartialMainDriverDrivingLicenseData = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$isLicenseMoreThanTwoYearsOld,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$drivingLicenseDate,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$newMainDriverDrivingLicenseData)));
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.NaiveDate',
	'birthDate',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B);
var $author$project$Common$Gql$Offer$partialMainDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$birthDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			'',
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				'',
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$recentInsuranceCompanyName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'recentInsuranceCompanyName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$partialMainDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Common$Gql$Offer$decodeMaybePartialMainDriverDrivingLicenseData,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialMainDriverData$recentInsuranceCompanyName),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficePartialMainDriverData$address($author$project$Common$Gql$Offer$addressSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$partialMainDriverPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Common$Gql$Offer$decodePartialMainDriver = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$mainDriver($author$project$Common$Gql$Offer$partialMainDriverSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentKind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.DocumentKind.DocumentKind', 'documentKind', _List_Nil, $author$project$Gql$Platform$Enum$DocumentKind$decoder);
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$email = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'email',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$partialPolicyHolderContactDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	'',
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$email),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Contacts)));
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B));
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$firstName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'firstName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$lastName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'lastName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Offer$partialPolicyHolderPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$DefaultValues$date, $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$lastName),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$firstName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$partialPolicyHolderSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeDocumentKind, $author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$documentKind),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Offer$partialPolicyHolderContactDataSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficePartialPolicyholderData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$partialPolicyHolderPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PolicyHolder)))));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$policyholder = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policyholder', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodePartialPolicyHolder = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$policyholder($author$project$Common$Gql$Offer$partialPolicyHolderSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$enginePower = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'enginePower',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$expectedMileage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeMileage.BackofficeMileage', 'expectedMileage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeMileage$decoder);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$fuelType = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.BackofficeFuelType.BackofficeFuelType)',
	'fuelType',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$Gql$Platform$Enum$BackofficeFuelType$decoder));
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$maker = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'maker', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$model = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'model', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$plateNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'plateNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$registrationDate = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'registrationDate', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$usage = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeVehicleUse.BackofficeVehicleUse', 'usage', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeVehicleUse$decoder);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleData$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Vehicle$partialVehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	_List_Nil,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePartialVehicleData$enginePower,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficePartialVehicleData$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeFuelType, $author$project$Gql$Platform$Object$BackofficePartialVehicleData$fuelType),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeUsage, $author$project$Gql$Platform$Object$BackofficePartialVehicleData$usage),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficePartialVehicleData$registrationDate,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeMileage, $author$project$Gql$Platform$Object$BackofficePartialVehicleData$expectedMileage),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Gql$Platform$Object$BackofficePartialVehicleData$plateNumber),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficePartialVehicleData$maker,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficePartialVehicleData$model,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Vehicle$new)))))))))));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicle = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicle', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodePartialVehicle = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicle($author$project$Common$Gql$Vehicle$partialVehicleOwnerSelectionSet);
var $author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$birthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.NaiveDate)',
	'birthDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).cN.B));
var $author$project$Common$Gql$Offer$partialVehicleOwnerPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, $author$project$Common$DefaultValues$date, $author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$birthDate),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
			'',
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
				'',
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Offer$partialVehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$Gql$Platform$Object$BackofficePartialVehicleOwnerData$address($author$project$Common$Gql$Offer$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Offer$partialVehicleOwnerPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicleOwner = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleOwner', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodePartialVehicleOwner = $author$project$Gql$Platform$Object$BackofficePartialCustomerData$vehicleOwner($author$project$Common$Gql$Offer$partialVehicleOwnerSelectionSet);
var $author$project$Common$Gql$Offer$decodeProvisionalOfferStatus = function (status) {
	switch (status) {
		case 0:
			return 8;
		case 1:
			return 4;
		default:
			return 5;
	}
};
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'partialCustomerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$Available = 0;
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$Blocked = 2;
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$Expired = 1;
var $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeProvisionalOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$provisionalStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeProvisionalOfferStatus.BackofficeProvisionalOfferStatus', 'provisionalStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeProvisionalOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeProvisionalOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$partialCustomerData($author$project$Common$Gql$Offer$decodePartialMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
																$elm$core$Maybe$Nothing,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeProvisionalOfferStatus, $author$project$Gql$Platform$Object$BackofficeProvisionalOffer$provisionalStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeProvisionalOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodePurchasedOfferStatus = function (_v0) {
	return 7;
};
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficePurchasedOfferStatus$Purchased = 0;
var $author$project$Gql$Platform$Enum$BackofficePurchasedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'PURCHASED') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('Invalid BackofficePurchasedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$purchasedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficePurchasedOfferStatus.BackofficePurchasedOfferStatus', 'purchasedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficePurchasedOfferStatus$decoder);
var $author$project$Gql$Platform$Object$BackofficePurchasedOffer$quoteIdForClaimsHistoryPurchased = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.Uuid)',
	'quoteIdForClaimsHistoryPurchased',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B));
var $author$project$Common$Gql$Offer$backofficePurchasedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficePurchasedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficePurchasedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficePurchasedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	$elm$core$Maybe$map($author$project$Common$QuoteId$new),
																	$author$project$Gql$Platform$Object$BackofficePurchasedOffer$quoteIdForClaimsHistoryPurchased),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodePurchasedOfferStatus, $author$project$Gql$Platform$Object$BackofficePurchasedOffer$purchasedStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficePurchasedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeRenewalOfferStatus = function (status) {
	switch (status) {
		case 2:
			return 8;
		case 0:
			return 4;
		default:
			return 3;
	}
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$quoteIdForClaimsHistory = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'quoteIdForClaimsHistory',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$Available = 2;
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$Expired = 0;
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$StartDateExpired = 1;
var $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(0);
			case 'START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeRenewalOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeRenewalOffer$renewalStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeRenewalOfferStatus.BackofficeRenewalOfferStatus', 'renewalStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeRenewalOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeRenewalOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeRenewalOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeRenewalOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeRenewalOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	$elm$core$Maybe$Just,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeRenewalOffer$quoteIdForClaimsHistory)),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeRenewalOfferStatus, $author$project$Gql$Platform$Object$BackofficeRenewalOffer$renewalStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeRenewalOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeRequoteValidationFailedOfferStatus = function (status) {
	if (status === 1) {
		return 4;
	} else {
		return 2;
	}
};
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$failedQuoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'failedQuoteId',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$Expired = 1;
var $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$MissingDocuments = 0;
var $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'MISSING_DOCUMENTS':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid BackofficeRequoteValidationFailedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$requotedValidationFailedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeRequoteValidationFailedOfferStatus.BackofficeRequoteValidationFailedOfferStatus', 'requotedValidationFailedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeRequoteValidationFailedOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeRequoteValidationFailedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	$elm$core$Maybe$Just,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$QuoteId$new, $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$failedQuoteId)),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeRequoteValidationFailedOfferStatus, $author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$requotedValidationFailedStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeRequoteValidationFailedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$continuitySummary = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'continuitySummary', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'customerData', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Gql$Offer$decodeRequotedOfferStatus = function (_v0) {
	return 6;
};
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$newQuoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.Uuid)',
	'newQuoteId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B));
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'offerDetails', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BackofficeRequotedOfferStatus$Requoted = 0;
var $author$project$Gql$Platform$Enum$BackofficeRequotedOfferStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'REQUOTED') {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$fail('Invalid BackofficeRequotedOfferStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeRequotedOffer$requotedStatus = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BackofficeRequotedOfferStatus.BackofficeRequotedOfferStatus', 'requotedStatus', _List_Nil, $author$project$Gql$Platform$Enum$BackofficeRequotedOfferStatus$decoder);
var $author$project$Common$Gql$Offer$backofficeRequotedOfferSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$isGreatLakesRenewal),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Gql$Platform$Object$BackofficeOfferDetails$requiresGreatLakesOptInConsent),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeComebackLink),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationSource),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeIsARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedBundle),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Gql$Platform$Object$BackofficeRequotedOffer$continuitySummary($author$project$Common$Gql$CoverContinuity$coverContinuitySelectionSet),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeSelectedProducts),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Gql$Platform$Object$BackofficeRequotedOffer$availableActions($author$project$Common$Gql$Offer$decodeAvailableActions),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullClaimsDeclaredWithFault),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicle),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullVehicleOwner),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullAdditionalDriver),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullPolicyHolder),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Gql$Platform$Object$BackofficeRequotedOffer$customerData($author$project$Common$Gql$Offer$decodeFullMainDriver),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																	$elm$core$Maybe$map($author$project$Common$QuoteId$new),
																	$author$project$Gql$Platform$Object$BackofficeRequotedOffer$newQuoteId),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Offer$decodeRequotedOfferStatus, $author$project$Gql$Platform$Object$BackofficeRequotedOffer$requotedStatus),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																			$author$project$Common$Locale$posixToCustomerDate,
																			$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeStartDate)),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																				$author$project$Common$Locale$posixToCustomerDate,
																				$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCreationDate)),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeQuoteId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeApplicationId),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeCustomerFacingId),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$Gql$Platform$Object$BackofficeRequotedOffer$offerDetails($author$project$Common$Gql$Offer$decodeId),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Offer$new))))))))))))))))))))))));
var $author$project$Gql$Platform$Union$BackofficeOfferStateMachine$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeProvisionalOffer', selections____.ow),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeCompletedProvisionalOffer', selections____.ot),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeRequoteValidationFailedOffer', selections____.oA),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeBlockedOffer', selections____.or),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeRequotedOffer', selections____.oB),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeFinalizedOffer', selections____.ov),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficeRenewalOffer', selections____.oz),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BackofficePurchasedOffer', selections____.oy)
			]));
};
var $author$project$Common$Gql$Offer$offerSelectionSet = $author$project$Gql$Platform$Union$BackofficeOfferStateMachine$fragments(
	{or: $author$project$Common$Gql$Offer$backofficeBlockedOfferSelectionSet, ot: $author$project$Common$Gql$Offer$backofficeCompletedProvisionalOfferSelectionSet, ov: $author$project$Common$Gql$Offer$backofficeFinalizedOfferSelectionSet, ow: $author$project$Common$Gql$Offer$backofficeProvisionalOfferSelectionSet, oy: $author$project$Common$Gql$Offer$backofficePurchasedOfferSelectionSet, oz: $author$project$Common$Gql$Offer$backofficeRenewalOfferSelectionSet, oA: $author$project$Common$Gql$Offer$backofficeRequoteValidationFailedOfferSelectionSet, oB: $author$project$Common$Gql$Offer$backofficeRequotedOfferSelectionSet});
var $author$project$Gql$Platform$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).at,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$Gql$Platform$InputObject$encodeOfferIdentifier = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'customerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'offerId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.oi,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$ScalarCodecs$codecs)))
			]));
};
var $author$project$Gql$Platform$Query$offerV2 = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'offerV2',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'identifier', requiredArgs____.bT, $author$project$Gql$Platform$InputObject$encodeOfferIdentifier)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$New$Gql$Platform$InputObject$PricingActionInputRequiredFields = function (offerOrPolicyIdentifier) {
	return {H: offerOrPolicyIdentifier};
};
var $author$project$New$Gql$Platform$Query$PricingActionRequiredArguments = function (input) {
	return {nD: input};
};
var $author$project$New$Gql$Platform$InputObject$buildPricingActionInput = function (required____) {
	return {H: required____.H};
};
var $author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdRequiredArguments = function (offerId) {
	var buildPricingActionInput = function (arg) {
		return $author$project$New$Gql$Platform$Query$PricingActionRequiredArguments(
			$author$project$New$Gql$Platform$InputObject$buildPricingActionInput(
				$author$project$New$Gql$Platform$InputObject$PricingActionInputRequiredFields(arg)));
	};
	var buildOfferInput = function (id) {
		return function (offerIdentifier) {
			return A2($author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier, offerIdentifier, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent);
		}(
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				A2(
					$author$project$New$Gql$Platform$InputObject$OfferIdentifier,
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(id),
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent)));
	};
	return buildPricingActionInput(
		buildOfferInput(offerId));
};
var $author$project$New$Gql$Platform$InputObject$encodePricingActionInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerOrPolicyIdentifier',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeOfferOrPolicyIdentifier(input____.H)))
			]));
};
var $author$project$New$Gql$Platform$Query$pricingAction = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'pricingAction',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodePricingActionInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $author$project$New$Gql$Platform$Enum$PricingAction$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'NONE';
		case 1:
			return 'ASK_FOR_SEVERITY_CERTIFICATE_POST_SALE';
		default:
			return 'REQUEST_CORRECT_5_DIGITS';
	}
};
var $author$project$Common$Gql$ClaimHistory$decodePricingAction = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $elm_community$string_extra$String$Extra$toSentenceCase, $elm$core$String$toLower),
	$author$project$New$Gql$Platform$Enum$PricingAction$toString);
var $author$project$New$Gql$Platform$Enum$PricingAction$AskForSeverityCertificatePostSale = 1;
var $author$project$New$Gql$Platform$Enum$PricingAction$None = 0;
var $author$project$New$Gql$Platform$Enum$PricingAction$RequestCorrect5Digits = 2;
var $author$project$New$Gql$Platform$Enum$PricingAction$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NONE':
				return $elm$json$Json$Decode$succeed(0);
			case 'ASK_FOR_SEVERITY_CERTIFICATE_POST_SALE':
				return $elm$json$Json$Decode$succeed(1);
			case 'REQUEST_CORRECT_5_DIGITS':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid PricingAction type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PricingActionOutput$pricingAction = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PricingAction.PricingAction', 'pricingAction', _List_Nil, $author$project$New$Gql$Platform$Enum$PricingAction$decoder);
var $author$project$Common$Gql$ClaimHistory$pricingActionSelectionSet = A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$ClaimHistory$decodePricingAction, $author$project$New$Gql$Platform$Object$PricingActionOutput$pricingAction);
var $author$project$Common$Gql$ClaimHistory$pricingActionQuery = function (queryArguments) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$Just,
		A2($author$project$New$Gql$Platform$Query$pricingAction, queryArguments, $author$project$Common$Gql$ClaimHistory$pricingActionSelectionSet));
};
var $author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdQuery = function (offerId) {
	return $author$project$Common$Gql$ClaimHistory$pricingActionQuery(
		$author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdRequiredArguments(offerId));
};
var $author$project$Tracker$encodeNormalizedUserEvent = function (_v0) {
	var type_ = _v0.bq;
	var payload = _v0.lo;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(type_)),
				_Utils_Tuple2('payload', payload)
			]));
};
var $author$project$Tracker$encodeUserSearchPayload = function (_v0) {
	var searchType = _v0.lM;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'searchType',
				$elm$json$Json$Encode$string(searchType))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Tracker$encodeUserSendEmailPayload = function (_v0) {
	var emails = _v0.gz;
	var entity = _v0.gC;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'entity',
				$elm$json$Json$Encode$string(
					function () {
						if (!entity) {
							return 'offer';
						} else {
							return 'policy';
						}
					}())),
				_Utils_Tuple2(
				'emails',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, emails))
			]));
};
var $author$project$Tracker$NormalizedUserEvent = $elm$core$Basics$identity;
var $author$project$Tracker$normalizedUserEvent = F2(
	function (type_, payload) {
		return {lo: payload, bq: type_};
	});
var $author$project$Tracker$userSearchEventName = 'userSearch';
var $author$project$Tracker$normalizeUserEvent = function (userEvent) {
	if (!userEvent.$) {
		var data = userEvent.a;
		return A2(
			$author$project$Tracker$normalizedUserEvent,
			$author$project$Tracker$userSearchEventName,
			$author$project$Tracker$encodeUserSearchPayload(data));
	} else {
		var data = userEvent.a;
		return A2(
			$author$project$Tracker$normalizedUserEvent,
			'userSendEmail',
			$author$project$Tracker$encodeUserSendEmailPayload(data));
	}
};
var $author$project$Tracker$encodeUserEvent = A2($elm$core$Basics$composeR, $author$project$Tracker$normalizeUserEvent, $author$project$Tracker$encodeNormalizedUserEvent);
var $author$project$Tracker$trackUserEvent = _Platform_outgoingPort('trackUserEvent', $elm$core$Basics$identity);
var $author$project$Tracker$publishUserEvent = A2($elm$core$Basics$composeR, $author$project$Tracker$encodeUserEvent, $author$project$Tracker$trackUserEvent);
var $author$project$Gql$Platform$Mutation$saveCustomerGreatLakesOptIn = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'Bool',
		'saveCustomerGreatLakesOptIn',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'offerId',
				requiredArgs____.oi,
				A2(
					$author$project$Gql$Platform$Scalar$unwrapEncoder,
					function ($) {
						return $.u;
					},
					$author$project$ScalarCodecs$codecs))
			]),
		$elm$json$Json$Decode$bool);
};
var $author$project$New$Gql$Platform$Object$SendNewBusinessOfferEmailOutput$response = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'response', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$Success = {$: 0};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$MissingEmail = 5;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferBlocked = 3;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferExpired = 0;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferIsRenewal = 6;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferPurchased = 2;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferRequoted = 4;
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$OfferStartDateExpired = 1;
var $author$project$Common$Gql$SendOfferEmail$decodeReason = function (reason) {
	switch (reason) {
		case 3:
			return 3;
		case 5:
			return 5;
		case 0:
			return 0;
		case 2:
			return 2;
		case 4:
			return 4;
		case 1:
			return 1;
		default:
			return 6;
	}
};
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$MissingEmail = 5;
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferBlocked = 3;
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferExpired = 0;
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferIsRenewal = 6;
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferPurchased = 2;
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferRequoted = 4;
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$OfferStartDateExpired = 1;
var $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'OFFER_EXPIRED':
				return $elm$json$Json$Decode$succeed(0);
			case 'OFFER_START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'OFFER_PURCHASED':
				return $elm$json$Json$Decode$succeed(2);
			case 'OFFER_BLOCKED':
				return $elm$json$Json$Decode$succeed(3);
			case 'OFFER_REQUOTED':
				return $elm$json$Json$Decode$succeed(4);
			case 'MISSING_EMAIL':
				return $elm$json$Json$Decode$succeed(5);
			case 'OFFER_IS_RENEWAL':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('Invalid SendNewBusinessOfferEmailFailureReason type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$SendNewBusinessOfferEmailFailure$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SendNewBusinessOfferEmailFailureReason.SendNewBusinessOfferEmailFailureReason', 'reason', _List_Nil, $author$project$New$Gql$Platform$Enum$SendNewBusinessOfferEmailFailureReason$decoder);
var $author$project$Common$Gql$SendOfferEmail$decodeSendNewBusinessOfferEmailError = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$SendOfferEmail$decodeReason, $author$project$New$Gql$Platform$Object$SendNewBusinessOfferEmailFailure$reason),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ComponentUI$Modal$SendOfferEmail$Failure));
var $author$project$New$Gql$Platform$Union$SendNewBusinessOfferEmailResponse$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SendNewBusinessOfferEmailSuccess', selections____.oX),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SendNewBusinessOfferEmailFailure', selections____.oW)
			]));
};
var $author$project$Common$Gql$SendOfferEmail$sendNewBusinessEmailSelectionSet = $author$project$New$Gql$Platform$Union$SendNewBusinessOfferEmailResponse$fragments(
	{
		oW: $author$project$Common$Gql$SendOfferEmail$decodeSendNewBusinessOfferEmailError,
		oX: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ComponentUI$Modal$SendOfferEmail$Success)
	});
var $author$project$Common$Gql$SendOfferEmail$sendNewBusinessEmailOutputSelectionSet = $author$project$New$Gql$Platform$Object$SendNewBusinessOfferEmailOutput$response($author$project$Common$Gql$SendOfferEmail$sendNewBusinessEmailSelectionSet);
var $author$project$New$Gql$Platform$InputObject$encodeSendNewBusinessOfferEmailInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offerId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.oi)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$sendNewBusinessOfferEmail = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'sendNewBusinessOfferEmail',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeSendNewBusinessOfferEmailInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Gql$SendOfferEmail$sendNewBusinessEmail = function (offerId) {
	return A2(
		$author$project$New$Gql$Platform$Mutation$sendNewBusinessOfferEmail,
		{
			nD: {oi: offerId}
		},
		$author$project$Common$Gql$SendOfferEmail$sendNewBusinessEmailOutputSelectionSet);
};
var $author$project$Common$Gql$SendOfferEmail$sendOfferEmailMutation = function (option) {
	var offerId = option;
	return $author$project$Common$Gql$SendOfferEmail$sendNewBusinessEmail(offerId);
};
var $author$project$Common$QuoteId$toUuid = function (_v0) {
	var quoteId = _v0;
	return quoteId;
};
var $author$project$Tracker$UserSendEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tracker$userSendEmailEvent = $author$project$Tracker$UserSendEmail;
var $author$project$Tracker$Offer = 0;
var $author$project$Tracker$UserSendEmailPayload = $elm$core$Basics$identity;
var $author$project$Tracker$userSendEmailPayloadForOffer = function (emails) {
	return {gz: emails, gC: 0};
};
var $author$project$Page$OfferDetails$Effect$runEffect = F2(
	function (env, effect) {
		switch (effect.$) {
			case 14:
				return $elm$core$Platform$Cmd$none;
			case 0:
				var id = effect.a;
				return ($author$project$Env$isStaging(env) || $author$project$Env$isProduction(env)) ? A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'offerDetails',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$NewOffer$getOfferDetails(id),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedNewOffer)) : A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$Gql$Platform$Query$offerV2,
						$author$project$Common$Gql$Offer$offerByCfidRequiredArguments(id),
						$author$project$Common$Gql$Offer$offerSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedOffer));
			case 6:
				var cmd = effect.a;
				return cmd;
			case 1:
				var quoteId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'claimsHistory',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$New$Gql$Platform$Query$claimsHistory,
						$author$project$Common$Gql$ClaimHistory$claimHistoryByQuoteIdRequiredArguments(
							$author$project$Common$QuoteId$toUuid(quoteId)),
						$author$project$Common$Gql$ClaimHistory$claimsHistoryOutputSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedClaimHistory));
			case 4:
				var offerId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'pricingAction',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$ClaimHistory$pricingActionByOfferIdQuery(offerId),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedClaimHistoryPricingAction));
			case 2:
				var offerId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getCustomerId',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$CustomerId$getCustomerId(
						$author$project$Common$Gql$CustomerId$OfferId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedCustomerId));
			case 5:
				var offerId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'fetchCoverSelection',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$Common$Gql$CoverSelection$getCoverSelection,
						env,
						$author$project$Common$Gql$CoverSelection$OfferId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedCoverSelection));
			case 8:
				var id = effect.a;
				var coverageEffectiveDate = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'amendOfferCoverageEffectiveDate',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$amendOfferCoverageEffectiveDate,
						A2($author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateArguments, id, coverageEffectiveDate),
						$author$project$Common$Gql$Offer$amendOfferCoverageEffectiveDateSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$OfferCoverageEffectiveDateAmended));
			case 7:
				return $elm$core$Platform$Cmd$none;
			case 9:
				return A2(
					$elm$core$Task$perform,
					$author$project$Page$OfferDetails$Msg$GotCurrentDate,
					A2(
						$elm$core$Task$map,
						$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
						$elm$time$Time$now));
			case 13:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Page$OfferDetails$Effect$runEffect(env),
						effects));
			case 3:
				var offerId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getPreviousPaymentMethod',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$PaymentMethod$getPaymentMethod(
						$author$project$Common$Gql$PaymentMethod$OfferId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$FetchedPaymentMethod));
			case 10:
				var option = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'sendNewBusinessOfferEmail',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					$author$project$Common$Gql$SendOfferEmail$sendOfferEmailMutation(option),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$OfferDetails$Msg$EmailSent));
			case 11:
				var emailOptions = effect.a;
				return $author$project$Tracker$publishUserEvent(
					$author$project$Tracker$userSendEmailEvent(
						$author$project$Tracker$userSendEmailPayloadForOffer(emailOptions)));
			default:
				var offerId = effect.a;
				var modalOrigin = effect.b;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					$author$project$Gql$Platform$Mutation$saveCustomerGreatLakesOptIn(
						{oi: offerId}),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$OfferDetails$Msg$SaveGreatLakesOptInConsentResponse(modalOrigin)));
		}
	});
var $author$project$Page$Payment$Msg$GotBraintreeToken = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Payment$Msg$GotOfferProducts = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Payment$Msg$GotPolicy = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Payment$Ports$braintreeSetup = _Platform_outgoingPort('braintreeSetup', $elm$json$Json$Encode$string);
var $author$project$Utils$executeGraphqlOperation = F5(
	function (envData, urlExtractor, operation, selectionSet, tagger) {
		var effectRunner = function (env) {
			return $dillonkearns$elm_graphql$Graphql$Http$toTask(
				$dillonkearns$elm_graphql$Graphql$Http$withCredentials(
					A2(
						operation,
						urlExtractor(env),
						selectionSet)));
		};
		return A2(
			$elm$core$Task$attempt,
			tagger,
			effectRunner(envData));
	});
var $author$project$Gql$Platform$Object$ClientConfiguration$braintreeClientToken = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'braintreeClientToken', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Query$clientConfiguration = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'clientConfiguration', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Page$Payment$Gql$fetchBraintreeToken = $author$project$Gql$Platform$Query$clientConfiguration($author$project$Gql$Platform$Object$ClientConfiguration$braintreeClientToken);
var $author$project$Gql$Platform$Query$ProductsRequiredArguments = function (offerId) {
	return {oi: offerId};
};
var $author$project$Page$Payment$Gql$findProductsByOfferIdRequiredArguments = function (offerId) {
	return $author$project$Gql$Platform$Query$ProductsRequiredArguments(offerId);
};
var $author$project$Gql$Platform$Object$BackofficeProduct$annualPrice = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'annualPrice', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Gql$Platform$Enum$BundleSlug$TercerosAmpliado = 1;
var $author$project$Gql$Platform$Enum$BundleSlug$TercerosBasico = 0;
var $author$project$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia = 2;
var $author$project$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia300 = 3;
var $author$project$Gql$Platform$Enum$BundleSlug$TodoRiesgoConFranquicia500 = 4;
var $author$project$Gql$Platform$Enum$BundleSlug$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TERCEROS_BASICO':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERCEROS_AMPLIADO':
				return $elm$json$Json$Decode$succeed(1);
			case 'TODO_RIESGO_CON_FRANQUICIA':
				return $elm$json$Json$Decode$succeed(2);
			case 'TODO_RIESGO_CON_FRANQUICIA_300':
				return $elm$json$Json$Decode$succeed(3);
			case 'TODO_RIESGO_CON_FRANQUICIA_500':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid BundleSlug type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$BackofficeProduct$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$Common$Gql$BundleSlug$decodeBundleSlug = function (bundleSlug) {
	switch (bundleSlug) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Gql$Platform$Object$BackofficeProduct$issuingCompany = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'issuingCompany', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$gross = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'gross',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$net = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'net',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$taxIps = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxIps',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$taxSurcharges = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxSurcharges',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Gql$Platform$Object$OfferAnnualPrice$taxes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.GqlDecimal',
	'taxes',
	_List_Nil,
	$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).mP.B);
var $author$project$Common$Gql$OfferProduct$offerAnnualPriceSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$taxSurcharges),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$taxIps),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$net),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$taxes),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$Gql$Platform$Object$OfferAnnualPrice$gross),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$AnnualPrice))))));
var $author$project$Common$Gql$OfferProduct$offerProductSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Gql$Platform$Object$BackofficeProduct$annualPrice($author$project$Common$Gql$OfferProduct$offerAnnualPriceSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeBundleSlug, $author$project$Gql$Platform$Object$BackofficeProduct$bundleSlug),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Gql$Platform$Object$BackofficeProduct$issuingCompany,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$OfferProduct))));
var $author$project$Gql$Platform$Query$products = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'products',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'offerId',
					requiredArgs____.oi,
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$ScalarCodecs$codecs))
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Page$Payment$Gql$findProductsByOfferId = function (offerId) {
	return A2(
		$author$project$Gql$Platform$Query$products,
		$author$project$Page$Payment$Gql$findProductsByOfferIdRequiredArguments(offerId),
		$author$project$Common$Gql$OfferProduct$offerProductSelectionSet);
};
var $author$project$Page$Payment$Ports$payWithCreditCard = _Platform_outgoingPort(
	'payWithCreditCard',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Gql$Platform$InputObject$MotoPaymentInfo = function (token) {
	return {as: token};
};
var $author$project$Gql$Platform$Mutation$PurchaseOfferRequiredArguments = F2(
	function (offerId, paymentInfo) {
		return {oi: offerId, aO: paymentInfo};
	});
var $author$project$Gql$Platform$InputObject$encodeMotoPaymentInfo = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.as)))
			]));
};
var $author$project$Gql$Platform$Mutation$purchaseOffer = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'ScalarCodecs.Uuid',
		'purchaseOffer',
		_List_fromArray(
			[
				A3(
				$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
				'offerId',
				requiredArgs____.oi,
				A2(
					$author$project$Gql$Platform$Scalar$unwrapEncoder,
					function ($) {
						return $.u;
					},
					$author$project$ScalarCodecs$codecs)),
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'paymentInfo', requiredArgs____.aO, $author$project$Gql$Platform$InputObject$encodeMotoPaymentInfo)
			]),
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
};
var $author$project$Page$Payment$Gql$purchaseOffer = F2(
	function (nonce, offerId) {
		var paymentInfo = $author$project$Gql$Platform$InputObject$MotoPaymentInfo(nonce);
		return $author$project$Gql$Platform$Mutation$purchaseOffer(
			A2($author$project$Gql$Platform$Mutation$PurchaseOfferRequiredArguments, offerId, paymentInfo));
	});
var $author$project$Page$Payment$Effect$runEffect = F3(
	function (env, model, effect) {
		switch (effect.$) {
			case 3:
				var token = effect.a;
				return $author$project$Page$Payment$Ports$braintreeSetup(token);
			case 4:
				return A5(
					$author$project$Utils$executeGraphqlOperation,
					env,
					$author$project$Env$apiUrl,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Page$Payment$Gql$fetchBraintreeToken,
					A2($elm$core$Basics$composeL, $author$project$Page$Payment$Msg$GotBraintreeToken, $krisajenkins$remotedata$RemoteData$fromResult));
			case 6:
				var offerId = effect.a;
				return A5(
					$author$project$Utils$executeGraphqlOperation,
					env,
					$author$project$Env$apiUrl,
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Page$Payment$Gql$findProductsByOfferId(offerId),
					A2($elm$core$Basics$composeL, $author$project$Page$Payment$Msg$GotOfferProducts, $krisajenkins$remotedata$RemoteData$fromResult));
			case 5:
				return $author$project$Page$Payment$Ports$payWithCreditCard(0);
			case 7:
				var nonce = effect.a;
				return A5(
					$author$project$Utils$executeGraphqlOperation,
					env,
					$author$project$Env$apiUrl,
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2($author$project$Page$Payment$Gql$purchaseOffer, nonce, model.oi),
					A2($elm$core$Basics$composeL, $author$project$Page$Payment$Msg$GotPolicy, $krisajenkins$remotedata$RemoteData$fromResult));
			case 0:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2($author$project$Page$Payment$Effect$runEffect, env, model),
						effects));
			case 8:
				return $elm$core$Platform$Cmd$none;
			case 1:
				return $elm$core$Platform$Cmd$none;
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived = F2(
	function (a, b) {
		return {$: 59, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Msg$CreateRefundResponseReceived = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedClaimHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedClaimHistoryPricingAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedCoverSelection = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedCustomerId = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedPaymentMethod = function (a) {
	return {$: 39, a: a};
};
var $author$project$Page$PolicyDetails$Msg$FetchedPolicy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotAmendExpectedRefund = function (a) {
	return {$: 58, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotChangeEmailResponse = function (a) {
	return {$: 49, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotCurrentTime = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotExpectedRefund = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$PolicyDetails$Msg$GotRefund = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundResponseReceived = function (a) {
	return {$: 28, a: a};
};
var $author$project$Common$Gql$CoverSelection$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Gql$CustomerId$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Gql$PaymentMethod$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$Msg$PolledForRefundCompletion = F2(
	function (a, b) {
		return {$: 63, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Msg$PolledForRefundUpdate = F3(
	function (a, b, c) {
		return {$: 61, a: a, b: b, c: c};
	});
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationResponseReceived = function (a) {
	return {$: 36, a: a};
};
var $author$project$Page$PolicyDetails$Msg$SendPolicyContractEmailResponseReceived = function (a) {
	return {$: 41, a: a};
};
var $author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundCompletion = function (a) {
	return {$: 64, a: a};
};
var $author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundUpdate = F2(
	function (a, b) {
		return {$: 62, a: a, b: b};
	});
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$Chargeback = 2;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$Fraud = 1;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$InexactDeclarationDni = 3;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$InexactDeclarationSinco = 0;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$PhotoVerificationNotProvided = 5;
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$RiskAggravation = 4;
var $author$project$Common$AmendReason$companyReasonToGql = function (companyReason) {
	switch (companyReason) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		default:
			return 5;
	}
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $author$project$Page$PolicyDetails$Gql$amendCompanyInterruption = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var interruptionAt = _v0.a6;
	var reason = _v0.iA;
	var description = _v0.m1;
	return {
		nD: {
			m1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			a6: interruptionAt,
			o6: id,
			iA: {
				X: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				ab: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Common$AmendReason$companyReasonToGql(reason))
			},
			i: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$CompetitorOffer = 0;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$CoverageChange = 12;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$DeceasedPolicyHolder = 11;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$DissatisfactionService = 13;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$DoesNotKnow = 5;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$IncorrectDataOther = 9;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$IncorrectEffectiveDate = 7;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$IncorrectPersonalData = 8;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$MovingToAnotherCountry = 15;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$NoInsuranceWanted = 4;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$Other = 19;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$PaymentMethodOrDate = 10;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$PolicyHolderChange = 17;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$ProductService = 16;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$SwitchToGreatLakes = 18;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$UnderwritingRules = 14;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$VehicleDeregistration = 3;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$VehicleNotPurchased = 2;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$VehicleSold = 1;
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$WantsGreenCard = 6;
var $author$project$Common$AmendReason$customerReasonToGql = function (customerReason) {
	switch (customerReason) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		default:
			return 19;
	}
};
var $author$project$Page$PolicyDetails$Gql$amendCustomerInterruption = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var interruptionAt = _v0.a6;
	var reason = _v0.iA;
	var description = _v0.m1;
	return {
		nD: {
			m1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			a6: interruptionAt,
			o6: id,
			iA: {
				X: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Common$AmendReason$customerReasonToGql(reason)),
				ab: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			},
			i: requestedAt
		}
	};
};
var $author$project$Page$PolicyDetails$Gql$amendDateCompanyInterruption = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var interruptionAt = _v0.a6;
	return {
		bz: {
			X: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			ab: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				{kv: id, a6: interruptionAt, i: requestedAt})
		}
	};
};
var $author$project$Page$PolicyDetails$Gql$amendDateCustomerInterruption = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var interruptionAt = _v0.a6;
	return {
		bz: {
			X: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				{kv: id, a6: interruptionAt, i: requestedAt}),
			ab: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
		}
	};
};
var $author$project$Gql$Platform$InputObject$encodeCustomerAmendTerminationDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$ScalarCodecs$codecs)(input____.kv))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$ScalarCodecs$codecs)(input____.i))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$ScalarCodecs$codecs)(input____.a6)))
			]));
};
var $author$project$Gql$Platform$InputObject$encodePrimaAmendTerminationDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$ScalarCodecs$codecs)(input____.kv))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$ScalarCodecs$codecs)(input____.i))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$ScalarCodecs$codecs)(input____.a6)))
			]));
};
var $author$project$Gql$Platform$InputObject$encodeAmendTerminationDateInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'customer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.X, $author$project$Gql$Platform$InputObject$encodeCustomerAmendTerminationDateInput)),
				_Utils_Tuple2(
				'prima',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Gql$Platform$InputObject$encodePrimaAmendTerminationDateInput))
			]));
};
var $author$project$Gql$Platform$Mutation$amendTerminationDate = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'ScalarCodecs.Uuid',
		'amendTerminationDate',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'amendment', requiredArgs____.bz, $author$project$Gql$Platform$InputObject$encodeAmendTerminationDateInput)
			]),
		$author$project$Gql$Platform$Scalar$unwrapCodecs($author$project$ScalarCodecs$codecs).u.B);
};
var $author$project$Common$AmendReason$isCustomerReason = function (reason) {
	if (!reason.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Page$PolicyDetails$Effect$amendDateInterruptionArgs = F2(
	function (reason, args) {
		return $author$project$Common$AmendReason$isCustomerReason(reason) ? $author$project$Gql$Platform$Mutation$amendTerminationDate(
			$author$project$Page$PolicyDetails$Gql$amendDateCustomerInterruption(args)) : $author$project$Gql$Platform$Mutation$amendTerminationDate(
			$author$project$Page$PolicyDetails$Gql$amendDateCompanyInterruption(args));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(
	function (enumToString, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(
			enumToString(value));
	});
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'COMPETITOR_OFFER';
		case 1:
			return 'VEHICLE_SOLD';
		case 2:
			return 'VEHICLE_NOT_PURCHASED';
		case 3:
			return 'VEHICLE_DEREGISTRATION';
		case 4:
			return 'NO_INSURANCE_WANTED';
		case 5:
			return 'DOES_NOT_KNOW';
		case 6:
			return 'WANTS_GREEN_CARD';
		case 7:
			return 'INCORRECT_EFFECTIVE_DATE';
		case 8:
			return 'INCORRECT_PERSONAL_DATA';
		case 9:
			return 'INCORRECT_DATA_OTHER';
		case 10:
			return 'PAYMENT_METHOD_OR_DATE';
		case 11:
			return 'DECEASED_POLICY_HOLDER';
		case 12:
			return 'COVERAGE_CHANGE';
		case 13:
			return 'DISSATISFACTION_SERVICE';
		case 14:
			return 'UNDERWRITING_RULES';
		case 15:
			return 'MOVING_TO_ANOTHER_COUNTRY';
		case 16:
			return 'PRODUCT_SERVICE';
		case 17:
			return 'POLICY_HOLDER_CHANGE';
		case 18:
			return 'SWITCH_TO_GREAT_LAKES';
		default:
			return 'OTHER';
	}
};
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'INEXACT_DECLARATION_SINCO';
		case 1:
			return 'FRAUD';
		case 2:
			return 'CHARGEBACK';
		case 3:
			return 'INEXACT_DECLARATION_DNI';
		case 4:
			return 'RISK_AGGRAVATION';
		default:
			return 'PHOTO_VERIFICATION_NOT_PROVIDED';
	}
};
var $author$project$New$Gql$Platform$InputObject$encodeTerminateReason = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'customer',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.X,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString))),
				_Utils_Tuple2(
				'prima',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ab,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeAmendTerminationInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.o6))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.i))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a6))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodeTerminateReason(input____.iA))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$amendTermination = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'amendTermination',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeAmendTerminationInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$AmendTerminationOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$amendTerminationSelectionSet = $author$project$New$Gql$Platform$Object$AmendTerminationOutput$policyId;
var $author$project$Common$Policy$pickId = function (_v0) {
	var policy = _v0;
	return policy.kv;
};
var $author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData = F2(
	function (policyId, interruptionAt) {
		return {a6: interruptionAt, o6: policyId};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$TerminationByCustomer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$terminationByCustomer = F3(
	function (policyId, interruptionDate, reason) {
		return A2(
			$author$project$Common$Gql$PolicyCheckEligibility$TerminationByCustomer,
			A2($author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData, policyId, interruptionDate),
			reason);
	});
var $author$project$Common$Gql$PolicyCheckEligibility$TerminationByPrima = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$terminationByPrima = F3(
	function (policyId, interruptionDate, reason) {
		return A2(
			$author$project$Common$Gql$PolicyCheckEligibility$TerminationByPrima,
			A2($author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData, policyId, interruptionDate),
			reason);
	});
var $author$project$Common$Gql$PolicyCheckEligibility$Withdrawal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Gql$PolicyCheckEligibility$withdrawal = F2(
	function (policyId, interruptionDate) {
		return $author$project$Common$Gql$PolicyCheckEligibility$Withdrawal(
			A2($author$project$Common$Gql$PolicyCheckEligibility$CheckEligibilityCommonData, policyId, interruptionDate));
	});
var $author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgumentFromModel = F2(
	function (policy, kindData) {
		switch (kindData.$) {
			case 0:
				var data = kindData.a;
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Common$Gql$PolicyCheckEligibility$withdrawal,
						$author$project$Common$Policy$pickId(policy),
						data.pm));
			case 1:
				var data = kindData.a;
				return A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Common$Gql$PolicyCheckEligibility$terminationByCustomer,
						$author$project$Common$Policy$pickId(policy),
						data.a6),
					data.kQ);
			default:
				var data = kindData.a;
				return A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Common$Gql$PolicyCheckEligibility$terminationByPrima,
						$author$project$Common$Policy$pickId(policy),
						data.a6),
					data.kQ);
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickKindData = function (_v0) {
	var model = _v0;
	return model.av;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickPolicy = function (_v0) {
	var model = _v0;
	return model.l;
};
var $author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgument = function (_v0) {
	var interruptionModal = _v0.q;
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A3(
			$elm$core$Maybe$map2,
			$author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgumentFromModel,
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickPolicy(interruptionModal),
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickKindData(interruptionModal)));
};
var $author$project$New$Gql$Platform$InputObject$encodeCreateRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.o6)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$createRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'createRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeCreateRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$createRefund = function (policyId) {
	return {
		nD: {o6: policyId}
	};
};
var $author$project$New$Gql$Platform$Object$CreateRefundOutput$refundId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'refundId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$createRefundSelectionSet = $author$project$New$Gql$Platform$Object$CreateRefundOutput$refundId;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'COMPETITOR_OFFER';
		case 1:
			return 'VEHICLE_SOLD';
		case 2:
			return 'VEHICLE_NOT_PURCHASED';
		case 3:
			return 'VEHICLE_DEREGISTRATION';
		case 4:
			return 'NO_INSURANCE_WANTED';
		case 5:
			return 'DOES_NOT_KNOW';
		case 6:
			return 'WANTS_GREEN_CARD';
		case 7:
			return 'INCORRECT_EFFECTIVE_DATE';
		case 8:
			return 'INCORRECT_PERSONAL_DATA';
		case 9:
			return 'INCORRECT_DATA_OTHER';
		case 10:
			return 'PAYMENT_METHOD_OR_DATE';
		case 11:
			return 'DECEASED_POLICY_HOLDER';
		case 12:
			return 'COVERAGE_CHANGE';
		case 13:
			return 'DISSATISFACTION_SERVICE';
		case 14:
			return 'UNDERWRITING_RULES';
		case 15:
			return 'MOVING_TO_ANOTHER_COUNTRY';
		case 16:
			return 'PRODUCT_SERVICE';
		case 17:
			return 'POLICY_HOLDER_CHANGE';
		case 18:
			return 'PRICE_INCREASE';
		default:
			return 'OTHER';
	}
};
var $author$project$New$Gql$Platform$InputObject$encodeCustomerDeclineRenewalInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kv))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.i))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString, input____.iA))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$customerDeclineRenewal = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'customerDeclineRenewal',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeCustomerDeclineRenewalInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$InputObject$encodeCustomerTerminatePolicyInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kv))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.i))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a6))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString, input____.iA))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$customerTerminatePolicy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'customerTerminatePolicy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeCustomerTerminatePolicyInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$customerTerminatePolicy = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var interruptionAt = _v0.a6;
	var reason = _v0.iA;
	var description = _v0.m1;
	return {
		nD: {
			m1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			kv: id,
			a6: interruptionAt,
			iA: reason,
			i: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$CustomerTerminatePolicyOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$customerTerminatePolicySelectionSet = $author$project$New$Gql$Platform$Object$CustomerTerminatePolicyOutput$policyId;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'COMPETITOR_OFFER';
		case 1:
			return 'VEHICLE_SOLD';
		case 2:
			return 'VEHICLE_NOT_PURCHASED';
		case 3:
			return 'VEHICLE_DEREGISTRATION';
		case 4:
			return 'NO_INSURANCE_WANTED';
		case 5:
			return 'DOES_NOT_KNOW';
		case 6:
			return 'WANTS_GREEN_CARD';
		case 7:
			return 'INCORRECT_EFFECTIVE_DATE';
		case 8:
			return 'INCORRECT_DATA_OTHER';
		case 9:
			return 'INCORRECT_PERSONAL_DATA';
		case 10:
			return 'PAYMENT_METHOD_OR_DATE';
		case 11:
			return 'DECEASED_POLICY_HOLDER';
		case 12:
			return 'COVERAGE_CHANGE';
		case 13:
			return 'DISSATISFACTION_SERVICE';
		case 14:
			return 'UNDERWRITING_RULES';
		case 15:
			return 'MOVING_TO_ANOTHER_COUNTRY';
		default:
			return 'OTHER';
	}
};
var $author$project$New$Gql$Platform$InputObject$encodeCustomerWithdrawPolicyInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kv))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.i))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$toString, input____.iA))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$customerWithdrawPolicy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'customerWithdrawPolicy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeCustomerWithdrawPolicyInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$declineRenewal = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var reason = _v0.iA;
	var additionalNotes = _v0.mt;
	return {
		nD: {
			m1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(additionalNotes),
			kv: id,
			iA: reason,
			i: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$CustomerDeclineRenewalOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$declineRenewalSelectionSet = $author$project$New$Gql$Platform$Object$CustomerDeclineRenewalOutput$policyId;
var $author$project$New$Gql$Platform$InputObject$encodePotentialCustomerTermination = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a6))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString, input____.iA)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePotentialPrimaTermination = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a6))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString, input____.iA)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePotentialWithdrawal = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a6)))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodePotentialInterruptionDetails = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'withdrawal',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.jm, $author$project$New$Gql$Platform$InputObject$encodePotentialWithdrawal)),
				_Utils_Tuple2(
				'customerTermination',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gn, $author$project$New$Gql$Platform$InputObject$encodePotentialCustomerTermination)),
				_Utils_Tuple2(
				'primaTermination',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.iw, $author$project$New$Gql$Platform$InputObject$encodePotentialPrimaTermination))
			]));
};
var $author$project$New$Gql$Platform$InputObject$encodeCheckElegibilityInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.o6))),
				_Utils_Tuple2(
				'interruptionDetails',
				$elm$core$Maybe$Just(
					$author$project$New$Gql$Platform$InputObject$encodePotentialInterruptionDetails(input____.nF)))
			]));
};
var $author$project$New$Gql$Platform$Query$checkEligibility = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'checkEligibility',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeCheckElegibilityInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Query$CheckEligibilityRequiredArguments = function (input) {
	return {nD: input};
};
var $author$project$Common$Gql$PolicyCheckEligibility$customerTerminateInputRequiredFields = F2(
	function (interruptionAt, reason) {
		return {a6: interruptionAt, iA: reason};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$customerWithdrawInputRequiredFields = function (interruptionAt) {
	return {a6: interruptionAt};
};
var $author$project$Common$Gql$PolicyCheckEligibility$primaTerminateInputRequiredFields = F2(
	function (interruptionAt, reason) {
		return {a6: interruptionAt, iA: reason};
	});
var $author$project$Common$Gql$PolicyCheckEligibility$backofficeInterruptionDetails = function (claimEligibilityArg) {
	switch (claimEligibilityArg.$) {
		case 0:
			var commonData = claimEligibilityArg.a;
			return {
				gn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				iw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				jm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Common$Gql$PolicyCheckEligibility$customerWithdrawInputRequiredFields(commonData.a6))
			};
		case 1:
			var commonData = claimEligibilityArg.a;
			var reason = claimEligibilityArg.b;
			return {
				gn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($author$project$Common$Gql$PolicyCheckEligibility$customerTerminateInputRequiredFields, commonData.a6, reason)),
				iw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				jm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			};
		default:
			var commonData = claimEligibilityArg.a;
			var reason = claimEligibilityArg.b;
			return {
				gn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
				iw: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					A2($author$project$Common$Gql$PolicyCheckEligibility$primaTerminateInputRequiredFields, commonData.a6, reason)),
				jm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
			};
	}
};
var $author$project$Common$Gql$PolicyCheckEligibility$pickPolicyId = function (argument) {
	switch (argument.$) {
		case 0:
			var policyId = argument.a.o6;
			return policyId;
		case 1:
			var policyId = argument.a.o6;
			return policyId;
		default:
			var policyId = argument.a.o6;
			return policyId;
	}
};
var $author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityRequiredArguments = function (claimEligibilityArg) {
	return $author$project$New$Gql$Platform$Query$CheckEligibilityRequiredArguments(
		{
			nF: $author$project$Common$Gql$PolicyCheckEligibility$backofficeInterruptionDetails(claimEligibilityArg),
			o6: $author$project$Common$Gql$PolicyCheckEligibility$pickPolicyId(claimEligibilityArg)
		});
};
var $author$project$New$Gql$Platform$Object$CheckEligibilityOutput$eligibility = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'eligibility', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$ExpectedRefund$ExpectedRefund = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$ExpectedRefund$refund = function (price) {
	return $author$project$Common$ExpectedRefund$ExpectedRefund(price);
};
var $author$project$New$Gql$Platform$Object$Eligible$refund = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.GqlDecimal',
	'refund',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mP.B);
var $author$project$Common$Gql$PolicyCheckEligibility$decodeEligible = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$Eligible$refund),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ExpectedRefund$refund));
var $author$project$Common$ExpectedRefund$NoExpectedRefund = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$ExpectedRefund$noRefund = function (price) {
	return $author$project$Common$ExpectedRefund$NoExpectedRefund(price);
};
var $author$project$New$Gql$Platform$Object$Ineligible$refund = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.GqlDecimal',
	'refund',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mP.B);
var $author$project$Common$Gql$PolicyCheckEligibility$decodeIneligible = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$Ineligible$refund),
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$ExpectedRefund$noRefund));
var $author$project$New$Gql$Platform$Union$Eligibility$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Eligible', selections____.oM),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Ineligible', selections____.oO)
			]));
};
var $author$project$Common$Gql$PolicyCheckEligibility$eligibilitySelectionSet = $author$project$New$Gql$Platform$Union$Eligibility$fragments(
	{oM: $author$project$Common$Gql$PolicyCheckEligibility$decodeEligible, oO: $author$project$Common$Gql$PolicyCheckEligibility$decodeIneligible});
var $author$project$Common$Gql$PolicyCheckEligibility$checkEligibilitySelectionSet = $author$project$New$Gql$Platform$Object$CheckEligibilityOutput$eligibility($author$project$Common$Gql$PolicyCheckEligibility$eligibilitySelectionSet);
var $author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityQuery = function (claimEligibilityArg) {
	return A2(
		$author$project$New$Gql$Platform$Query$checkEligibility,
		$author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityRequiredArguments(claimEligibilityArg),
		$author$project$Common$Gql$PolicyCheckEligibility$checkEligibilitySelectionSet);
};
var $author$project$Page$PolicyDetails$Effect$executeCheckEligibilityQuery = F3(
	function (env, returnMsg, checkEligibilityArgument) {
		return A5(
			$author$project$Api$executeNewGraphqlOperation,
			env,
			'checkEligibility',
			$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
			$author$project$Common$Gql$PolicyCheckEligibility$checkEligibilityQuery(checkEligibilityArgument),
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, returnMsg));
	});
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Common$AmendReason$toCustomerReason = function (reason) {
	if (reason.$ === 1) {
		var customerReason = reason.a;
		return $elm$core$Maybe$Just(customerReason);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$AmendReason$toPrimaReason = function (reason) {
	if (!reason.$) {
		var primaReason = reason.a;
		return $elm$core$Maybe$Just(primaReason);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$Effect$getExpectedRefundForAmendInterruption = F3(
	function (amendReason, policyId, interruptionAt) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Common$AmendReason$companyReasonToGql,
					A2($author$project$Common$Gql$PolicyCheckEligibility$terminationByPrima, policyId, interruptionAt)),
				$author$project$Common$AmendReason$toPrimaReason(amendReason)),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Common$AmendReason$customerReasonToGql,
					A2($author$project$Common$Gql$PolicyCheckEligibility$terminationByCustomer, policyId, interruptionAt)),
				$author$project$Common$AmendReason$toCustomerReason(amendReason)));
	});
var $author$project$New$Gql$Platform$Query$GetRefundRequiredArguments = function (input) {
	return {nD: input};
};
var $author$project$New$Gql$Platform$InputObject$encodeGetRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.o6)))
			]));
};
var $author$project$New$Gql$Platform$Query$getRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'getRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeGetRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Common$Refund$Completed = 2;
var $author$project$Common$Refund$Failed = 3;
var $author$project$Common$Refund$NotRequired = 4;
var $author$project$Common$Refund$Pending = 0;
var $author$project$Common$Refund$ToBePaid = 1;
var $author$project$Common$Gql$GetRefund$decodeStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$New$Gql$Platform$Object$GetRefundOutput$eligibility = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'eligibility', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$GetRefundOutput$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Common$Refund$Refund = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Common$Refund$new = F3(
	function (id, expectedRefund, status) {
		return A2(
			$author$project$Common$Refund$Refund,
			{nc: expectedRefund, kv: id},
			status);
	});
var $author$project$New$Gql$Platform$Enum$RefundStatus$Completed = 2;
var $author$project$New$Gql$Platform$Enum$RefundStatus$Failed = 3;
var $author$project$New$Gql$Platform$Enum$RefundStatus$NotRequired = 4;
var $author$project$New$Gql$Platform$Enum$RefundStatus$Pending = 0;
var $author$project$New$Gql$Platform$Enum$RefundStatus$ToBePaid = 1;
var $author$project$New$Gql$Platform$Enum$RefundStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'PENDING':
				return $elm$json$Json$Decode$succeed(0);
			case 'TO_BE_PAID':
				return $elm$json$Json$Decode$succeed(1);
			case 'COMPLETED':
				return $elm$json$Json$Decode$succeed(2);
			case 'FAILED':
				return $elm$json$Json$Decode$succeed(3);
			case 'NOT_REQUIRED':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid RefundStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$GetRefundOutput$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.RefundStatus.RefundStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$RefundStatus$decoder);
var $author$project$Common$Gql$GetRefund$getRefundSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$GetRefund$decodeStatus, $author$project$New$Gql$Platform$Object$GetRefundOutput$status),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$GetRefundOutput$eligibility($author$project$Common$Gql$PolicyCheckEligibility$eligibilitySelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$GetRefundOutput$id,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Refund$new))));
var $author$project$Common$Gql$GetRefund$getRefundQuery = function (policyId) {
	return A2(
		$author$project$New$Gql$Platform$Query$getRefund,
		$author$project$New$Gql$Platform$Query$GetRefundRequiredArguments(
			{o6: policyId}),
		$author$project$Common$Gql$GetRefund$getRefundSelectionSet);
};
var $author$project$New$Gql$Platform$Enum$IssueReason$toString = function (enum____) {
	return 'OTHER';
};
var $author$project$New$Gql$Platform$InputObject$encodeIssueRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'refundId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.ao))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$IssueReason$toString, input____.iA)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$issueRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'issueRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeIssueRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Enum$IssueReason$Other = 0;
var $author$project$Page$PolicyDetails$Gql$issueRefund = function (refundId) {
	return {
		nD: {iA: 0, ao: refundId}
	};
};
var $author$project$New$Gql$Platform$Object$IssueRefundOutput$refundId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'refundId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$issueRefundSelectionSet = $author$project$New$Gql$Platform$Object$IssueRefundOutput$refundId;
var $author$project$New$Gql$Platform$InputObject$encodePayRefundInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'refundId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.ao)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$payRefund = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'payRefund',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodePayRefundInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$payRefund = function (refundId) {
	return {
		nD: {ao: refundId}
	};
};
var $author$project$New$Gql$Platform$Object$PayRefundOutput$refundId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'refundId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$payRefundSelectionSet = $author$project$New$Gql$Platform$Object$PayRefundOutput$refundId;
var $author$project$Common$Refund$pickId = function (_v0) {
	var refundData = _v0.a;
	return refundData.kv;
};
var $author$project$Common$Gql$Policy$policyByIdRequiredArguments = function (id) {
	return {
		nD: {o6: id}
	};
};
var $author$project$New$Gql$Platform$InputObject$encodePolicyDetailsInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.o6)))
			]));
};
var $author$project$New$Gql$Platform$Query$policyDetails = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'policyDetails',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodePolicyDetailsInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$Policy$additionalDriver = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'additionalDriver',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$AdditionalDriver$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$AdditionalDriver$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$AdditionalDriver$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$AdditionalDriver$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$additionalDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$AdditionalDriver$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AdditionalDriver$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AdditionalDriver$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$AdditionalDriver$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$additionalDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Policy$additionalDriverPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$AdditionalDriver)));
var $author$project$New$Gql$Platform$Object$Policy$applicationId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'applicationId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$availableActions = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'availableActions',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$claimsDeclaredWithFault = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'claimsDeclaredWithFault',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$coverContinuityInfo = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'coverContinuityInfo', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Policy$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$AmendTerminationType$Customer = 1;
var $author$project$Common$Policy$AmendTermination = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Policy$actionAmendTermination = F4(
	function (policyId, earliestSelectableDate, latestSelectableDate, kind) {
		return $author$project$Common$Policy$AmendTermination(
			{a2: earliestSelectableDate, c7: kind, a9: latestSelectableDate, o6: policyId});
	});
var $author$project$New$Gql$Platform$Object$AmendCustomerTermination$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$AmendCustomerTermination$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$AmendCustomerTermination$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Policy$decodeAmendCustomerTerminationAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	1,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AmendCustomerTermination$latestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AmendCustomerTermination$earliestSelectableDate,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$AmendCustomerTermination$policyId,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionAmendTermination)))));
var $author$project$New$Gql$Platform$Object$AmendPrimaTermination$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$AmendPrimaTermination$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$AmendPrimaTermination$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Policy$decodeAmendPrimaTerminationAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	1,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$AmendPrimaTermination$latestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$AmendPrimaTermination$earliestSelectableDate,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$AmendPrimaTermination$policyId,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionAmendTermination)))));
var $author$project$Common$Policy$CancelRenewal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Common$Policy$actionCancelRenewal = function (policyId) {
	return $author$project$Common$Policy$CancelRenewal(
		{o6: policyId});
};
var $author$project$New$Gql$Platform$Object$CancelRenewal$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Policy$decodeCancelRenewalAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$CancelRenewal$policyId,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionCancelRenewal));
var $author$project$Common$Policy$CustomerTerminate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$Policy$actionCustomerTerminate = F3(
	function (policyId, earliestSelectableDate, latestSelectableDate) {
		return $author$project$Common$Policy$CustomerTerminate(
			{a2: earliestSelectableDate, a9: latestSelectableDate, o6: policyId});
	});
var $author$project$New$Gql$Platform$Object$CustomerTerminate$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$CustomerTerminate$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$CustomerTerminate$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Policy$decodeCustomerTerminateAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$CustomerTerminate$latestSelectableDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$CustomerTerminate$earliestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$CustomerTerminate$policyId,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionCustomerTerminate))));
var $author$project$Common$Policy$PrimaTerminate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Common$Policy$actionPrimaTerminate = F3(
	function (policyId, earliestSelectableDate, latestSelectableDate) {
		return $author$project$Common$Policy$PrimaTerminate(
			{a2: earliestSelectableDate, a9: latestSelectableDate, o6: policyId});
	});
var $author$project$New$Gql$Platform$Object$PrimaTerminate$earliestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'earliestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$PrimaTerminate$latestSelectableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestSelectableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$PrimaTerminate$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Policy$decodePrimaTerminateAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PrimaTerminate$latestSelectableDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PrimaTerminate$earliestSelectableDate,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PrimaTerminate$policyId,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionPrimaTerminate))));
var $author$project$Common$Policy$Withdraw = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Policy$actionWithdraw = F2(
	function (policyId, latestRequestableDate) {
		return $author$project$Common$Policy$Withdraw(
			{kL: latestRequestableDate, o6: policyId});
	});
var $author$project$New$Gql$Platform$Object$Withdraw$latestRequestableDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'latestRequestableDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$Withdraw$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Common$Gql$Policy$decodeWithdrawAction = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$Withdraw$latestRequestableDate,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$Withdraw$policyId,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$actionWithdraw)));
var $author$project$New$Gql$Platform$Union$AvailablePolicyDetailsPageActions$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CustomerTerminate', selections____.oL),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PrimaTerminate', selections____.oV),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Withdraw', selections____.o0),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CancelRenewal', selections____.oE),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AmendCustomerTermination', selections____.ok),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AmendPrimaTermination', selections____.om)
			]));
};
var $author$project$Common$Gql$Policy$decodeAvailableActions = $author$project$New$Gql$Platform$Union$AvailablePolicyDetailsPageActions$fragments(
	{ok: $author$project$Common$Gql$Policy$decodeAmendCustomerTerminationAction, om: $author$project$Common$Gql$Policy$decodeAmendPrimaTerminationAction, oE: $author$project$Common$Gql$Policy$decodeCancelRenewalAction, oL: $author$project$Common$Gql$Policy$decodeCustomerTerminateAction, oV: $author$project$Common$Gql$Policy$decodePrimaTerminateAction, o0: $author$project$Common$Gql$Policy$decodeWithdrawAction});
var $author$project$Common$Gql$Source$decodeFromQuoteSource = function (source) {
	switch (source) {
		case 2:
			return 0;
		case 3:
			return 1;
		case 1:
			return 3;
		default:
			return 2;
	}
};
var $author$project$Common$PolicyStatus$Active = 1;
var $author$project$Common$PolicyStatus$Expired = 3;
var $author$project$Common$PolicyStatus$GracePeriod = 2;
var $author$project$Common$PolicyStatus$Issued = 0;
var $author$project$Common$PolicyStatus$NotRenewed = 5;
var $author$project$Common$PolicyStatus$Renewed = 4;
var $author$project$Common$PolicyStatus$TerminatedByCustomer = 7;
var $author$project$Common$PolicyStatus$TerminatedByPrima = 8;
var $author$project$Common$PolicyStatus$Withdrawn = 6;
var $author$project$Common$Gql$Policy$decodePolicyStatus = function (status) {
	switch (status) {
		case 1:
			return 1;
		case 3:
			return 3;
		case 0:
			return 0;
		case 7:
			return 7;
		case 8:
			return 8;
		case 6:
			return 6;
		case 2:
			return 2;
		case 5:
			return 4;
		default:
			return 5;
	}
};
var $author$project$Common$Person$emptyAdditionalDriverFixture = A2(
	$author$project$Common$Person$AdditionalDriver,
	{aD: $author$project$Common$Locale$defaultDate, aF: '', aG: '', aM: ''},
	$elm$core$Maybe$Nothing);
var $author$project$New$Gql$Platform$Object$Policy$endDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'endDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$Policy$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$Policy$interruption = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'interruption',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Policy$Interruption = F4(
	function (at, kind, reason, description) {
		return {mB: at, m1: description, c7: kind, iA: reason};
	});
var $author$project$New$Gql$Platform$Object$Interruption$at = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.DateTime',
	'at',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).O.B);
var $author$project$Common$InterruptionKind$TerminationByCustomer = 1;
var $author$project$Common$InterruptionKind$TerminationByPrima = 2;
var $author$project$Common$InterruptionKind$Withdrawal = 0;
var $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionKind = function (kind) {
	switch (kind) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Common$InterruptionReason$Chargeback = 0;
var $author$project$Common$InterruptionReason$CompetitorOffer = 1;
var $author$project$Common$InterruptionReason$CoverageChange = 2;
var $author$project$Common$InterruptionReason$DeceasedPolicyHolder = 3;
var $author$project$Common$InterruptionReason$DissatisfactionDocsRequest = 4;
var $author$project$Common$InterruptionReason$DissatisfactionService = 5;
var $author$project$Common$InterruptionReason$DoesNotKnow = 6;
var $author$project$Common$InterruptionReason$Fraud = 7;
var $author$project$Common$InterruptionReason$IncorrectDataOther = 8;
var $author$project$Common$InterruptionReason$IncorrectEffectiveDate = 9;
var $author$project$Common$InterruptionReason$IncorrectPersonalData = 10;
var $author$project$Common$InterruptionReason$IncorrectVehicleInfo = 11;
var $author$project$Common$InterruptionReason$InexactDeclaration = 12;
var $author$project$Common$InterruptionReason$InexactDeclarationDni = 13;
var $author$project$Common$InterruptionReason$InexactDeclarationSinco = 14;
var $author$project$Common$InterruptionReason$MovingToAnotherCountry = 15;
var $author$project$Common$InterruptionReason$NoInsuranceWanted = 16;
var $author$project$Common$InterruptionReason$NoReason = 17;
var $author$project$Common$InterruptionReason$Other = 18;
var $author$project$Common$InterruptionReason$PaymentMethodOrDate = 19;
var $author$project$Common$InterruptionReason$PhotoVerificationNotProvided = 32;
var $author$project$Common$InterruptionReason$PolicyHolderChange = 20;
var $author$project$Common$InterruptionReason$PriceIncrease = 31;
var $author$project$Common$InterruptionReason$ProductService = 21;
var $author$project$Common$InterruptionReason$RenewalNotProvided = 22;
var $author$project$Common$InterruptionReason$RenewalRejected = 23;
var $author$project$Common$InterruptionReason$RiskAggravation = 24;
var $author$project$Common$InterruptionReason$SwitchToGreatLakes = 33;
var $author$project$Common$InterruptionReason$UnderwritingRules = 25;
var $author$project$Common$InterruptionReason$VehicleDeregistration = 26;
var $author$project$Common$InterruptionReason$VehicleNotPurchased = 27;
var $author$project$Common$InterruptionReason$VehicleScrapped = 28;
var $author$project$Common$InterruptionReason$VehicleSold = 29;
var $author$project$Common$InterruptionReason$WantsGreenCard = 30;
var $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionReason = function (reasonKind) {
	switch (reasonKind) {
		case 0:
			return 17;
		case 1:
			return 9;
		case 2:
			return 1;
		case 3:
			return 11;
		case 4:
			return 30;
		case 5:
			return 10;
		case 6:
			return 4;
		case 7:
			return 29;
		case 8:
			return 28;
		case 9:
			return 3;
		case 10:
			return 15;
		case 11:
			return 5;
		case 12:
			return 16;
		case 13:
			return 7;
		case 14:
			return 24;
		case 15:
			return 12;
		case 16:
			return 18;
		case 17:
			return 27;
		case 18:
			return 26;
		case 19:
			return 6;
		case 21:
			return 19;
		case 22:
			return 2;
		case 23:
			return 25;
		case 24:
			return 14;
		case 25:
			return 0;
		case 26:
			return 13;
		case 20:
			return 8;
		case 28:
			return 22;
		case 27:
			return 23;
		case 30:
			return 20;
		case 31:
			return 21;
		case 32:
			return 31;
		case 29:
			return 32;
		default:
			return 33;
	}
};
var $author$project$New$Gql$Platform$Object$Interruption$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Enum$InterruptionKind$TerminatedByCustomer = 1;
var $author$project$New$Gql$Platform$Enum$InterruptionKind$TerminatedByPrima = 2;
var $author$project$New$Gql$Platform$Enum$InterruptionKind$Withdrawn = 0;
var $author$project$New$Gql$Platform$Enum$InterruptionKind$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'WITHDRAWN':
				return $elm$json$Json$Decode$succeed(0);
			case 'TERMINATED_BY_CUSTOMER':
				return $elm$json$Json$Decode$succeed(1);
			case 'TERMINATED_BY_PRIMA':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid InterruptionKind type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Interruption$kind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.InterruptionKind.InterruptionKind', 'kind', _List_Nil, $author$project$New$Gql$Platform$Enum$InterruptionKind$decoder);
var $author$project$New$Gql$Platform$Enum$InterruptionReason$Chargeback = 25;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$CompetitorOffer = 2;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$CoverageChange = 22;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DeceasedPolicyHolder = 9;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DissatisfactionDocsRequest = 6;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DissatisfactionService = 11;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$DoesNotKnow = 19;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$Fraud = 13;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectDataOther = 20;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectEffectiveDate = 1;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectPersonalData = 5;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$IncorrectVehicleInfo = 3;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$InexactDeclaration = 15;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$InexactDeclarationDni = 26;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$InexactDeclarationSinco = 24;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$MovingToAnotherCountry = 10;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$NoInsuranceWanted = 12;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$NoReason = 0;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$Other = 16;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PaymentMethodOrDate = 21;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PhotoVerificationNotProvided = 29;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PolicyHolderChange = 30;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$PriceIncrease = 32;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$ProductService = 31;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$RenewalNotProvided = 28;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$RenewalRejected = 27;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$RiskAggravation = 14;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$SwitchToGreatLakes = 33;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$UnderwritingRules = 23;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleDeregistration = 18;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleNotPurchased = 17;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleScrapped = 8;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$VehicleSold = 7;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$WantsGreenCard = 4;
var $author$project$New$Gql$Platform$Enum$InterruptionReason$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NO_REASON':
				return $elm$json$Json$Decode$succeed(0);
			case 'INCORRECT_EFFECTIVE_DATE':
				return $elm$json$Json$Decode$succeed(1);
			case 'COMPETITOR_OFFER':
				return $elm$json$Json$Decode$succeed(2);
			case 'INCORRECT_VEHICLE_INFO':
				return $elm$json$Json$Decode$succeed(3);
			case 'WANTS_GREEN_CARD':
				return $elm$json$Json$Decode$succeed(4);
			case 'INCORRECT_PERSONAL_DATA':
				return $elm$json$Json$Decode$succeed(5);
			case 'DISSATISFACTION_DOCS_REQUEST':
				return $elm$json$Json$Decode$succeed(6);
			case 'VEHICLE_SOLD':
				return $elm$json$Json$Decode$succeed(7);
			case 'VEHICLE_SCRAPPED':
				return $elm$json$Json$Decode$succeed(8);
			case 'DECEASED_POLICY_HOLDER':
				return $elm$json$Json$Decode$succeed(9);
			case 'MOVING_TO_ANOTHER_COUNTRY':
				return $elm$json$Json$Decode$succeed(10);
			case 'DISSATISFACTION_SERVICE':
				return $elm$json$Json$Decode$succeed(11);
			case 'NO_INSURANCE_WANTED':
				return $elm$json$Json$Decode$succeed(12);
			case 'FRAUD':
				return $elm$json$Json$Decode$succeed(13);
			case 'RISK_AGGRAVATION':
				return $elm$json$Json$Decode$succeed(14);
			case 'INEXACT_DECLARATION':
				return $elm$json$Json$Decode$succeed(15);
			case 'OTHER':
				return $elm$json$Json$Decode$succeed(16);
			case 'VEHICLE_NOT_PURCHASED':
				return $elm$json$Json$Decode$succeed(17);
			case 'VEHICLE_DEREGISTRATION':
				return $elm$json$Json$Decode$succeed(18);
			case 'DOES_NOT_KNOW':
				return $elm$json$Json$Decode$succeed(19);
			case 'INCORRECT_DATA_OTHER':
				return $elm$json$Json$Decode$succeed(20);
			case 'PAYMENT_METHOD_OR_DATE':
				return $elm$json$Json$Decode$succeed(21);
			case 'COVERAGE_CHANGE':
				return $elm$json$Json$Decode$succeed(22);
			case 'UNDERWRITING_RULES':
				return $elm$json$Json$Decode$succeed(23);
			case 'INEXACT_DECLARATION_SINCO':
				return $elm$json$Json$Decode$succeed(24);
			case 'CHARGEBACK':
				return $elm$json$Json$Decode$succeed(25);
			case 'INEXACT_DECLARATION_DNI':
				return $elm$json$Json$Decode$succeed(26);
			case 'RENEWAL_REJECTED':
				return $elm$json$Json$Decode$succeed(27);
			case 'RENEWAL_NOT_PROVIDED':
				return $elm$json$Json$Decode$succeed(28);
			case 'PHOTO_VERIFICATION_NOT_PROVIDED':
				return $elm$json$Json$Decode$succeed(29);
			case 'POLICY_HOLDER_CHANGE':
				return $elm$json$Json$Decode$succeed(30);
			case 'PRODUCT_SERVICE':
				return $elm$json$Json$Decode$succeed(31);
			case 'PRICE_INCREASE':
				return $elm$json$Json$Decode$succeed(32);
			case 'SWITCH_TO_GREAT_LAKES':
				return $elm$json$Json$Decode$succeed(33);
			default:
				return $elm$json$Json$Decode$fail('Invalid InterruptionReason type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Interruption$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.InterruptionReason.InterruptionReason', 'reason', _List_Nil, $author$project$New$Gql$Platform$Enum$InterruptionReason$decoder);
var $author$project$Common$Gql$Policy$interruptionSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$Interruption$description,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionReason, $author$project$New$Gql$Platform$Object$Interruption$reason),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionKind, $author$project$New$Gql$Platform$Object$Interruption$kind),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$Interruption$at,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$Interruption)))));
var $author$project$New$Gql$Platform$Object$Policy$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$Policy$lastWithdrawableDay = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Date)',
	'lastWithdrawableDay',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B));
var $author$project$New$Gql$Platform$Object$Policy$mainDriver = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'mainDriver', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$MainDriver$address = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'address', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Address$postalCode = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'postalCode', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Address$province = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'province', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Address$streetName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$Address$streetNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'streetNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Common$Gql$Policy$addressSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$Address$postalCode,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$Address$province,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$Address$streetNumber),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$New$Gql$Platform$Object$Address$streetName),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Address$Address)))));
var $author$project$New$Gql$Platform$Object$MainDriver$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$MainDriver$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$MainDriver$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$MainDriver$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$mainDriverPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$MainDriver$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$MainDriver$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$MainDriver$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$MainDriver$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$mainDriverSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
	$elm$core$Maybe$Nothing,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
		'',
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$MainDriver$address($author$project$Common$Gql$Policy$addressSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Policy$mainDriverPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Driver)))));
var $author$project$Common$Policy$Policy = $elm$core$Basics$identity;
var $author$project$Common$Policy$new = function (id) {
	return function (applicationId) {
		return function (quoteId) {
			return function (customerFacingId) {
				return function (startDate) {
					return function (endDate) {
						return function (purchaseDate) {
							return function (lastWithdrawableDay) {
								return function (status) {
									return function (interruption) {
										return function (product) {
											return function (mainDriver) {
												return function (policyHolder) {
													return function (vehicleOwner) {
														return function (additionalDriver) {
															return function (claimsDeclaredWithFault) {
																return function (vehicle) {
																	return function (coverContinuity) {
																		return function (isARenewal) {
																			return function (renewalPolicyId) {
																				return function (renewalCancellation) {
																					return function (source) {
																						return function (availableActions) {
																							return {jq: additionalDriver, jt: applicationId, aY: availableActions, f9: claimsDeclaredWithFault, jX: coverContinuity, mY: customerFacingId, ez: endDate, kv: id, c2: interruption, g3: isARenewal, eZ: lastWithdrawableDay, kP: mainDriver, io: policyHolder, dx: product, iy: purchaseDate, pf: quoteId, iE: renewalCancellation, iF: renewalPolicyId, iO: source, l_: startDate, iR: status, je: vehicle, me: vehicleOwner};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Object$Vehicle$enginePower = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Int)',
	'enginePower',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$New$Gql$Platform$Object$Vehicle$expectedMileage = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.Mileage.Mileage)',
	'expectedMileage',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$Mileage$decoder));
var $author$project$Common$Locale$formatDate = function (date) {
	return _Utils_eq(date, $author$project$Common$Locale$defaultDate) ? '' : A2($justinmimbs$date$Date$format, 'dd/MM/y', date);
};
var $author$project$New$Gql$Platform$Object$Vehicle$fuelType = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.FuelType.FuelType)',
	'fuelType',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$FuelType$decoder));
var $author$project$New$Gql$Platform$Object$Vehicle$maker = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'maker', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$model = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'model', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$modifications = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List Enum.VehicleModification.VehicleModification)',
	'modifications',
	_List_Nil,
	$elm$json$Json$Decode$list($author$project$New$Gql$Platform$Enum$VehicleModification$decoder));
var $author$project$New$Gql$Platform$Object$Vehicle$plateNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'plateNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Vehicle$registrationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Date)',
	'registrationDate',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B));
var $author$project$New$Gql$Platform$Object$Vehicle$usage = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Enum.VehicleUse.VehicleUse)',
	'usage',
	_List_Nil,
	$elm$json$Json$Decode$nullable($author$project$New$Gql$Platform$Enum$VehicleUse$decoder));
var $author$project$New$Gql$Platform$Object$Vehicle$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Vehicle$newVehicleSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeModifications, $author$project$New$Gql$Platform$Object$Vehicle$modifications),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$Vehicle$enginePower,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$Vehicle$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewFuelType, $author$project$New$Gql$Platform$Object$Vehicle$fuelType),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewUsage, $author$project$New$Gql$Platform$Object$Vehicle$usage),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
							'',
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								$elm$core$Maybe$map($author$project$Common$Locale$formatDate),
								$author$project$New$Gql$Platform$Object$Vehicle$registrationDate)),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Vehicle$decodeNewMileage, $author$project$New$Gql$Platform$Object$Vehicle$expectedMileage),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$New$Gql$Platform$Object$Vehicle$plateNumber,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$New$Gql$Platform$Object$Vehicle$maker,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$Vehicle$model,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Vehicle$new)))))))))));
var $author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policy', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Policy$policyHolder = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'policyHolder', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$PolicyHolder$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Gql$Policy$decodeDocumentKind = function (status) {
	if (!status) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$DocumentKind$Dni = 0;
var $author$project$New$Gql$Platform$Enum$DocumentKind$Nie = 1;
var $author$project$New$Gql$Platform$Enum$DocumentKind$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DNI':
				return $elm$json$Json$Decode$succeed(0);
			case 'NIE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid DocumentKind type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$documentKind = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.DocumentKind.DocumentKind', 'documentKind', _List_Nil, $author$project$New$Gql$Platform$Enum$DocumentKind$decoder);
var $author$project$New$Gql$Platform$Object$PolicyHolder$email = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'email', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$phoneNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'phoneNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$policyHolderContactsSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicyHolder$phoneNumber,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PolicyHolder$email,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$Contacts)));
var $author$project$New$Gql$Platform$Object$PolicyHolder$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$PolicyHolder$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicyHolder$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$policyHolderPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicyHolder$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$PolicyHolder$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PolicyHolder$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$PolicyHolder$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$policyHolderSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$Policy$decodeDocumentKind, $author$project$New$Gql$Platform$Object$PolicyHolder$documentKind),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Policy$policyHolderContactsSelectionSet,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
				$author$project$Common$Address$defaultAddress,
				$author$project$New$Gql$Platform$Object$PolicyHolder$address($author$project$Common$Gql$Policy$addressSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Common$Gql$Policy$policyHolderPersonDataSelectionSet,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PolicyHolder)))));
var $author$project$New$Gql$Platform$Object$Policy$product = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'product', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Common$Product$PolicyProduct = F4(
	function (bundleSlug, annualPrice, issuingCompany, chosenExcess) {
		return {mz: annualPrice, mJ: bundleSlug, f7: chosenExcess, a8: issuingCompany};
	});
var $author$project$New$Gql$Platform$Object$Product$chosenExcess = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Decimal)',
	'chosenExcess',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B));
var $author$project$Common$Gql$PolicyProduct$priceBreakdownSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxSurcharges),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxIps),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$net),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$taxes),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Price$euro, $author$project$New$Gql$Platform$Object$SurchargesAndInsuranceTaxPriceBreakdown$gross),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$AnnualPrice))))));
var $author$project$Common$Gql$PolicyProduct$policyProductSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Maybe$map($author$project$Common$Price$euro),
		$author$project$New$Gql$Platform$Object$Product$chosenExcess),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$IssuingCompany$decodeIssuingCompany, $author$project$New$Gql$Platform$Object$Product$issuingCompany),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$Product$priceBreakdown($author$project$Common$Gql$PolicyProduct$priceBreakdownSelectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$Product$bundleSlug),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Product$PolicyProduct)))));
var $author$project$Common$Gql$Policy$productSelectionSet = $author$project$Common$Gql$PolicyProduct$policyProductSelectionSet;
var $author$project$New$Gql$Platform$Object$Policy$purchasedDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'purchasedDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$Policy$quoteId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Uuid)',
	'quoteId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B));
var $author$project$New$Gql$Platform$Object$Policy$renewalCancellation = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'renewalCancellation',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Common$Policy$RenewalCancellation = F2(
	function (reason, description) {
		return {m1: description, iA: reason};
	});
var $author$project$New$Gql$Platform$Object$RenewalCancellation$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$RenewalCancellation$reason = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.InterruptionReason.InterruptionReason', 'reason', _List_Nil, $author$project$New$Gql$Platform$Enum$InterruptionReason$decoder);
var $author$project$Common$Gql$Policy$renewalCancellationSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$RenewalCancellation$description,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$PolicyInterruption$decodePolicyInterruptionReason, $author$project$New$Gql$Platform$Object$RenewalCancellation$reason),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$RenewalCancellation)));
var $author$project$New$Gql$Platform$Object$Policy$renewalPolicyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe NewScalarCodecs.Uuid)',
	'renewalPolicyId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B));
var $author$project$New$Gql$Platform$Enum$QuoteSource$Acierto = 2;
var $author$project$New$Gql$Platform$Enum$QuoteSource$Check24 = 3;
var $author$project$New$Gql$Platform$Enum$QuoteSource$Dts = 0;
var $author$project$New$Gql$Platform$Enum$QuoteSource$Rastreator = 1;
var $author$project$New$Gql$Platform$Enum$QuoteSource$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DTS':
				return $elm$json$Json$Decode$succeed(0);
			case 'RASTREATOR':
				return $elm$json$Json$Decode$succeed(1);
			case 'ACIERTO':
				return $elm$json$Json$Decode$succeed(2);
			case 'CHECK_24':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid QuoteSource type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Policy$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.QuoteSource.QuoteSource', 'source', _List_Nil, $author$project$New$Gql$Platform$Enum$QuoteSource$decoder);
var $author$project$New$Gql$Platform$Object$Policy$startDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'startDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Active = 1;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Expired = 3;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$GracePeriod = 2;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Issued = 0;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$NotRenewed = 4;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Renewed = 5;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$TerminatedByCustomer = 7;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$TerminatedByPrima = 8;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$Withdrawn = 6;
var $author$project$New$Gql$Platform$Enum$PolicyStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ISSUED':
				return $elm$json$Json$Decode$succeed(0);
			case 'ACTIVE':
				return $elm$json$Json$Decode$succeed(1);
			case 'GRACE_PERIOD':
				return $elm$json$Json$Decode$succeed(2);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(3);
			case 'NOT_RENEWED':
				return $elm$json$Json$Decode$succeed(4);
			case 'RENEWED':
				return $elm$json$Json$Decode$succeed(5);
			case 'WITHDRAWN':
				return $elm$json$Json$Decode$succeed(6);
			case 'TERMINATED_BY_CUSTOMER':
				return $elm$json$Json$Decode$succeed(7);
			case 'TERMINATED_BY_PRIMA':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Invalid PolicyStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$Policy$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PolicyStatus.PolicyStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$PolicyStatus$decoder);
var $author$project$New$Gql$Platform$Object$Policy$vehicle = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicle', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$Policy$vehicleOwner = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vehicleOwner', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$New$Gql$Platform$Object$VehicleOwner$address = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'address',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$New$Gql$Platform$Object$VehicleOwner$dateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'dateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$VehicleOwner$documentId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'documentId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$VehicleOwner$firstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'firstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$VehicleOwner$lastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'lastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Common$Gql$Policy$vehicleOwnerPersonDataSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$VehicleOwner$dateOfBirth,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$VehicleOwner$documentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$VehicleOwner$lastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$VehicleOwner$firstName,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$PersonData)))));
var $author$project$Common$Gql$Policy$vehicleOwnerSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
		$author$project$Common$Address$defaultAddress,
		$author$project$New$Gql$Platform$Object$VehicleOwner$address($author$project$Common$Gql$Policy$addressSelectionSet)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Common$Gql$Policy$vehicleOwnerPersonDataSelectionSet,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Person$VehicleOwner)));
var $author$project$Common$Gql$Policy$policySelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$availableActions($author$project$Common$Gql$Policy$decodeAvailableActions),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$author$project$Common$Gql$Source$decodeFromQuoteSource,
			$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$source)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
				$author$project$New$Gql$Platform$Object$Policy$renewalCancellation($author$project$Common$Gql$Policy$renewalCancellationSelectionSet)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$renewalPolicyId),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$isARenewal),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$coverContinuityInfo($author$project$Common$Gql$CoverContinuity$newCoverContinuitySelectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
								$author$project$New$Gql$Platform$Object$Policy$vehicle($author$project$Common$Gql$Vehicle$newVehicleSelectionSet)),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
									$author$project$Common$Count$default,
									$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$claimsDeclaredWithFault($author$project$Common$Gql$ClaimsCount$newClaimsDeclaredWithFaultSelectionSet)),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault,
										$author$project$Common$Person$emptyAdditionalDriverFixture,
										$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
											$author$project$New$Gql$Platform$Object$Policy$additionalDriver($author$project$Common$Gql$Policy$additionalDriverSelectionSet))),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
											$author$project$New$Gql$Platform$Object$Policy$vehicleOwner($author$project$Common$Gql$Policy$vehicleOwnerSelectionSet)),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
												$author$project$New$Gql$Platform$Object$Policy$policyHolder($author$project$Common$Gql$Policy$policyHolderSelectionSet)),
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
													$author$project$New$Gql$Platform$Object$Policy$mainDriver($author$project$Common$Gql$Policy$mainDriverSelectionSet)),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
														$author$project$New$Gql$Platform$Object$Policy$product($author$project$Common$Gql$Policy$productSelectionSet)),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy(
															$author$project$New$Gql$Platform$Object$Policy$interruption($author$project$Common$Gql$Policy$interruptionSelectionSet)),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																$author$project$Common$Gql$Policy$decodePolicyStatus,
																$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$status)),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$lastWithdrawableDay),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$purchasedDate),
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$endDate),
																		A2(
																			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																			$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$startDate),
																			A2(
																				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																				$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$customerFacingId),
																				A2(
																					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																						$elm$core$Maybe$map($author$project$Common$QuoteId$new),
																						$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$quoteId)),
																					A2(
																						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
																							$author$project$Common$ApplicationId$new,
																							$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$applicationId)),
																						A2(
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																							$author$project$New$Gql$Platform$Object$PolicyDetailsOutput$policy($author$project$New$Gql$Platform$Object$Policy$id),
																							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Common$Policy$new))))))))))))))))))))))));
var $author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdRequiredArguments = function (policyId) {
	var buildPricingActionInput = function (arg) {
		return $author$project$New$Gql$Platform$Query$PricingActionRequiredArguments(
			$author$project$New$Gql$Platform$InputObject$buildPricingActionInput(
				$author$project$New$Gql$Platform$InputObject$PricingActionInputRequiredFields(arg)));
	};
	var buildPolicyInput = function (id) {
		return A2(
			$author$project$New$Gql$Platform$InputObject$OfferOrPolicyIdentifier,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$New$Gql$Platform$InputObject$PolicyIdentifier(
					$dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(id))));
	};
	return buildPricingActionInput(
		buildPolicyInput(policyId));
};
var $author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdQuery = function (policyId) {
	return $author$project$Common$Gql$ClaimHistory$pricingActionQuery(
		$author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdRequiredArguments(policyId));
};
var $author$project$New$Gql$Platform$InputObject$encodePrimaTerminatePolicyInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.kv))),
				_Utils_Tuple2(
				'requestedAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.i))),
				_Utils_Tuple2(
				'interruptionAt',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.O;
						},
						$author$project$NewScalarCodecs$codecs)(input____.a6))),
				_Utils_Tuple2(
				'reason',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString, input____.iA))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$New$Gql$Platform$Mutation$primaTerminatePolicy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'primaTerminatePolicy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodePrimaTerminatePolicyInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$PolicyDetails$Gql$primaTerminatePolicy = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var interruptionAt = _v0.a6;
	var reason = _v0.iA;
	var description = _v0.m1;
	return {
		nD: {
			m1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			kv: id,
			a6: interruptionAt,
			iA: reason,
			i: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$PrimaTerminatePolicyOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$primaTerminatePolicySelectionSet = $author$project$New$Gql$Platform$Object$PrimaTerminatePolicyOutput$policyId;
var $author$project$Page$PolicyDetails$Ports$requestIssueRefundReleaseDate = _Platform_outgoingPort(
	'requestIssueRefundReleaseDate',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$New$Gql$Platform$InputObject$SendPolicyContractEmailInput = function (policyId) {
	return {o6: policyId};
};
var $author$project$Page$PolicyDetails$Gql$sendPolicyContract = function (policyId) {
	return {
		nD: $author$project$New$Gql$Platform$InputObject$SendPolicyContractEmailInput(policyId)
	};
};
var $author$project$New$Gql$Platform$InputObject$encodeSendPolicyContractEmailInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)(input____.o6)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$sendPolicyContractEmail = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'sendPolicyContractEmail',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeSendPolicyContractEmailInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$New$Gql$Platform$Object$SendPolicyContractEmailOutput$success = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'success', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Page$PolicyDetails$Gql$sendPolicyContractSelectionSet = $author$project$New$Gql$Platform$Object$SendPolicyContractEmailOutput$success;
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Gql$Platform$InputObject$BackofficeUpdatePolicyholderEmailInput = F2(
	function (policyCustomerFacingId, newEmailAddress) {
		return {dg: newEmailAddress, dl: policyCustomerFacingId};
	});
var $author$project$Page$PolicyDetails$Gql$updateEmail = F2(
	function (policyCfid, email) {
		return {
			nD: A2($author$project$Gql$Platform$InputObject$BackofficeUpdatePolicyholderEmailInput, policyCfid, email)
		};
	});
var $author$project$New$Gql$Platform$Object$UpdatePolicyHolderEmailOutput$success = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'success', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Page$PolicyDetails$Gql$updateEmailSelectionSet = $author$project$New$Gql$Platform$Object$UpdatePolicyHolderEmailOutput$success;
var $author$project$New$Gql$Platform$InputObject$encodeUpdatePolicyHolderEmailInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyCustomerFacingId',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.dl))),
				_Utils_Tuple2(
				'newEmailAddress',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.dg)))
			]));
};
var $author$project$New$Gql$Platform$Mutation$updatePolicyHolderEmail = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'updatePolicyHolderEmail',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeUpdatePolicyHolderEmailInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Tracker$Policy = 1;
var $author$project$Tracker$userSendEmailPayloadForPolicy = function (emails) {
	return {gz: emails, gC: 1};
};
var $author$project$Page$PolicyDetails$Gql$withdrawPolicy = function (_v0) {
	var id = _v0.kv;
	var requestedAt = _v0.i;
	var reason = _v0.iA;
	var description = _v0.m1;
	return {
		nD: {
			m1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(description),
			kv: id,
			iA: reason,
			i: requestedAt
		}
	};
};
var $author$project$New$Gql$Platform$Object$CustomerWithdrawPolicyOutput$policyId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'policyId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$PolicyDetails$Gql$withdrawPolicySelectionSet = $author$project$New$Gql$Platform$Object$CustomerWithdrawPolicyOutput$policyId;
var $author$project$Page$PolicyDetails$Effect$runEffect = F3(
	function (env, model, effect) {
		switch (effect.$) {
			case 31:
				return $elm$core$Platform$Cmd$none;
			case 7:
				var cmd = effect.a;
				return cmd;
			case 0:
				var id = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'policyDetails',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$New$Gql$Platform$Query$policyDetails,
						$author$project$Common$Gql$Policy$policyByIdRequiredArguments(id),
						$author$project$Common$Gql$Policy$policySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedPolicy));
			case 1:
				var quoteId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'claimsHistory',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$New$Gql$Platform$Query$claimsHistory,
						$author$project$Common$Gql$ClaimHistory$claimHistoryByQuoteIdRequiredArguments(
							$author$project$Common$QuoteId$toUuid(quoteId)),
						$author$project$Common$Gql$ClaimHistory$claimsHistoryOutputSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedClaimHistory));
			case 2:
				var offerId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getCustomerId',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$CustomerId$getCustomerId(
						$author$project$Common$Gql$CustomerId$PolicyId(offerId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedCustomerId));
			case 4:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'fetchCoverSelection',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$Common$Gql$CoverSelection$getCoverSelection,
						env,
						$author$project$Common$Gql$CoverSelection$PolicyId(policyId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedCoverSelection));
			case 3:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'pricingAction',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$ClaimHistory$pricingActionByPolicyIdQuery(policyId),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedClaimHistoryPricingAction));
			case 11:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'customerWithdrawPolicy',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$customerWithdrawPolicy,
						$author$project$Page$PolicyDetails$Gql$withdrawPolicy(_arguments),
						$author$project$Page$PolicyDetails$Gql$withdrawPolicySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived));
			case 12:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'customerTerminatePolicy',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$customerTerminatePolicy,
						$author$project$Page$PolicyDetails$Gql$customerTerminatePolicy(_arguments),
						$author$project$Page$PolicyDetails$Gql$customerTerminatePolicySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived));
			case 13:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'primaTerminatePolicy',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$primaTerminatePolicy,
						$author$project$Page$PolicyDetails$Gql$primaTerminatePolicy(_arguments),
						$author$project$Page$PolicyDetails$Gql$primaTerminatePolicySelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$InterruptionResponseReceived));
			case 8:
				return A2($elm$core$Task$perform, $author$project$Page$PolicyDetails$Msg$GotCurrentTime, $elm$time$Time$now);
			case 9:
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Page$PolicyDetails$Effect$executeCheckEligibilityQuery, env, $author$project$Page$PolicyDetails$Msg$GotExpectedRefund),
						$author$project$Page$PolicyDetails$Effect$createCheckEligibilityArgument(model)));
			case 10:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getRefund',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$GetRefund$getRefundQuery(policyId),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$GotRefund));
			case 30:
				var policyId = effect.a;
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						$author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundCompletion(policyId)),
					$elm$core$Process$sleep(500.0));
			case 29:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getRefund',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$GetRefund$getRefundQuery(policyId),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$PolledForRefundCompletion(policyId)));
			case 28:
				var originalRefund = effect.a;
				var policyId = effect.b;
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						A2($author$project$Page$PolicyDetails$Msg$WaitedBeforePollingRefundUpdate, originalRefund, policyId)),
					$elm$core$Process$sleep(500.0));
			case 27:
				var originalRefund = effect.a;
				var policyId = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getRefund',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$GetRefund$getRefundQuery(policyId),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						A2($author$project$Page$PolicyDetails$Msg$PolledForRefundUpdate, originalRefund, policyId)));
			case 14:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'createRefund',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$createRefund,
						$author$project$Page$PolicyDetails$Gql$createRefund(policyId),
						$author$project$Page$PolicyDetails$Gql$createRefundSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$CreateRefundResponseReceived));
			case 15:
				var refund = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'issueRefund',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$issueRefund,
						$author$project$Page$PolicyDetails$Gql$issueRefund(
							$author$project$Common$Refund$pickId(refund)),
						$author$project$Page$PolicyDetails$Gql$issueRefundSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$IssueRefundResponseReceived));
			case 16:
				var refund = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'payRefund',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$payRefund,
						$author$project$Page$PolicyDetails$Gql$payRefund(
							$author$project$Common$Refund$pickId(refund)),
						$author$project$Page$PolicyDetails$Gql$payRefundSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$IssueRefundResponseReceived));
			case 17:
				return $author$project$Page$PolicyDetails$Ports$requestIssueRefundReleaseDate(0);
			case 19:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'getPreviousPaymentMethod',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					$author$project$Common$Gql$PaymentMethod$getPaymentMethod(
						$author$project$Common$Gql$PaymentMethod$PolicyId(policyId)),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$FetchedPaymentMethod));
			case 18:
				var _arguments = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'customerDeclineRenewal',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$customerDeclineRenewal,
						$author$project$Page$PolicyDetails$Gql$declineRenewal(_arguments),
						$author$project$Page$PolicyDetails$Gql$declineRenewalSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$RenewalCancellationResponseReceived));
			case 20:
				var policyId = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'sendPolicyContractEmail',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$sendPolicyContractEmail,
						$author$project$Page$PolicyDetails$Gql$sendPolicyContract(policyId),
						$author$project$Page$PolicyDetails$Gql$sendPolicyContractSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$SendPolicyContractEmailResponseReceived));
			case 21:
				var email = effect.a;
				var policyCfid = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'updatePolicyHolderEmail',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$updatePolicyHolderEmail,
						A2($author$project$Page$PolicyDetails$Gql$updateEmail, policyCfid, email),
						$author$project$Page$PolicyDetails$Gql$updateEmailSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$PolicyDetails$Msg$GotChangeEmailResponse));
			case 22:
				var emailOptions = effect.a;
				return $author$project$Tracker$publishUserEvent(
					$author$project$Tracker$userSendEmailEvent(
						$author$project$Tracker$userSendEmailPayloadForPolicy(emailOptions)));
			case 23:
				var args = effect.a;
				var hasInterruptionDateChanged = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'amendTermination',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$amendTermination,
						$author$project$Page$PolicyDetails$Gql$amendCustomerInterruption(args),
						$author$project$Page$PolicyDetails$Gql$amendTerminationSelectionSet),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived(hasInterruptionDateChanged)));
			case 24:
				var args = effect.a;
				var hasInterruptionDateChanged = effect.b;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'amendTermination',
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2(
						$author$project$New$Gql$Platform$Mutation$amendTermination,
						$author$project$Page$PolicyDetails$Gql$amendCompanyInterruption(args),
						$author$project$Page$PolicyDetails$Gql$amendTerminationSelectionSet),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived(hasInterruptionDateChanged)));
			case 25:
				var reason = effect.a;
				var args = effect.b;
				var hasInterruptionDateChanged = effect.c;
				return A4(
					$author$project$Api$executeGraphqlOperation,
					env,
					$dillonkearns$elm_graphql$Graphql$Http$mutationRequest,
					A2($author$project$Page$PolicyDetails$Effect$amendDateInterruptionArgs, reason, args),
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$PolicyDetails$Msg$AmendInterruptionResponseReceived(hasInterruptionDateChanged)));
			case 26:
				var reason = effect.a;
				var policyId = effect.b;
				var interruptionAt = effect.c;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						A2($author$project$Page$PolicyDetails$Effect$executeCheckEligibilityQuery, env, $author$project$Page$PolicyDetails$Msg$GotAmendExpectedRefund),
						A3($author$project$Page$PolicyDetails$Effect$getExpectedRefundForAmendInterruption, reason, policyId, interruptionAt)));
			case 5:
				return $elm$core$Platform$Cmd$none;
			default:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2($author$project$Page$PolicyDetails$Effect$runEffect, env, model),
						effects));
		}
	});
var $author$project$Page$Search$Msg$GotCurrentDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Search$Msg$GotNewResults = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$Msg$RewriteUrl = function (a) {
	return {$: 5, a: a};
};
var $primait$prima_elm_extra$PrimaCmd$fromMsg = A2(
	$elm$core$Basics$composeL,
	$elm$core$Task$perform($elm$core$Basics$identity),
	$elm$core$Task$succeed);
var $author$project$New$Gql$Platform$InputObject$encodeSearchInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'policyCustomerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dl, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'offerCustomerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'quoteCustomerFacingId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cf, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'policyHolderEmail',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ca, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'plateNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.$9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'policyHolderPhoneNumber',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cb, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'policyHolderDocumentId',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b9, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'customerId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gm,
					A2(
						$author$project$New$Gql$Platform$Scalar$unwrapEncoder,
						function ($) {
							return $.u;
						},
						$author$project$NewScalarCodecs$codecs)))
			]));
};
var $author$project$New$Gql$Platform$Query$search = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'search',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.nD, $author$project$New$Gql$Platform$InputObject$encodeSearchInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Page$Search$NewGql$emptySearchArgs = {gm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, $9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ca: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cf: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent};
var $elm$core$String$trim = _String_trim;
var $author$project$Page$Search$NewGql$searchRequiredArg = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			var documentId = searchInput.a;
			return {
				nD: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						b9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(documentId)
					})
			};
		case 1:
			switch (searchInput.a.$) {
				case 0:
					var cfid = searchInput.a.a;
					return {
						nD: _Utils_update(
							$author$project$Page$Search$NewGql$emptySearchArgs,
							{
								dl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid)
							})
					};
				case 1:
					var cfid = searchInput.a.a;
					return {
						nD: _Utils_update(
							$author$project$Page$Search$NewGql$emptySearchArgs,
							{
								b3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid)
							})
					};
				default:
					var cfid = searchInput.a.a;
					return {
						nD: _Utils_update(
							$author$project$Page$Search$NewGql$emptySearchArgs,
							{
								cf: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(cfid)
							})
					};
			}
		case 2:
			var email = searchInput.a;
			var normalizedEmail = $elm$core$String$toLower(
				$elm$core$String$trim(email));
			return {
				nD: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						ca: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(normalizedEmail)
					})
			};
		case 3:
			return {nD: $author$project$Page$Search$NewGql$emptySearchArgs};
		case 4:
			var plateNumber = searchInput.a;
			return {
				nD: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						$9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(plateNumber)
					})
			};
		case 5:
			var phoneNumber = searchInput.a;
			return {
				nD: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						cb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(phoneNumber)
					})
			};
		default:
			var customerId = searchInput.a;
			return {
				nD: _Utils_update(
					$author$project$Page$Search$NewGql$emptySearchArgs,
					{
						gm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(customerId)
					})
			};
	}
};
var $author$project$Page$Search$NewSearchResult$new = F3(
	function (offers, policies, quotes) {
		return {k_: offers, lt: policies, lB: quotes};
	});
var $author$project$New$Gql$Platform$Object$OfferSearchResult$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$creationDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'creationDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Page$Search$NewGql$decodeGrossPrice = function (decimalPrice) {
	return $author$project$Common$Price$euro(decimalPrice);
};
var $author$project$Page$Search$NewGql$decodeOfferBy = function (source) {
	switch (source) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 2;
	}
};
var $author$project$Page$Search$NewGql$decodeOfferStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		default:
			return 8;
	}
};
var $author$project$New$Gql$Platform$Object$OfferSearchResult$grossPrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'grossPrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$isAGreatLakesRenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isAGreatLakesRenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$isCustomerInformationComplete = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isCustomerInformationComplete', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverBirthDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'mainDriverBirthDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverProvince = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mainDriverProvince', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverRecentInsuranceCompanyName = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'mainDriverRecentInsuranceCompanyName',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Page$Search$OfferSearchResult$OfferSearchResult = $elm$core$Basics$identity;
var $author$project$Page$Search$OfferSearchResult$new = function (id) {
	return function (customerFacingId) {
		return function (status) {
			return function (grossPrice) {
				return function (vehiclePlateNumber) {
					return function (vehicleModel) {
						return function (vehicleMake) {
							return function (policyholderDni) {
								return function (mainDriverBirthDate) {
									return function (bundleSlug) {
										return function (offerBy) {
											return function (startDate) {
												return function (creationDate) {
													return function (mainDriverRecentInsuranceCompanyName) {
														return function (mainDriverProvince) {
															return function (isARenewal) {
																return function (isAGreatLakesRenewal) {
																	return function (isCustomerInformationComplete) {
																		return {mJ: bundleSlug, gh: creationDate, mY: customerFacingId, c$: grossPrice, kv: id, g2: isAGreatLakesRenewal, g3: isARenewal, g5: isCustomerInformationComplete, hl: mainDriverBirthDate, hm: mainDriverProvince, hn: mainDriverRecentInsuranceCompanyName, hJ: offerBy, iq: policyholderDni, l_: startDate, iR: status, jf: vehicleMake, jh: vehicleModel, ji: vehiclePlateNumber};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Object$OfferSearchResult$offerBy = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ApplicationSource.ApplicationSource', 'offerBy', _List_Nil, $author$project$New$Gql$Platform$Enum$ApplicationSource$decoder);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$policyholderDni = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyholderDni', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$startDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'startDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Available = 7;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Blocked = 4;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Expired = 3;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$NewPrice = 0;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$NewProduct = 1;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Purchased = 6;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$Requoted = 5;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$StartDateExpired = 2;
var $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NEW_PRICE':
				return $elm$json$Json$Decode$succeed(0);
			case 'NEW_PRODUCT':
				return $elm$json$Json$Decode$succeed(1);
			case 'START_DATE_EXPIRED':
				return $elm$json$Json$Decode$succeed(2);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(3);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(4);
			case 'REQUOTED':
				return $elm$json$Json$Decode$succeed(5);
			case 'PURCHASED':
				return $elm$json$Json$Decode$succeed(6);
			case 'AVAILABLE':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid OfferSearchResultStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.OfferSearchResultStatus.OfferSearchResultStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$OfferSearchResultStatus$decoder);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleMake = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleMake', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleModel = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleModel', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$OfferSearchResult$vehiclePlateNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'vehiclePlateNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Page$Search$NewGql$offerSearchResultSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$OfferSearchResult$isCustomerInformationComplete,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$OfferSearchResult$isAGreatLakesRenewal,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$OfferSearchResult$isARenewal,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverProvince,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverRecentInsuranceCompanyName,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$OfferSearchResult$creationDate,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$OfferSearchResult$startDate,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeOfferBy, $author$project$New$Gql$Platform$Object$OfferSearchResult$offerBy),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$OfferSearchResult$bundleSlug),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$OfferSearchResult$mainDriverBirthDate,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$OfferSearchResult$policyholderDni,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleMake,
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$New$Gql$Platform$Object$OfferSearchResult$vehicleModel,
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														$author$project$New$Gql$Platform$Object$OfferSearchResult$vehiclePlateNumber,
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeGrossPrice, $author$project$New$Gql$Platform$Object$OfferSearchResult$grossPrice),
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeOfferStatus, $author$project$New$Gql$Platform$Object$OfferSearchResult$status),
																A2(
																	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																	$author$project$New$Gql$Platform$Object$OfferSearchResult$customerFacingId,
																	A2(
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																		$author$project$New$Gql$Platform$Object$OfferSearchResult$id,
																		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$OfferSearchResult$new)))))))))))))))))));
var $author$project$New$Gql$Platform$Object$SearchOutput$offers = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'offers',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$SearchOutput$policies = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'policies',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$New$Gql$Platform$Object$PolicySearchResult$bundleSlug = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.BundleSlug.BundleSlug', 'bundleSlug', _List_Nil, $author$project$New$Gql$Platform$Enum$BundleSlug$decoder);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Page$Search$NewGql$decodePolicySource = function (source) {
	switch (source) {
		case 2:
			return 0;
		case 3:
			return 1;
		case 1:
			return 3;
		default:
			return 2;
	}
};
var $author$project$Page$Search$NewGql$decodePolicyStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 3:
			return 3;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 5:
			return 4;
		case 4:
			return 5;
		default:
			return 2;
	}
};
var $author$project$New$Gql$Platform$Object$PolicySearchResult$endDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'endDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$grossPrice = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Decimal',
	'grossPrice',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mO.B);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$isARenewal = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isARenewal', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Page$Search$PolicySearchResult$PolicySearchResult = $elm$core$Basics$identity;
var $author$project$Page$Search$PolicySearchResult$new = function (id) {
	return function (customerFacingId) {
		return function (bundleSlug) {
			return function (grossPrice) {
				return function (source) {
					return function (startDate) {
						return function (endDate) {
							return function (vehiclePlateNumber) {
								return function (vehicleMaker) {
									return function (vehicleModel) {
										return function (policyholderDni) {
											return function (policyholderDateOfBirth) {
												return function (policyholderFirstName) {
													return function (policyholderLastName) {
														return function (status) {
															return function (isARenewal) {
																return {mJ: bundleSlug, mY: customerFacingId, ez: endDate, c$: grossPrice, kv: id, g3: isARenewal, ip: policyholderDateOfBirth, iq: policyholderDni, is: policyholderFirstName, it: policyholderLastName, iO: source, l_: startDate, iR: status, jg: vehicleMaker, jh: vehicleModel, ji: vehiclePlateNumber};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDateOfBirth = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'policyHolderDateOfBirth',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDocument = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyHolderDocument', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderFirstName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyHolderFirstName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderLastName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'policyHolderLastName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.QuoteSource.QuoteSource', 'source', _List_Nil, $author$project$New$Gql$Platform$Enum$QuoteSource$decoder);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$startDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'startDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.PolicyStatus.PolicyStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$PolicyStatus$decoder);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleMake = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleMake', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleModel = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleModel', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$PolicySearchResult$vehiclePlateNumber = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehiclePlateNumber', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Page$Search$NewGql$policySearchResultSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$PolicySearchResult$isARenewal,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodePolicyStatus, $author$project$New$Gql$Platform$Object$PolicySearchResult$status),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderLastName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderFirstName,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDateOfBirth,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$PolicySearchResult$policyHolderDocument,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleModel,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$New$Gql$Platform$Object$PolicySearchResult$vehicleMake,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$New$Gql$Platform$Object$PolicySearchResult$vehiclePlateNumber,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$New$Gql$Platform$Object$PolicySearchResult$endDate,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$PolicySearchResult$startDate,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodePolicySource, $author$project$New$Gql$Platform$Object$PolicySearchResult$source),
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeGrossPrice, $author$project$New$Gql$Platform$Object$PolicySearchResult$grossPrice),
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Common$Gql$BundleSlug$decodeNewBundleSlug, $author$project$New$Gql$Platform$Object$PolicySearchResult$bundleSlug),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$New$Gql$Platform$Object$PolicySearchResult$customerFacingId,
															A2(
																$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
																$author$project$New$Gql$Platform$Object$PolicySearchResult$id,
																$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$PolicySearchResult$new)))))))))))))))));
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$applicationId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'applicationId',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$customerFacingId = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'customerFacingId', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Page$Search$NewGql$decodeQuoteSource = function (source) {
	switch (source) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 3:
			return 3;
		case 2:
			return 2;
		default:
			return 2;
	}
};
var $author$project$Common$QuoteStatus$Active = 0;
var $author$project$Common$QuoteStatus$Blocked = 2;
var $author$project$Common$QuoteStatus$Expired = 1;
var $author$project$Page$Search$NewGql$decodeQuoteStatus = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$funnelGuaranteeSelectionUrl = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'funnelGuaranteeSelectionUrl', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Uuid',
	'id',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).u.B);
var $author$project$Page$Search$QuoteSearchResult$QuoteSearchResult = $elm$core$Basics$identity;
var $author$project$Page$Search$QuoteSearchResult$new = function (id) {
	return function (applicationId) {
		return function (source) {
			return function (customerFacingId) {
				return function (validUntil) {
					return function (date) {
						return function (vehiclePlateNumber) {
							return function (vehicleMake) {
								return function (vehicleModel) {
									return function (status) {
										return function (policyholderEmail) {
											return function (funnelGuaranteeSelectionUrl) {
												return {jt: applicationId, mY: customerFacingId, go: date, gM: funnelGuaranteeSelectionUrl, kv: id, ir: policyholderEmail, iO: source, iR: status, ja: validUntil, jf: vehicleMake, jh: vehicleModel, ji: vehiclePlateNumber};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$policyholderEmail = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'policyholderEmail',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$quoteDate = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'quoteDate',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ApplicationSource.ApplicationSource', 'source', _List_Nil, $author$project$New$Gql$Platform$Enum$ApplicationSource$decoder);
var $author$project$New$Gql$Platform$Enum$QuoteStatus$Active = 0;
var $author$project$New$Gql$Platform$Enum$QuoteStatus$Blocked = 2;
var $author$project$New$Gql$Platform$Enum$QuoteStatus$Expired = 1;
var $author$project$New$Gql$Platform$Enum$QuoteStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ACTIVE':
				return $elm$json$Json$Decode$succeed(0);
			case 'EXPIRED':
				return $elm$json$Json$Decode$succeed(1);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid QuoteStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.QuoteStatus.QuoteStatus', 'status', _List_Nil, $author$project$New$Gql$Platform$Enum$QuoteStatus$decoder);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$validUntil = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'NewScalarCodecs.Date',
	'validUntil',
	_List_Nil,
	$author$project$New$Gql$Platform$Scalar$unwrapCodecs($author$project$NewScalarCodecs$codecs).mN.B);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$vehicleMake = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleMake', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$vehicleModel = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'vehicleModel', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$New$Gql$Platform$Object$QuoteSearchResult$vehiclePlateNumber = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'vehiclePlateNumber',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Page$Search$NewGql$quoteSearchResultSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$QuoteSearchResult$funnelGuaranteeSelectionUrl,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$QuoteSearchResult$policyholderEmail,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeQuoteStatus, $author$project$New$Gql$Platform$Object$QuoteSearchResult$status),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$New$Gql$Platform$Object$QuoteSearchResult$vehicleModel,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$New$Gql$Platform$Object$QuoteSearchResult$vehicleMake,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$New$Gql$Platform$Object$QuoteSearchResult$vehiclePlateNumber,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$New$Gql$Platform$Object$QuoteSearchResult$quoteDate,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$New$Gql$Platform$Object$QuoteSearchResult$validUntil,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$New$Gql$Platform$Object$QuoteSearchResult$customerFacingId,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Page$Search$NewGql$decodeQuoteSource, $author$project$New$Gql$Platform$Object$QuoteSearchResult$source),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$New$Gql$Platform$Object$QuoteSearchResult$applicationId,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$New$Gql$Platform$Object$QuoteSearchResult$id,
												$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$QuoteSearchResult$new)))))))))))));
var $author$project$New$Gql$Platform$Object$SearchOutput$quotes = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'quotes',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Page$Search$NewGql$searchSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$New$Gql$Platform$Object$SearchOutput$quotes($author$project$Page$Search$NewGql$quoteSearchResultSelectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$New$Gql$Platform$Object$SearchOutput$policies($author$project$Page$Search$NewGql$policySearchResultSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$New$Gql$Platform$Object$SearchOutput$offers($author$project$Page$Search$NewGql$offerSearchResultSelectionSet),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Page$Search$NewSearchResult$new))));
var $author$project$Tracker$UserSearch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tracker$userSearchEvent = $author$project$Tracker$UserSearch;
var $author$project$Tracker$UserSearchPayload = $elm$core$Basics$identity;
var $author$project$Tracker$userSearchPayload = function (searchType) {
	return {lM: searchType};
};
var $author$project$Page$Search$Effect$runEffect = F2(
	function (env, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 2:
				return $elm$core$Platform$Cmd$none;
			case 7:
				return $elm$core$Platform$Cmd$none;
			case 3:
				var cmd = effect.a;
				return cmd;
			case 4:
				var searchInputString = effect.a;
				return A5(
					$author$project$Api$executeNewGraphqlOperation,
					env,
					'search',
					$dillonkearns$elm_graphql$Graphql$Http$queryRequest,
					A2(
						$author$project$New$Gql$Platform$Query$search,
						$author$project$Page$Search$NewGql$searchRequiredArg(searchInputString),
						$author$project$Page$Search$NewGql$searchSelectionSet),
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$Msg$GotNewResults));
			case 5:
				return A2(
					$elm$core$Task$perform,
					$author$project$Page$Search$Msg$GotCurrentDate,
					A2(
						$elm$core$Task$map,
						$justinmimbs$date$Date$fromPosix($elm$time$Time$utc),
						$elm$time$Time$now));
			case 6:
				var searchInputString = effect.a;
				return $primait$prima_elm_extra$PrimaCmd$fromMsg(
					$author$project$Page$Search$Msg$RewriteUrl(searchInputString));
			case 8:
				var searchType = effect.a;
				return $author$project$Tracker$publishUserEvent(
					$author$project$Tracker$userSearchEvent(
						$author$project$Tracker$userSearchPayload(searchType)));
			default:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Page$Search$Effect$runEffect(env),
						effects));
		}
	});
var $author$project$Page$Search$SearchQueryParam$pickCustomerFacingId = function (customerFId) {
	switch (customerFId.$) {
		case 0:
			var policyId = customerFId.a;
			return policyId;
		case 1:
			var offerId = customerFId.a;
			return offerId;
		default:
			var quoteId = customerFId.a;
			return quoteId;
	}
};
var $author$project$Referer$toString = 'payment-page';
var $author$project$Route$routeToPieces = function (page) {
	switch (page.$) {
		case 0:
			return _List_fromArray(
				['not-found']);
		case 1:
			return _List_fromArray(
				['not-authorized']);
		case 2:
			return _List_fromArray(
				['login']);
		case 4:
			var offerId = page.a;
			return _List_fromArray(
				[
					'payment',
					$danyx23$elm_uuid$Uuid$toString(offerId)
				]);
		case 3:
			var tabIndex = page.a;
			var searchQuery = page.b;
			if (!searchQuery.$) {
				switch (searchQuery.a.$) {
					case 0:
						var documentId = searchQuery.a.a;
						return _List_fromArray(
							['#search=' + documentId]);
					case 1:
						var cfid = searchQuery.a.a;
						return _List_fromArray(
							[
								'#search=' + $author$project$Page$Search$SearchQueryParam$pickCustomerFacingId(cfid)
							]);
					case 4:
						var plateNumber = searchQuery.a.a;
						return _List_fromArray(
							['#search=' + plateNumber]);
					case 2:
						var email = searchQuery.a.a;
						return _List_fromArray(
							[
								'?tabIndex=' + ($elm$core$String$fromInt(tabIndex) + ('#search=' + email))
							]);
					case 5:
						var phoneNumber = searchQuery.a.a;
						return _List_fromArray(
							['#search=' + phoneNumber]);
					case 6:
						var customerId = searchQuery.a.a;
						return _List_fromArray(
							[
								'#search=' + $danyx23$elm_uuid$Uuid$toString(customerId)
							]);
					default:
						var _v2 = searchQuery.a;
						return _List_Nil;
				}
			} else {
				return _List_Nil;
			}
		case 5:
			if (!page.b.$) {
				var policyId = page.a;
				return _List_fromArray(
					[
						'policy-details',
						$danyx23$elm_uuid$Uuid$toString(policyId),
						'?referer=' + $author$project$Referer$toString
					]);
			} else {
				var policyId = page.a;
				var _v3 = page.b;
				return _List_fromArray(
					[
						'policy-details',
						$danyx23$elm_uuid$Uuid$toString(policyId)
					]);
			}
		default:
			var cfid = page.a;
			return _List_fromArray(
				['offer-details', cfid]);
	}
};
var $author$project$Route$toString = function (page) {
	return '/' + A2(
		$elm$core$String$join,
		'/',
		$author$project$Route$routeToPieces(page));
};
var $author$project$Translations$languageToString = function (lang) {
	if (!lang) {
		return 'en';
	} else {
		return 'es';
	}
};
var $author$project$Route$toStringWithLanguageOverride = F2(
	function (language, page) {
		return '/' + ($author$project$Translations$languageToString(language) + ('/' + A2(
			$elm$core$String$join,
			'/',
			$author$project$Route$routeToPieces(page))));
	});
var $author$project$Effect$runEffect = F3(
	function (env, model, effect) {
		var _v0 = _Utils_Tuple2(model.o4, effect);
		_v0$15:
		while (true) {
			_v0$16:
			while (true) {
				_v0$17:
				while (true) {
					_v0$18:
					while (true) {
						_v0$19:
						while (true) {
							_v0$20:
							while (true) {
								_v0$21:
								while (true) {
									switch (_v0.b.$) {
										case 0:
											var _v1 = _v0.b;
											return $elm$core$Platform$Cmd$none;
										case 1:
											var effects = _v0.b.a;
											return $elm$core$Platform$Cmd$batch(
												A2(
													$elm$core$List$map,
													A2($author$project$Effect$runEffect, env, model),
													effects));
										case 2:
											var cmd = _v0.b.a;
											return cmd;
										case 3:
											var route = _v0.b.a;
											var fullRoute = function () {
												var _v2 = $author$project$Env$languageOverride(model.m8);
												if (!_v2.$) {
													var languageOverride = _v2.a;
													return A2($author$project$Route$toStringWithLanguageOverride, languageOverride, route);
												} else {
													return $author$project$Route$toString(route);
												}
											}();
											return A2($elm$browser$Browser$Navigation$pushUrl, model.hz, fullRoute);
										case 4:
											var pageNumber = _v0.b.a;
											return A2($elm$browser$Browser$Navigation$back, model.hz, pageNumber);
										case 6:
											var queryParams = _v0.b.a;
											return A2($elm$browser$Browser$Navigation$replaceUrl, model.hz, queryParams);
										case 5:
											var address = _v0.b.a;
											return $elm$browser$Browser$Navigation$load(address);
										case 10:
											var _v3 = _v0.b;
											return A3($author$project$Utils$executeLogout, env, $author$project$Env$newApiUrl, $author$project$Msg$GotLogoutResult);
										case 9:
											switch (_v0.a.$) {
												case 2:
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$Login,
														A2($author$project$Page$Login$Effect$runEffect, env, subEffect));
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 7:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													return A2($elm$core$Platform$Cmd$map, $author$project$Msg$NotFound, $author$project$Page$NotFound$Effect$runEffect);
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 8:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													return A2($elm$core$Platform$Cmd$map, $author$project$Msg$NotAuthorized, $author$project$Page$NotAuthorized$Effect$runEffect);
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 11:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$Search,
														A2($author$project$Page$Search$Effect$runEffect, env, subEffect));
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 12:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$Payment,
														A3($author$project$Page$Payment$Effect$runEffect, env, subModel, subEffect));
												case 5:
													break _v0$20;
												default:
													break _v0$21;
											}
										case 13:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													var subModel = _v0.a.a;
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$PolicyDetails,
														A3($author$project$Page$PolicyDetails$Effect$runEffect, env, subModel, subEffect));
												default:
													break _v0$21;
											}
										default:
											switch (_v0.a.$) {
												case 2:
													break _v0$15;
												case 0:
													break _v0$16;
												case 1:
													break _v0$17;
												case 3:
													break _v0$18;
												case 4:
													break _v0$19;
												case 5:
													break _v0$20;
												default:
													var subEffect = _v0.b.a;
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Msg$OfferDetails,
														A2($author$project$Page$OfferDetails$Effect$runEffect, env, subEffect));
											}
									}
								}
								return $elm$core$Platform$Cmd$none;
							}
							return $elm$core$Platform$Cmd$none;
						}
						return $elm$core$Platform$Cmd$none;
					}
					return $elm$core$Platform$Cmd$none;
				}
				return $elm$core$Platform$Cmd$none;
			}
			return $elm$core$Platform$Cmd$none;
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Common$User$Anonymous = {$: 0};
var $author$project$Common$User$Backoffice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Effect$ChangeRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Effect$Effects = function (a) {
	return {$: 1, a: a};
};
var $author$project$Effect$GoBack = function (a) {
	return {$: 4, a: a};
};
var $author$project$Effect$LoadExternalPage = function (a) {
	return {$: 5, a: a};
};
var $author$project$Effect$Login = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Login = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$Login = {$: 2};
var $author$project$Effect$Logout = {$: 10};
var $author$project$Effect$None = {$: 0};
var $author$project$Effect$NotAuthorized = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$NotAuthorized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Effect$NotFound = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$NotFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Effect$OfferDetails = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$OfferDetails = function (a) {
	return {$: 6, a: a};
};
var $author$project$Effect$Payment = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Payment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Effect$PolicyDetails = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$PolicyDetails = function (a) {
	return {$: 5, a: a};
};
var $author$project$Effect$RewriteUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Effect$Search = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Search = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$NotFound = {$: 0};
var $author$project$Route$NotAuthorized = {$: 1};
var $author$project$Route$OfferDetails = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$Payment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$PolicyDetails = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Route$Search = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$url$Url$Parser$fragment = function (toFrag) {
	return function (_v0) {
		var visited = _v0.bs;
		var unvisited = _v0.aV;
		var params = _v0.bi;
		var frag = _v0.a4;
		var value = _v0.pR;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					toFrag(frag)))
			]);
	};
};
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bs;
		var unvisited = _v0.aV;
		var params = _v0.bi;
		var frag = _v0.a4;
		var value = _v0.pR;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bs;
			var unvisited = _v1.aV;
			var params = _v1.bi;
			var frag = _v1.a4;
			var value = _v1.pR;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $author$project$Referer$PaymentPage = 0;
var $author$project$Referer$fromString = function (str) {
	if (str === 'payment-page') {
		return $elm$core$Result$Ok(0);
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$Route$parseRefererQueryParam = A2(
	$elm$url$Url$Parser$Query$custom,
	'referer',
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				A2($elm$core$Basics$composeR, $author$project$Referer$fromString, $elm$core$Result$toMaybe)),
			$elm_community$maybe_extra$Maybe$Extra$join)));
var $author$project$Page$Search$SearchQueryParam$Empty = {$: 3};
var $author$project$Page$Search$SearchQueryParam$CustomerFacingId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Search$SearchQueryParam$OfferId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Search$SearchQueryParam$PolicyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Search$SearchQueryParam$QuoteId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$SearchQueryParam$attemptIdentifyCustomerFacingId = function (value) {
	var _v0 = A2($elm$core$String$left, 1, value);
	switch (_v0) {
		case 'F':
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$OfferId(value));
		case 'P':
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$PolicyId(value));
		case 'Q':
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$QuoteId(value));
		default:
			return $elm$core$Result$Err(0);
	}
};
var $author$project$Page$Search$SearchQueryParam$fromStringToRegex = function (pattern) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString(pattern));
};
var $author$project$Page$Search$SearchQueryParam$NotRecognised = 0;
var $author$project$Page$Search$SearchQueryParam$inputRecogniser = F2(
	function (recognizer, value) {
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$always(0),
			recognizer(value));
	});
var $author$project$Page$Search$SearchQueryParam$cfIdRecogniser = function (value) {
	var pattern = '^[FPQ]\\d+$';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(pattern);
	var recogniser = function (cfid) {
		return A2($elm$regex$Regex$contains, regex, cfid) ? A2(
			$elm$core$Result$map,
			$author$project$Page$Search$SearchQueryParam$CustomerFacingId,
			$author$project$Page$Search$SearchQueryParam$attemptIdentifyCustomerFacingId(cfid)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$CustomerId = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Search$SearchQueryParam$customerIdRecogniser = function (value) {
	var recogniser = function (customerId) {
		return A2(
			$elm$core$Result$map,
			$author$project$Page$Search$SearchQueryParam$CustomerId,
			A2(
				$elm$core$Result$fromMaybe,
				0,
				$danyx23$elm_uuid$Uuid$fromString(customerId)));
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$PlateNumber = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Search$SearchQueryParam$defaultWhenNotRecognised = function (inputValue) {
	return $author$project$Page$Search$SearchQueryParam$PlateNumber(inputValue);
};
var $author$project$Page$Search$SearchQueryParam$DocumentId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Search$SearchQueryParam$dniRecogniser = function (value) {
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex('^[X,x,Y,y, Z,z, 0-9]*[0-9][a-zA-Z]$');
	var recogniser = function (dni) {
		return A2($elm$regex$Regex$contains, regex, dni) ? $elm$core$Result$Ok(
			$author$project$Page$Search$SearchQueryParam$DocumentId(dni)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$emptyStringRecogniser = function (value) {
	var recogniser = function (v) {
		return $elm$core$String$isEmpty(v) ? $elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $author$project$Page$Search$SearchQueryParam$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$SearchQueryParam$mailRecogniser = function (value) {
	var pattern = '^[a-z]?.*@';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(pattern);
	var recogniser = function (mail) {
		return A2($elm$regex$Regex$contains, regex, mail) ? $elm$core$Result$Ok(
			$author$project$Page$Search$SearchQueryParam$Email(mail)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $elm_community$result_extra$Result$Extra$or = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			return rb;
		} else {
			return ra;
		}
	});
var $author$project$Page$Search$SearchQueryParam$PhoneNumber = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Search$SearchQueryParam$phoneNumberRecogniser = function (value) {
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex('^[0-9]*[0-9]$');
	var recogniser = function (phone) {
		return A2($elm$regex$Regex$contains, regex, phone) ? $elm$core$Result$Ok(
			$author$project$Page$Search$SearchQueryParam$PhoneNumber(phone)) : $elm$core$Result$Err(0);
	};
	return A2($author$project$Page$Search$SearchQueryParam$inputRecogniser, recogniser, value);
};
var $elm_community$result_extra$Result$Extra$unwrap = F3(
	function (defaultValue, okFunc, result) {
		if (!result.$) {
			var ok = result.a;
			return okFunc(ok);
		} else {
			return defaultValue;
		}
	});
var $author$project$Page$Search$SearchQueryParam$fromUrlStringToSearchInput = function (inputValue) {
	return A3(
		$elm_community$result_extra$Result$Extra$unwrap,
		$author$project$Page$Search$SearchQueryParam$defaultWhenNotRecognised(inputValue),
		$elm$core$Basics$identity,
		A2(
			$elm_community$result_extra$Result$Extra$or,
			$author$project$Page$Search$SearchQueryParam$customerIdRecogniser(inputValue),
			A2(
				$elm_community$result_extra$Result$Extra$or,
				$author$project$Page$Search$SearchQueryParam$phoneNumberRecogniser(inputValue),
				A2(
					$elm_community$result_extra$Result$Extra$or,
					$author$project$Page$Search$SearchQueryParam$dniRecogniser(inputValue),
					A2(
						$elm_community$result_extra$Result$Extra$or,
						$author$project$Page$Search$SearchQueryParam$emptyStringRecogniser(inputValue),
						A2(
							$elm_community$result_extra$Result$Extra$or,
							$author$project$Page$Search$SearchQueryParam$cfIdRecogniser(inputValue),
							$author$project$Page$Search$SearchQueryParam$mailRecogniser(inputValue)))))));
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm_community$string_extra$String$Extra$firstResultHelp = F2(
	function (_default, list) {
		firstResultHelp:
		while (true) {
			if (!list.b) {
				return _default;
			} else {
				if (!list.a.$) {
					var a = list.a.a;
					return a;
				} else {
					var _v1 = list.a;
					var rest = list.b;
					var $temp$default = _default,
						$temp$list = rest;
					_default = $temp$default;
					list = $temp$list;
					continue firstResultHelp;
				}
			}
		}
	});
var $elm_community$string_extra$String$Extra$firstResult = function (list) {
	return A2($elm_community$string_extra$String$Extra$firstResultHelp, '', list);
};
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$regexEscape = A2(
	$elm$regex$Regex$replace,
	$elm_community$string_extra$String$Extra$regexFromString('[-/\\^$*+?.()|[\\]{}]'),
	function (_v0) {
		var match = _v0.de;
		return '\\' + match;
	});
var $elm_community$string_extra$String$Extra$rightOf = F2(
	function (pattern, string) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.l3;
					},
					$elm_community$string_extra$String$Extra$firstResult),
				A3(
					$elm$regex$Regex$findAtMost,
					1,
					$elm_community$string_extra$String$Extra$regexFromString(
						$elm_community$string_extra$String$Extra$regexEscape(pattern) + '(.*)$'),
					string)));
	});
var $author$project$Route$parseSearchFragment = function (fragment) {
	var searchString = A2(
		$elm_community$string_extra$String$Extra$rightOf,
		'search=',
		A2($elm$core$Maybe$withDefault, '', fragment));
	return $elm$core$String$isEmpty(searchString) ? $elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty) : $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$fromUrlStringToSearchInput(searchString));
};
var $author$project$Page$Search$SearchQueryParam$defaultSearchContext = 0;
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $author$project$Route$searchTabIndex = A2(
	$elm$url$Url$Parser$Query$map,
	$elm$core$Maybe$withDefault($author$project$Page$Search$SearchQueryParam$defaultSearchContext),
	$elm$url$Url$Parser$Query$int('tabIndex'));
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bs;
			var unvisited = _v0.aV;
			var params = _v0.bi;
			var frag = _v0.a4;
			var value = _v0.pR;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$uuid = A2($elm$url$Url$Parser$custom, 'uuid', $danyx23$elm_uuid$Uuid$fromString);
var $author$project$Route$parser = function () {
	var routeParser = $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Search,
				A2(
					$elm$url$Url$Parser$slash,
					A2($elm$url$Url$Parser$questionMark, $elm$url$Url$Parser$top, $author$project$Route$searchTabIndex),
					$elm$url$Url$Parser$fragment($author$project$Route$parseSearchFragment))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Payment,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payment'),
					$author$project$Route$uuid)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$Login,
				$elm$url$Url$Parser$s('login')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$NotAuthorized,
				$elm$url$Url$Parser$s('not-authorized')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$PolicyDetails,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('policy-details'),
					A2($elm$url$Url$Parser$questionMark, $author$project$Route$uuid, $author$project$Route$parseRefererQueryParam))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Route$OfferDetails,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('offer-details'),
					$elm$url$Url$Parser$string))
			]));
	var routeWithLanguage = A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$oneOf(
			_List_fromArray(
				[
					$elm$url$Url$Parser$s('es'),
					$elm$url$Url$Parser$s('en')
				])),
		routeParser);
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[routeParser, routeWithLanguage]));
}();
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$NotFound,
		A2($elm$url$Url$Parser$parse, $author$project$Route$parser, url));
};
var $author$project$Common$User$hasAnyPermissions = function (user) {
	if (!user.$) {
		return false;
	} else {
		var permissions = user.a.dk;
		return !$elm$core$List$isEmpty(permissions);
	}
};
var $author$project$Main$canAccess = F2(
	function (user, route) {
		switch (route.$) {
			case 2:
				return true;
			case 0:
				return true;
			case 1:
				return true;
			case 3:
				return $author$project$Common$User$hasAnyPermissions(user);
			case 4:
				return $author$project$Common$User$hasAnyPermissions(user);
			case 5:
				return $author$project$Common$User$hasAnyPermissions(user);
			default:
				return $author$project$Common$User$hasAnyPermissions(user);
		}
	});
var $author$project$Page$Login$Effect$CheckIfAuthed = {$: 1};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Page$Login$Model$init = F2(
	function (externalApiUrl, maybeTargetRoute) {
		var targetRoute = function () {
			if (maybeTargetRoute.$ === 1) {
				return A2(
					$author$project$Route$Search,
					$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
					$elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty));
			} else {
				if (maybeTargetRoute.a.$ === 2) {
					var _v1 = maybeTargetRoute.a;
					return A2(
						$author$project$Route$Search,
						$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
						$elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty));
				} else {
					var route = maybeTargetRoute.a;
					return route;
				}
			}
		}();
		return {mD: $krisajenkins$remotedata$RemoteData$Loading, cX: externalApiUrl, pH: targetRoute};
	});
var $author$project$Page$Login$init = F2(
	function (apiUrl, targetRoute) {
		return _Utils_Tuple2(
			A2($author$project$Page$Login$Model$init, apiUrl, targetRoute),
			$author$project$Page$Login$Effect$CheckIfAuthed);
	});
var $author$project$Page$NotAuthorized$Effect$None = 0;
var $author$project$Page$NotAuthorized$Model$init = {};
var $author$project$Page$NotAuthorized$init = _Utils_Tuple2($author$project$Page$NotAuthorized$Model$init, 0);
var $author$project$Page$NotFound$Effect$None = 0;
var $author$project$Page$NotFound$Model$init = {};
var $author$project$Page$NotFound$init = _Utils_Tuple2($author$project$Page$NotFound$Model$init, 0);
var $author$project$Page$OfferDetails$Effect$Effects = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$OfferDetails$Effect$FetchOffer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$OfferDetails$Effect$GetCurrentDate = {$: 9};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Page$OfferDetails$Msg$PortfolioMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$OfferDetails$Msg$ShowCoverPackagesModal = function (a) {
	return {$: 16, a: a};
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$init = function (id) {
	return {gs: $elm$core$Maybe$Nothing, gA: $elm$core$Maybe$Nothing, kv: id, g8: false, fq: $elm$core$Maybe$Nothing};
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$init = function (onClose) {
	return {
		b2: $author$project$Pyxis$Components$Modal$init('cover-packages-modal'),
		hU: onClose,
		ix: $elm$core$Maybe$Nothing
	};
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$Model = F4(
	function (popUp, isSendEmailSubmitted, sendEmailCheckBoxGroup, recipientEmail) {
		return {hb: isSendEmailSubmitted, iu: popUp, iB: recipientEmail, ck: sendEmailCheckBoxGroup};
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$FieldStatus$FieldStatus = F2(
	function (isBlurred, isDirty) {
		return {kE: isBlurred, nI: isDirty};
	});
var $author$project$Pyxis$Components$Field$FieldStatus$init = A2($author$project$Pyxis$Components$Field$FieldStatus$FieldStatus, false, false);
var $author$project$Pyxis$Components$Field$CheckboxGroup$init = {aB: _List_Nil, eB: $author$project$Pyxis$Components$Field$FieldStatus$init, hR: $elm$core$Maybe$Nothing, k$: $elm$core$Maybe$Nothing, h_: $elm$core$Maybe$Nothing};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$init = A4(
	$author$project$Common$ComponentUI$Modal$SendOfferEmail$Model,
	$author$project$Pyxis$Components$Modal$init('send-offer-email-modal'),
	false,
	$author$project$Pyxis$Components$Field$CheckboxGroup$init,
	'');
var $author$project$Common$Portfolio$Portfolio = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$init = {
	V: 0,
	e9: $elm$core$Maybe$Nothing,
	ic: $elm$core$Maybe$Nothing,
	b6: A3($elm$core$Dict$insert, 0, 1, $elm$core$Dict$empty),
	du: $elm$core$Maybe$Nothing
};
var $author$project$Common$Portfolio$init = F2(
	function (onShowIncludedCovers, tagger) {
		return {gw: $elm$core$Maybe$Nothing, gx: $elm$core$Maybe$Nothing, eK: $author$project$Pyxis$Components$Tabs$init, k1: $elm$core$Maybe$Nothing, li: onShowIncludedCovers, b7: $author$project$Pyxis$Components$Tabs$init, i$: tagger};
	});
var $author$project$Pyxis$Components$Toasts$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Toasts$init = {ei: 0, t: $elm$core$Dict$empty};
var $author$project$Page$OfferDetails$Model$init = {
	mw: $krisajenkins$remotedata$RemoteData$NotAsked,
	cM: $krisajenkins$remotedata$RemoteData$NotAsked,
	eh: $author$project$Pyxis$Components$Modal$init('legal-recording-disclaimer-modal'),
	ej: $author$project$Common$ComponentUI$Modal$CoverPackages$init(
		$author$project$Page$OfferDetails$Msg$ShowCoverPackagesModal(false)),
	jZ: $krisajenkins$remotedata$RemoteData$NotAsked,
	gj: $elm$core$Maybe$Nothing,
	gm: $krisajenkins$remotedata$RemoteData$NotAsked,
	au: $author$project$Pyxis$Components$Modal$init('great-lakes-opt-in-consent-modal-landing'),
	bQ: $author$project$Pyxis$Components$Modal$init('great-lakes-opt-in-consent-modal-purchase'),
	G: $krisajenkins$remotedata$RemoteData$Loading,
	lq: $krisajenkins$remotedata$RemoteData$NotAsked,
	dt: A2($author$project$Common$Portfolio$init, $author$project$Page$OfferDetails$Msg$ShowCoverPackagesModal, $author$project$Page$OfferDetails$Msg$PortfolioMsg),
	dA: $krisajenkins$remotedata$RemoteData$NotAsked,
	C: $author$project$Common$ComponentUI$Modal$SendOfferEmail$init,
	dE: $author$project$Pyxis$Components$Modal$init('start-recording-disclaimer-modal'),
	t: $author$project$Pyxis$Components$Toasts$init
};
var $author$project$Page$OfferDetails$init = function (offerCFID) {
	return _Utils_Tuple2(
		$author$project$Page$OfferDetails$Model$init,
		$author$project$Page$OfferDetails$Effect$Effects(
			_List_fromArray(
				[
					$author$project$Page$OfferDetails$Effect$FetchOffer(offerCFID),
					$author$project$Page$OfferDetails$Effect$GetCurrentDate
				])));
};
var $author$project$Page$Payment$Effect$Effects = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Payment$Effect$FetchBraintreeToken = {$: 4};
var $author$project$Page$Payment$Effect$FetchProducts = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Payment$Model$Initializing = 0;
var $author$project$Page$Payment$Model$initCreditCardField = function (id) {
	return {kv: id, eN: false, eS: true, bX: false};
};
var $author$project$Page$Payment$Model$initCreditCardFields = {
	cL: $author$project$Page$Payment$Model$initCreditCardField('credit-card-number'),
	cW: $author$project$Page$Payment$Model$initCreditCardField('credit-card-expiration-date')
};
var $author$project$Page$Payment$Model$init = function (offerId) {
	return {ea: $author$project$Page$Payment$Model$initCreditCardFields, gO: $krisajenkins$remotedata$RemoteData$NotAsked, gP: $krisajenkins$remotedata$RemoteData$NotAsked, gQ: $krisajenkins$remotedata$RemoteData$NotAsked, oi: offerId, ij: $elm$core$Maybe$Nothing, iR: 0};
};
var $author$project$Page$Payment$init = function (offerId) {
	return _Utils_Tuple2(
		$author$project$Page$Payment$Model$init(offerId),
		$author$project$Page$Payment$Effect$Effects(
			_List_fromArray(
				[
					$author$project$Page$Payment$Effect$FetchBraintreeToken,
					$author$project$Page$Payment$Effect$FetchProducts(offerId)
				])));
};
var $author$project$Page$PolicyDetails$Effect$Effects = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchPolicy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$Effect$GetCurrentTime = {$: 8};
var $author$project$Page$PolicyDetails$Effect$RequestIssueRefundReleaseData = {$: 17};
var $author$project$Page$PolicyDetails$Msg$ChangeEmailModalMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ChangeEmailSubmitted = function (a) {
	return {$: 48, a: a};
};
var $author$project$Page$PolicyDetails$Msg$PortfolioMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Page$PolicyDetails$Msg$SendEmailConfirmed = function (a) {
	return {$: 43, a: a};
};
var $author$project$Page$PolicyDetails$Msg$SendEmailModalMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ShowCoverPackagesModal = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Closed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$ChangeEmailModal$ResetSubmission = {$: 4};
var $author$project$Pyxis$Components$Field$Input$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Input$init = {eB: $author$project$Pyxis$Components$Field$FieldStatus$init, hR: $elm$core$Maybe$Nothing, h_: $elm$core$Maybe$Nothing, h0: $elm$core$Maybe$Nothing, h4: $elm$core$Maybe$Nothing, pR: ''};
var $author$project$Pyxis$Components$Field$Input$setOnFocus = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				h_: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$init = F2(
	function (tagger, onConfirm) {
		return {
			a3: A2(
				$author$project$Pyxis$Components$Field$Input$setOnFocus,
				tagger($author$project$Page$PolicyDetails$ChangeEmailModal$ResetSubmission),
				$author$project$Pyxis$Components$Field$Input$init),
			c5: false,
			k0: onConfirm,
			i$: tagger,
			cx: $author$project$Page$PolicyDetails$ChangeEmailModal$Closed(
				$author$project$Pyxis$Components$Modal$init(''))
		};
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$DateInput$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$DateInput$init = {eB: $author$project$Pyxis$Components$Field$FieldStatus$init, hR: $elm$core$Maybe$Nothing, h_: $elm$core$Maybe$Nothing, h0: $elm$core$Maybe$Nothing, pR: ''};
var $author$project$Pyxis$Components$Field$Textarea$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Textarea$init = {eB: $author$project$Pyxis$Components$Field$FieldStatus$init, hR: $elm$core$Maybe$Nothing, h_: $elm$core$Maybe$Nothing, h0: $elm$core$Maybe$Nothing, pR: ''};
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonConfirmed = {$: 14};
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonReset = {$: 15};
var $author$project$Pyxis$Components$Field$Autocomplete$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$Basics$ternaryOperator = F3(
	function (condition, functionOnTrue, functionOnFalse) {
		return condition ? functionOnTrue : functionOnFalse;
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getFilterFunction = F4(
	function (isCaseSensitive, isStartWith, filteringValue, value) {
		var filterFunction = A3($author$project$Pyxis$Commons$Basics$ternaryOperator, isStartWith, $elm$core$String$startsWith, $elm$core$String$contains);
		var convertForCaseSensitive = A3($author$project$Pyxis$Commons$Basics$ternaryOperator, isCaseSensitive, $elm$core$Basics$identity, $elm$core$String$toLower);
		return A2(
			filterFunction,
			convertForCaseSensitive(filteringValue),
			convertForCaseSensitive(value));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$init = {
	J: $elm$core$Maybe$Nothing,
	eB: $author$project$Pyxis$Components$Field$FieldStatus$init,
	bN: A2($author$project$Pyxis$Components$Field$Autocomplete$getFilterFunction, false, true),
	F: '',
	eG: false,
	a7: false,
	bV: false,
	hR: $elm$core$Maybe$Nothing,
	h_: $elm$core$Maybe$Nothing,
	h$: $elm$core$Maybe$Nothing,
	h0: $elm$core$Maybe$Nothing,
	ib: $elm$core$Maybe$Nothing,
	e8: $elm$core$Maybe$Nothing,
	fn: $elm$core$Maybe$Nothing,
	pR: $elm$core$Maybe$Nothing,
	ax: $krisajenkins$remotedata$RemoteData$NotAsked
};
var $author$project$Pyxis$Components$Field$Autocomplete$setFilterStrategyContains = F2(
	function (isCaseSensitive, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				bN: A2($author$project$Pyxis$Components$Field$Autocomplete$getFilterFunction, isCaseSensitive, false)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setOnReset = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ib: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setOnSelect = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				e8: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$initReasonInput = A2(
	$author$project$Pyxis$Components$Field$Autocomplete$setOnReset,
	$author$project$Page$PolicyDetails$Msg$InterruptionReasonReset,
	A2(
		$author$project$Pyxis$Components$Field$Autocomplete$setOnSelect,
		$author$project$Page$PolicyDetails$Msg$InterruptionReasonConfirmed,
		A2($author$project$Pyxis$Components$Field$Autocomplete$setFilterStrategyContains, false, $author$project$Pyxis$Components$Field$Autocomplete$init)));
var $author$project$Page$PolicyDetails$InterruptionModal$Model$init = {
	aE: $author$project$Pyxis$Components$Field$Textarea$init,
	nc: $krisajenkins$remotedata$RemoteData$NotAsked,
	aL: $author$project$Pyxis$Components$Field$DateInput$init,
	av: $elm$core$Maybe$Nothing,
	hI: $elm$core$Maybe$Nothing,
	l: $elm$core$Maybe$Nothing,
	aQ: $author$project$Page$PolicyDetails$InterruptionModal$Model$initReasonInput,
	cx: $author$project$Pyxis$Components$Modal$init('policy-interruption-modal')
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$RefundIssuingModal$init = {
	pk: $elm$core$Maybe$Nothing,
	cx: $author$project$Pyxis$Components$Modal$init('policy-refund-modal')
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$Model = $elm$core$Basics$identity;
var $author$project$Common$ReasonDescriptionStatus$NotSet = 3;
var $author$project$Page$PolicyDetails$RenewalCancellationModal$initReasonInput = A2($author$project$Pyxis$Components$Field$Autocomplete$setFilterStrategyContains, false, $author$project$Pyxis$Components$Field$Autocomplete$init);
var $author$project$Page$PolicyDetails$RenewalCancellationModal$init = {
	mt: $elm$core$Maybe$Nothing,
	aE: $author$project$Pyxis$Components$Field$Textarea$init,
	bJ: 3,
	l: $elm$core$Maybe$Nothing,
	aQ: $author$project$Page$PolicyDetails$RenewalCancellationModal$initReasonInput,
	fo: $elm$core$Maybe$Nothing,
	cx: $author$project$Pyxis$Components$Modal$init('renewal-cancellation-modal')
};
var $author$project$Page$PolicyDetails$SendEmailModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$SendEmailModal$OptionChecked = {$: 3};
var $author$project$Pyxis$Components$Field$CheckboxGroup$setOnCheck = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				k$: $elm$core$Maybe$Just(msg)
			});
	});
var $author$project$Page$PolicyDetails$SendEmailModal$init = F3(
	function (policyId, confirmMsg, tagger) {
		return {
			a$: A2(
				$author$project$Pyxis$Components$Field$CheckboxGroup$setOnCheck,
				tagger($author$project$Page$PolicyDetails$SendEmailModal$OptionChecked),
				$author$project$Pyxis$Components$Field$CheckboxGroup$init),
			jS: confirmMsg(policyId),
			gy: $elm$core$Maybe$Nothing,
			c5: false,
			o6: policyId,
			i$: tagger,
			cx: $author$project$Pyxis$Components$Modal$init('policy-email-send-modal')
		};
	});
var $author$project$Page$PolicyDetails$Model$init = F2(
	function (referer, policyId) {
		return {
			W: $elm$core$Maybe$Nothing,
			bD: A2($author$project$Page$PolicyDetails$ChangeEmailModal$init, $author$project$Page$PolicyDetails$Msg$ChangeEmailModalMsg, $author$project$Page$PolicyDetails$Msg$ChangeEmailSubmitted),
			cM: $krisajenkins$remotedata$RemoteData$NotAsked,
			ej: $author$project$Common$ComponentUI$Modal$CoverPackages$init(
				$author$project$Page$PolicyDetails$Msg$ShowCoverPackagesModal(false)),
			jZ: $krisajenkins$remotedata$RemoteData$NotAsked,
			j_: $krisajenkins$remotedata$RemoteData$NotAsked,
			gk: $elm$core$Maybe$Nothing,
			gm: $krisajenkins$remotedata$RemoteData$NotAsked,
			q: $author$project$Page$PolicyDetails$InterruptionModal$Model$init,
			nJ: $elm$core$Maybe$Nothing,
			lq: $krisajenkins$remotedata$RemoteData$NotAsked,
			lr: $author$project$Pyxis$Components$Tabs$init,
			l: $krisajenkins$remotedata$RemoteData$Loading,
			o6: policyId,
			dt: A2($author$project$Common$Portfolio$init, $author$project$Page$PolicyDetails$Msg$ShowCoverPackagesModal, $author$project$Page$PolicyDetails$Msg$PortfolioMsg),
			pi: referer,
			pk: $krisajenkins$remotedata$RemoteData$NotAsked,
			cg: $author$project$Page$PolicyDetails$RefundIssuingModal$init,
			ap: $author$project$Page$PolicyDetails$RenewalCancellationModal$init,
			cl: A3($author$project$Page$PolicyDetails$SendEmailModal$init, policyId, $author$project$Page$PolicyDetails$Msg$SendEmailConfirmed, $author$project$Page$PolicyDetails$Msg$SendEmailModalMsg),
			fp: $krisajenkins$remotedata$RemoteData$NotAsked,
			t: $author$project$Pyxis$Components$Toasts$init
		};
	});
var $author$project$Page$PolicyDetails$init = F2(
	function (referer, policyId) {
		return _Utils_Tuple2(
			A2($author$project$Page$PolicyDetails$Model$init, referer, policyId),
			$author$project$Page$PolicyDetails$Effect$Effects(
				_List_fromArray(
					[
						$author$project$Page$PolicyDetails$Effect$FetchPolicy(policyId),
						$author$project$Page$PolicyDetails$Effect$GetCurrentTime,
						$author$project$Page$PolicyDetails$Effect$RequestIssueRefundReleaseData
					])));
	});
var $author$project$Page$Search$Effect$Effects = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Search$Effect$FetchNewResults = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Search$Effect$GetCurrentDate = {$: 5};
var $author$project$Page$Search$Msg$NoOp = {$: 13};
var $author$project$Page$Search$Effect$None = {$: 0};
var $author$project$Page$Search$Effect$WithCmd = function (a) {
	return {$: 3, a: a};
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Page$Search$Model$init = {
	fQ: $author$project$Pyxis$Components$Tabs$init,
	eh: $author$project$Pyxis$Components$Modal$init('legal-recording-disclaimer-modal'),
	gj: $elm$core$Maybe$Nothing,
	gR: $author$project$Pyxis$Components$Modal$init('great-lakes-opt-in-consent-modal'),
	g9: false,
	eT: false,
	kK: $krisajenkins$remotedata$RemoteData$NotAsked,
	kX: $krisajenkins$remotedata$RemoteData$NotAsked,
	ik: $author$project$Pyxis$Components$Field$Input$init,
	lp: 'payment-disputes',
	dA: $krisajenkins$remotedata$RemoteData$NotAsked,
	dB: $author$project$Pyxis$Components$Field$Input$init,
	lL: 'personal-id-number',
	bo: $elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty),
	lT: $elm$core$Maybe$Nothing,
	dE: $author$project$Pyxis$Components$Modal$init('stop-recording-disclaimer-modal'),
	t: $author$project$Pyxis$Components$Toasts$init
};
var $author$project$Pyxis$Components$Tabs$setActiveTabIndex = F2(
	function (index, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				V: index,
				b6: A3(
					$elm$core$Dict$insert,
					index,
					1 + A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Dict$get, index, modelData.b6)),
					modelData.b6),
				du: $elm$core$Maybe$Just(modelData.V)
			});
	});
var $author$project$Page$Search$Model$setAdminSearchBarTab = F2(
	function (tabIndex, model) {
		return _Utils_update(
			model,
			{
				fQ: A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, tabIndex, model.fQ)
			});
	});
var $author$project$Page$Search$Model$setAdminSearchBarToDisputes = $author$project$Page$Search$Model$setAdminSearchBarTab(1);
var $author$project$Page$Search$Model$setAdminSearchBarToInquiries = $author$project$Page$Search$Model$setAdminSearchBarTab(0);
var $author$project$Pyxis$Components$Field$Input$setValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{pR: value});
	});
var $author$project$Page$Search$Model$setPaymentDisputeSearch = F2(
	function (searchTerm, model) {
		return _Utils_update(
			model,
			{
				ik: A2($author$project$Pyxis$Components$Field$Input$setValue, searchTerm, $author$project$Pyxis$Components$Field$Input$init)
			});
	});
var $author$project$Page$Search$Model$setRemoteDataLoading = function (model) {
	return _Utils_update(
		model,
		{kX: $krisajenkins$remotedata$RemoteData$Loading});
};
var $author$project$Page$Search$Model$setSearchInputField = F2(
	function (searchTerm, model) {
		return _Utils_update(
			model,
			{
				dB: A2($author$project$Pyxis$Components$Field$Input$setValue, searchTerm, $author$project$Pyxis$Components$Field$Input$init)
			});
	});
var $author$project$Page$Search$init = F2(
	function (tabIndex, searchQuery) {
		var initialModel = $author$project$Page$Search$Model$init;
		var searchModel = function () {
			if (!searchQuery.$) {
				switch (searchQuery.a.$) {
					case 3:
						var _v3 = searchQuery.a;
						return initialModel;
					case 0:
						var documentId = searchQuery.a.a;
						return $author$project$Page$Search$Model$setRemoteDataLoading(
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									documentId,
									_Utils_update(
										initialModel,
										{bo: searchQuery}))));
					case 1:
						var customerFacingId = searchQuery.a.a;
						return $author$project$Page$Search$Model$setRemoteDataLoading(
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									$author$project$Page$Search$SearchQueryParam$pickCustomerFacingId(customerFacingId),
									_Utils_update(
										initialModel,
										{bo: searchQuery}))));
					case 2:
						var email = searchQuery.a.a;
						return $author$project$Page$Search$Model$setRemoteDataLoading(
							A2(
								$author$project$Page$Search$Model$setAdminSearchBarTab,
								tabIndex,
								A2(
									$author$project$Page$Search$Model$setPaymentDisputeSearch,
									email,
									A2(
										$author$project$Page$Search$Model$setSearchInputField,
										email,
										_Utils_update(
											initialModel,
											{bo: searchQuery})))));
					case 4:
						var plateNumber = searchQuery.a.a;
						return $author$project$Page$Search$Model$setRemoteDataLoading(
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									plateNumber,
									_Utils_update(
										initialModel,
										{bo: searchQuery}))));
					case 5:
						var phoneNumber = searchQuery.a.a;
						return $author$project$Page$Search$Model$setRemoteDataLoading(
							$author$project$Page$Search$Model$setAdminSearchBarToInquiries(
								A2(
									$author$project$Page$Search$Model$setSearchInputField,
									phoneNumber,
									_Utils_update(
										initialModel,
										{bo: searchQuery}))));
					default:
						var id = searchQuery.a.a;
						return $author$project$Page$Search$Model$setRemoteDataLoading(
							$author$project$Page$Search$Model$setAdminSearchBarToDisputes(
								A2(
									$author$project$Page$Search$Model$setPaymentDisputeSearch,
									$danyx23$elm_uuid$Uuid$toString(id),
									_Utils_update(
										initialModel,
										{bo: searchQuery}))));
				}
			} else {
				return _Utils_update(
					initialModel,
					{bo: searchQuery});
			}
		}();
		var additionalEffect = function () {
			if (!searchQuery.$) {
				if (searchQuery.a.$ === 3) {
					var _v1 = searchQuery.a;
					return $author$project$Page$Search$Effect$WithCmd(
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Page$Search$Msg$NoOp),
							$elm$browser$Browser$Dom$focus(initialModel.lL)));
				} else {
					var searchInputString = searchQuery.a;
					return $author$project$Page$Search$Effect$FetchNewResults(searchInputString);
				}
			} else {
				return $author$project$Page$Search$Effect$None;
			}
		}();
		return _Utils_Tuple2(
			searchModel,
			$author$project$Page$Search$Effect$Effects(
				_List_fromArray(
					[additionalEffect, $author$project$Page$Search$Effect$GetCurrentDate])));
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Main$initPage = F2(
	function (env, route) {
		switch (route.$) {
			case 0:
				return A3($elm$core$Tuple$mapBoth, $author$project$Model$NotFound, $author$project$Effect$NotFound, $author$project$Page$NotFound$init);
			case 1:
				return A3($elm$core$Tuple$mapBoth, $author$project$Model$NotAuthorized, $author$project$Effect$NotAuthorized, $author$project$Page$NotAuthorized$init);
			case 2:
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$Login,
					$author$project$Effect$Login,
					A2(
						$author$project$Page$Login$init,
						$author$project$Env$newApiUrl(env),
						$elm$core$Maybe$Nothing));
			case 3:
				var tabIndex = route.a;
				var searchQuery = route.b;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$Search,
					$author$project$Effect$Search,
					A2($author$project$Page$Search$init, tabIndex, searchQuery));
			case 4:
				var offerId = route.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$Payment,
					$author$project$Effect$Payment,
					$author$project$Page$Payment$init(offerId));
			case 5:
				var policyId = route.a;
				var referer = route.b;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$PolicyDetails,
					$author$project$Effect$PolicyDetails,
					A2($author$project$Page$PolicyDetails$init, referer, policyId));
			default:
				var cfid = route.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Model$OfferDetails,
					$author$project$Effect$OfferDetails,
					$author$project$Page$OfferDetails$init(cfid));
		}
	});
var $author$project$Common$User$isBackoffice = function (user) {
	if (!user.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Main$onRouteChange = F2(
	function (model, route) {
		if (A2($author$project$Main$canAccess, model.fG, route)) {
			var _v0 = A2($author$project$Main$initPage, model.m8, route);
			var pageModel = _v0.a;
			var effect = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{o4: pageModel}),
				effect);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Common$User$isBackoffice(model.fG) ? $author$project$Effect$ChangeRoute($author$project$Route$NotAuthorized) : $author$project$Effect$ChangeRoute($author$project$Route$Login));
		}
	});
var $author$project$Page$Login$Effect$None = {$: 0};
var $author$project$Page$Login$Effect$TryRouteUserTo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Login$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var result = msg.a;
			switch (result.$) {
				case 3:
					var user = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Page$Login$Effect$TryRouteUserTo(
							_Utils_Tuple2(user, model.pH)));
				case 2:
					var failure = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								mD: $krisajenkins$remotedata$RemoteData$Failure(failure)
							}),
						$author$project$Page$Login$Effect$None);
				default:
					return _Utils_Tuple2(model, $author$project$Page$Login$Effect$None);
			}
		} else {
			return _Utils_Tuple2(model, $author$project$Page$Login$Effect$None);
		}
	});
var $author$project$Page$NotAuthorized$update = function (model) {
	return _Utils_Tuple2(model, 0);
};
var $author$project$Page$NotFound$update = function (model) {
	return _Utils_Tuple2(model, 0);
};
var $author$project$Page$OfferDetails$Effect$AmendOfferCoverageEffectiveDate = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Effect$ChangeRoute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$OfferDetails$Effect$FetchPaymentMethod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$OfferDetails$Effect$FetchPricingActionClaimHistory = function (a) {
	return {$: 4, a: a};
};
var $author$project$ExternalUrl$FunnelOffer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Effect$None = {$: 14};
var $author$project$Page$OfferDetails$Effect$SaveGreatLakesOptInConsent = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Effect$SendOfferEmail = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$OfferDetails$Effect$TrackSendEmail = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$OfferDetails$Effect$WithCmd = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pyxis$Components$Toasts$Add = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$deletingTimed = function (timed) {
	switch (timed.$) {
		case 0:
			var wrappedEl = timed.b;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		case 1:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		case 2:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		default:
			var wrappedEl = timed.b;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
	}
};
var $author$project$Pyxis$Components$Toasts$updateModelDeletingToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				t: A3(
					$elm$core$Dict$update,
					toastUUID,
					$elm$core$Maybe$map($author$project$Pyxis$Components$Toasts$ToastsHelpers$deletingTimed),
					model.t)
			});
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds = 500;
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$pausingTimed = function (timed) {
	switch (timed.$) {
		case 0:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, visibilityTime, wrappedEl);
		case 1:
			var wrappedEl = timed.a;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds, wrappedEl);
		case 2:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle(wrappedEl);
		default:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, visibilityTime, wrappedEl);
	}
};
var $author$project$Pyxis$Components$Toasts$updateModelPausedToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				t: A3(
					$elm$core$Dict$update,
					toastUUID,
					$elm$core$Maybe$map($author$project$Pyxis$Components$Toasts$ToastsHelpers$pausingTimed),
					model.t)
			});
	});
var $author$project$Pyxis$Components$Toasts$updateModelRemoveToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				t: A2($elm$core$Dict$remove, toastUUID, model.t)
			});
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$Running = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$resumingTimed = function (timed) {
	switch (timed.$) {
		case 3:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return _Utils_eq(visibilityTime, $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds) ? $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl) : A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Running, visibilityTime, wrappedEl);
		case 1:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedEl);
		case 2:
			var wrappedEl = timed.a;
			return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle(wrappedEl);
		default:
			var visibilityTime = timed.a;
			var wrappedEl = timed.b;
			return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Running, visibilityTime, wrappedEl);
	}
};
var $author$project$Pyxis$Components$Toasts$updateModelResumeToast = F2(
	function (toastUUID, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				t: A3(
					$elm$core$Dict$update,
					toastUUID,
					$elm$core$Maybe$map($author$project$Pyxis$Components$Toasts$ToastsHelpers$resumingTimed),
					model.t)
			});
	});
var $author$project$Pyxis$Components$Toasts$updateModelWithIncreasedCounter = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{ei: model.ei + 1});
};
var $primait$prima_elm_extra$PrimaFunction$flip = F3(
	function (mapper, b, a) {
		return A2(mapper, a, b);
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $TSFoster$elm_uuid$UUID$UUID = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $TSFoster$elm_uuid$UUID$encoder = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, a),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, b),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, c),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, d)
			]));
};
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $TSFoster$elm_sha1$SHA1$loopHelp = F2(
	function (step, _v0) {
		var n = _v0.a;
		var state = _v0.b;
		return (n > 0) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(n - 1, _new));
			},
			step(state)) : $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(state));
	});
var $TSFoster$elm_sha1$SHA1$iterate = F3(
	function (n, step, initial) {
		return A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(n, initial),
			$TSFoster$elm_sha1$SHA1$loopHelp(step));
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $elm$bytes$Bytes$width = _Bytes_width;
var $TSFoster$elm_sha1$SHA1$padBuffer = function (bytes) {
	var byteCount = $elm$bytes$Bytes$width(bytes);
	var paddingSize = 4 + A2(
		$elm$core$Basics$modBy,
		64,
		56 - A2($elm$core$Basics$modBy, 64, byteCount + 1));
	var message = $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$bytes(bytes),
					$elm$bytes$Bytes$Encode$unsignedInt8(128),
					$elm$bytes$Bytes$Encode$sequence(
					A2(
						$elm$core$List$repeat,
						paddingSize,
						$elm$bytes$Bytes$Encode$unsignedInt8(0))),
					A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, byteCount << 3)
				])));
	return message;
};
var $elm$bytes$Bytes$Decode$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		return F2(
			function (bites, offset) {
				var _v4 = A2(decodeA, bites, offset);
				var aOffset = _v4.a;
				var a = _v4.b;
				var _v5 = A2(decodeB, bites, aOffset);
				var bOffset = _v5.a;
				var b = _v5.b;
				var _v6 = A2(decodeC, bites, bOffset);
				var cOffset = _v6.a;
				var c = _v6.b;
				var _v7 = A2(decodeD, bites, cOffset);
				var dOffset = _v7.a;
				var d = _v7.b;
				return _Utils_Tuple2(
					dOffset,
					A4(func, a, b, c, d));
			});
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $TSFoster$elm_sha1$SHA1$map16 = function (f) {
	return function (b1) {
		return function (b2) {
			return function (b3) {
				return function (b4) {
					return function (b5) {
						return function (b6) {
							return function (b7) {
								return function (b8) {
									return function (b9) {
										return function (b10) {
											return function (b11) {
												return function (b12) {
													return function (b13) {
														return function (b14) {
															return function (b15) {
																return function (b16) {
																	var d1 = A5(
																		$elm$bytes$Bytes$Decode$map4,
																		F4(
																			function (a, b, c, d) {
																				return A4(f, a, b, c, d);
																			}),
																		b1,
																		b2,
																		b3,
																		b4);
																	var d2 = A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (h, a, b, c, d) {
																				return A4(h, a, b, c, d);
																			}),
																		d1,
																		b5,
																		b6,
																		b7,
																		b8);
																	var d3 = A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (h, a, b, c, d) {
																				return A4(h, a, b, c, d);
																			}),
																		d2,
																		b9,
																		b10,
																		b11,
																		b12);
																	var d4 = A6(
																		$elm$bytes$Bytes$Decode$map5,
																		F5(
																			function (h, a, b, c, d) {
																				return A4(h, a, b, c, d);
																			}),
																		d3,
																		b13,
																		b14,
																		b15,
																		b16);
																	return d4;
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $TSFoster$elm_sha1$SHA1$DeltaState = $elm$core$Basics$identity;
var $TSFoster$elm_sha1$SHA1$State = $elm$core$Basics$identity;
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $TSFoster$elm_sha1$SHA1$rotateLeftBy = F2(
	function (amount, i) {
		return ((i >>> (32 - amount)) | (i << amount)) >>> 0;
	});
var $TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk = F3(
	function (index, _int, _v0) {
		var a = _v0.dY;
		var b = _v0.mE;
		var c = _v0.d9;
		var d = _v0.eo;
		var e = _v0.P;
		var shiftedA = (a >>> (32 - 5)) | (a << 5);
		var f = function () {
			var _v1 = (index / 20) | 0;
			switch (_v1) {
				case 0:
					return ((b & c) | ((~b) & d)) + 1518500249;
				case 1:
					return (b ^ (c ^ d)) + 1859775393;
				case 2:
					return ((b & (c | d)) | (c & d)) + 2400959708;
				default:
					return (b ^ (c ^ d)) + 3395469782;
			}
		}();
		var newA = (((shiftedA + f) + e) + _int) >>> 0;
		return {
			dY: newA,
			mE: a,
			d9: A2($TSFoster$elm_sha1$SHA1$rotateLeftBy, 30, b),
			eo: c,
			P: d
		};
	});
var $TSFoster$elm_sha1$SHA1$calculateDigestDeltas = function (remaining) {
	return function (index) {
		return function (a) {
			return function (b) {
				return function (c) {
					return function (d) {
						return function (e) {
							return function (v1) {
								return function (v2) {
									return function (v3) {
										return function (v4) {
											return function (v5) {
												return function (v6) {
													return function (v7) {
														return function (v8) {
															calculateDigestDeltas:
															while (true) {
																if (!remaining) {
																	return {dY: a, mE: b, d9: c, eo: d, P: e};
																} else {
																	var shiftedA = (a >>> (32 - 5)) | (a << 5);
																	var _int = v1;
																	var f = function () {
																		var _v0 = (index / 20) | 0;
																		switch (_v0) {
																			case 0:
																				return ((b & c) | ((~b) & d)) + 1518500249;
																			case 1:
																				return (b ^ (c ^ d)) + 1859775393;
																			case 2:
																				return ((b & (c | d)) | (c & d)) + 2400959708;
																			default:
																				return (b ^ (c ^ d)) + 3395469782;
																		}
																	}();
																	var newA = (((shiftedA + f) + e) + _int) >>> 0;
																	var $temp$remaining = remaining - 1,
																		$temp$index = index + 1,
																		$temp$a = newA,
																		$temp$b = a,
																		$temp$c = A2($TSFoster$elm_sha1$SHA1$rotateLeftBy, 30, b),
																		$temp$d = c,
																		$temp$e = d,
																		$temp$v1 = v2,
																		$temp$v2 = v3,
																		$temp$v3 = v4,
																		$temp$v4 = v5,
																		$temp$v5 = v6,
																		$temp$v6 = v7,
																		$temp$v7 = v8,
																		$temp$v8 = 0;
																	remaining = $temp$remaining;
																	index = $temp$index;
																	a = $temp$a;
																	b = $temp$b;
																	c = $temp$c;
																	d = $temp$d;
																	e = $temp$e;
																	v1 = $temp$v1;
																	v2 = $temp$v2;
																	v3 = $temp$v3;
																	v4 = $temp$v4;
																	v5 = $temp$v5;
																	v6 = $temp$v6;
																	v7 = $temp$v7;
																	v8 = $temp$v8;
																	continue calculateDigestDeltas;
																}
															}
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $TSFoster$elm_sha1$SHA1$rotateLeftBy1 = function (i) {
	return (i >>> 31) | (i << 1);
};
var $TSFoster$elm_sha1$SHA1$reduceWords = function (i) {
	return function (deltaState) {
		return function (b16) {
			return function (b15) {
				return function (b14) {
					return function (b13) {
						return function (b12) {
							return function (b11) {
								return function (b10) {
									return function (b9) {
										return function (b8) {
											return function (b7) {
												return function (b6) {
													return function (b5) {
														return function (b4) {
															return function (b3) {
																return function (b2) {
																	return function (b1) {
																		reduceWords:
																		while (true) {
																			var a = deltaState.dY;
																			var b = deltaState.mE;
																			var c = deltaState.d9;
																			var d = deltaState.eo;
																			var e = deltaState.P;
																			if (i !== 64) {
																				var value3 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b14 ^ (b12 ^ (b6 ^ b1)));
																				var value6 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b11 ^ (b9 ^ (b3 ^ value3)));
																				var value2 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b15 ^ (b13 ^ (b7 ^ b2)));
																				var value5 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b12 ^ (b10 ^ (b4 ^ value2)));
																				var value8 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b9 ^ (b7 ^ (b1 ^ value5)));
																				var value1 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b16 ^ (b14 ^ (b8 ^ b3)));
																				var value4 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b13 ^ (b11 ^ (b5 ^ value1)));
																				var value7 = $TSFoster$elm_sha1$SHA1$rotateLeftBy1(b10 ^ (b8 ^ (b2 ^ value4)));
																				var newState = $TSFoster$elm_sha1$SHA1$calculateDigestDeltas(8)(i + 16)(a)(b)(c)(d)(e)(value1)(value2)(value3)(value4)(value5)(value6)(value7)(value8);
																				var $temp$i = i + 8,
																					$temp$deltaState = newState,
																					$temp$b16 = b8,
																					$temp$b15 = b7,
																					$temp$b14 = b6,
																					$temp$b13 = b5,
																					$temp$b12 = b4,
																					$temp$b11 = b3,
																					$temp$b10 = b2,
																					$temp$b9 = b1,
																					$temp$b8 = value1,
																					$temp$b7 = value2,
																					$temp$b6 = value3,
																					$temp$b5 = value4,
																					$temp$b4 = value5,
																					$temp$b3 = value6,
																					$temp$b2 = value7,
																					$temp$b1 = value8;
																				i = $temp$i;
																				deltaState = $temp$deltaState;
																				b16 = $temp$b16;
																				b15 = $temp$b15;
																				b14 = $temp$b14;
																				b13 = $temp$b13;
																				b12 = $temp$b12;
																				b11 = $temp$b11;
																				b10 = $temp$b10;
																				b9 = $temp$b9;
																				b8 = $temp$b8;
																				b7 = $temp$b7;
																				b6 = $temp$b6;
																				b5 = $temp$b5;
																				b4 = $temp$b4;
																				b3 = $temp$b3;
																				b2 = $temp$b2;
																				b1 = $temp$b1;
																				continue reduceWords;
																			} else {
																				return deltaState;
																			}
																		}
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $TSFoster$elm_sha1$SHA1$reduceChunkHelp = function (_v0) {
	return function (b1) {
		return function (b2) {
			return function (b3) {
				return function (b4) {
					return function (b5) {
						return function (b6) {
							return function (b7) {
								return function (b8) {
									return function (b9) {
										return function (b10) {
											return function (b11) {
												return function (b12) {
													return function (b13) {
														return function (b14) {
															return function (b15) {
																return function (b16) {
																	var initial = _v0;
																	var initialDeltaState = A3(
																		$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																		15,
																		b16,
																		A3(
																			$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																			14,
																			b15,
																			A3(
																				$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																				13,
																				b14,
																				A3(
																					$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																					12,
																					b13,
																					A3(
																						$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																						11,
																						b12,
																						A3(
																							$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																							10,
																							b11,
																							A3(
																								$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																								9,
																								b10,
																								A3(
																									$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																									8,
																									b9,
																									A3(
																										$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																										7,
																										b8,
																										A3(
																											$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																											6,
																											b7,
																											A3(
																												$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																												5,
																												b6,
																												A3(
																													$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																													4,
																													b5,
																													A3(
																														$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																														3,
																														b4,
																														A3(
																															$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																															2,
																															b3,
																															A3(
																																$TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk,
																																1,
																																b2,
																																A3($TSFoster$elm_sha1$SHA1$calculateDigestDeltasChunk, 0, b1, initial))))))))))))))));
																	var _v1 = $TSFoster$elm_sha1$SHA1$reduceWords(0)(initialDeltaState)(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10)(b11)(b12)(b13)(b14)(b15)(b16);
																	var a = _v1.dY;
																	var b = _v1.mE;
																	var c = _v1.d9;
																	var d = _v1.eo;
																	var e = _v1.P;
																	return {dY: initial.dY + a, mE: initial.mE + b, d9: initial.d9 + c, eo: initial.eo + d, P: initial.P + e};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $TSFoster$elm_sha1$SHA1$u32 = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $TSFoster$elm_sha1$SHA1$reduceChunk = function (state) {
	return $TSFoster$elm_sha1$SHA1$map16(
		$TSFoster$elm_sha1$SHA1$reduceChunkHelp(state))($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32)($TSFoster$elm_sha1$SHA1$u32);
};
var $TSFoster$elm_sha1$SHA1$Digest = $elm$core$Basics$identity;
var $TSFoster$elm_sha1$SHA1$stateToDigest = function (_v0) {
	var a = _v0.dY;
	var b = _v0.mE;
	var c = _v0.d9;
	var d = _v0.eo;
	var e = _v0.P;
	return {dY: a >>> 0, mE: b >>> 0, d9: c >>> 0, eo: d >>> 0, P: e >>> 0};
};
var $TSFoster$elm_sha1$SHA1$hashBytes = F2(
	function (state, bytes) {
		var message = $TSFoster$elm_sha1$SHA1$padBuffer(bytes);
		var numberOfChunks = ($elm$bytes$Bytes$width(message) / 64) | 0;
		var hashState = A3($TSFoster$elm_sha1$SHA1$iterate, numberOfChunks, $TSFoster$elm_sha1$SHA1$reduceChunk, state);
		return $TSFoster$elm_sha1$SHA1$stateToDigest(
			A2(
				$elm$core$Maybe$withDefault,
				state,
				A2($elm$bytes$Bytes$Decode$decode, hashState, message)));
	});
var $TSFoster$elm_sha1$SHA1$Tuple5 = F5(
	function (a, b, c, d, e) {
		return {dY: a, mE: b, d9: c, eo: d, P: e};
	});
var $TSFoster$elm_sha1$SHA1$initialState = A5($TSFoster$elm_sha1$SHA1$Tuple5, 1732584193, 4023233417, 2562383102, 271733878, 3285377520);
var $TSFoster$elm_sha1$SHA1$fromBytes = $TSFoster$elm_sha1$SHA1$hashBytes($TSFoster$elm_sha1$SHA1$initialState);
var $TSFoster$elm_sha1$SHA1$toInt32s = function (_v0) {
	var digest = _v0;
	return digest;
};
var $TSFoster$elm_uuid$UUID$forceUnsigned = $elm$core$Bitwise$shiftRightZfBy(0);
var $TSFoster$elm_uuid$UUID$toVariant1 = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	return A4(
		$TSFoster$elm_uuid$UUID$UUID,
		a,
		b,
		$TSFoster$elm_uuid$UUID$forceUnsigned(2147483648 | (1073741823 & c)),
		d);
};
var $TSFoster$elm_uuid$UUID$toVersion = F2(
	function (v, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return A4(
			$TSFoster$elm_uuid$UUID$UUID,
			a,
			$TSFoster$elm_uuid$UUID$forceUnsigned((v << 12) | (4294905855 & b)),
			c,
			d);
	});
var $TSFoster$elm_uuid$UUID$forBytes = F2(
	function (bytes, namespace) {
		return $TSFoster$elm_uuid$UUID$toVariant1(
			A2(
				$TSFoster$elm_uuid$UUID$toVersion,
				5,
				function (_v0) {
					var a = _v0.dY;
					var b = _v0.mE;
					var c = _v0.d9;
					var d = _v0.eo;
					return A4($TSFoster$elm_uuid$UUID$UUID, a, b, c, d);
				}(
					$TSFoster$elm_sha1$SHA1$toInt32s(
						$TSFoster$elm_sha1$SHA1$fromBytes(
							$elm$bytes$Bytes$Encode$encode(
								$elm$bytes$Bytes$Encode$sequence(
									_List_fromArray(
										[
											$TSFoster$elm_uuid$UUID$encoder(namespace),
											$elm$bytes$Bytes$Encode$bytes(bytes)
										]))))))));
	});
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $TSFoster$elm_uuid$UUID$forName = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $TSFoster$elm_uuid$UUID$forBytes, $elm$bytes$Bytes$Encode$encode),
	$elm$bytes$Bytes$Encode$string);
var $TSFoster$elm_uuid$UUID$toHex = F2(
	function (acc, _int) {
		toHex:
		while (true) {
			if (!_int) {
				return $elm$core$String$fromList(acc);
			} else {
				var _char = function () {
					var _v0 = 15 & _int;
					switch (_v0) {
						case 0:
							return '0';
						case 1:
							return '1';
						case 2:
							return '2';
						case 3:
							return '3';
						case 4:
							return '4';
						case 5:
							return '5';
						case 6:
							return '6';
						case 7:
							return '7';
						case 8:
							return '8';
						case 9:
							return '9';
						case 10:
							return 'a';
						case 11:
							return 'b';
						case 12:
							return 'c';
						case 13:
							return 'd';
						case 14:
							return 'e';
						default:
							return 'f';
					}
				}();
				var $temp$acc = A2($elm$core$List$cons, _char, acc),
					$temp$int = _int >>> 4;
				acc = $temp$acc;
				_int = $temp$int;
				continue toHex;
			}
		}
	});
var $TSFoster$elm_uuid$UUID$toStringWith = F2(
	function (sep, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return _Utils_ap(
			A3(
				$elm$core$String$padLeft,
				8,
				'0',
				A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, a)),
			_Utils_ap(
				sep,
				_Utils_ap(
					A3(
						$elm$core$String$padLeft,
						4,
						'0',
						A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, b >>> 16)),
					_Utils_ap(
						sep,
						_Utils_ap(
							A3(
								$elm$core$String$padLeft,
								4,
								'0',
								A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & b)),
							_Utils_ap(
								sep,
								_Utils_ap(
									A3(
										$elm$core$String$padLeft,
										4,
										'0',
										A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, c >>> 16)),
									_Utils_ap(
										sep,
										_Utils_ap(
											A3(
												$elm$core$String$padLeft,
												4,
												'0',
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & c)),
											A3(
												$elm$core$String$padLeft,
												8,
												'0',
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, d)))))))))));
	});
var $TSFoster$elm_uuid$UUID$toString = $TSFoster$elm_uuid$UUID$toStringWith('-');
var $TSFoster$elm_uuid$UUID$urlNamespace = A4($TSFoster$elm_uuid$UUID$UUID, 1806153745, 2645365201, 2159280320, 1339306184);
var $author$project$Pyxis$Components$Toasts$counterToUUID = function (counter) {
	return $TSFoster$elm_uuid$UUID$toString(
		A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$TSFoster$elm_uuid$UUID$forName,
			$TSFoster$elm_uuid$UUID$urlNamespace,
			$elm$core$String$fromInt(counter)));
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$idle = $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle;
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$running = function (duration) {
	return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Running(duration);
};
var $author$project$Pyxis$Components$Toasts$Toast = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Toasts$withInternalId = F2(
	function (internalId, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{kv: internalId});
	});
var $author$project$Pyxis$Components$Toasts$updateModelWithNewToast = F2(
	function (toastToAdd, _v0) {
		var duration = toastToAdd.eu;
		var isSticky = toastToAdd.eV;
		var model = _v0;
		var internalId = $author$project$Pyxis$Components$Toasts$counterToUUID(model.ei);
		var toastToAddWithId = A2($author$project$Pyxis$Components$Toasts$withInternalId, internalId, toastToAdd);
		var timedToast = isSticky ? $author$project$Pyxis$Components$Toasts$ToastsHelpers$idle(toastToAddWithId) : A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$running, duration, toastToAddWithId);
		return _Utils_update(
			model,
			{
				t: A3($elm$core$Dict$insert, internalId, timedToast, model.t)
			});
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$isDeleting = function (timed) {
	if (timed.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$tickDownVisibilityTimeForToastsDict = F3(
	function (tick, _v0, timedToast) {
		var deltaInTimeAsInt = tick | 0;
		switch (timedToast.$) {
			case 0:
				var visibilityTime = timedToast.a;
				var wrappedToast = timedToast.b;
				return _Utils_eq(visibilityTime - deltaInTimeAsInt, $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds) ? $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedToast) : A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Running, visibilityTime - deltaInTimeAsInt, wrappedToast);
			case 1:
				var wrappedToast = timedToast.a;
				return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Deleting(wrappedToast);
			case 2:
				var wrappedToast = timedToast.a;
				return $author$project$Pyxis$Components$Toasts$ToastsHelpers$Idle(wrappedToast);
			default:
				var visibilityTime = timedToast.a;
				var wrappedToast = timedToast.b;
				return A2($author$project$Pyxis$Components$Toasts$ToastsHelpers$Paused, visibilityTime, wrappedToast);
		}
	});
var $author$project$Pyxis$Components$Toasts$updateModelWithTickDown = F2(
	function (deltaTime, _v0) {
		var model = _v0;
		var isNotDeleting = F2(
			function (_v1, timed) {
				return !$author$project$Pyxis$Components$Toasts$ToastsHelpers$isDeleting(timed);
			});
		return _Utils_update(
			model,
			{
				t: A2(
					$elm$core$Dict$map,
					$author$project$Pyxis$Components$Toasts$ToastsHelpers$tickDownVisibilityTimeForToastsDict(deltaTime),
					A2($elm$core$Dict$filter, isNotDeleting, model.t))
			});
	});
var $primait$prima_elm_extra$PrimaUpdate$withoutCmds = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Pyxis$Components$Toasts$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var delta = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelWithTickDown, delta, model));
			case 0:
				var toastToAdd = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2(
						$author$project$Pyxis$Components$Toasts$updateModelWithNewToast,
						toastToAdd,
						$author$project$Pyxis$Components$Toasts$updateModelWithIncreasedCounter(model)));
			case 2:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelDeletingToast, toastUUID, model));
			case 3:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelRemoveToast, toastUUID, model));
			case 4:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelPausedToast, toastUUID, model));
			default:
				var toastUUID = msg.a;
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2($author$project$Pyxis$Components$Toasts$updateModelResumeToast, toastUUID, model));
		}
	});
var $author$project$Pyxis$Components$Toasts$addNewToast = function (toastToAdd) {
	return $author$project$Pyxis$Components$Toasts$update(
		$author$project$Pyxis$Components$Toasts$Add(toastToAdd));
};
var $author$project$Page$OfferDetails$Effect$FetchClaimHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Offer$pickQuoteIdForClaimsHistory = function (_v0) {
	var offer = _v0;
	return offer.iz;
};
var $author$project$Page$OfferDetails$chooseEffectForClaimHistory = function (maybeOffer) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$OfferDetails$Effect$None,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$OfferDetails$Effect$FetchClaimHistory,
			A2($elm$core$Maybe$andThen, $author$project$Common$Offer$pickQuoteIdForClaimsHistory, maybeOffer)));
};
var $author$project$Page$OfferDetails$Effect$FetchCoverSelection = function (a) {
	return {$: 5, a: a};
};
var $author$project$Common$Offer$pickId = function (_v0) {
	var offer = _v0;
	return offer.kv;
};
var $author$project$Page$OfferDetails$chooseEffectForCoverSelection = A2(
	$elm_community$maybe_extra$Maybe$Extra$unwrap,
	$author$project$Page$OfferDetails$Effect$None,
	A2($elm$core$Basics$composeR, $author$project$Common$Offer$pickId, $author$project$Page$OfferDetails$Effect$FetchCoverSelection));
var $author$project$Page$OfferDetails$Effect$FetchCustomerId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$OfferDetails$chooseEffectForCustomerId = function (maybeOffer) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$OfferDetails$Effect$None,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$OfferDetails$Effect$FetchCustomerId,
			A2($elm$core$Maybe$map, $author$project$Common$Offer$pickId, maybeOffer)));
};
var $author$project$Common$Offer$pickIsRenewal = function (_v0) {
	var offer = _v0;
	return offer.ha;
};
var $author$project$Page$OfferDetails$choseEffectForRenewal = function (offer) {
	return $author$project$Common$Offer$pickIsRenewal(offer) ? $author$project$Page$OfferDetails$Effect$FetchPaymentMethod(
		$author$project$Common$Offer$pickId(offer)) : $author$project$Page$OfferDetails$Effect$None;
};
var $author$project$Page$OfferDetails$chooseEffectForPaymentMethod = function (maybeOffer) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$OfferDetails$Effect$None,
		A2($elm$core$Maybe$map, $author$project$Page$OfferDetails$choseEffectForRenewal, maybeOffer));
};
var $author$project$Pyxis$Components$Modal$Close = 1;
var $author$project$Pyxis$Commons$Basics$forwardValue = F2(
	function (value, _function) {
		return _function(value);
	});
var $author$project$Pyxis$Commons$Basics$maybeForwardValue = function (value) {
	return $elm$core$Maybe$map(
		$author$project$Pyxis$Commons$Basics$forwardValue(value));
};
var $author$project$Pyxis$Components$Modal$updateIsOpen = F2(
	function (isOpen, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{g8: isOpen});
	});
var $primait$prima_elm_extra$PrimaUpdate$withCmd = F2(
	function (cmd, model) {
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Pyxis$Components$Modal$update = F2(
	function (msg, model) {
		var enableFocusTrap = model.gA;
		var disableFocusTrap = model.gs;
		var id = model.kv;
		var startingElementId = model.fq;
		if (!msg) {
			return A2(
				$primait$prima_elm_extra$PrimaUpdate$withCmd,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$author$project$Pyxis$Commons$Basics$maybeForwardValue,
						{fq: startingElementId, pV: id},
						enableFocusTrap)),
				A2($author$project$Pyxis$Components$Modal$updateIsOpen, true, model));
		} else {
			return A2(
				$primait$prima_elm_extra$PrimaUpdate$withCmd,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Pyxis$Commons$Basics$maybeForwardValue, 0, disableFocusTrap)),
				A2($author$project$Pyxis$Components$Modal$updateIsOpen, false, model));
		}
	});
var $author$project$Pyxis$Components$Modal$close = $author$project$Pyxis$Components$Modal$update(1);
var $author$project$Common$ComponentUI$Modal$CoverPackages$close = function (_v0) {
	var modelData = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(modelData.b2);
	var newModalModel = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			modelData,
			{b2: newModalModel}),
		cmd);
};
var $author$project$Page$OfferDetails$closeConsentModelWithOrigin = F2(
	function (model, modalOrigin) {
		if (!modalOrigin) {
			return $author$project$Pyxis$Components$Modal$close(model.au);
		} else {
			return $author$project$Pyxis$Components$Modal$close(model.bQ);
		}
	});
var $author$project$Translations$detailsToastAmendDateErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The start date has not been correctly updated. Please try again later.';
	} else {
		return 'La fecha de inicio no se ha actualizado correctamente. Por favor, inténtelo de nuevo más tarde.';
	}
};
var $author$project$Translations$detailsToastAmendDateSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The start date has been correctly updated.';
	} else {
		return 'La fecha de inicio se ha actualizado correctamente.';
	}
};
var $author$project$Pyxis$Components$Toasts$Error = 4;
var $author$project$Pyxis$Components$Toasts$SimpleContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$IconSet$svgCheckCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm-1 16c-.26 0-.51-.1-.71-.29L7 12.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L11 13.59 16.59 8c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-6.29 6.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$checkCircle = {eY: 'check-circle', a: $author$project$Pyxis$Components$IconSet$svgCheckCircle};
var $author$project$Pyxis$Components$IconSet$svgExclamationCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm0 14.37h0c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v7c0 .56-.45 1-1 1z\"/><circle cx=\"12\" cy=\"17.38\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$exclamationCircle = {eY: 'exclamation-circle', a: $author$project$Pyxis$Components$IconSet$svgExclamationCircle};
var $author$project$Pyxis$Components$IconSet$svgExclamationTriangle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2.77c.18 0 .62.05.88.52l8.85 16.23a.97.97 0 0 1-.02.99c-.09.15-.34.49-.86.49H3.15c-.51 0-.77-.34-.86-.49s-.26-.54-.02-.99l8.85-16.23c.26-.47.7-.52.88-.52m0-2c-1.03 0-2.07.52-2.63 1.56L.51 18.56C-.58 20.56.87 23 3.14 23h17.7c2.28 0 3.72-2.44 2.63-4.44L14.63 2.33C14.07 1.29 13.03.77 12 .77h0zM12 15h0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1z\"/><circle cx=\"12\" cy=\"18\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$exclamationTriangle = {eY: 'exclamation-triangle', a: $author$project$Pyxis$Components$IconSet$svgExclamationTriangle};
var $author$project$Pyxis$Components$IconSet$svgInfoCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm0 18.62h0c-.55 0-1-.45-1-1v-6h0c-.55 0-1-.45-1-1h0c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v7c0 .56-.45 1-1 1z\"/><circle cx=\"12\" cy=\"6.63\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$infoCircle = {eY: 'info-circle', a: $author$project$Pyxis$Components$IconSet$svgInfoCircle};
var $author$project$Pyxis$Components$IconSet$svgThumbUp = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.1 11.09l-2.96-.79c-.44-.12-.74-.51-.74-.97V4c0-1.66-1.34-3-3-3h-.03c-.71 0-1.37.38-1.73 1l-4.85 8.4c-.18.31-.51.5-.87.5H4c-1.66 0-3 1.34-3 3V20c0 1.66 1.34 3 3 3h2.5 11.21a3 3 0 0 0 2.9-2.22l1.61-6.02c.43-1.6-.52-3.24-2.12-3.67zM3 20v-6.1c0-.55.45-1 1-1h1.5V21H4c-.55 0-1-.45-1-1zm17.29-5.76l-1.61 6.02c-.12.44-.51.74-.97.74H7.5v-8.56c.41-.26.77-.6 1.02-1.04L13.37 3h.03c.55 0 1 .45 1 1v5.33a3 3 0 0 0 2.22 2.9l2.96.79c.54.14.85.69.71 1.22z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$thumbUp = {eY: 'thumb-up', a: $author$project$Pyxis$Components$IconSet$svgThumbUp};
var $author$project$Pyxis$Components$Toasts$variantToDefaultIcon = function (variant) {
	switch (variant) {
		case 0:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
		case 1:
			return $author$project$Pyxis$Components$IconSet$thumbUp;
		case 2:
			return $author$project$Pyxis$Components$IconSet$exclamationTriangle;
		case 3:
			return $author$project$Pyxis$Components$IconSet$checkCircle;
		case 4:
			return $author$project$Pyxis$Components$IconSet$exclamationCircle;
		default:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
	}
};
var $author$project$Pyxis$Components$Toasts$toast = function (variant) {
	return {
		U: $elm$core$Maybe$Nothing,
		ga: _List_Nil,
		gb: 'Close',
		ep: _List_Nil,
		eu: 20000,
		ku: $elm$core$Maybe$Just(
			$author$project$Pyxis$Components$Toasts$variantToDefaultIcon(variant)),
		kv: '',
		eV: false,
		hQ: $elm$core$Maybe$Nothing,
		fz: $elm$core$Maybe$Nothing,
		pK: $author$project$Pyxis$Components$Toasts$SimpleContent(''),
		jd: variant
	};
};
var $author$project$Pyxis$Components$Toasts$errorToast = $author$project$Pyxis$Components$Toasts$toast(4);
var $author$project$Page$OfferDetails$fromMaybeOfferIdToString = function (maybeUuid) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		'',
		function (uuid) {
			return uuid;
		},
		maybeUuid);
};
var $author$project$Translations$greatLakesOptInConsentModalErrorToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Error saving consent';
	} else {
		return 'Error al guardar el consentimiento';
	}
};
var $author$project$Translations$greatLakesOptInConsentModalSuccessToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Consent saved successfully';
	} else {
		return 'Consentimiento guardado correctamente';
	}
};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$mapError = F2(
	function (mapFn, error) {
		if (!error.$) {
			var possiblyParsedData = error.a;
			var graphqlErrorList = error.b;
			if (!possiblyParsedData.$) {
				var parsedData = possiblyParsedData.a;
				return A2(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData(
						mapFn(parsedData)),
					graphqlErrorList);
			} else {
				var unparsedData = possiblyParsedData.a;
				return A2(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(unparsedData),
					graphqlErrorList);
			}
		} else {
			var httpError = error.a;
			return $dillonkearns$elm_graphql$Graphql$Http$HttpError(httpError);
		}
	});
var $krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var x = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(x);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Common$Offer$filterActionValue = F2(
	function (filterFunc, _v0) {
		var offer = _v0;
		return $elm$core$List$head(
			A2($elm$core$List$filterMap, filterFunc, offer.aY));
	});
var $author$project$Common$Offer$pickEditCoverAction = function (action) {
	if (action.$ === 4) {
		var url = action.a;
		return $elm$core$Maybe$Just(url);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Offer$mayEditCover = $author$project$Common$Offer$filterActionValue($author$project$Common$Offer$pickEditCoverAction);
var $author$project$Common$Portfolio$setEditCoverageUrl = F2(
	function (coverageUrl, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				gw: $elm$core$Maybe$Just(coverageUrl)
			});
	});
var $author$project$Page$OfferDetails$Model$maybeAddSetEditCoverUrlToPortfolio = F2(
	function (maybeOffer, model) {
		var updatePortfolioEditCoverUrl = function (link) {
			return _Utils_update(
				model,
				{
					dt: A2($author$project$Common$Portfolio$setEditCoverageUrl, link, model.dt)
				});
		};
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				updatePortfolioEditCoverUrl,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2($elm$core$Maybe$map, $author$project$Common$Offer$mayEditCover, maybeOffer))));
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Common$Offer$isEditAction = function (action) {
	if (action.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$mayBeEdited = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isEditAction, offer.aY);
};
var $author$project$Common$Portfolio$setEditRedirectUrl = F2(
	function (redirectUrl, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				gx: $elm$core$Maybe$Just(redirectUrl)
			});
	});
var $author$project$Page$OfferDetails$Model$maybeAddSetOnEditToPortfolio = F3(
	function (maybeFunnelUrl, maybeOffer, model) {
		var isEditable = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Common$Offer$mayBeEdited, maybeOffer));
		var _v0 = _Utils_Tuple2(isEditable, maybeFunnelUrl);
		if (_v0.a && (!_v0.b.$)) {
			var funnelUrl = _v0.b.a;
			return _Utils_update(
				model,
				{
					dt: A2($author$project$Common$Portfolio$setEditRedirectUrl, funnelUrl, model.dt)
				});
		} else {
			return model;
		}
	});
var $author$project$Page$OfferDetails$maybeSetCoverSelectionAsLoading = F2(
	function (maybeOffer, model) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			model,
			function (_v0) {
				return _Utils_update(
					model,
					{jZ: $krisajenkins$remotedata$RemoteData$Loading});
			},
			maybeOffer);
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateEmailAddress = F2(
	function (email, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{iB: email});
	});
var $author$project$Page$OfferDetails$setPolicyHolderEmailAddress = F2(
	function (email, model) {
		return _Utils_update(
			model,
			{
				C: A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateEmailAddress, email, model.C)
			});
	});
var $author$project$Page$OfferDetails$maybeSetPolicyHolderEmailAddress = F2(
	function (email, model) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			model,
			A2($primait$prima_elm_extra$PrimaFunction$flip, $author$project$Page$OfferDetails$setPolicyHolderEmailAddress, model),
			email);
	});
var $author$project$Page$OfferDetails$Model$setPaymentMethod = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{lq: result});
	});
var $author$project$Page$OfferDetails$updatePaymentMethodIfRenewal = F2(
	function (model, offer) {
		return $author$project$Common$Offer$pickIsRenewal(offer) ? A2($author$project$Page$OfferDetails$Model$setPaymentMethod, $krisajenkins$remotedata$RemoteData$Loading, model) : model;
	});
var $author$project$Page$OfferDetails$maybeUpdatePaymentMethodIfRenewal = F2(
	function (maybeOffer, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				$author$project$Page$OfferDetails$updatePaymentMethodIfRenewal(model),
				maybeOffer));
	});
var $author$project$Pyxis$Components$Modal$Open = 0;
var $author$project$Pyxis$Components$Modal$open = $author$project$Pyxis$Components$Modal$update(0);
var $author$project$Common$ComponentUI$Modal$CoverPackages$open = function (_v0) {
	var modelData = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$open(modelData.b2);
	var newModalModel = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			modelData,
			{b2: newModalModel}),
		cmd);
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$optionToString = function (_v0) {
	return 'new business offer';
};
var $author$project$Common$Person$pickContacts = function (person) {
	switch (person.$) {
		case 1:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			var contacts = person.c;
			return $elm$core$Maybe$Just(contacts);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Offer$pickCustomerFacingId = function (_v0) {
	var offer = _v0;
	return offer.mY;
};
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Page$OfferDetails$Model$pickCustomerFacingId = function (model) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$Maybe$map($author$project$Common$Offer$pickCustomerFacingId),
			model.G));
};
var $author$project$Page$OfferDetails$Model$pickOfferId = function (model) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$Maybe$map($author$project$Common$Offer$pickId),
			model.G));
};
var $author$project$Common$Offer$pickPolicyHolder = function (_v0) {
	var offer = _v0;
	return offer.io;
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$ProductV1 = 0;
var $author$project$Common$ComponentUI$Modal$CoverPackages$ProductV2 = 1;
var $author$project$Common$ComponentUI$Modal$CoverPackages$productVersionFromCoverSelection = function (coverSelection) {
	var _v0 = coverSelection.mx;
	if (!_v0.$) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Common$Offer$requiresGreatLakesOptInConsent = function (_v0) {
	var offer = _v0;
	return offer.iH;
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$resetValue = function (_v0) {
	var modelData = _v0;
	return _Utils_update(
		modelData,
		{aB: _List_Nil});
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$resetCheckBoxGropup = function (sendEmailModalModel) {
	return _Utils_update(
		sendEmailModalModel,
		{
			ck: $author$project$Pyxis$Components$Field$CheckboxGroup$resetValue(sendEmailModalModel.ck)
		});
};
var $author$project$Translations$sendOfferEmailsBlockedOffer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer is not available for recruitment, so it is not possible to send emails.';
	} else {
		return 'La oferta no está disponible para contratación, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsMissingEmailAddress = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'There is no email address associated with this offer, please complete it to be able to send emails.';
	} else {
		return 'No hay una dirección de correo electrónico asociada a esta oferta, complétala para poder enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsOfferExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer has expired, so it is not possible to send emails.';
	} else {
		return 'La oferta ha caducado, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsOfferIsRenewal = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'This offer is a renewal, so it is not possible to send email';
	} else {
		return 'Esta oferta es una renovación, por lo que no es posible enviar emails';
	}
};
var $author$project$Translations$sendOfferEmailsOfferPurchased = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer has been contracted, so it is not possible to send emails.';
	} else {
		return 'La oferta ha sido contratada, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsOfferRequoted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The offer has been re-quoted, so it is not possible to send emails.';
	} else {
		return 'La oferta ha sido cotizada nuevamente, por lo que no es posible enviar emails.';
	}
};
var $author$project$Translations$sendOfferEmailsStartDateExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You need to change the start date to be able to send emails.';
	} else {
		return 'Necesitas cambiar la fecha de inicio para poder enviar emails.';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailError = F2(
	function (i18n, error) {
		switch (error) {
			case 0:
				return $author$project$Translations$sendOfferEmailsOfferExpired(i18n);
			case 1:
				return $author$project$Translations$sendOfferEmailsStartDateExpired(i18n);
			case 2:
				return $author$project$Translations$sendOfferEmailsOfferPurchased(i18n);
			case 3:
				return $author$project$Translations$sendOfferEmailsBlockedOffer(i18n);
			case 4:
				return $author$project$Translations$sendOfferEmailsOfferRequoted(i18n);
			case 5:
				return $author$project$Translations$sendOfferEmailsMissingEmailAddress(i18n);
			default:
				return $author$project$Translations$sendOfferEmailsOfferIsRenewal(i18n);
		}
	});
var $author$project$Translations$sendOfferEmailsGenericErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'It was not possible to send the email. Please refresh the page to try again.';
	} else {
		return 'No ha sido posible enviar el email. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$sendOfferEmailsSuccessMessage = F2(
	function (email, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Email successfully sent to ' + email;
		} else {
			return 'Envío realizado a ' + email;
		}
	});
var $author$project$Common$PricingAction$new = function (pricingAction) {
	return $author$project$Common$PricingAction$PricingAction(pricingAction);
};
var $author$project$Common$PricingAction$Unknown = {$: 1};
var $author$project$Common$PricingAction$unknown = $author$project$Common$PricingAction$Unknown;
var $author$project$Page$OfferDetails$Model$pickPricingAction = function (response) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$author$project$Common$PricingAction$unknown,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($author$project$Common$PricingAction$new),
				$elm$core$Maybe$withDefault($author$project$Common$PricingAction$default)),
			response));
};
var $author$project$Common$ClaimHistory$default = A6($author$project$Common$ClaimHistory$ClaimHistory, '', '', '', $author$project$Common$Count$default, $elm$core$Maybe$Nothing, $author$project$Common$PricingAction$default);
var $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2(
	function (fma, mb) {
		if (mb.$ === 1) {
			return fma(0);
		} else {
			return mb;
		}
	});
var $author$project$Common$ClaimHistory$setActionNeeded = F2(
	function (actionNeeded, claimHistory) {
		return _Utils_update(
			claimHistory,
			{fN: actionNeeded});
	});
var $author$project$Common$ClaimHistory$setPricingActionToClaimHistoryOrDefault = F2(
	function (action, maybeClaimHistory) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
			function (_v0) {
				return $elm$core$Maybe$Just(
					A2($author$project$Common$ClaimHistory$setActionNeeded, action, $author$project$Common$ClaimHistory$default));
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$ClaimHistory$setActionNeeded(action),
				maybeClaimHistory));
	});
var $author$project$Page$OfferDetails$Model$setPricingActionToClaimHistoryResponse = F2(
	function (model, action) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Common$ClaimHistory$setPricingActionToClaimHistoryOrDefault(action),
			model.cM);
	});
var $author$project$Page$OfferDetails$Model$setClaimHistoryPricingActionResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cM: A2(
					$author$project$Page$OfferDetails$Model$setPricingActionToClaimHistoryResponse,
					model,
					$author$project$Page$OfferDetails$Model$pickPricingAction(result))
			});
	});
var $author$project$Common$Offer$pickClaimsDeclaredWithFault = function (_v0) {
	var offer = _v0;
	return offer.f9;
};
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Page$OfferDetails$Model$pickClaimsDeclaredWithFaultByCustomer = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.G;
	},
	A2(
		$elm$core$Basics$composeR,
		$krisajenkins$remotedata$RemoteData$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$maybe_extra$Maybe$Extra$join,
			A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Common$Count$default, $author$project$Common$Offer$pickClaimsDeclaredWithFault))));
var $author$project$Common$ClaimHistory$setClaimDeclaredWithFaultByCustomer = F2(
	function (claims, claimHistory) {
		return _Utils_update(
			claimHistory,
			{f8: claims});
	});
var $author$project$Page$OfferDetails$Model$setClaimDeclaredToClaimHistory = function (model) {
	return $author$project$Common$ClaimHistory$setClaimDeclaredWithFaultByCustomer(
		$author$project$Page$OfferDetails$Model$pickClaimsDeclaredWithFaultByCustomer(model));
};
var $author$project$Page$OfferDetails$Model$setClaimsDeclaredToResponse = function (model) {
	return $krisajenkins$remotedata$RemoteData$map(
		$elm$core$Maybe$map(
			$author$project$Page$OfferDetails$Model$setClaimDeclaredToClaimHistory(model)));
};
var $author$project$Page$OfferDetails$Model$setClaimHistoryResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cM: A2($author$project$Page$OfferDetails$Model$setClaimsDeclaredToResponse, model, result)
			});
	});
var $author$project$Page$OfferDetails$Model$setConsentModalModelWithOrigin = F3(
	function (origin, modalModel, model) {
		if (!origin) {
			return _Utils_update(
				model,
				{au: modalModel});
		} else {
			return _Utils_update(
				model,
				{bQ: modalModel});
		}
	});
var $author$project$Page$OfferDetails$Model$setCustomerId = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{gm: result});
	});
var $author$project$Page$OfferDetails$Model$setGreatLakesOptInConsentModalForLanding = F2(
	function (modalModel, model) {
		return _Utils_update(
			model,
			{au: modalModel});
	});
var $author$project$Page$OfferDetails$Model$setOfferResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{G: result});
	});
var $author$project$Pyxis$Components$Toasts$Success = 3;
var $author$project$Pyxis$Components$Toasts$successToast = $author$project$Pyxis$Components$Toasts$toast(3);
var $author$project$Env$funnelUrl = function (_v0) {
	var environment = _v0;
	return environment.cZ;
};
var $author$project$ExternalUrl$toString = function (link) {
	var env = link.a;
	var offerId = link.b;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Env$funnelUrl(env),
				'/offer/',
				$danyx23$elm_uuid$Uuid$toString(offerId)
			]));
};
var $author$project$Commands$dispatch = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(msg),
		$elm$core$Task$succeed(
			$elm$core$Basics$always(msg)));
};
var $author$project$Commands$dispatchFromMaybe = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$Commands$dispatch),
	$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
var $author$project$Pyxis$Commons$Commands$dispatch = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(msg),
		$elm$core$Task$succeed(
			$elm$core$Basics$always(msg)));
};
var $author$project$Pyxis$Commons$Commands$dispatchFromMaybe = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($author$project$Pyxis$Commons$Commands$dispatch),
	$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
var $author$project$Pyxis$Components$Tabs$dispatchOnTabActivation = function (_v0) {
	var activeIndex = _v0.V;
	var onTabActivation = _v0.e9;
	return $author$project$Pyxis$Commons$Commands$dispatchFromMaybe(
		A2(
			$elm$core$Maybe$map,
			function (theMsg) {
				return theMsg(activeIndex);
			},
			onTabActivation));
};
var $author$project$Pyxis$Components$Tabs$dispatchOnTabFirstActivation = function (_v0) {
	var activeIndex = _v0.V;
	var onTabFirstActivation = _v0.ic;
	return $author$project$Pyxis$Commons$Commands$dispatchFromMaybe(
		A2(
			$elm$core$Maybe$map,
			function (theMsg) {
				return theMsg(activeIndex);
			},
			onTabFirstActivation));
};
var $primait$prima_elm_extra$PrimaCmd$ifThenCmd = F2(
	function (condition, cmd) {
		return condition ? cmd : $elm$core$Platform$Cmd$none;
	});
var $primait$prima_elm_extra$PrimaCmd$ifThenCmdMap = F3(
	function (condition, cmd, a) {
		return A2(
			$primait$prima_elm_extra$PrimaCmd$ifThenCmd,
			condition(a),
			cmd(a));
	});
var $author$project$Pyxis$Components$Tabs$isCurrentTabFirstActivation = function (_v0) {
	var activeIndex = _v0.V;
	var openedTabs = _v0.b6;
	return 1 === A2(
		$elm$core$Maybe$withDefault,
		1,
		A2($elm$core$Dict$get, activeIndex, openedTabs));
};
var $author$project$Pyxis$Components$Tabs$Next = 0;
var $author$project$Pyxis$Components$Tabs$Previous = 1;
var $primait$prima_elm_extra$PrimaCmd$fromMaybeMap = F2(
	function (command, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return command(a);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pyxis$Components$Tabs$getTabId = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		$elm$core$Basics$append(id + '-tab-'));
};
var $author$project$Pyxis$Components$Tabs$attemptTabFocus = F2(
	function (id, _v0) {
		var modelData = _v0;
		return A2(
			$primait$prima_elm_extra$PrimaCmd$fromMaybeMap,
			function (msg) {
				return A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always(msg),
					$elm$browser$Browser$Dom$focus(
						A2($author$project$Pyxis$Components$Tabs$getTabId, id, modelData.V)));
			},
			A2(
				$elm$core$Maybe$map,
				function (msg) {
					return msg(modelData.V);
				},
				modelData.e9));
	});
var $author$project$Pyxis$Commons$Events$Keyboard$matchKey = F2(
	function (match, _v0) {
		var key = _v0.eW;
		return _Utils_eq(key, match);
	});
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowLeft = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('ArrowLeft');
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowRight = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('ArrowRight');
var $author$project$Pyxis$Commons$Events$Keyboard$isEnd = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('End');
var $author$project$Pyxis$Commons$Events$Keyboard$isHome = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('Home');
var $author$project$Pyxis$Components$Tabs$getAdjacentPosition = F3(
	function (currentPosition, direction, enabledTabsLength) {
		if (!direction) {
			return (_Utils_cmp(currentPosition + 1, enabledTabsLength - 1) > 0) ? 0 : (currentPosition + 1);
		} else {
			return ((currentPosition - 1) < 0) ? (enabledTabsLength - 1) : (currentPosition - 1);
		}
	});
var $author$project$Pyxis$Components$Tabs$findAdjacentIndex = F3(
	function (enabledTabIndexes, currentPosition, direction) {
		var nextPosition = A3(
			$author$project$Pyxis$Components$Tabs$getAdjacentPosition,
			currentPosition,
			direction,
			$elm$core$List$length(enabledTabIndexes));
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$head(
				A2($elm$core$List$drop, nextPosition, enabledTabIndexes)));
	});
var $author$project$Pyxis$Components$Tabs$findCurrentPosition = F2(
	function (enabledIndexes, startIndex) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var index = _v0.b;
							return _Utils_eq(index, startIndex);
						},
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, enabledIndexes)))));
	});
var $author$project$Pyxis$Components$Tabs$updateAdjacentIndex = F3(
	function (enabledTabIndexes, direction, model) {
		var activeIndex = model.V;
		var currentPosition = A2($author$project$Pyxis$Components$Tabs$findCurrentPosition, enabledTabIndexes, activeIndex);
		var newIndex = A3($author$project$Pyxis$Components$Tabs$findAdjacentIndex, enabledTabIndexes, currentPosition, direction);
		return A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, newIndex, model);
	});
var $author$project$Pyxis$Components$Tabs$findFirstEnabledIndex = function (enabledTabIndexes) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$head(enabledTabIndexes));
};
var $author$project$Pyxis$Components$Tabs$updateToFirstEnabledIndex = F2(
	function (enabledTabIndexes, model) {
		var nextIndex = $author$project$Pyxis$Components$Tabs$findFirstEnabledIndex(enabledTabIndexes);
		return A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, nextIndex, model);
	});
var $author$project$Pyxis$Components$Tabs$findLastEnabledIndex = function (enabledTabIndexes) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$List$length(enabledTabIndexes) - 1,
		$elm$core$List$head(
			$elm$core$List$reverse(enabledTabIndexes)));
};
var $author$project$Pyxis$Components$Tabs$updateToLastEnabledIndex = F2(
	function (enabledTabIndexes, model) {
		var nextIndex = $author$project$Pyxis$Components$Tabs$findLastEnabledIndex(enabledTabIndexes);
		return A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, nextIndex, model);
	});
var $primait$prima_elm_extra$PrimaUpdate$withCmdsMap = F2(
	function (cmdFunctions, model) {
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (f) {
						return f(model);
					},
					cmdFunctions)));
	});
var $author$project$Pyxis$Components$Tabs$updateOnKeyEvent = F3(
	function (id, enabledTabIndexes, event) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Commons$Events$Keyboard$isArrowLeft(event) ? A2($author$project$Pyxis$Components$Tabs$updateAdjacentIndex, enabledTabIndexes, 1) : ($author$project$Pyxis$Commons$Events$Keyboard$isArrowRight(event) ? A2($author$project$Pyxis$Components$Tabs$updateAdjacentIndex, enabledTabIndexes, 0) : ($author$project$Pyxis$Commons$Events$Keyboard$isHome(event) ? $author$project$Pyxis$Components$Tabs$updateToFirstEnabledIndex(enabledTabIndexes) : ($author$project$Pyxis$Commons$Events$Keyboard$isEnd(event) ? $author$project$Pyxis$Components$Tabs$updateToLastEnabledIndex(enabledTabIndexes) : $elm$core$Basics$identity))),
			$primait$prima_elm_extra$PrimaUpdate$withCmdsMap(
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Tabs$attemptTabFocus(id),
						$author$project$Pyxis$Components$Tabs$dispatchOnTabActivation,
						A2($primait$prima_elm_extra$PrimaCmd$ifThenCmdMap, $author$project$Pyxis$Components$Tabs$isCurrentTabFirstActivation, $author$project$Pyxis$Components$Tabs$dispatchOnTabFirstActivation)
					])));
	});
var $author$project$Pyxis$Components$Tabs$update = F2(
	function (msg, model) {
		var model_ = model;
		switch (msg.$) {
			case 0:
				var index = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Tabs$dispatchOnTabActivation,
							A2($primait$prima_elm_extra$PrimaCmd$ifThenCmdMap, $author$project$Pyxis$Components$Tabs$isCurrentTabFirstActivation, $author$project$Pyxis$Components$Tabs$dispatchOnTabFirstActivation)
						]),
					A2($author$project$Pyxis$Components$Tabs$setActiveTabIndex, index, model));
			case 1:
				var enabledTabIndexes = msg.a;
				var id = msg.b;
				var event = msg.c;
				return A4($author$project$Pyxis$Components$Tabs$updateOnKeyEvent, id, enabledTabIndexes, event, model);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model_,
						{du: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Common$Portfolio$updateInnerTabsModel = F2(
	function (newTabModel, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{eK: newTabModel});
	});
var $author$project$Common$Portfolio$updateOuterTabsModel = F2(
	function (newTabModel, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{b7: newTabModel});
	});
var $author$project$Common$Portfolio$update = F2(
	function (msg, portfolio) {
		var model = portfolio;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.b7);
				var newTabModel = _v1.a;
				var tabCmd = _v1.b;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmd,
					tabCmd,
					A2($author$project$Common$Portfolio$updateOuterTabsModel, newTabModel, portfolio));
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.eK);
				var newTabModel = _v2.a;
				var tabCmd = _v2.b;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmd,
					tabCmd,
					A2($author$project$Common$Portfolio$updateInnerTabsModel, newTabModel, portfolio));
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmd,
					$author$project$Commands$dispatchFromMaybe(model.k1),
					portfolio);
			default:
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(portfolio);
		}
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckedValues = F2(
	function (mapper, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				aB: mapper(modelData.aB)
			});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$checkValue = function (value) {
	return $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckedValues(
		$elm$core$List$cons(value));
};
var $primait$prima_elm_extra$PrimaFunction$ifThenElseMap = F4(
	function (condition, mapper1, mapper2, m) {
		return condition(m) ? mapper1(m) : mapper2(m);
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				eB: mapper(model.eB)
			});
	});
var $author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred = F2(
	function (isBlurred, fieldStatus) {
		return _Utils_update(
			fieldStatus,
			{kE: isBlurred});
	});
var $author$project$Pyxis$Components$Field$FieldStatus$setIsDirty = F2(
	function (isDirty, fieldStatus) {
		return _Utils_update(
			fieldStatus,
			{nI: isDirty});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$uncheckValue = function (value) {
	return $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckedValues(
		$elm$core$List$filter(
			$elm$core$Basics$neq(value)));
};
var $primait$prima_elm_extra$PrimaUpdate$withCmds = F2(
	function (cmds, model) {
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(cmds));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hR)
						]),
					A2(
						$author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h_)
						]),
					A2(
						$author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			default:
				var value = msg.a;
				var check = msg.b;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.k$)
						]),
					A2(
						$author$project$Pyxis$Components$Field$CheckboxGroup$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						A4(
							$primait$prima_elm_extra$PrimaFunction$ifThenElseMap,
							$elm$core$Basics$always(check),
							$author$project$Pyxis$Components$Field$CheckboxGroup$checkValue(value),
							$author$project$Pyxis$Components$Field$CheckboxGroup$uncheckValue(value),
							model)));
		}
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateCheckBoxGroup = F2(
	function (newCheckBoxModel, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{ck: newCheckBoxModel});
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted = F2(
	function (isSubmitted, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{hb: isSubmitted});
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel = F2(
	function (newSendEmailModel, sendEmailModalModel) {
		return _Utils_update(
			sendEmailModalModel,
			{iu: newSendEmailModel});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$withProductVersion = F2(
	function (productVersion, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				ix: $elm$core$Maybe$Just(productVersion)
			});
	});
var $author$project$Pyxis$Components$Toasts$withToastText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				pK: $author$project$Pyxis$Components$Toasts$SimpleContent(text)
			});
	});
var $author$project$Page$OfferDetails$update = F4(
	function (i18n, env, msg, model) {
		switch (msg.$) {
			case 0:
				var remoteData = msg.a;
				var maybeOffer = $elm_community$maybe_extra$Maybe$Extra$join(
					$krisajenkins$remotedata$RemoteData$toMaybe(remoteData));
				var policyHolderEmailAddress = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ew;
					},
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeR, $author$project$Common$Offer$pickPolicyHolder, $author$project$Common$Person$pickContacts),
						maybeOffer));
				var maybeFunneUrl = A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Common$Offer$pickId,
						A2(
							$elm$core$Basics$composeR,
							$author$project$ExternalUrl$FunnelOffer(env),
							$author$project$ExternalUrl$toString)),
					maybeOffer);
				var _v1 = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Common$Offer$requiresGreatLakesOptInConsent, maybeOffer) ? $author$project$Pyxis$Components$Modal$open(model.au) : _Utils_Tuple2(model.au, $elm$core$Platform$Cmd$none);
				var newConsentModalModel = _v1.a;
				var consentModalCmd = _v1.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$OfferDetails$maybeSetCoverSelectionAsLoading,
						maybeOffer,
						A2(
							$author$project$Page$OfferDetails$maybeSetPolicyHolderEmailAddress,
							policyHolderEmailAddress,
							A2(
								$author$project$Page$OfferDetails$maybeUpdatePaymentMethodIfRenewal,
								maybeOffer,
								A2(
									$author$project$Page$OfferDetails$Model$maybeAddSetEditCoverUrlToPortfolio,
									maybeOffer,
									A3(
										$author$project$Page$OfferDetails$Model$maybeAddSetOnEditToPortfolio,
										maybeFunneUrl,
										maybeOffer,
										A2(
											$author$project$Page$OfferDetails$Model$setGreatLakesOptInConsentModalForLanding,
											newConsentModalModel,
											A2(
												$author$project$Page$OfferDetails$Model$setOfferResult,
												remoteData,
												_Utils_update(
													model,
													{au: newConsentModalModel})))))))),
					$author$project$Page$OfferDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$OfferDetails$chooseEffectForCustomerId(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForClaimHistory(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForPaymentMethod(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForCoverSelection(maybeOffer),
								$author$project$Page$OfferDetails$Effect$WithCmd(consentModalCmd)
							])));
			case 1:
				var remoteData = msg.a;
				var maybeOffer = $krisajenkins$remotedata$RemoteData$toMaybe(remoteData);
				var policyHolderEmailAddress = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.ew;
					},
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeR, $author$project$Common$Offer$pickPolicyHolder, $author$project$Common$Person$pickContacts),
						maybeOffer));
				var maybeFunneUrl = A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Common$Offer$pickId,
						A2(
							$elm$core$Basics$composeR,
							$author$project$ExternalUrl$FunnelOffer(env),
							$author$project$ExternalUrl$toString)),
					maybeOffer);
				var mappedRemoteData = A2(
					$krisajenkins$remotedata$RemoteData$mapError,
					$dillonkearns$elm_graphql$Graphql$Http$mapError($elm$core$Maybe$Just),
					A2($krisajenkins$remotedata$RemoteData$map, $elm$core$Maybe$Just, remoteData));
				var _v2 = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Common$Offer$requiresGreatLakesOptInConsent, maybeOffer) ? $author$project$Pyxis$Components$Modal$open(model.au) : _Utils_Tuple2(model.au, $elm$core$Platform$Cmd$none);
				var newConsentModalModel = _v2.a;
				var consentModalCmd = _v2.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Page$OfferDetails$maybeSetCoverSelectionAsLoading,
						maybeOffer,
						A2(
							$author$project$Page$OfferDetails$maybeSetPolicyHolderEmailAddress,
							policyHolderEmailAddress,
							A2(
								$author$project$Page$OfferDetails$maybeUpdatePaymentMethodIfRenewal,
								maybeOffer,
								A2(
									$author$project$Page$OfferDetails$Model$maybeAddSetEditCoverUrlToPortfolio,
									maybeOffer,
									A3(
										$author$project$Page$OfferDetails$Model$maybeAddSetOnEditToPortfolio,
										maybeFunneUrl,
										maybeOffer,
										A2(
											$author$project$Page$OfferDetails$Model$setGreatLakesOptInConsentModalForLanding,
											newConsentModalModel,
											A2(
												$author$project$Page$OfferDetails$Model$setOfferResult,
												mappedRemoteData,
												_Utils_update(
													model,
													{au: newConsentModalModel})))))))),
					$author$project$Page$OfferDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$OfferDetails$chooseEffectForCustomerId(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForClaimHistory(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForPaymentMethod(maybeOffer),
								$author$project$Page$OfferDetails$chooseEffectForCoverSelection(maybeOffer),
								$author$project$Page$OfferDetails$Effect$WithCmd(consentModalCmd)
							])));
			case 2:
				if (msg.a.$ === 3) {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$OfferDetails$Model$setClaimHistoryResult, remoteData, model),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Page$OfferDetails$Effect$None,
							A2(
								$elm$core$Maybe$map,
								$author$project$Page$OfferDetails$Effect$FetchPricingActionClaimHistory,
								$author$project$Page$OfferDetails$Model$pickOfferId(model))));
				} else {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$OfferDetails$Model$setClaimHistoryResult, remoteData, model),
						$author$project$Page$OfferDetails$Effect$None);
				}
			case 3:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$OfferDetails$Model$setClaimHistoryPricingActionResult, remoteData, model),
					$author$project$Page$OfferDetails$Effect$None);
			case 4:
				var remotedata = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$OfferDetails$Model$setCustomerId, remotedata, model),
					$author$project$Page$OfferDetails$Effect$None);
			case 5:
				if (msg.a.$ === 3) {
					var coverSelectionResult = msg.a;
					var coverSelection = coverSelectionResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ej: A2(
									$author$project$Common$ComponentUI$Modal$CoverPackages$withProductVersion,
									$author$project$Common$ComponentUI$Modal$CoverPackages$productVersionFromCoverSelection(coverSelection),
									model.ej),
								jZ: coverSelectionResult
							}),
						$author$project$Page$OfferDetails$Effect$None);
				} else {
					var coverSelection = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{jZ: coverSelection}),
						$author$project$Page$OfferDetails$Effect$None);
				}
			case 15:
				return _Utils_Tuple2(model, $author$project$Page$OfferDetails$Effect$None);
			case 6:
				var offer = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$OfferDetails$Effect$ChangeRoute(
						$author$project$Route$Payment(
							$author$project$Common$Offer$pickId(offer))));
			case 7:
				var searchQuery = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$OfferDetails$Effect$ChangeRoute(
						A2($author$project$Route$Search, $author$project$Page$Search$SearchQueryParam$defaultSearchContext, searchQuery)));
			case 21:
				if (msg.a) {
					var _v3 = $author$project$Pyxis$Components$Modal$open(model.C.iu);
					var newModalState = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								C: A2(
									$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
									false,
									A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel, newModalState, model.C))
							}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v4 = $author$project$Pyxis$Components$Modal$close(model.C.iu);
					var newModalState = _v4.a;
					var cmd = _v4.b;
					var newSendOfferEmailModel = $author$project$Common$ComponentUI$Modal$SendOfferEmail$resetCheckBoxGropup(
						A2(
							$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
							false,
							A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel, newModalState, model.C)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{C: newSendOfferEmailModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 16:
				if (msg.a) {
					var _v5 = $author$project$Common$ComponentUI$Modal$CoverPackages$open(model.ej);
					var newModalModel = _v5.a;
					var cmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ej: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v6 = $author$project$Common$ComponentUI$Modal$CoverPackages$close(model.ej);
					var newModalModel = _v6.a;
					var cmd = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ej: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 22:
				var value = msg.a;
				var _v7 = A2($author$project$Pyxis$Components$Field$CheckboxGroup$update, value, model.C.ck);
				var newModel = _v7.a;
				var cmd = _v7.b;
				var newSendOfferEmailModel = A2(
					$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
					false,
					A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateCheckBoxGroup, newModel, model.C));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{C: newSendOfferEmailModel}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 23:
				var options = msg.a;
				var trackEmails = $author$project$Page$OfferDetails$Effect$TrackSendEmail(
					A2($elm$core$List$map, $author$project$Common$ComponentUI$Modal$SendOfferEmail$optionToString, options));
				var sendEmailEffects = A2($elm$core$List$map, $author$project$Page$OfferDetails$Effect$SendOfferEmail, options);
				var _v8 = function () {
					if (!options.b) {
						return _Utils_Tuple2(model.C.iu, $elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Pyxis$Components$Modal$close(model.C.iu);
					}
				}();
				var newModalState = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							C: $author$project$Common$ComponentUI$Modal$SendOfferEmail$resetCheckBoxGropup(
								A2(
									$author$project$Common$ComponentUI$Modal$SendOfferEmail$updateIsSentEmailSubmitted,
									true,
									A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$updateModalModel, newModalState, model.C)))
						}),
					$author$project$Page$OfferDetails$Effect$Effects(
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Page$OfferDetails$Effect$WithCmd(cmd),
									trackEmails
								]),
							sendEmailEffects)));
			case 12:
				var offer = msg.a;
				if ($author$project$Common$Offer$requiresGreatLakesOptInConsent(offer)) {
					var _v10 = $author$project$Pyxis$Components$Modal$open(model.bQ);
					var newModalModel = _v10.a;
					var cmd = _v10.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bQ: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v11 = $author$project$Pyxis$Components$Modal$open(model.dE);
					var newModalState = _v11.a;
					var cmd = _v11.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dE: newModalState}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 13:
				var _v12 = $author$project$Pyxis$Components$Modal$close(model.dE);
				var newModalState = _v12.a;
				var cmd = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dE: newModalState}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 8:
				var offer = msg.a;
				var newCoverageEffectiveDate = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mw: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Page$OfferDetails$Effect$AmendOfferCoverageEffectiveDate,
						$author$project$Common$Offer$pickId(offer),
						newCoverageEffectiveDate));
			case 9:
				if ((msg.a.$ === 3) && (!msg.a.a.$)) {
					var _v13 = msg.a.a;
					var offerId = $author$project$Page$OfferDetails$fromMaybeOfferIdToString(
						$author$project$Page$OfferDetails$Model$pickCustomerFacingId(model));
					var _v14 = A2(
						$author$project$Pyxis$Components$Toasts$addNewToast,
						A2(
							$author$project$Pyxis$Components$Toasts$withToastText,
							$author$project$Translations$detailsToastAmendDateSuccessMessage(i18n),
							$author$project$Pyxis$Components$Toasts$successToast),
						model.t);
					var newToastsModel = _v14.a;
					var toastCmd = _v14.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{t: newToastsModel}),
						$author$project$Page$OfferDetails$Effect$Effects(
							_List_fromArray(
								[
									$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd),
									$author$project$Page$OfferDetails$Effect$FetchOffer(offerId)
								])));
				} else {
					var _v15 = A2(
						$author$project$Pyxis$Components$Toasts$addNewToast,
						A2(
							$author$project$Pyxis$Components$Toasts$withToastText,
							$author$project$Translations$detailsToastAmendDateErrorMessage(i18n),
							$author$project$Pyxis$Components$Toasts$errorToast),
						model.t);
					var newToastsModel = _v15.a;
					var toastCmd = _v15.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{t: newToastsModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd));
				}
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gj: $elm$core$Maybe$Just(date)
						}),
					$author$project$Page$OfferDetails$Effect$None);
			case 11:
				if (msg.a) {
					var _v16 = $author$project$Pyxis$Components$Modal$open(model.eh);
					var newModalModel = _v16.a;
					var cmd = _v16.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eh: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				} else {
					var _v17 = $author$project$Pyxis$Components$Modal$close(model.eh);
					var newModalModel = _v17.a;
					var cmd = _v17.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eh: newModalModel}),
						$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
				}
			case 14:
				var portfolioSubMsg = msg.a;
				var _v18 = A2($author$project$Common$Portfolio$update, portfolioSubMsg, model.dt);
				var newPortFolioModel = _v18.a;
				var cmd = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dt: newPortFolioModel}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 19:
				var offerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lq: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$OfferDetails$Effect$FetchPaymentMethod(offerId));
			case 20:
				var response = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lq: response}),
					$author$project$Page$OfferDetails$Effect$None);
			case 17:
				var toastCounterSubMsg = msg.a;
				var _v19 = A2($author$project$Pyxis$Components$Toasts$update, toastCounterSubMsg, model.t);
				var newToastsModel = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{t: newToastsModel}),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
			case 18:
				switch (msg.a.$) {
					case 2:
						var _v20 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$sendOfferEmailsGenericErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastsModel = _v20.a;
						var toastCmd = _v20.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsModel}),
							$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd));
					case 3:
						if (!msg.a.a.$) {
							var _v21 = msg.a.a;
							var _v22 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									A2($author$project$Translations$sendOfferEmailsSuccessMessage, model.C.iB, i18n),
									$author$project$Pyxis$Components$Toasts$successToast),
								model.t);
							var newToastsModel = _v22.a;
							var toastCmd = _v22.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{t: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$Effects(
									_List_fromArray(
										[
											$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd)
										])));
						} else {
							var reason = msg.a.a.a;
							var _v23 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailError, i18n, reason),
									$author$project$Pyxis$Components$Toasts$errorToast),
								model.t);
							var newToastsModel = _v23.a;
							var toastCmd = _v23.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{t: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$WithCmd(toastCmd));
						}
					default:
						return _Utils_Tuple2(model, $author$project$Page$OfferDetails$Effect$None);
				}
			case 24:
				var origin = msg.a;
				var offerId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dA: $krisajenkins$remotedata$RemoteData$Loading}),
					A2($author$project$Page$OfferDetails$Effect$SaveGreatLakesOptInConsent, offerId, origin));
			case 26:
				switch (msg.b.$) {
					case 3:
						if (!msg.a) {
							var _v24 = msg.a;
							var response = msg.b;
							var offerCfid = $author$project$Page$OfferDetails$fromMaybeOfferIdToString(
								$author$project$Page$OfferDetails$Model$pickCustomerFacingId(model));
							var _v25 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									$author$project$Translations$greatLakesOptInConsentModalSuccessToastMessage(i18n),
									$author$project$Pyxis$Components$Toasts$successToast),
								model.t);
							var newToastsModel = _v25.a;
							var toastsCmd = _v25.b;
							var _v26 = $author$project$Pyxis$Components$Modal$close(model.au);
							var newModalModel = _v26.a;
							var modalCmd = _v26.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{au: newModalModel, dA: response, t: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$Effects(
									_List_fromArray(
										[
											$author$project$Page$OfferDetails$Effect$WithCmd(modalCmd),
											$author$project$Page$OfferDetails$Effect$WithCmd(toastsCmd),
											$author$project$Page$OfferDetails$Effect$FetchOffer(offerCfid)
										])));
						} else {
							var _v27 = msg.a;
							var response = msg.b;
							var _v28 = A2(
								$author$project$Pyxis$Components$Toasts$addNewToast,
								A2(
									$author$project$Pyxis$Components$Toasts$withToastText,
									$author$project$Translations$greatLakesOptInConsentModalSuccessToastMessage(i18n),
									$author$project$Pyxis$Components$Toasts$successToast),
								model.t);
							var newToastsModel = _v28.a;
							var toastsCmd = _v28.b;
							var _v29 = $author$project$Pyxis$Components$Modal$open(model.bQ);
							var newDisclaimerModalModel = _v29.a;
							var disclaimerModalCmd = _v29.b;
							var _v30 = $author$project$Pyxis$Components$Modal$close(model.bQ);
							var newConsentModalModel = _v30.a;
							var consentModalCmd = _v30.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{bQ: newConsentModalModel, dA: response, dE: newDisclaimerModalModel, t: newToastsModel}),
								$author$project$Page$OfferDetails$Effect$Effects(
									_List_fromArray(
										[
											$author$project$Page$OfferDetails$Effect$WithCmd(consentModalCmd),
											$author$project$Page$OfferDetails$Effect$WithCmd(toastsCmd),
											$author$project$Page$OfferDetails$Effect$WithCmd(disclaimerModalCmd)
										])));
						}
					case 2:
						var origin = msg.a;
						var response = msg.b;
						var _v31 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$greatLakesOptInConsentModalErrorToastMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastsModel = _v31.a;
						var toastsCmd = _v31.b;
						var _v32 = A2($author$project$Page$OfferDetails$closeConsentModelWithOrigin, model, origin);
						var newModalModel = _v32.a;
						var cmd = _v32.b;
						return _Utils_Tuple2(
							A3(
								$author$project$Page$OfferDetails$Model$setConsentModalModelWithOrigin,
								origin,
								newModalModel,
								_Utils_update(
									model,
									{dA: response, t: newToastsModel})),
							$author$project$Page$OfferDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$OfferDetails$Effect$WithCmd(cmd),
										$author$project$Page$OfferDetails$Effect$WithCmd(toastsCmd)
									])));
					default:
						var response = msg.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dA: response}),
							$author$project$Page$OfferDetails$Effect$None);
				}
			default:
				var origin = msg.a;
				var _v33 = A2($author$project$Page$OfferDetails$closeConsentModelWithOrigin, model, origin);
				var newModalModel = _v33.a;
				var cmd = _v33.b;
				return _Utils_Tuple2(
					A3($author$project$Page$OfferDetails$Model$setConsentModalModelWithOrigin, origin, newModalModel, model),
					$author$project$Page$OfferDetails$Effect$WithCmd(cmd));
		}
	});
var $author$project$Page$Payment$Effect$ChangeRoute = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Payment$Effect$GoBack = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Payment$Effect$None = {$: 8};
var $author$project$Page$Payment$Effect$PayWithCreditCard = {$: 5};
var $author$project$Page$Payment$Effect$SetupBraintreeClient = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Payment$Effect$Purchase = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Payment$Model$ClientSideError = $elm$core$Basics$identity;
var $author$project$Page$Payment$Model$setPaymentClientError = F2(
	function (error, model) {
		return _Utils_update(
			model,
			{
				ij: $elm$core$Maybe$Just(error)
			});
	});
var $author$project$Page$Payment$Model$setClientError = F2(
	function (_v0, model) {
		var error = _v0.ka;
		var clientSideError = error;
		return A2($author$project$Page$Payment$Model$setPaymentClientError, clientSideError, model);
	});
var $author$project$Page$Payment$Model$setCreditCardFields = F2(
	function (fieldsValidation, model) {
		var cardFields = model.ea;
		var updateField = F2(
			function (field, _v1) {
				var id = _v1.kv;
				var isValid = _v1.bX;
				var isPristine = _v1.eS;
				var isFocused = _v1.eN;
				return _Utils_update(
					field,
					{kv: id, eN: isFocused, eS: isPristine, bX: isValid});
			});
		var updatedFields = A3(
			$elm$core$List$foldl,
			F2(
				function (field, current) {
					var _v0 = field.kv;
					switch (_v0) {
						case 'credit-card-number':
							return _Utils_update(
								current,
								{
									cL: A2(updateField, current.cL, field)
								});
						case 'credit-card-expiration-date':
							return _Utils_update(
								current,
								{
									cW: A2(updateField, current.cW, field)
								});
						default:
							return current;
					}
				}),
			cardFields,
			fieldsValidation);
		return _Utils_update(
			model,
			{ea: updatedFields});
	});
var $author$project$Page$Payment$Model$PaymentNotReady = 2;
var $author$project$Page$Payment$Model$PaymentReady = 1;
var $author$project$Page$Payment$Model$setStatusCreditCardReady = F2(
	function (isReady, model) {
		var newStatus = isReady ? 1 : 2;
		return _Utils_update(
			model,
			{iR: newStatus});
	});
var $author$project$Page$Payment$handlePaymentEvent = F2(
	function (paymentMsg, model) {
		switch (paymentMsg.$) {
			case 0:
				var creditCardFieldValidations = paymentMsg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setCreditCardFields, creditCardFieldValidations, model),
					$author$project$Page$Payment$Effect$None);
			case 1:
				var clientErrorEvent = paymentMsg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setClientError, clientErrorEvent, model),
					$author$project$Page$Payment$Effect$None);
			case 2:
				var isReady = paymentMsg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setStatusCreditCardReady, isReady, model),
					$author$project$Page$Payment$Effect$None);
			default:
				var nonce = paymentMsg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Payment$Effect$Purchase(nonce));
		}
	});
var $author$project$Referer$paymentPage = 0;
var $author$project$Page$Payment$Model$setGotBraintreeTokenResult = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{gO: remoteData});
	});
var $author$project$Page$Payment$Model$setGotOfferProductResult = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{gP: remoteData});
	});
var $author$project$Page$Payment$Model$setGotPolicyResult = F2(
	function (remoteData, model) {
		return _Utils_update(
			model,
			{gQ: remoteData});
	});
var $author$project$Page$Payment$Model$PayingWithCreditCard = 3;
var $author$project$Page$Payment$Model$setStatusPayingWithCreditCard = function (model) {
	return _Utils_update(
		model,
		{iR: 3});
};
var $author$project$Page$Payment$Model$PaymentFailed = 4;
var $author$project$Page$Payment$Model$PaymentSuccess = 5;
var $author$project$Page$Payment$Model$setStatusPayment = F2(
	function (remoteData, model) {
		switch (remoteData.$) {
			case 2:
				return _Utils_update(
					model,
					{iR: 4});
			case 3:
				return _Utils_update(
					model,
					{iR: 5});
			default:
				return model;
		}
	});
var $krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var $author$project$Page$Payment$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setGotBraintreeTokenResult, remoteData, model),
					A3($krisajenkins$remotedata$RemoteData$unwrap, $author$project$Page$Payment$Effect$None, $author$project$Page$Payment$Effect$SetupBraintreeClient, remoteData));
			case 4:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$Payment$Model$setGotOfferProductResult, remoteData, model),
					$author$project$Page$Payment$Effect$None);
			case 5:
				var remoteData = msg.a;
				var updatedModel = A2(
					$author$project$Page$Payment$Model$setStatusPayment,
					remoteData,
					A2($author$project$Page$Payment$Model$setGotPolicyResult, remoteData, model));
				var newEffect = A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					$author$project$Page$Payment$Effect$None,
					function (policyId) {
						return $author$project$Page$Payment$Effect$ChangeRoute(
							A2(
								$author$project$Route$PolicyDetails,
								policyId,
								$elm$core$Maybe$Just($author$project$Referer$paymentPage)));
					},
					remoteData);
				return _Utils_Tuple2(updatedModel, newEffect);
			case 1:
				var paymentMsg = msg.a;
				return A2($author$project$Page$Payment$handlePaymentEvent, paymentMsg, model);
			case 6:
				return _Utils_Tuple2(
					$author$project$Page$Payment$Model$setStatusPayingWithCreditCard(model),
					$author$project$Page$Payment$Effect$PayWithCreditCard);
			case 0:
				return _Utils_Tuple2(model, $author$project$Page$Payment$Effect$None);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Page$Payment$Effect$GoBack(1));
		}
	});
var $author$project$Page$PolicyDetails$Effect$ChangeRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$PolicyDetails$Effect$CreateRefund = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$PolicyDetails$Effect$CustomerTerminatePolicy = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchCoverSelection = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchCustomerId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchPaymentMethod = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$PolicyDetails$Effect$FetchPricingActionClaimHistory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$PolicyDetails$Effect$GetExpectedRefund = {$: 9};
var $author$project$Page$PolicyDetails$Effect$IssueRefund = function (a) {
	return {$: 15, a: a};
};
var $author$project$Page$PolicyDetails$Effect$None = {$: 31};
var $author$project$Page$PolicyDetails$Effect$PayRefund = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$PolicyDetails$Effect$PollForRefundUpdate = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$PollRefundForCompletion = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$PolicyDetails$Effect$PrimaTerminatePolicy = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$PolicyDetails$Effect$RenewalCancellation = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$PolicyDetails$Effect$SendPolicyContractEmail = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$PolicyDetails$Effect$TrackSendEmail = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$PolicyDetails$Effect$UpdateEmail = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundUpdate = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$WithCmd = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$PolicyDetails$Effect$WithdrawPolicy = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$isDifferent = F2(
	function (modelA, modelB) {
		return !_Utils_eq(modelA, modelB);
	});
var $author$project$Page$PolicyDetails$applyIfInterruptionModelChanged = F3(
	function (model, interruptionModal, effect) {
		return A2($author$project$Page$PolicyDetails$InterruptionModal$Model$isDifferent, interruptionModal, model.q) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{q: interruptionModal}),
			effect) : _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
	});
var $author$project$Translations$changeEmailModalErrorToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'It was not possible to change the email address. Please refresh the page to try again.';
	} else {
		return 'No ha sido posible cambiar el dirección de email. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$changeEmailModalSuccessToastMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The email address was changed successfully.';
	} else {
		return 'El dirección de email ha cambiado correctamente.';
	}
};
var $author$project$Page$PolicyDetails$Effect$FetchClaimHistory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Policy$pickQuoteId = function (_v0) {
	var policy = _v0;
	return policy.pf;
};
var $author$project$Page$PolicyDetails$chooseClaimHistoryEffectByFetchedPolicy = function (policy) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$PolicyDetails$Effect$None,
		A2(
			$elm$core$Maybe$map,
			$author$project$Page$PolicyDetails$Effect$FetchClaimHistory,
			$author$project$Common$Policy$pickQuoteId(policy)));
};
var $author$project$Page$PolicyDetails$Effect$GetRefund = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$PolicyDetails$chooseEffectForInterruptedPolicy = F3(
	function (policyId, issueRefundReleaseDate, interruption) {
		return (_Utils_cmp(
			$elm$time$Time$posixToMillis(issueRefundReleaseDate),
			$elm$time$Time$posixToMillis(interruption.mB)) < 0) ? $author$project$Page$PolicyDetails$Effect$GetRefund(policyId) : $author$project$Page$PolicyDetails$Effect$None;
	});
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Policy$pickInterruption = function (_v0) {
	var policy = _v0;
	return policy.c2;
};
var $author$project$Page$PolicyDetails$chooseGetRefundEffectByFetchedPolicy = F3(
	function (model, issueRefundReleaseDate, policy) {
		return (!$krisajenkins$remotedata$RemoteData$isLoading(model.pk)) ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Page$PolicyDetails$Effect$None,
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$Page$PolicyDetails$chooseEffectForInterruptedPolicy,
					$author$project$Common$Policy$pickId(policy),
					issueRefundReleaseDate),
				$author$project$Common$Policy$pickInterruption(policy))) : $author$project$Page$PolicyDetails$Effect$None;
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Model = $elm$core$Basics$identity;
var $author$project$Page$PolicyDetails$AmendInterruptionModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cx);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cx: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss = {$: 0};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Opened = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pyxis$Components$Field$Input$getValue = function (_v0) {
	var value = _v0.pR;
	return value;
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[^@\\s]+@[^@\\s]+'));
var $author$project$Page$PolicyDetails$ChangeEmailModal$isInputValid = function (emailInput) {
	return (!$elm$core$String$isEmpty(emailInput)) && A2($elm$regex$Regex$contains, $author$project$Page$PolicyDetails$ChangeEmailModal$emailRegex, emailInput);
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility = function (_v0) {
	var visibility = _v0.cx;
	if (!visibility.$) {
		var visibilityStatus = visibility.a;
		return visibilityStatus;
	} else {
		var visibilityStatus = visibility.a;
		return visibilityStatus;
	}
};
var $author$project$Pyxis$Components$Field$Input$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				eB: mapper(model.eB)
			});
	});
var $author$project$Pyxis$Components$Field$Input$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hR)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Input$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h_)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Input$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			case 0:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h0)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Input$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						_Utils_update(
							modelData,
							{pR: value})));
			default:
				var event = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(
							A2($author$project$Pyxis$Commons$Basics$maybeForwardValue, event, modelData.h4))
						]),
					model);
		}
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 0:
				var _v1 = $author$project$Pyxis$Components$Modal$close(
					$author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility(model));
				var visibility = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{
							cx: $author$project$Page$PolicyDetails$ChangeEmailModal$Closed(visibility)
						}),
					cmd);
			case 1:
				var email = msg.a;
				var newInputModel = A2($author$project$Pyxis$Components$Field$Input$setValue, email, modelData.a3);
				var _v2 = $author$project$Pyxis$Components$Modal$open(
					$author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility(model));
				var visibility = _v2.a;
				var cmd = _v2.b;
				var newModalVisibility = A2($author$project$Page$PolicyDetails$ChangeEmailModal$Opened, visibility, email);
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{a3: newInputModel, cx: newModalVisibility}),
					cmd);
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Pyxis$Components$Field$Input$update, subMsg, modelData.a3);
				var newInputModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{a3: newInputModel}),
					cmd);
			case 3:
				var inputValue = $author$project$Pyxis$Components$Field$Input$getValue(modelData.a3);
				return $author$project$Page$PolicyDetails$ChangeEmailModal$isInputValid(inputValue) ? _Utils_Tuple2(
					_Utils_update(
						modelData,
						{c5: true}),
					$author$project$Pyxis$Commons$Commands$dispatch(
						modelData.k0(inputValue))) : _Utils_Tuple2(
					_Utils_update(
						modelData,
						{c5: true}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						modelData,
						{c5: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$closeModal = $author$project$Page$PolicyDetails$ChangeEmailModal$update($author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss);
var $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cx);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cx: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cx);
	var newVisibility = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cx: newVisibility}),
		cmd);
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cx);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cx: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$SendEmailModal$closeModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$close(model.cx);
	var newVisibility = _v1.a;
	var cmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cx: newVisibility}),
		cmd);
};
var $author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundCompletion = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$PolicyDetails$Model$setRefundResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{pk: result});
	});
var $author$project$Page$PolicyDetails$continuePolling = F2(
	function (model, policyId) {
		return _Utils_Tuple2(
			A2($author$project$Page$PolicyDetails$Model$setRefundResult, $krisajenkins$remotedata$RemoteData$Loading, model),
			$author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundCompletion(policyId));
	});
var $author$project$Page$PolicyDetails$SendEmailModal$emailOptionToString = 'policy contract';
var $author$project$Common$Refund$isPendingOrNotRequired = function (_v0) {
	var status = _v0.b;
	return (!status) || (status === 4);
};
var $author$project$Common$Refund$isToBePaid = function (_v0) {
	var status = _v0.b;
	return status === 1;
};
var $author$project$Page$PolicyDetails$Effect$GetExpectedRefundForAmendInterruption = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Pyxis$Components$Field$DateInput$getValue = function (_v0) {
	var value = _v0.pR;
	return value;
};
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.pW;
		var month = _v0.n2;
		var day = _v0.mZ;
		var hour = _v0.nx;
		var minute = _v0.n0;
		var second = _v0.pw;
		var millisecond = _v0.n_;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Common$Locale$midnightAtCustomerDate = function (date) {
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$author$project$Common$Locale$customerTimeZone,
		{
			mZ: $justinmimbs$date$Date$day(date),
			nx: 0,
			n_: 0,
			n0: 0,
			n2: $justinmimbs$date$Date$month(date),
			pw: 0,
			pW: $justinmimbs$date$Date$year(date)
		});
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$pickDateValue = function (_v0) {
	var interruptionDateInput = _v0.aL;
	return A2(
		$elm$core$Maybe$map,
		$author$project$Common$Locale$midnightAtCustomerDate,
		$elm$core$Result$toMaybe(
			$justinmimbs$date$Date$fromIsoString(
				$author$project$Pyxis$Components$Field$DateInput$getValue(interruptionDateInput))));
};
var $author$project$Pyxis$Components$Field$Autocomplete$getValue = function (_v0) {
	var value = _v0.pR;
	return value;
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$pickReasonValue = function (_v0) {
	var reasonInput = _v0.aQ;
	return $author$project$Pyxis$Components$Field$Autocomplete$getValue(reasonInput);
};
var $author$project$Page$PolicyDetails$maybeGetExpectedRefundForAmendInterruption = function (oldState) {
	var model = oldState.a;
	var effect = oldState.b;
	var updateModelAndEffect = F3(
		function (reason, policyId, interruptionAt) {
			return A2(
				$elm$core$Tuple$pair,
				model,
				$author$project$Page$PolicyDetails$Effect$Effects(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[effect]),
						$elm$core$List$singleton(
							A3($author$project$Page$PolicyDetails$Effect$GetExpectedRefundForAmendInterruption, reason, policyId, interruptionAt)))));
		});
	var maybeReason = A2($elm$core$Maybe$andThen, $author$project$Page$PolicyDetails$AmendInterruptionModal$pickReasonValue, model.W);
	var maybePolicyId = A2(
		$elm$core$Maybe$map,
		$author$project$Common$Policy$pickId,
		$krisajenkins$remotedata$RemoteData$toMaybe(model.l));
	var maybeInterruptionAt = A2($elm$core$Maybe$andThen, $author$project$Page$PolicyDetails$AmendInterruptionModal$pickDateValue, model.W);
	return A2(
		$elm$core$Maybe$withDefault,
		oldState,
		A4($elm$core$Maybe$map3, updateModelAndEffect, maybeReason, maybePolicyId, maybeInterruptionAt));
};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionDateSelected = {$: 57};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionModalSubmitErrored = {$: 60};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonChanged = function (a) {
	return {$: 53, a: a};
};
var $author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonSelected = {$: 54};
var $author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDate = function (a) {
	return {$: 56, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDescription = function (a) {
	return {$: 55, a: a};
};
var $author$project$Page$PolicyDetails$Msg$DismissAmendModal = {$: 51};
var $author$project$Page$PolicyDetails$Msg$SubmitAmendInterruptionModal = F4(
	function (a, b, c, d) {
		return {$: 52, a: a, b: b, c: c, d: d};
	});
var $author$project$Translations$interruptionCompetitorOffer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Competitor offer';
	} else {
		return 'Competencia';
	}
};
var $author$project$Translations$interruptionCoverageChange = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Coverage change';
	} else {
		return 'Cambio cobertura';
	}
};
var $author$project$Translations$interruptionDeceasedPolicyHolder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Deceased policy holder';
	} else {
		return 'Fallecimiento';
	}
};
var $author$project$Translations$interruptionDissatisfactionService = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Unsatisfied';
	} else {
		return 'Insatisfacción';
	}
};
var $author$project$Translations$interruptionDoesNotKnow = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Doesn\'t know / doesn\'t reply';
	} else {
		return 'NS/NC';
	}
};
var $author$project$Translations$interruptionIncorrectDataOther = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect data - Other';
	} else {
		return 'Datos incorrectos - Otro';
	}
};
var $author$project$Translations$interruptionIncorrectEffectiveDate = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect start date';
	} else {
		return 'Fecha de inicio incorrecta';
	}
};
var $author$project$Translations$interruptionIncorrectPersonalData = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect personal data';
	} else {
		return 'Datos personales incorrectos';
	}
};
var $author$project$Translations$interruptionMovingToAnotherCountry = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Moving To another country';
	} else {
		return 'Mudanza al extranjero';
	}
};
var $author$project$Translations$interruptionNoInsuranceWanted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Leaves vehicle uninsured';
	} else {
		return 'Deja sin seguro';
	}
};
var $author$project$Translations$interruptionOther = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Other';
	} else {
		return 'Otro';
	}
};
var $author$project$Translations$interruptionPaymentMethodOrDate = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Payment method / date';
	} else {
		return 'Fecha de pago';
	}
};
var $author$project$Translations$interruptionPolicyHolderChange = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy holder change';
	} else {
		return 'Cambio de titular';
	}
};
var $author$project$Translations$interruptionProductService = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Product service';
	} else {
		return 'Producto/servicio';
	}
};
var $author$project$Translations$interruptionSwitchToGreatLakes = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Switch to Great Lakes';
	} else {
		return 'Cambio a Great Lakes';
	}
};
var $author$project$Translations$interruptionUnderwritingRules = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Underwriting rules';
	} else {
		return 'Normas de suscripción';
	}
};
var $author$project$Translations$interruptionVehicleDeregistration = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle deregistration';
	} else {
		return 'Baja del vehículo';
	}
};
var $author$project$Translations$interruptionVehicleNotPurchased = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle not purchased';
	} else {
		return 'No compra vehículo';
	}
};
var $author$project$Translations$interruptionVehicleSold = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle sold';
	} else {
		return 'Venta';
	}
};
var $author$project$Translations$interruptionWantsGreenCard = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Needs Carta Verde';
	} else {
		return 'Necesidad de Carta Verde';
	}
};
var $author$project$Common$AmendReason$customerReasonLabel = F2(
	function (i18n, customerReason) {
		switch (customerReason) {
			case 0:
				return $author$project$Translations$interruptionCompetitorOffer(i18n);
			case 1:
				return $author$project$Translations$interruptionVehicleSold(i18n);
			case 2:
				return $author$project$Translations$interruptionVehicleNotPurchased(i18n);
			case 3:
				return $author$project$Translations$interruptionVehicleDeregistration(i18n);
			case 4:
				return $author$project$Translations$interruptionNoInsuranceWanted(i18n);
			case 5:
				return $author$project$Translations$interruptionDoesNotKnow(i18n);
			case 6:
				return $author$project$Translations$interruptionWantsGreenCard(i18n);
			case 7:
				return $author$project$Translations$interruptionIncorrectEffectiveDate(i18n);
			case 8:
				return $author$project$Translations$interruptionIncorrectPersonalData(i18n);
			case 9:
				return $author$project$Translations$interruptionIncorrectDataOther(i18n);
			case 10:
				return $author$project$Translations$interruptionPaymentMethodOrDate(i18n);
			case 11:
				return $author$project$Translations$interruptionDeceasedPolicyHolder(i18n);
			case 12:
				return $author$project$Translations$interruptionCoverageChange(i18n);
			case 13:
				return $author$project$Translations$interruptionDissatisfactionService(i18n);
			case 14:
				return $author$project$Translations$interruptionUnderwritingRules(i18n);
			case 15:
				return $author$project$Translations$interruptionMovingToAnotherCountry(i18n);
			case 16:
				return $author$project$Translations$interruptionProductService(i18n);
			case 17:
				return $author$project$Translations$interruptionPolicyHolderChange(i18n);
			case 18:
				return $author$project$Translations$interruptionSwitchToGreatLakes(i18n);
			default:
				return $author$project$Translations$interruptionOther(i18n);
		}
	});
var $author$project$Translations$interruptionChargeback = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Chargeback';
	} else {
		return 'Impago';
	}
};
var $author$project$Translations$interruptionFraud = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Fraud';
	} else {
		return 'Fraude';
	}
};
var $author$project$Translations$interruptionInexactDeclarationDni = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inexact declaration - DNI';
	} else {
		return 'Declaración inexacta - DNI';
	}
};
var $author$project$Translations$interruptionInexactDeclarationSinco = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inexact declaration - SINCO';
	} else {
		return 'Declaración inexacta - SINCO';
	}
};
var $author$project$Translations$interruptionPhotoVericiationNotProvided = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Photo verification not provided';
	} else {
		return 'Fotoverificación no enviada';
	}
};
var $author$project$Translations$interruptionRiskAggravation = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Risk aggravation';
	} else {
		return 'Agravación del riesgo';
	}
};
var $author$project$Common$AmendReason$primaReasonLabel = F2(
	function (i18n, primaReason) {
		switch (primaReason) {
			case 0:
				return $author$project$Translations$interruptionInexactDeclarationSinco(i18n);
			case 1:
				return $author$project$Translations$interruptionFraud(i18n);
			case 2:
				return $author$project$Translations$interruptionChargeback(i18n);
			case 3:
				return $author$project$Translations$interruptionInexactDeclarationDni(i18n);
			case 4:
				return $author$project$Translations$interruptionRiskAggravation(i18n);
			default:
				return $author$project$Translations$interruptionPhotoVericiationNotProvided(i18n);
		}
	});
var $author$project$Common$AmendReason$amendReasonLabel = F2(
	function (i18n, reason) {
		if (!reason.$) {
			var primaReason = reason.a;
			return A2($author$project$Common$AmendReason$primaReasonLabel, i18n, primaReason);
		} else {
			var customerReason = reason.a;
			return A2($author$project$Common$AmendReason$customerReasonLabel, i18n, customerReason);
		}
	});
var $author$project$Common$AmendReason$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$AmendReason$CompetitorOffer = 0;
var $author$project$Common$AmendReason$Customer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$AmendReason$InexactDeclarationSinco = 0;
var $author$project$Common$AmendReason$defaultFromAmendType = function (amendKind) {
	if (!amendKind) {
		return $author$project$Common$AmendReason$Company(0);
	} else {
		return $author$project$Common$AmendReason$Customer(0);
	}
};
var $author$project$Common$AmendReason$Chargeback = 2;
var $author$project$Common$AmendReason$Fraud = 1;
var $author$project$Common$AmendReason$InexactDeclarationDni = 3;
var $author$project$Common$AmendReason$PhotoVerificationNotProvided = 5;
var $author$project$Common$AmendReason$RiskAggravation = 4;
var $author$project$Common$AmendReason$nextCompany = function (list) {
	var _v0 = $elm$core$List$head(list);
	if (_v0.$ === 1) {
		return $author$project$Common$AmendReason$nextCompany(
			A2($elm$core$List$cons, 0, list));
	} else {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 1, list));
			case 1:
				var _v2 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 2, list));
			case 2:
				var _v3 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 3, list));
			case 3:
				var _v4 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 4, list));
			case 4:
				var _v5 = _v0.a;
				return $author$project$Common$AmendReason$nextCompany(
					A2($elm$core$List$cons, 5, list));
			default:
				var _v6 = _v0.a;
				return list;
		}
	}
};
var $author$project$Common$AmendReason$allCompanyReason = $elm$core$List$reverse(
	$author$project$Common$AmendReason$nextCompany(_List_Nil));
var $author$project$Common$AmendReason$CoverageChange = 12;
var $author$project$Common$AmendReason$DeceasedPolicyHolder = 11;
var $author$project$Common$AmendReason$DissatisfactionService = 13;
var $author$project$Common$AmendReason$DoesNotKnow = 5;
var $author$project$Common$AmendReason$IncorrectDataOther = 9;
var $author$project$Common$AmendReason$IncorrectEffectiveDate = 7;
var $author$project$Common$AmendReason$IncorrectPersonalData = 8;
var $author$project$Common$AmendReason$MovingToAnotherCountry = 15;
var $author$project$Common$AmendReason$NoInsuranceWanted = 4;
var $author$project$Common$AmendReason$Other = 19;
var $author$project$Common$AmendReason$PaymentMethodOrDate = 10;
var $author$project$Common$AmendReason$PolicyHolderChange = 17;
var $author$project$Common$AmendReason$ProductService = 16;
var $author$project$Common$AmendReason$SwitchToGreatLakes = 18;
var $author$project$Common$AmendReason$UnderwritingRules = 14;
var $author$project$Common$AmendReason$VehicleDeregistration = 3;
var $author$project$Common$AmendReason$VehicleNotPurchased = 2;
var $author$project$Common$AmendReason$VehicleSold = 1;
var $author$project$Common$AmendReason$WantsGreenCard = 6;
var $author$project$Common$AmendReason$nextCustomer = function (list) {
	var _v0 = $elm$core$List$head(list);
	if (_v0.$ === 1) {
		return $author$project$Common$AmendReason$nextCustomer(
			A2($elm$core$List$cons, 0, list));
	} else {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 1, list));
			case 1:
				var _v2 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 2, list));
			case 2:
				var _v3 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 3, list));
			case 3:
				var _v4 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 4, list));
			case 4:
				var _v5 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 5, list));
			case 5:
				var _v6 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 6, list));
			case 6:
				var _v7 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 7, list));
			case 7:
				var _v8 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 8, list));
			case 8:
				var _v9 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 9, list));
			case 9:
				var _v10 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 10, list));
			case 10:
				var _v11 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 11, list));
			case 11:
				var _v12 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 12, list));
			case 12:
				var _v13 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 13, list));
			case 13:
				var _v14 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 14, list));
			case 14:
				var _v15 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 15, list));
			case 15:
				var _v16 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 16, list));
			case 16:
				var _v17 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 17, list));
			case 17:
				var _v18 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 18, list));
			case 18:
				var _v19 = _v0.a;
				return $author$project$Common$AmendReason$nextCustomer(
					A2($elm$core$List$cons, 19, list));
			default:
				var _v20 = _v0.a;
				return list;
		}
	}
};
var $author$project$Common$AmendReason$allCustomerReason = $elm$core$List$reverse(
	$author$project$Common$AmendReason$nextCustomer(_List_Nil));
var $author$project$Common$AmendReason$amendReasons = _Utils_ap(
	A2($elm$core$List$map, $author$project$Common$AmendReason$Company, $author$project$Common$AmendReason$allCompanyReason),
	A2($elm$core$List$map, $author$project$Common$AmendReason$Customer, $author$project$Common$AmendReason$allCustomerReason));
var $author$project$Common$AmendReason$isCompanyReason = function (reason) {
	if (!reason.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$AmendReason$companyReasons = A2($elm$core$List$filter, $author$project$Common$AmendReason$isCompanyReason, $author$project$Common$AmendReason$amendReasons);
var $author$project$Common$AmendReason$customerReasons = A2($elm$core$List$filter, $author$project$Common$AmendReason$isCustomerReason, $author$project$Common$AmendReason$amendReasons);
var $author$project$Common$AmendReason$fromAmendInterruptionType = function (amendKind) {
	if (!amendKind) {
		return $author$project$Common$AmendReason$companyReasons;
	} else {
		return $author$project$Common$AmendReason$customerReasons;
	}
};
var $author$project$Common$AmendReason$fromInterruptionReason = function (intReason) {
	switch (intReason) {
		case 0:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(2));
		case 1:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(0));
		case 2:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(12));
		case 3:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(11));
		case 4:
			return $elm$core$Maybe$Nothing;
		case 5:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(13));
		case 6:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(5));
		case 7:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(1));
		case 8:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(9));
		case 9:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(7));
		case 10:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(8));
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(3));
		case 14:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(0));
		case 15:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(15));
		case 16:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(4));
		case 17:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(19));
		case 19:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(10));
		case 20:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(17));
		case 21:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(16));
		case 22:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(4));
		case 25:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(14));
		case 26:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(3));
		case 27:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(2));
		case 28:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(3));
		case 29:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(1));
		case 30:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(6));
		case 32:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Company(5));
		case 33:
			return $elm$core$Maybe$Just(
				$author$project$Common$AmendReason$Customer(18));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Pristine = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Autocomplete$option = function (_v0) {
	var value = _v0.pR;
	var label = _v0.eY;
	return {kv: 'id-' + label, eY: label, pR: value};
};
var $author$project$Pyxis$Components$Field$DateInput$setOnInput = F2(
	function (msg, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				h0: $elm$core$Maybe$Just(msg)
			});
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getOptionData = function (_v0) {
	var optionData = _v0;
	return optionData;
};
var $author$project$Pyxis$Components$Field$Autocomplete$getOptions = function (_v0) {
	var modelData = _v0;
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.eY;
				},
				modelData.bN(modelData.F))),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$krisajenkins$remotedata$RemoteData$toMaybe(modelData.ax)));
};
var $author$project$Pyxis$Components$Field$Autocomplete$setActiveOption = F2(
	function (option_, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{J: option_});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$initializeActiveOption = function (model) {
	var value = model.pR;
	if (!value.$) {
		var currentValue = value.a;
		return A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$author$project$Pyxis$Components$Field$Autocomplete$setActiveOption,
			model,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pR;
						},
						$elm$core$Basics$eq(currentValue))),
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)));
	} else {
		return A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$author$project$Pyxis$Components$Field$Autocomplete$setActiveOption,
			model,
			$elm$core$List$head(
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)));
	}
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Field$Autocomplete$setOptions = F2(
	function (optionsRemoteData, _v0) {
		var modelData = _v0;
		var values = A2(
			$krisajenkins$remotedata$RemoteData$mapError,
			$elm$core$Basics$always(0),
			optionsRemoteData);
		return $author$project$Pyxis$Components$Field$Autocomplete$initializeActiveOption(
			_Utils_update(
				modelData,
				{
					a7: $krisajenkins$remotedata$RemoteData$isSuccess(optionsRemoteData),
					ax: values
				}));
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$init = function (onDismiss) {
	return function (onSubmit) {
		return function (onSubmitError) {
			return function (onReasonChanged) {
				return function (onReasonSelected) {
					return function (onDescriptionChanges) {
						return function (onInterruptionDateChanges) {
							return function (onInterruptionDateSelected) {
								return function (policyStartDate) {
									return function (earliestSelectableDate) {
										return function (latestSelectableDate) {
											return function (reasons) {
												return function (descriptionStatusMapper) {
													return function (defaultReason) {
														var reasonsOptions = A2(
															$elm$core$List$map,
															$author$project$Pyxis$Components$Field$Autocomplete$option,
															A2(
																$elm$core$List$sortBy,
																function ($) {
																	return $.eY;
																},
																reasons));
														return {
															m0: defaultReason,
															aE: $author$project$Pyxis$Components$Field$Textarea$init,
															bJ: 3,
															gr: descriptionStatusMapper,
															a2: earliestSelectableDate,
															nc: $krisajenkins$remotedata$RemoteData$NotAsked,
															aH: 0,
															g0: $elm$core$Maybe$Nothing,
															aL: A2($author$project$Pyxis$Components$Field$DateInput$setOnInput, onInterruptionDateSelected, $author$project$Pyxis$Components$Field$DateInput$init),
															a9: latestSelectableDate,
															k3: onDescriptionChanges,
															hZ: onDismiss,
															k5: onInterruptionDateChanges,
															lg: onReasonChanged,
															lj: onSubmit,
															lk: onSubmitError,
															lu: policyStartDate,
															aQ: A2(
																$author$project$Pyxis$Components$Field$Autocomplete$setOnSelect,
																onReasonSelected,
																A2(
																	$author$project$Pyxis$Components$Field$Autocomplete$setOptions,
																	$krisajenkins$remotedata$RemoteData$Success(reasonsOptions),
																	$author$project$Pyxis$Components$Field$Autocomplete$init)),
															cx: $author$project$Pyxis$Components$Modal$init('edit-policy-interruption-modal')
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Dirty = 1;
var $author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed = function (_v0) {
	var modelData = _v0;
	return _Utils_update(
		modelData,
		{J: $elm$core$Maybe$Nothing, eG: false, a7: false, bV: false});
};
var $author$project$Pyxis$Components$Field$Autocomplete$setSelectedOption = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				fn: A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pR;
							},
							$elm$core$Basics$eq(value))),
					$author$project$Pyxis$Components$Field$Autocomplete$getOptions(modelData))
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getLabelByValue = F2(
	function (model, value) {
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
				function ($) {
					return $.eY;
				}),
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pR;
						},
						$elm$core$Basics$eq(value))),
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$updateFilteringValue = function (model) {
	var modelData = model;
	var filteringValue = A2(
		$elm$core$Maybe$withDefault,
		modelData.F,
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Pyxis$Components$Field$Autocomplete$getLabelByValue(model),
			modelData.pR));
	return _Utils_update(
		modelData,
		{F: filteringValue});
};
var $author$project$Pyxis$Components$Field$Autocomplete$updateSelectedValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				pR: $elm$core$Maybe$Just(value)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setValue = F2(
	function (value, model) {
		return $author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed(
			$author$project$Pyxis$Components$Field$Autocomplete$updateFilteringValue(
				A2(
					$author$project$Pyxis$Components$Field$Autocomplete$setSelectedOption,
					value,
					A2($author$project$Pyxis$Components$Field$Autocomplete$updateSelectedValue, value, model))));
	});
var $author$project$Pyxis$Components$Field$DateInput$setValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{pR: value});
	});
var $author$project$Pyxis$Components$Field$Textarea$setValue = F2(
	function (value, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{pR: value});
	});
var $author$project$Common$Locale$toIsoString = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$fromPosix($author$project$Common$Locale$customerTimeZone),
	$justinmimbs$date$Date$toIsoString);
var $author$project$Page$PolicyDetails$AmendInterruptionModal$setInitialValues = F2(
	function (initialValues, _v0) {
		var modelData = _v0;
		var stringDate = $author$project$Common$Locale$toIsoString(initialValues.g1);
		var newReasonModel = A2(
			$elm$core$Maybe$withDefault,
			modelData.aQ,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return A2($author$project$Pyxis$Components$Field$Autocomplete$setValue, value, modelData.aQ);
				},
				initialValues.iA));
		var newDescriptionStatus = A2(
			$elm$core$Maybe$withDefault,
			3,
			A2($elm$core$Maybe$map, modelData.gr, initialValues.iA));
		var newDescriptionModel = A2(
			$elm$core$Maybe$withDefault,
			modelData.aE,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return A2($author$project$Pyxis$Components$Field$Textarea$setValue, value, modelData.aE);
				},
				initialValues.m1));
		return _Utils_update(
			modelData,
			{
				aE: newDescriptionModel,
				bJ: newDescriptionStatus,
				aH: 1,
				g0: $elm$core$Maybe$Just(initialValues),
				aL: A2($author$project$Pyxis$Components$Field$DateInput$setValue, stringDate, modelData.aL),
				aQ: newReasonModel
			});
	});
var $author$project$Common$Policy$startDateTime = function (_v0) {
	var policy = _v0;
	return $author$project$Common$Locale$midnightAtCustomerDate(policy.l_);
};
var $author$project$Common$ReasonDescriptionStatus$Mandatory = 0;
var $author$project$Common$ReasonDescriptionStatus$NotRequired = 2;
var $author$project$Common$ReasonDescriptionStatus$Optional = 1;
var $author$project$Common$AmendReason$customerReasonToDescriptionStatus = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 7:
			return 2;
		case 8:
			return 1;
		case 9:
			return 1;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 16:
			return 1;
		case 17:
			return 1;
		case 18:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Common$AmendReason$primaReasonToDescriptionStatus = function (reason) {
	switch (reason) {
		case 2:
			return 2;
		case 0:
			return 2;
		case 1:
			return 1;
		case 3:
			return 2;
		case 4:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Common$AmendReason$toDescriptionStatus = function (reason) {
	if (!reason.$) {
		var primaReason = reason.a;
		return $author$project$Common$AmendReason$primaReasonToDescriptionStatus(primaReason);
	} else {
		var customerReason = reason.a;
		return $author$project$Common$AmendReason$customerReasonToDescriptionStatus(customerReason);
	}
};
var $author$project$Page$PolicyDetails$Model$initAmendModal = F4(
	function (i18n, policy, model, _v0) {
		var earliestSelectableDate = _v0.a2;
		var latestSelectableDate = _v0.a9;
		var kind = _v0.c7;
		var setInitialValues = F2(
			function (initialModel, interruption) {
				return A2(
					$author$project$Page$PolicyDetails$AmendInterruptionModal$setInitialValues,
					{
						m1: interruption.m1,
						g1: interruption.mB,
						iA: $author$project$Common$AmendReason$fromInterruptionReason(interruption.iA)
					},
					initialModel);
			});
		var reasons = A2(
			$elm$core$List$map,
			function (reason) {
				return {
					eY: A2($author$project$Common$AmendReason$amendReasonLabel, i18n, reason),
					pR: reason
				};
			},
			$author$project$Common$AmendReason$fromAmendInterruptionType(kind));
		var initModel = $author$project$Page$PolicyDetails$AmendInterruptionModal$init($author$project$Page$PolicyDetails$Msg$DismissAmendModal)($author$project$Page$PolicyDetails$Msg$SubmitAmendInterruptionModal)($author$project$Page$PolicyDetails$Msg$AmendInterruptionModalSubmitErrored)($author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonChanged)($author$project$Page$PolicyDetails$Msg$AmendInterruptionReasonSelected)($author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDescription)($author$project$Page$PolicyDetails$Msg$ChangeAmendInterruptionDate)($author$project$Page$PolicyDetails$Msg$AmendInterruptionDateSelected)(
			$author$project$Common$Policy$startDateTime(policy))(earliestSelectableDate)(latestSelectableDate)(reasons)($author$project$Common$AmendReason$toDescriptionStatus)(
			$author$project$Common$AmendReason$defaultFromAmendType(kind));
		var maybeWithInitialValues = A2(
			$elm$core$Maybe$withDefault,
			initModel,
			A2(
				$elm$core$Maybe$map,
				setInitialValues(initModel),
				$author$project$Common$Policy$pickInterruption(policy)));
		return _Utils_update(
			model,
			{
				W: $elm$core$Maybe$Just(maybeWithInitialValues)
			});
	});
var $author$project$Common$Policy$mapActionAmendInterruption = F2(
	function (f, _v0) {
		var policyId = _v0.o6;
		var earliestSelectableDate = _v0.a2;
		var latestSelectableDate = _v0.a9;
		var kind = _v0.c7;
		return f(
			{a2: earliestSelectableDate, c7: kind, a9: latestSelectableDate, o6: policyId});
	});
var $author$project$Common$Policy$pickAmendTerminationAction = function (_v0) {
	var policy = _v0;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (action) {
				if (!action.$) {
					var params = action.a;
					return $elm$core$Maybe$Just(params);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			policy.aY));
};
var $author$project$Page$PolicyDetails$Model$maybeInitAmendModal = F3(
	function (i18n, policy, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$Policy$mapActionAmendInterruption(
					A3($author$project$Page$PolicyDetails$Model$initAmendModal, i18n, policy, model)),
				$author$project$Common$Policy$pickAmendTerminationAction(policy)));
	});
var $author$project$Referer$isPaymentPage = true;
var $author$project$Translations$paymentAfterPurchaseText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Thank you! The policy has been successfully purchased';
	} else {
		return 'Gracias! La contratación de la póliza se ha completado.';
	}
};
var $author$project$Page$PolicyDetails$showToastIfRefererIsPaymentPage = F3(
	function (i18n, model, _v0) {
		if ($author$project$Referer$isPaymentPage) {
			var _v1 = A2(
				$author$project$Pyxis$Components$Toasts$addNewToast,
				A2(
					$author$project$Pyxis$Components$Toasts$withToastText,
					$author$project$Translations$paymentAfterPurchaseText(i18n),
					$author$project$Pyxis$Components$Toasts$successToast),
				model.t);
			var newToastModel = _v1.a;
			var newCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{t: newToastModel}),
				$author$project$Page$PolicyDetails$Effect$WithCmd(newCmd));
		} else {
			return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
		}
	});
var $author$project$Page$PolicyDetails$maybeUpdateModelIfRefererIsPaymentPage = F2(
	function (i18n, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Page$PolicyDetails$showToastIfRefererIsPaymentPage, i18n, model),
				model.pi));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$openModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$open(model.cx);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cx: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$setActualTime = F2(
	function (now, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				hI: $elm$core$Maybe$Just(now)
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$initCustomerTermination = F2(
	function (now, interruptionAt) {
		return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
			{m1: $elm$core$Maybe$Nothing, bJ: 3, a6: interruptionAt, kQ: $elm$core$Maybe$Nothing, pm: now});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$initPrimaTermination = F2(
	function (now, interruptionAt) {
		return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
			{m1: $elm$core$Maybe$Nothing, bJ: 3, a6: interruptionAt, kQ: $elm$core$Maybe$Nothing, pm: now});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$initWithdrawal = function (now) {
	return $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput(
		{m1: $elm$core$Maybe$Nothing, bJ: 3, kQ: $elm$core$Maybe$Nothing, pm: now});
};
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.pW - 1)) + ($justinmimbs$date$Date$monthToNumber(date.n2) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.mZ,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $author$project$Common$Locale$maxPosix = F2(
	function (l, r) {
		var rMillis = $elm$time$Time$posixToMillis(r);
		var lMillis = $elm$time$Time$posixToMillis(l);
		return $elm$time$Time$millisToPosix(
			A2($elm$core$Basics$max, lMillis, rMillis));
	});
var $author$project$Common$Policy$earliestCustomerTerminationDate = function (_v0) {
	var policy = _v0;
	var startAt = $author$project$Common$Locale$midnightAtCustomerDate(policy.l_);
	return A2(
		$elm$core$Maybe$withDefault,
		startAt,
		A2(
			$elm$core$Maybe$map,
			$author$project$Common$Locale$maxPosix(startAt),
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$Locale$midnightAtCustomerDate,
				A2(
					$elm$core$Maybe$map,
					A2($justinmimbs$date$Date$add, 3, 1),
					policy.eZ))));
};
var $author$project$Common$Policy$earliestPrimaTerminationDate = function (_v0) {
	var policy = _v0;
	return $author$project$Common$Locale$midnightAtCustomerDate(policy.l_);
};
var $author$project$Common$Locale$nextCustomerMidnight = function (now) {
	return $author$project$Common$Locale$midnightAtCustomerDate(
		A3(
			$justinmimbs$date$Date$add,
			3,
			1,
			$author$project$Common$Locale$posixToCustomerDate(now)));
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$initialInterruptionAt = F3(
	function (time, policy, kind) {
		switch (kind) {
			case 0:
				return time;
			case 1:
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(time),
					$elm$time$Time$posixToMillis(
						$author$project$Common$Policy$earliestCustomerTerminationDate(policy))) < 0) ? $author$project$Common$Policy$earliestCustomerTerminationDate(policy) : $author$project$Common$Locale$nextCustomerMidnight(time);
			default:
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(time),
					$elm$time$Time$posixToMillis(
						$author$project$Common$Policy$earliestPrimaTerminationDate(policy))) < 0) ? $author$project$Common$Policy$earliestPrimaTerminationDate(policy) : $author$project$Common$Locale$nextCustomerMidnight(time);
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$kindDataFromInterruptionKind = F3(
	function (time, policy, kind) {
		switch (kind) {
			case 0:
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$initWithdrawal(time);
			case 1:
				return A2(
					$author$project$Page$PolicyDetails$InterruptionModal$Data$initCustomerTermination,
					time,
					A3($author$project$Page$PolicyDetails$InterruptionModal$Model$initialInterruptionAt, time, policy, kind));
			default:
				return A2(
					$author$project$Page$PolicyDetails$InterruptionModal$Data$initPrimaTermination,
					time,
					A3($author$project$Page$PolicyDetails$InterruptionModal$Model$initialInterruptionAt, time, policy, kind));
		}
	});
var $author$project$Page$PolicyDetails$TerminationReasonList$initCustomerCancellationReasonOptionList = function (i18n) {
	return A2(
		$elm$core$List$map,
		$author$project$Pyxis$Components$Field$Autocomplete$option,
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.eY;
			},
			_List_fromArray(
				[
					{
					eY: $author$project$Translations$interruptionCompetitorOffer(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(0)
				},
					{
					eY: $author$project$Translations$interruptionCoverageChange(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(12)
				},
					{
					eY: $author$project$Translations$interruptionDeceasedPolicyHolder(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(11)
				},
					{
					eY: $author$project$Translations$interruptionDissatisfactionService(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(13)
				},
					{
					eY: $author$project$Translations$interruptionDoesNotKnow(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(5)
				},
					{
					eY: $author$project$Translations$interruptionIncorrectDataOther(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(9)
				},
					{
					eY: $author$project$Translations$interruptionIncorrectEffectiveDate(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(7)
				},
					{
					eY: $author$project$Translations$interruptionIncorrectPersonalData(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(8)
				},
					{
					eY: $author$project$Translations$interruptionMovingToAnotherCountry(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(15)
				},
					{
					eY: $author$project$Translations$interruptionNoInsuranceWanted(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(4)
				},
					{
					eY: $author$project$Translations$interruptionOther(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(19)
				},
					{
					eY: $author$project$Translations$interruptionPaymentMethodOrDate(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(10)
				},
					{
					eY: $author$project$Translations$interruptionUnderwritingRules(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(14)
				},
					{
					eY: $author$project$Translations$interruptionVehicleDeregistration(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(3)
				},
					{
					eY: $author$project$Translations$interruptionVehicleNotPurchased(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(2)
				},
					{
					eY: $author$project$Translations$interruptionVehicleSold(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(1)
				},
					{
					eY: $author$project$Translations$interruptionWantsGreenCard(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(6)
				},
					{
					eY: $author$project$Translations$interruptionProductService(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(16)
				},
					{
					eY: $author$project$Translations$interruptionPolicyHolderChange(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(17)
				},
					{
					eY: $author$project$Translations$interruptionSwitchToGreatLakes(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$toString(18)
				}
				])));
};
var $author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel = F2(
	function (autoCompleteModel, optionList) {
		return A2(
			$author$project$Pyxis$Components$Field$Autocomplete$setOptions,
			$krisajenkins$remotedata$RemoteData$Success(optionList),
			autoCompleteModel);
	});
var $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerTerminationReasonList = F2(
	function (i18n, autoCompleteModel) {
		return A2(
			$author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel,
			autoCompleteModel,
			$author$project$Page$PolicyDetails$TerminationReasonList$initCustomerCancellationReasonOptionList(i18n));
	});
var $author$project$Page$PolicyDetails$TerminationReasonList$initPrimaTerminateReasonOptionList = function (i18n) {
	return A2(
		$elm$core$List$map,
		$author$project$Pyxis$Components$Field$Autocomplete$option,
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.eY;
			},
			_List_fromArray(
				[
					{
					eY: $author$project$Translations$interruptionInexactDeclarationSinco(i18n),
					pR: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(0)
				},
					{
					eY: $author$project$Translations$interruptionFraud(i18n),
					pR: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(1)
				},
					{
					eY: $author$project$Translations$interruptionChargeback(i18n),
					pR: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(2)
				},
					{
					eY: $author$project$Translations$interruptionInexactDeclarationDni(i18n),
					pR: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(3)
				},
					{
					eY: $author$project$Translations$interruptionRiskAggravation(i18n),
					pR: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(4)
				},
					{
					eY: $author$project$Translations$interruptionPhotoVericiationNotProvided(i18n),
					pR: $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$toString(5)
				}
				])));
};
var $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithPrimaTerminationReasonList = F2(
	function (i18n, autoCompleteModel) {
		return A2(
			$author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel,
			autoCompleteModel,
			$author$project$Page$PolicyDetails$TerminationReasonList$initPrimaTerminateReasonOptionList(i18n));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonInputOptionsWhenKindIsSet = function (kind) {
	switch (kind) {
		case 0:
			return $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerTerminationReasonList;
		case 1:
			return $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerTerminationReasonList;
		default:
			return $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithPrimaTerminationReasonList;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$setInterruptionKind = F3(
	function (i18n, kind, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				av: A4(
					$elm$core$Maybe$map3,
					$author$project$Page$PolicyDetails$InterruptionModal$Model$kindDataFromInterruptionKind,
					model.hI,
					model.l,
					$elm$core$Maybe$Just(kind)),
				aQ: A3($author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonInputOptionsWhenKindIsSet, kind, i18n, model.aQ)
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$setPolicy = F2(
	function (policy, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				l: $elm$core$Maybe$Just(policy)
			});
	});
var $author$project$Page$PolicyDetails$openAndInitInterruptionModal = F5(
	function (i18n, kind, model, policy, time) {
		var _v0 = $author$project$Page$PolicyDetails$InterruptionModal$Model$openModal(
			A3(
				$author$project$Page$PolicyDetails$InterruptionModal$Model$setInterruptionKind,
				i18n,
				kind,
				A2(
					$author$project$Page$PolicyDetails$InterruptionModal$Model$setPolicy,
					policy,
					A2($author$project$Page$PolicyDetails$InterruptionModal$Model$setActualTime, time, model.q))));
		var interruptionModelModal = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{q: interruptionModelModal}),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$CompetitorOffer = 0;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$CoverageChange = 12;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$DeceasedPolicyHolder = 11;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$DissatisfactionService = 13;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$DoesNotKnow = 5;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$IncorrectDataOther = 9;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$IncorrectEffectiveDate = 7;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$IncorrectPersonalData = 8;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$MovingToAnotherCountry = 15;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$NoInsuranceWanted = 4;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$Other = 19;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$PaymentMethodOrDate = 10;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$PolicyHolderChange = 17;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$PriceIncrease = 18;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$ProductService = 16;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$UnderwritingRules = 14;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$VehicleDeregistration = 3;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$VehicleNotPurchased = 2;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$VehicleSold = 1;
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$WantsGreenCard = 6;
var $author$project$Translations$interruptionPriceIncrease = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Price increased';
	} else {
		return 'Aumento de precio';
	}
};
var $author$project$Page$PolicyDetails$TerminationReasonList$initCustomerDeclineRenewalOptionList = function (i18n) {
	return A2(
		$elm$core$List$map,
		$author$project$Pyxis$Components$Field$Autocomplete$option,
		A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.eY;
			},
			_List_fromArray(
				[
					{
					eY: $author$project$Translations$interruptionCompetitorOffer(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(0)
				},
					{
					eY: $author$project$Translations$interruptionCoverageChange(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(12)
				},
					{
					eY: $author$project$Translations$interruptionDeceasedPolicyHolder(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(11)
				},
					{
					eY: $author$project$Translations$interruptionDissatisfactionService(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(13)
				},
					{
					eY: $author$project$Translations$interruptionDoesNotKnow(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(5)
				},
					{
					eY: $author$project$Translations$interruptionIncorrectDataOther(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(9)
				},
					{
					eY: $author$project$Translations$interruptionIncorrectEffectiveDate(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(7)
				},
					{
					eY: $author$project$Translations$interruptionIncorrectPersonalData(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(8)
				},
					{
					eY: $author$project$Translations$interruptionMovingToAnotherCountry(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(15)
				},
					{
					eY: $author$project$Translations$interruptionNoInsuranceWanted(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(4)
				},
					{
					eY: $author$project$Translations$interruptionOther(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(19)
				},
					{
					eY: $author$project$Translations$interruptionPaymentMethodOrDate(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(10)
				},
					{
					eY: $author$project$Translations$interruptionUnderwritingRules(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(14)
				},
					{
					eY: $author$project$Translations$interruptionVehicleDeregistration(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(3)
				},
					{
					eY: $author$project$Translations$interruptionVehicleNotPurchased(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(2)
				},
					{
					eY: $author$project$Translations$interruptionVehicleSold(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(1)
				},
					{
					eY: $author$project$Translations$interruptionWantsGreenCard(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(6)
				},
					{
					eY: $author$project$Translations$interruptionProductService(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(16)
				},
					{
					eY: $author$project$Translations$interruptionPolicyHolderChange(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(17)
				},
					{
					eY: $author$project$Translations$interruptionPriceIncrease(i18n),
					pR: $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$toString(18)
				}
				])));
};
var $author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerDeclineRenewalList = F2(
	function (i18n, autoCompleteModel) {
		return A2(
			$author$project$Page$PolicyDetails$TerminationReasonList$updateAutoCompleteModel,
			autoCompleteModel,
			$author$project$Page$PolicyDetails$TerminationReasonList$initCustomerDeclineRenewalOptionList(i18n));
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$openModal = F2(
	function (i18n, _v0) {
		var model = _v0;
		var _v1 = $author$project$Pyxis$Components$Modal$open(model.cx);
		var visibilityModel = _v1.a;
		var visibilityCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aQ: A2($author$project$Page$PolicyDetails$TerminationReasonList$updateModelWithCustomerDeclineRenewalList, i18n, model.aQ),
					cx: visibilityModel
				}),
			visibilityCmd);
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$setPolicy = F2(
	function (policy, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				l: $elm$core$Maybe$Just(policy)
			});
	});
var $author$project$Page$PolicyDetails$openAndInitRenewalCancellationModal = F3(
	function (i18n, model, policy) {
		var _v0 = A2(
			$author$project$Page$PolicyDetails$RenewalCancellationModal$openModal,
			i18n,
			A2($author$project$Page$PolicyDetails$RenewalCancellationModal$setPolicy, policy, model.ap));
		var renewalCancellationModal = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{ap: renewalCancellationModal}),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$openModal = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Pyxis$Components$Modal$open(model.cx);
	var visibilityModel = _v1.a;
	var visibilityCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cx: visibilityModel}),
		visibilityCmd);
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$openModal = A2($elm$core$Basics$composeL, $author$project$Page$PolicyDetails$ChangeEmailModal$update, $author$project$Page$PolicyDetails$ChangeEmailModal$Open);
var $author$project$Page$PolicyDetails$RefundIssuingModal$openModal = F2(
	function (refund, _v0) {
		var model = _v0;
		var _v1 = $author$project$Pyxis$Components$Modal$open(model.cx);
		var newVisibility = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					pk: $elm$core$Maybe$Just(refund),
					cx: newVisibility
				}),
			cmd);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$openModal = F3(
	function (policyId, emailRecipient, _v0) {
		var model = _v0;
		var _v1 = $author$project$Pyxis$Components$Modal$open(model.cx);
		var newVisibility = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					a$: $author$project$Pyxis$Components$Field$CheckboxGroup$resetValue(model.a$),
					gy: emailRecipient,
					c5: false,
					o6: policyId,
					cx: newVisibility
				}),
			cmd);
	});
var $author$project$Page$PolicyDetails$openSendEmailModal = F2(
	function (newModalModel, model) {
		return _Utils_update(
			model,
			{cl: newModalModel});
	});
var $author$project$Common$Policy$pickCustomerFacingId = function (_v0) {
	var policy = _v0;
	return policy.mY;
};
var $author$project$Common$Person$pickEmail = function (person) {
	switch (person.$) {
		case 1:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			var email = person.c.ew;
			return $elm$core$Maybe$Just(email);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Policy$pickPolicyHolder = function (_v0) {
	var policy = _v0;
	return policy.io;
};
var $author$project$Page$PolicyDetails$Model$pickEmailRecipient = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.l;
	},
	A2(
		$elm$core$Basics$composeR,
		$krisajenkins$remotedata$RemoteData$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Common$Policy$pickPolicyHolder),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($author$project$Common$Person$pickEmail),
				$elm_community$maybe_extra$Maybe$Extra$join))));
var $author$project$Fixtures$epoch = $elm$time$Time$millisToPosix(0);
var $author$project$Page$PolicyDetails$Model$pickIssueRefundReleaseDate = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.nJ;
	},
	$elm$core$Maybe$withDefault($author$project$Fixtures$epoch));
var $author$project$Page$PolicyDetails$Model$pickPolicyId = function (model) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Common$Policy$pickId,
		$krisajenkins$remotedata$RemoteData$toMaybe(model.l));
};
var $author$project$Page$PolicyDetails$Model$pickRefund = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.pk;
	},
	$krisajenkins$remotedata$RemoteData$toMaybe);
var $author$project$Common$Refund$pickStatus = function (_v0) {
	var status = _v0.b;
	return status;
};
var $author$project$Translations$policyAmendInterruptionSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Interruption has been correctly amended';
	} else {
		return 'La interrupción se ha modificado correctamente';
	}
};
var $author$project$Translations$policyCreateRefundSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund has been correctly created.';
	} else {
		return 'Reembolso creado correctamente.';
	}
};
var $author$project$Translations$policyGeneralErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'An error has occurred, please contact the development team.';
	} else {
		return 'Se ha detectado un error, contacta con el equipo de desarrollo.';
	}
};
var $author$project$Translations$policyInterruptionSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy has been correctly interrupted.';
	} else {
		return 'Póliza interrumpida correctamente.';
	}
};
var $author$project$Translations$policyIssueRefundErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The refund could not be processed. Please wait a few minutes and refresh the page to try again.';
	} else {
		return 'No se pudo procesar el reembolso. Espera unos minutos y actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$policyRenewalCancellationErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'We were unable to cancel the renewal. Please refresh the page to try again.';
	} else {
		return 'No pudimos cancelar la renovación. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$policyRenewalCancellationSuccessMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal has been correctly cancelled.';
	} else {
		return 'La renovación se ha cancelado correctamente.';
	}
};
var $author$project$Translations$policySendEmailFailureMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'It was not possible to send the email. Please refresh the page to try again.';
	} else {
		return 'No ha sido posible enviar el email. Actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$policySendEmailSuccessMessage = F2(
	function (email, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'The email has been sent to ' + email;
		} else {
			return 'El email se ha enviado a ' + email;
		}
	});
var $author$project$Page$PolicyDetails$Effect$AmendCompanyInterruption = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$Effect$AmendCustomerInterruption = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$amendInterruptionEffect = F6(
	function (description, interruptionAt, amendReason, policyId, requestedAt, hasInterruptionDateChanged) {
		var createCustomerAmendEffect = function (customerReason) {
			return A2(
				$author$project$Page$PolicyDetails$Effect$AmendCustomerInterruption,
				{
					m1: $elm$core$Maybe$Just(description),
					kv: policyId,
					a6: interruptionAt,
					iA: customerReason,
					i: requestedAt
				},
				hasInterruptionDateChanged);
		};
		var createCompanyAmendEffect = function (primaReason) {
			return A2(
				$author$project$Page$PolicyDetails$Effect$AmendCompanyInterruption,
				{
					m1: $elm$core$Maybe$Just(description),
					kv: policyId,
					a6: interruptionAt,
					iA: primaReason,
					i: requestedAt
				},
				hasInterruptionDateChanged);
		};
		var maybeCreateAmendWithReasonEffect = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Page$PolicyDetails$Effect$None,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$map,
					createCompanyAmendEffect,
					$author$project$Common$AmendReason$toPrimaReason(amendReason)),
				A2(
					$elm$core$Maybe$map,
					createCustomerAmendEffect,
					$author$project$Common$AmendReason$toCustomerReason(amendReason))));
		return maybeCreateAmendWithReasonEffect;
	});
var $author$project$Page$PolicyDetails$requestAmendInterruption = F5(
	function (desctiption, interruptionAt, reason, hasInterruptionDateChanged, _v0) {
		var model = _v0.a;
		var effect = _v0.b;
		var updateModelAndEffect = F3(
			function (amendReason, policyId, requestedAt) {
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								effect,
								A6($author$project$Page$PolicyDetails$amendInterruptionEffect, desctiption, interruptionAt, amendReason, policyId, requestedAt, hasInterruptionDateChanged)
							])));
			});
		var maybeRequestedAt = model.gk;
		var maybePolicyId = A2(
			$elm$core$Maybe$map,
			$author$project$Common$Policy$pickId,
			$krisajenkins$remotedata$RemoteData$toMaybe(model.l));
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, effect),
			A3(
				$elm$core$Maybe$map2,
				updateModelAndEffect(reason),
				maybePolicyId,
				maybeRequestedAt));
	});
var $author$project$Page$PolicyDetails$resetSendEmailResult = function (model) {
	return _Utils_update(
		model,
		{fp: $krisajenkins$remotedata$RemoteData$NotAsked});
};
var $author$project$Page$PolicyDetails$Model$pickPricingAction = function (response) {
	return A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		$author$project$Common$PricingAction$unknown,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($author$project$Common$PricingAction$new),
				$elm$core$Maybe$withDefault($author$project$Common$PricingAction$default)),
			response));
};
var $author$project$Page$PolicyDetails$Model$setPricingActionToClaimHistoryResponse = F2(
	function (model, action) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Common$ClaimHistory$setPricingActionToClaimHistoryOrDefault(action),
			model.cM);
	});
var $author$project$Page$PolicyDetails$Model$setClaimHistoryPricingActionResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cM: A2(
					$author$project$Page$PolicyDetails$Model$setPricingActionToClaimHistoryResponse,
					model,
					$author$project$Page$PolicyDetails$Model$pickPricingAction(result))
			});
	});
var $author$project$Common$Policy$pickClaimsDeclaredWithFault = function (_v0) {
	var policy = _v0;
	return policy.f9;
};
var $author$project$Page$PolicyDetails$Model$pickClaimsDeclaredWithFaultByCustomer = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.l;
	},
	A2(
		$elm$core$Basics$composeR,
		$krisajenkins$remotedata$RemoteData$toMaybe,
		A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Common$Count$default, $author$project$Common$Policy$pickClaimsDeclaredWithFault)));
var $author$project$Page$PolicyDetails$Model$setClaimDeclaredToClaimHistory = function (model) {
	return $author$project$Common$ClaimHistory$setClaimDeclaredWithFaultByCustomer(
		$author$project$Page$PolicyDetails$Model$pickClaimsDeclaredWithFaultByCustomer(model));
};
var $author$project$Page$PolicyDetails$Model$setClaimsDeclaredToResponse = function (model) {
	return $krisajenkins$remotedata$RemoteData$map(
		$elm$core$Maybe$map(
			$author$project$Page$PolicyDetails$Model$setClaimDeclaredToClaimHistory(model)));
};
var $author$project$Page$PolicyDetails$Model$setClaimHistoryResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{
				cM: A2($author$project$Page$PolicyDetails$Model$setClaimsDeclaredToResponse, model, result)
			});
	});
var $author$project$Page$PolicyDetails$Model$setCustomerId = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{gm: result});
	});
var $author$project$Page$PolicyDetails$Model$setPaymentMethod = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{lq: result});
	});
var $author$project$Page$PolicyDetails$Model$setPolicyResult = F2(
	function (result, model) {
		return _Utils_update(
			model,
			{l: result});
	});
var $author$project$Page$PolicyDetails$showRefundFailure = F3(
	function (i18n, model, result) {
		var _v0 = A2(
			$author$project$Pyxis$Components$Toasts$addNewToast,
			A2(
				$author$project$Pyxis$Components$Toasts$withToastText,
				$author$project$Translations$policyIssueRefundErrorMessage(i18n),
				$author$project$Pyxis$Components$Toasts$errorToast),
			model.t);
		var newToastsState = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Page$PolicyDetails$Model$setRefundResult,
				result,
				_Utils_update(
					model,
					{t: newToastsState})),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$Common$ExpectedRefund$pickPrice = function (expectedRefund) {
	if (!expectedRefund.$) {
		var price = expectedRefund.a;
		return price;
	} else {
		var price = expectedRefund.a;
		return price;
	}
};
var $author$project$Common$Refund$pickPrice = function (_v0) {
	var refundData = _v0.a;
	return $author$project$Common$ExpectedRefund$pickPrice(refundData.nc);
};
var $author$project$Translations$policyIssueRefundSuccessMessage = F2(
	function (refundAmount, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'The refund was issued successfully. The customer will receive ' + (refundAmount + '.');
		} else {
			return 'El reembolso ha sido efectuado correctamente. El cliente recibirá ' + (refundAmount + '.');
		}
	});
var $author$project$Common$Price$pickSign = '€';
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	m_: '.',
	m$: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	hC: '−',
	hD: '',
	lv: '',
	lw: '',
	fv: 0,
	aT: '',
	ml: '',
	mm: ''
};
var $author$project$Translations$currentLanguage = function (_v0) {
	var lang = _v0;
	return lang;
};
var $author$project$Common$Price$decimalSeparator = function (i18n) {
	var _v0 = $author$project$Translations$currentLanguage(i18n);
	if (!_v0) {
		return '.';
	} else {
		return ',';
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {m$: decimals, kB: integers, lm: original, fd: prefix, ft: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.kB,
				$elm$core$List$singleton(formatted.m$))));
	return onlyZeros ? 1 : ((formatted.lm < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.m$;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.m$;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.fv,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{fd: locale.hC, ft: locale.hD});
			case 0:
				return _Utils_update(
					partial,
					{fd: locale.lv, ft: locale.lw});
			default:
				return _Utils_update(
					partial,
					{fd: locale.ml, ft: locale.mm});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.m_, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.aT, formatted.kB);
		var decimals = stringfyDecimals(formatted.m$);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.fd, integers, decimals, formatted.ft]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $prikhi$decimal$Decimal$toFloat = function (d) {
	var _v0 = $elm$core$String$toFloat(
		$prikhi$decimal$Decimal$toString(d));
	if (!_v0.$) {
		var a = _v0.a;
		return a;
	} else {
		return 42.0;
	}
};
var $author$project$Common$Price$toAmountString = F2(
	function (i18n, amount) {
		var base = $cuducos$elm_format_number$FormatNumber$Locales$base;
		return A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				base,
				{
					m_: $author$project$Common$Price$decimalSeparator(i18n),
					m$: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2)
				}),
			$prikhi$decimal$Decimal$toFloat(amount));
	});
var $author$project$Common$Price$toStringSignFirst = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$author$project$Common$Price$pickSign,
					A2($author$project$Common$Price$toAmountString, i18n, amount)
				]));
	});
var $author$project$Page$PolicyDetails$showRefundSuccess = F4(
	function (i18n, model, refund, result) {
		var successMessage = A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$author$project$Translations$policyIssueRefundSuccessMessage,
			i18n,
			A2(
				$author$project$Common$Price$toStringSignFirst,
				i18n,
				$author$project$Common$Refund$pickPrice(refund)));
		var _v0 = A2(
			$author$project$Pyxis$Components$Toasts$addNewToast,
			A2($author$project$Pyxis$Components$Toasts$withToastText, successMessage, $author$project$Pyxis$Components$Toasts$successToast),
			model.t);
		var newToastModel = _v0.a;
		var toastCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Page$PolicyDetails$Model$setRefundResult,
				result,
				_Utils_update(
					model,
					{t: newToastModel})),
			$author$project$Page$PolicyDetails$Effect$Effects(
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Page$PolicyDetails$Effect$None,
						A2(
							$elm$core$Maybe$map,
							$author$project$Page$PolicyDetails$Effect$FetchPolicy,
							$author$project$Page$PolicyDetails$Model$pickPolicyId(model))),
						$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd)
					])));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$getValue = function (_v0) {
	var modelData = _v0;
	return modelData.aB;
};
var $author$project$Page$PolicyDetails$SendEmailModal$updateCheckboxGroup = F2(
	function (checkboxMsg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$CheckboxGroup$update, checkboxMsg, model.a$);
		var newCheckboxModel = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a$: newCheckboxModel}),
			cmd);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$update = F2(
	function (modalMsg, model) {
		var innerModel = model;
		switch (modalMsg.$) {
			case 0:
				var checkboxMsg = modalMsg.a;
				return A2($author$project$Page$PolicyDetails$SendEmailModal$updateCheckboxGroup, checkboxMsg, model);
			case 1:
				return $author$project$Page$PolicyDetails$SendEmailModal$closeModal(model);
			case 2:
				return $elm$core$List$isEmpty(
					$author$project$Pyxis$Components$Field$CheckboxGroup$getValue(innerModel.a$)) ? _Utils_Tuple2(
					_Utils_update(
						innerModel,
						{c5: true}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					model,
					$author$project$Pyxis$Commons$Commands$dispatch(innerModel.jS));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						innerModel,
						{c5: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$PolicyDetails$updateAmendModalState = F2(
	function (model, _v0) {
		var amendInterruptionModel = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					W: $elm$core$Maybe$Just(amendInterruptionModel)
				}),
			$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateExpectedRefundAmount = F2(
	function (amount, _v0) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{nc: amount}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount = F2(
	function (_v0, amount) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{nc: amount}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pyxis$Components$Field$DateInput$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				eB: mapper(model.eB)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hR)
						]),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h_)
						]),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			default:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h0)
						]),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						_Utils_update(
							modelData,
							{pR: value})));
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDate = F2(
	function (msg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$DateInput$update, msg, model.aL);
		var dateInputModel = _v1.a;
		var dateInputCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aL: dateInputModel}),
			dateInputCmd);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$setInterruptionDate = F2(
	function (dateInput, data) {
		var maybeDate = $elm$core$Result$toMaybe(
			$justinmimbs$date$Date$fromIsoString(dateInput));
		if (!maybeDate.$) {
			var selectedDate = maybeDate.a;
			var interruptionAt = $author$project$Common$Locale$midnightAtCustomerDate(selectedDate);
			switch (data.$) {
				case 1:
					var customerTerminateData = data.a;
					return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
						_Utils_update(
							customerTerminateData,
							{a6: interruptionAt}));
				case 2:
					var primaTerminateData = data.a;
					return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
						_Utils_update(
							primaTerminateData,
							{a6: interruptionAt}));
				default:
					return data;
			}
		} else {
			return data;
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateInterruptionDateInput = F2(
	function (_v0, inputMsg) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$DateInput$update, inputMsg, model.aL);
		var newInterruptionDateModel = _v1.a;
		var selectCmd = _v1.b;
		var date = $author$project$Pyxis$Components$Field$DateInput$getValue(newInterruptionDateModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aL: newInterruptionDateModel,
					av: A2(
						$elm$core$Maybe$map,
						$author$project$Page$PolicyDetails$InterruptionModal$Data$setInterruptionDate(date),
						model.av)
				}),
			selectCmd);
	});
var $author$project$Pyxis$Components$Field$Textarea$mapFieldStatus = F2(
	function (mapper, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				eB: mapper(model.eB)
			});
	});
var $author$project$Pyxis$Components$Field$Textarea$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 2:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hR)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Textarea$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						model));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h_)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Textarea$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						model));
			default:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h0)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Textarea$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						_Utils_update(
							modelData,
							{pR: value})));
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDescription = F2(
	function (msg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Textarea$update, msg, model.aE);
		var descriptionInputModel = _v1.a;
		var descriptionInputCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aE: descriptionInputModel}),
			descriptionInputCmd);
	});
var $author$project$Pyxis$Commons$Events$Keyboard$isEnter = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('Enter');
var $author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus = F2(
	function (mapper, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{
				eB: mapper(modelData.eB)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange = F2(
	function (_v0, _v1) {
		var oldModelData = _v0;
		var newModelData = _v1;
		return (!_Utils_eq(oldModelData.J, newModelData.J)) ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (_v2, onHoveredOptionChange) {
						var id = _v2.kv;
						return $author$project$Pyxis$Commons$Commands$dispatch(
							onHoveredOptionChange(id));
					}),
				newModelData.J,
				newModelData.h$)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pyxis$Components$Field$Autocomplete$getSelectedOption = function (_v0) {
	var modelData = _v0;
	return modelData.fn;
};
var $author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueToSelectedValueLabel = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Field$Autocomplete$getSelectedOption,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
				function ($) {
					return $.eY;
				})),
		$elm$core$Maybe$withDefault('')));
var $author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueOnBlur = function (_v0) {
	var modelData = _v0;
	return _Utils_eq(
		$author$project$Pyxis$Components$Field$Autocomplete$getSelectedOption(modelData),
		$elm$core$Maybe$Nothing) ? modelData : _Utils_update(
		modelData,
		{
			F: $author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueToSelectedValueLabel(modelData)
		});
};
var $author$project$Pyxis$Components$Field$Autocomplete$setHasFocus = F2(
	function (hasFocus, _v0) {
		var modelData = _v0;
		return _Utils_update(
			modelData,
			{eG: hasFocus});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen = F2(
	function (isOpen, _v0) {
		var modelData = _v0;
		return A4(
			$author$project$Pyxis$Commons$Basics$ternaryOperator,
			isOpen,
			$author$project$Pyxis$Components$Field$Autocomplete$initializeActiveOption,
			$elm$core$Basics$identity,
			_Utils_update(
				modelData,
				{a7: isOpen}));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$handleOnSelect = function (value) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Field$Autocomplete$setValue(value),
		$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus(
			$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true)));
};
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowDown = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('ArrowDown');
var $author$project$Pyxis$Commons$Events$Keyboard$isArrowUp = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('ArrowUp');
var $author$project$Pyxis$Commons$Events$Keyboard$isEsc = $author$project$Pyxis$Commons$Events$Keyboard$matchKey('Escape');
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return A3(
		$elm$core$Array$foldr,
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$Pyxis$Components$Field$Autocomplete$getActiveOptionWithIndex = function (model) {
	var modelData = model;
	var findOption = function (_v0) {
		var value = _v0.b.pR;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pR;
						},
						$elm$core$Basics$eq(value))),
				modelData.J));
	};
	return A2(
		$elm_community$list_extra$List$Extra$find,
		findOption,
		$elm$core$Array$toIndexedList(
			$elm$core$Array$fromList(
				$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model))));
};
var $author$project$Pyxis$Components$Field$Autocomplete$getValuesLength = function (_v0) {
	var modelData = _v0;
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.eY;
					},
					modelData.bN(modelData.F))),
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, modelData.ax)));
};
var $author$project$Pyxis$Components$Field$Autocomplete$updateActiveOption = F2(
	function (moveByPositions, model) {
		var modelData = model;
		var newActiveOptionIndex = moveByPositions + A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				$author$project$Pyxis$Components$Field$Autocomplete$getActiveOptionWithIndex(model)));
		return _Utils_update(
			modelData,
			{
				J: ((newActiveOptionIndex < 0) || (_Utils_cmp(
					newActiveOptionIndex,
					$author$project$Pyxis$Components$Field$Autocomplete$getValuesLength(model)) > -1)) ? modelData.J : A2(
					$elm$core$Array$get,
					newActiveOptionIndex,
					$elm$core$Array$fromList(
						$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model)))
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$updateOnKeyEvent = F2(
	function (event, model) {
		var modelData = model;
		return $author$project$Pyxis$Commons$Events$Keyboard$isArrowDown(event) ? A2($author$project$Pyxis$Components$Field$Autocomplete$updateActiveOption, 1, model) : ($author$project$Pyxis$Commons$Events$Keyboard$isArrowUp(event) ? A2($author$project$Pyxis$Components$Field$Autocomplete$updateActiveOption, -1, model) : ($author$project$Pyxis$Commons$Events$Keyboard$isEsc(event) ? $author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed(model) : ($author$project$Pyxis$Commons$Events$Keyboard$isEnter(event) ? A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pR;
						},
						A2($primait$prima_elm_extra$PrimaFunction$flip, $author$project$Pyxis$Components$Field$Autocomplete$handleOnSelect, model))),
				modelData.J)) : model)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$update = F2(
	function (msg, model) {
		var modelData = model;
		switch (msg.$) {
			case 0:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.hR)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(true),
						$author$project$Pyxis$Components$Field$Autocomplete$setFilteringValueOnBlur(
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
								false,
								A2($author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen, false, model)))));
			case 1:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h_)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
						true,
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen,
							true,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
								$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
								model))));
			case 3:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$elm$core$Basics$always(
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.h0)),
							$author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange(model)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
							true,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen,
								$krisajenkins$remotedata$RemoteData$isSuccess(modelData.ax),
								_Utils_update(
									modelData,
									{F: value, bV: true})))));
			case 4:
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.ib)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
							$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(false),
							_Utils_update(
								modelData,
								{J: $elm$core$Maybe$Nothing, F: '', bV: false, fn: $elm$core$Maybe$Nothing, pR: $elm$core$Maybe$Nothing}))));
			case 5:
				var value = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmds,
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.e8)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
						$author$project$Pyxis$Components$Field$FieldStatus$setIsDirty(true),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
							$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
							A2($author$project$Pyxis$Components$Field$Autocomplete$setValue, value, model))));
			case 6:
				var event = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$elm$core$Basics$always(
							A3(
								$author$project$Pyxis$Commons$Basics$ternaryOperator,
								$author$project$Pyxis$Commons$Events$Keyboard$isEnter(event) && (!_Utils_eq(modelData.J, $elm$core$Maybe$Nothing)),
								$author$project$Pyxis$Commons$Commands$dispatchFromMaybe(modelData.e8),
								$elm$core$Platform$Cmd$none)),
							$author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange(model)
						]),
					A2($author$project$Pyxis$Components$Field$Autocomplete$updateOnKeyEvent, event, model));
			case 2:
				var option_ = msg.a;
				return A2(
					$primait$prima_elm_extra$PrimaUpdate$withCmdsMap,
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Field$Autocomplete$maybeDispatchOnHoveredOptionChange(model)
						]),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$setActiveOption,
						$elm$core$Maybe$Just(option_),
						model));
			case 7:
				return $primait$prima_elm_extra$PrimaUpdate$withoutCmds(model);
			default:
				return modelData.a7 ? $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					$author$project$Pyxis$Components$Field$Autocomplete$setDropdownClosed(model)) : $primait$prima_elm_extra$PrimaUpdate$withoutCmds(
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$setIsDropdownOpen,
						true,
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$setHasFocus,
							true,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$mapFieldStatus,
								$author$project$Pyxis$Components$Field$FieldStatus$setIsBlurred(false),
								model))));
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionReason = F2(
	function (msg, _v0) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Autocomplete$update, msg, model.aQ);
		var reasonInputModel = _v1.a;
		var reasonInputCmd = _v1.b;
		var descriptionStatus = A2(
			$elm$core$Maybe$withDefault,
			3,
			A2(
				$elm$core$Maybe$map,
				model.gr,
				$author$project$Pyxis$Components$Field$Autocomplete$getValue(reasonInputModel)));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bJ: descriptionStatus, aQ: reasonInputModel}),
			reasonInputCmd);
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Loading = 3;
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmit = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{aH: 3}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$Submitted = 2;
var $author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmitError = function (_v0) {
	var model = _v0;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{aH: 2}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pyxis$Components$Field$Textarea$getValue = function (_v0) {
	var value = _v0.pR;
	return value;
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonAdditionalNotes = F2(
	function (_v0, textareaMsg) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Textarea$update, textareaMsg, model.aE);
		var newDescriptionModel = _v1.a;
		var textareaCmd = _v1.b;
		var description = $author$project$Pyxis$Components$Field$Textarea$getValue(newDescriptionModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					mt: $elm$core$Maybe$Just(description),
					aE: newDescriptionModel
				}),
			textareaCmd);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$setDescription = F2(
	function (description, data) {
		switch (data.$) {
			case 0:
				var withdrawalData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput(
					_Utils_update(
						withdrawalData,
						{m1: description}));
			case 1:
				var customerTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
					_Utils_update(
						customerTerminationData,
						{m1: description}));
			default:
				var primaTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
					_Utils_update(
						primaTerminationData,
						{m1: description}));
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonDescription = F2(
	function (_v0, textareaMsg) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Textarea$update, textareaMsg, model.aE);
		var newDescriptionModel = _v1.a;
		var textareaCmd = _v1.b;
		var description = $author$project$Pyxis$Components$Field$Textarea$getValue(newDescriptionModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aE: newDescriptionModel,
					av: A2(
						$elm$core$Maybe$map,
						$author$project$Page$PolicyDetails$InterruptionModal$Data$setDescription(
							$elm$core$Maybe$Just(description)),
						model.av)
				}),
			textareaCmd);
	});
var $author$project$Common$ReasonDescriptionStatus$fromCustomerTerminationReason = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 8:
			return 1;
		case 9:
			return 1;
		case 7:
			return 2;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 19:
			return 0;
		case 16:
			return 1;
		case 17:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Common$ReasonDescriptionStatus$fromCustomerWithdrawReason = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 7:
			return 2;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 16:
			return 0;
		case 9:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Common$ReasonDescriptionStatus$fromPrimaTerminationReason = function (reason) {
	switch (reason) {
		case 2:
			return 2;
		case 0:
			return 2;
		case 1:
			return 1;
		case 3:
			return 2;
		case 4:
			return 1;
		default:
			return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'COMPETITOR_OFFER':
			return $elm$core$Maybe$Just(0);
		case 'VEHICLE_SOLD':
			return $elm$core$Maybe$Just(1);
		case 'VEHICLE_NOT_PURCHASED':
			return $elm$core$Maybe$Just(2);
		case 'VEHICLE_DEREGISTRATION':
			return $elm$core$Maybe$Just(3);
		case 'NO_INSURANCE_WANTED':
			return $elm$core$Maybe$Just(4);
		case 'DOES_NOT_KNOW':
			return $elm$core$Maybe$Just(5);
		case 'WANTS_GREEN_CARD':
			return $elm$core$Maybe$Just(6);
		case 'INCORRECT_EFFECTIVE_DATE':
			return $elm$core$Maybe$Just(7);
		case 'INCORRECT_PERSONAL_DATA':
			return $elm$core$Maybe$Just(8);
		case 'INCORRECT_DATA_OTHER':
			return $elm$core$Maybe$Just(9);
		case 'PAYMENT_METHOD_OR_DATE':
			return $elm$core$Maybe$Just(10);
		case 'DECEASED_POLICY_HOLDER':
			return $elm$core$Maybe$Just(11);
		case 'COVERAGE_CHANGE':
			return $elm$core$Maybe$Just(12);
		case 'DISSATISFACTION_SERVICE':
			return $elm$core$Maybe$Just(13);
		case 'UNDERWRITING_RULES':
			return $elm$core$Maybe$Just(14);
		case 'MOVING_TO_ANOTHER_COUNTRY':
			return $elm$core$Maybe$Just(15);
		case 'PRODUCT_SERVICE':
			return $elm$core$Maybe$Just(16);
		case 'POLICY_HOLDER_CHANGE':
			return $elm$core$Maybe$Just(17);
		case 'SWITCH_TO_GREAT_LAKES':
			return $elm$core$Maybe$Just(18);
		case 'OTHER':
			return $elm$core$Maybe$Just(19);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$CompetitorOffer = 0;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$CoverageChange = 12;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$DeceasedPolicyHolder = 11;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$DissatisfactionService = 13;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$DoesNotKnow = 5;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$IncorrectDataOther = 8;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$IncorrectEffectiveDate = 7;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$IncorrectPersonalData = 9;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$MovingToAnotherCountry = 15;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$NoInsuranceWanted = 4;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$Other = 16;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$PaymentMethodOrDate = 10;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$UnderwritingRules = 14;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$VehicleDeregistration = 3;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$VehicleNotPurchased = 2;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$VehicleSold = 1;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$WantsGreenCard = 6;
var $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'COMPETITOR_OFFER':
			return $elm$core$Maybe$Just(0);
		case 'VEHICLE_SOLD':
			return $elm$core$Maybe$Just(1);
		case 'VEHICLE_NOT_PURCHASED':
			return $elm$core$Maybe$Just(2);
		case 'VEHICLE_DEREGISTRATION':
			return $elm$core$Maybe$Just(3);
		case 'NO_INSURANCE_WANTED':
			return $elm$core$Maybe$Just(4);
		case 'DOES_NOT_KNOW':
			return $elm$core$Maybe$Just(5);
		case 'WANTS_GREEN_CARD':
			return $elm$core$Maybe$Just(6);
		case 'INCORRECT_EFFECTIVE_DATE':
			return $elm$core$Maybe$Just(7);
		case 'INCORRECT_DATA_OTHER':
			return $elm$core$Maybe$Just(8);
		case 'INCORRECT_PERSONAL_DATA':
			return $elm$core$Maybe$Just(9);
		case 'PAYMENT_METHOD_OR_DATE':
			return $elm$core$Maybe$Just(10);
		case 'DECEASED_POLICY_HOLDER':
			return $elm$core$Maybe$Just(11);
		case 'COVERAGE_CHANGE':
			return $elm$core$Maybe$Just(12);
		case 'DISSATISFACTION_SERVICE':
			return $elm$core$Maybe$Just(13);
		case 'UNDERWRITING_RULES':
			return $elm$core$Maybe$Just(14);
		case 'MOVING_TO_ANOTHER_COUNTRY':
			return $elm$core$Maybe$Just(15);
		case 'OTHER':
			return $elm$core$Maybe$Just(16);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'INEXACT_DECLARATION_SINCO':
			return $elm$core$Maybe$Just(0);
		case 'FRAUD':
			return $elm$core$Maybe$Just(1);
		case 'CHARGEBACK':
			return $elm$core$Maybe$Just(2);
		case 'INEXACT_DECLARATION_DNI':
			return $elm$core$Maybe$Just(3);
		case 'RISK_AGGRAVATION':
			return $elm$core$Maybe$Just(4);
		case 'PHOTO_VERIFICATION_NOT_PROVIDED':
			return $elm$core$Maybe$Just(5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$setReason = F2(
	function (maybeReason, data) {
		switch (data.$) {
			case 0:
				var withdrawalData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$WithdrawalInput(
					_Utils_update(
						withdrawalData,
						{
							bJ: A2(
								$elm$core$Maybe$withDefault,
								3,
								A2(
									$elm$core$Maybe$map,
									$author$project$Common$ReasonDescriptionStatus$fromCustomerWithdrawReason,
									A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$fromString, maybeReason))),
							kQ: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerWithdrawReason$fromString, maybeReason)
						}));
			case 1:
				var customerTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$CustomerTerminationInput(
					_Utils_update(
						customerTerminationData,
						{
							bJ: A2(
								$elm$core$Maybe$withDefault,
								3,
								A2(
									$elm$core$Maybe$map,
									$author$project$Common$ReasonDescriptionStatus$fromCustomerTerminationReason,
									A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$fromString, maybeReason))),
							kQ: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerTerminateReason$fromString, maybeReason)
						}));
			default:
				var primaTerminationData = data.a;
				return $author$project$Page$PolicyDetails$InterruptionModal$Data$PrimaTerminationInput(
					_Utils_update(
						primaTerminationData,
						{
							bJ: A2(
								$elm$core$Maybe$withDefault,
								3,
								A2(
									$elm$core$Maybe$map,
									$author$project$Common$ReasonDescriptionStatus$fromPrimaTerminationReason,
									A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$fromString, maybeReason))),
							kQ: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$PrimaTerminateReason$fromString, maybeReason)
						}));
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonKindInput = F2(
	function (_v0, autoCompleteMessage) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Autocomplete$update, autoCompleteMessage, model.aQ);
		var autoCompleteReasonModel = _v1.a;
		var selectCmd = _v1.b;
		var reason = $author$project$Pyxis$Components$Field$Autocomplete$getValue(autoCompleteReasonModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					av: A2(
						$elm$core$Maybe$map,
						$author$project$Page$PolicyDetails$InterruptionModal$Data$setReason(reason),
						model.av),
					aQ: autoCompleteReasonModel
				}),
			selectCmd);
	});
var $author$project$Common$ReasonDescriptionStatus$fromCustomerDeclineRenewalReason = function (reason) {
	switch (reason) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 2;
		case 6:
			return 2;
		case 8:
			return 1;
		case 9:
			return 1;
		case 7:
			return 2;
		case 10:
			return 2;
		case 11:
			return 2;
		case 12:
			return 1;
		case 13:
			return 1;
		case 14:
			return 2;
		case 15:
			return 2;
		case 19:
			return 0;
		case 16:
			return 1;
		case 17:
			return 1;
		default:
			return 1;
	}
};
var $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$fromString = function (enumString____) {
	switch (enumString____) {
		case 'COMPETITOR_OFFER':
			return $elm$core$Maybe$Just(0);
		case 'VEHICLE_SOLD':
			return $elm$core$Maybe$Just(1);
		case 'VEHICLE_NOT_PURCHASED':
			return $elm$core$Maybe$Just(2);
		case 'VEHICLE_DEREGISTRATION':
			return $elm$core$Maybe$Just(3);
		case 'NO_INSURANCE_WANTED':
			return $elm$core$Maybe$Just(4);
		case 'DOES_NOT_KNOW':
			return $elm$core$Maybe$Just(5);
		case 'WANTS_GREEN_CARD':
			return $elm$core$Maybe$Just(6);
		case 'INCORRECT_EFFECTIVE_DATE':
			return $elm$core$Maybe$Just(7);
		case 'INCORRECT_PERSONAL_DATA':
			return $elm$core$Maybe$Just(8);
		case 'INCORRECT_DATA_OTHER':
			return $elm$core$Maybe$Just(9);
		case 'PAYMENT_METHOD_OR_DATE':
			return $elm$core$Maybe$Just(10);
		case 'DECEASED_POLICY_HOLDER':
			return $elm$core$Maybe$Just(11);
		case 'COVERAGE_CHANGE':
			return $elm$core$Maybe$Just(12);
		case 'DISSATISFACTION_SERVICE':
			return $elm$core$Maybe$Just(13);
		case 'UNDERWRITING_RULES':
			return $elm$core$Maybe$Just(14);
		case 'MOVING_TO_ANOTHER_COUNTRY':
			return $elm$core$Maybe$Just(15);
		case 'PRODUCT_SERVICE':
			return $elm$core$Maybe$Just(16);
		case 'POLICY_HOLDER_CHANGE':
			return $elm$core$Maybe$Just(17);
		case 'PRICE_INCREASE':
			return $elm$core$Maybe$Just(18);
		case 'OTHER':
			return $elm$core$Maybe$Just(19);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonKindInput = F2(
	function (_v0, autoCompleteMessage) {
		var model = _v0;
		var _v1 = A2($author$project$Pyxis$Components$Field$Autocomplete$update, autoCompleteMessage, model.aQ);
		var autoCompleteReasonModel = _v1.a;
		var selectCmd = _v1.b;
		var maybeReason = $author$project$Pyxis$Components$Field$Autocomplete$getValue(autoCompleteReasonModel);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					mt: $elm$core$Maybe$Nothing,
					bJ: A2(
						$elm$core$Maybe$withDefault,
						3,
						A2(
							$elm$core$Maybe$map,
							$author$project$Common$ReasonDescriptionStatus$fromCustomerDeclineRenewalReason,
							A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$fromString, maybeReason))),
					aQ: autoCompleteReasonModel,
					fo: A2($elm$core$Maybe$andThen, $author$project$New$Gql$Platform$Enum$CustomerDeclineRenewalReason$fromString, maybeReason)
				}),
			selectCmd);
	});
var $author$project$Page$PolicyDetails$updateToastState = F2(
	function (_v0, _v1) {
		var toastModel = _v0.a;
		var toastCmd = _v0.b;
		var model = _v1.a;
		var effect = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{t: toastModel}),
			$author$project$Page$PolicyDetails$Effect$Effects(
				_List_fromArray(
					[
						effect,
						$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd)
					])));
	});
var $author$project$Page$PolicyDetails$update = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				if (msg.a.$ === 3) {
					var policy = msg.a.a;
					var _v1 = A2($author$project$Page$PolicyDetails$maybeUpdateModelIfRefererIsPaymentPage, i18n, model);
					var updatedModel = _v1.a;
					var toastEffect = _v1.b;
					return _Utils_Tuple2(
						A3(
							$author$project$Page$PolicyDetails$Model$maybeInitAmendModal,
							i18n,
							policy,
							A2(
								$author$project$Page$PolicyDetails$Model$setPaymentMethod,
								$krisajenkins$remotedata$RemoteData$Loading,
								A2(
									$author$project$Page$PolicyDetails$Model$setPolicyResult,
									$krisajenkins$remotedata$RemoteData$Success(policy),
									updatedModel))),
						$author$project$Page$PolicyDetails$Effect$Effects(
							_List_fromArray(
								[
									$author$project$Page$PolicyDetails$Effect$FetchCustomerId(
									$author$project$Common$Policy$pickId(policy)),
									$author$project$Page$PolicyDetails$chooseClaimHistoryEffectByFetchedPolicy(policy),
									A3(
									$author$project$Page$PolicyDetails$chooseGetRefundEffectByFetchedPolicy,
									model,
									$author$project$Page$PolicyDetails$Model$pickIssueRefundReleaseDate(model),
									policy),
									$author$project$Page$PolicyDetails$Effect$FetchPaymentMethod(
									$author$project$Common$Policy$pickId(policy)),
									$author$project$Page$PolicyDetails$Effect$FetchCoverSelection(
									$author$project$Common$Policy$pickId(policy)),
									toastEffect
								])));
				} else {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setPolicyResult, remoteData, model),
						$author$project$Page$PolicyDetails$Effect$None);
				}
			case 1:
				if (msg.a.$ === 3) {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setClaimHistoryResult, remoteData, model),
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Page$PolicyDetails$Effect$None,
							A2(
								$elm$core$Maybe$map,
								$author$project$Page$PolicyDetails$Effect$FetchPricingActionClaimHistory,
								$author$project$Page$PolicyDetails$Model$pickPolicyId(model))));
				} else {
					var remoteData = msg.a;
					return _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setClaimHistoryResult, remoteData, model),
						$author$project$Page$PolicyDetails$Effect$None);
				}
			case 2:
				var remoteData = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$PolicyDetails$Model$setClaimHistoryPricingActionResult, remoteData, model),
					$author$project$Page$PolicyDetails$Effect$None);
			case 3:
				var remotedata = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$PolicyDetails$Model$setCustomerId, remotedata, model),
					$author$project$Page$PolicyDetails$Effect$None);
			case 4:
				if (msg.a.$ === 3) {
					var coverSelectionResult = msg.a;
					var coverSelection = coverSelectionResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ej: A2(
									$author$project$Common$ComponentUI$Modal$CoverPackages$withProductVersion,
									$author$project$Common$ComponentUI$Modal$CoverPackages$productVersionFromCoverSelection(coverSelection),
									model.ej),
								jZ: coverSelectionResult
							}),
						$author$project$Page$PolicyDetails$Effect$None);
				} else {
					var coverSelection = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{jZ: coverSelection}),
						$author$project$Page$PolicyDetails$Effect$None);
				}
			case 5:
				var searchTerm = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$ChangeRoute(
						A2(
							$author$project$Route$Search,
							$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
							$elm$core$Result$Ok(searchTerm))));
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gk: $elm$core$Maybe$Just(time)
						}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 6:
				return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
			case 7:
				if (msg.a) {
					var _v2 = $author$project$Common$ComponentUI$Modal$CoverPackages$open(model.ej);
					var newModalModel = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ej: newModalModel}),
						$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
				} else {
					var _v3 = $author$project$Common$ComponentUI$Modal$CoverPackages$close(model.ej);
					var newModalModel = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ej: newModalModel}),
						$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
				}
			case 8:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.lr);
				var newModel = _v4.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lr: newModel}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 12:
				var inputMsg = msg.a;
				var _v5 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateInterruptionDateInput, model.q, inputMsg);
				var modalModel = _v5.a;
				var subCmd = _v5.b;
				return A3(
					$author$project$Page$PolicyDetails$applyIfInterruptionModelChanged,
					model,
					modalModel,
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd),
								$author$project$Page$PolicyDetails$Effect$GetExpectedRefund
							])));
			case 13:
				var selectMsg = msg.a;
				var _v6 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonKindInput, model.q, selectMsg);
				var modalModel = _v6.a;
				var subCmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 15:
				var _v7 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount, model.q, $krisajenkins$remotedata$RemoteData$NotAsked);
				var newModalState = _v7.a;
				var subCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: newModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 14:
				var _v8 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount, model.q, $krisajenkins$remotedata$RemoteData$Loading);
				var newModalState = _v8.a;
				return A3($author$project$Page$PolicyDetails$applyIfInterruptionModelChanged, model, newModalState, $author$project$Page$PolicyDetails$Effect$GetExpectedRefund);
			case 16:
				var textareaMsg = msg.a;
				var _v9 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateReasonDescription, model.q, textareaMsg);
				var modalModel = _v9.a;
				var subCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 17:
				var kind = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A3(
						$elm$core$Maybe$map2,
						A3($author$project$Page$PolicyDetails$openAndInitInterruptionModal, i18n, kind, model),
						$krisajenkins$remotedata$RemoteData$toMaybe(model.l),
						model.gk));
			case 18:
				var _v10 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.q);
				var newInterruptionDateModel = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: newInterruptionDateModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 22:
				switch (msg.a.$) {
					case 3:
						var _v11 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyInterruptionSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.t);
						var newToastsState = _v11.a;
						var cmd = _v11.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.o6),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					case 2:
						var _v12 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyGeneralErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastsState = _v12.a;
						var cmd = _v12.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 19:
				var _arguments = msg.a;
				var _v13 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.q);
				var newInterruptionDateModel = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: newInterruptionDateModel, l: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$WithdrawPolicy(_arguments),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 20:
				var _arguments = msg.a;
				var _v14 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.q);
				var newInterruptionDateModel = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: newInterruptionDateModel, l: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$CustomerTerminatePolicy(_arguments),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 21:
				var _arguments = msg.a;
				var _v15 = $author$project$Page$PolicyDetails$InterruptionModal$Model$closeModal(model.q);
				var newInterruptionDateModel = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: newInterruptionDateModel, l: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$PrimaTerminatePolicy(_arguments),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 10:
				var amount = msg.a;
				var _v16 = A2($author$project$Page$PolicyDetails$InterruptionModal$Model$updateExpectedRefundAmount, model.q, amount);
				var newModalState = _v16.a;
				var subCmd = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{q: newModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 11:
				var result = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
					$author$project$Page$PolicyDetails$Effect$None);
			case 63:
				if (msg.b.$ === 3) {
					var policyId = msg.a;
					var result = msg.b;
					var refund = result.a;
					var _v17 = $author$project$Common$Refund$pickStatus(refund);
					switch (_v17) {
						case 2:
							return A4($author$project$Page$PolicyDetails$showRefundSuccess, i18n, model, refund, result);
						case 3:
							return A3($author$project$Page$PolicyDetails$showRefundFailure, i18n, model, result);
						case 1:
							return _Utils_Tuple2(
								A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
								$author$project$Page$PolicyDetails$Effect$None);
						case 0:
							return A2($author$project$Page$PolicyDetails$continuePolling, model, policyId);
						default:
							return _Utils_Tuple2(
								A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
								$author$project$Page$PolicyDetails$Effect$None);
					}
				} else {
					var policyId = msg.a;
					return A2($author$project$Page$PolicyDetails$continuePolling, model, policyId);
				}
			case 64:
				var policyId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$PollRefundForCompletion(policyId));
			case 23:
				var policyId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$CreateRefund(policyId));
			case 24:
				var refund = msg.a;
				var _v18 = A2($author$project$Page$PolicyDetails$RefundIssuingModal$openModal, refund, model.cg);
				var newRefundModalState = _v18.a;
				var cmd = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cg: newRefundModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 25:
				var _v19 = $author$project$Page$PolicyDetails$RefundIssuingModal$closeModal(model.cg);
				var newRefundModalState = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cg: newRefundModalState}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 26:
				var refund = msg.a;
				var refundEffect = $author$project$Common$Refund$isToBePaid(refund) ? $author$project$Page$PolicyDetails$Effect$PayRefund(refund) : $author$project$Page$PolicyDetails$Effect$IssueRefund(refund);
				var _v20 = $author$project$Page$PolicyDetails$RefundIssuingModal$closeModal(model.cg);
				var newRefundModalState = _v20.a;
				var cmd = _v20.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cg: newRefundModalState}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								refundEffect,
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 27:
				switch (msg.a.$) {
					case 3:
						var _v21 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyCreateRefundSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.t);
						var newToastsState = _v21.a;
						var cmd = _v21.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.o6),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					case 2:
						var _v22 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyGeneralErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastsState = _v22.a;
						var cmd = _v22.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 28:
				switch (msg.a.$) {
					case 3:
						return _Utils_Tuple2(
							A2($author$project$Page$PolicyDetails$Model$setRefundResult, $krisajenkins$remotedata$RemoteData$Loading, model),
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$Page$PolicyDetails$Effect$None,
								A2(
									$elm$core$Maybe$map,
									$author$project$Page$PolicyDetails$Effect$PollRefundForCompletion,
									$author$project$Page$PolicyDetails$Model$pickPolicyId(model))));
					case 2:
						var _v23 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyIssueRefundErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastsState = _v23.a;
						var cmd = _v23.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsState}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 29:
				var timestampMillis = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							nJ: $elm$core$Maybe$Just(
								$elm$time$Time$millisToPosix(timestampMillis))
						}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 30:
				return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
			case 31:
				var policy = msg.a;
				return A3($author$project$Page$PolicyDetails$openAndInitRenewalCancellationModal, i18n, model, policy);
			case 32:
				var _v24 = $author$project$Page$PolicyDetails$RenewalCancellationModal$closeModal(model.ap);
				var newRenewalCancellationModel = _v24.a;
				var cmd = _v24.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ap: newRenewalCancellationModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 33:
				var selectMsg = msg.a;
				var _v25 = A2($author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonKindInput, model.ap, selectMsg);
				var modalModel = _v25.a;
				var subCmd = _v25.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ap: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 34:
				var textareaMsg = msg.a;
				var _v26 = A2($author$project$Page$PolicyDetails$RenewalCancellationModal$updateReasonAdditionalNotes, model.ap, textareaMsg);
				var modalModel = _v26.a;
				var subCmd = _v26.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ap: modalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(subCmd));
			case 35:
				var args = msg.a;
				var _v27 = $author$project$Page$PolicyDetails$RenewalCancellationModal$closeModal(model.ap);
				var newRenewalCancellationModal = _v27.a;
				var cmd = _v27.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l: $krisajenkins$remotedata$RemoteData$Loading, ap: newRenewalCancellationModal}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$RenewalCancellation(args),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 36:
				switch (msg.a.$) {
					case 3:
						var _v28 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyRenewalCancellationSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.t);
						var newToastsModel = _v28.a;
						var toastCmd = _v28.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.o6),
										$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd)
									])));
					case 2:
						var _v29 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyRenewalCancellationErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastsModel = _v29.a;
						var toastCmd = _v29.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 41:
				switch (msg.a.$) {
					case 3:
						var result = msg.a;
						var _v30 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								A2(
									$author$project$Translations$policySendEmailSuccessMessage,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Page$PolicyDetails$Model$pickEmailRecipient(model)),
									i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.t);
						var newToastsModel = _v30.a;
						var toastCmd = _v30.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fp: result, t: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd));
					case 2:
						var result = msg.a;
						var _v31 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policySendEmailFailureMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastsModel = _v31.a;
						var toastCmd = _v31.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fp: result, t: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(toastCmd));
					default:
						var result = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fp: result}),
							$author$project$Page$PolicyDetails$Effect$None);
				}
			case 37:
				var renewalPolicyId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$PolicyDetails$Effect$ChangeRoute(
						A2(
							$author$project$Route$PolicyDetails,
							renewalPolicyId,
							$elm$core$Maybe$Just($author$project$Referer$paymentPage))));
			case 38:
				var message = msg.a;
				var _v32 = A2($author$project$Common$Portfolio$update, message, model.dt);
				var newModel = _v32.a;
				var cmd = _v32.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dt: newModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 39:
				var response = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lq: response}),
					$author$project$Page$PolicyDetails$Effect$None);
			case 40:
				var policyId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lq: $krisajenkins$remotedata$RemoteData$Loading}),
					$author$project$Page$PolicyDetails$Effect$FetchPaymentMethod(policyId));
			case 42:
				var policyId = msg.a;
				var email = msg.b;
				var _v33 = A3($author$project$Page$PolicyDetails$SendEmailModal$openModal, policyId, email, model.cl);
				var newModalModel = _v33.a;
				var cmd = _v33.b;
				return _Utils_Tuple2(
					$author$project$Page$PolicyDetails$resetSendEmailResult(
						A2($author$project$Page$PolicyDetails$openSendEmailModal, newModalModel, model)),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 44:
				var sendEmailMsg = msg.a;
				var _v34 = A2($author$project$Page$PolicyDetails$SendEmailModal$update, sendEmailMsg, model.cl);
				var newModalModel = _v34.a;
				var cmd = _v34.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cl: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 43:
				var id = msg.a;
				var trackSendingEmail = $author$project$Page$PolicyDetails$Effect$TrackSendEmail(
					$elm$core$List$singleton($author$project$Page$PolicyDetails$SendEmailModal$emailOptionToString));
				var _v35 = $author$project$Page$PolicyDetails$SendEmailModal$closeModal(model.cl);
				var newModalModel = _v35.a;
				var cmd = _v35.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cl: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								$author$project$Page$PolicyDetails$Effect$SendPolicyContractEmail(id),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd),
								trackSendingEmail
							])));
			case 45:
				var toastCounterSubMsg = msg.a;
				var _v36 = A2($author$project$Pyxis$Components$Toasts$update, toastCounterSubMsg, model.t);
				var newToastsModel = _v36.a;
				var cmd = _v36.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{t: newToastsModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 46:
				var originalEmail = msg.a;
				var _v37 = A2($author$project$Page$PolicyDetails$ChangeEmailModal$openModal, originalEmail, model.bD);
				var newModalModel = _v37.a;
				var cmd = _v37.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bD: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 47:
				var subMsg = msg.a;
				var _v38 = A2($author$project$Page$PolicyDetails$ChangeEmailModal$update, subMsg, model.bD);
				var newModalModel = _v38.a;
				var cmd = _v38.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bD: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
			case 48:
				var newEmail = msg.a;
				var _v39 = $author$project$Page$PolicyDetails$ChangeEmailModal$closeModal(model.bD);
				var newModalModel = _v39.a;
				var cmd = _v39.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bD: newModalModel}),
					$author$project$Page$PolicyDetails$Effect$Effects(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$author$project$Page$PolicyDetails$Effect$None,
								A2(
									$elm$core$Maybe$map,
									$author$project$Page$PolicyDetails$Effect$UpdateEmail(newEmail),
									A2(
										$elm$core$Maybe$map,
										$author$project$Common$Policy$pickCustomerFacingId,
										$krisajenkins$remotedata$RemoteData$toMaybe(model.l)))),
								$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
							])));
			case 49:
				switch (msg.a.$) {
					case 2:
						var _v40 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$changeEmailModalErrorToastMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						var newToastModel = _v40.a;
						var cmd = _v40.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastModel}),
							$author$project$Page$PolicyDetails$Effect$WithCmd(cmd));
					case 3:
						var _v41 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$changeEmailModalSuccessToastMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.t);
						var newToastModel = _v41.a;
						var cmd = _v41.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastModel}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.o6),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 50:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$openModal,
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.W));
			case 51:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$closeModal,
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.W));
			case 52:
				var description = msg.a;
				var interruptionAt = msg.b;
				var reason = msg.c;
				var hasInterruptionDateChanged = msg.d;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A4($author$project$Page$PolicyDetails$requestAmendInterruption, description, interruptionAt, reason, hasInterruptionDateChanged),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmit,
								$author$project$Page$PolicyDetails$updateAmendModalState(model)),
							model.W)));
			case 60:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmitError,
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.W));
			case 59:
				switch (msg.b.$) {
					case 3:
						var hasInterruptionDateChanged = msg.a;
						var pollRefundEffect = A2(
							$elm$core$Maybe$withDefault,
							$author$project$Page$PolicyDetails$Effect$None,
							A3(
								$elm$core$Maybe$map2,
								$author$project$Page$PolicyDetails$Effect$PollForRefundUpdate,
								$author$project$Page$PolicyDetails$Model$pickRefund(model),
								$author$project$Page$PolicyDetails$Model$pickPolicyId(model)));
						var canBePolled = A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Common$Refund$isPendingOrNotRequired,
								$author$project$Page$PolicyDetails$Model$pickRefund(model)));
						var _v42 = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyAmendInterruptionSuccessMessage(i18n),
								$author$project$Pyxis$Components$Toasts$successToast),
							model.t);
						var newToastsModel = _v42.a;
						var cmd = _v42.b;
						return (hasInterruptionDateChanged && canBePolled) ? _Utils_Tuple2(
							A2(
								$author$project$Page$PolicyDetails$Model$setRefundResult,
								$krisajenkins$remotedata$RemoteData$Loading,
								_Utils_update(
									model,
									{t: newToastsModel})),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.o6),
										pollRefundEffect,
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									]))) : _Utils_Tuple2(
							_Utils_update(
								model,
								{t: newToastsModel}),
							$author$project$Page$PolicyDetails$Effect$Effects(
								_List_fromArray(
									[
										$author$project$Page$PolicyDetails$Effect$FetchPolicy(model.o6),
										$author$project$Page$PolicyDetails$Effect$WithCmd(cmd)
									])));
					case 2:
						var updatedToastStatus = A2(
							$author$project$Pyxis$Components$Toasts$addNewToast,
							A2(
								$author$project$Pyxis$Components$Toasts$withToastText,
								$author$project$Translations$policyGeneralErrorMessage(i18n),
								$author$project$Pyxis$Components$Toasts$errorToast),
							model.t);
						return A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
							A2(
								$elm$core$Maybe$map,
								$author$project$Page$PolicyDetails$updateToastState(updatedToastStatus),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Page$PolicyDetails$AmendInterruptionModal$updateOnSubmitError,
										$author$project$Page$PolicyDetails$updateAmendModalState(model)),
									model.W)));
					default:
						return _Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None);
				}
			case 57:
				return $author$project$Page$PolicyDetails$maybeGetExpectedRefundForAmendInterruption(
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None));
			case 54:
				return $author$project$Page$PolicyDetails$maybeGetExpectedRefundForAmendInterruption(
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None));
			case 58:
				var result = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateExpectedRefundAmount(result),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.W));
			case 56:
				var subMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDate(subMsg),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.W));
			case 53:
				var subMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionReason(subMsg),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.W));
			case 55:
				var subMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $author$project$Page$PolicyDetails$Effect$None),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$updateInterruptionDescription(subMsg),
							$author$project$Page$PolicyDetails$updateAmendModalState(model)),
						model.W));
			case 61:
				if (msg.c.$ === 3) {
					var originalRefund = msg.a;
					var policyId = msg.b;
					var result = msg.c;
					var refund = result.a;
					return _Utils_eq(refund, originalRefund) ? _Utils_Tuple2(
						model,
						A2($author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundUpdate, originalRefund, policyId)) : _Utils_Tuple2(
						A2($author$project$Page$PolicyDetails$Model$setRefundResult, result, model),
						$author$project$Page$PolicyDetails$Effect$None);
				} else {
					var originalRefund = msg.a;
					var policyId = msg.b;
					return _Utils_Tuple2(
						model,
						A2($author$project$Page$PolicyDetails$Effect$WaitBeforePollingRefundUpdate, originalRefund, policyId));
				}
			default:
				var originalRefund = msg.a;
				var policyId = msg.b;
				return _Utils_Tuple2(
					model,
					A2($author$project$Page$PolicyDetails$Effect$PollForRefundUpdate, originalRefund, policyId));
		}
	});
var $author$project$Page$Search$Effect$ChangeRoute = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Search$Effect$RewriteUrlRequest = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Search$Effect$RewrittenUrl = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Search$Effect$TrackUserSearch = function (a) {
	return {$: 8, a: a};
};
var $author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute = function (inputValue) {
	return A2(
		$elm_community$result_extra$Result$Extra$or,
		$author$project$Page$Search$SearchQueryParam$customerIdRecogniser(inputValue),
		$author$project$Page$Search$SearchQueryParam$mailRecogniser(inputValue));
};
var $author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput = function (inputValue) {
	return A3(
		$elm_community$result_extra$Result$Extra$unwrap,
		$author$project$Page$Search$SearchQueryParam$defaultWhenNotRecognised(inputValue),
		$elm$core$Basics$identity,
		A2(
			$elm_community$result_extra$Result$Extra$or,
			$author$project$Page$Search$SearchQueryParam$phoneNumberRecogniser(inputValue),
			A2(
				$elm_community$result_extra$Result$Extra$or,
				$author$project$Page$Search$SearchQueryParam$dniRecogniser(inputValue),
				A2(
					$elm_community$result_extra$Result$Extra$or,
					$author$project$Page$Search$SearchQueryParam$emptyStringRecogniser(inputValue),
					A2(
						$elm_community$result_extra$Result$Extra$or,
						$author$project$Page$Search$SearchQueryParam$cfIdRecogniser(inputValue),
						$author$project$Page$Search$SearchQueryParam$mailRecogniser(inputValue))))));
};
var $author$project$Pyxis$Components$Tabs$getActiveTabIndex = function (_v0) {
	var activeIndex = _v0.V;
	return activeIndex;
};
var $author$project$Pyxis$Components$Field$Input$resetValue = function (_v0) {
	var modelData = _v0;
	return _Utils_update(
		modelData,
		{pR: ''});
};
var $author$project$Page$Search$SearchQueryParam$searchInputToString = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			return 'documentId';
		case 1:
			switch (searchInput.a.$) {
				case 1:
					return 'offerId';
				case 0:
					return 'policyId';
				default:
					return 'quoteId';
			}
		case 2:
			return 'email';
		case 3:
			return 'empty';
		case 6:
			return 'customerId';
		case 4:
			return 'plateNumber';
		default:
			return 'phoneNumber';
	}
};
var $author$project$Translations$searchResultsToastErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'An unexpected error occurred. Please try again later.';
	} else {
		return 'Se ha producido un error inesperado. Vuelve a intentarlo más tarde.';
	}
};
var $author$project$Page$Search$SearchQueryParam$UnexpectedError = function (a) {
	return {$: 10, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Page$Search$SearchQueryParam$EmailError = {$: 4};
var $author$project$Page$Search$SearchQueryParam$isValidEmail = function (email) {
	var emailPattern = '^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(emailPattern);
	return A2($elm$regex$Regex$contains, regex, email) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$Email(email)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$EmailError);
};
var $author$project$Page$Search$SearchQueryParam$validatePaymentDisputes = function () {
	var genericError = $author$project$Page$Search$SearchQueryParam$UnexpectedError('');
	var validate = function (okResult) {
		switch (okResult.$) {
			case 6:
				var id = okResult.a;
				return $elm$core$Result$Ok(
					$author$project$Page$Search$SearchQueryParam$CustomerId(id));
			case 2:
				var email = okResult.a;
				return $author$project$Page$Search$SearchQueryParam$isValidEmail(email);
			default:
				return $elm$core$Result$Err(genericError);
		}
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$mapError(
			$elm$core$Basics$always(genericError)),
		$elm$core$Result$andThen(validate));
}();
var $author$project$Page$Search$SearchQueryParam$EmptyError = {$: 9};
var $author$project$Page$Search$SearchQueryParam$CustomerFacingIdError = {$: 0};
var $author$project$Page$Search$SearchQueryParam$OfferError = {$: 2};
var $author$project$Page$Search$SearchQueryParam$isValidOfferId = function (offerId) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$Page$Search$SearchQueryParam$fromStringToRegex('^F\\d{9}$'),
		offerId) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$CustomerFacingId(
			$author$project$Page$Search$SearchQueryParam$OfferId(offerId))) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$OfferError);
};
var $author$project$Page$Search$SearchQueryParam$PolicyError = {$: 1};
var $author$project$Page$Search$SearchQueryParam$isValidPolicyId = function (policyId) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$Page$Search$SearchQueryParam$fromStringToRegex('^P\\d{9}$'),
		policyId) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$CustomerFacingId(
			$author$project$Page$Search$SearchQueryParam$PolicyId(policyId))) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$PolicyError);
};
var $author$project$Page$Search$SearchQueryParam$QuoteError = {$: 3};
var $author$project$Page$Search$SearchQueryParam$isValidQuoteId = function (quoteId) {
	return A2(
		$elm$regex$Regex$contains,
		$author$project$Page$Search$SearchQueryParam$fromStringToRegex('^Q\\d{8}$'),
		quoteId) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$CustomerFacingId(
			$author$project$Page$Search$SearchQueryParam$QuoteId(quoteId))) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$QuoteError);
};
var $author$project$Page$Search$SearchQueryParam$isValidCustomerFacingId = function (cfid) {
	var _v0 = $author$project$Page$Search$SearchQueryParam$attemptIdentifyCustomerFacingId(cfid);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var value = _v0.a.a;
				return $author$project$Page$Search$SearchQueryParam$isValidPolicyId(value);
			case 1:
				var value = _v0.a.a;
				return $author$project$Page$Search$SearchQueryParam$isValidOfferId(value);
			default:
				var value = _v0.a.a;
				return $author$project$Page$Search$SearchQueryParam$isValidQuoteId(value);
		}
	} else {
		return $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$CustomerFacingIdError);
	}
};
var $author$project$Page$Search$SearchQueryParam$DocumentIdError = {$: 5};
var $author$project$Page$Search$SearchQueryParam$isValidDocumentId = function (value) {
	var controlLetters = 'TRWAGMYFPDXBNJZSQVHLCKEtrwagmyfpdxbnjzsqvhlcke';
	var dniPattern = '\\d{8}[' + (controlLetters + ']');
	var niePattern = '[KLMXYZklmxyz]\\d{7,8}[' + (controlLetters + ']');
	var documentIdPattern = A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'^({0}|{1})$',
		_List_fromArray(
			[dniPattern, niePattern]));
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(documentIdPattern);
	return A2($elm$regex$Regex$contains, regex, value) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$DocumentId(value)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$DocumentIdError);
};
var $author$project$Page$Search$SearchQueryParam$PhoneNumberError = {$: 7};
var $author$project$Page$Search$SearchQueryParam$isValidPhoneNumber = function (phoneNumber) {
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex('^(\\d{9}|\\d{10})$');
	return A2($elm$regex$Regex$contains, regex, phoneNumber) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$PhoneNumber(phoneNumber)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$PhoneNumberError);
};
var $author$project$Page$Search$SearchQueryParam$PlateNumberError = {$: 6};
var $author$project$Page$Search$SearchQueryParam$isValidPlateNumber = function (value) {
	var oldProvincialCodes = '(A|ALB|AB|AL|AOE|AV|B|BA|BI|BU|C|CA|CAC|CC|CAS|CS|CE|CO|CR|CU|FP|GC|GE|GI|GR|GU|H|HU|I|IF|PM|IB|J|L|LE|LO|LR|LU|M|MA|ME|ML|MU|O|OR|OU|P|PA|NA|PO|RM|S|SA|SE|SEG|SG|SH|SO|SS|T|TE|TER|TE|TEG|TF|TG|TO|V|VA|VI|Z|ZA)';
	var previousPlateNumberPattern = oldProvincialCodes + '\\d{4}[A-Z]{1,2}';
	var oldPlateNumberPattern = oldProvincialCodes + '\\d{1,6}';
	var currentPlateNumberPattern = '\\d{4}[BCDFGHJKLMNPRSTVWXYZ]{3}';
	var regex = $author$project$Page$Search$SearchQueryParam$fromStringToRegex(
		A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'^({0}|{1}|{2})$',
			_List_fromArray(
				[currentPlateNumberPattern, previousPlateNumberPattern, oldPlateNumberPattern])));
	return A2($elm$regex$Regex$contains, regex, value) ? $elm$core$Result$Ok(
		$author$project$Page$Search$SearchQueryParam$PlateNumber(value)) : $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$PlateNumberError);
};
var $author$project$Page$Search$SearchQueryParam$validateSearchInput = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			var docId = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidDocumentId(docId);
		case 1:
			var cfid = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidCustomerFacingId(
				$author$project$Page$Search$SearchQueryParam$pickCustomerFacingId(cfid));
		case 2:
			var email = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidEmail(email);
		case 4:
			var plateNumber = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidPlateNumber(plateNumber);
		case 5:
			var phone = searchInput.a;
			return $author$project$Page$Search$SearchQueryParam$isValidPhoneNumber(phone);
		case 6:
			var id = searchInput.a;
			return $elm$core$Result$Ok(
				$author$project$Page$Search$SearchQueryParam$CustomerId(id));
		default:
			return $elm$core$Result$Err($author$project$Page$Search$SearchQueryParam$EmptyError);
	}
};
var $author$project$Page$Search$update = F3(
	function (i18n, msg, model) {
		switch (msg.$) {
			case 0:
				var inputValue = $author$project$Page$Search$SearchQueryParam$validateSearchInput(
					$author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput(
						$author$project$Pyxis$Components$Field$Input$getValue(model.dB)));
				if (!inputValue.$) {
					var value = inputValue.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eT: true}),
						$author$project$Page$Search$Effect$Effects(
							_List_fromArray(
								[
									$author$project$Page$Search$Effect$RewriteUrlRequest(value),
									$author$project$Page$Search$Effect$TrackUserSearch(
									$author$project$Page$Search$SearchQueryParam$searchInputToString(value))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eT: true}),
						$author$project$Page$Search$Effect$None);
				}
			case 1:
				var id = msg.a;
				var _v2 = A2($author$project$Pyxis$Components$Field$Input$update, id, model.dB);
				var newFieldModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eT: false, dB: newFieldModel}),
					$author$project$Page$Search$Effect$WithCmd(subCmd));
			case 2:
				if (msg.a.$ === 2) {
					var result = msg.a;
					var _v3 = A2(
						$author$project$Pyxis$Components$Toasts$addNewToast,
						A2(
							$author$project$Pyxis$Components$Toasts$withToastText,
							$author$project$Translations$searchResultsToastErrorMessage(i18n),
							$author$project$Pyxis$Components$Toasts$errorToast),
						model.t);
					var newToastsModel = _v3.a;
					var toastsCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kX: result, t: newToastsModel}),
						$author$project$Page$Search$Effect$WithCmd(toastsCmd));
				} else {
					var results = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kX: results}),
						$author$project$Page$Search$Effect$None);
				}
			case 3:
				var offer = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$ChangeRoute(
						$author$project$Route$Payment(
							$author$project$Common$Offer$pickId(offer))));
			case 4:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gj: $elm$core$Maybe$Just(date)
						}),
					$author$project$Page$Search$Effect$None);
			case 5:
				var searchTerm = msg.a;
				var actualTabIndex = $author$project$Pyxis$Components$Tabs$getActiveTabIndex(model.fQ);
				var queryParams = $author$project$Route$toString(
					A2(
						$author$project$Route$Search,
						actualTabIndex,
						$elm$core$Result$Ok(searchTerm)));
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$RewrittenUrl(queryParams));
			case 6:
				var customerFacingId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$ChangeRoute(
						A2($author$project$Route$PolicyDetails, customerFacingId, $elm$core$Maybe$Nothing)));
			case 7:
				var offerCfid = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Page$Search$Effect$ChangeRoute(
						$author$project$Route$OfferDetails(offerCfid)));
			case 8:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Pyxis$Components$Toasts$update, subMsg, model.t);
				var newToastsModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{t: newToastsModel}),
					$author$project$Page$Search$Effect$WithCmd(cmd));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eT: false,
							dB: $author$project$Pyxis$Components$Field$Input$resetValue(model.dB)
						}),
					$author$project$Page$Search$Effect$WithCmd(
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Page$Search$Msg$NoOp),
							$elm$browser$Browser$Dom$focus(model.lL))));
			case 10:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Pyxis$Components$Tabs$update, subMsg, model.fQ);
				var newModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fQ: newModel}),
					$author$project$Page$Search$Effect$WithCmd(cmd));
			case 11:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Pyxis$Components$Field$Input$update, subMsg, model.ik);
				var newModel = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{g9: false, ik: newModel}),
					$author$project$Page$Search$Effect$WithCmd(cmd));
			case 12:
				var inputValue = $author$project$Page$Search$SearchQueryParam$validatePaymentDisputes(
					$author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute(
						$author$project$Pyxis$Components$Field$Input$getValue(model.ik)));
				if (!inputValue.$) {
					var value = inputValue.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g9: true}),
						$author$project$Page$Search$Effect$RewriteUrlRequest(value));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g9: true}),
						$author$project$Page$Search$Effect$None);
				}
			default:
				return _Utils_Tuple2(model, $author$project$Page$Search$Effect$None);
		}
	});
var $author$project$Main$update = F2(
	function (model, msg) {
		var _v0 = _Utils_Tuple2(msg, model.o4);
		_v0$0:
		while (true) {
			_v0$1:
			while (true) {
				_v0$2:
				while (true) {
					_v0$10:
					while (true) {
						_v0$11:
						while (true) {
							switch (_v0.b.$) {
								case 0:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 3:
											var subModel = _v0.b.a;
											var _v5 = $author$project$Page$NotFound$update(subModel);
											var newSubModel = _v5.a;
											var subEffect = _v5.b;
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														o4: $author$project$Model$NotFound(newSubModel)
													}),
												$author$project$Effect$NotFound(subEffect));
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 1:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 4:
											var subModel = _v0.b.a;
											var _v6 = $author$project$Page$NotAuthorized$update(subModel);
											var newSubModel = _v6.a;
											var subEffect = _v6.b;
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														o4: $author$project$Model$NotAuthorized(newSubModel)
													}),
												$author$project$Effect$NotAuthorized(subEffect));
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 2:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 5:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v2 = A2($author$project$Page$Login$update, subMsg, subModel);
											var newSubModel = _v2.a;
											var subEffect = _v2.b;
											if (subEffect.$ === 2) {
												var _v4 = subEffect.a;
												var user = _v4.a;
												var route = _v4.b;
												return _Utils_Tuple2(
													_Utils_update(
														model,
														{
															o4: $author$project$Model$Login(newSubModel),
															fG: $author$project$Common$User$Backoffice(user)
														}),
													$author$project$Effect$ChangeRoute(route));
											} else {
												return _Utils_Tuple2(
													_Utils_update(
														model,
														{
															o4: $author$project$Model$Login(newSubModel)
														}),
													$author$project$Effect$Login(subEffect));
											}
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 3:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 8:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v7 = A3($author$project$Page$Search$update, model.ny, subMsg, subModel);
											var newSubModel = _v7.a;
											var subEffect = _v7.b;
											var subEffectToMainEffect = function () {
												switch (subEffect.$) {
													case 2:
														var route = subEffect.a;
														return $author$project$Effect$ChangeRoute(route);
													case 7:
														var queryParams = subEffect.a;
														return $author$project$Effect$RewriteUrl(queryParams);
													default:
														return $author$project$Effect$Search(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														o4: $author$project$Model$Search(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 4:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 9:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v9 = A2($author$project$Page$Payment$update, subMsg, subModel);
											var newSubModel = _v9.a;
											var subEffect = _v9.b;
											var subEffectToMainEffect = function () {
												switch (subEffect.$) {
													case 1:
														var route = subEffect.a;
														return $author$project$Effect$ChangeRoute(route);
													case 2:
														var pageNumber = subEffect.a;
														return $author$project$Effect$GoBack(pageNumber);
													default:
														return $author$project$Effect$Payment(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														o4: $author$project$Model$Payment(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								case 5:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 10:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v11 = A3($author$project$Page$PolicyDetails$update, model.ny, subMsg, subModel);
											var newSubModel = _v11.a;
											var subEffect = _v11.b;
											var subEffectToMainEffect = function () {
												if (subEffect.$ === 5) {
													var route = subEffect.a;
													return $author$project$Effect$ChangeRoute(route);
												} else {
													return $author$project$Effect$PolicyDetails(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														o4: $author$project$Model$PolicyDetails(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
								default:
									switch (_v0.a.$) {
										case 1:
											break _v0$0;
										case 2:
											break _v0$1;
										case 12:
											break _v0$2;
										case 11:
											var subMsg = _v0.a.a;
											var subModel = _v0.b.a;
											var _v13 = A4($author$project$Page$OfferDetails$update, model.ny, model.m8, subMsg, subModel);
											var newSubModel = _v13.a;
											var subEffect = _v13.b;
											var subEffectToMainEffect = function () {
												if (subEffect.$ === 7) {
													var route = subEffect.a;
													return $author$project$Effect$ChangeRoute(route);
												} else {
													return $author$project$Effect$OfferDetails(subEffect);
												}
											}();
											return _Utils_Tuple2(
												_Utils_update(
													model,
													{
														o4: $author$project$Model$OfferDetails(newSubModel)
													}),
												subEffectToMainEffect);
										case 6:
											break _v0$10;
										case 7:
											break _v0$11;
										default:
											return _Utils_Tuple2(model, $author$project$Effect$None);
									}
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fG: $author$project$Common$User$Anonymous}),
							$author$project$Effect$ChangeRoute($author$project$Route$Login));
					}
					var _v15 = _v0.a;
					return _Utils_Tuple2(model, $author$project$Effect$Logout);
				}
				return _Utils_Tuple2(model, $author$project$Effect$None);
			}
			var url = _v0.a.a;
			return A2(
				$author$project$Main$onRouteChange,
				model,
				$author$project$Route$fromUrl(url));
		}
		var urlRequest = _v0.a.a;
		if (!urlRequest.$) {
			var url = urlRequest.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				function (effect) {
					return $author$project$Effect$Effects(
						_List_fromArray(
							[
								effect,
								$author$project$Effect$ChangeRoute(
								$author$project$Route$fromUrl(url))
							]));
				},
				A2(
					$author$project$Main$onRouteChange,
					model,
					$author$project$Route$fromUrl(url)));
		} else {
			var address = urlRequest.a;
			return _Utils_Tuple2(
				model,
				$author$project$Effect$LoadExternalPage(address));
		}
	});
var $author$project$Main$handle = F2(
	function (msg, model) {
		var _v0 = A2($author$project$Main$update, model, msg);
		var newModel = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple2(
			newModel,
			A3($author$project$Effect$runEffect, model.m8, newModel, effect));
	});
var $author$project$Translations$Es = 1;
var $author$project$Env$Env = $elm$core$Basics$identity;
var $author$project$Env$Unknown = 3;
var $author$project$Env$env = {cF: '', cT: 3, cX: '', cZ: '', c8: $elm$core$Maybe$Nothing, db: $author$project$Common$Locale$customerTimeZone, dc: '', dd: '', df: ''};
var $author$project$Env$Development = 0;
var $author$project$Env$Production = 2;
var $author$project$Env$Staging = 1;
var $author$project$Env$envNameFromString = function (envString) {
	switch (envString) {
		case 'dev':
			return 0;
		case 'staging':
			return 1;
		case 'production':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Translations$En = 0;
var $author$project$Translations$languages = _List_fromArray(
	[0, 1]);
var $author$project$Translations$languageFromString = function (lang) {
	var helper = function (langs) {
		helper:
		while (true) {
			if (!langs.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var l = langs.a;
				var ls = langs.b;
				if (A2(
					$elm$core$String$startsWith,
					$author$project$Translations$languageToString(l),
					lang)) {
					return $elm$core$Maybe$Just(l);
				} else {
					var $temp$langs = ls;
					langs = $temp$langs;
					continue helper;
				}
			}
		}
	};
	return helper(
		$elm$core$List$reverse($author$project$Translations$languages));
};
var $author$project$Main$extractPreferredLanguage = function (languages) {
	return $elm$core$List$head(
		A2($elm$core$List$filterMap, $author$project$Translations$languageFromString, languages));
};
var $author$project$Translations$I18n = $elm$core$Basics$identity;
var $author$project$Translations$init = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$Collapsed = 1;
var $author$project$Pyxis$Components$NavigationSidebar$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$initCollapsed = {cz: '', cV: 1, aJ: $elm$core$Set$empty, c0: $elm$core$Maybe$Nothing, e6: $elm$core$Maybe$Nothing};
var $author$project$Model$init = F4(
	function (key, env, pageModel, language) {
		return {
			m8: env,
			ny: $author$project$Translations$init(language),
			hz: key,
			n7: $author$project$Pyxis$Components$NavigationSidebar$initCollapsed,
			o4: pageModel,
			fG: $author$project$Common$User$Anonymous
		};
	});
var $author$project$Main$languageFromUrl = function (url) {
	return $elm_community$maybe_extra$Maybe$Extra$join(
		A2(
			$elm$core$Maybe$map,
			$author$project$Translations$languageFromString,
			A2(
				$elm$core$Array$get,
				1,
				$elm$core$Array$fromList(
					A2($elm$core$String$split, '/', url.o5)))));
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Env$withApiUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{cF: value});
	});
var $author$project$Env$withEnvName = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{cT: value});
	});
var $author$project$Env$withExternalApiUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{cX: value});
	});
var $author$project$Env$withFunnelUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{cZ: value});
	});
var $author$project$Env$withLanguageOverride = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{
				c8: $elm$core$Maybe$Just(value)
			});
	});
var $author$project$Env$withLocalTimeZone = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{db: value});
	});
var $author$project$Env$withLoginPath = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{dc: value});
	});
var $author$project$Env$withLogoutPath = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{dd: value});
	});
var $author$project$Env$withNewApiUrl = F2(
	function (value, _v0) {
		var environment = _v0;
		return _Utils_update(
			environment,
			{df: value});
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1380,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1380,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1959,
		1981,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1994,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1988,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1994,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2010,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 3, 1),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2018,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 3, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 1, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-45,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 2, 8, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 0, 1, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 9, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 10, 10, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2017,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2017,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2017,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2011,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2014,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2019,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1969,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1993,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 18, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 8, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 11, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2001,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2004,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2003,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2009,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2024,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2024,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 9, 15, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2022,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2022,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 3, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
};
var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
};
var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
};
var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 1, 3, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 10, 5, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 0, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 9, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 7, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 1, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 11, 9, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-270,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 1, 150, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__ciudad_juarez = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1972,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1996,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1997,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2010,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2021,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__coyhaique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2025, 2, 20, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 7, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 3, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
};
var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1951,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1960,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2010,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-225,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 7, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 60, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2003,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2010,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
};
var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 3, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 9, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
};
var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 9, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 23),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 1, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
};
var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 3, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 10, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 10, 4, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 20, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		90),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1991,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2014,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 2, 10, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 11, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
};
var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 10, 7, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 9, 26, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 2, 26, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 9, 29, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
};
var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 3, 60, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 2, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 3, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
};
var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 5, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1020, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 7, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 2, 17, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 9, 4, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 2, 8, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 9, 4, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 2, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 9, 3, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 2, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 2, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 2, 9, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 10, 1200, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1200, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 11, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 1, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 1, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 10, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2023, 11, 18, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 2, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1998,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2002,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2021,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2022,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 28, 0, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		240,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		300,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 4, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 7),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 7, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 7, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 4, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						390,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 26, 30, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 15, 30, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1996,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(0),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2022,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2022, 9, 28, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 4, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 8, 17, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 9, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 8, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 9, 29, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2003,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2021,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2035,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2054,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 5, 30),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 4, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 23),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 7, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 27, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 7, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				270,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 2, 26, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				345,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1973,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
};
var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 3, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
};
var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 6, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 7, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 4, 4, 1410, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 5, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2024, 2, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 11, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1991,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
};
var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 31, 960, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2022,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 20, 1440, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 10, 10, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
};
var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 4, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 29, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1986,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 2, 28, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 11, 27, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 5, 17, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 10, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 6, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2000,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 8, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 8, 5, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				525,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
};
var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						630,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				630,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
};
var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 2, 31, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		540,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 10, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
};
var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 5, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 28, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 25, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 8, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kyiv = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 4, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 8, 26, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 9, 31, 120, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1969,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1972,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1979,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1979,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1980,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 2, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 1, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 2, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 180, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 2, 31, 1380, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 8, 26, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 2, 29, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 11, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
};
var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		180,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2021,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2020,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 29, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 11, 28, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				765,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 2, 14, 180, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		720,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		720,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2013,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2021,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 12),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		121,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 23, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kanton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-640,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				840,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 7, 20, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 1, 10, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 2, 2, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 4, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		11,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-630,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 10, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2002,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
};
var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
			_Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
			_Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
			_Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
			_Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
			_Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
			_Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
			_Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
			_Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
			_Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
			_Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
			_Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
			_Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
			_Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
			_Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
			_Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
			_Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
			_Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
			_Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
			_Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
			_Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
			_Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
			_Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
			_Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
			_Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
			_Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
			_Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
			_Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
			_Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
			_Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
			_Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
			_Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
			_Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
			_Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
			_Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
			_Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
			_Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
			_Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
			_Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
			_Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
			_Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
			_Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
			_Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
			_Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
			_Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
			_Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
			_Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
			_Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
			_Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
			_Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
			_Utils_Tuple2('America/Ciudad_Juarez', $justinmimbs$timezone_data$TimeZone$america__ciudad_juarez),
			_Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
			_Utils_Tuple2('America/Coyhaique', $justinmimbs$timezone_data$TimeZone$america__coyhaique),
			_Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
			_Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
			_Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
			_Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
			_Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
			_Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
			_Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
			_Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
			_Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
			_Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
			_Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
			_Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
			_Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
			_Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
			_Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
			_Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
			_Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
			_Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
			_Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
			_Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
			_Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
			_Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
			_Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
			_Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
			_Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
			_Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
			_Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
			_Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
			_Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
			_Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
			_Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
			_Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
			_Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
			_Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
			_Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
			_Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
			_Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
			_Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
			_Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
			_Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
			_Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
			_Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
			_Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
			_Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
			_Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
			_Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
			_Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
			_Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
			_Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
			_Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
			_Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
			_Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
			_Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
			_Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
			_Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
			_Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
			_Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
			_Utils_Tuple2('America/Nuuk', $justinmimbs$timezone_data$TimeZone$america__nuuk),
			_Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
			_Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
			_Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
			_Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
			_Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
			_Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
			_Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
			_Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
			_Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
			_Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
			_Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
			_Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
			_Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
			_Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
			_Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
			_Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
			_Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
			_Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
			_Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
			_Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
			_Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
			_Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
			_Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
			_Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
			_Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
			_Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
			_Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
			_Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
			_Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
			_Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
			_Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
			_Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
			_Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
			_Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
			_Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
			_Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
			_Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
			_Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
			_Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
			_Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
			_Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
			_Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
			_Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
			_Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
			_Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
			_Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
			_Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
			_Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
			_Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
			_Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
			_Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
			_Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
			_Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
			_Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
			_Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
			_Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
			_Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
			_Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
			_Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
			_Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
			_Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
			_Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
			_Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
			_Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
			_Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
			_Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
			_Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
			_Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
			_Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
			_Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
			_Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
			_Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
			_Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
			_Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
			_Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
			_Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
			_Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
			_Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
			_Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
			_Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
			_Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
			_Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
			_Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
			_Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
			_Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
			_Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
			_Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
			_Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
			_Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
			_Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
			_Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
			_Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
			_Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
			_Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
			_Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
			_Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
			_Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
			_Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
			_Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
			_Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
			_Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
			_Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
			_Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
			_Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
			_Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
			_Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
			_Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
			_Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
			_Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
			_Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
			_Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
			_Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
			_Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
			_Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
			_Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
			_Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
			_Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
			_Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
			_Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
			_Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
			_Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
			_Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
			_Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
			_Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
			_Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
			_Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
			_Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
			_Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
			_Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
			_Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
			_Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
			_Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
			_Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
			_Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
			_Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
			_Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
			_Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
			_Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
			_Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
			_Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
			_Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
			_Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
			_Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
			_Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
			_Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
			_Utils_Tuple2('Europe/Kyiv', $justinmimbs$timezone_data$TimeZone$europe__kyiv),
			_Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
			_Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
			_Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
			_Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
			_Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
			_Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
			_Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
			_Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
			_Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
			_Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
			_Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
			_Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
			_Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
			_Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
			_Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
			_Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
			_Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
			_Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
			_Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
			_Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
			_Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
			_Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
			_Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
			_Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
			_Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
			_Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
			_Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
			_Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
			_Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
			_Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
			_Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
			_Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
			_Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
			_Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
			_Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
			_Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
			_Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
			_Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
			_Utils_Tuple2('Pacific/Kanton', $justinmimbs$timezone_data$TimeZone$pacific__kanton),
			_Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
			_Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
			_Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
			_Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
			_Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
			_Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
			_Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
			_Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
			_Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
			_Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
			_Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
			_Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
			_Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
			_Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
			_Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
			_Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu)
		]));
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var route = $author$project$Route$fromUrl(url);
		var localTimeZone = A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$utc,
			A2(
				$elm$core$Maybe$map,
				function (f) {
					return f(0);
				},
				A2($elm$core$Dict$get, flags.db, $justinmimbs$timezone_data$TimeZone$zones)));
		var languageOverride = $author$project$Main$languageFromUrl(url);
		var language = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$or,
				languageOverride,
				$author$project$Main$extractPreferredLanguage(flags.hg)));
		var envName = $author$project$Env$envNameFromString(flags.m8);
		var env = A2(
			$author$project$Env$withEnvName,
			envName,
			A2(
				$author$project$Env$withLogoutPath,
				flags.dd,
				A2(
					$author$project$Env$withLoginPath,
					flags.dc,
					A2(
						$author$project$Env$withLanguageOverride,
						language,
						A2(
							$author$project$Env$withLocalTimeZone,
							localTimeZone,
							A2(
								$author$project$Env$withFunnelUrl,
								flags.cZ,
								A2(
									$author$project$Env$withExternalApiUrl,
									flags.cX,
									A2(
										$author$project$Env$withNewApiUrl,
										flags.df,
										A2($author$project$Env$withApiUrl, flags.cF + '/graphql', $author$project$Env$env)))))))));
		var _v0 = A3(
			$elm$core$Tuple$mapBoth,
			$author$project$Model$Login,
			$author$project$Effect$Login,
			A2(
				$author$project$Page$Login$init,
				$author$project$Env$newApiUrl(env),
				$elm$core$Maybe$Just(route)));
		var pageModel = _v0.a;
		var checkAuthEffect = _v0.b;
		var model = A4($author$project$Model$init, key, env, pageModel, language);
		return _Utils_Tuple2(
			model,
			A3($author$project$Effect$runEffect, env, model, checkAuthEffect));
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Page$Search$Msg$ToastMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pyxis$Components$Toasts$Tick = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {ly: processes, l5: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.ly;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.l5);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$isTimeBlocked = function (timedEl) {
	switch (timedEl.$) {
		case 2:
			return true;
		case 0:
			return false;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$haveAllStopped = function (listTimed) {
	if (!listTimed.b) {
		return true;
	} else {
		var nonEmptylist = listTimed;
		return A2($elm$core$List$all, $author$project$Pyxis$Components$Toasts$ToastsHelpers$isTimeBlocked, nonEmptylist);
	}
};
var $author$project$Pyxis$Components$Toasts$subscription = function (_v0) {
	var model = _v0;
	var listOfTimedToast = A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		$elm$core$Dict$toList(model.t));
	var deltaTickAsFloat = $author$project$Pyxis$Components$Toasts$ToastsHelpers$deltaIntervalInMilliseconds;
	return $author$project$Pyxis$Components$Toasts$ToastsHelpers$haveAllStopped(listOfTimedToast) ? $elm$core$Platform$Sub$none : A2(
		$elm$time$Time$every,
		deltaTickAsFloat,
		$elm$core$Basics$always(
			$author$project$Pyxis$Components$Toasts$Tick(deltaTickAsFloat)));
};
var $author$project$Page$Search$subscription = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Page$Search$Msg$ToastMsg,
		$author$project$Pyxis$Components$Toasts$subscription(model.t));
};
var $author$project$Page$OfferDetails$Msg$ToastMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$OfferDetails$toastCounterSubscription = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Page$OfferDetails$Msg$ToastMsg,
		$author$project$Pyxis$Components$Toasts$subscription(model.t));
};
var $author$project$Page$PolicyDetails$Msg$ToastMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Page$PolicyDetails$toastCounterSubscription = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Page$PolicyDetails$Msg$ToastMsg,
		$author$project$Pyxis$Components$Toasts$subscription(model.t));
};
var $author$project$Main$subscribeToToastCounter = function (model) {
	var _v0 = model.o4;
	switch (_v0.$) {
		case 3:
			var searchModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$Search,
				$author$project$Page$Search$subscription(searchModel));
		case 6:
			var offerDetailModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$OfferDetails,
				$author$project$Page$OfferDetails$toastCounterSubscription(offerDetailModel));
		case 5:
			var policyDetailsModel = _v0.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$PolicyDetails,
				$author$project$Page$PolicyDetails$toastCounterSubscription(policyDetailsModel));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Page$Payment$Msg$CreditCardReady = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Payment$Msg$NonceReceive = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Payment$Msg$NotifyErrorEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Payment$Msg$PaymentEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Payment$Msg$ValidateCreditCardFields = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Payment$Ports$creditCardReady = _Platform_incomingPort('creditCardReady', $elm$json$Json$Decode$bool);
var $author$project$Page$Payment$Ports$nonceReceived = _Platform_incomingPort('nonceReceived', $elm$json$Json$Decode$string);
var $author$project$Page$Payment$Ports$notifyErrorEvent = _Platform_incomingPort(
	'notifyErrorEvent',
	A2(
		$elm$json$Json$Decode$andThen,
		function (error) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (context) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (code) {
							return $elm$json$Json$Decode$succeed(
								{jI: code, mR: context, ka: error});
						},
						A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'context', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)));
var $author$project$Page$Payment$Ports$validateCreditCardFields = _Platform_incomingPort(
	'validateCreditCardFields',
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$andThen,
			function (isValid) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (isPristine) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (isFocused) {
								return A2(
									$elm$json$Json$Decode$andThen,
									function (id) {
										return $elm$json$Json$Decode$succeed(
											{kv: id, eN: isFocused, eS: isPristine, bX: isValid});
									},
									A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
							},
							A2($elm$json$Json$Decode$field, 'isFocused', $elm$json$Json$Decode$bool));
					},
					A2($elm$json$Json$Decode$field, 'isPristine', $elm$json$Json$Decode$bool));
			},
			A2($elm$json$Json$Decode$field, 'isValid', $elm$json$Json$Decode$bool))));
var $author$project$Page$Payment$Subscriptions$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Page$Payment$Ports$creditCardReady(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$CreditCardReady, $author$project$Page$Payment$Msg$PaymentEvent)),
			$author$project$Page$Payment$Ports$notifyErrorEvent(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$NotifyErrorEvent, $author$project$Page$Payment$Msg$PaymentEvent)),
			$author$project$Page$Payment$Ports$validateCreditCardFields(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$ValidateCreditCardFields, $author$project$Page$Payment$Msg$PaymentEvent)),
			$author$project$Page$Payment$Ports$nonceReceived(
			A2($elm$core$Basics$composeR, $author$project$Page$Payment$Msg$NonceReceive, $author$project$Page$Payment$Msg$PaymentEvent))
		]));
var $author$project$Page$PolicyDetails$Msg$ReceivedIssueRefundReleaseDate = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$PolicyDetails$Ports$receiveManualRefundCutoff = _Platform_incomingPort('receiveManualRefundCutoff', $elm$json$Json$Decode$int);
var $author$project$Page$PolicyDetails$subscriptions = $author$project$Page$PolicyDetails$Ports$receiveManualRefundCutoff($author$project$Page$PolicyDetails$Msg$ReceivedIssueRefundReleaseDate);
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$Msg$PolicyDetails, $author$project$Page$PolicyDetails$subscriptions),
				A2($elm$core$Platform$Sub$map, $author$project$Msg$Payment, $author$project$Page$Payment$Subscriptions$subscriptions),
				$author$project$Main$subscribeToToastCounter(model)
			]));
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Msg$Logout = {$: 6};
var $author$project$Msg$NavigationSidebarMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pyxis$Components$NavigationSidebar$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$Content = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$content = {ga: _List_Nil, ep: _List_Nil, kv: $elm$core$Maybe$Nothing, hA: $elm$core$Maybe$Nothing, hB: 'Navigation', iM: $elm$core$Maybe$Nothing, iN: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$NavigationSidebar$Header = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$header = {ga: _List_Nil, ep: _List_Nil, kv: $elm$core$Maybe$Nothing, hk: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$NavigationSidebar$config = {f1: $elm$core$Maybe$Nothing, ga: _List_Nil, gg: $author$project$Pyxis$Components$NavigationSidebar$content, ep: _List_Nil, gI: $elm$core$Maybe$Nothing, gU: $author$project$Pyxis$Components$NavigationSidebar$header, kv: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$NavigationSidebar$Default = {$: 0};
var $author$project$Pyxis$Components$NavigationSidebar$Footer = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$NavigationSidebar$UserInfo = F2(
	function (email, name) {
		return {ew: email, kT: name};
	});
var $author$project$Pyxis$Components$NavigationSidebar$footer = F3(
	function (email, name, onLogout) {
		return {
			az: $elm$core$Maybe$Nothing,
			ga: _List_Nil,
			ep: _List_Nil,
			kv: $elm$core$Maybe$Nothing,
			k6: onLogout,
			fz: $elm$core$Maybe$Nothing,
			i9: $author$project$Pyxis$Components$NavigationSidebar$Default,
			md: A2($author$project$Pyxis$Components$NavigationSidebar$UserInfo, email, name)
		};
	});
var $author$project$Pyxis$Components$NavigationSidebar$Prima = {$: 0};
var $author$project$Pyxis$Components$NavigationSidebar$primaLogo = $author$project$Pyxis$Components$NavigationSidebar$Prima;
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Pyxis$Commons$Attributes$dataAttribute = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, 'data-' + key, value);
};
var $author$project$Pyxis$Commons$Attributes$appendDataAttrList = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$Pyxis$Commons$Attributes$dataAttribute),
	$elm$core$List$append);
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$header = _VirtualDom_node('header');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Pyxis$Components$NavigationSidebar$Expanded = 0;
var $author$project$Pyxis$Components$NavigationSidebar$isExpanded = function (_v0) {
	var expandState = _v0.cV;
	return !expandState;
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Pyxis$Commons$Attributes$none = A2($elm$html$Html$Attributes$property, 'none@pyxis-elm', $elm$json$Json$Encode$null);
var $author$project$Pyxis$Commons$Attributes$maybe = function (f) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(f),
		$elm$core$Maybe$withDefault($author$project$Pyxis$Commons$Attributes$none));
};
var $author$project$Pyxis$Components$NavigationSidebar$Collapse = {$: 2};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pyxis$Components$NavigationSidebar$overlay = function (tagger) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__overlay'),
				$elm$html$Html$Events$onClick(
				tagger($author$project$Pyxis$Components$NavigationSidebar$Collapse))
			]),
		_List_Nil);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Pyxis$Commons$Render$empty = $elm$html$Html$text('');
var $author$project$Pyxis$Commons$Render$renderMaybe = $elm$core$Maybe$withDefault($author$project$Pyxis$Commons$Render$empty);
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey = function (index) {
	return $TSFoster$elm_uuid$UUID$toString(
		A3(
			$primait$prima_elm_extra$PrimaFunction$flip,
			$TSFoster$elm_uuid$UUID$forName,
			$TSFoster$elm_uuid$UUID$urlNamespace,
			$elm$core$String$fromInt(index)));
};
var $author$project$Pyxis$Components$NavigationSidebar$ToggleGroupExpand = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$IconSet$svgChevronDown = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 17c-.26 0-.51-.1-.71-.29L5 10.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L12 14.59 17.59 9c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-6.29 6.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$chevronDown = {eY: 'chevron-down', a: $author$project$Pyxis$Components$IconSet$svgChevronDown};
var $author$project$Pyxis$Components$Icon$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Icon$Default = {$: 0};
var $author$project$Pyxis$Components$Icon$M = 1;
var $author$project$Pyxis$Components$Icon$config = function (icon) {
	return {fZ: $elm$core$Maybe$Nothing, f$: $elm$core$Maybe$Nothing, ga: _List_Nil, eg: $elm$core$Maybe$Nothing, ep: _List_Nil, ku: icon, aR: 1, dG: $author$project$Pyxis$Components$Icon$Default};
};
var $author$project$Pyxis$Components$NavigationSidebar$isGroupExpanded = F2(
	function (groupId, _v0) {
		var model = _v0;
		return A2($elm$core$Set$member, groupId, model.aJ);
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Pyxis$Commons$Render$maybeMapRender = function (renderFn) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(renderFn),
		$author$project$Pyxis$Commons$Render$renderMaybe);
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Pyxis$Commons$NonEmptyList$toList = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	return A2($elm$core$List$cons, head, tail);
};
var $author$project$Pyxis$Components$NavigationSidebar$pickNavItemGroupLinkHref = function (groupItemList_) {
	return A2(
		$elm$core$List$filterMap,
		function (navItemGroupLink) {
			if (!navItemGroupLink.$) {
				var c = navItemGroupLink.a;
				return $elm$core$Maybe$Just(c.c1);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$author$project$Pyxis$Commons$NonEmptyList$toList(groupItemList_));
};
var $author$project$Pyxis$Commons$String$fromBool = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Pyxis$Commons$Attributes$ariaHidden = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-hidden'));
var $author$project$Pyxis$Commons$Attributes$ariaLabel = $elm$html$Html$Attributes$attribute('aria-label');
var $author$project$Pyxis$Commons$Attributes$ariaLabelledBy = $elm$html$Html$Attributes$attribute('aria-labelledby');
var $author$project$Pyxis$Tokens$TypographyColor$toString = function (typographyColor) {
	switch (typographyColor) {
		case 0:
			return 'action';
		case 1:
			return 'alert';
		case 2:
			return 'brand';
		case 3:
			return 'content';
		case 4:
			return 'content-on-action';
		case 5:
			return 'content-on-action-surface';
		case 6:
			return 'content-on-alert';
		case 7:
			return 'content-on-alert-surface';
		case 8:
			return 'content-on-brand';
		case 9:
			return 'content-on-brand-surface';
		case 10:
			return 'content-on-error';
		case 11:
			return 'content-on-error-surface';
		case 12:
			return 'content-on-informative';
		case 13:
			return 'content-on-informative-surface';
		case 14:
			return 'content-on-inverse';
		case 15:
			return 'content-on-success';
		case 16:
			return 'content-on-success-surface';
		case 17:
			return 'content-weak';
		case 18:
			return 'error';
		case 19:
			return 'informative';
		default:
			return 'success';
	}
};
var $author$project$Pyxis$Components$Icon$getColorClass = function (maybeColor) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (color) {
				return 'c-' + $author$project$Pyxis$Tokens$TypographyColor$toString(color);
			},
			maybeColor));
};
var $author$project$Pyxis$Components$Icon$getEmphasisClass = function (style) {
	if (!style.$) {
		return '';
	} else {
		var emphasis = style.b;
		if (!emphasis) {
			return '';
		} else {
			return 'icon--strong';
		}
	}
};
var $author$project$Pyxis$Components$Icon$getSizeClass = function (size) {
	switch (size) {
		case 2:
			return 'icon--size-l';
		case 1:
			return 'icon--size-m';
		default:
			return 'icon--size-s';
	}
};
var $author$project$Pyxis$Components$Icon$getVariantClass = function (variant) {
	switch (variant) {
		case 0:
			return 'icon--boxed';
		case 1:
			return 'icon--boxed icon--brand';
		case 2:
			return 'icon--boxed icon--success';
		case 3:
			return 'icon--boxed icon--alert';
		case 4:
			return 'icon--boxed icon--error';
		default:
			return 'icon--boxed icon--informative';
	}
};
var $author$project$Pyxis$Components$Icon$getStyleClass = function (style) {
	if (!style.$) {
		return '';
	} else {
		var variant = style.a;
		return $author$project$Pyxis$Components$Icon$getVariantClass(variant);
	}
};
var $author$project$Pyxis$Components$Icon$getClassList = function (_v0) {
	var style = _v0.dG;
	var size = _v0.aR;
	var color = _v0.eg;
	var classList = _v0.ga;
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$first,
			A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('icon', true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getSizeClass(size),
					true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getStyleClass(style),
					true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getEmphasisClass(style),
					true),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Icon$getColorClass(color),
					true)
				]),
			classList));
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $Garados007$elm_svg_parser$SvgParser$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return (name === 'xlink:href') ? $elm$svg$Svg$Attributes$xlinkHref(value) : A2($elm$virtual_dom$VirtualDom$attribute, name, value);
};
var $Garados007$elm_svg_parser$SvgParser$elementToSvg = function (element) {
	return A3(
		$elm$svg$Svg$node,
		element.kT,
		A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$toAttribute, element.mC),
		A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, element.ah));
};
var $Garados007$elm_svg_parser$SvgParser$nodeToSvg = function (svgNode) {
	switch (svgNode.$) {
		case 0:
			var element = svgNode.a;
			return $Garados007$elm_svg_parser$SvgParser$elementToSvg(element);
		case 1:
			var content = svgNode.a;
			return $elm$svg$Svg$text(content);
		default:
			var content = svgNode.a;
			return $elm$svg$Svg$text('');
	}
};
var $andre_dietrich$parser_combinators$Combine$Parser = $elm$core$Basics$identity;
var $andre_dietrich$parser_combinators$Combine$app = function (_v0) {
	var inner = _v0;
	return inner;
};
var $andre_dietrich$parser_combinators$Combine$andThen = F2(
	function (f, p) {
		return F2(
			function (state, stream) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
				if (!_v0.c.$) {
					var rstate = _v0.a;
					var rstream = _v0.b;
					var res = _v0.c.a;
					return A3(
						$andre_dietrich$parser_combinators$Combine$app,
						f(res),
						rstate,
						rstream);
				} else {
					var estate = _v0.a;
					var estream = _v0.b;
					var ms = _v0.c.a;
					return _Utils_Tuple3(
						estate,
						estream,
						$elm$core$Result$Err(ms));
				}
			});
	});
var $pilatch$flip$Flip$flip = F3(
	function (_function, argB, argA) {
		return A2(_function, argA, argB);
	});
var $andre_dietrich$parser_combinators$Combine$bimap = F3(
	function (fok, ferr, p) {
		return F2(
			function (state, stream) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
				if (!_v0.c.$) {
					var rstate = _v0.a;
					var rstream = _v0.b;
					var res = _v0.c.a;
					return _Utils_Tuple3(
						rstate,
						rstream,
						$elm$core$Result$Ok(
							fok(res)));
				} else {
					var estate = _v0.a;
					var estream = _v0.b;
					var ms = _v0.c.a;
					return _Utils_Tuple3(
						estate,
						estream,
						$elm$core$Result$Err(
							ferr(ms)));
				}
			});
	});
var $andre_dietrich$parser_combinators$Combine$map = F2(
	function (f, p) {
		return A3($andre_dietrich$parser_combinators$Combine$bimap, f, $elm$core$Basics$identity, p);
	});
var $andre_dietrich$parser_combinators$Combine$andMap = F2(
	function (rp, lp) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andThen,
			A2($pilatch$flip$Flip$flip, $andre_dietrich$parser_combinators$Combine$map, rp),
			lp);
	});
var $Garados007$elm_svg_parser$SvgParser$flip = F3(
	function (func, b, a) {
		return A2(func, a, b);
	});
var $Garados007$elm_svg_parser$SvgParser$andMapRight = F2(
	function (lp, rp) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			rp,
			A2(
				$andre_dietrich$parser_combinators$Combine$map,
				$Garados007$elm_svg_parser$SvgParser$flip($elm$core$Basics$always),
				lp));
	});
var $andre_dietrich$parser_combinators$Combine$many = function (p) {
	var accumulate = F3(
		function (acc, state, stream) {
			accumulate:
			while (true) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
				if (!_v0.c.$) {
					var rstate = _v0.a;
					var rstream = _v0.b;
					var res = _v0.c.a;
					if (_Utils_eq(stream, rstream)) {
						return _Utils_Tuple3(
							rstate,
							rstream,
							$elm$core$List$reverse(acc));
					} else {
						var $temp$acc = A2($elm$core$List$cons, res, acc),
							$temp$state = rstate,
							$temp$stream = rstream;
						acc = $temp$acc;
						state = $temp$state;
						stream = $temp$stream;
						continue accumulate;
					}
				} else {
					return _Utils_Tuple3(
						state,
						stream,
						$elm$core$List$reverse(acc));
				}
			}
		});
	return F2(
		function (state, stream) {
			var _v1 = A3(accumulate, _List_Nil, state, stream);
			var rstate = _v1.a;
			var rstream = _v1.b;
			var res = _v1.c;
			return _Utils_Tuple3(
				rstate,
				rstream,
				$elm$core$Result$Ok(res));
		});
};
var $Garados007$elm_svg_parser$SvgParser$SvgElement = function (a) {
	return {$: 0, a: a};
};
var $Garados007$elm_svg_parser$SvgParser$andMapLeft = F2(
	function (lp, rp) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			rp,
			A2($andre_dietrich$parser_combinators$Combine$map, $elm$core$Basics$always, lp));
	});
var $andre_dietrich$parser_combinators$Combine$emptyErr = F2(
	function (state, stream) {
		return _Utils_Tuple3(
			state,
			stream,
			$elm$core$Result$Err(_List_Nil));
	});
var $andre_dietrich$parser_combinators$Combine$or = F2(
	function (lp, rp) {
		return F2(
			function (state, stream) {
				var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, lp, state, stream);
				if (!_v0.c.$) {
					var res = _v0;
					return res;
				} else {
					var lms = _v0.c.a;
					var _v1 = A3($andre_dietrich$parser_combinators$Combine$app, rp, state, stream);
					if (!_v1.c.$) {
						var res = _v1;
						return res;
					} else {
						var rms = _v1.c.a;
						return _Utils_Tuple3(
							state,
							stream,
							$elm$core$Result$Err(
								_Utils_ap(lms, rms)));
					}
				}
			});
	});
var $andre_dietrich$parser_combinators$Combine$choice = function (xs) {
	return A3($elm$core$List$foldr, $andre_dietrich$parser_combinators$Combine$or, $andre_dietrich$parser_combinators$Combine$emptyErr, xs);
};
var $Garados007$elm_svg_parser$SvgParser$SvgComment = function (a) {
	return {$: 2, a: a};
};
var $andre_dietrich$parser_combinators$Combine$mapError = $andre_dietrich$parser_combinators$Combine$bimap($elm$core$Basics$identity);
var $andre_dietrich$parser_combinators$Combine$onerror = F2(
	function (m, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$mapError,
			$elm$core$Basics$always(
				_List_fromArray(
					[m])),
			p);
	});
var $andre_dietrich$parser_combinators$Combine$primitive = $elm$core$Basics$identity;
var $andre_dietrich$parser_combinators$Combine$Char$satisfy = function (pred) {
	return $andre_dietrich$parser_combinators$Combine$primitive(
		F2(
			function (state, stream) {
				var message = 'could not satisfy predicate';
				var _v0 = $elm$core$String$uncons(stream.nD);
				if (!_v0.$) {
					var _v1 = _v0.a;
					var h = _v1.a;
					var rest = _v1.b;
					return pred(h) ? _Utils_Tuple3(
						state,
						_Utils_update(
							stream,
							{nD: rest, fc: stream.fc + 1}),
						$elm$core$Result$Ok(h)) : _Utils_Tuple3(
						state,
						stream,
						$elm$core$Result$Err(
							_List_fromArray(
								[message])));
				} else {
					return _Utils_Tuple3(
						state,
						stream,
						$elm$core$Result$Err(
							_List_fromArray(
								[message])));
				}
			}));
};
var $andre_dietrich$parser_combinators$Combine$Char$anyChar = A2(
	$andre_dietrich$parser_combinators$Combine$onerror,
	'expected any character',
	$andre_dietrich$parser_combinators$Combine$Char$satisfy(
		$elm$core$Basics$always(true)));
var $andre_dietrich$parser_combinators$Combine$succeed = function (res) {
	return F2(
		function (state, stream) {
			return _Utils_Tuple3(
				state,
				stream,
				$elm$core$Result$Ok(res));
		});
};
var $andre_dietrich$parser_combinators$Combine$lazy = function (t) {
	return A2(
		$andre_dietrich$parser_combinators$Combine$andThen,
		t,
		$andre_dietrich$parser_combinators$Combine$succeed(0));
};
var $andre_dietrich$parser_combinators$Combine$manyTill = F2(
	function (p, end_) {
		var accumulate = F3(
			function (acc, state, stream) {
				accumulate:
				while (true) {
					var _v0 = A3($andre_dietrich$parser_combinators$Combine$app, end_, state, stream);
					if (!_v0.c.$) {
						var rstate = _v0.a;
						var rstream = _v0.b;
						return _Utils_Tuple3(
							rstate,
							rstream,
							$elm$core$Result$Ok(
								$elm$core$List$reverse(acc)));
					} else {
						var estate = _v0.a;
						var estream = _v0.b;
						var ms = _v0.c.a;
						var _v1 = A3($andre_dietrich$parser_combinators$Combine$app, p, state, stream);
						if (!_v1.c.$) {
							var rstate = _v1.a;
							var rstream = _v1.b;
							var res = _v1.c.a;
							var $temp$acc = A2($elm$core$List$cons, res, acc),
								$temp$state = rstate,
								$temp$stream = rstream;
							acc = $temp$acc;
							state = $temp$state;
							stream = $temp$stream;
							continue accumulate;
						} else {
							return _Utils_Tuple3(
								estate,
								estream,
								$elm$core$Result$Err(ms));
						}
					}
				}
			});
		return accumulate(_List_Nil);
	});
var $andre_dietrich$parser_combinators$Combine$string = function (s) {
	return F2(
		function (state, stream) {
			if (A2($elm$core$String$startsWith, s, stream.nD)) {
				var len = $elm$core$String$length(s);
				var pos = stream.fc + len;
				var rem = A2($elm$core$String$dropLeft, len, stream.nD);
				return _Utils_Tuple3(
					state,
					_Utils_update(
						stream,
						{nD: rem, fc: pos}),
					$elm$core$Result$Ok(s));
			} else {
				return _Utils_Tuple3(
					state,
					stream,
					$elm$core$Result$Err(
						_List_fromArray(
							['expected \"' + (s + '\"')])));
			}
		});
};
var $andre_dietrich$parser_combinators$Combine$regexer = F5(
	function (input, output, pat, state, stream) {
		var pattern = A2($elm$core$String$startsWith, '^', pat) ? pat : ('^' + pat);
		var _v0 = A3(
			$elm$regex$Regex$findAtMost,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				input(pattern)),
			stream.nD);
		if (_v0.b && (!_v0.b.b)) {
			var match = _v0.a;
			var len = $elm$core$String$length(match.de);
			var pos = stream.fc + len;
			var rem = A2($elm$core$String$dropLeft, len, stream.nD);
			return _Utils_Tuple3(
				state,
				_Utils_update(
					stream,
					{nD: rem, fc: pos}),
				$elm$core$Result$Ok(
					output(match)));
		} else {
			return _Utils_Tuple3(
				state,
				stream,
				$elm$core$Result$Err(
					_List_fromArray(
						['expected input matching Regexp /' + (pattern + '/')])));
		}
	});
var $andre_dietrich$parser_combinators$Combine$regex = A2(
	$elm$core$Basics$composeR,
	A2(
		$andre_dietrich$parser_combinators$Combine$regexer,
		$elm$regex$Regex$fromString,
		function ($) {
			return $.de;
		}),
	$elm$core$Basics$identity);
var $andre_dietrich$parser_combinators$Combine$whitespace = A2(
	$andre_dietrich$parser_combinators$Combine$onerror,
	'optional whitespace',
	$andre_dietrich$parser_combinators$Combine$regex('\\s*'));
var $Garados007$elm_svg_parser$SvgParser$commentParser = $andre_dietrich$parser_combinators$Combine$lazy(
	function (_v0) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$map,
			A2($elm$core$Basics$composeL, $Garados007$elm_svg_parser$SvgParser$SvgComment, $elm$core$String$fromList),
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapRight,
				A2(
					$Garados007$elm_svg_parser$SvgParser$andMapRight,
					$andre_dietrich$parser_combinators$Combine$whitespace,
					$andre_dietrich$parser_combinators$Combine$string('<!--')),
				A2(
					$andre_dietrich$parser_combinators$Combine$manyTill,
					$andre_dietrich$parser_combinators$Combine$Char$anyChar,
					$andre_dietrich$parser_combinators$Combine$string('-->'))));
	});
var $Garados007$elm_svg_parser$SvgParser$Element = F3(
	function (name, attributes, children) {
		return {mC: attributes, ah: children, kT: name};
	});
var $andre_dietrich$parser_combinators$Combine$optional = F2(
	function (res, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$or,
			p,
			$andre_dietrich$parser_combinators$Combine$succeed(res));
	});
var $Garados007$elm_svg_parser$SvgParser$attributeParser = A2(
	$andre_dietrich$parser_combinators$Combine$andMap,
	A2(
		$andre_dietrich$parser_combinators$Combine$optional,
		'',
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapLeft,
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapRight,
				$andre_dietrich$parser_combinators$Combine$string('=\"'),
				$andre_dietrich$parser_combinators$Combine$regex('[^\"]*')),
			$andre_dietrich$parser_combinators$Combine$string('\"'))),
	A2(
		$andre_dietrich$parser_combinators$Combine$map,
		$elm$core$Tuple$pair,
		$andre_dietrich$parser_combinators$Combine$regex('[^=>/]+')));
var $andre_dietrich$parser_combinators$Combine$keep = F2(
	function (p1, p2) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			p1,
			A2(
				$andre_dietrich$parser_combinators$Combine$map,
				$pilatch$flip$Flip$flip($elm$core$Basics$always),
				p2));
	});
var $andre_dietrich$parser_combinators$Combine$sepBy1 = F2(
	function (sep, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$andMap,
			$andre_dietrich$parser_combinators$Combine$many(
				A2($andre_dietrich$parser_combinators$Combine$keep, p, sep)),
			A2($andre_dietrich$parser_combinators$Combine$map, $elm$core$List$cons, p));
	});
var $andre_dietrich$parser_combinators$Combine$sepBy = F2(
	function (sep, p) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$or,
			A2($andre_dietrich$parser_combinators$Combine$sepBy1, sep, p),
			$andre_dietrich$parser_combinators$Combine$succeed(_List_Nil));
	});
var $Garados007$elm_svg_parser$SvgParser$openingParser = A3(
	$Garados007$elm_svg_parser$SvgParser$flip,
	$andre_dietrich$parser_combinators$Combine$andMap,
	A2(
		$andre_dietrich$parser_combinators$Combine$andMap,
		$andre_dietrich$parser_combinators$Combine$regex('[^/>\\s]+'),
		A2(
			$andre_dietrich$parser_combinators$Combine$map,
			F3(
				function (_v0, tagName, attributes) {
					return A3($Garados007$elm_svg_parser$SvgParser$Element, tagName, attributes, _List_Nil);
				}),
			$andre_dietrich$parser_combinators$Combine$string('<'))),
	A2(
		$Garados007$elm_svg_parser$SvgParser$andMapLeft,
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapRight,
			$andre_dietrich$parser_combinators$Combine$whitespace,
			A2($andre_dietrich$parser_combinators$Combine$sepBy, $andre_dietrich$parser_combinators$Combine$whitespace, $Garados007$elm_svg_parser$SvgParser$attributeParser)),
		$andre_dietrich$parser_combinators$Combine$whitespace));
var $Garados007$elm_svg_parser$SvgParser$SvgText = function (a) {
	return {$: 1, a: a};
};
var $Garados007$elm_svg_parser$SvgParser$textParser = $andre_dietrich$parser_combinators$Combine$lazy(
	function (_v0) {
		return A2(
			$andre_dietrich$parser_combinators$Combine$map,
			$Garados007$elm_svg_parser$SvgParser$SvgText,
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapRight,
				$andre_dietrich$parser_combinators$Combine$whitespace,
				$andre_dietrich$parser_combinators$Combine$regex('[^<]+')));
	});
var $Garados007$elm_svg_parser$SvgParser$closingOrChildrenParser = function (element) {
	var childrenParser = A2(
		$andre_dietrich$parser_combinators$Combine$map,
		function (children) {
			return _Utils_update(
				element,
				{ah: children});
		},
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapLeft,
			A2(
				$Garados007$elm_svg_parser$SvgParser$andMapLeft,
				A2(
					$Garados007$elm_svg_parser$SvgParser$andMapRight,
					A2(
						$Garados007$elm_svg_parser$SvgParser$andMapRight,
						$andre_dietrich$parser_combinators$Combine$whitespace,
						$andre_dietrich$parser_combinators$Combine$string('>')),
					$andre_dietrich$parser_combinators$Combine$many(
						$Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser())),
				$andre_dietrich$parser_combinators$Combine$whitespace),
			$andre_dietrich$parser_combinators$Combine$string('</' + (element.kT + '>'))));
	return $andre_dietrich$parser_combinators$Combine$lazy(
		function (_v2) {
			return $andre_dietrich$parser_combinators$Combine$choice(
				_List_fromArray(
					[
						A2(
						$Garados007$elm_svg_parser$SvgParser$andMapRight,
						A2(
							$Garados007$elm_svg_parser$SvgParser$andMapRight,
							$andre_dietrich$parser_combinators$Combine$whitespace,
							$andre_dietrich$parser_combinators$Combine$string('/>')),
						$andre_dietrich$parser_combinators$Combine$succeed(element)),
						childrenParser
					]));
		});
};
function $Garados007$elm_svg_parser$SvgParser$cyclic$elementParser() {
	return $andre_dietrich$parser_combinators$Combine$lazy(
		function (_v1) {
			return A2(
				$andre_dietrich$parser_combinators$Combine$map,
				$Garados007$elm_svg_parser$SvgParser$SvgElement,
				A2(
					$andre_dietrich$parser_combinators$Combine$andThen,
					$Garados007$elm_svg_parser$SvgParser$closingOrChildrenParser,
					A2(
						$andre_dietrich$parser_combinators$Combine$andMap,
						$Garados007$elm_svg_parser$SvgParser$openingParser,
						A2(
							$andre_dietrich$parser_combinators$Combine$map,
							$Garados007$elm_svg_parser$SvgParser$flip($elm$core$Basics$always),
							$andre_dietrich$parser_combinators$Combine$whitespace))));
		});
}
function $Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser() {
	return $andre_dietrich$parser_combinators$Combine$lazy(
		function (_v0) {
			return $andre_dietrich$parser_combinators$Combine$choice(
				_List_fromArray(
					[
						$Garados007$elm_svg_parser$SvgParser$textParser,
						$Garados007$elm_svg_parser$SvgParser$commentParser,
						$Garados007$elm_svg_parser$SvgParser$cyclic$elementParser()
					]));
		});
}
var $Garados007$elm_svg_parser$SvgParser$elementParser = $Garados007$elm_svg_parser$SvgParser$cyclic$elementParser();
$Garados007$elm_svg_parser$SvgParser$cyclic$elementParser = function () {
	return $Garados007$elm_svg_parser$SvgParser$elementParser;
};
var $Garados007$elm_svg_parser$SvgParser$nodeParser = $Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser();
$Garados007$elm_svg_parser$SvgParser$cyclic$nodeParser = function () {
	return $Garados007$elm_svg_parser$SvgParser$nodeParser;
};
var $andre_dietrich$parser_combinators$Combine$InputStream = F3(
	function (data, input, position) {
		return {j1: data, nD: input, fc: position};
	});
var $andre_dietrich$parser_combinators$Combine$initStream = function (s) {
	return A3($andre_dietrich$parser_combinators$Combine$InputStream, s, s, 0);
};
var $andre_dietrich$parser_combinators$Combine$runParser = F3(
	function (p, st, s) {
		var _v0 = A3(
			$andre_dietrich$parser_combinators$Combine$app,
			p,
			st,
			$andre_dietrich$parser_combinators$Combine$initStream(s));
		if (!_v0.c.$) {
			var state = _v0.a;
			var stream = _v0.b;
			var res = _v0.c.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple3(state, stream, res));
		} else {
			var state = _v0.a;
			var stream = _v0.b;
			var ms = _v0.c.a;
			return $elm$core$Result$Err(
				_Utils_Tuple3(state, stream, ms));
		}
	});
var $Garados007$elm_svg_parser$SvgParser$xmlDeclarationParser = A2(
	$andre_dietrich$parser_combinators$Combine$map,
	$elm$core$String$fromList,
	A2(
		$Garados007$elm_svg_parser$SvgParser$andMapRight,
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapRight,
			$andre_dietrich$parser_combinators$Combine$whitespace,
			$andre_dietrich$parser_combinators$Combine$string('<?xml')),
		A2(
			$andre_dietrich$parser_combinators$Combine$manyTill,
			$andre_dietrich$parser_combinators$Combine$Char$anyChar,
			$andre_dietrich$parser_combinators$Combine$string('?>'))));
var $Garados007$elm_svg_parser$SvgParser$parseToNodes = function (input) {
	var _v0 = A3(
		$andre_dietrich$parser_combinators$Combine$runParser,
		A2(
			$Garados007$elm_svg_parser$SvgParser$andMapRight,
			A2($andre_dietrich$parser_combinators$Combine$optional, '', $Garados007$elm_svg_parser$SvgParser$xmlDeclarationParser),
			$andre_dietrich$parser_combinators$Combine$many($Garados007$elm_svg_parser$SvgParser$nodeParser)),
		_List_Nil,
		input);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var svgNodes = _v1.c;
		return $elm$core$Result$Ok(svgNodes);
	} else {
		var _v2 = _v0.a;
		var errors = _v2.c;
		return $elm$core$Result$Err(
			A2($elm$core$String$join, ' or ', errors));
	}
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $Garados007$elm_svg_parser$SvgParser$parse = function (input) {
	var toHtml = function (svgNodes) {
		toHtml:
		while (true) {
			if (svgNodes.b) {
				if (!svgNodes.a.$) {
					var element = svgNodes.a.a;
					var tl = svgNodes.b;
					if (element.kT === 'svg') {
						return $elm$core$Result$Ok(
							A2(
								$elm$svg$Svg$svg,
								A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$toAttribute, element.mC),
								A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, element.ah)));
					} else {
						var $temp$svgNodes = tl;
						svgNodes = $temp$svgNodes;
						continue toHtml;
					}
				} else {
					var tl = svgNodes.b;
					var $temp$svgNodes = tl;
					svgNodes = $temp$svgNodes;
					continue toHtml;
				}
			} else {
				return $elm$core$Result$Err('No svg found');
			}
		}
	};
	return A2(
		$elm$core$Result$andThen,
		toHtml,
		$Garados007$elm_svg_parser$SvgParser$parseToNodes(input));
};
var $author$project$Pyxis$Commons$Attributes$renderIf = F2(
	function (bool, attr) {
		return bool ? attr : $author$project$Pyxis$Commons$Attributes$none;
	});
var $author$project$Pyxis$Commons$Attributes$role = $elm$html$Html$Attributes$attribute('role');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Pyxis$Components$IconSet$toLabel = function (_v0) {
	var data = _v0;
	return data.eY;
};
var $author$project$Pyxis$Components$IconSet$toString = function (_v0) {
	var data = _v0;
	return data.a;
};
var $author$project$Pyxis$Components$Icon$render = function (configuration) {
	var ariaLabel = configuration.fZ;
	var ariaLabelledby = configuration.f$;
	var icon = configuration.ku;
	var color = configuration.eg;
	var dataAttrList = configuration.ep;
	return A2(
		$elm$html$Html$span,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					$author$project$Pyxis$Components$Icon$getClassList(configuration)),
					$author$project$Pyxis$Commons$Attributes$ariaHidden(
					$elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabel) && $elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabelledby)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabel, ariaLabel),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, ariaLabelledby),
					A2(
					$author$project$Pyxis$Commons$Attributes$renderIf,
					$elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabel) || $elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabelledby),
					$author$project$Pyxis$Commons$Attributes$role('img')),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-name',
					$author$project$Pyxis$Components$IconSet$toLabel(icon))
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				$elm$core$Result$toMaybe(
					$Garados007$elm_svg_parser$SvgParser$parse(
						$author$project$Pyxis$Components$IconSet$toString(icon))))
			]));
};
var $author$project$Pyxis$Components$Badge$Brand = 1;
var $author$project$Pyxis$Components$Badge$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Badge$Default = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Badge$Weak = 0;
var $author$project$Pyxis$Components$Badge$config = function (variant) {
	return {
		d_: $elm$core$Maybe$Nothing,
		ga: _List_Nil,
		ep: _List_Nil,
		ex: 0,
		kv: $elm$core$Maybe$Nothing,
		fz: $elm$core$Maybe$Nothing,
		pK: '',
		bq: $author$project$Pyxis$Components$Badge$Default($elm$core$Maybe$Nothing),
		jd: variant
	};
};
var $author$project$Pyxis$Components$Badge$brand = $author$project$Pyxis$Components$Badge$config(1);
var $author$project$Pyxis$Components$NavigationSidebar$getBadgeAccessibilityLabel = F3(
	function (badgeAccessibilityLabel, badgeText, itemLabel) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_ap(badgeText, itemLabel),
			A2(
				$elm$core$Maybe$map,
				function (badgeFn) {
					return A2(badgeFn, badgeText, itemLabel);
				},
				badgeAccessibilityLabel));
	});
var $author$project$Pyxis$Components$Badge$Notification = {$: 2};
var $author$project$Pyxis$Components$Badge$notification = $author$project$Pyxis$Components$Badge$Notification;
var $author$project$Pyxis$Components$Badge$Strong = 1;
var $author$project$Pyxis$Components$Badge$getBadgeTypeClass = F2(
	function (type_, emphasis) {
		switch (type_.$) {
			case 0:
				var icon = type_.a;
				return A3(
					$author$project$Pyxis$Commons$Basics$ternaryOperator,
					$elm_community$maybe_extra$Maybe$Extra$isJust(icon),
					'badge--with-icon',
					'');
			case 1:
				var icon = type_.a;
				return A3(
					$author$project$Pyxis$Commons$Basics$ternaryOperator,
					$elm_community$maybe_extra$Maybe$Extra$isJust(icon),
					'badge--ribbon badge--with-icon',
					'badge--ribbon');
			default:
				return A3($author$project$Pyxis$Commons$Basics$ternaryOperator, emphasis === 1, 'badge--notification', '');
		}
	});
var $author$project$Pyxis$Components$Badge$getBadgeVariantClass = function (variant) {
	switch (variant) {
		case 2:
			return 'badge--action';
		case 5:
			return 'badge--alert';
		case 1:
			return 'badge--brand';
		case 3:
			return 'badge--error';
		case 0:
			return '';
		case 4:
			return 'badge--success';
		default:
			return 'badge--informative';
	}
};
var $author$project$Pyxis$Commons$Attributes$ariaLivePolite = A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite');
var $author$project$Pyxis$Components$Badge$renderAccessibilityLabel = function (accessibilityLabel) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sr-only'),
				$author$project$Pyxis$Commons$Attributes$ariaLivePolite,
				$author$project$Pyxis$Commons$Attributes$role('status')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(accessibilityLabel)
			]));
};
var $author$project$Pyxis$Components$Badge$renderIcon = function (type_) {
	var maybeIcon = function () {
		switch (type_.$) {
			case 0:
				var icon = type_.a;
				return icon;
			case 1:
				var icon = type_.a;
				return icon;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Pyxis$Components$Icon$config, $author$project$Pyxis$Components$Icon$render),
			maybeIcon));
};
var $author$project$Pyxis$Commons$Attributes$testId = $elm$html$Html$Attributes$attribute('data-test-id');
var $author$project$Pyxis$Components$Badge$render = function (_v0) {
	var accessibilityLabel = _v0.d_;
	var classList = _v0.ga;
	var dataAttrList = _v0.ep;
	var id = _v0.kv;
	var emphasis = _v0.ex;
	var testId = _v0.fz;
	var text = _v0.pK;
	var type_ = _v0.bq;
	var variant = _v0.jd;
	return A2(
		$elm$html$Html$span,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('badge', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Badge$getBadgeVariantClass(variant),
							true),
							_Utils_Tuple2('badge--strong', emphasis === 1),
							_Utils_Tuple2(
							A2($author$project$Pyxis$Components$Badge$getBadgeTypeClass, type_, emphasis),
							true)
						])),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Badge$renderAccessibilityLabel, accessibilityLabel)),
				$author$project$Pyxis$Components$Badge$renderIcon(type_),
				$elm$html$Html$text(text)
			]));
};
var $author$project$Pyxis$Components$Badge$strong = 1;
var $author$project$Pyxis$Components$Badge$withAccessibilityLabel = F2(
	function (accessibilityLabel, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				d_: $elm$core$Maybe$Just(accessibilityLabel)
			});
	});
var $author$project$Pyxis$Components$Badge$withEmphasis = F2(
	function (emphasis, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ex: emphasis});
	});
var $author$project$Pyxis$Components$Badge$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{pK: text});
	});
var $author$project$Pyxis$Components$Badge$withType = F2(
	function (type_, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{bq: type_});
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderBadge = F3(
	function (accessibilityLabelFn, itemLabel, badge) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withType,
				$author$project$Pyxis$Components$Badge$notification,
				A2(
					$author$project$Pyxis$Components$Badge$withEmphasis,
					$author$project$Pyxis$Components$Badge$strong,
					A2(
						$author$project$Pyxis$Components$Badge$withAccessibilityLabel,
						A3($author$project$Pyxis$Components$NavigationSidebar$getBadgeAccessibilityLabel, accessibilityLabelFn, badge, itemLabel),
						A2($author$project$Pyxis$Components$Badge$withText, badge, $author$project$Pyxis$Components$Badge$brand)))));
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Pyxis$Components$IconSet$svgExternalLink = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17 22H7c-2.76 0-5-2.24-5-5V7c0-2.76 2.24-5 5-5h3c.55 0 1 .45 1 1h0c0 .55-.45 1-1 1H7C5.34 4 4 5.34 4 7v10c0 1.66 1.34 3 3 3h10c1.66 0 3-1.34 3-3v-3c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v3c0 2.76-2.24 5-5 5zm5-21h-7c-.55 0-1 .45-1 1h0c0 .55.45 1 1 1h4.59L12 10.59c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L21 4.41V9c0 .55.45 1 1 1h0c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$externalLink = {eY: 'external-link', a: $author$project$Pyxis$Components$IconSet$svgExternalLink};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Pyxis$Commons$Attributes$LinkTarget$toString = function (linkTarget) {
	switch (linkTarget) {
		case 0:
			return '_blank';
		case 1:
			return '_self';
		case 2:
			return '_parent';
		case 3:
			return '_top';
		default:
			return 'framename';
	}
};
var $author$project$Pyxis$Commons$Attributes$target = A2($elm$core$Basics$composeR, $author$project$Pyxis$Commons$Attributes$LinkTarget$toString, $elm$html$Html$Attributes$target);
var $author$project$Pyxis$Components$Icon$withClassList = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: a});
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupExternalLinkItem = F4(
	function (tabIndexValue, badgeAccessibilityLabel, _v0, target) {
		var href = _v0.c1;
		var label = _v0.eY;
		var danger = _v0.a1;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		var badge = _v0.bA;
		return A2(
			$elm$html$Html$a,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item side-nav-item--with-icon'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('side-nav-item--danger', danger)
							])),
						$elm$html$Html$Attributes$href(href),
						$elm$html$Html$Attributes$tabindex(tabIndexValue),
						$author$project$Pyxis$Commons$Attributes$target(target),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(label),
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('side-nav-item__external-link-icon', true)
							]),
						$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$externalLink))),
					A2(
					$author$project$Pyxis$Commons$Render$maybeMapRender,
					A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
					badge)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$isActiveRoute = F2(
	function (href, activeRoute) {
		return _Utils_eq(href, activeRoute);
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupInternalLinkItem = F4(
	function (activeRoute, badgeAccessibilityLabel, tabIndexValue, _v0) {
		var href = _v0.c1;
		var label = _v0.eY;
		var danger = _v0.a1;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		var badge = _v0.bA;
		return A2(
			$elm$html$Html$a,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('side-nav-item--danger', danger),
								_Utils_Tuple2(
								'side-nav-item--selected',
								A2($author$project$Pyxis$Components$NavigationSidebar$isActiveRoute, href, activeRoute))
							])),
						$elm$html$Html$Attributes$href(href),
						$elm$html$Html$Attributes$tabindex(tabIndexValue),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(label),
					A2(
					$author$project$Pyxis$Commons$Render$maybeMapRender,
					A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
					badge)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupItemLink = F4(
	function (activeRoute, badgeAccessibilityLabel, tabIndexValue, groupLink) {
		if (!groupLink.$) {
			var configuration = groupLink.a;
			return A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupInternalLinkItem, activeRoute, badgeAccessibilityLabel, tabIndexValue, configuration);
		} else {
			var configuration = groupLink.a;
			var target = groupLink.b;
			return A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupExternalLinkItem, tabIndexValue, badgeAccessibilityLabel, configuration, target);
		}
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsDropdown = F3(
	function (activeRoute, badgeAccessibilityLabel, groupLink) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__dropdown__list__item')
				]),
			_List_fromArray(
				[
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemLink, activeRoute, badgeAccessibilityLabel, 0, groupLink)
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupAsDropdown = F4(
	function (activeRoute, badgeAccessibilityLabel, label, groupItemList) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__dropdown-wrapper'),
					A2($elm$html$Html$Attributes$attribute, 'data-style', 'default')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__dropdown__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__dropdown__list')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsDropdown, activeRoute, badgeAccessibilityLabel),
						$author$project$Pyxis$Commons$NonEmptyList$toList(groupItemList)))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsList = F4(
	function (activeRoute, badgeAccessibilityLabel, groupExpanded, groupLink) {
		var tabIndexValue = groupExpanded ? 0 : (-1);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__group__list__item')
				]),
			_List_fromArray(
				[
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemLink, activeRoute, badgeAccessibilityLabel, tabIndexValue, groupLink)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroupAsList = F4(
	function (activeRoute, badgeAccessibilityLabel, groupItemList, groupExpanded) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__group-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__group__list')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$Pyxis$Components$NavigationSidebar$renderGroupItemAsList, activeRoute, badgeAccessibilityLabel, groupExpanded),
						$author$project$Pyxis$Commons$NonEmptyList$toList(groupItemList)))
				]));
	});
var $author$project$Pyxis$Commons$Render$renderIfElse = F3(
	function (condition, falseHtml, trueHtml) {
		return condition ? trueHtml : falseHtml;
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderGroup = F6(
	function (key, badgeAccessibilityLabel, _v0, groupItemList, tagger, model) {
		var label = _v0.eY;
		var icon = _v0.ku;
		var badge = _v0.bA;
		var activeRoute = model.cz;
		var groupIsSelected = A2(
			$elm$core$List$member,
			activeRoute,
			$author$project$Pyxis$Components$NavigationSidebar$pickNavItemGroupLinkHref(groupItemList));
		var groupExpanded = A2($author$project$Pyxis$Components$NavigationSidebar$isGroupExpanded, key, model);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-nav__list__item side-nav__list__item--with-sub-item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-nav__list__item--expanded', groupExpanded)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-nav-item side-nav-item--button side-nav-item--with-icon'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('side-nav-item--selected', groupIsSelected && (!groupExpanded))
								])),
							A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'group-item'),
							A2($elm$html$Html$Attributes$attribute, 'data-group-key', key),
							$elm$html$Html$Events$onClick(
							tagger(
								$author$project$Pyxis$Components$NavigationSidebar$ToggleGroupExpand(key)))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							$author$project$Pyxis$Components$Icon$config(icon)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-nav-item__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-nav-item__right-section')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pyxis$Commons$Render$maybeMapRender,
									A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
									badge),
									$author$project$Pyxis$Components$Icon$render(
									A2(
										$author$project$Pyxis$Components$Icon$withClassList,
										_List_fromArray(
											[
												_Utils_Tuple2('side-nav-item__toggle-icon', true)
											]),
										$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$chevronDown)))
								]))
						])),
					A3(
					$author$project$Pyxis$Commons$Render$renderIfElse,
					$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model),
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupAsDropdown, activeRoute, badgeAccessibilityLabel, label, groupItemList),
					A4($author$project$Pyxis$Components$NavigationSidebar$renderGroupAsList, activeRoute, badgeAccessibilityLabel, groupItemList, groupExpanded))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderKeyedGroup = F6(
	function (badgeAccessibilityLabel, key, groupConfig, groupItemList, tagger, model) {
		return _Utils_Tuple2(
			key,
			A6($author$project$Pyxis$Components$NavigationSidebar$renderGroup, key, badgeAccessibilityLabel, groupConfig, groupItemList, tagger, model));
	});
var $author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pyxis$Components$NavigationSidebar$itemLinkId = F2(
	function (elementIndex, label) {
		return 'nav-item-' + (label + $elm$core$String$fromInt(elementIndex));
	});
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemText = function (label) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-nav-item__text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$isItemLinkHovered = $elm$core$Basics$eq;
var $author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemToolTip = F3(
	function (itemId, hoveredLink, label) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-nav-item__tooltip', true),
							_Utils_Tuple2(
							'side-nav-item__tooltip--show',
							A2($author$project$Pyxis$Components$NavigationSidebar$isItemLinkHovered, itemId, hoveredLink))
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-style', 'default')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderExternalLink = F6(
	function (tagger, badgeAccessibilityLabel, model, _v0, target, elementIndex) {
		var hoveredLink = model.c0;
		var href = _v0.c1;
		var divider = _v0.gv;
		var label = _v0.eY;
		var icon = _v0.ku;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		var badge = _v0.bA;
		var itemId = $elm$core$Maybe$Just(
			A2($author$project$Pyxis$Components$NavigationSidebar$itemLinkId, elementIndex, label));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-nav__list__item', true),
							_Utils_Tuple2('side-nav__list__item--with-divider', divider)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						dataAttrList,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('side-nav-item side-nav-item--with-icon'),
								$elm$html$Html$Attributes$href(href),
								$elm$html$Html$Events$onMouseEnter(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink(itemId))),
								$elm$html$Html$Events$onMouseLeave(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink($elm$core$Maybe$Nothing))),
								$elm$html$Html$Events$onFocus(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink(itemId))),
								$elm$html$Html$Events$onBlur(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink($elm$core$Maybe$Nothing))),
								$author$project$Pyxis$Commons$Attributes$target(target),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
							])),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							$author$project$Pyxis$Components$Icon$config(icon)),
							A3(
							$author$project$Pyxis$Commons$Render$renderIfElse,
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model),
							A3($author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemToolTip, itemId, hoveredLink, label),
							$author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemText(label)),
							$author$project$Pyxis$Components$Icon$render(
							A2(
								$author$project$Pyxis$Components$Icon$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('side-nav-item__external-link-icon', true)
									]),
								$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$externalLink))),
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
							badge)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderInternalLink = F5(
	function (tagger, badgeAccessibilityLabel, model, _v0, elementIndex) {
		var activeRoute = model.cz;
		var hoveredLink = model.c0;
		var href = _v0.c1;
		var divider = _v0.gv;
		var label = _v0.eY;
		var icon = _v0.ku;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		var badge = _v0.bA;
		var itemId = $elm$core$Maybe$Just(
			A2($author$project$Pyxis$Components$NavigationSidebar$itemLinkId, elementIndex, label));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-nav__list__item', true),
							_Utils_Tuple2('side-nav__list__item--with-divider', divider)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						dataAttrList,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('side-nav-item'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('side-nav-item', true),
										_Utils_Tuple2(
										'side-nav-item--selected',
										A2($author$project$Pyxis$Components$NavigationSidebar$isActiveRoute, href, activeRoute))
									])),
								$elm$html$Html$Attributes$href(href),
								$elm$html$Html$Events$onMouseEnter(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink(itemId))),
								$elm$html$Html$Events$onMouseLeave(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink($elm$core$Maybe$Nothing))),
								$elm$html$Html$Events$onFocus(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink(itemId))),
								$elm$html$Html$Events$onBlur(
								tagger(
									$author$project$Pyxis$Components$NavigationSidebar$SetHoveredLink($elm$core$Maybe$Nothing))),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
							])),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							$author$project$Pyxis$Components$Icon$config(icon)),
							A3(
							$author$project$Pyxis$Commons$Render$renderIfElse,
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model),
							A3($author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemToolTip, itemId, hoveredLink, label),
							$author$project$Pyxis$Components$NavigationSidebar$renderNavigationItemText(label)),
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							A2($author$project$Pyxis$Components$NavigationSidebar$renderBadge, badgeAccessibilityLabel, label),
							badge)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderLink = F5(
	function (tagger, badgeAccessibilityLabel, model, navItemLink, elementIndex) {
		if (!navItemLink.$) {
			var navigationItemLinkConfig = navItemLink.a;
			return A5($author$project$Pyxis$Components$NavigationSidebar$renderInternalLink, tagger, badgeAccessibilityLabel, model, navigationItemLinkConfig, elementIndex);
		} else {
			var navigationItemLinkConfig = navItemLink.a;
			var target = navItemLink.b;
			return A6($author$project$Pyxis$Components$NavigationSidebar$renderExternalLink, tagger, badgeAccessibilityLabel, model, navigationItemLinkConfig, target, elementIndex);
		}
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Pyxis$Components$NavigationSidebar$renderSectionTitle = function (title) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-nav__list__item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav__list__item__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]))
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderNavItem = F5(
	function (tagger, badgeAccessibilityLabel, model, elementIndex, navItem) {
		switch (navItem.$) {
			case 0:
				var navItemLink = navItem.a;
				return _Utils_Tuple2(
					$author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
					A5($author$project$Pyxis$Components$NavigationSidebar$renderLink, tagger, badgeAccessibilityLabel, model, navItemLink, elementIndex));
			case 1:
				var title = navItem.a;
				return _Utils_Tuple2(
					$author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
					$author$project$Pyxis$Components$NavigationSidebar$renderSectionTitle(title));
			default:
				if (navItem.a.b.$ === 1) {
					var _v1 = navItem.a;
					var _v2 = _v1.b;
					return _Utils_Tuple2(
						$author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
						$author$project$Pyxis$Commons$Render$empty);
				} else {
					var _v3 = navItem.a;
					var groupConfiguration = _v3.a;
					var items = _v3.b.a;
					return $author$project$Pyxis$Components$NavigationSidebar$isExpanded(model) ? A6(
						$author$project$Pyxis$Components$NavigationSidebar$renderKeyedGroup,
						badgeAccessibilityLabel,
						'with-list-' + $author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
						groupConfiguration,
						items,
						tagger,
						model) : A6(
						$author$project$Pyxis$Components$NavigationSidebar$renderKeyedGroup,
						badgeAccessibilityLabel,
						'with-dropdown-' + $author$project$Pyxis$Components$NavigationSidebar$elementIndexToKey(elementIndex),
						groupConfiguration,
						items,
						tagger,
						model);
				}
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $author$project$Pyxis$Components$NavigationSidebar$renderNavigationList = F5(
	function (tagger, badgeAccessibilityLabel, model, ariaLabel, navigation) {
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-nav'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', ariaLabel)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Keyed$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-nav__list')
						]),
					A2(
						$elm$core$List$indexedMap,
						A3($author$project$Pyxis$Components$NavigationSidebar$renderNavItem, tagger, badgeAccessibilityLabel, model),
						$author$project$Pyxis$Commons$NonEmptyList$toList(navigation)))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderSlotBottom = F2(
	function (model, customContent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-panel__slot-bottom', true),
							_Utils_Tuple2(
							'side-panel__slot-bottom--opened',
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
							_Utils_Tuple2(
							'side-panel__slot-bottom--collapsed',
							!$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
						]))
				]),
			_List_fromArray(
				[customContent]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderSlotTop = F2(
	function (model, customContent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('side-panel__slot-top', true),
							_Utils_Tuple2(
							'side-panel__slot-top--opened',
							$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
							_Utils_Tuple2(
							'side-panel__slot-top--collapsed',
							!$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
						]))
				]),
			_List_fromArray(
				[customContent]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderContent = F4(
	function (tagger, badgeAccessibilityLabel, model, _v0) {
		var slotBottom = _v0.iM;
		var slotTop = _v0.iN;
		var navigation = _v0.hA;
		var id = _v0.kv;
		var classList = _v0.ga;
		var testId = _v0.fz;
		var navigationAriaLabel = _v0.hB;
		var dataAttrList = _v0.ep;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__content-wrapper'),
						$elm$html$Html$Attributes$classList(classList),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$NavigationSidebar$renderSlotTop(model),
						slotTop)),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						A4($author$project$Pyxis$Components$NavigationSidebar$renderNavigationList, tagger, badgeAccessibilityLabel, model, navigationAriaLabel),
						navigation)),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$NavigationSidebar$renderSlotBottom(model),
						slotBottom))
				]));
	});
var $author$project$Pyxis$Components$Button$Ghost = 5;
var $author$project$Pyxis$Components$Button$Button = {$: 0};
var $author$project$Pyxis$Components$Button$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Button$Inherit = 2;
var $author$project$Pyxis$Components$Button$M = 2;
var $author$project$Pyxis$Components$Button$None = {$: 3};
var $author$project$Pyxis$Components$Button$config = function (variant) {
	return {fT: $elm$core$Maybe$Nothing, fU: $elm$core$Maybe$Nothing, fV: $elm$core$Maybe$Nothing, fW: $elm$core$Maybe$Nothing, fX: $elm$core$Maybe$Nothing, fY: $elm$core$Maybe$Nothing, fZ: $elm$core$Maybe$Nothing, f_: $elm$core$Maybe$Nothing, ga: _List_Nil, ep: _List_Nil, gt: false, gJ: $elm$core$Maybe$Nothing, ku: $author$project$Pyxis$Components$Button$None, kv: $elm$core$Maybe$Nothing, bY: false, hj: 'Loading...', hR: $elm$core$Maybe$Nothing, hT: $elm$core$Maybe$Nothing, h_: $elm$core$Maybe$Nothing, h5: $elm$core$Maybe$Nothing, h6: $elm$core$Maybe$Nothing, h7: $elm$core$Maybe$Nothing, aR: 2, iU: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, pK: '', bq: $author$project$Pyxis$Components$Button$Button, jd: variant, dX: 2};
};
var $author$project$Pyxis$Components$Button$ghost = $author$project$Pyxis$Components$Button$config(5);
var $author$project$Pyxis$Components$IconSet$svgMoreVertical = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><circle cx=\"12\" cy=\"12\" r=\"2\"/><circle cx=\"12\" cy=\"5\" r=\"2\"/><circle cx=\"12\" cy=\"19\" r=\"2\"/></svg>';
var $author$project$Pyxis$Components$IconSet$moreVertical = {eY: 'more-vertical', a: $author$project$Pyxis$Components$IconSet$svgMoreVertical};
var $author$project$Pyxis$Commons$Attributes$ariaControls = $elm$html$Html$Attributes$attribute('aria-controls');
var $author$project$Pyxis$Commons$Attributes$ariaCurrent = $elm$html$Html$Attributes$attribute('aria-current');
var $author$project$Pyxis$Commons$Attributes$ariaDescribedBy = $elm$html$Html$Attributes$attribute('aria-describedby');
var $author$project$Pyxis$Commons$Attributes$ariaDisabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-disabled'));
var $primait$prima_elm_extra$PrimaFunction$ifThenElse = F3(
	function (condition, a, b) {
		return condition ? a : b;
	});
var $author$project$Pyxis$Commons$Attributes$ariaExpanded = function (isExpanded) {
	return A2(
		$elm$html$Html$Attributes$attribute,
		'aria-expanded',
		A3($primait$prima_elm_extra$PrimaFunction$ifThenElse, isExpanded, 'true', 'false'));
};
var $author$project$Pyxis$Commons$Attributes$ariaHasPopup = $elm$html$Html$Attributes$attribute('aria-haspopup');
var $author$project$Pyxis$Components$AriaLive$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$AriaLive$config = function (text) {
	return text;
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Attributes$form = _VirtualDom_attribute('form');
var $author$project$Pyxis$Commons$Attributes$getAriaDisabledState = F2(
	function (maybeDisabled, loading) {
		var _v0 = _Utils_Tuple2(maybeDisabled, loading);
		if (!_v0.b) {
			if (!_v0.a.$) {
				var disabled = _v0.a.a;
				return $elm$core$Maybe$Just(disabled);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Just(true);
		}
	});
var $author$project$Pyxis$Components$Button$getButtonIconClass = function (icon) {
	switch (icon.$) {
		case 0:
			return 'button--append-icon';
		case 1:
			return 'button--prepend-icon';
		case 2:
			return 'button--icon-only';
		default:
			return '';
	}
};
var $author$project$Pyxis$Components$Button$getButtonSizeClass = function (size) {
	switch (size) {
		case 0:
			return 'button--xl';
		case 1:
			return 'button--l';
		case 2:
			return 'button--m';
		default:
			return 'button--s';
	}
};
var $author$project$Pyxis$Components$Button$getButtonVariantClass = function (variant) {
	switch (variant) {
		case 0:
			return 'button--primary';
		case 1:
			return 'button--secondary';
		case 2:
			return 'button--tertiary';
		case 3:
			return 'button--brand';
		case 5:
			return 'button--ghost';
		default:
			return 'button--danger';
	}
};
var $author$project$Pyxis$Components$Button$getButtonWidthClass = function (width) {
	switch (width) {
		case 2:
			return '';
		case 0:
			return 'button--min-width';
		default:
			return 'button--full-width';
	}
};
var $author$project$Pyxis$Components$Button$isAppend = function (buttonIcon) {
	if (!buttonIcon.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Button$isGhost = function (buttonVariant) {
	if (buttonVariant === 5) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Button$isPrepend = function (buttonIcon) {
	if (buttonIcon.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Button$isStandalone = function (buttonIcon) {
	if (buttonIcon.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Commons$Attributes$TabIndex$Negative = 0;
var $author$project$Pyxis$Commons$Attributes$TabIndex$negative = 0;
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pyxis$Components$AriaLive$render = function (_v0) {
	var text = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sr-only'),
				$author$project$Pyxis$Commons$Attributes$role('status'),
				$author$project$Pyxis$Commons$Attributes$ariaLivePolite
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$Pyxis$Components$Icon$L = 2;
var $author$project$Pyxis$Components$Icon$sizeL = 2;
var $author$project$Pyxis$Components$Icon$sizeM = 1;
var $author$project$Pyxis$Components$Icon$S = 0;
var $author$project$Pyxis$Components$Icon$sizeS = 0;
var $author$project$Pyxis$Components$Icon$withSize = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: a});
	});
var $author$project$Pyxis$Components$Button$applyIconSize = F3(
	function (size, ghostButton, iconOnlyButton) {
		var _v0 = _Utils_Tuple3(size, ghostButton, iconOnlyButton);
		_v0$8:
		while (true) {
			_v0$9:
			while (true) {
				_v0$10:
				while (true) {
					_v0$11:
					while (true) {
						switch (_v0.a) {
							case 0:
								if (!_v0.b) {
									if (_v0.c) {
										var _v1 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$8;
									}
								} else {
									if (_v0.c) {
										var _v5 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$8;
									}
								}
							case 1:
								if (!_v0.b) {
									if (_v0.c) {
										var _v2 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$9;
									}
								} else {
									if (_v0.c) {
										var _v6 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$9;
									}
								}
							case 2:
								if (!_v0.b) {
									if (_v0.c) {
										var _v3 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
									} else {
										break _v0$10;
									}
								} else {
									if (_v0.c) {
										var _v7 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeL);
									} else {
										break _v0$10;
									}
								}
							default:
								if (!_v0.b) {
									if (_v0.c) {
										var _v4 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
									} else {
										break _v0$11;
									}
								} else {
									if (_v0.c) {
										var _v8 = _v0.a;
										return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM);
									} else {
										break _v0$11;
									}
								}
						}
					}
					var _v12 = _v0.a;
					return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
				}
				var _v11 = _v0.a;
				return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS);
			}
			var _v10 = _v0.a;
			return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM);
		}
		var _v9 = _v0.a;
		return $author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM);
	});
var $author$project$Pyxis$Components$Button$pickIcon = function (buttonIcon) {
	switch (buttonIcon.$) {
		case 0:
			var icon = buttonIcon.a;
			return $elm$core$Maybe$Just(icon);
		case 1:
			var icon = buttonIcon.a;
			return $elm$core$Maybe$Just(icon);
		case 2:
			var icon = buttonIcon.a;
			return $elm$core$Maybe$Just(icon);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pyxis$Components$Button$renderIcon = F4(
	function (size, ghostButton, iconOnlyButton, icon) {
		return $author$project$Pyxis$Commons$Render$renderMaybe(
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Icon$config,
					A2(
						$elm$core$Basics$composeR,
						A3($author$project$Pyxis$Components$Button$applyIconSize, size, ghostButton, iconOnlyButton),
						$author$project$Pyxis$Components$Icon$render)),
				$author$project$Pyxis$Components$Button$pickIcon(icon)));
	});
var $author$project$Pyxis$Commons$Render$renderIf = function (condition) {
	return A2($author$project$Pyxis$Commons$Render$renderIfElse, condition, $author$project$Pyxis$Commons$Render$empty);
};
var $author$project$Pyxis$Components$Button$renderTag = function (_v0) {
	var configData = _v0;
	var _v1 = configData.bq;
	if (_v1.$ === 3) {
		return $elm$html$Html$a;
	} else {
		return $elm$html$Html$button;
	}
};
var $author$project$Pyxis$Commons$Render$renderUnless = function (condition) {
	return $author$project$Pyxis$Commons$Render$renderIf(!condition);
};
var $author$project$Pyxis$Commons$Attributes$TabIndex$toInt = function (index) {
	if (!index) {
		return -1;
	} else {
		return 0;
	}
};
var $author$project$Pyxis$Commons$Attributes$TabIndex$tabIndex = A2($elm$core$Basics$composeR, $author$project$Pyxis$Commons$Attributes$TabIndex$toInt, $elm$html$Html$Attributes$tabindex);
var $elm$html$Html$Attributes$download = function (fileName) {
	return A2($elm$html$Html$Attributes$stringProperty, 'download', fileName);
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Pyxis$Components$Button$typeToAttribute = function (type_) {
	switch (type_.$) {
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('submit')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('reset')
				]);
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button')
				]);
		default:
			if (type_.c === 1) {
				var href = type_.a;
				var _v1 = type_.c;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$href(href),
						$elm$html$Html$Attributes$download('')
					]);
			} else {
				var href = type_.a;
				var target = type_.b;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$href(href),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$target, target)
					]);
			}
	}
};
var $author$project$Pyxis$Components$Button$render = function (configuration) {
	var configData = configuration;
	return A3(
		$author$project$Pyxis$Components$Button$renderTag,
		configuration,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			configData.ep,
			A2(
				$elm$core$List$append,
				$author$project$Pyxis$Components$Button$typeToAttribute(configData.bq),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2('button', true),
									_Utils_Tuple2('button--loading', configData.bY),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonIconClass(configData.ku),
									true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonVariantClass(configData.jd),
									true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonWidthClass(configData.dX),
									true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Button$getButtonSizeClass(configData.aR),
									true)
								]),
							configData.ga)),
						$elm$html$Html$Attributes$disabled(configData.gt),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onClick, configData.hT),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onMouseOver, configData.h7),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onMouseOut, configData.h6),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onFocus, configData.h_),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onBlur, configData.hR),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						A2(
							$elm$core$Basics$composeR,
							$elm$json$Json$Decode$succeed,
							$elm$html$Html$Events$on('mousedown')),
						configData.h5),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, configData.kv),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fz),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, configData.f_),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaDescribedBy, configData.fV),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabel, configData.fZ),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						$author$project$Pyxis$Commons$Attributes$ariaDisabled,
						A2($author$project$Pyxis$Commons$Attributes$getAriaDisabledState, configData.fW, configData.bY)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaControls, configData.fT),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaCurrent, configData.fU),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaExpanded, configData.fX),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaHasPopup, configData.fY),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						$author$project$Pyxis$Commons$Attributes$TabIndex$tabIndex,
						A3(
							$primait$prima_elm_extra$PrimaFunction$ifThenElse,
							configData.bY,
							$elm$core$Maybe$Just($author$project$Pyxis$Commons$Attributes$TabIndex$negative),
							configData.iU)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$form, configData.gJ)
					]))),
		_List_fromArray(
			[
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				configData.bY,
				$author$project$Pyxis$Components$AriaLive$render(
					$author$project$Pyxis$Components$AriaLive$config(configData.hj))),
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				$author$project$Pyxis$Components$Button$isPrepend(configData.ku) || $author$project$Pyxis$Components$Button$isStandalone(configData.ku),
				A4(
					$author$project$Pyxis$Components$Button$renderIcon,
					configData.aR,
					$author$project$Pyxis$Components$Button$isGhost(configData.jd),
					$author$project$Pyxis$Components$Button$isStandalone(configData.ku),
					configData.ku)),
				A2(
				$author$project$Pyxis$Commons$Render$renderUnless,
				$author$project$Pyxis$Components$Button$isStandalone(configData.ku),
				$elm$html$Html$text(configData.pK)),
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				$author$project$Pyxis$Components$Button$isAppend(configData.ku),
				A4(
					$author$project$Pyxis$Components$Button$renderIcon,
					configData.aR,
					$author$project$Pyxis$Components$Button$isGhost(configData.jd),
					$author$project$Pyxis$Components$Button$isStandalone(configData.ku),
					configData.ku))
			]));
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Pyxis$Components$IconSet$svgUser = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3a3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3 3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3m0-2C9.24 1 7 3.24 7 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5h0zm5 14c1.1 0 2 .9 2 2v4H5v-4c0-1.1.9-2 2-2h10m0-2H7a4 4 0 0 0-4 4v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4a4 4 0 0 0-4-4h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$user = {eY: 'user', a: $author$project$Pyxis$Components$IconSet$svgUser};
var $author$project$Pyxis$Components$NavigationSidebar$renderUserAvatar = function (userAvatar) {
	if (!userAvatar.$) {
		return $author$project$Pyxis$Components$Icon$render(
			$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$user));
	} else {
		var imageReference = userAvatar.a;
		return A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(imageReference)
				]),
			_List_Nil);
	}
};
var $author$project$Pyxis$Components$Button$sizeM = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aR: 2});
};
var $author$project$Pyxis$Components$Button$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Pyxis$Components$Button$Standalone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Button$withIconOnly = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ku: $author$project$Pyxis$Components$Button$Standalone(icon)
			});
	});
var $author$project$Pyxis$Components$Button$withSize = function (setSize) {
	return setSize;
};
var $author$project$Pyxis$Components$NavigationSidebar$renderDropdownTrigger = F2(
	function (isSidebarExpanded, userAvatar) {
		return isSidebarExpanded ? $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withSize,
				$author$project$Pyxis$Components$Button$sizeM,
				A2(
					$author$project$Pyxis$Components$Button$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('side-panel__footer__show-more-button', true)
						]),
					A2($author$project$Pyxis$Components$Button$withIconOnly, $author$project$Pyxis$Components$IconSet$moreVertical, $author$project$Pyxis$Components$Button$ghost)))) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__footer__show-more-button-collapsed'),
					A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'true')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$NavigationSidebar$renderUserAvatar(userAvatar)
				]));
	});
var $author$project$Pyxis$Commons$NonEmptyList$map = function (mapper) {
	return A2(
		$elm$core$Tuple$mapBoth,
		mapper,
		$elm$core$List$map(mapper));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderFooterAction = function (_v0) {
	var label = _v0.a;
	var theMsg = _v0.b;
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__footer-dropdown__list__item'),
				$elm$html$Html$Events$onClick(theMsg)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]));
};
var $author$project$Pyxis$Components$IconSet$svgLogout = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21.71 11.29L18.41 8c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L18.59 11H12c-.55 0-1 .45-1 1h0c0 .55.45 1 1 1h6.59L17 14.59c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l3.29-3.29a1 1 0 0 0 .01-1.42zM15 23H7a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4h8a4.02 4.02 0 0 1 3.8 2.74c.2.62-.29 1.26-.95 1.26h0c-.42 0-.82-.24-.95-.63C16.63 3.57 15.88 3 15 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c.88 0 1.63-.57 1.9-1.37.13-.39.54-.63.95-.63h0c.66 0 1.15.64.95 1.26A4.02 4.02 0 0 1 15 23z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$logout = {eY: 'logout', a: $author$project$Pyxis$Components$IconSet$svgLogout};
var $author$project$Pyxis$Components$NavigationSidebar$renderLogoutIcon = $author$project$Pyxis$Components$Icon$render(
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$logout));
var $author$project$Pyxis$Components$NavigationSidebar$renderLogoutAction = function (onLogoutAction) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__footer-dropdown__list__item side-panel__footer-dropdown__list__item--logout'),
				$elm$html$Html$Events$onClick(onLogoutAction)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-nav-item')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Logout'),
						$author$project$Pyxis$Components$NavigationSidebar$renderLogoutIcon
					]))
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderFooterDropdown = F3(
	function (userInfo, onLogoutAction, actions) {
		var actionList = A2(
			$elm$core$List$append,
			$author$project$Pyxis$Commons$NonEmptyList$toList(
				A2($author$project$Pyxis$Commons$NonEmptyList$map, $author$project$Pyxis$Components$NavigationSidebar$renderFooterAction, actions)),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$NavigationSidebar$renderLogoutAction(onLogoutAction)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel__footer-dropdown'),
					A2($elm$html$Html$Attributes$attribute, 'data-style', 'default')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__footer-dropdown__title')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__footer__user__name text-m-bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(userInfo.kT)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__footer__user__email text-s-book')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(userInfo.ew)
								]))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__footer-dropdown__list')
						]),
					actionList)
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderLogoutActionButton = function (onLogout) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__footer__logout-button'),
				$elm$html$Html$Events$onClick(onLogout)
			]),
		_List_fromArray(
			[$author$project$Pyxis$Components$NavigationSidebar$renderLogoutIcon]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderActionsOrLogout = F5(
	function (actions, userInfo, userAvatar, onLogout, isSidebarExpanded) {
		if (!actions.$) {
			var actions_ = actions.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__footer__actions-wrapper')
					]),
				_List_fromArray(
					[
						A2($author$project$Pyxis$Components$NavigationSidebar$renderDropdownTrigger, isSidebarExpanded, userAvatar),
						A3($author$project$Pyxis$Components$NavigationSidebar$renderFooterDropdown, userInfo, onLogout, actions_)
					]));
		} else {
			return $author$project$Pyxis$Components$NavigationSidebar$renderLogoutActionButton(onLogout);
		}
	});
var $author$project$Pyxis$Components$NavigationSidebar$renderFooter = F2(
	function (isSidebarExpanded, _v0) {
		var actions = _v0.az;
		var userAvatar = _v0.i9;
		var userInfo = _v0.md;
		var onLogout = _v0.k6;
		var id = _v0.kv;
		var classList = _v0.ga;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__footer-wrapper'),
						$elm$html$Html$Attributes$classList(classList),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-panel__footer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('avatar side-panel__footer__avatar')
								]),
							_List_fromArray(
								[
									$author$project$Pyxis$Components$NavigationSidebar$renderUserAvatar(userAvatar)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__footer__user')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('side-panel__footer__user__name text-m-bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(userInfo.kT)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('side-panel__footer__user__email text-s-book')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(userInfo.ew)
										]))
								])),
							A5($author$project$Pyxis$Components$NavigationSidebar$renderActionsOrLogout, actions, userInfo, userAvatar, onLogout, isSidebarExpanded)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$ToggleExpand = {$: 0};
var $author$project$Pyxis$Components$Logos$PrimaLogo$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Logos$PrimaLogo$Default = 0;
var $author$project$Pyxis$Components$Logos$PrimaLogo$Logotype = 0;
var $author$project$Pyxis$Components$Logos$PrimaLogo$config = {d_: $elm$core$Maybe$Nothing, ga: _List_Nil, eg: 0, ep: _List_Nil, kv: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, jd: 0, dX: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$Logos$PrimaLogo$Monogram = 1;
var $author$project$Pyxis$Components$Logos$PrimaLogo$monogramVariant = 1;
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Pyxis$Components$Logos$SvgBuilder$fromClassListToString = function (classList) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
					classList))));
};
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $author$project$Pyxis$Components$Logos$SvgBuilder$svgTitle = F2(
	function (accessibilityLabel, id) {
		return A2(
			$elm$svg$Svg$title,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(id)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(accessibilityLabel)
				]));
	});
var $author$project$Pyxis$Components$Logos$SvgBuilder$getSvgTitle = F2(
	function (accessibilityLabel, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pyxis$Commons$Render$empty,
			A3($elm$core$Maybe$map2, $author$project$Pyxis$Components$Logos$SvgBuilder$svgTitle, accessibilityLabel, id));
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Pyxis$Components$Logos$SvgBuilder$getViewBox = function (nodes) {
	if (nodes.b && (!nodes.a.$)) {
		var attributes = nodes.a.a.mC;
		return A2(
			$elm$core$List$filterMap,
			function (attr) {
				return (attr.a === 'viewBox') ? $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$viewBox(attr.b)) : $elm$core$Maybe$Nothing;
			},
			attributes);
	} else {
		return _List_Nil;
	}
};
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $author$project$Pyxis$Components$Logos$SvgBuilder$buildSvg = F3(
	function (_v0, svgAttr, nodes) {
		var dataAttrList = _v0.ep;
		var accessibilityLabel = _v0.d_;
		var id = _v0.kv;
		var testId = _v0.fz;
		var classList = _v0.ga;
		var titleId = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append('title-'),
			id);
		var titleElement = A2($author$project$Pyxis$Components$Logos$SvgBuilder$getSvgTitle, accessibilityLabel, titleId);
		if (nodes.b && (!nodes.a.$)) {
			var payload = nodes.a.a;
			return A2(
				$elm$svg$Svg$svg,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					dataAttrList,
					A2(
						$elm$core$List$append,
						$author$project$Pyxis$Components$Logos$SvgBuilder$getViewBox(nodes),
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class(
									$author$project$Pyxis$Components$Logos$SvgBuilder$fromClassListToString(classList)),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$svg$Svg$Attributes$id, id),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
									$author$project$Pyxis$Commons$Attributes$ariaHidden(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(accessibilityLabel)),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, titleId),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									$elm_community$maybe_extra$Maybe$Extra$isJust(accessibilityLabel) && $elm_community$maybe_extra$Maybe$Extra$isJust(id),
									$author$project$Pyxis$Commons$Attributes$role('img'))
								]),
							svgAttr))),
				A2(
					$elm$core$List$cons,
					titleElement,
					A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, payload.ah)));
		} else {
			return $author$project$Pyxis$Commons$Render$empty;
		}
	});
var $author$project$Pyxis$Components$Logos$PrimaLogo$Pride = 1;
var $author$project$Pyxis$Components$Logos$PrimaLogo$getClassList = function (_v0) {
	var classList = _v0.ga;
	var color = _v0.eg;
	var variant = _v0.jd;
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2('logo--pride', color === 1),
				_Utils_Tuple2('logo-prima--monogram', variant === 1),
				_Utils_Tuple2('logo-prima--logotype', !variant)
			]),
		classList);
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$getSizeAttributesSingleton = function (attribute) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(attribute),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault($author$project$Pyxis$Commons$Attributes$none),
			$elm$core$List$singleton));
};
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$Pyxis$Components$Logos$SvgBuilder$svgSizeFormatter = function (size) {
	return (!_Utils_eq(
		$elm$core$String$toFloat(size),
		$elm$core$Maybe$Nothing)) ? ('--logo-size: ' + (size + 'px')) : ('--logo-size: ' + size);
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$buildSvg = F2(
	function (configuration, nodes) {
		var width = configuration.dX;
		var id = configuration.kv;
		var dataAttrList = configuration.ep;
		var testId = configuration.fz;
		var accessibilityLabel = configuration.d_;
		var sizeAttributes = A2(
			$author$project$Pyxis$Components$Logos$PrimaLogo$getSizeAttributesSingleton,
			$elm$svg$Svg$Attributes$style,
			A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Logos$SvgBuilder$svgSizeFormatter, width));
		return A3(
			$author$project$Pyxis$Components$Logos$SvgBuilder$buildSvg,
			{
				d_: accessibilityLabel,
				ga: $author$project$Pyxis$Components$Logos$PrimaLogo$getClassList(configuration),
				ep: dataAttrList,
				kv: id,
				fz: testId
			},
			sizeAttributes,
			nodes);
	});
var $author$project$Pyxis$Components$Logos$LogoSet$Logo = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Logos$LogoSet$svgPrima = '<svg viewBox=\"0 0 120 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g class=\"logo__content\" clip-path=\"url(#clip0_1777_801)\">\n<path d=\"M65.9781 14.5636C65.061 14.8848 64.6853 15.4165 64.6964 16.4245C64.7627 21.5642 64.7295 26.7039 64.7295 31.8325C64.7295 32.2313 64.7406 32.619 64.7185 33.0178C64.6522 34.3581 63.9229 35.1778 62.8179 35.1888C61.6356 35.1999 60.7737 34.3359 60.7627 32.9845C60.7406 26.7925 60.7295 20.6005 60.7958 14.4085C60.8069 13.7993 61.2267 12.9685 61.735 12.6473C65.9892 9.92237 70.5748 9.32422 75.3814 11.1298C76.2875 11.4731 77.0389 12.2042 77.9781 12.8356C80.1881 11.0411 82.7295 10.1218 85.6798 10.1328C91.503 10.155 94.6964 12.8024 94.9505 18.363C95.1825 23.2701 95.0389 28.1993 95.0168 33.1174C95.0057 34.4134 94.1439 35.211 93.0057 35.1888C91.9671 35.1667 91.1052 34.3581 91.0831 33.1618C91.0278 29.5618 91.0499 25.9618 91.0389 22.3618C91.0389 21.3094 91.072 20.2571 91.0057 19.2048C90.7295 14.8184 87.8566 12.8356 83.3925 13.9876C82.5638 14.1981 81.7903 14.6411 81.0499 15.0731C80.1881 15.5827 79.8124 16.3138 79.8234 17.3771C79.8897 22.6054 79.8676 27.8227 79.8455 33.051C79.8455 34.3581 79.0389 35.1888 77.9339 35.1888C76.7847 35.1888 76.0002 34.3691 75.9339 33.1064C75.9118 32.7519 75.9229 32.4085 75.9229 32.0541C75.9229 28.0553 75.9229 24.0676 75.9229 20.0688C75.9229 19.5814 75.9339 19.1051 75.8897 18.6178C75.5582 15.3501 73.5803 13.6221 70.1218 13.7439C70.1328 13.7439 68.2875 13.755 65.9781 14.5636Z\"/>\n<path d=\"M34.2544 15.7599C34.5858 12.5254 36.8842 10.5205 40.2654 10.2214C42.1218 10.0552 44.0334 10.2657 45.8897 10.4983C47.3041 10.6756 47.9892 11.6171 47.7792 12.6362C47.5693 13.6552 46.5748 14.1869 45.1936 14.054C43.956 13.9432 42.7184 13.7439 41.4919 13.7992C39.3151 13.8989 38.1881 14.9623 38.1107 17.0337C38.0113 20.0577 38.0444 23.0817 38.0334 26.1168C38.0223 28.2657 38.0444 30.4922 38.0223 32.6411C38.0113 34.2694 37.3151 35.1666 36.0886 35.1999C34.7737 35.2442 33.9892 34.3137 33.9892 32.6633C33.9781 30.1156 33.9892 27.5014 33.9892 24.9537C34.0665 24.9537 33.945 18.7949 34.2544 15.7599Z\"/>\n<path d=\"M55.3925 22.7938C55.3925 26.1279 55.4035 29.4621 55.3925 32.7962C55.3814 34.3248 54.6743 35.1888 53.4809 35.1999C52.2102 35.211 51.4588 34.3027 51.4588 32.7408C51.4477 26.1611 51.4477 25.563 51.4588 18.9944C51.4588 17.3439 52.1218 16.491 53.3925 16.4799C54.7295 16.4578 55.3925 17.3107 55.4035 19.0498C55.3925 22.2842 55.3925 19.5482 55.3925 22.7938Z\"/>\n<path d=\"M53.3483 14.4085C52.2323 14.3975 51.2157 13.3895 51.2047 12.2928C51.1936 11.0744 52.1439 10.1439 53.3925 10.1439C54.6411 10.1439 55.6466 11.1187 55.6024 12.2707C55.5803 13.4448 54.5417 14.4196 53.3483 14.4085Z\"/>\n<path d=\"M29.0058 17.5655C28.3759 13.611 25.6135 11.1298 21.4035 10.3876C19.3483 10.0332 17.3704 10.0885 15.4588 10.4541C14.5969 10.5981 13.9781 11.2849 13.956 12.171C13.9339 13.1347 14.829 14.0209 15.8013 13.9987C15.945 13.9987 16.0776 13.9765 16.2102 13.9433C17.5251 13.6442 18.8732 13.5556 20.2875 13.8104C23.4477 14.3532 25.0389 16.0479 25.3704 19.7698C25.5803 22.1513 25.4809 24.5993 25.1936 26.9809C24.8511 29.9273 22.8732 31.5445 19.7682 31.8104C17.3814 32.0098 15.1052 31.5445 12.9284 30.603C12.2544 30.315 11.9781 29.9495 12.0002 29.2184C12.0555 27.0695 12.0223 24.9205 12.0223 22.7716C12.0223 21.0325 12.0002 19.2824 12.0334 17.5433V14.5082C12.0334 13.4781 11.1383 12.6141 10.0444 12.5919C9.71293 12.5809 9.40354 12.6473 9.1273 12.7581C6.85105 13.755 5.21569 14.6079 1.45879 16.5907C0.0444237 17.3661 -0.342317 18.4959 0.309617 19.5815C0.917352 20.6116 2.02232 20.7889 3.35934 20.0689C4.89525 19.2381 6.46431 18.4405 8.05547 17.6762C8.08862 25.8289 8.06652 36.219 8.07757 44.0947V44.1058C8.07757 44.1168 8.07757 44.1168 8.07757 44.1168C8.07757 44.139 8.07757 44.1501 8.07757 44.1722H8.08862C8.13282 45.1802 8.9947 45.9888 10.0555 45.9888C11.1162 45.9888 11.9892 45.1802 12.0223 44.1722H12.0334C12.0444 41.9015 12.0334 37.9581 12.0334 34.2584C14.2433 34.6682 16.2433 35.1999 18.2765 35.3772C23.9118 35.8645 28.398 32.8073 29.1715 27.5015C29.6356 24.2449 29.5251 20.8221 29.0058 17.5655Z\"/>\n<path d=\"M119.801 17.5877C119.691 14.0321 117.569 11.5287 114.111 10.6425C110.188 9.63451 106.343 10.1219 102.619 11.573C101.392 12.0493 100.939 13.0462 101.315 13.9988C101.669 14.8961 102.718 15.2284 104.033 14.8407C104.033 14.8407 107.492 13.6997 110.906 13.7219C113.812 13.7441 115.459 15.1508 115.857 17.7207C115.923 18.1748 115.934 18.6401 115.923 19.1274H115.934L115.967 24.1453V24.2007C115.967 24.2228 115.967 24.2561 115.967 24.2782V24.4001C115.967 26.2056 116.022 27.8561 115.923 29.4954C115.901 29.9496 115.514 30.6031 115.105 30.8025C112.232 32.2093 109.194 32.4308 106.133 31.4893C104.177 30.8801 103.227 29.4179 103.227 27.4573C103.227 25.6739 104.287 24.3004 106.243 23.6468C108.155 23.0154 110.022 23.0487 111.89 23.3367C111.978 23.3477 112.078 23.3588 112.177 23.3588C113.061 23.3588 113.768 22.6388 113.768 21.7637C113.768 20.9884 113.216 20.3459 112.475 20.2019C110.011 19.8364 107.547 19.7699 105.061 20.4677C101.392 21.4979 99.282 24.0345 99.2709 27.4351C99.2599 31.1459 101.293 33.9484 105.028 34.8677C109.834 36.0641 114.453 35.2887 118.729 32.9293C119.26 32.6413 119.79 31.8437 119.801 31.2788C119.89 26.7262 119.956 22.1514 119.801 17.5877Z\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_1777_801\">\n<rect width=\"120\" height=\"36\" fill=\"white\" transform=\"translate(0 10)\"/>\n <linearGradient\n          id=\"full-pride-gradient-default\"\n          x1=\"0.000488281\"\n          y1=\"20.3767\"\n          x2=\"120.676\"\n          y2=\"20.3767\"\n          gradientUnits=\"userSpaceOnUse\"\n        >\n          <stop stop-color=\"#DF1654\" />\n          <stop offset=\"0.033\" stop-color=\"#E43353\" />\n          <stop offset=\"0.098\" stop-color=\"#EE6552\" />\n          <stop offset=\"0.16\" stop-color=\"#F58E51\" />\n          <stop offset=\"0.216\" stop-color=\"#FBAA51\" />\n          <stop offset=\"0.264\" stop-color=\"#FEBC50\" />\n          <stop offset=\"0.3\" stop-color=\"#FFC250\" />\n          <stop offset=\"0.515\" stop-color=\"#A3CD50\" />\n          <stop offset=\"0.557\" stop-color=\"#9BC95A\" />\n          <stop offset=\"0.627\" stop-color=\"#84C073\" />\n          <stop offset=\"0.716\" stop-color=\"#5FB09D\" />\n          <stop offset=\"0.78\" stop-color=\"#41A3BF\" />\n          <stop offset=\"0.823\" stop-color=\"#4A93BF\" />\n          <stop offset=\"0.906\" stop-color=\"#636AC1\" />\n          <stop offset=\"1\" stop-color=\"#8334C2\" />\n        </linearGradient>\n\n        <linearGradient\n          id=\"full-pride-gradient-negative\"\n          x1=\"0\"\n          y1=\"20.3767\"\n          x2=\"120.675\"\n          y2=\"20.3767\"\n          gradientUnits=\"userSpaceOnUse\"\n        >\n          <stop stop-color=\"#DF1654\" />\n          <stop offset=\"0.257\" stop-color=\"#FF9110\" />\n          <stop offset=\"0.26\" stop-color=\"#FF9211\" />\n          <stop offset=\"0.325\" stop-color=\"#FFB22C\" />\n          <stop offset=\"0.389\" stop-color=\"#FFC940\" />\n          <stop offset=\"0.448\" stop-color=\"#FFD74C\" />\n          <stop offset=\"0.5\" stop-color=\"#FFDC50\" />\n          <stop offset=\"0.756\" stop-color=\"#A3CD50\" />\n          <stop offset=\"0.781\" stop-color=\"#9ACC58\" />\n          <stop offset=\"0.822\" stop-color=\"#83CB6E\" />\n          <stop offset=\"0.872\" stop-color=\"#5DC892\" />\n          <stop offset=\"0.93\" stop-color=\"#29C5C3\" />\n          <stop offset=\"0.971\" stop-color=\"#00C2E9\" />\n        </linearGradient>\n</clipPath>\n</defs>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$prima = {eY: 'prima', a: $author$project$Pyxis$Components$Logos$LogoSet$svgPrima};
var $author$project$Pyxis$Components$Logos$LogoSet$svgPrimaMonogram = '<svg fill=\"none\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_1638_800)\">\n<g>\n<path  class=\"logo__content\" d=\"M20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0ZM28.67 20.75C28.16 24.26 25.19 26.28 21.44 25.94C20.09 25.82 18.77 25.47 17.3 25.2V31.76C17.25 32.39 16.75 32.89 16.12 32.94C15.4 33.01 14.76 32.47 14.7 31.76V14.25C13.65 14.76 12.6 15.29 11.59 15.84C10.69 16.31 9.98 16.23 9.55 15.51C9.12 14.8 9.37 14.05 10.28 13.55C12.78 12.22 13.84 11.66 15.37 11C15.56 10.92 15.77 10.89 15.98 10.89C16.69 10.89 17.27 11.45 17.3 12.16V17.65C17.3 19.07 17.34 20.49 17.3 21.91C17.25 22.33 17.51 22.71 17.91 22.83C19.33 23.46 20.89 23.74 22.45 23.63C24.52 23.45 25.81 22.38 26.04 20.43C26.25 18.84 26.29 17.23 26.16 15.64C25.94 13.18 24.88 12.06 22.79 11.7C21.89 11.55 20.97 11.57 20.09 11.79C19.99 11.81 19.9 11.82 19.8 11.82C19.13 11.82 18.59 11.28 18.57 10.62C18.58 10.04 19.02 9.55 19.59 9.48C20.89 9.23 22.23 9.21 23.53 9.44C26.32 9.93 28.16 11.57 28.57 14.18C28.93 16.35 28.96 18.57 28.67 20.75Z\"/>\n</g>\n<path class=\"logo__text\"  d=\"M28.5705 14.1823C28.1639 11.5686 26.3179 9.92642 23.5313 9.43828C22.2261 9.21457 20.8909 9.22865 19.5905 9.47902C19.0161 9.55457 18.5839 10.039 18.5735 10.6179C18.5898 11.2846 19.1324 11.8179 19.7991 11.8231C19.8968 11.8235 19.9942 11.8116 20.0891 11.7875C20.9739 11.5749 21.8928 11.5457 22.7891 11.7012C24.8839 12.0572 25.9416 13.1809 26.1602 15.6368C26.2857 17.2349 26.2465 18.8416 26.0431 20.432C25.8142 22.3794 24.5176 23.4472 22.4479 23.6253C20.8935 23.7375 19.335 23.4631 17.9124 22.8272C17.5113 22.7131 17.2513 22.3261 17.2972 21.912C17.3379 20.4883 17.2972 19.0694 17.2972 17.6509C17.2972 16.4964 17.2972 15.3423 17.2972 14.1931V12.159C17.2698 11.4516 16.6883 10.8923 15.9802 10.8927C15.7713 10.8868 15.5631 10.9246 15.3698 11.0046C13.8442 11.6605 12.7765 12.2249 10.285 13.5472C9.37461 14.0505 9.12054 14.7979 9.55276 15.5149C9.98498 16.232 10.6868 16.3131 11.5868 15.8353C12.6039 15.2861 13.6461 14.7623 14.6987 14.2538C14.6987 19.6438 14.6987 26.5135 14.6987 31.7153V31.7561C14.7624 32.4749 15.3968 33.0061 16.1157 32.9427C16.7465 32.8868 17.2465 32.3868 17.3024 31.7561C17.3024 30.2305 17.3024 27.6475 17.3024 25.2016C18.7668 25.4712 20.0891 25.822 21.4365 25.939C25.1942 26.2798 28.1639 24.2561 28.6724 20.7472C28.9639 18.5661 28.9294 16.3535 28.5705 14.1823Z\"/>\n</g>\n\n<defs>\n<clipPath id=\"clip0_1638_800\">\n<rect width=\"40\" height=\"40\" fill=\"white\"/>\n</clipPath>\n\n  <linearGradient id=\"monogram-gradient-default\" x1=\"20\" y1=\"-0.365233\" x2=\"20\" y2=\"40.9458\" gradientUnits=\"userSpaceOnUse\">\n  <stop offset=\"0.00166442\" stop-color=\"var(--pyx-color-monogram-gradient-0)\"/>\n  <stop offset=\"1\" stop-color=\"var(--pyx-color-monogram-gradient-100)\"/>\n  </linearGradient>\n\n\n  <linearGradient id=\"monogram-gradient-negative\" x1=\"20\" y1=\"-0.365233\" x2=\"20\" y2=\"40.9458\" gradientUnits=\"userSpaceOnUse\">\n  <stop offset=\"0.00166442\" stop-color=\"var(--pyx-color-monogram-gradient-0-vibrant)\"/>\n  <stop offset=\"1\" stop-color=\"var(--pyx-color-monogram-gradient-100-vibrant)\"/>\n  </linearGradient>\n\n\n    <linearGradient id=\"monogram-pride-gradient-default\" x1=\"19.9996\" y1=\"6.33545\" x2=\"19.9996\" y2=\"33.6631\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#DF1654\"/>\n      <stop offset=\"0.033\" stop-color=\"#E43353\"/>\n      <stop offset=\"0.098\" stop-color=\"#EE6552\"/>\n      <stop offset=\"0.16\" stop-color=\"#F58E51\"/>\n      <stop offset=\"0.216\" stop-color=\"#FBAA51\"/>\n      <stop offset=\"0.264\" stop-color=\"#FEBC50\"/>\n      <stop offset=\"0.3\" stop-color=\"#FFC250\"/>\n      <stop offset=\"0.515\" stop-color=\"#A3CD50\"/>\n      <stop offset=\"0.557\" stop-color=\"#9BC95A\"/>\n      <stop offset=\"0.627\" stop-color=\"#84C073\"/>\n      <stop offset=\"0.716\" stop-color=\"#5FB09D\"/>\n      <stop offset=\"0.78\" stop-color=\"#41A3BF\"/>\n      <stop offset=\"0.823\" stop-color=\"#4A93BF\"/>\n      <stop offset=\"0.906\" stop-color=\"#636AC1\"/>\n      <stop offset=\"1\" stop-color=\"#8334C2\"/>\n    </linearGradient>\n\n    <linearGradient id=\"monogram-pride-gradient-negative\" x1=\"19.1001\" y1=\"7.15681\" x2=\"19.1001\" y2=\"34.9925\" gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#DF1654\"/>\n      <stop offset=\"0.257\" stop-color=\"#FF9110\"/>\n      <stop offset=\"0.26\" stop-color=\"#FF9211\"/>\n      <stop offset=\"0.325\" stop-color=\"#FFB22C\"/>\n      <stop offset=\"0.389\" stop-color=\"#FFC940\"/>\n      <stop offset=\"0.448\" stop-color=\"#FFD74C\"/>\n      <stop offset=\"0.5\" stop-color=\"#FFDC50\"/>\n      <stop offset=\"0.756\" stop-color=\"#A3CD50\"/>\n      <stop offset=\"0.781\" stop-color=\"#9ACC58\"/>\n      <stop offset=\"0.822\" stop-color=\"#83CB6E\"/>\n      <stop offset=\"0.872\" stop-color=\"#5DC892\"/>\n      <stop offset=\"0.93\" stop-color=\"#29C5C3\"/>\n      <stop offset=\"0.971\" stop-color=\"#00C2E9\"/>\n    </linearGradient>\n\n</defs>\n</svg>\n';
var $author$project$Pyxis$Components$Logos$LogoSet$primaMonogram = {eY: 'prima-monogram', a: $author$project$Pyxis$Components$Logos$LogoSet$svgPrimaMonogram};
var $author$project$Pyxis$Components$Logos$LogoSet$toString = function (_v0) {
	var data = _v0;
	return data.a;
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$getPrimaLogoSvg = function (variant) {
	if (!variant) {
		return $author$project$Pyxis$Components$Logos$LogoSet$toString($author$project$Pyxis$Components$Logos$LogoSet$prima);
	} else {
		return $author$project$Pyxis$Components$Logos$LogoSet$toString($author$project$Pyxis$Components$Logos$LogoSet$primaMonogram);
	}
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$render = function (configuration) {
	var variant = configuration.jd;
	return $author$project$Pyxis$Commons$Render$renderMaybe(
		A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Logos$PrimaLogo$buildSvg(configuration),
			$elm$core$Result$toMaybe(
				$Garados007$elm_svg_parser$SvgParser$parseToNodes(
					$author$project$Pyxis$Components$Logos$PrimaLogo$getPrimaLogoSvg(variant)))));
};
var $author$project$Pyxis$Components$Logos$PrimaLogo$withVariant = F2(
	function (variant, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{jd: variant});
	});
var $author$project$Pyxis$Components$NavigationSidebar$defaultCollapsedLogo = $author$project$Pyxis$Components$Logos$PrimaLogo$render(
	A2($author$project$Pyxis$Components$Logos$PrimaLogo$withVariant, $author$project$Pyxis$Components$Logos$PrimaLogo$monogramVariant, $author$project$Pyxis$Components$Logos$PrimaLogo$config));
var $author$project$Pyxis$Components$NavigationSidebar$defaultExpandedLogo = $author$project$Pyxis$Components$Logos$PrimaLogo$render($author$project$Pyxis$Components$Logos$PrimaLogo$config);
var $author$project$Pyxis$Components$NavigationSidebar$pickLogosFromConfig = function (logoConfig) {
	if (!logoConfig.$) {
		return _Utils_Tuple2($author$project$Pyxis$Components$NavigationSidebar$defaultCollapsedLogo, $author$project$Pyxis$Components$NavigationSidebar$defaultExpandedLogo);
	} else {
		var collapsedLogo = logoConfig.a;
		var expandedLogo = logoConfig.b;
		return _Utils_Tuple2(collapsedLogo, expandedLogo);
	}
};
var $author$project$Pyxis$Components$NavigationSidebar$renderLogos = function (logoConfig) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('side-panel__logo-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__logo side-panel__logo--collapsed')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$NavigationSidebar$pickLogosFromConfig(logoConfig).a
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__logo side-panel__logo--expanded')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$NavigationSidebar$pickLogosFromConfig(logoConfig).b
					]))
			]));
};
var $author$project$Pyxis$Components$NavigationSidebar$renderHeader = F3(
	function (tagger, model, _v0) {
		var logo = _v0.hk;
		var classList = _v0.ga;
		var id = _v0.kv;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('side-panel__header-wrapper'),
						$elm$html$Html$Attributes$classList(classList),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('side-panel__toggle', true),
									_Utils_Tuple2(
									'side-panel__toggle--opened',
									$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
								])),
							$elm$html$Html$Events$onClick(
							tagger($author$project$Pyxis$Components$NavigationSidebar$ToggleExpand))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__toggle__line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__toggle__line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-panel__toggle__line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close Sidebar')
								]))
						])),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$NavigationSidebar$renderLogos, logo))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$render = F3(
	function (tagger, model, _v0) {
		var headerConfig = _v0.gU;
		var contentConfig = _v0.gg;
		var footerConfig = _v0.gI;
		var badgeAccessibilityLabel = _v0.f1;
		var id = _v0.kv;
		var classList = _v0.ga;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-panel-scrollable-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						dataAttrList,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('side-panel', true),
										_Utils_Tuple2(
										'side-panel--opened',
										$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
										_Utils_Tuple2(
										'side-panel--collapsed',
										!$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model))
									])),
								$elm$html$Html$Attributes$classList(classList),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
							])),
					_List_fromArray(
						[
							A3($author$project$Pyxis$Components$NavigationSidebar$renderHeader, tagger, model, headerConfig),
							A4($author$project$Pyxis$Components$NavigationSidebar$renderContent, tagger, badgeAccessibilityLabel, model, contentConfig),
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								$author$project$Pyxis$Components$NavigationSidebar$renderFooter(
									$author$project$Pyxis$Components$NavigationSidebar$isExpanded(model)),
								footerConfig)),
							$author$project$Pyxis$Components$NavigationSidebar$overlay(tagger)
						]))
				]));
	});
var $author$project$Pyxis$Components$NavigationSidebar$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Pyxis$Components$NavigationSidebar$withFooter = F2(
	function (footerConfig, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gI: $elm$core$Maybe$Just(footerConfig)
			});
	});
var $author$project$Pyxis$Components$NavigationSidebar$withHeader = F2(
	function (headerConfig, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gU: headerConfig});
	});
var $author$project$Pyxis$Components$NavigationSidebar$withHeaderLogo = F2(
	function (logo, _v0) {
		var headerConfig = _v0;
		return _Utils_update(
			headerConfig,
			{
				hk: $elm$core$Maybe$Just(logo)
			});
	});
var $author$project$Main$navigationSidebar = function (model) {
	var headerConfiguration = A2($author$project$Pyxis$Components$NavigationSidebar$withHeaderLogo, $author$project$Pyxis$Components$NavigationSidebar$primaLogo, $author$project$Pyxis$Components$NavigationSidebar$header);
	var footerConfiguration = A3($author$project$Pyxis$Components$NavigationSidebar$footer, '', '', $author$project$Msg$Logout);
	return A3(
		$author$project$Pyxis$Components$NavigationSidebar$render,
		$author$project$Msg$NavigationSidebarMsg,
		model.n7,
		A2(
			$author$project$Pyxis$Components$NavigationSidebar$withFooter,
			footerConfiguration,
			A2(
				$author$project$Pyxis$Components$NavigationSidebar$withHeader,
				headerConfiguration,
				A2(
					$author$project$Pyxis$Components$NavigationSidebar$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('main-header-navigation', true)
						]),
					$author$project$Pyxis$Components$NavigationSidebar$config))));
};
var $author$project$Main$addHeaderToBody = F2(
	function (model, _v0) {
		var title = _v0.i4;
		var body = _v0.f3;
		var container = _List_fromArray(
			[
				A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container--with-sidebar')
					]),
				body)
			]);
		return {
			f3: A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$author$project$Main$navigationSidebar(model)
					]),
				container),
			i4: title
		};
	});
var $elm$browser$Browser$Document = F2(
	function (title, body) {
		return {f3: body, i4: title};
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Main$mapDocument = F2(
	function (msgMapper, _v0) {
		var title = _v0.i4;
		var body = _v0.f3;
		return A2(
			$elm$browser$Browser$Document,
			title,
			A2(
				$elm$core$List$map,
				$elm$html$Html$map(msgMapper),
				body));
	});
var $author$project$Translations$routeLogin = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Login';
	} else {
		return 'Ingresar';
	}
};
var $author$project$Pyxis$Components$Button$Full = 1;
var $author$project$Pyxis$Components$Button$full = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{dX: 1});
};
var $author$project$Pyxis$Components$Button$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Pyxis$Components$Button$NoOp = 2;
var $author$project$Pyxis$Components$Button$link = function (href) {
	return A3($author$project$Pyxis$Components$Button$Link, href, $elm$core$Maybe$Nothing, 2);
};
var $author$project$Translations$loginButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Login';
	} else {
		return 'Iniciar sesión';
	}
};
var $author$project$Translations$loginErrorText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Something went wrong.';
	} else {
		return 'Algo salió mal';
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Page$Login$View$encodeReturnUrl = F2(
	function (env, returnRoute) {
		var _v0 = $author$project$Env$languageOverride(env);
		if (!_v0.$) {
			var languageOverride = _v0.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				A2(
					$elm$core$List$cons,
					$author$project$Translations$languageToString(languageOverride),
					$author$project$Route$routeToPieces(returnRoute)),
				_List_Nil);
		} else {
			return A2(
				$elm$url$Url$Builder$absolute,
				$author$project$Route$routeToPieces(returnRoute),
				_List_Nil);
		}
	});
var $author$project$Env$loginPath = function (_v0) {
	var environment = _v0;
	return environment.dc;
};
var $author$project$Page$Login$View$loginLink = F2(
	function (env, returnRoute) {
		return _Utils_ap(
			$author$project$Env$newApiUrl(env),
			_Utils_ap(
				$author$project$Env$loginPath(env),
				A2($author$project$Page$Login$View$encodeReturnUrl, env, returnRoute)));
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Common$ComponentUI$Illustrations$primaLogo = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('194'),
			$elm$svg$Svg$Attributes$height('80'),
			$elm$svg$Svg$Attributes$viewBox('0 0 194 80'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip0_38_4221)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M105.516 7.15611C104.159 7.46915 103.26 8.7576 103.432 10.1396C103.54 18.3799 103.485 26.6126 103.485 34.8453C103.485 35.4847 103.504 36.1127 103.466 36.7464C103.357 38.8938 102.172 40.209 100.372 40.2262C99.4404 40.2434 98.5451 39.8692 97.9057 39.1935C97.2701 38.5235 96.9494 37.613 97.0276 36.693C96.9914 26.7653 96.9723 16.8357 97.083 6.90796C97.1593 5.7894 97.7167 4.75865 98.6119 4.08484C105.171 -0.316872 113.466 -1.22546 120.821 1.65302C122.323 2.41081 123.739 3.32704 125.049 4.38834C128.582 1.50604 133.02 -0.0286422 137.58 0.0515276C147.057 0.087795 152.255 4.33107 152.669 13.249C153.047 21.1171 152.813 29.0196 152.778 36.9068C152.843 37.7925 152.522 38.6629 151.898 39.2928C151.268 39.9284 150.4 40.2682 149.506 40.2262C148.655 40.2071 147.846 39.854 147.256 39.2412C146.67 38.6323 146.353 37.8134 146.378 36.9698C146.288 31.1956 146.323 25.4272 146.307 19.6531C146.307 17.9657 146.361 16.2802 146.252 14.5833C145.803 7.54932 141.119 4.37116 133.86 6.21888C132.516 6.62164 131.233 7.20764 130.048 7.95781C128.706 8.68124 127.922 10.1319 128.053 11.6513C128.162 20.0348 128.124 28.3992 128.088 36.7827C128.181 37.6569 127.895 38.5312 127.301 39.1802C126.704 39.8349 125.858 40.209 124.971 40.209C124.085 40.2185 123.236 39.8654 122.615 39.2317C122.001 38.6037 121.674 37.7486 121.716 36.8705C121.68 36.3017 121.697 35.7519 121.697 35.1831V15.9824C121.697 15.1998 121.716 14.4363 121.644 13.6575C121.105 8.41783 117.885 5.64624 112.258 5.84285C109.962 5.95738 107.692 6.39831 105.52 7.15611H105.516Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M57.2042 8.97137C57.7387 3.76987 61.4532 0.545899 66.9143 0.0648796C69.9493 -0.106913 72.9977 0.041974 76.0021 0.509632C78.287 0.794044 79.3921 2.30773 79.0543 3.94739C78.7164 5.58706 77.1073 6.4403 74.8683 6.22651C72.8869 5.95737 70.8865 5.81993 68.8861 5.81612C65.3701 5.97646 63.5472 7.68484 63.4269 11.0176C63.2666 15.8793 63.32 20.743 63.3009 25.6219C63.2818 29.0711 63.32 32.6559 63.2818 36.1127C63.2627 38.7297 62.1385 40.1746 60.159 40.2281C58.0345 40.2987 56.769 38.8041 56.769 36.1471C56.7499 32.0489 56.769 27.8476 56.769 23.7513C56.874 23.7513 56.6774 13.8484 57.2023 8.96947L57.2042 8.97137Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M90.3506 20.974C90.3506 26.1507 90.3697 31.3235 90.3506 36.5002C90.3315 38.8729 89.1232 40.2128 87.0732 40.23C84.899 40.2472 83.6029 38.8366 83.6029 36.4143C83.5839 26.2022 83.5839 25.2726 83.6029 15.0758C83.6029 12.5141 84.7387 11.1913 86.9128 11.1723C89.2015 11.1379 90.3372 12.4626 90.3563 15.1617C90.3506 20.1837 90.3506 15.9347 90.3506 20.974Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M86.8518 6.70181C85.0976 6.62355 83.6851 5.16713 83.5858 3.33277C83.6755 1.46977 85.1396 0.00571518 86.9224 -0.00382885C88.7052 -0.0133729 90.1827 1.43541 90.2915 3.29459C90.1941 5.20531 88.6823 6.70181 86.8518 6.6999V6.70181Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M47.0895 12.0286C46.0873 5.62077 41.6856 1.59319 34.98 0.388736C31.8457 -0.168635 28.6332 -0.132368 25.5123 0.497538C24.1399 0.715142 23.1282 1.89288 23.1206 3.28058C23.1416 4.89925 24.4396 6.20869 26.0582 6.24305C26.2777 6.23923 26.4972 6.20869 26.7091 6.15333C28.8355 5.63223 31.0478 5.55969 33.2029 5.93764C38.2364 6.8176 40.7713 9.56628 41.2981 15.6C41.5997 19.4978 41.5062 23.4147 41.0156 27.2934C40.4773 32.073 37.3221 34.6938 32.3745 35.1252C28.637 35.4077 24.8862 34.7358 21.4809 33.1687C20.5036 32.8862 19.8775 31.9337 20.0035 30.9239C20.0913 27.4461 20.0397 23.953 20.0397 20.4713C20.0397 17.652 20.0035 14.8136 20.0569 11.9924V7.05047C20.0111 5.32873 18.612 3.95439 16.8902 3.93912C16.3901 3.92003 15.8919 4.01165 15.43 4.20826C11.788 5.8422 9.18246 7.22417 3.19835 10.4329C0.944044 11.6889 0.327499 13.5194 1.3678 15.2793C2.33556 16.9495 4.09548 17.2359 6.22571 16.0696C8.6709 14.7277 11.1657 13.4335 13.7063 12.1909C13.7579 25.4113 13.7235 42.2603 13.7426 55.0321V55.1581H13.7598C13.8609 56.8875 15.346 58.2084 17.0773 58.1053C18.6654 58.0118 19.9309 56.7462 20.0245 55.1581H20.0417C20.0588 51.4779 20.0417 45.0892 20.0417 39.0821C23.5596 39.7464 26.7473 40.6092 29.9846 40.8955C38.9522 41.6858 46.1045 36.7286 47.3376 28.1237C48.0534 22.7771 47.9694 17.3523 47.0875 12.0286H47.0895Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M192.958 11.8689C192.957 6.48992 189.084 1.86488 183.71 0.818854C177.486 -0.654746 170.954 -0.137459 165.04 2.29818C164.214 2.48715 163.506 3.0178 163.095 3.76033C162.691 4.49522 162.626 5.37136 162.92 6.15779C163.494 7.58558 165.201 8.11432 167.337 7.49777C170.958 6.39257 174.716 5.79321 178.501 5.71685C183.224 5.75312 185.9 7.99024 186.554 12.0808C186.661 12.8214 186.698 13.5716 186.663 14.3179H186.682L186.736 22.3025V22.7091C186.736 25.5837 186.825 28.2083 186.665 30.8177C186.56 31.6766 186.072 32.4421 185.337 32.8983C180.796 35.1182 175.575 35.5095 170.753 33.9901C167.321 33.0376 165.309 29.4815 166.262 26.0495C166.886 23.8047 168.671 22.0677 170.937 21.5103C173.912 20.6208 177.058 20.4509 180.112 21.0159C180.267 21.0369 180.423 21.0484 180.578 21.0522C181.973 21.1095 183.153 20.0253 183.21 18.6299C183.264 17.3396 182.338 16.2172 181.063 16.0244C177.06 15.3201 172.956 15.4632 169.013 16.4463C163.051 18.084 159.621 22.1231 159.602 27.5326C159.293 33.2094 163.277 38.2468 168.957 39.3615C176.503 41.2054 184.466 40.1021 191.225 36.2769C192.17 35.708 192.812 34.7441 192.968 33.6503C193.119 26.4102 193.209 19.13 192.958 11.8689Z'),
							$elm$svg$Svg$Attributes$fill('#8334C2')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M54.3849 77.8373V61.9694C54.3849 61.3891 54.5624 60.9253 54.9194 60.5798C55.2744 60.2343 55.7516 60.0606 56.351 60.0606H62.5851C64.3641 60.0606 65.7404 60.5474 66.7139 61.5208C67.7064 62.5134 68.2027 63.7102 68.2027 65.1151C68.2027 67.4172 67.3228 68.8774 65.5629 69.4958V69.5531C66.5554 69.7974 67.3361 70.3204 67.9088 71.126C68.4795 71.9315 68.7658 72.9336 68.7658 74.1304C68.7658 75.9839 68.2409 77.383 67.193 78.3298C66.1431 79.2747 64.7115 79.748 62.8963 79.748H56.3529C55.7535 79.748 55.2763 79.5705 54.9213 79.2136C54.5643 78.8585 54.3868 78.3985 54.3868 77.8373H54.3849ZM56.6869 62.2786V68.4861H62.4439C64.7459 68.4861 65.8988 67.4572 65.8988 65.3976C65.8988 63.338 64.7478 62.2806 62.4439 62.2806H56.6869V62.2786ZM56.6869 70.6755V77.5281H62.5851C65.1315 77.5281 66.4046 76.3771 66.4046 74.0732C66.4046 73.0252 66.0859 72.1968 65.4502 71.5879C64.8127 70.979 63.9518 70.6755 62.8657 70.6755H56.6869Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M72.1902 75.2261C72.1902 73.8784 72.6904 72.7828 73.6925 71.941C74.6946 71.0992 76.0747 70.6774 77.8346 70.6774C78.9951 70.6774 80.3065 70.874 81.7667 71.2672V70.1162C81.7667 68.9919 81.4804 68.1749 80.9097 67.6596C80.3389 67.1442 79.4533 66.8865 78.2564 66.8865C77.3383 66.8865 76.2255 67.1308 74.9141 67.6176C74.7461 67.692 74.5495 67.7302 74.3243 67.7302C74.1372 67.7302 73.9502 67.6844 73.7631 67.5908C73.4443 67.3847 73.2859 67.1041 73.2859 66.7491C73.2859 66.2623 73.5283 65.9073 74.017 65.682C75.2711 65.0827 76.7599 64.783 78.4817 64.783C80.2034 64.783 81.6274 65.2182 82.5818 66.0886C83.5362 66.959 84.0134 68.2742 84.0134 70.0341V77.5052C84.0134 77.9175 83.855 78.2267 83.5362 78.4329C83.1048 78.7516 82.3279 79.1067 81.2055 79.4999C80.1767 79.8377 79.0429 80.0057 77.8079 80.0057C76.0289 80.0057 74.6488 79.5743 73.6658 78.7135C72.6827 77.8526 72.1922 76.692 72.1922 75.2318L72.1902 75.2261ZM74.4655 75.1688C74.4655 77.0222 75.6643 77.9499 78.0598 77.9499C79.8388 77.9499 81.0738 77.6044 81.7667 76.9115V73.2333C80.1939 72.821 78.8921 72.6148 77.8632 72.6148C76.8344 72.6148 76.0327 72.8439 75.4066 73.302C74.7786 73.7601 74.4655 74.3843 74.4655 75.1688Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M88.3387 74.327C88.2643 72.9794 88.2643 71.649 88.3387 70.3395C88.4132 68.7113 89.0412 67.3713 90.2208 66.3234C91.3814 65.2946 92.8512 64.7792 94.6302 64.7792C96.4092 64.7792 97.7568 65.2659 98.7875 66.2394C99.8355 67.1938 100.36 68.0833 100.36 68.9079C100.36 69.2458 100.257 69.5206 100.051 69.7363C99.845 69.952 99.5931 70.0589 99.2934 70.0589C98.7875 70.0589 98.423 69.8051 98.1977 69.3011C97.8789 68.5338 97.4075 67.944 96.7795 67.5317C96.1515 67.1194 95.4452 66.9132 94.6588 66.9132C93.4982 66.9132 92.5572 67.2358 91.8357 67.8829C91.1141 68.53 90.7076 69.3947 90.614 70.4808C90.5396 71.5287 90.5396 72.7656 90.614 74.1877C90.7076 75.2929 91.1141 76.1824 91.8357 76.8562C92.5572 77.53 93.4963 77.8679 94.6588 77.8679C95.4452 77.8679 96.161 77.6617 96.8081 77.2494C97.4533 76.8371 97.9362 76.2473 98.255 75.4799C98.4802 74.9741 98.8448 74.7221 99.3506 74.7221C99.6503 74.7221 99.9023 74.829 100.108 75.0447C100.315 75.2604 100.418 75.5353 100.418 75.8732C100.418 76.7149 99.8832 77.614 98.8162 78.5684C97.7663 79.5228 96.3729 80.0019 94.6321 80.0019C92.8912 80.0019 91.3642 79.4674 90.2227 78.4004C89.0431 77.2761 88.4151 75.919 88.3406 74.327H88.3387Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M104.516 78.6791V60.9577C104.516 60.639 104.623 60.3679 104.838 60.1427C105.054 59.9174 105.319 59.8048 105.638 59.8048C105.957 59.8048 106.228 59.9174 106.453 60.1427C106.679 60.3679 106.791 60.639 106.791 60.9577V71.0973H107.268C107.887 71.0973 108.41 70.8816 108.841 70.4521L114.092 65.285C114.318 65.0426 114.592 64.9204 114.921 64.9204C115.249 64.9204 115.514 65.033 115.721 65.2564C115.946 65.5179 116.058 65.7813 116.058 66.0428C116.058 66.3425 115.936 66.6135 115.694 66.8579L110.16 72.1662L115.778 77.8679C116.039 78.1675 116.171 78.4481 116.171 78.7096C116.171 78.9711 116.058 79.2441 115.833 79.5247C115.627 79.7499 115.36 79.8626 115.033 79.8626C114.707 79.8626 114.43 79.7404 114.205 79.498L108.841 73.993C108.393 73.5444 107.877 73.3192 107.297 73.3192H106.791V78.6829C106.791 79.0208 106.684 79.3014 106.469 79.5247C106.253 79.7499 105.978 79.8626 105.64 79.8626C105.34 79.8626 105.079 79.7461 104.854 79.5113C104.628 79.2766 104.516 79.0017 104.516 78.6829V78.6791Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M118.866 74.327C118.792 73.0176 118.792 71.6871 118.866 70.3395C118.941 68.7285 119.569 67.4 120.748 66.352C121.947 65.3041 123.407 64.7792 125.129 64.7792C126.851 64.7792 128.34 65.2946 129.483 66.3234C130.682 67.3713 131.317 68.7113 131.394 70.3395C131.506 71.6871 131.506 73.0176 131.394 74.327C131.319 75.9743 130.682 77.3315 129.483 78.4004C128.342 79.4674 126.889 80.0019 125.129 80.0019C123.369 80.0019 121.955 79.4674 120.777 78.4004C119.578 77.3334 118.943 75.9762 118.866 74.327ZM121.142 74.1877C121.235 75.2929 121.642 76.1824 122.363 76.8562C123.085 77.53 124.007 77.8679 125.129 77.8679C126.251 77.8679 127.175 77.53 127.895 76.8562C128.615 76.1824 129.023 75.2929 129.117 74.1877C129.191 72.9527 129.191 71.7253 129.117 70.5075C129.042 69.4214 128.649 68.551 127.937 67.8963C127.225 67.2415 126.29 66.9132 125.129 66.9132C123.969 66.9132 123.031 67.2415 122.321 67.8963C121.609 68.551 121.216 69.4214 121.142 70.5075C121.067 71.7253 121.067 72.9508 121.142 74.1877Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M135.578 65.4511H136.561V64.1588C136.561 62.7367 136.945 61.6182 137.712 60.8031C138.479 59.9881 139.565 59.5815 140.97 59.5815C141.944 59.5815 142.768 59.6846 143.442 59.8907C144.041 60.0587 144.341 60.4156 144.341 60.9577C144.341 61.2383 144.244 61.4769 144.047 61.6735C143.851 61.8701 143.583 61.9675 143.247 61.9675C143.154 61.9675 142.822 61.9255 142.251 61.8415C141.68 61.7575 141.272 61.7155 141.029 61.7155C139.569 61.7155 138.838 62.5859 138.838 64.3268V65.4511H142.77C143.219 65.4148 143.534 65.577 143.711 65.9435C143.889 66.3081 143.889 66.6746 143.711 67.0392C143.534 67.4038 143.219 67.5679 142.77 67.5297H138.838V78.6791C138.838 79.0169 138.729 79.2975 138.515 79.5209C138.3 79.7461 138.033 79.8587 137.716 79.8587C137.399 79.8587 137.126 79.7461 136.901 79.5209C136.675 79.2956 136.563 79.015 136.563 78.6791V67.5297H135.58C135.131 67.5679 134.816 67.4038 134.639 67.0392C134.461 66.6746 134.461 66.3081 134.639 65.9435C134.816 65.5789 135.131 65.4148 135.58 65.4511H135.578Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M146.586 65.4511H147.569V64.1588C147.569 62.7367 147.953 61.6182 148.72 60.8031C149.487 59.9881 150.573 59.5815 151.978 59.5815C152.952 59.5815 153.776 59.6846 154.45 59.8907C155.05 60.0587 155.349 60.4156 155.349 60.9577C155.349 61.2383 155.252 61.4769 155.055 61.6735C154.859 61.8701 154.592 61.9675 154.256 61.9675C154.162 61.9675 153.83 61.9255 153.259 61.8415C152.688 61.7575 152.28 61.7155 152.038 61.7155C150.577 61.7155 149.846 62.5859 149.846 64.3268V65.4511H153.778C154.227 65.4148 154.542 65.577 154.719 65.9435C154.897 66.3081 154.897 66.6746 154.719 67.0392C154.542 67.4038 154.227 67.5679 153.778 67.5297H149.846V78.6791C149.846 79.0169 149.737 79.2975 149.524 79.5209C149.308 79.7461 149.041 79.8587 148.724 79.8587C148.407 79.8587 148.134 79.7461 147.909 79.5209C147.684 79.2956 147.571 79.015 147.571 78.6791V67.5297H146.588C146.139 67.5679 145.824 67.4038 145.647 67.0392C145.469 66.6746 145.469 66.3081 145.647 65.9435C145.824 65.5789 146.139 65.4148 146.588 65.4511H146.586ZM159.28 62.7272C158.886 62.7272 158.558 62.5859 158.297 62.3053C158.035 62.0248 157.903 61.6869 157.903 61.2937C157.903 60.9005 158.033 60.5721 158.297 60.3106C158.558 60.03 158.886 59.8888 159.28 59.8888C159.673 59.8888 160.001 60.03 160.263 60.3106C160.543 60.5721 160.684 60.9005 160.684 61.2937C160.684 61.6869 160.543 62.0248 160.263 62.3053C160.001 62.5859 159.673 62.7272 159.28 62.7272ZM158.155 78.6791V66.1535C158.155 65.8347 158.262 65.5599 158.478 65.3251C158.694 65.0903 158.959 64.9739 159.278 64.9739C159.596 64.9739 159.867 65.0903 160.093 65.3251C160.318 65.5599 160.431 65.8347 160.431 66.1535V78.6791C160.431 79.0169 160.324 79.2975 160.108 79.5209C159.892 79.7442 159.617 79.8587 159.28 79.8587C158.98 79.8587 158.718 79.7461 158.493 79.5209C158.268 79.2956 158.155 79.015 158.155 78.6791Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M165.178 74.327C165.103 72.9794 165.103 71.649 165.178 70.3395C165.252 68.7113 165.88 67.3713 167.06 66.3234C168.22 65.2946 169.69 64.7792 171.469 64.7792C173.248 64.7792 174.596 65.2659 175.627 66.2394C176.674 67.1938 177.199 68.0833 177.199 68.9079C177.199 69.2458 177.096 69.5206 176.89 69.7363C176.684 69.952 176.432 70.0589 176.132 70.0589C175.627 70.0589 175.262 69.8051 175.037 69.3011C174.718 68.5338 174.246 67.944 173.618 67.5317C172.99 67.1194 172.284 66.9132 171.498 66.9132C170.337 66.9132 169.396 67.2358 168.675 67.8829C167.953 68.53 167.547 69.3947 167.453 70.4808C167.379 71.5287 167.379 72.7656 167.453 74.1877C167.547 75.2929 167.953 76.1824 168.675 76.8562C169.396 77.53 170.335 77.8679 171.498 77.8679C172.284 77.8679 173 77.6617 173.647 77.2494C174.292 76.8371 174.775 76.2473 175.094 75.4799C175.319 74.9741 175.684 74.7221 176.19 74.7221C176.489 74.7221 176.741 74.829 176.947 75.0447C177.154 75.2604 177.257 75.5353 177.257 75.8732C177.257 76.7149 176.722 77.614 175.655 78.5684C174.605 79.5228 173.212 80.0019 171.471 80.0019C169.73 80.0019 168.203 79.4674 167.062 78.4004C165.882 77.2761 165.254 75.919 165.18 74.327H165.178Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M180.822 73.9605C180.784 73.1741 180.767 72.6224 180.767 72.3037C180.767 71.668 180.796 71.0954 180.851 70.5915C181 68.7934 181.637 67.3751 182.76 66.3367C183.882 65.2984 185.316 64.7773 187.056 64.7773C188.891 64.7773 190.351 65.348 191.437 66.4895C192.542 67.6309 193.094 69.0931 193.094 70.8702V71.7119C193.094 72.7981 192.542 73.3402 191.437 73.3402H183.04V73.7887C183.04 75.0619 183.42 76.0678 184.178 76.8085C184.936 77.5491 185.951 77.9175 187.224 77.9175C188.104 77.9175 189.246 77.6731 190.651 77.1864C190.893 77.0929 191.09 77.0452 191.241 77.0452C191.408 77.0452 191.596 77.1024 191.802 77.2131C192.082 77.4193 192.241 77.7094 192.279 78.0835C192.279 78.5149 192.073 78.8509 191.66 79.0952C190.649 79.6946 189.16 79.9943 187.196 79.9943C185.232 79.9943 183.792 79.4522 182.66 78.3641C181.527 77.278 180.914 75.8082 180.82 73.9548L180.822 73.9605ZM183.04 71.208V71.4333H190.511C190.737 71.4333 190.857 71.3206 190.876 71.0954V70.7308C190.876 69.6256 190.567 68.7189 189.948 68.007C189.236 67.2205 188.282 66.8273 187.083 66.8273C185.755 66.8273 184.733 67.2396 184.021 68.0623C183.367 68.8678 183.038 69.9158 183.038 71.208H183.04Z'),
							$elm$svg$Svg$Attributes$fill('#90939D')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip0_38_4221')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('192.188'),
									$elm$svg$Svg$Attributes$height('80'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0.905884)')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Pyxis$Components$Button$Primary = 0;
var $author$project$Pyxis$Components$Button$primary = $author$project$Pyxis$Components$Button$config(0);
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Pyxis$Components$Button$XL = 0;
var $author$project$Pyxis$Components$Button$sizeXL = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aR: 0});
};
var $author$project$Pyxis$Components$Button$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{pK: text});
	});
var $author$project$Pyxis$Components$Button$withType = F2(
	function (type_, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{bq: type_});
	});
var $author$project$Pyxis$Components$Button$withWidth = function (setWidth) {
	return setWidth;
};
var $author$project$Page$Login$View$view = F3(
	function (i18n, env, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-responsive display-flex justify-content-center align-items-center login-container')
					]),
				function () {
					var _v0 = model.mD;
					switch (_v0.$) {
						case 0:
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$loginErrorText(i18n))
								]);
						case 1:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						case 3:
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						default:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('login-container__logo')
										]),
									_List_fromArray(
										[$author$project$Common$ComponentUI$Illustrations$primaLogo])),
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('login-container__actions')
										]),
									_List_fromArray(
										[
											$author$project$Pyxis$Components$Button$render(
											A2(
												$author$project$Pyxis$Components$Button$withType,
												$author$project$Pyxis$Components$Button$link(
													A2($author$project$Page$Login$View$loginLink, env, model.pH)),
												A2(
													$author$project$Pyxis$Components$Button$withWidth,
													$author$project$Pyxis$Components$Button$full,
													A2(
														$author$project$Pyxis$Components$Button$withSize,
														$author$project$Pyxis$Components$Button$sizeXL,
														A2(
															$author$project$Pyxis$Components$Button$withText,
															$author$project$Translations$loginButtonText(i18n),
															$author$project$Pyxis$Components$Button$primary)))))
										]))
								]);
					}
				}())
			]);
	});
var $author$project$Page$Login$view = F3(
	function (i18n, env, model) {
		return {
			f3: A3($author$project$Page$Login$View$view, i18n, env, model),
			i4: $author$project$Translations$routeLogin(i18n)
		};
	});
var $author$project$Translations$routeNotAuthorized = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Not authorized';
	} else {
		return 'No Autorizado';
	}
};
var $author$project$Page$NotAuthorized$View$view = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container-responsive'),
				$elm$html$Html$Attributes$class('justify-content-center')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('You do not have the required permissions to perform this action. Please contact your supervisor if you need to acquire permissions.')
			]))
	]);
var $author$project$Page$NotAuthorized$view = function (i18n) {
	return {
		f3: $author$project$Page$NotAuthorized$View$view,
		i4: $author$project$Translations$routeNotAuthorized(i18n)
	};
};
var $author$project$Translations$routeNotFound = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Not found';
	} else {
		return 'Sin Resultados';
	}
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Pyxis$Components$IconSet$svgHome = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.24c.15 0 .45.04.71.29l6.71 6.71c.38.38.59.88.59 1.41V20c0 .55-.45 1-1 1h-3v-5a3.01 3.01 0 0 0-3-3h-2a3.01 3.01 0 0 0-3 3v5H5c-.55 0-1-.45-1-1v-8.34c0-.53.21-1.04.59-1.41l6.71-6.71c.25-.26.55-.3.7-.3m0-2c-.77 0-1.54.29-2.12.88L3.17 8.83C2.42 9.58 2 10.6 2 11.66V20c0 1.66 1.34 3 3 3h3c1.1 0 2-.9 2-2v-5c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v5c0 1.1.9 2 2 2h3c1.66 0 3-1.34 3-3v-8.34c0-1.06-.42-2.08-1.17-2.83l-6.71-6.71A3 3 0 0 0 12 1.24h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$home = {eY: 'home', a: $author$project$Pyxis$Components$IconSet$svgHome};
var $author$project$Pyxis$Components$Button$Prepend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Button$withIconPrepend = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ku: $author$project$Pyxis$Components$Button$Prepend(icon)
			});
	});
var $author$project$Page$NotFound$View$view = _List_fromArray(
	[
		A2(
		$elm$html$Html$h1,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Not found')
			])),
		$author$project$Pyxis$Components$Button$render(
		A2(
			$author$project$Pyxis$Components$Button$withType,
			$author$project$Pyxis$Components$Button$link(
				$author$project$Route$toString(
					A2(
						$author$project$Route$Search,
						$author$project$Page$Search$SearchQueryParam$defaultSearchContext,
						$elm$core$Result$Ok($author$project$Page$Search$SearchQueryParam$Empty)))),
			A2(
				$author$project$Pyxis$Components$Button$withText,
				'Go Home',
				A2($author$project$Pyxis$Components$Button$withIconPrepend, $author$project$Pyxis$Components$IconSet$home, $author$project$Pyxis$Components$Button$primary))))
	]);
var $author$project$Page$NotFound$view = function (i18n) {
	return {
		f3: $author$project$Page$NotFound$View$view,
		i4: $author$project$Translations$routeNotFound(i18n)
	};
};
var $author$project$Translations$routeOfferDetails = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Offer details';
	} else {
		return 'Detalles de Oferta';
	}
};
var $author$project$Page$OfferDetails$GreatLakesModalOrigin$AfterPressingPurchaseButton = 1;
var $author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentDismissed = function (a) {
	return {$: 25, a: a};
};
var $author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentGiven = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Page$OfferDetails$GreatLakesModalOrigin$LandingOnPage = 0;
var $author$project$Page$OfferDetails$Msg$RecordingDisclaimerDismissed = {$: 13};
var $author$project$Page$OfferDetails$Msg$RedirectToPayment = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$OfferDetails$Msg$ShowCompleteOfferLegalInformationModal = function (a) {
	return {$: 11, a: a};
};
var $author$project$Common$CoverSelection$defaultExcess = $author$project$Common$Price$euro(
	$prikhi$decimal$Decimal$fromInt(200));
var $author$project$Common$ErrorContainer$CarCrashing = 0;
var $author$project$Pyxis$Components$Form$Legend$Center = 0;
var $author$project$Pyxis$Components$Form$Legend$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$Legend$config = {mu: $elm$core$Maybe$Nothing, d2: 0, ga: _List_Nil, ep: _List_Nil, m1: $elm$core$Maybe$Nothing, eI: $elm$core$Maybe$Nothing, kv: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, i4: $elm$core$Maybe$Nothing};
var $author$project$Common$ErrorContainer$iconToImagePath = function (errorIcon) {
	return '/assets/' + function () {
		if (!errorIcon) {
			return 'car-crashing.svg';
		} else {
			return 'camera.svg';
		}
	}();
};
var $author$project$Pyxis$Components$Form$Legend$Left = 1;
var $author$project$Pyxis$Components$Form$Legend$isAlignedLeft = $elm$core$Basics$eq(1);
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Pyxis$Components$Icon$Boxed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pyxis$Components$Icon$Brand = 1;
var $author$project$Pyxis$Components$Icon$Weak = 0;
var $author$project$Pyxis$Components$Icon$brand = A2($author$project$Pyxis$Components$Icon$Boxed, 1, 0);
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Pyxis$Components$Icon$withStyle = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{dG: a});
	});
var $author$project$Pyxis$Components$Form$Legend$renderAddonByType = function (type_) {
	if (!type_.$) {
		var icon = type_.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-legend__addon')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withStyle,
						$author$project$Pyxis$Components$Icon$brand,
						$author$project$Pyxis$Components$Icon$config(icon)))
				]));
	} else {
		var url = type_.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-legend__addon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(url),
							$elm$html$Html$Attributes$width(80)
						]),
					_List_Nil)
				]));
	}
};
var $author$project$Pyxis$Components$Form$Legend$renderDescription = function (str) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-legend__text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $author$project$Pyxis$Components$Form$Legend$renderTag = function (maybeHeadingLevel) {
	if (!maybeHeadingLevel.$) {
		switch (maybeHeadingLevel.a) {
			case 0:
				var _v1 = maybeHeadingLevel.a;
				return $elm$html$Html$h1;
			case 1:
				var _v2 = maybeHeadingLevel.a;
				return $elm$html$Html$h2;
			case 2:
				var _v3 = maybeHeadingLevel.a;
				return $elm$html$Html$h3;
			case 3:
				var _v4 = maybeHeadingLevel.a;
				return $elm$html$Html$h4;
			case 4:
				var _v5 = maybeHeadingLevel.a;
				return $elm$html$Html$h5;
			default:
				var _v6 = maybeHeadingLevel.a;
				return $elm$html$Html$h6;
		}
	} else {
		return $elm$html$Html$span;
	}
};
var $author$project$Pyxis$Components$Form$Legend$renderTitle = F2(
	function (maybeHeadingLevel, str) {
		return A3(
			$author$project$Pyxis$Components$Form$Legend$renderTag,
			maybeHeadingLevel,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-legend__title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				]));
	});
var $author$project$Pyxis$Components$Form$Legend$render = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$legend,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			configuration.ep,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('form-legend', true),
								_Utils_Tuple2(
								'form-legend--align-left',
								$author$project$Pyxis$Components$Form$Legend$isAlignedLeft(configuration.d2))
							]),
						configuration.ga)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, configuration.kv),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configuration.fz)
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Legend$renderAddonByType, configuration.mu)),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					$author$project$Pyxis$Components$Form$Legend$renderTitle(configuration.eI),
					configuration.i4)),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Legend$renderDescription, configuration.m1))
			]));
};
var $author$project$Pyxis$Components$Form$Legend$withTitle = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				i4: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Common$ErrorContainer$custom = F2(
	function (errorIcon, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-container__icon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('space-v-xs'),
									$elm$html$Html$Attributes$src(
									$author$project$Common$ErrorContainer$iconToImagePath(errorIcon))
								]),
							_List_Nil)
						])),
					$author$project$Pyxis$Components$Form$Legend$render(
					A2($author$project$Pyxis$Components$Form$Legend$withTitle, title, $author$project$Pyxis$Components$Form$Legend$config))
				]));
	});
var $author$project$Common$ErrorContainer$generic = A2($author$project$Common$ErrorContainer$custom, 0, 'Oops! This is embarrassing... something has gone wrong.');
var $elm_community$html_extra$Html$Extra$nothing = $elm$html$Html$text('');
var $author$project$Common$Render$maybe = F2(
	function (content, maybeValue) {
		if (maybeValue.$ === 1) {
			return $elm_community$html_extra$Html$Extra$nothing;
		} else {
			var value = maybeValue.a;
			return content(value);
		}
	});
var $author$project$Common$ErrorContainer$Camera = 1;
var $author$project$Common$ErrorContainer$notFound = A2($author$project$Common$ErrorContainer$custom, 1, '404 - we can\'t find this page');
var $author$project$Common$CoverSelection$pickExcess = function (_v0) {
	var chosenExcess = _v0.f7;
	return A2($elm$core$Maybe$withDefault, $author$project$Common$CoverSelection$defaultExcess, chosenExcess);
};
var $author$project$Common$Offer$pickSelectedBundle = function (_v0) {
	var offer = _v0;
	return offer.iK;
};
var $author$project$Translations$completeOfferLegalInformationContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The customer has been previously informed about the Privacy Policy. If you have voluntarily mentioned that you do not agree to receive commercial emails, please make sure you tick the relevant boxes.';
	} else {
		return 'El cliente ha sido informado previamente sobre la Política de privacidad. Si ha mencionado voluntariamente no estar de acuerdo con recibir emails comerciales, asegúrate de seleccionar las casillas correspondientes.';
	}
};
var $author$project$Pyxis$Components$Modal$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$M = 1;
var $author$project$Pyxis$Components$Modal$config = {d0: $elm$core$Maybe$Nothing, ga: _List_Nil, a0: _List_Nil, ep: _List_Nil, eC: $elm$core$Maybe$Nothing, eH: $elm$core$Maybe$Nothing, eM: false, e5: $elm$core$Maybe$Nothing, aR: 1, fz: $elm$core$Maybe$Nothing};
var $author$project$Translations$completeOfferLegalInformationButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Continue';
	} else {
		return 'Continuar';
	}
};
var $author$project$Pyxis$Components$Modal$Footer$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$Footer$Horizontal = 0;
var $author$project$Pyxis$Components$Modal$Footer$config = {d6: _List_Nil, d7: 0, ga: _List_Nil, em: $elm$core$Maybe$Nothing, ep: _List_Nil, eE: false, eV: false};
var $author$project$Pyxis$Components$Modal$Footer$withButtons = F2(
	function (buttons, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{d6: buttons});
	});
var $author$project$Pyxis$Components$Button$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Button$withOnClick = F2(
	function (onClick, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hT: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Pyxis$Components$Button$withTestId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fz: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$footer = F3(
	function (i18n, externalUrl, ctaMsg) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$href(
							$author$project$ExternalUrl$toString(externalUrl))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Button$render(
							A2(
								$author$project$Pyxis$Components$Button$withTestId,
								'legal-info-btn',
								A2(
									$author$project$Pyxis$Components$Button$withId,
									'legal-info-btn',
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$completeOfferLegalInformationButtonText(i18n),
										A2($author$project$Pyxis$Components$Button$withOnClick, ctaMsg, $author$project$Pyxis$Components$Button$primary)))))
						]))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$completeOfferLegalInformationTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Preference over commercial emails';
	} else {
		return 'Preferencia sobre emails comerciales';
	}
};
var $author$project$Pyxis$Components$Modal$Header$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Modal$Header$H2 = 0;
var $author$project$Pyxis$Components$Modal$Header$config = {bA: $elm$core$Maybe$Nothing, ga: _List_Nil, ee: $elm$core$Maybe$Nothing, em: $elm$core$Maybe$Nothing, ep: _List_Nil, ku: $elm$core$Maybe$Nothing, eV: false, i4: $elm$core$Maybe$Nothing, i5: 0};
var $author$project$Pyxis$Components$Modal$Header$withTitle = F2(
	function (title, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				i4: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$completeOfferLegalInformationTitle(i18n),
		$author$project$Pyxis$Components$Modal$Header$config);
};
var $author$project$Pyxis$Components$Modal$contentId = function (id) {
	return id + '-content';
};
var $author$project$Pyxis$Components$Modal$getModalSizeClass = function (size) {
	switch (size) {
		case 0:
			return 'modal--s';
		case 1:
			return 'modal--m';
		default:
			return 'modal--l';
	}
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Pyxis$Components$Modal$Footer$Vertical = 1;
var $author$project$Pyxis$Components$Modal$Footer$renderButtons = F2(
	function (fullWidthButton, buttonsOrientation) {
		return $elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal__footer__buttons', true),
							_Utils_Tuple2('modal__footer__buttons--full-width', fullWidthButton),
							_Utils_Tuple2('modal__footer__buttons--vertical-orientation', buttonsOrientation === 1)
						]))
				]));
	});
var $author$project$Pyxis$Components$Modal$Footer$render = function (_v0) {
	var classList = _v0.ga;
	var dataAttrList = _v0.ep;
	var customContent = _v0.em;
	var isSticky = _v0.eV;
	var fullWidthButton = _v0.eE;
	var buttons = _v0.d6;
	var buttonsOrientation = _v0.d7;
	return A2(
		$elm$html$Html$footer,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal__footer', true),
							_Utils_Tuple2('modal__footer--sticky', isSticky),
							_Utils_Tuple2(
							'modal__footer--custom',
							$elm_community$maybe_extra$Maybe$Extra$isJust(customContent))
						])),
					$elm$html$Html$Attributes$classList(classList)
				])),
		A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A3($author$project$Pyxis$Components$Modal$Footer$renderButtons, fullWidthButton, buttonsOrientation, buttons)
				]),
			customContent));
};
var $author$project$Pyxis$Components$Modal$Header$renderBadge = function (badge) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__header__badge')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Badge$render(badge)
			]));
};
var $author$project$Pyxis$Components$Button$button = $author$project$Pyxis$Components$Button$Button;
var $author$project$Pyxis$Components$IconSet$svgCross = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.0098 3.99001C19.6198 3.60001 18.9898 3.60001 18.5998 3.99001L11.9998 10.59L5.39977 3.99001C5.00977 3.60001 4.37977 3.60001 3.98977 3.99001C3.59977 4.38001 3.59977 5.01001 3.98977 5.40001L10.5898 12L3.98977 18.6C3.59977 18.99 3.59977 19.62 3.98977 20.01C4.37977 20.4 5.00977 20.4 5.39977 20.01L11.9998 13.41L18.5998 20.01C18.9898 20.4 19.6198 20.4 20.0098 20.01C20.3998 19.62 20.3998 18.99 20.0098 18.6L13.4098 12L20.0098 5.40001C20.3998 5.01001 20.3998 4.38001 20.0098 3.99001V3.99001Z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$cross = {eY: 'cross', a: $author$project$Pyxis$Components$IconSet$svgCross};
var $author$project$Pyxis$Components$Button$S = 3;
var $author$project$Pyxis$Components$Button$sizeS = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aR: 3});
};
var $author$project$Pyxis$Components$Button$withAriaLabel = F2(
	function (ariaLabel, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fZ: $elm$core$Maybe$Just(ariaLabel)
			});
	});
var $author$project$Pyxis$Components$Modal$Header$renderCloseButton = function (_v0) {
	var msg = _v0.kR;
	var ariaLabel = _v0.fZ;
	return $author$project$Pyxis$Components$Button$render(
		A2(
			$author$project$Pyxis$Components$Button$withIconOnly,
			$author$project$Pyxis$Components$IconSet$cross,
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				msg,
				A2(
					$author$project$Pyxis$Components$Button$withType,
					$author$project$Pyxis$Components$Button$button,
					A2(
						$author$project$Pyxis$Components$Button$withAriaLabel,
						ariaLabel,
						A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeS, $author$project$Pyxis$Components$Button$ghost))))));
};
var $author$project$Pyxis$Components$Modal$Header$renderIcon = $author$project$Pyxis$Components$Icon$render;
var $author$project$Pyxis$Components$Modal$Header$renderTitleTag = function (headingLevel) {
	switch (headingLevel) {
		case 0:
			return $elm$html$Html$h2;
		case 1:
			return $elm$html$Html$h3;
		case 2:
			return $elm$html$Html$h4;
		case 3:
			return $elm$html$Html$h5;
		default:
			return $elm$html$Html$h6;
	}
};
var $author$project$Pyxis$Components$Modal$Header$renderTitle = F3(
	function (id, titleTag, title) {
		return A3(
			$author$project$Pyxis$Components$Modal$Header$renderTitleTag,
			titleTag,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal__header__title'),
					$elm$html$Html$Attributes$id(id)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				]));
	});
var $author$project$Pyxis$Components$Modal$Header$render = F2(
	function (titleId, _v0) {
		var classList = _v0.ga;
		var closeButton = _v0.ee;
		var customContent = _v0.em;
		var dataAttrList = _v0.ep;
		var isSticky = _v0.eV;
		var title = _v0.i4;
		var badge = _v0.bA;
		var icon = _v0.ku;
		var titleTag = _v0.i5;
		return A2(
			$elm$html$Html$header,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal__header', true),
								_Utils_Tuple2('modal__header--sticky', isSticky)
							]))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal__header__wrapper', true),
									_Utils_Tuple2(
									'modal__header__wrapper--custom',
									$elm_community$maybe_extra$Maybe$Extra$isJust(customContent))
								])),
							$elm$html$Html$Attributes$classList(classList)
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Header$renderBadge, badge)),
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Header$renderIcon, icon)),
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2(
									$elm$core$Maybe$map,
									A2($author$project$Pyxis$Components$Modal$Header$renderTitle, titleId, titleTag),
									title))
							]),
						customContent)),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Header$renderCloseButton, closeButton))
				]));
	});
var $author$project$Pyxis$Components$Modal$screenReaderDescriptionId = function (id) {
	return id + '-sr-description';
};
var $author$project$Pyxis$Components$Modal$renderDescribedBy = F2(
	function (id, description) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only'),
					$elm$html$Html$Attributes$id(
					$author$project$Pyxis$Components$Modal$screenReaderDescriptionId(id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(description)
				]));
	});
var $author$project$Pyxis$Components$Modal$titleId = function (id) {
	return id + '-header-title';
};
var $author$project$Pyxis$Components$Modal$Header$withCloseButton = F2(
	function (onCloseData, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ee: onCloseData});
	});
var $author$project$Pyxis$Components$Modal$render = F2(
	function (_v0, _v1) {
		var id = _v0.kv;
		var isOpen = _v0.g8;
		var classList = _v1.ga;
		var header = _v1.eH;
		var dataAttrList = _v1.ep;
		var content = _v1.a0;
		var footer = _v1.eC;
		var size = _v1.aR;
		var onCloseMsg = _v1.e5;
		var accessibleDescription = _v1.d0;
		var testId = _v1.fz;
		var isCentered = _v1.eM;
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			isOpen,
			A2(
				$elm$html$Html$div,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					dataAttrList,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('modal-backdrop--show', isOpen)
								])),
							$elm$html$Html$Attributes$classList(classList)
						])),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2(
							$elm$core$Maybe$map,
							$author$project$Pyxis$Components$Modal$renderDescribedBy(id),
							accessibleDescription)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-close'),
								A2(
								$author$project$Pyxis$Commons$Attributes$maybe,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.kR;
									},
									$elm$html$Html$Events$onClick),
								onCloseMsg)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$section,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal', true),
										_Utils_Tuple2(
										$author$project$Pyxis$Components$Modal$getModalSizeClass(size),
										true),
										_Utils_Tuple2('modal--center', isCentered)
									])),
								$elm$html$Html$Attributes$id(id),
								$author$project$Pyxis$Commons$Attributes$role('dialog'),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
								$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
								$author$project$Pyxis$Components$Modal$titleId(id)),
								$author$project$Pyxis$Commons$Attributes$ariaDescribedBy(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Pyxis$Components$Modal$contentId(id),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(
											$author$project$Pyxis$Components$Modal$screenReaderDescriptionId(id)),
										accessibleDescription))),
								A2($elm$html$Html$Attributes$attribute, 'aria-modal', 'true')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2(
									$elm$core$Maybe$map,
									$author$project$Pyxis$Components$Modal$Header$render(
										$author$project$Pyxis$Components$Modal$titleId(id)),
									A2(
										$elm$core$Maybe$map,
										$author$project$Pyxis$Components$Modal$Header$withCloseButton(onCloseMsg),
										header))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal__content'),
										$elm$html$Html$Attributes$id(
										$author$project$Pyxis$Components$Modal$contentId(id))
									]),
								content),
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Modal$Footer$render, footer))
							]))
					])));
	});
var $author$project$Pyxis$Components$Modal$S = 0;
var $author$project$Pyxis$Components$Modal$sizeS = 0;
var $author$project$Pyxis$Components$Modal$withCloseMsg = F3(
	function (msg, ariaLabel, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				e5: $elm$core$Maybe$Just(
					{fZ: ariaLabel, kR: msg})
			});
	});
var $author$project$Pyxis$Components$Modal$withContent = F2(
	function (content, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{a0: content});
	});
var $author$project$Pyxis$Components$Modal$withFooter = F2(
	function (footer, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				eC: $elm$core$Maybe$Just(footer)
			});
	});
var $author$project$Pyxis$Components$Modal$withHeader = F2(
	function (header, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				eH: $elm$core$Maybe$Just(header)
			});
	});
var $author$project$Pyxis$Components$Modal$withSize = F2(
	function (size, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{aR: size});
	});
var $author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$render = F5(
	function (offer, i18n, env, closeMsg, modelMessage) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modelMessage,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A3(
					$author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$footer,
					i18n,
					env(
						$author$project$Common$Offer$pickId(offer)),
					closeMsg),
				A3(
					$author$project$Pyxis$Components$Modal$withCloseMsg,
					closeMsg,
					'',
					A2(
						$author$project$Pyxis$Components$Modal$withContent,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$completeOfferLegalInformationContent(i18n))
							]),
						A2(
							$author$project$Pyxis$Components$Modal$withHeader,
							$author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$header(i18n),
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Pyxis$Components$List$Block = {$: 1};
var $author$project$Pyxis$Components$List$block = $author$project$Pyxis$Components$List$Block;
var $author$project$Pyxis$Components$List$Dl = 2;
var $author$project$Pyxis$Components$List$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$List$EmphasisOnTitle = 0;
var $author$project$Pyxis$Components$List$FullWidth = 1;
var $author$project$Pyxis$Components$List$H2 = 1;
var $author$project$Pyxis$Components$List$ItemBlock = 0;
var $author$project$Pyxis$Components$List$M = 1;
var $author$project$Pyxis$Components$List$config = function (tag) {
	return {ga: _List_Nil, ep: _List_Nil, gv: false, ex: 0, kv: $elm$core$Maybe$Nothing, hd: 0, he: 1, hf: _List_Nil, kO: tag, ig: $author$project$Pyxis$Components$List$Block, aR: 1, fz: $elm$core$Maybe$Nothing, i5: 1};
};
var $author$project$Pyxis$Components$List$dl = $author$project$Pyxis$Components$List$config(2);
var $author$project$Pyxis$Components$List$EmphasisOnText = 1;
var $author$project$Pyxis$Components$List$emphasisText = 1;
var $author$project$Pyxis$Components$List$ItemInline = 1;
var $author$project$Pyxis$Components$List$itemOrientationInline = 1;
var $author$project$Pyxis$Components$List$getItemOrientationClass = function (itemOrientation) {
	if (!itemOrientation) {
		return 'list--item-block';
	} else {
		return 'list--item-inline';
	}
};
var $author$project$Pyxis$Components$List$getItemSizeClass = function (itemSize) {
	switch (itemSize) {
		case 0:
			return 'list--s';
		case 1:
			return 'list--m';
		default:
			return 'list--l';
	}
};
var $author$project$Pyxis$Components$List$getItemWidthClass = F3(
	function (itemWidth, orientation, itemOrientation) {
		var itemWidthClass = function () {
			if (!itemWidth) {
				return 'list--item-width-content';
			} else {
				return 'list--item-width-full-width';
			}
		}();
		var isInlineItemOrientation = itemOrientation === 1;
		var isBlockOrientation = _Utils_eq(orientation, $author$project$Pyxis$Components$List$Block);
		return A3($author$project$Pyxis$Commons$Basics$ternaryOperator, isBlockOrientation && isInlineItemOrientation, itemWidthClass, '');
	});
var $author$project$Pyxis$Components$List$orientationClass = function (orientation) {
	switch (orientation.$) {
		case 0:
			return 'list--inline';
		case 1:
			return 'list--block';
		case 2:
			return 'list--columns';
		default:
			return 'list--columns-horizontal';
	}
};
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $author$project$Pyxis$Components$List$renderAction = function (_v0) {
	var icon = _v0.ku;
	var label = _v0.eY;
	var onClick = _v0.hT;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item__action')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					onClick,
					A2(
						$author$project$Pyxis$Components$Button$withText,
						label,
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeS,
							A2($author$project$Pyxis$Components$Button$withIconOnly, icon, $author$project$Pyxis$Components$Button$ghost)))))
			]));
};
var $author$project$Pyxis$Components$List$Ol = 1;
var $author$project$Pyxis$Components$List$Ul = 0;
var $author$project$Pyxis$Components$Illustration$getClassList = function (classList) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2('illustration', true),
						classList)))));
};
var $author$project$Pyxis$Components$Illustration$formatSize = function (size) {
	return (!_Utils_eq(
		$elm$core$String$toFloat(size),
		$elm$core$Maybe$Nothing)) ? ('--illustration-size: ' + (size + 'px')) : ('--illustration-size: ' + size);
};
var $author$project$Pyxis$Components$Illustration$getOptionalSizeStyleAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		function (size) {
			return $elm$svg$Svg$Attributes$style(
				$author$project$Pyxis$Components$Illustration$formatSize(size));
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($elm$core$List$singleton),
		$elm$core$Maybe$withDefault(_List_Nil)));
var $author$project$Pyxis$Components$IllustrationSet$toLabel = function (_v0) {
	var data = _v0;
	return data.eY;
};
var $author$project$Pyxis$Components$Illustration$buildSvg = F2(
	function (_v0, nodes) {
		var size = _v0.aR;
		var ariaLabel = _v0.fZ;
		var ariaLabelledby = _v0.f$;
		var dataAttrList = _v0.ep;
		var illustration = _v0.gZ;
		var classList = _v0.ga;
		if (nodes.b && (!nodes.a.$)) {
			var payload = nodes.a.a;
			return A2(
				$elm$svg$Svg$svg,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					dataAttrList,
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
								$elm$svg$Svg$Attributes$class(
								$author$project$Pyxis$Components$Illustration$getClassList(classList)),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabel, ariaLabel),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaLabelledBy, ariaLabelledby),
								$author$project$Pyxis$Commons$Attributes$ariaHidden(
								$elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabel) && $elm_community$maybe_extra$Maybe$Extra$isNothing(ariaLabelledby)),
								A2(
								$author$project$Pyxis$Commons$Attributes$renderIf,
								$elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabel) || $elm_community$maybe_extra$Maybe$Extra$isJust(ariaLabelledby),
								$author$project$Pyxis$Commons$Attributes$role('img')),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-name',
								$author$project$Pyxis$Components$IllustrationSet$toLabel(illustration))
							]),
						$author$project$Pyxis$Components$Illustration$getOptionalSizeStyleAttribute(size))),
				A2($elm$core$List$map, $Garados007$elm_svg_parser$SvgParser$nodeToSvg, payload.ah));
		} else {
			return $author$project$Pyxis$Commons$Render$empty;
		}
	});
var $author$project$Pyxis$Components$Illustration$prefixIdAttribute = F2(
	function (name, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2($elm$core$Array$get, 0, array))) + (name + ('_' + A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2($elm$core$Array$get, 1, array)))));
	});
var $author$project$Pyxis$Components$Illustration$replace = F3(
	function (userRegex, replacer, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return string;
		} else {
			var regex = _v0.a;
			return A3($elm$regex$Regex$replace, regex, replacer, string);
		}
	});
var $author$project$Pyxis$Components$Illustration$prefixIdsWithName = F2(
	function (name, string) {
		return A3(
			$author$project$Pyxis$Components$Illustration$replace,
			'(id="|xlink:href="#|fill="url\\(#)((?![^\\"]*\\/>)[^( |\\/|>)]*)',
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.l3;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Array$fromList,
					$author$project$Pyxis$Components$Illustration$prefixIdAttribute(name))),
			string);
	});
var $author$project$Pyxis$Components$Illustration$addHrefAttribute = function (array) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm_community$maybe_extra$Maybe$Extra$join(
			A2($elm$core$Array$get, 0, array))) + (' href=' + A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm_community$maybe_extra$Maybe$Extra$join(
			A2($elm$core$Array$get, 1, array))));
};
var $author$project$Pyxis$Components$Illustration$replaceXlinkHref = function (string) {
	return A3(
		$author$project$Pyxis$Components$Illustration$replace,
		'(xlink:href=((?![^\\"]*\\/>)[^( |\\/|>)]*))',
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.l3;
			},
			A2($elm$core$Basics$composeR, $elm$core$Array$fromList, $author$project$Pyxis$Components$Illustration$addHrefAttribute)),
		string);
};
var $author$project$Pyxis$Components$IllustrationSet$toString = function (_v0) {
	var data = _v0;
	return data.a;
};
var $author$project$Pyxis$Components$Illustration$render = function (configuration) {
	var illustration = configuration.gZ;
	return $author$project$Pyxis$Commons$Render$renderMaybe(
		A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Illustration$buildSvg(configuration),
			$elm$core$Result$toMaybe(
				$Garados007$elm_svg_parser$SvgParser$parseToNodes(
					$author$project$Pyxis$Components$Illustration$replaceXlinkHref(
						A2(
							$author$project$Pyxis$Components$Illustration$prefixIdsWithName,
							$author$project$Pyxis$Components$IllustrationSet$toLabel(illustration),
							$author$project$Pyxis$Components$IllustrationSet$toString(illustration)))))));
};
var $author$project$Pyxis$Components$List$renderAddon = F2(
	function (tag, addon) {
		switch (addon.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__addon', true),
									_Utils_Tuple2('list__item__addon--bullet', !tag),
									_Utils_Tuple2('list__item__addon--number', tag === 1)
								]))
						]),
					_List_Nil);
			case 1:
				var iconConf = addon.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__addon', true),
									_Utils_Tuple2('list__item__addon--icon', true)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(iconConf)
						]));
			default:
				var illustrationConf = addon.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__addon', true),
									_Utils_Tuple2('list__item__addon--icon', true)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Illustration$render(illustrationConf)
						]));
		}
	});
var $author$project$Pyxis$Components$List$renderDlItemText = F2(
	function (action, text) {
		return A3(
			$author$project$Pyxis$Commons$Render$renderIfElse,
			$elm_community$maybe_extra$Maybe$Extra$isJust(action),
			text,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[text])));
	});
var $author$project$Pyxis$Components$List$renderDlItemTitle = F2(
	function (addon, title) {
		return A3(
			$author$project$Pyxis$Commons$Render$renderIfElse,
			$elm_community$maybe_extra$Maybe$Extra$isJust(addon),
			$elm$html$Html$text(title),
			A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])));
	});
var $author$project$Pyxis$Components$List$renderDetailListItem = F4(
	function (listTag, emphasis, itemOrientation, _v0) {
		var text = _v0.pK;
		var title = _v0.i4;
		var addon = _v0.mu;
		var action = _v0.U;
		var classList = _v0.ga;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item', true),
									_Utils_Tuple2('list__item__wrapper', true),
									_Utils_Tuple2(
									'list__item--with-action',
									$elm_community$maybe_extra$Maybe$Extra$isJust(action)),
									_Utils_Tuple2(
									'list__item--with-addon',
									$elm_community$maybe_extra$Maybe$Extra$isJust(addon)),
									_Utils_Tuple2('list__item--emphasis-text', emphasis === 1)
								]),
							classList)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dt,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list__item__title')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								$author$project$Pyxis$Components$List$renderAddon(listTag),
								addon)),
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							$author$project$Pyxis$Components$List$renderDlItemTitle(addon),
							title)
						])),
					A2(
					$elm$html$Html$dd,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item__text', true),
									_Utils_Tuple2(
									'list__item__text--orientation-block',
									$elm_community$maybe_extra$Maybe$Extra$isJust(addon) && (!itemOrientation))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							$author$project$Pyxis$Components$List$renderDlItemText(action),
							text),
							A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$List$renderAction, action)
						]))
				]));
	});
var $author$project$Pyxis$Components$Title$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$TagBuilder$Tag = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$TagBuilder$h2 = 'h2';
var $author$project$Pyxis$Tokens$FontWeight$FontWeightBook = 1;
var $author$project$Pyxis$Tokens$FontWeight$tokenBook = 1;
var $author$project$Pyxis$Tokens$TitleSize$TitleSizeM = 4;
var $author$project$Pyxis$Tokens$TitleSize$tokenM = 4;
var $author$project$Pyxis$Components$Title$config = function (content) {
	return {ga: _List_Nil, eg: $elm$core$Maybe$Nothing, a0: content, ep: _List_Nil, gG: $author$project$Pyxis$Tokens$FontWeight$tokenBook, kv: $elm$core$Maybe$Nothing, hp: _List_Nil, iJ: _List_Nil, aR: $author$project$Pyxis$Tokens$TitleSize$tokenM, i_: $author$project$Pyxis$Commons$TagBuilder$h2, fz: $elm$core$Maybe$Nothing};
};
var $author$project$Pyxis$Commons$TagBuilder$h3 = 'h3';
var $author$project$Pyxis$Commons$TagBuilder$h4 = 'h4';
var $author$project$Pyxis$Commons$TagBuilder$h5 = 'h5';
var $author$project$Pyxis$Commons$TagBuilder$h6 = 'h6';
var $author$project$Pyxis$Commons$TagBuilder$strong = 'strong';
var $author$project$Pyxis$Components$List$getTitleTag = function (titleTag) {
	switch (titleTag) {
		case 0:
			return $author$project$Pyxis$Commons$TagBuilder$strong;
		case 1:
			return $author$project$Pyxis$Commons$TagBuilder$h2;
		case 2:
			return $author$project$Pyxis$Commons$TagBuilder$h3;
		case 3:
			return $author$project$Pyxis$Commons$TagBuilder$h4;
		case 4:
			return $author$project$Pyxis$Commons$TagBuilder$h5;
		default:
			return $author$project$Pyxis$Commons$TagBuilder$h6;
	}
};
var $author$project$Pyxis$Tokens$FontWeight$toString = function (fontWeight) {
	if (!fontWeight) {
		return 'bold';
	} else {
		return 'book';
	}
};
var $author$project$Pyxis$Tokens$TitleSize$toString = function (titleSize) {
	switch (titleSize) {
		case 0:
			return '3xl';
		case 1:
			return '2xl';
		case 2:
			return 'xl';
		case 3:
			return 'l';
		case 4:
			return 'm';
		default:
			return 's';
	}
};
var $author$project$Pyxis$Components$Title$baseClass = F2(
	function (size, fontWeight) {
		return $elm$html$Html$Attributes$class(
			A2(
				$elm$core$String$join,
				'-',
				_List_fromArray(
					[
						'title',
						$author$project$Pyxis$Tokens$TitleSize$toString(size),
						$author$project$Pyxis$Tokens$FontWeight$toString(fontWeight)
					])));
	});
var $author$project$Pyxis$Tokens$Spacing$toString = function (spacing) {
	switch (spacing) {
		case 0:
			return '0';
		case 1:
			return '5xl';
		case 2:
			return '4xl';
		case 3:
			return '3xl';
		case 4:
			return '2xl';
		case 5:
			return 'xl';
		case 6:
			return 'l';
		case 7:
			return 'm';
		case 8:
			return 's';
		case 9:
			return 'xs';
		case 10:
			return '2xs';
		case 11:
			return '3xs';
		default:
			return '4xs';
	}
};
var $author$project$Pyxis$Commons$Attributes$Margin$toClass = function (margin) {
	switch (margin.$) {
		case 0:
			var s = margin.a;
			return 'margin-t-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
		case 1:
			var s = margin.a;
			return 'margin-b-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
		case 2:
			var s = margin.a;
			return 'margin-l-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
		default:
			var s = margin.a;
			return 'margin-r-' + $author$project$Pyxis$Tokens$Spacing$toString(s);
	}
};
var $author$project$Pyxis$Components$Title$marginClassList = function (margins) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Commons$Attributes$Margin$toClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			margins));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Pyxis$Commons$Responsive$pickBreakpoint = function (_v0) {
	var breakpoint = _v0.a_;
	return breakpoint;
};
var $author$project$Pyxis$Commons$Responsive$pickPropertyValue = function (_v0) {
	var propertyValue = _v0.bk;
	return propertyValue;
};
var $author$project$Pyxis$Tokens$Breakpoint$toString = function (breakpoint) {
	switch (breakpoint) {
		case 0:
			return 'base';
		case 1:
			return '2xs';
		case 2:
			return 'xs';
		case 3:
			return 's';
		case 4:
			return 'm';
		case 5:
			return 'l';
		default:
			return 'xl';
	}
};
var $author$project$Pyxis$Components$Title$responsiveSizeClass = function (responsiveSize) {
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				'title',
				$author$project$Pyxis$Tokens$TitleSize$toString(
				$author$project$Pyxis$Commons$Responsive$pickPropertyValue(responsiveSize)),
				'from',
				$author$project$Pyxis$Tokens$Breakpoint$toString(
				$author$project$Pyxis$Commons$Responsive$pickBreakpoint(responsiveSize))
			]));
};
var $author$project$Pyxis$Components$Title$responsiveSizeClassList = function (responsiveSizes) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Title$responsiveSizeClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			responsiveSizes));
};
var $author$project$Pyxis$Commons$Attributes$typographyColorClass = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Tokens$TypographyColor$toString,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$append('c-'),
		$elm$html$Html$Attributes$class));
var $author$project$Pyxis$Commons$TagBuilder$unwrap = function (_v0) {
	var nodeName = _v0;
	return nodeName;
};
var $author$project$Pyxis$Components$Title$render = function (_v0) {
	var content = _v0.a0;
	var margins = _v0.hp;
	var id = _v0.kv;
	var classList = _v0.ga;
	var testId = _v0.fz;
	var dataAttrList = _v0.ep;
	var color = _v0.eg;
	var tag = _v0.i_;
	var fontWeight = _v0.gG;
	var size = _v0.aR;
	var responsiveSize = _v0.iJ;
	return A3(
		$elm$html$Html$node,
		$author$project$Pyxis$Commons$TagBuilder$unwrap(tag),
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					A2($author$project$Pyxis$Components$Title$baseClass, size, fontWeight),
					$author$project$Pyxis$Components$Title$responsiveSizeClassList(responsiveSize),
					$author$project$Pyxis$Components$Title$marginClassList(margins),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$typographyColorClass, color)
				])),
		_List_fromArray(
			[content]));
};
var $author$project$Pyxis$Components$Title$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Pyxis$Components$Title$withTag = F2(
	function (tag, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{i_: tag});
	});
var $author$project$Pyxis$Components$List$renderItemTitleWithTag = F2(
	function (titleTag, title) {
		return $author$project$Pyxis$Components$Title$render(
			A2(
				$author$project$Pyxis$Components$Title$withTag,
				$author$project$Pyxis$Components$List$getTitleTag(titleTag),
				A2(
					$author$project$Pyxis$Components$Title$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('list__item__title', true)
						]),
					$author$project$Pyxis$Components$Title$config(
						$elm$html$Html$text(title)))));
	});
var $author$project$Pyxis$Components$List$renderLiItem = F4(
	function (listTag, titleTag, emphasis, _v0) {
		var text = _v0.pK;
		var title = _v0.i4;
		var addon = _v0.mu;
		var action = _v0.U;
		var classList = _v0.ga;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		return A2(
			$elm$html$Html$li,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_Utils_ap(
							_List_fromArray(
								[
									_Utils_Tuple2('list__item', true),
									_Utils_Tuple2(
									'list__item--with-addon',
									$elm_community$maybe_extra$Maybe$Extra$isJust(addon)),
									_Utils_Tuple2(
									'list__item--with-action',
									$elm_community$maybe_extra$Maybe$Extra$isJust(action)),
									_Utils_Tuple2('list__item--emphasis-text', emphasis === 1)
								]),
							classList)),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$List$renderAddon(listTag),
						addon)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list__item__wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Commons$Render$maybeMapRender,
							$author$project$Pyxis$Components$List$renderItemTitleWithTag(titleTag),
							title),
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$elm$html$Html$span(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list__item__text')
											]))),
								text))
						])),
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$List$renderAction, action)
				]));
	});
var $author$project$Pyxis$Components$List$renderListItem = F5(
	function (listTag, titleTag, emphasis, itemOrientation, itemConfig) {
		return (listTag === 2) ? A4($author$project$Pyxis$Components$List$renderDetailListItem, listTag, emphasis, itemOrientation, itemConfig) : A4($author$project$Pyxis$Components$List$renderLiItem, listTag, titleTag, emphasis, itemConfig);
	});
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Pyxis$Components$List$renderTag = function (tag) {
	switch (tag) {
		case 0:
			return $elm$html$Html$ul;
		case 1:
			return $elm$html$Html$ol;
		default:
			return $elm$html$Html$dl;
	}
};
var $author$project$Pyxis$Components$List$stylesForOrientation = F2(
	function (orientation, itemsLength) {
		switch (orientation.$) {
			case 0:
				return $elm$html$Html$Attributes$classList(_List_Nil);
			case 1:
				return $elm$html$Html$Attributes$classList(_List_Nil);
			case 2:
				var count = orientation.a;
				return A2(
					$elm$html$Html$Attributes$attribute,
					'style',
					A2(
						$elm$core$String$join,
						';',
						_List_fromArray(
							[
								'--list-item-counter: ' + $elm$core$String$fromInt(itemsLength),
								'--list-max-columns: ' + $elm$core$String$fromInt(count)
							])));
			default:
				var count = orientation.a;
				return A2(
					$elm$html$Html$Attributes$attribute,
					'style',
					A2(
						$elm$core$String$join,
						';',
						_List_fromArray(
							[
								'--list-item-counter: ' + $elm$core$String$fromInt(itemsLength),
								'--list-max-columns: ' + $elm$core$String$fromInt(count)
							])));
		}
	});
var $author$project$Pyxis$Components$List$render = function (_v0) {
	var listTag = _v0.kO;
	var dataAttrList = _v0.ep;
	var divider = _v0.gv;
	var orientation = _v0.ig;
	var itemOrientation = _v0.hd;
	var itemWidth = _v0.he;
	var id = _v0.kv;
	var classList = _v0.ga;
	var testId = _v0.fz;
	var items = _v0.hf;
	var size = _v0.aR;
	var emphasis = _v0.ex;
	var titleTag = _v0.i5;
	return A3(
		$author$project$Pyxis$Components$List$renderTag,
		listTag,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('list', true),
							_Utils_Tuple2(
							A3($author$project$Pyxis$Components$List$getItemWidthClass, itemWidth, orientation, itemOrientation),
							true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$List$getItemSizeClass(size),
							true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$List$getItemOrientationClass(itemOrientation),
							true),
							_Utils_Tuple2('list--with-divider', divider),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$List$orientationClass(orientation),
							true)
						])),
					A2(
					$author$project$Pyxis$Components$List$stylesForOrientation,
					orientation,
					$elm$core$List$length(items)),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		A2(
			$elm$core$List$map,
			A4($author$project$Pyxis$Components$List$renderListItem, listTag, titleTag, emphasis, itemOrientation),
			items));
};
var $author$project$Pyxis$Components$List$Default = {$: 0};
var $author$project$Pyxis$Components$List$Item = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$List$item = {
	U: $elm$core$Maybe$Nothing,
	mu: $elm$core$Maybe$Just($author$project$Pyxis$Components$List$Default),
	ga: _List_Nil,
	ep: _List_Nil,
	fz: $elm$core$Maybe$Nothing,
	pK: $elm$core$Maybe$Nothing,
	i4: $elm$core$Maybe$Nothing
};
var $author$project$Pyxis$Components$List$Icon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$List$withItemAddonIcon = F2(
	function (iconConfig, _v0) {
		var itemConf = _v0;
		return _Utils_update(
			itemConf,
			{
				mu: $elm$core$Maybe$Just(
					$author$project$Pyxis$Components$List$Icon(iconConfig))
			});
	});
var $author$project$Pyxis$Components$List$withItemTitle = F2(
	function (title, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{
				i4: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$renderCover = function (cover) {
	return A2(
		$author$project$Pyxis$Components$List$withItemTitle,
		cover.jY,
		A2(
			$author$project$Pyxis$Components$List$withItemAddonIcon,
			$author$project$Pyxis$Components$Icon$config(cover.ku),
			$author$project$Pyxis$Components$List$item));
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$SelectedPackage = F3(
	function (packageName, covers, tooltipText) {
		return {ek: covers, o3: packageName, pO: tooltipText};
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$Cover = F2(
	function (coverName, icon) {
		return {jY: coverName, ku: icon};
	});
var $author$project$Translations$coversCoverageCivilLiability = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Mandatory and voluntary civil liability';
	} else {
		return 'Responsabilidad civil obligatoria y voluntaria';
	}
};
var $author$project$Translations$coversCoverageDriverProtection = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Third party damage';
	} else {
		return 'Protección al conductor';
	}
};
var $author$project$Translations$coversCoverageFreeWorkshopChoice = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Free choice of workshop';
	} else {
		return 'Libre elección de taller';
	}
};
var $author$project$Translations$coversCoverageLegalDefense = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Legal defense and damage claims';
	} else {
		return 'Defensa jurídica y reclamación de daños';
	}
};
var $author$project$Translations$coversCoverageRoadsideAssistanceV1 = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return '24h. roadside assistance with no km limit';
	} else {
		return 'Asistencia en viaje 24 h sin límite de km';
	}
};
var $author$project$Translations$coversCoverageRoadsideAssistanceV2 = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Basic roadside assistance';
	} else {
		return 'Asistencia en carretera básica';
	}
};
var $author$project$Pyxis$Components$IconSet$svgVehicleLegalProtection = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.65 21.72c-.21.07-.42.11-.65.11-.22 0-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04c1.26 1.1 3.5 2.48 7 2.85v6.81l1.96 1.13c.05-.51.04-.83.04-.83V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39-.37-.33-.83-.49-1.3-.49a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.94 2.39C3.75 4.02 3 4.88 3 5.89V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22.44 0 .89-.07 1.31-.22 2.68-.94 4.41-2.46 5.55-4.07l-1.75-1.01c-.94 1.27-2.34 2.45-4.46 3.19zm8.95-5.21l-5.63-3.25.5-.87a3 3 0 0 0-1.1-4.1l-.87-.5c-.47-.27-.99-.4-1.5-.4-1.04 0-2.05.54-2.6 1.5l-2 3.46a3 3 0 0 0 1.1 4.1l.87.5c.47.27.99.4 1.5.4 1.04 0 2.05-.54 2.6-1.5l.5-.87 5.63 3.25a1.01 1.01 0 0 0 .5.13c.35 0 .68-.18.87-.5.27-.46.1-1.07-.37-1.35zm-8.87-1.65c-.18.31-.51.5-.87.5-.18 0-.34-.05-.5-.13l-.87-.5c-.31-.18-.43-.46-.47-.61a1 1 0 0 1 .1-.76l2-3.46c.18-.31.51-.5.87-.5.18 0 .34.05.5.13l.87.5c.31.18.43.46.47.61a1 1 0 0 1-.1.76l-2 3.46z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$vehicleLegalProtection = {eY: 'vehicle-legal-protection', a: $author$project$Pyxis$Components$IconSet$svgVehicleLegalProtection};
var $author$project$Pyxis$Components$IconSet$svgWrench = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M14.35 3.99l.33.01-2.44 2.44a2.97 2.97 0 0 0-.88 2.12 2.97 2.97 0 0 0 .88 2.12l1.41 1.41a2.97 2.97 0 0 0 2.12.88 2.97 2.97 0 0 0 2.12-.88l2.45-2.45c.09 1.68-.52 3.35-1.74 4.57a5.96 5.96 0 0 1-4.24 1.75c-.22 0-.44-.01-.66-.04l-.95-.1-.68.68-3.37 3.37a.96.96 0 0 1-.7.3c-.15 0-.45-.04-.71-.29l-2.83-2.83c-.39-.39-.39-1.02 0-1.41l3.37-3.37.68-.68-.1-.95c-.23-2.09.62-4.11 2.29-5.41 1.02-.8 2.32-1.24 3.65-1.24m7.3 4.36h0 0m-7.3-6.36c-1.74 0-3.47.55-4.89 1.66-2.33 1.82-3.34 4.57-3.05 7.2l-3.37 3.37a3 3 0 0 0 0 4.24l2.83 2.83c.59.59 1.35.88 2.12.88s1.54-.29 2.12-.88l3.37-3.37.88.05c2.05 0 4.09-.78 5.65-2.34 2.27-2.27 2.88-5.55 1.86-8.38-.15-.41-.53-.62-.92-.62-.26 0-.52.1-.72.3l-3.75 3.75a.98.98 0 0 1-.71.29c-.26 0-.51-.1-.71-.29l-1.41-1.41c-.39-.39-.39-1.02 0-1.41l3.75-3.75c.53-.53.31-1.42-.4-1.66-.84-.31-1.74-.46-2.65-.46h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$wrench = {eY: 'wrench', a: $author$project$Pyxis$Components$IconSet$svgWrench};
var $author$project$Common$ComponentUI$Modal$CoverPackages$baseCoverPackage = F2(
	function (i18n, productVersion) {
		var roadAssistance = function () {
			if (!productVersion) {
				return $author$project$Translations$coversCoverageRoadsideAssistanceV1(i18n);
			} else {
				return $author$project$Translations$coversCoverageRoadsideAssistanceV2(i18n);
			}
		}();
		return _List_fromArray(
			[
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageCivilLiability(i18n),
				$author$project$Pyxis$Components$IconSet$vehicleLegalProtection),
				A2($author$project$Common$ComponentUI$Modal$CoverPackages$Cover, roadAssistance, $author$project$Pyxis$Components$IconSet$vehicleRoadsideAssistance),
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageFreeWorkshopChoice(i18n),
				$author$project$Pyxis$Components$IconSet$wrench),
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageDriverProtection(i18n),
				$author$project$Pyxis$Components$IconSet$car),
				A2(
				$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
				$author$project$Translations$coversCoverageLegalDefense(i18n),
				$author$project$Pyxis$Components$IconSet$vehicleLegalProtection)
			]);
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$basePackage = F4(
	function (packageName, tooltipText, i18n, productVersion) {
		return A3(
			$author$project$Common$ComponentUI$Modal$CoverPackages$SelectedPackage,
			packageName,
			A2($author$project$Common$ComponentUI$Modal$CoverPackages$baseCoverPackage, i18n, productVersion),
			tooltipText);
	});
var $author$project$Translations$bundleSlugThirdPartyExtended = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Third party extended';
	} else {
		return 'Terceros ampliado';
	}
};
var $author$project$Translations$coversThirdPartyExtendedSubtitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Protect yourself against unforeseen events by adding glass, theft and fire coverage.';
	} else {
		return 'Protégete ante imprevistos añadiendo la cobertura de lunas, robo e incendio.';
	}
};
var $author$project$Translations$coversCoverageMisfortunes = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Glass, theft, fire';
	} else {
		return 'Lunas, robo, incendio';
	}
};
var $author$project$Pyxis$Components$IconSet$svgVehicleDriverInjuries = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M19.07 12l1.41-1.41c1.56-1.56 1.56-4.09 0-5.66l-1.41-1.41a3.98 3.98 0 0 0-2.83-1.17 3.98 3.98 0 0 0-2.83 1.17L12 4.93l-1.41-1.41c-.79-.79-1.81-1.18-2.83-1.18a4 4 0 0 0-2.83 1.17L3.51 4.93c-1.56 1.56-1.56 4.09 0 5.66L4.93 12l-1.41 1.41c-1.56 1.56-1.56 4.09 0 5.66l1.41 1.41a3.98 3.98 0 0 0 2.83 1.17 3.98 3.98 0 0 0 2.83-1.17l7.07-7.07 1.41 1.41c.78.78.78 2.05 0 2.83l-1.41 1.41c-.38.38-.88.59-1.41.59s-1.04-.21-1.41-.59l-1.41-1.41L12 19.07l1.41 1.41a3.98 3.98 0 0 0 2.83 1.17 3.98 3.98 0 0 0 2.83-1.17l1.41-1.41c1.56-1.56 1.56-4.09 0-5.66L19.07 12zM4.93 9.17c-.38-.38-.59-.88-.59-1.41s.21-1.04.59-1.41l1.41-1.41c.38-.38.88-.59 1.41-.59s1.04.21 1.41.59l1.41 1.41-4.24 4.24-1.4-1.42zm4.24 9.9c-.38.38-.88.59-1.41.59s-1.04-.21-1.41-.59l-1.41-1.41c-.78-.78-.78-2.05 0-2.83l9.9-9.9c.38-.38.88-.59 1.41-.59s1.04.21 1.41.59l1.41 1.41c.38.38.59.88.59 1.41s-.21 1.04-.59 1.41l-9.9 9.91zm3.54-10.19c-.26 0-.51.1-.71.29L9.17 12c-.39.39-.39 1.02 0 1.41l1.41 1.41a.98.98 0 0 0 .71.29c.26 0 .51-.1.71-.29L14.83 12c.39-.39.39-1.02 0-1.41l-1.41-1.41a1.01 1.01 0 0 0-.71-.3h0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$vehicleDriverInjuries = {eY: 'vehicle-driver-injuries', a: $author$project$Pyxis$Components$IconSet$svgVehicleDriverInjuries};
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoCoverPackage = function (i18n) {
	return _List_fromArray(
		[
			A2(
			$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
			$author$project$Translations$coversCoverageMisfortunes(i18n),
			$author$project$Pyxis$Components$IconSet$vehicleDriverInjuries)
		]);
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$withAdditionalCovers = F2(
	function (covers, selected) {
		return _Utils_update(
			selected,
			{
				ek: A2($elm$core$List$append, selected.ek, covers)
			});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoPackage = F2(
	function (i18n, productVersion) {
		return A2(
			$author$project$Common$ComponentUI$Modal$CoverPackages$withAdditionalCovers,
			$author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoCoverPackage(i18n),
			A4(
				$author$project$Common$ComponentUI$Modal$CoverPackages$basePackage,
				$author$project$Translations$bundleSlugThirdPartyExtended(i18n),
				$author$project$Translations$coversThirdPartyExtendedSubtitle(i18n),
				i18n,
				productVersion));
	});
var $author$project$Translations$bundleSlugThirdPartyOnly = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Third party only';
	} else {
		return 'Terceros básico';
	}
};
var $author$project$Translations$coversThirdPartyBasicSubtitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Get a powerful third party insurance with top quality travel assistance.';
	} else {
		return 'Obtén un seguro a terceros potente, con asistencia en viaje de primera calidad.';
	}
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosBasicoPackage = F2(
	function (i18n, productVersion) {
		return A4(
			$author$project$Common$ComponentUI$Modal$CoverPackages$basePackage,
			$author$project$Translations$bundleSlugThirdPartyOnly(i18n),
			$author$project$Translations$coversThirdPartyBasicSubtitle(i18n),
			i18n,
			productVersion);
	});
var $author$project$Translations$bundleSlugComprehensiveCover = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Comprehensive cover';
	} else {
		return 'Todo riesgo con franquicia';
	}
};
var $author$project$Translations$coversComprehensiveSubtitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Drive worry-free with our most complete insurance.';
	} else {
		return 'Conduce libre de preocupaciones con nuestro seguro más completo.';
	}
};
var $author$project$Translations$coversCoveragePersonalDamage = F2(
	function (excess, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Personal damage up to ' + excess;
		} else {
			return 'Daños propios con franquicia ' + excess;
		}
	});
var $author$project$Pyxis$Components$IconSet$svgHomeTheftValuable = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M15.73 7.93l1.5-2.6a2 2 0 0 0-.32-2.41l-1.33-1.33c-.37-.38-.88-.59-1.41-.59H9.83c-.53 0-1.04.21-1.42.59L7.09 2.91a2 2 0 0 0-.32 2.42l1.5 2.6C5.73 9.27 4 11.93 4 15a8 8 0 1 0 16 0c0-3.07-1.73-5.73-4.27-7.07zM8.5 4.33L9.83 3h4.34 0l1.33 1.33-1.67 2.89C13.24 7.08 12.63 7 12 7s-1.24.08-1.83.22L8.5 4.33zM12 21c-3.31 0-6-2.69-6-6 0-2.32 1.33-4.34 3.27-5.34a5.98 5.98 0 0 1 5.46 0c1.94 1 3.27 3.01 3.27 5.34 0 3.31-2.69 6-6 6z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$homeTheftValuable = {eY: 'home-theft-valuable', a: $author$project$Pyxis$Components$IconSet$svgHomeTheftValuable};
var $author$project$Common$Price$toStringSignLast = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($author$project$Common$Price$toAmountString, i18n, amount),
					$author$project$Common$Price$pickSign
				]));
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoCoverPackage = F2(
	function (i18n, chosenExcess) {
		return A2(
			$elm$core$List$append,
			$author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoCoverPackage(i18n),
			_List_fromArray(
				[
					A2(
					$author$project$Common$ComponentUI$Modal$CoverPackages$Cover,
					A2(
						$author$project$Translations$coversCoveragePersonalDamage,
						A2($author$project$Common$Price$toStringSignLast, i18n, chosenExcess),
						i18n),
					$author$project$Pyxis$Components$IconSet$homeTheftValuable)
				]));
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoConFranquicia = F3(
	function (i18n, productVersion, chosenExcess) {
		return A2(
			$author$project$Common$ComponentUI$Modal$CoverPackages$withAdditionalCovers,
			A2($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoCoverPackage, i18n, chosenExcess),
			A4(
				$author$project$Common$ComponentUI$Modal$CoverPackages$basePackage,
				$author$project$Translations$bundleSlugComprehensiveCover(i18n),
				$author$project$Translations$coversComprehensiveSubtitle(i18n),
				i18n,
				productVersion));
	});
var $author$project$Pyxis$Components$List$withEmphasis = F2(
	function (emphasis, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ex: emphasis});
	});
var $author$project$Pyxis$Components$List$withItemOrientation = F2(
	function (orientation, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{hd: orientation});
	});
var $author$project$Pyxis$Components$List$withItems = F2(
	function (items, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{hf: items});
	});
var $author$project$Pyxis$Components$List$withOrientation = F2(
	function (orientation, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ig: orientation});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$content = F4(
	function (i18n, productSlug, productVersion, chosenExcess) {
		var _v0 = function () {
			switch (productSlug) {
				case 0:
					return A2($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosBasicoPackage, i18n, productVersion);
				case 1:
					return A2($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosAmpliadoPackage, i18n, productVersion);
				default:
					return A3($author$project$Common$ComponentUI$Modal$CoverPackages$tercerosTodoRiesgoConFranquicia, i18n, productVersion, chosenExcess);
			}
		}();
		var covers = _v0.ek;
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withEmphasis,
				$author$project$Pyxis$Components$List$emphasisText,
				A2(
					$author$project$Pyxis$Components$List$withOrientation,
					$author$project$Pyxis$Components$List$block,
					A2(
						$author$project$Pyxis$Components$List$withItemOrientation,
						$author$project$Pyxis$Components$List$itemOrientationInline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							A2($elm$core$List$map, $author$project$Common$ComponentUI$Modal$CoverPackages$renderCover, covers),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Translations$coversIncludedCoversModalButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Got it';
	} else {
		return 'Entendido';
	}
};
var $author$project$Common$ComponentUI$Modal$CoverPackages$footer = F2(
	function (i18n, ctaMsg) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						ctaMsg,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$coversIncludedCoversModalButton(i18n),
							$author$project$Pyxis$Components$Button$primary)))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Common$Product$bundleSlugToString = F2(
	function (i18n, bundleSlug) {
		switch (bundleSlug) {
			case 0:
				return $author$project$Translations$bundleSlugThirdPartyOnly(i18n);
			case 1:
				return $author$project$Translations$bundleSlugThirdPartyExtended(i18n);
			default:
				return $author$project$Translations$bundleSlugComprehensiveCover(i18n);
		}
	});
var $author$project$Translations$coversIncludedCoversModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Included covers';
	} else {
		return 'Coberturas incluidas';
	}
};
var $author$project$Pyxis$Components$Modal$Header$withBadge = F2(
	function (badge, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				bA: $elm$core$Maybe$Just(badge)
			});
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$header = F2(
	function (i18n, bundleSlug) {
		return A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$coversIncludedCoversModalTitle(i18n),
			A2(
				$author$project$Pyxis$Components$Modal$Header$withBadge,
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					A2($author$project$Common$Product$bundleSlugToString, i18n, bundleSlug),
					$author$project$Pyxis$Components$Badge$brand),
				$author$project$Pyxis$Components$Modal$Header$config));
	});
var $author$project$Common$ComponentUI$Modal$CoverPackages$render = F4(
	function (i18n, bundleSlug, chosenExcess, _v0) {
		var modelData = _v0;
		return A2(
			$author$project$Common$Render$maybe,
			function (productVersion) {
				return A2(
					$author$project$Pyxis$Components$Modal$render,
					modelData.b2,
					A2(
						$author$project$Pyxis$Components$Modal$withFooter,
						A2($author$project$Common$ComponentUI$Modal$CoverPackages$footer, i18n, modelData.hU),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							modelData.hU,
							'',
							A2(
								$author$project$Pyxis$Components$Modal$withContent,
								_List_fromArray(
									[
										A4($author$project$Common$ComponentUI$Modal$CoverPackages$content, i18n, bundleSlug, productVersion, chosenExcess)
									]),
								A2(
									$author$project$Pyxis$Components$Modal$withHeader,
									A2($author$project$Common$ComponentUI$Modal$CoverPackages$header, i18n, bundleSlug),
									A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
			},
			modelData.ix);
	});
var $author$project$Tracker$customActionAttributeName = 'dd-action-name';
var $author$project$Translations$greatLakesOptInConsentModalAcceptButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Yes, continue';
	} else {
		return 'Sí, continuemos';
	}
};
var $author$project$Translations$greatLakesOptInConsentModalDismissButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'No, I don\'t accept';
	} else {
		return 'No, no acepto';
	}
};
var $author$project$Pyxis$Components$Button$Secondary = 1;
var $author$project$Pyxis$Components$Button$secondary = $author$project$Pyxis$Components$Button$config(1);
var $author$project$Pyxis$Components$Button$L = 1;
var $author$project$Pyxis$Components$Button$sizeL = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{aR: 1});
};
var $author$project$Pyxis$Components$Button$withDataAttrList = F2(
	function (attributes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ep: attributes});
	});
var $author$project$Pyxis$Components$Button$withDisabled = F2(
	function (isDisabled, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gt: isDisabled});
	});
var $author$project$Pyxis$Components$Button$withLoading = F2(
	function (isLoading, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{bY: isLoading});
	});
var $author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$footer = F5(
	function (i18n, offerId, approveMsg, closeMsg, isLoading) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDataAttrList,
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'refuse-great-lakes-opt-in')
							]),
						A2(
							$author$project$Pyxis$Components$Button$withDisabled,
							isLoading,
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								closeMsg,
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeL,
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$greatLakesOptInConsentModalDismissButton(i18n),
										$author$project$Pyxis$Components$Button$secondary)))))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDataAttrList,
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'accept-great-lakes-opt-in')
							]),
						A2(
							$author$project$Pyxis$Components$Button$withLoading,
							isLoading,
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								approveMsg(offerId),
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeL,
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$greatLakesOptInConsentModalAcceptButton(i18n),
										$author$project$Pyxis$Components$Button$primary))))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$greatLakesOptInConsentModalBody = F2(
	function (extraAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('In order to continue to offer you the same service as always, your new policy will be backed by '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, extraAttrs.mE),
					_List_fromArray(
						[
							$elm$html$Html$text('Great Lakes (Great Lakes Insurance SE, part of the Munich RE Group)')
						])),
					$elm$html$Html$text(' instead of iptiQ.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('We will continue to accompany you and manage everything as before.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('Two months before expiry, we\'ll send you an email with all the details if you want to take a look at it. Is it OK if we continue and I\'ll tell you the price and the next steps?')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Para seguir ofreciéndote el servicio de siempre, tu nueva póliza estará respaldada por '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, extraAttrs.mE),
					_List_fromArray(
						[
							$elm$html$Html$text('Great Lakes (Great Lakes Insurance SE, parte del grupo Munich RE)')
						])),
					$elm$html$Html$text(', en lugar de iptiQ.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('Nosotros seguimos acompañándote y gestionando todo como hasta ahora.'),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A3(
					$elm$html$Html$node,
					'br',
					_Utils_ap(_List_Nil, extraAttrs.mH),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					$elm$html$Html$text('Dos meses antes del vencimiento, te enviamos un email con todos los detalles, por si quieres echarle un vistazo. ¿Te parece bien que sigamos y te cuento el precio y los siguientes pasos?')
				]);
		}
	});
var $author$project$Translations$greatLakesOptInConsentModalHeader = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Same protection, with a new insurance partner';
	} else {
		return 'La misma protección, con un nuevo socio asegurador';
	}
};
var $author$project$Translations$greatLakesOptInConsentModalHeaderTag = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy update';
	} else {
		return 'Actualización de la póliza';
	}
};
var $author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$greatLakesOptInConsentModalHeader(i18n),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withBadge,
			A2(
				$author$project$Pyxis$Components$Badge$withText,
				$author$project$Translations$greatLakesOptInConsentModalHeaderTag(i18n),
				$author$project$Pyxis$Components$Badge$brand),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Pyxis$Components$Modal$sizeM = 1;
var $author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$render = F6(
	function (i18n, offerId, approveMsg, closeMsg, isLoading, modelMessage) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modelMessage,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A5($author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$footer, i18n, offerId, approveMsg, closeMsg, isLoading),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A2(
						$author$project$Translations$greatLakesOptInConsentModalBody,
						{mE: _List_Nil, mH: _List_Nil},
						i18n),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$header(i18n),
						A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeM, $author$project$Pyxis$Components$Modal$config)))));
	});
var $author$project$Common$Offer$pickStartDate = function (_v0) {
	var offer = _v0;
	return offer.l_;
};
var $author$project$Translations$recordingDisclaimerModalContent = F3(
	function (data, extraAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('\"I confirm that you will take out an insurance policy ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.jy)
								])),
							$elm$html$Html$text('), which covers: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text('compulsory and voluntary civil liability, basic travel assistance, free choice of garage, driver protection, legal defence and damage claims / windows, theft, fire / own damage with an excess of €200. ' + data.my)
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Drivers under 26 years of age and with less than 2 years of driving licence are not covered, unless explicitly declared.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment will be made today but the insurance will take effect on '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l_)
								])),
							$elm$html$Html$text('. The total price for your insurance is '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l9)
								])),
							$elm$html$Html$text(', including insurance premium tax and statutory surcharges.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('You have 14 days to exercise your right of withdrawal, in which case the unearned premium will be refunded. You can find information on how to proceed on our website or contact our customer service.\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kr),
					_List_fromArray(
						[
							$elm$html$Html$text('Call recording protocol')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Pause the recording in Aircall before the customer\'s bank details and remember to resume it afterwards.')
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('\"Te confirmo que contratarás un seguro a ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.jy)
								])),
							$elm$html$Html$text('), que cubre: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text('responsabilidad civil obligatoria y voluntaria, asistencia en carretera básica, libre elección de taller, protección al conductor, defensa jurídica y reclamación de daños / lunas, robo, incendio / daños propios con franquicia 200€. ' + data.my)
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Los conductores menores de 26 años o con menos de 2 años de antigüedad de carnet no están cubiertos, salvo que estén declarados de manera explícita.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('El pago se realizará hoy pero el seguro entrará en vigor el '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l_)
								])),
							$elm$html$Html$text('. El precio de su seguro es de '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l9)
								])),
							$elm$html$Html$text(', e incluye el Impuesto sobre las Primas de Seguros y los recargos legales.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Tienes 14 días para ejercer el derecho de desistimiento, y en ese caso se te devolverá la prima no consumida. Puedes encontrar la información sobre cómo proceder en nuestra página web o contactar con nuestro servicio de atención al cliente\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kr),
					_List_fromArray(
						[
							$elm$html$Html$text('Protocolo de grabación de llamadas')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Pausa la grabación en Aircall antes de los datos bancarios del cliente y recuerda reanudarla luego.')
						]))
				]);
		}
	});
var $author$project$Common$StringUtils$joinWithCommas = F2(
	function (separator, strings) {
		if (!strings.b) {
			return '';
		} else {
			if (!strings.b.b) {
				var string = strings.a;
				return string;
			} else {
				if (!strings.b.b.b) {
					var head = strings.a;
					var _v1 = strings.b;
					var rest = _v1.a;
					return head + (' ' + (separator + (' ' + rest)));
				} else {
					var first = strings.a;
					var rest = strings.b;
					return first + (', ' + A2($author$project$Common$StringUtils$joinWithCommas, separator, rest));
				}
			}
		}
	});
var $author$project$Translations$recordingDisclaimerModalAncillarySentenceJoinWord = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'And';
	} else {
		return 'Y';
	}
};
var $author$project$Translations$recordingDisclaimerModalAncillarySentencePrefixSingluar = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'In addition, you have contracted the extra coverage of';
	} else {
		return 'Además has contratado la cobertura extra de';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$selectedAncillariesText = F2(
	function (i18n, selectedAncillaries) {
		if (!selectedAncillaries.b) {
			return '';
		} else {
			var ancillaries = selectedAncillaries;
			return $author$project$Translations$recordingDisclaimerModalAncillarySentencePrefixSingluar(i18n) + (' ' + ($elm$core$String$toLower(
				A2(
					$author$project$Common$StringUtils$joinWithCommas,
					$author$project$Translations$recordingDisclaimerModalAncillarySentenceJoinWord(i18n),
					A2(
						$elm$core$List$map,
						function (ancillary) {
							return ancillary.nz(i18n);
						},
						ancillaries))) + '.'));
		}
	});
var $author$project$Common$Price$toStringNoSpaceSignLast = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		return _Utils_ap(
			A2($author$project$Common$Price$toAmountString, i18n, amount),
			$author$project$Common$Price$pickSign);
	});
var $author$project$Common$Offer$totalPrice = function (_v0) {
	var offer = _v0;
	return offer.dx.mz.nl;
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultContent = F3(
	function (i18n, offer, coverSelection) {
		return A3(
			$author$project$Translations$recordingDisclaimerModalContent,
			{
				my: A2($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$selectedAncillariesText, i18n, coverSelection),
				jy: A2(
					$author$project$Common$Product$bundleSlugToString,
					i18n,
					$author$project$Common$Offer$pickSelectedBundle(offer)),
				l_: $author$project$Common$Locale$formatDate(
					$author$project$Common$Offer$pickStartDate(offer)),
				l9: A2(
					$author$project$Common$Price$toStringNoSpaceSignLast,
					i18n,
					$author$project$Common$Offer$totalPrice(offer))
			},
			{
				kr: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__subtitle')
					]),
				ln: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__paragraph')
					]),
				l1: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__strong')
					])
			},
			i18n);
	});
var $author$project$Translations$recordingDisclaimerModalPreAncillaryContent = F3(
	function (data, extraAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('\"I confirm that you will take out an insurance policy ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.jy)
								])),
							$elm$html$Html$text('), which covers: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text('compulsory and voluntary civil liability, 24-hour travel assistance with no km limit, free choice of garage, driver protection, legal defence and damage claims / windows, theft, fire / own damage with an excess of €200.')
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Drivers under 26 years of age and with less than 2 years of driving licence are not covered, unless explicitly declared.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment will be made today but the insurance will take effect on '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l_)
								])),
							$elm$html$Html$text('. The total price for your insurance is '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l9)
								])),
							$elm$html$Html$text(', including insurance premium tax and statutory surcharges.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('You have 14 days to exercise your right of withdrawal, in which case the unearned premium will be refunded. You can find information on how to proceed on our website or contact our customer service.\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kr),
					_List_fromArray(
						[
							$elm$html$Html$text('Call recording protocol')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Pause the recording in Aircall before the customer\'s bank details and remember to resume it afterwards.')
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('\"Te confirmo que contratarás un seguro a ('),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.jy)
								])),
							$elm$html$Html$text('), que cubre: '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text('responsabilidad civil obligatoria y voluntaria, asistencia en viaje 24 h sin límite de km, libre elección de taller, protección al conductor, defensa jurídica y reclamación de daños / lunas, robo, incendio / daños propios con franquicia 200€.')
								]))
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Los conductores menores de 26 años o con menos de 2 años de antigüedad de carnet no están cubiertos, salvo que estén declarados de manera explícita.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('El pago se realizará hoy pero el seguro entrará en vigor el '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l_)
								])),
							$elm$html$Html$text('. El precio de su seguro es de '),
							A3(
							$elm$html$Html$node,
							'strong',
							_Utils_ap(_List_Nil, extraAttrs.l1),
							_List_fromArray(
								[
									$elm$html$Html$text(data.l9)
								])),
							$elm$html$Html$text(', e incluye el Impuesto sobre las Primas de Seguros y los recargos legales.')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Tienes 14 días para ejercer el derecho de desistimiento, y en ese caso se te devolverá la prima no consumida. Puedes encontrar la información sobre cómo proceder en nuestra página web o contactar con nuestro servicio de atención al cliente\"')
						])),
					A3(
					$elm$html$Html$node,
					'h2',
					_Utils_ap(_List_Nil, extraAttrs.kr),
					_List_fromArray(
						[
							$elm$html$Html$text('Protocolo de grabación de llamadas')
						])),
					A3(
					$elm$html$Html$node,
					'p',
					_Utils_ap(_List_Nil, extraAttrs.ln),
					_List_fromArray(
						[
							$elm$html$Html$text('Pausa la grabación en Aircall antes de los datos bancarios del cliente y recuerda reanudarla luego.')
						]))
				]);
		}
	});
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$preAncillaryContent = F2(
	function (i18n, offer) {
		return A3(
			$author$project$Translations$recordingDisclaimerModalPreAncillaryContent,
			{
				jy: A2(
					$author$project$Common$Product$bundleSlugToString,
					i18n,
					$author$project$Common$Offer$pickSelectedBundle(offer)),
				l_: $author$project$Common$Locale$formatDate(
					$author$project$Common$Offer$pickStartDate(offer)),
				l9: A2(
					$author$project$Common$Price$toStringNoSpaceSignLast,
					i18n,
					$author$project$Common$Offer$totalPrice(offer))
			},
			{
				kr: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__subtitle')
					]),
				ln: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__paragraph')
					]),
				l1: _List_fromArray(
					[
						$elm$html$Html$Attributes$class('recording-disclaimer-modal__strong')
					])
			},
			i18n);
	});
var $author$project$Translations$recordingDisclaimerModalRenewalContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Pause the recording in Aircall before the customer\'s bank details and remember to resume it afterwards.';
	} else {
		return 'Pausa la grabación en Aircall antes de los datos bancarios del cliente y recuerda reanudarla luego.';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalContent = A2(
	$elm$core$Basics$composeR,
	$author$project$Translations$recordingDisclaimerModalRenewalContent,
	A2($elm$core$Basics$composeR, $elm$html$Html$text, $elm$core$List$singleton));
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$content = F3(
	function (i18n, offer, coverSelection) {
		if ($author$project$Common$Offer$pickIsRenewal(offer)) {
			return $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalContent(i18n);
		} else {
			var _v0 = coverSelection.mx;
			if (!_v0.$) {
				return A2($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$preAncillaryContent, i18n, offer);
			} else {
				var selectedAncillaries = _v0.a;
				return A3($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultContent, i18n, offer, selectedAncillaries);
			}
		}
	});
var $author$project$Translations$recordingDisclaimerModalButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase Offer';
	} else {
		return 'Comprar Oferta';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$footer = F2(
	function (i18n, msg) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withTestId,
						'purchase-button',
						A2(
							$author$project$Pyxis$Components$Button$withId,
							'purchase-button',
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$recordingDisclaimerModalButtonText(i18n),
								A2($author$project$Pyxis$Components$Button$withOnClick, msg, $author$project$Pyxis$Components$Button$primary)))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Pyxis$Components$IconSet$svgHomeLegalProtection = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12.65 21.72c-.21.07-.42.11-.65.11-.22 0-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04c1.26 1.1 3.5 2.48 7 2.85v6.81l1.96 1.13c.05-.51.04-.83.04-.83V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39-.37-.33-.83-.49-1.3-.49a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.94 2.39C3.75 4.02 3 4.88 3 5.89V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22s.89-.07 1.31-.22c2.68-.94 4.41-2.46 5.55-4.07l-1.75-1.01c-.94 1.27-2.34 2.45-4.46 3.19zm8.95-5.21l-5.63-3.25.5-.87a3 3 0 0 0-1.1-4.1l-.87-.5c-.47-.27-.99-.4-1.5-.4-1.04 0-2.05.54-2.6 1.5l-2 3.46a3 3 0 0 0 1.1 4.1l.87.5c.47.27.99.4 1.5.4 1.04 0 2.05-.54 2.6-1.5l.5-.87 5.63 3.25a1.01 1.01 0 0 0 .5.13c.35 0 .68-.18.87-.5.27-.46.1-1.07-.37-1.35zm-8.87-1.65c-.18.31-.51.5-.87.5-.18 0-.34-.05-.5-.13l-.87-.5c-.31-.18-.43-.46-.47-.61a1 1 0 0 1 .1-.76l2-3.46c.18-.31.51-.5.87-.5.18 0 .34.05.5.13l.87.5c.31.18.43.46.47.61a1 1 0 0 1-.1.76l-2 3.46z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$homeLegalProtection = {eY: 'home-legal-protection', a: $author$project$Pyxis$Components$IconSet$svgHomeLegalProtection};
var $author$project$Translations$recordingDisclaimerModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Legal Text';
	} else {
		return 'Texto Legal';
	}
};
var $author$project$Pyxis$Tokens$TypographyColor$Brand = 2;
var $author$project$Pyxis$Tokens$TypographyColor$tokenBrand = 2;
var $author$project$Pyxis$Components$Icon$withColor = F2(
	function (color, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eg: $elm$core$Maybe$Just(color)
			});
	});
var $author$project$Pyxis$Components$Modal$Header$withIcon = F2(
	function (icon, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				ku: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultHeader = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withIcon,
		A2(
			$author$project$Pyxis$Components$Icon$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
			$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$homeLegalProtection)),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$recordingDisclaimerModalTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Pyxis$Components$IconSet$svgPhone = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M17.02 21.68c-.28 0-.56-.03-.83-.09A17.98 17.98 0 0 1 2.41 7.81 3.88 3.88 0 0 1 3.2 4.5C3.97 3.55 5.11 3 6.33 3h1.03c1.42 0 2.66 1.01 2.94 2.41l.47 2.34c.2.99-.11 2-.82 2.71.94 1.42 2.14 2.65 3.52 3.68l-.01-.02.08-.08c.71-.71 1.72-1.01 2.71-.82l2.34.47c1.4.28 2.41 1.52 2.41 2.94v1.03c0 1.22-.55 2.36-1.5 3.13a3.87 3.87 0 0 1-2.48.89zM6.33 5a1.98 1.98 0 0 0-1.57.75 1.95 1.95 0 0 0-.4 1.64 16.01 16.01 0 0 0 12.25 12.25c.58.13 1.17-.02 1.64-.4a2.01 2.01 0 0 0 .75-1.57v-1.03a1 1 0 0 0-.8-.98l-2.34-.47a.99.99 0 0 0-.9.27l-.08.08c-.7.7-1.81.79-2.59.21-1.55-1.15-2.9-2.54-4.01-4.11-.57-.79-.47-1.87.22-2.56.27-.27.37-.61.31-.94L8.34 5.8a1 1 0 0 0-.98-.8H6.33z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$phone = {eY: 'phone', a: $author$project$Pyxis$Components$IconSet$svgPhone};
var $author$project$Translations$recordingDisclaimerModalRenewalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Call recording protocol';
	} else {
		return 'Protocolo de grabación de llamadas';
	}
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalHeader = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withIcon,
		A2(
			$author$project$Pyxis$Components$Icon$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
			$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$phone)),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$recordingDisclaimerModalRenewalTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$header = F2(
	function (i18n, offer) {
		return $author$project$Common$Offer$pickIsRenewal(offer) ? $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$renewalHeader(i18n) : $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$defaultHeader(i18n);
	});
var $author$project$Pyxis$Components$Modal$L = 2;
var $author$project$Pyxis$Components$Modal$sizeL = 2;
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$size = function (offer) {
	return $author$project$Common$Offer$pickIsRenewal(offer) ? $author$project$Pyxis$Components$Modal$sizeS : $author$project$Pyxis$Components$Modal$sizeL;
};
var $author$project$Pyxis$Components$Modal$withTestId = F2(
	function (id, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				fz: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Common$ComponentUI$Modal$RecordingDisclaimer$render = F6(
	function (offer, coverSelection, i18n, closeMsg, ctaMsg, modalMessage) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modalMessage,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2(
					$author$project$Common$ComponentUI$Modal$RecordingDisclaimer$footer,
					i18n,
					ctaMsg(offer)),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A3($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$content, i18n, offer, coverSelection),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						A2($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$header, i18n, offer),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							closeMsg,
							'',
							A2(
								$author$project$Pyxis$Components$Modal$withSize,
								$author$project$Common$ComponentUI$Modal$RecordingDisclaimer$size(offer),
								A2($author$project$Pyxis$Components$Modal$withTestId, 'stop-recording-disclaimer-modal', $author$project$Pyxis$Components$Modal$config)))))));
	});
var $author$project$Pyxis$Components$Loaders$Loader$getModifierClassForVariant = function (variant) {
	if (variant.$ === 1) {
		if (!variant.a) {
			var _v1 = variant.a;
			return 'loader--with-car';
		} else {
			var _v2 = variant.a;
			return 'loader--s';
		}
	} else {
		if (variant.a === 1) {
			var _v3 = variant.a;
			return 'loader--s';
		} else {
			var _v4 = variant.a;
			return '';
		}
	}
};
var $author$project$Pyxis$Components$Loaders$Loader$getVariantClass = function (variant) {
	if (variant.$ === 1) {
		return 'loader__car';
	} else {
		return 'loader__spinner';
	}
};
var $author$project$Pyxis$Components$Loaders$Loader$isCar = function (variant) {
	if (variant.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Pyxis$Components$Loaders$LoaderCar$renderSvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
			$elm$svg$Svg$Attributes$class('loader__car__items-wrapper'),
			$elm$svg$Svg$Attributes$viewBox('0 0 33 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip0_104_19465)'),
					$elm$svg$Svg$Attributes$class('loader__car__body')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M22.1998 10.5H17.3997C16.8497 10.5 16.3998 10.05 16.3998 9.5C16.3998 8.95 16.8497 8.5 17.3997 8.5H22.1998C22.7498 8.5 23.1998 8.95 23.1998 9.5C23.1998 10.05 22.7498 10.5 22.1998 10.5ZM30.7798 10L26.6798 8.9L25.5798 7C25.0398 6.07 24.0498 5.5 22.9798 5.5H14.8398C14.0398 5.5 13.2798 5.82 12.7198 6.38L10.2198 8.88C9.45975 9.64 9.16975 10.74 9.43975 11.78L10.1098 14.28C10.2814 14.9176 10.6587 15.4808 11.183 15.8821C11.7073 16.2835 12.3494 16.5007 13.0098 16.5H13.8698V14.5H13.0098C12.5598 14.5 12.1598 14.2 12.0398 13.76L11.3698 11.26C11.2798 10.92 11.3698 10.55 11.6298 10.29L14.1298 7.79C14.2229 7.69687 14.3336 7.62325 14.4555 7.57345C14.5774 7.52366 14.7081 7.49869 14.8398 7.5H22.9798C23.3398 7.5 23.6698 7.69 23.8498 8L24.9498 9.9C25.2198 10.36 25.6498 10.69 26.1598 10.83L30.2598 11.93C30.6998 12.05 30.9998 12.44 30.9998 12.9V13.5C30.9998 14.05 30.5498 14.5 29.9998 14.5H29.1098V16.5H29.9998C31.6598 16.5 32.9998 15.16 32.9998 13.5V12.9C33.0005 12.2397 32.7833 11.5976 32.3819 11.0733C31.9805 10.5489 31.4174 10.1717 30.7798 10ZM16.0998 14.5H26.8798V16.5H16.0998V14.5Z')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('loader__car__wheel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M15 15C15.55 15 16 15.45 16 16C16 16.55 15.55 17 15 17C14.45 17 14 16.55 14 16C14 15.45 14.45 15 15 15ZM15 13C13.34 13 12 14.34 12 16C12 17.66 13.34 19 15 19C16.66 19 18 17.66 18 16C18 14.34 16.66 13 15 13Z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M28 15C28.55 15 29 15.45 29 16C29 16.55 28.55 17 28 17C27.45 17 27 16.55 27 16C27 15.45 27.45 15 28 15ZM28 13C26.34 13 25 14.34 25 16C25 17.66 26.34 19 28 19C29.66 19 31 17.66 31 16C31 14.34 29.66 13 28 13Z')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip1_104_19465)'),
					$elm$svg$Svg$Attributes$class('loader__car__line loader__car__line--top')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M1 11H2'),
							$elm$svg$Svg$Attributes$strokeWidth('2'),
							$elm$svg$Svg$Attributes$strokeLinecap('round')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$clipPath('url(#clip2_104_19465)'),
					$elm$svg$Svg$Attributes$class('loader__car__line loader__car__line--bottom')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M1 15H6'),
							$elm$svg$Svg$Attributes$strokeWidth('2'),
							$elm$svg$Svg$Attributes$strokeLinecap('round')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip0_104_19465')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('24'),
									$elm$svg$Svg$Attributes$height('24'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(9)')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip1_104_19465')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('3'),
									$elm$svg$Svg$Attributes$height('2'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0 10)')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('clip2_104_19465')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$rect,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width('7'),
									$elm$svg$Svg$Attributes$height('2'),
									$elm$svg$Svg$Attributes$fill('white'),
									$elm$svg$Svg$Attributes$transform('translate(0 14)')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Pyxis$Components$Loaders$Loader$renderText = function (text) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loader__text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$Pyxis$Components$Loaders$Loader$renderTitle = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loader__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pyxis$Components$Loaders$Loader$renderTextBlock = F3(
	function (isHiddenText, title, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loader__text-wrapper', true),
							_Utils_Tuple2('sr-only', isHiddenText)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Loaders$Loader$renderTitle, title),
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Loaders$Loader$renderText, label)
				]));
	});
var $author$project$Pyxis$Components$Loaders$Loader$render = function (_v0) {
	var variant = _v0.jd;
	var classList = _v0.ga;
	var id = _v0.kv;
	var testId = _v0.fz;
	var dataAttrList = _v0.ep;
	var isHiddenText = _v0.eQ;
	var title = _v0.i4;
	var text = _v0.pK;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('loader', true),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Loaders$Loader$getModifierClassForVariant(variant),
								true)
							]),
						classList)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					$author$project$Pyxis$Commons$Attributes$ariaLivePolite
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						$author$project$Pyxis$Components$Loaders$Loader$getVariantClass(variant))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Commons$Render$renderIf,
						$author$project$Pyxis$Components$Loaders$Loader$isCar(variant),
						$author$project$Pyxis$Components$Loaders$LoaderCar$renderSvg)
					])),
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				$elm_community$maybe_extra$Maybe$Extra$isJust(text) || $elm_community$maybe_extra$Maybe$Extra$isJust(title),
				A3($author$project$Pyxis$Components$Loaders$Loader$renderTextBlock, isHiddenText, title, text))
			]));
};
var $author$project$Pyxis$Components$Loaders$Loader$M = 0;
var $author$project$Pyxis$Components$Loaders$Loader$Spinner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Loaders$Loader$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Loaders$Loader$config = function (variant) {
	return {ga: _List_Nil, ep: _List_Nil, kv: $elm$core$Maybe$Nothing, eQ: false, fz: $elm$core$Maybe$Nothing, pK: $elm$core$Maybe$Nothing, i4: $elm$core$Maybe$Nothing, jd: variant};
};
var $author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM = $author$project$Pyxis$Components$Loaders$Loader$config(
	$author$project$Pyxis$Components$Loaders$Loader$Spinner(0));
var $author$project$Page$OfferDetails$Msg$AmendOfferCoverageEffectiveDate = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Page$OfferDetails$Msg$PurchaseOfferButtonPressed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Common$Render$empty = $elm_community$html_extra$Html$Extra$nothing;
var $author$project$Common$Render$ifCondition = F2(
	function (content, condition) {
		return condition ? content : $author$project$Common$Render$empty;
	});
var $author$project$Common$Offer$isOfferGreatLakesRenewal = function (_v0) {
	var offer = _v0;
	return offer.g6;
};
var $author$project$Common$CoverContinuity$CurrentInsuranceInfo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Portfolio$Config = $elm$core$Basics$identity;
var $author$project$Common$Portfolio$config = function (vehicleOwner) {
	return function (mainDriver) {
		return function (additionalDriver) {
			return function (policyHolder) {
				return function (vehicle) {
					return function (claimsHistory) {
						return function (coversData) {
							return function (selectedBundleSlug) {
								return function (customerId) {
									return function (coverSelection) {
										return function (editAncillaryCoversUrl) {
											return {jq: additionalDriver, jH: claimsHistory, jZ: coverSelection, j$: coversData, gm: customerId, j8: editAncillaryCoversUrl, kP: mainDriver, hS: $elm$core$Maybe$Nothing, io: policyHolder, lS: selectedBundleSlug, je: vehicle, me: vehicleOwner};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Common$Offer$pickEditAncillaryCoversAction = function (action) {
	if (action.$ === 5) {
		var maybeUrl = action.a;
		return maybeUrl;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Common$Offer$mayEditAncillaryCovers = $author$project$Common$Offer$filterActionValue($author$project$Common$Offer$pickEditAncillaryCoversAction);
var $author$project$Page$OfferDetails$Model$pickCustomerId = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.gm;
	},
	A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$toMaybe, $elm_community$maybe_extra$Maybe$Extra$join));
var $author$project$Common$Offer$pickData = function (_v0) {
	var offer = _v0;
	return offer;
};
var $author$project$Page$OfferDetails$View$portfolioConfig = F2(
	function (model, offer) {
		var _v0 = $author$project$Common$Offer$pickData(offer);
		var vehicleOwner = _v0.me;
		var mainDriver = _v0.kP;
		var additionalDriver = _v0.jq;
		var policyHolder = _v0.io;
		var vehicle = _v0.je;
		var coverContinuity = _v0.jX;
		var selectedBundle = _v0.iK;
		return $author$project$Common$Portfolio$config(vehicleOwner)(mainDriver)(additionalDriver)(policyHolder)(vehicle)(model.cM)(
			$author$project$Common$CoverContinuity$CurrentInsuranceInfo(coverContinuity))(selectedBundle)(
			$author$project$Page$OfferDetails$Model$pickCustomerId(model))(model.jZ)(
			$author$project$Common$Offer$mayEditAncillaryCovers(offer));
	});
var $author$project$Common$Portfolio$OuterTabsChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Tabs$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$Left = 0;
var $author$project$Pyxis$Components$Tabs$Slide = 0;
var $author$project$Pyxis$Components$Tabs$Underline = 0;
var $author$project$Pyxis$Components$Tabs$underline = 0;
var $author$project$Pyxis$Components$Tabs$config = function (id) {
	return {d0: $elm$core$Maybe$Nothing, ga: _List_Nil, gl: $elm$core$Maybe$Nothing, ep: _List_Nil, gT: false, kv: id, ih: 0, aa: 0, dP: _List_Nil, fz: $elm$core$Maybe$Nothing, jd: $author$project$Pyxis$Components$Tabs$underline};
};
var $author$project$Pyxis$Components$IconSet$svgChart = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 3c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h16m0-2H4C2.34 1 1 2.34 1 4v16c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3h0zM7 18h0c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1zm5 0h0c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1zm5 0h0c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h0c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$chart = {eY: 'chart', a: $author$project$Pyxis$Components$IconSet$svgChart};
var $author$project$Translations$detailsPortfolioCoverLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover';
	} else {
		return 'Coberturas';
	}
};
var $author$project$Translations$detailsPortfolioDataLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Data';
	} else {
		return 'Datos';
	}
};
var $author$project$Pyxis$Components$Grid$Col = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Col$buildConfiguration = F2(
	function (options, config) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, c) {
					var mapper = _v0;
					return mapper(c);
				}),
			config,
			options);
	});
var $author$project$Pyxis$Components$Grid$SpanSize$Span1 = 0;
var $author$project$Pyxis$Components$Grid$SpanSize$span1 = 0;
var $author$project$Pyxis$Tokens$Breakpoint$Base = 0;
var $author$project$Pyxis$Tokens$Breakpoint$tokenBase = 0;
var $author$project$Pyxis$Components$Grid$initialColConfiguration = {a_: $author$project$Pyxis$Tokens$Breakpoint$tokenBase, cJ: $author$project$Pyxis$Components$Grid$SpanSize$span1, ah: _List_Nil, ga: _List_Nil, dD: $author$project$Pyxis$Components$Grid$SpanSize$span1};
var $author$project$Pyxis$Components$Grid$col = F2(
	function (options, children) {
		var configuration = A2($author$project$Pyxis$Components$Grid$Col$buildConfiguration, options, $author$project$Pyxis$Components$Grid$initialColConfiguration);
		return {a_: configuration.a_, cJ: configuration.cJ, ah: children, ga: configuration.ga, dD: configuration.dD};
	});
var $author$project$Common$CoverContinuity$getCoverContinuityInfo = function (coverContinuity) {
	if (!coverContinuity.$) {
		var info = coverContinuity.a;
		return info;
	} else {
		var info = coverContinuity.a;
		return info;
	}
};
var $author$project$Common$CoverContinuity$hasPreviousCoverage = function (coverContinuityInfo) {
	var _v0 = $author$project$Common$CoverContinuity$getCoverContinuityInfo(coverContinuityInfo);
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Translations$detailsCurrentInsurerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Current insurer';
	} else {
		return 'Aseguradora Actual';
	}
};
var $author$project$Translations$detailsPreviousInsurer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Previous insurer';
	} else {
		return 'Aseguradora anterior';
	}
};
var $author$project$Pyxis$Components$Text$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Commons$TagBuilder$p = 'p';
var $author$project$Pyxis$Tokens$TextSize$TextSizeM = 1;
var $author$project$Pyxis$Tokens$TextSize$tokenM = 1;
var $author$project$Pyxis$Components$Text$config = function (content) {
	return {ga: _List_Nil, eg: $elm$core$Maybe$Nothing, a0: content, ep: _List_Nil, gG: $author$project$Pyxis$Tokens$FontWeight$tokenBook, kv: $elm$core$Maybe$Nothing, hp: _List_Nil, iJ: _List_Nil, aR: $author$project$Pyxis$Tokens$TextSize$tokenM, i_: $author$project$Pyxis$Commons$TagBuilder$p, fz: $elm$core$Maybe$Nothing};
};
var $author$project$Translations$coversSummaryPendingCoversInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Previous policy information is not available until it’s entered by the customer or agent.';
	} else {
		return 'La información sobre pólizas anteriores no está disponible hasta que el cliente o el agente la introduzca.';
	}
};
var $author$project$Translations$coversSummaryWithNoCoversInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The information about previous policies is not available for this client, as we didn’t request this data at the time of their registration.';
	} else {
		return 'La información sobre pólizas anteriores no está disponible para este cliente, ya que no hemos solicitado estos datos al momento de su registro.';
	}
};
var $author$project$Translations$coversTercerosBasicoSummaryInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'This package does not provide other covers.';
	} else {
		return 'Este paquete no proporciona otras coberturas.';
	}
};
var $author$project$Translations$coversCurrentCover = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Current cover';
	} else {
		return 'Cobertura actual';
	}
};
var $author$project$Pyxis$Components$List$withItemAddonNone = function (_v0) {
	var itemConfig = _v0;
	return _Utils_update(
		itemConfig,
		{mu: $elm$core$Maybe$Nothing});
};
var $author$project$Pyxis$Components$List$withItemText = F2(
	function (text, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{
				pK: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Common$CoverContinuity$createInsurerInfoListItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemTitle,
				title,
				A2(
					$author$project$Pyxis$Components$List$withItemText,
					$elm$html$Html$text(text),
					$author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$CoverContinuity$currentCoverListItem = F3(
	function (i18n, bundleSlug, company) {
		if (!company.$) {
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Common$CoverContinuity$createInsurerInfoListItem,
					$author$project$Translations$coversCurrentCover(i18n),
					A2($author$project$Common$Product$bundleSlugToString, i18n, bundleSlug)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$coversDanosProprios = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Daños propios';
	} else {
		return 'Daños propios';
	}
};
var $author$project$Pyxis$Components$IconSet$svgCrossCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0zm1.41 12l2.48-2.48c.39-.39.39-1.02 0-1.41s-1.02-.39-1.41 0L12 10.59 9.52 8.11c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L10.59 12l-2.48 2.48c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L12 13.41l2.48 2.48c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L13.41 12z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$crossCircle = {eY: 'cross-circle', a: $author$project$Pyxis$Components$IconSet$svgCrossCircle};
var $author$project$Common$CoverContinuity$coverContinuityIcon = function (thereIsCoverContinuity) {
	return thereIsCoverContinuity ? A2(
		$author$project$Pyxis$Components$Icon$withColor,
		$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
		$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$checkCircle)) : A2(
		$author$project$Pyxis$Components$Icon$withColor,
		$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
		$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$crossCircle));
};
var $author$project$Common$CoverContinuity$declaredCoverListItem = F2(
	function (title, hasCover) {
		return A2(
			$author$project$Pyxis$Components$List$withItemAddonIcon,
			A2(
				$author$project$Pyxis$Components$Icon$withSize,
				$author$project$Pyxis$Components$Icon$sizeM,
				$author$project$Common$CoverContinuity$coverContinuityIcon(hasCover)),
			A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item));
	});
var $author$project$Common$CoverContinuity$danosPropriosCoverListItem = F2(
	function (i18n, danosProprios) {
		return A2(
			$author$project$Common$CoverContinuity$declaredCoverListItem,
			$author$project$Translations$coversDanosProprios(i18n),
			danosProprios);
	});
var $author$project$Pyxis$Components$Message$Neutral = 0;
var $author$project$Pyxis$Components$Message$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Message$defaultIcon = function (variant) {
	switch (variant) {
		case 1:
			return $author$project$Pyxis$Components$IconSet$thumbUp;
		case 3:
			return $author$project$Pyxis$Components$IconSet$checkCircle;
		case 2:
			return $author$project$Pyxis$Components$IconSet$exclamationTriangle;
		case 4:
			return $author$project$Pyxis$Components$IconSet$exclamationCircle;
		case 5:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
		case 0:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
		default:
			return $author$project$Pyxis$Components$IconSet$infoCircle;
	}
};
var $author$project$Pyxis$Components$Message$config = F2(
	function (variant, style) {
		return {
			cK: $elm$core$Maybe$Nothing,
			ga: _List_Nil,
			a0: _List_Nil,
			ep: _List_Nil,
			ku: $author$project$Pyxis$Components$Message$defaultIcon(variant),
			kv: $elm$core$Maybe$Nothing,
			hZ: $elm$core$Maybe$Nothing,
			dG: style,
			fz: $elm$core$Maybe$Nothing,
			i4: $elm$core$Maybe$Nothing,
			jd: variant
		};
	});
var $author$project$Pyxis$Components$Message$neutral = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 0, style);
};
var $author$project$Pyxis$Components$Message$Bottom = 1;
var $author$project$Pyxis$Components$Message$getMessageStyleClass = function (style) {
	switch (style) {
		case 0:
			return 'message--background-surface-strong';
		case 1:
			return 'message--background-surface-on-surface-strong';
		default:
			return 'message--background-tint';
	}
};
var $author$project$Pyxis$Components$Message$getMessageVariantClass = function (variant) {
	switch (variant) {
		case 1:
			return 'message--brand';
		case 3:
			return 'message--success';
		case 2:
			return 'message--alert';
		case 4:
			return 'message--error';
		case 5:
			return 'message--ghost';
		case 6:
			return 'message--informative';
		default:
			return '';
	}
};
var $author$project$Pyxis$Components$Message$getRole = function (variant) {
	if (variant === 4) {
		return 'alert';
	} else {
		return 'status';
	}
};
var $author$project$Pyxis$Components$Message$renderButton = function (buttonConfig) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__button')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Button$render(buttonConfig)
			]));
};
var $author$project$Pyxis$Components$Message$renderClose = function (_v0) {
	var onDismiss = _v0.hZ;
	var ariaLabel = _v0.fZ;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__close'),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Events$onClick(onDismiss),
				$author$project$Pyxis$Commons$Attributes$ariaLabel(ariaLabel)
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$cross))
			]));
};
var $author$project$Pyxis$Components$Message$renderTitle = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pyxis$Components$Message$render = function (_v0) {
	var button = _v0.cK;
	var classList = _v0.ga;
	var icon = _v0.ku;
	var dataAttrList = _v0.ep;
	var id = _v0.kv;
	var testId = _v0.fz;
	var content = _v0.a0;
	var title = _v0.i4;
	var onDismiss = _v0.hZ;
	var style = _v0.dG;
	var variant = _v0.jd;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('message', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Message$getMessageStyleClass(style),
							true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Message$getMessageVariantClass(variant),
							true),
							_Utils_Tuple2(
							'message--dismissable',
							$elm_community$maybe_extra$Maybe$Extra$isJust(onDismiss)),
							_Utils_Tuple2(
							'message--with-button',
							$elm_community$maybe_extra$Maybe$Extra$isJust(button)),
							_Utils_Tuple2(
							'message--with-button-bottom',
							_Utils_eq(
								A2($elm$core$Maybe$map, $elm$core$Tuple$second, button),
								$elm$core$Maybe$Just(1)))
						])),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					$author$project$Pyxis$Commons$Attributes$role(
					$author$project$Pyxis$Components$Message$getRole(variant))
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__icon')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Icon$render(
						$author$project$Pyxis$Components$Icon$config(icon))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('message__wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__content-wrapper')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybe(
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Message$renderTitle, title)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message__text')
									]),
								content)
							])),
						A2(
						$author$project$Pyxis$Commons$Render$maybeMapRender,
						$author$project$Pyxis$Components$Message$renderButton,
						A2($elm$core$Maybe$map, $elm$core$Tuple$first, button))
					])),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Message$renderClose, onDismiss))
			]));
};
var $author$project$Pyxis$Components$Message$SurfaceStrong = 0;
var $author$project$Pyxis$Components$Message$surfaceStrongBackground = 0;
var $author$project$Pyxis$Components$Message$withContent = F2(
	function (htmlText, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{a0: htmlText});
	});
var $author$project$Common$CoverContinuity$declaredCoverMessage = function (text) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('covers__declared-cover')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Message$render(
				A2(
					$author$project$Pyxis$Components$Message$withContent,
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]),
					$author$project$Pyxis$Components$Message$neutral($author$project$Pyxis$Components$Message$surfaceStrongBackground)))
			]));
};
var $author$project$Common$CoverContinuity$getCompanyName = function (company) {
	if (!company.$) {
		return 'Prima';
	} else {
		var companyName = company.a;
		return companyName;
	}
};
var $author$project$Common$CoverContinuity$insurerNameListItem = F2(
	function (title, insurerName) {
		return A2($author$project$Common$CoverContinuity$createInsurerInfoListItem, title, insurerName);
	});
var $author$project$Translations$coversLunas = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Lunas';
	} else {
		return 'Lunas';
	}
};
var $author$project$Common$CoverContinuity$lunasCoverListItem = F2(
	function (i18n, lunas) {
		return A2(
			$author$project$Common$CoverContinuity$declaredCoverListItem,
			$author$project$Translations$coversLunas(i18n),
			lunas);
	});
var $author$project$Pyxis$Tokens$TextSize$toString = function (textSize) {
	switch (textSize) {
		case 0:
			return 'l';
		case 1:
			return 'm';
		default:
			return 's';
	}
};
var $author$project$Pyxis$Components$Text$baseClass = F2(
	function (size, fontWeight) {
		return $elm$html$Html$Attributes$class(
			A2(
				$elm$core$String$join,
				'-',
				_List_fromArray(
					[
						'text',
						$author$project$Pyxis$Tokens$TextSize$toString(size),
						$author$project$Pyxis$Tokens$FontWeight$toString(fontWeight)
					])));
	});
var $author$project$Pyxis$Components$Text$marginClassList = function (margins) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Commons$Attributes$Margin$toClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			margins));
};
var $author$project$Pyxis$Components$Text$responsiveSizeClass = function (responsiveSize) {
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			[
				'text',
				$author$project$Pyxis$Tokens$TextSize$toString(
				$author$project$Pyxis$Commons$Responsive$pickPropertyValue(responsiveSize)),
				'from',
				$author$project$Pyxis$Tokens$Breakpoint$toString(
				$author$project$Pyxis$Commons$Responsive$pickBreakpoint(responsiveSize))
			]));
};
var $author$project$Pyxis$Components$Text$responsiveSizeClassList = function (responsiveSizes) {
	return $elm$html$Html$Attributes$classList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Text$responsiveSizeClass,
				A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true)),
			responsiveSizes));
};
var $author$project$Pyxis$Components$Text$render = function (_v0) {
	var content = _v0.a0;
	var margins = _v0.hp;
	var id = _v0.kv;
	var classList = _v0.ga;
	var testId = _v0.fz;
	var dataAttrList = _v0.ep;
	var color = _v0.eg;
	var tag = _v0.i_;
	var fontWeight = _v0.gG;
	var size = _v0.aR;
	var responsiveSize = _v0.iJ;
	return A3(
		$elm$html$Html$node,
		$author$project$Pyxis$Commons$TagBuilder$unwrap(tag),
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					A2($author$project$Pyxis$Components$Text$baseClass, size, fontWeight),
					$author$project$Pyxis$Components$Text$responsiveSizeClassList(responsiveSize),
					$author$project$Pyxis$Components$Text$marginClassList(margins),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$typographyColorClass, color)
				])),
		_List_fromArray(
			[content]));
};
var $author$project$Translations$coversDeclaredCoverTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Declared covers';
	} else {
		return 'Coberturas declaradas';
	}
};
var $author$project$Pyxis$Tokens$TypographyColor$ContentWeak = 17;
var $author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak = 17;
var $author$project$Pyxis$Tokens$TextSize$TextSizeL = 0;
var $author$project$Pyxis$Tokens$TextSize$tokenL = 0;
var $author$project$Pyxis$Components$Text$withColor = F2(
	function (color, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eg: $elm$core$Maybe$Just(color)
			});
	});
var $author$project$Pyxis$Components$Text$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Common$CoverContinuity$renderDeclaredCoversTitle = function (i18n) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
			A2(
				$author$project$Pyxis$Components$Text$withSize,
				$author$project$Pyxis$Tokens$TextSize$tokenL,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(
						$author$project$Translations$coversDeclaredCoverTitle(i18n))))));
};
var $author$project$Common$CoverContinuity$renderDeclaredCoversBox = F2(
	function (i18n, html) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__declared-covers')
				]),
			_List_fromArray(
				[
					$author$project$Common$CoverContinuity$renderDeclaredCoversTitle(i18n),
					html
				]));
	});
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Common$CoverContinuity$renderInsurerInfoList = F2(
	function (insurerNameItem, currentCoverItem) {
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withEmphasis,
				$author$project$Pyxis$Components$List$emphasisText,
				A2(
					$author$project$Pyxis$Components$List$withItems,
					A2(
						$elm$core$List$cons,
						insurerNameItem,
						$elm_community$maybe_extra$Maybe$Extra$toList(currentCoverItem)),
					$author$project$Pyxis$Components$List$dl)));
	});
var $author$project$Common$CoverContinuity$renderCoverContinuityBox = F3(
	function (i18n, _v0, declaredCovers) {
		var insurerName = _v0.a;
		var currentCover = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cover__previous-coverage-container')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$CoverContinuity$renderInsurerInfoList, insurerName, currentCover),
					A2($author$project$Common$CoverContinuity$renderDeclaredCoversBox, i18n, declaredCovers)
				]));
	});
var $author$project$Pyxis$Components$List$Inline = {$: 0};
var $author$project$Pyxis$Components$List$inline = $author$project$Pyxis$Components$List$Inline;
var $author$project$Pyxis$Components$List$ul = $author$project$Pyxis$Components$List$config(0);
var $author$project$Common$CoverContinuity$renderDeclaredCoversList = function (items) {
	return $author$project$Pyxis$Components$List$render(
		A2(
			$author$project$Pyxis$Components$List$withOrientation,
			$author$project$Pyxis$Components$List$inline,
			A2($author$project$Pyxis$Components$List$withItems, items, $author$project$Pyxis$Components$List$ul)));
};
var $author$project$Pyxis$Tokens$FontWeight$FontWeightBold = 0;
var $author$project$Pyxis$Tokens$FontWeight$tokenBold = 0;
var $author$project$Pyxis$Components$Text$withFontWeight = F2(
	function (fontWeight, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gG: fontWeight});
	});
var $author$project$Common$CoverContinuity$renderCoverContinuityInfo = F4(
	function (i18n, referenceTypeText, bundleSlug, coverContinuityInfo) {
		switch (coverContinuityInfo.$) {
			case 2:
				var companyName = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2($author$project$Common$CoverContinuity$insurerNameListItem, referenceTypeText, companyName),
						$elm$core$Maybe$Nothing),
					$author$project$Common$CoverContinuity$declaredCoverMessage(
						$author$project$Translations$coversSummaryWithNoCoversInfo(i18n)));
			case 3:
				var companyName = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2($author$project$Common$CoverContinuity$insurerNameListItem, referenceTypeText, companyName),
						$elm$core$Maybe$Nothing),
					$author$project$Common$CoverContinuity$declaredCoverMessage(
						$author$project$Translations$coversSummaryPendingCoversInfo(i18n)));
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				var company = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(company)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, company)),
					$author$project$Common$CoverContinuity$declaredCoverMessage(
						$author$project$Translations$coversTercerosBasicoSummaryInfo(i18n)));
			case 4:
				var info = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(info.K)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, info.K)),
					$author$project$Common$CoverContinuity$renderDeclaredCoversList(
						_List_fromArray(
							[
								A2($author$project$Common$CoverContinuity$lunasCoverListItem, i18n, info.aK)
							])));
			case 5:
				var info = coverContinuityInfo.a;
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(info.K)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, info.K)),
					$author$project$Common$CoverContinuity$renderDeclaredCoversList(
						_List_fromArray(
							[
								A2($author$project$Common$CoverContinuity$lunasCoverListItem, i18n, info.aK),
								A2($author$project$Common$CoverContinuity$danosPropriosCoverListItem, i18n, info.eF)
							])));
			default:
				var info = coverContinuityInfo.a;
				var declaredCoversInfoBundle = $author$project$Pyxis$Components$Text$render(
					A2(
						$author$project$Pyxis$Components$Text$withSize,
						$author$project$Pyxis$Tokens$TextSize$tokenL,
						A2(
							$author$project$Pyxis$Components$Text$withFontWeight,
							$author$project$Pyxis$Tokens$FontWeight$tokenBold,
							$author$project$Pyxis$Components$Text$config(
								$elm$html$Html$text(info.f4)))));
				return A3(
					$author$project$Common$CoverContinuity$renderCoverContinuityBox,
					i18n,
					_Utils_Tuple2(
						A2(
							$author$project$Common$CoverContinuity$insurerNameListItem,
							referenceTypeText,
							$author$project$Common$CoverContinuity$getCompanyName(info.K)),
						A3($author$project$Common$CoverContinuity$currentCoverListItem, i18n, bundleSlug, info.K)),
					declaredCoversInfoBundle);
		}
	});
var $author$project$Common$CoverContinuity$render = F3(
	function (i18n, bundleSlug, coverContinuity) {
		var _v0 = function () {
			if (!coverContinuity.$) {
				var info = coverContinuity.a;
				return _Utils_Tuple2(
					$author$project$Translations$detailsCurrentInsurerLabel(i18n),
					info);
			} else {
				var info = coverContinuity.a;
				return _Utils_Tuple2(
					$author$project$Translations$detailsPreviousInsurer(i18n),
					info);
			}
		}();
		var referenceTypeText = _v0.a;
		var continuityInfo = _v0.b;
		return A4($author$project$Common$CoverContinuity$renderCoverContinuityInfo, i18n, referenceTypeText, bundleSlug, continuityInfo);
	});
var $author$project$Pyxis$Components$Grid$Gap$M = 1;
var $author$project$Pyxis$Components$Grid$Gap$sizeM = 1;
var $author$project$Pyxis$Components$Grid$initialConfiguration = {ah: _List_Nil, aI: $author$project$Pyxis$Components$Grid$Gap$sizeM};
var $author$project$Pyxis$Components$Grid$getRowColumnsFromClass = function (breakpointType) {
	var breakpoint = $author$project$Pyxis$Tokens$Breakpoint$toString(breakpointType);
	return 'grid__row--from-' + breakpoint;
};
var $author$project$Pyxis$Components$Grid$Row$M = 1;
var $author$project$Pyxis$Components$Grid$Row$isSizeM = $elm$core$Basics$eq(1);
var $author$project$Pyxis$Components$Grid$Row$S = 0;
var $author$project$Pyxis$Components$Grid$Row$isSizeS = $elm$core$Basics$eq(0);
var $author$project$Pyxis$Components$Grid$SpanSize$toInt = function (spanSize) {
	switch (spanSize) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		default:
			return 5;
	}
};
var $author$project$Pyxis$Components$Grid$SpanSize$toString = A2($elm$core$Basics$composeR, $author$project$Pyxis$Components$Grid$SpanSize$toInt, $elm$core$String$fromInt);
var $author$project$Pyxis$Components$Grid$getColumnSpanAtBreakpointClass = F2(
	function (spanSize, breakpointType) {
		var span = $author$project$Pyxis$Components$Grid$SpanSize$toString(spanSize);
		var breakpoint = $author$project$Pyxis$Tokens$Breakpoint$toString(breakpointType);
		return 'grid__row__column--span-' + (span + ('-from-' + breakpoint));
	});
var $author$project$Pyxis$Components$Grid$getColumnSpanClass = function (spanSize) {
	return 'grid__row__column--span-' + $author$project$Pyxis$Components$Grid$SpanSize$toString(spanSize);
};
var $author$project$Pyxis$Components$Grid$renderCol = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2('grid__row__column', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Grid$getColumnSpanClass(configuration.dD),
							true),
							_Utils_Tuple2(
							A2($author$project$Pyxis$Components$Grid$getColumnSpanAtBreakpointClass, configuration.cJ, configuration.a_),
							true)
						]),
					configuration.ga))
			]),
		configuration.ah);
};
var $author$project$Pyxis$Components$Grid$renderRow = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2('grid__row', true),
							_Utils_Tuple2(
							'grid__row--m',
							$author$project$Pyxis$Components$Grid$Row$isSizeM(configuration.aR)),
							_Utils_Tuple2(
							'grid__row--s',
							$author$project$Pyxis$Components$Grid$Row$isSizeS(configuration.aR)),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Grid$getRowColumnsFromClass(configuration.a_),
							true)
						]),
					configuration.ga))
			]),
		A2($elm$core$List$map, $author$project$Pyxis$Components$Grid$renderCol, configuration.ah));
};
var $author$project$Pyxis$Components$Grid$Gap$toString = function (gap) {
	switch (gap) {
		case 0:
			return 's';
		case 1:
			return 'm';
		case 2:
			return 'l';
		case 3:
			return 'xl';
		default:
			return '2xl';
	}
};
var $author$project$Pyxis$Components$Grid$toGapClass = function (gap) {
	return 'grid--gap-' + $author$project$Pyxis$Components$Grid$Gap$toString(gap);
};
var $author$project$Pyxis$Components$Grid$render = F2(
	function (options, children) {
		var configuration = A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, config) {
					var mapper = _v0;
					return mapper(config);
				}),
			$author$project$Pyxis$Components$Grid$initialConfiguration,
			options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('grid', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Grid$toGapClass(configuration.aI),
							true)
						]))
				]),
			A2($elm$core$List$map, $author$project$Pyxis$Components$Grid$renderRow, children));
	});
var $author$project$Translations$coversPreAncillariesDescription = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'This offer was calculated before the introduction of the additional covers. Therefore, some covers cannot be added.';
	} else {
		return 'Esta oferta se calculó antes de la introducción de los coberturas adicionales. Por lo tanto, algunas coberturas no se pueden añadir.';
	}
};
var $author$project$Common$CoverSelection$hasAncillaries = function (_v0) {
	var ancillaries = _v0.mx;
	if (!ancillaries.$) {
		return false;
	} else {
		if ((!ancillaries.a.b) && (!ancillaries.b.b)) {
			return false;
		} else {
			return true;
		}
	}
};
var $author$project$Common$CoverSelection$isUpdateAdditionalCoverButtonVisible = $author$project$Common$CoverSelection$hasAncillaries;
var $author$project$Pyxis$Components$Card$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Card$M = 1;
var $author$project$Pyxis$Components$Card$None = 0;
var $author$project$Pyxis$Components$IconSet$svgChevronRight = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M9 19h0c-.39-.39-.39-1.02 0-1.41L14.59 12 9 6.41C8.61 6.02 8.61 5.39 9 5h0c.39-.39 1.02-.39 1.41 0l6.29 6.29c.39.39.39 1.02 0 1.41L10.41 19c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$chevronRight = {eY: 'chevron-right', a: $author$project$Pyxis$Components$IconSet$svgChevronRight};
var $author$project$Pyxis$Components$Card$config = {U: $elm$core$Maybe$Nothing, fM: $elm$core$Maybe$Nothing, d1: $author$project$Pyxis$Components$IconSet$chevronRight, mu: $elm$core$Maybe$Nothing, cG: 0, ga: _List_Nil, a0: $elm$core$Maybe$Nothing, ep: _List_Nil, eC: $elm$core$Maybe$Nothing, eH: $elm$core$Maybe$Nothing, kv: $elm$core$Maybe$Nothing, aR: 1, fz: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$Card$cardBackgroundClass = function (background) {
	switch (background) {
		case 0:
			return '';
		case 1:
			return 'card--neutral';
		case 2:
			return 'card--brand';
		case 3:
			return 'card--action';
		case 4:
			return 'card--success';
		case 5:
			return 'card--alert';
		case 6:
			return 'card--error';
		case 7:
			return 'card--surface-strong';
		default:
			return 'card--surface-on-surface-strong';
	}
};
var $author$project$Pyxis$Components$Card$cardSizeClass = function (size) {
	switch (size) {
		case 0:
			return '';
		case 1:
			return 'card--m';
		default:
			return 'card--l';
	}
};
var $author$project$Pyxis$Components$Card$childrenNumber = function (_v0) {
	var configuration = _v0;
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.eH),
					$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.a0),
					$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.eC)
				])));
};
var $author$project$Pyxis$Components$Card$isAddonHeader = function (placement) {
	if (placement === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Card$isAddonLeft = function (placement) {
	if (placement === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Card$isAddonPlacement = F2(
	function (mapper, maybeAddon) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.aa;
					},
					mapper),
				maybeAddon));
	});
var $author$project$Pyxis$Components$Card$isJustActionCard = function (maybeAction) {
	_v0$4:
	while (true) {
		if (!maybeAction.$) {
			switch (maybeAction.a.$) {
				case 0:
					return true;
				case 3:
					var _v1 = maybeAction.a;
					return true;
				case 5:
					var _v2 = maybeAction.a;
					return true;
				case 1:
					var _v3 = maybeAction.a;
					return true;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return false;
};
var $author$project$Pyxis$Components$Card$isJustActionCardOnBottom = function (maybeAction) {
	_v0$2:
	while (true) {
		if (!maybeAction.$) {
			switch (maybeAction.a.$) {
				case 5:
					var _v1 = maybeAction.a;
					return true;
				case 1:
					var _v2 = maybeAction.a;
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Pyxis$Components$Card$getActionText = function (action) {
	_v0$2:
	while (true) {
		if (!action.$) {
			switch (action.a.$) {
				case 5:
					var _v1 = action.a;
					var text = _v1.c;
					return text;
				case 1:
					var _v2 = action.a;
					var text = _v2.a;
					return text;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pyxis$Components$Card$renderActionIcon = function (icon) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__action')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('card__header__action__icon', true)
						]),
					$author$project$Pyxis$Components$Icon$config(icon)))
			]));
};
var $author$project$Pyxis$Components$Card$renderActionBottom = F2(
	function (icon, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card__action-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Commons$Render$maybeMapRender,
					function (text) {
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(text)
								]));
					},
					label),
					$author$project$Pyxis$Components$Card$renderActionIcon(icon)
				]));
	});
var $author$project$Pyxis$Components$Card$renderAction = F2(
	function (_v0, icon) {
		var action = _v0.U;
		return A3(
			$author$project$Pyxis$Commons$Basics$ternaryOperator,
			$author$project$Pyxis$Components$Card$isJustActionCardOnBottom(action),
			A2(
				$author$project$Pyxis$Components$Card$renderActionBottom,
				icon,
				$author$project$Pyxis$Components$Card$getActionText(action)),
			$author$project$Pyxis$Components$Card$renderActionIcon(icon));
	});
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Pyxis$Components$Card$renderAddonByType = function (addonType) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__addon')
			]),
		_List_fromArray(
			[
				function () {
				switch (addonType.$) {
					case 0:
						var iconConfig = addonType.a;
						return $author$project$Pyxis$Components$Icon$render(iconConfig);
					case 1:
						var url = addonType.a;
						return A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(url),
									$elm$html$Html$Attributes$height(48),
									$elm$html$Html$Attributes$width(48)
								]),
							_List_Nil);
					default:
						var html = addonType.a;
						return html;
				}
			}()
			]));
};
var $author$project$Pyxis$Components$Card$renderContent = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__content')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Pyxis$Components$Card$renderFooter = function (footer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__footer')
			]),
		_List_fromArray(
			[footer]));
};
var $author$project$Pyxis$Components$Card$isAddonTop = function (placement) {
	if (!placement) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pyxis$Components$Card$renderAddonIfPlacement = F2(
	function (mapper, addon) {
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			mapper(addon.aa),
			$author$project$Pyxis$Components$Card$renderAddonByType(addon.bq));
	});
var $author$project$Pyxis$Components$Card$AnchorCard = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pyxis$Components$Card$ButtonCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Button$Open = 0;
var $author$project$Pyxis$Components$Button$linkWithTarget = F2(
	function (href, linkTarget) {
		return A3(
			$author$project$Pyxis$Components$Button$Link,
			href,
			$elm$core$Maybe$Just(linkTarget),
			0);
	});
var $author$project$Pyxis$Components$Button$Append = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Button$withIconAppend = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				ku: $author$project$Pyxis$Components$Button$Append(icon)
			});
	});
var $author$project$Pyxis$Components$Card$renderInlineButton = F4(
	function (label, actionIcon, ariaLabel, buttonConfig) {
		return $author$project$Pyxis$Components$Button$render(
			buttonConfig(
				function (btn) {
					return A2(
						$elm$core$Maybe$withDefault,
						btn,
						A2(
							$elm$core$Maybe$map,
							function (text) {
								return A2($author$project$Pyxis$Components$Button$withAriaLabel, text, btn);
							},
							ariaLabel));
				}(
					A2(
						$author$project$Pyxis$Components$Button$withIconAppend,
						actionIcon,
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeS,
							A2($author$project$Pyxis$Components$Button$withText, label, $author$project$Pyxis$Components$Button$ghost))))));
	});
var $author$project$Pyxis$Components$Card$renderSubtitle = function (subtitle) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__header__subtitle')
			]),
		_List_fromArray(
			[subtitle]));
};
var $author$project$Pyxis$Components$Card$renderTitle = function (title) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('card__header__title')
			]),
		_List_fromArray(
			[title]));
};
var $author$project$Pyxis$Components$Card$renderTitleAndSubtitle = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderTitle, configuration.i4)),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderSubtitle, configuration.dO))
			]));
};
var $author$project$Pyxis$Components$Card$renderActionByType = F5(
	function (background, icon, headerConfig, ariaLabel, action) {
		renderActionByType:
		while (true) {
			var configuration = headerConfig;
			switch (action.$) {
				case 0:
					var msg = action.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(msg),
										$elm$html$Html$Attributes$class('card__header__action'),
										A2(
										$author$project$Pyxis$Commons$Attributes$maybe,
										$elm$html$Html$Attributes$attribute('aria-label'),
										ariaLabel)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card__header__action__focus'),
												A2(
												$author$project$Pyxis$Commons$Attributes$renderIf,
												!(!background),
												A2($elm$html$Html$Attributes$attribute, 'data-style', 'default'))
											]),
										_List_Nil),
										$author$project$Pyxis$Commons$Render$renderMaybe(configuration.i4)
									])),
								$author$project$Pyxis$Commons$Render$renderMaybe(configuration.dO)
							]));
				case 3:
					var href = action.a;
					var linkTarget = action.b;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(href),
										$elm$html$Html$Attributes$class('card__header__action'),
										$author$project$Pyxis$Commons$Attributes$target(linkTarget),
										A2(
										$author$project$Pyxis$Commons$Attributes$maybe,
										$elm$html$Html$Attributes$attribute('aria-label'),
										ariaLabel)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('card__header__action__focus'),
												A2(
												$author$project$Pyxis$Commons$Attributes$renderIf,
												!(!background),
												A2($elm$html$Html$Attributes$attribute, 'data-style', 'default'))
											]),
										_List_Nil),
										$author$project$Pyxis$Commons$Render$renderMaybe(configuration.i4)
									])),
								$author$project$Pyxis$Commons$Render$renderMaybe(configuration.dO)
							]));
				case 2:
					var label = action.a;
					var msg = action.b;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card__header__content__inline-action')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Card$renderTitleAndSubtitle(headerConfig),
								A4(
								$author$project$Pyxis$Components$Card$renderInlineButton,
								label,
								icon,
								ariaLabel,
								$author$project$Pyxis$Components$Button$withOnClick(msg))
							]));
				case 4:
					var label = action.a;
					var href = action.b;
					var linkTarget = action.c;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card__header__content__inline-action')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Card$renderTitleAndSubtitle(headerConfig),
								A4(
								$author$project$Pyxis$Components$Card$renderInlineButton,
								label,
								icon,
								ariaLabel,
								$author$project$Pyxis$Components$Button$withType(
									A2($author$project$Pyxis$Components$Button$linkWithTarget, href, linkTarget)))
							]));
				case 5:
					var href = action.a;
					var linkTarget = action.b;
					var $temp$background = background,
						$temp$icon = icon,
						$temp$headerConfig = headerConfig,
						$temp$ariaLabel = ariaLabel,
						$temp$action = A2($author$project$Pyxis$Components$Card$AnchorCard, href, linkTarget);
					background = $temp$background;
					icon = $temp$icon;
					headerConfig = $temp$headerConfig;
					ariaLabel = $temp$ariaLabel;
					action = $temp$action;
					continue renderActionByType;
				default:
					var msg = action.b;
					var $temp$background = background,
						$temp$icon = icon,
						$temp$headerConfig = headerConfig,
						$temp$ariaLabel = ariaLabel,
						$temp$action = $author$project$Pyxis$Components$Card$ButtonCard(msg);
					background = $temp$background;
					icon = $temp$icon;
					headerConfig = $temp$headerConfig;
					ariaLabel = $temp$ariaLabel;
					action = $temp$action;
					continue renderActionByType;
			}
		}
	});
var $author$project$Pyxis$Components$Card$renderBadgeList = function (badgeList) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('display-flex gap-2xs')
			]),
		A2($elm$core$List$map, $author$project$Pyxis$Components$Badge$render, badgeList));
};
var $author$project$Pyxis$Components$Card$renderInternalHeader = F5(
	function (background, icon, maybeAction, headerConfig, ariaLabel) {
		var configuration = headerConfig;
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				!$elm$core$List$isEmpty(configuration.d3),
				$author$project$Pyxis$Components$Card$renderBadgeList(configuration.d3)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Pyxis$Components$Card$renderTitleAndSubtitle(headerConfig),
				A2(
					$elm$core$Maybe$map,
					A4($author$project$Pyxis$Components$Card$renderActionByType, background, icon, headerConfig, ariaLabel),
					maybeAction)),
				$author$project$Pyxis$Commons$Render$renderMaybe(configuration.a0)
			]);
	});
var $author$project$Pyxis$Components$Card$renderHeader = F2(
	function (_v0, headerConfig) {
		var background = _v0.cG;
		var action = _v0.U;
		var addon = _v0.mu;
		var actionIcon = _v0.d1;
		var actionAriaLabel = _v0.fM;
		var renderMaybeAddonIfPlacement = function (condition) {
			return $author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					$author$project$Pyxis$Components$Card$renderAddonIfPlacement(condition),
					addon));
		};
		var internalHeader = A5($author$project$Pyxis$Components$Card$renderInternalHeader, background, actionIcon, action, headerConfig, actionAriaLabel);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card__header')
				]),
			A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonHeader, addon) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card__header__content')
						]),
					_List_fromArray(
						[
							renderMaybeAddonIfPlacement($author$project$Pyxis$Components$Card$isAddonHeader),
							A2($elm$html$Html$div, _List_Nil, internalHeader)
						]))
				]) : A2(
				$elm$core$List$cons,
				renderMaybeAddonIfPlacement($author$project$Pyxis$Components$Card$isAddonTop),
				internalHeader));
	});
var $author$project$Pyxis$Components$Card$setDataStyle = function (background) {
	switch (background) {
		case 0:
			return 'default';
		case 1:
			return 'vibrant';
		case 3:
			return 'vibrant';
		case 5:
			return 'vibrant';
		case 2:
			return 'vibrant';
		case 4:
			return 'vibrant';
		case 6:
			return 'vibrant';
		case 7:
			return 'default';
		default:
			return 'default';
	}
};
var $author$project$Pyxis$Components$Card$render = function (_v0) {
	var configuration = _v0;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			configuration.ep,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('card', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Card$cardSizeClass(configuration.aR),
							true),
							_Utils_Tuple2(
							'card--with-action',
							$author$project$Pyxis$Components$Card$isJustActionCard(configuration.U)),
							_Utils_Tuple2(
							'card--with-action-bottom',
							$author$project$Pyxis$Components$Card$isJustActionCardOnBottom(configuration.U)),
							_Utils_Tuple2(
							'card--with-addon',
							$elm_community$maybe_extra$Maybe$Extra$isJust(configuration.mu)),
							_Utils_Tuple2(
							'card--with-addon--left',
							A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonLeft, configuration.mu)),
							_Utils_Tuple2(
							'card--with-addon--header',
							A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonHeader, configuration.mu)),
							_Utils_Tuple2(
							'card--with-single-row',
							$author$project$Pyxis$Components$Card$childrenNumber(configuration) === 1),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Card$cardBackgroundClass(configuration.cG),
							true)
						])),
					$elm$html$Html$Attributes$classList(configuration.ga),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, configuration.kv),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configuration.fz),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-style',
					$author$project$Pyxis$Components$Card$setDataStyle(configuration.cG))
				])),
		_List_fromArray(
			[
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				A2($author$project$Pyxis$Components$Card$isAddonPlacement, $author$project$Pyxis$Components$Card$isAddonLeft, configuration.mu),
				$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bq;
							},
							$author$project$Pyxis$Components$Card$renderAddonByType),
						configuration.mu))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card__wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2(
							$elm$core$Maybe$map,
							$author$project$Pyxis$Components$Card$renderHeader(configuration),
							configuration.eH)),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderContent, configuration.a0)),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Card$renderFooter, configuration.eC))
					])),
				A2(
				$author$project$Pyxis$Commons$Render$renderIf,
				$author$project$Pyxis$Components$Card$isJustActionCard(configuration.U),
				A2($author$project$Pyxis$Components$Card$renderAction, configuration, configuration.d1))
			]));
};
var $author$project$Pyxis$Components$Icon$default = $author$project$Pyxis$Components$Icon$Default;
var $author$project$Common$CoverSelection$renderIcon = function (icon) {
	return $author$project$Pyxis$Components$Icon$render(
		A2(
			$author$project$Pyxis$Components$Icon$withColor,
			$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
			A2(
				$author$project$Pyxis$Components$Icon$withStyle,
				$author$project$Pyxis$Components$Icon$default,
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeM,
					$author$project$Pyxis$Components$Icon$config(icon)))));
};
var $author$project$Pyxis$Tokens$TypographyColor$Content = 3;
var $author$project$Pyxis$Tokens$TypographyColor$tokenContent = 3;
var $author$project$Common$CoverSelection$renderSelectableDescription = F2(
	function (i18n, _v0) {
		var icon = _v0.ku;
		var i18nDescription = _v0.nz;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-cover__description')
				]),
			_List_fromArray(
				[
					$author$project$Common$CoverSelection$renderIcon(icon),
					$author$project$Pyxis$Components$Text$render(
					A2(
						$author$project$Pyxis$Components$Text$withFontWeight,
						$author$project$Pyxis$Tokens$FontWeight$tokenBold,
						A2(
							$author$project$Pyxis$Components$Text$withColor,
							$author$project$Pyxis$Tokens$TypographyColor$tokenContent,
							A2(
								$author$project$Pyxis$Components$Text$withSize,
								$author$project$Pyxis$Tokens$TextSize$tokenL,
								$author$project$Pyxis$Components$Text$config(
									$elm$html$Html$text(
										i18nDescription(i18n)))))))
				]));
	});
var $author$project$Pyxis$Components$Price$Bold = 1;
var $author$project$Pyxis$Components$Price$Bottom = 0;
var $author$project$Pyxis$Components$Price$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Price$L = 1;
var $author$project$Pyxis$Components$Price$Left = 0;
var $author$project$Pyxis$Commons$Locale$EN = 0;
var $author$project$Pyxis$Commons$Locale$enLocale = 0;
var $author$project$Pyxis$Commons$Currency$GBP = 1;
var $author$project$Pyxis$Commons$Currency$gbpCurrency = 1;
var $author$project$Pyxis$Components$Price$config = {d$: $elm$core$Maybe$Nothing, d2: 0, ga: _List_Nil, el: $author$project$Pyxis$Commons$Currency$gbpCurrency, eq: _List_Nil, m3: $elm$core$Maybe$Nothing, er: 0, eJ: false, kv: $elm$core$Maybe$Nothing, e$: $author$project$Pyxis$Commons$Locale$enLocale, bj: $elm$core$Maybe$Nothing, dw: $elm$core$Maybe$Nothing, aR: 1, fz: $elm$core$Maybe$Nothing, fK: 1};
var $author$project$Translations$coversAncillaryStatusAvailable = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Available';
	} else {
		return 'Disponible';
	}
};
var $author$project$Pyxis$Commons$Locale$ES = 2;
var $author$project$Pyxis$Commons$Locale$esLocale = 2;
var $author$project$Pyxis$Commons$Currency$EUR = 0;
var $author$project$Pyxis$Commons$Currency$euroCurrency = 0;
var $author$project$Common$Price$pickAmountAsFloat = function (_v0) {
	var amount = _v0.a;
	return $prikhi$decimal$Decimal$toFloat(amount);
};
var $author$project$Pyxis$Components$Price$Book = 0;
var $author$project$Pyxis$Components$Price$getPriceAlignmentClass = function (alignment) {
	switch (alignment) {
		case 0:
			return '';
		case 1:
			return 'price--center';
		default:
			return 'price--right';
	}
};
var $author$project$Pyxis$Components$Price$getPriceSizeClass = function (size) {
	switch (size) {
		case 3:
			return 'price--s';
		case 2:
			return 'price--m';
		case 1:
			return '';
		default:
			return 'price--xl';
	}
};
var $author$project$Pyxis$Commons$Currency$getCurrencySymbolFromCode = function (currencyCode) {
	if (!currencyCode) {
		return '€';
	} else {
		return '£';
	}
};
var $author$project$Pyxis$Commons$Locale$isEn = $elm$core$Basics$eq(0);
var $author$project$Pyxis$Commons$Currency$addCurrencyBaseOnLocale = F3(
	function (locale, currencyCode, value) {
		return $author$project$Pyxis$Commons$Locale$isEn(locale) ? _Utils_ap(
			$author$project$Pyxis$Commons$Currency$getCurrencySymbolFromCode(currencyCode),
			value) : (value + (' ' + $author$project$Pyxis$Commons$Currency$getCurrencySymbolFromCode(currencyCode)));
	});
var $author$project$Pyxis$Commons$Float$isInt = function (value) {
	return _Utils_eq(
		value,
		$elm$core$Basics$floor(value));
};
var $cuducos$elm_format_number$FormatNumber$Locales$spanishLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		m_: ',',
		m$: $cuducos$elm_format_number$FormatNumber$Locales$Exact(3),
		aT: '.'
	});
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		m$: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		aT: ','
	});
var $author$project$Pyxis$Commons$Float$formatFloatBasedOnLocale = F3(
	function (locale, hideTrailingZero, value) {
		var usLocale = $cuducos$elm_format_number$FormatNumber$Locales$usLocale;
		var spanishLocale = $cuducos$elm_format_number$FormatNumber$Locales$spanishLocale;
		var numberOfDecimals = A3(
			$author$project$Pyxis$Commons$Basics$ternaryOperator,
			hideTrailingZero && $author$project$Pyxis$Commons$Float$isInt(value),
			0,
			2);
		return $author$project$Pyxis$Commons$Locale$isEn(locale) ? A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				usLocale,
				{
					m$: $cuducos$elm_format_number$FormatNumber$Locales$Exact(numberOfDecimals)
				}),
			value) : A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				spanishLocale,
				{
					m$: $cuducos$elm_format_number$FormatNumber$Locales$Exact(numberOfDecimals)
				}),
			value);
	});
var $author$project$Pyxis$Commons$Currency$formatCurrency = F3(
	function (locale, currencyCode, hideTrailingZero) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pyxis$Commons$Float$formatFloatBasedOnLocale, locale, hideTrailingZero),
			A2($author$project$Pyxis$Commons$Currency$addCurrencyBaseOnLocale, locale, currencyCode));
	});
var $author$project$Pyxis$Components$Price$maybeFormatPrice = F2(
	function (_v0, price) {
		var locale = _v0.e$;
		var currencyCode = _v0.el;
		var hideTrailingZero = _v0.eJ;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Pyxis$Commons$Currency$formatCurrency, locale, currencyCode, hideTrailingZero),
				price));
	});
var $author$project$Pyxis$Components$Price$applyLabelFormatter = F3(
	function (formattedPriceBeforeDiscount, formattedPrice, formatter) {
		return A2(formatter, formattedPriceBeforeDiscount, formattedPrice);
	});
var $author$project$Pyxis$Components$Price$defaultLabel = F2(
	function (formattedPrice, formattedPriceBeforeDiscount) {
		return formattedPrice + (' instead of ' + formattedPriceBeforeDiscount);
	});
var $author$project$Pyxis$Components$Price$getAccessibilityLabel = F3(
	function (accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Pyxis$Components$Price$defaultLabel, formattedPrice, formattedPriceBeforeDiscount),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Pyxis$Components$Price$applyLabelFormatter, formattedPriceBeforeDiscount, formattedPrice),
				accessibilityLabelFormatter));
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $author$project$Pyxis$Components$Price$renderPriceBeforeDiscountBlock = F3(
	function (accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$Pyxis$Components$Price$getAccessibilityLabel, accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount))
						])),
					A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price__discount'),
							$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(formattedPriceBeforeDiscount)
						]))
				]));
	});
var $author$project$Pyxis$Components$Price$maybeRenderPriceBeforeDiscountBlock = F3(
	function (accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount) {
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			formattedPriceBeforeDiscount !== '',
			A3($author$project$Pyxis$Components$Price$renderPriceBeforeDiscountBlock, accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount));
	});
var $author$project$Pyxis$Components$Price$DetailsRight = 1;
var $author$project$Pyxis$Components$Price$isDetailsToPositionRight = F2(
	function (details, alignment) {
		return $elm_community$maybe_extra$Maybe$Extra$isJust(details) && (alignment === 1);
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Pyxis$Components$Price$renderDetails = function (details) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('price__details')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(details)
			]));
};
var $author$project$Pyxis$Components$Price$renderPriceBlock = F2(
	function (_v0, formattedPrice) {
		var priceBeforeDiscount = _v0.dw;
		var details = _v0.m3;
		var detailsPosition = _v0.er;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('price__wrapper', true),
							_Utils_Tuple2(
							'price__wrapper--details-right',
							A2($author$project$Pyxis$Components$Price$isDetailsToPositionRight, details, detailsPosition))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price__value'),
							$author$project$Pyxis$Commons$Attributes$ariaHidden(
							$elm_community$maybe_extra$Maybe$Extra$isJust(priceBeforeDiscount))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(formattedPrice)
						])),
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Price$renderDetails, details)
				]));
	});
var $author$project$Pyxis$Components$Price$render = function (_v0) {
	var configuration = _v0;
	var id = configuration.kv;
	var testId = configuration.fz;
	var size = configuration.aR;
	var alignment = configuration.d2;
	var priceBeforeDiscount = configuration.dw;
	var price = configuration.bj;
	var accessibilityLabelFormatter = configuration.d$;
	var dataAttributeList = configuration.eq;
	var weight = configuration.fK;
	var formattedPriceBeforeDiscount = A2($author$project$Pyxis$Components$Price$maybeFormatPrice, configuration, priceBeforeDiscount);
	var formattedPrice = A2($author$project$Pyxis$Components$Price$maybeFormatPrice, configuration, price);
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttributeList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('price', true),
								_Utils_Tuple2('price--book', !weight),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Price$getPriceSizeClass(size),
								size !== 1),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Price$getPriceAlignmentClass(alignment),
								!(!alignment))
							]),
						configuration.ga)),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		_List_fromArray(
			[
				A3($author$project$Pyxis$Components$Price$maybeRenderPriceBeforeDiscountBlock, accessibilityLabelFormatter, formattedPrice, formattedPriceBeforeDiscount),
				A2($author$project$Pyxis$Components$Price$renderPriceBlock, configuration, formattedPrice)
			]));
};
var $author$project$Pyxis$Components$Price$S = 3;
var $author$project$Pyxis$Components$Price$sizeS = 3;
var $author$project$Pyxis$Components$Badge$Success = 4;
var $author$project$Pyxis$Components$Badge$success = $author$project$Pyxis$Components$Badge$config(4);
var $author$project$Pyxis$Components$Price$withFormatOptions = F3(
	function (locale, currency, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{el: currency, e$: locale});
	});
var $author$project$Pyxis$Components$Price$withPrice = F2(
	function (price, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				bj: $elm$core$Maybe$Just(price)
			});
	});
var $author$project$Pyxis$Components$Price$withSize = F2(
	function (s, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: s});
	});
var $author$project$Common$CoverSelection$renderSelectablePrice = F2(
	function (i18n, _v0) {
		var grossPrice = _v0.c$;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-cover__price')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Price$render(
					A3(
						$author$project$Pyxis$Components$Price$withFormatOptions,
						$author$project$Pyxis$Commons$Locale$esLocale,
						$author$project$Pyxis$Commons$Currency$euroCurrency,
						A2(
							$author$project$Pyxis$Components$Price$withSize,
							$author$project$Pyxis$Components$Price$sizeS,
							A2(
								$author$project$Pyxis$Components$Price$withPrice,
								$author$project$Common$Price$pickAmountAsFloat(grossPrice),
								$author$project$Pyxis$Components$Price$config)))),
					$author$project$Pyxis$Components$Badge$render(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$coversAncillaryStatusAvailable(i18n),
						$author$project$Pyxis$Components$Badge$success))
				]));
	});
var $author$project$Common$CoverSelection$renderSelectable = F2(
	function (i18n, ancillary) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-cover')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$CoverSelection$renderSelectableDescription, i18n, ancillary),
					A2($author$project$Common$CoverSelection$renderSelectablePrice, i18n, ancillary)
				]));
	});
var $author$project$Pyxis$Components$Card$S = 0;
var $author$project$Pyxis$Components$Card$sizeS = 0;
var $author$project$Pyxis$Components$Card$withClassList = F2(
	function (classes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classes});
	});
var $author$project$Pyxis$Components$Card$withContent = F2(
	function (content, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				a0: $elm$core$Maybe$Just(content)
			});
	});
var $author$project$Pyxis$Components$Card$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Common$CoverSelection$renderSelectableContainer = F2(
	function (i18n, ancillary) {
		return $author$project$Pyxis$Components$Card$render(
			A2(
				$author$project$Pyxis$Components$Card$withSize,
				$author$project$Pyxis$Components$Card$sizeS,
				A2(
					$author$project$Pyxis$Components$Card$withContent,
					A2($author$project$Common$CoverSelection$renderSelectable, i18n, ancillary),
					A2(
						$author$project$Pyxis$Components$Card$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('covers__selectable-cover-container', true)
							]),
						$author$project$Pyxis$Components$Card$config))));
	});
var $author$project$Common$CoverSelection$renderSelectableCovers = F2(
	function (i18n, ancillaryList) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selectable-covers-container')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Common$CoverSelection$renderSelectableContainer(i18n),
				ancillaryList));
	});
var $author$project$Pyxis$Components$Divider$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Divider$Horizontal = 0;
var $author$project$Pyxis$Components$Divider$S = 0;
var $author$project$Pyxis$Components$Divider$config = {ga: _List_Nil, ep: _List_Nil, kv: $elm$core$Maybe$Nothing, eY: $elm$core$Maybe$Nothing, ig: 0, fz: $elm$core$Maybe$Nothing, i3: 0};
var $author$project$Pyxis$Components$Divider$M = 1;
var $author$project$Pyxis$Components$Divider$Vertical = 1;
var $author$project$Pyxis$Components$Divider$commonAttributes = function (_v0) {
	var classList = _v0.ga;
	var dataAttrList = _v0.ep;
	var id = _v0.kv;
	var testId = _v0.fz;
	var label = _v0.eY;
	var orientation = _v0.ig;
	var thickness = _v0.i3;
	return A2(
		$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
		dataAttrList,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('divider', true),
						_Utils_Tuple2('divider--vertical', orientation === 1),
						_Utils_Tuple2('divider--horizontal', !orientation),
						_Utils_Tuple2('divider--border-s', !thickness),
						_Utils_Tuple2('divider--border-m', thickness === 1),
						_Utils_Tuple2(
						'divider--label',
						$elm_community$maybe_extra$Maybe$Extra$isJust(label))
					])),
				$elm$html$Html$Attributes$classList(classList),
				A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
				A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
				A2(
				$author$project$Pyxis$Commons$Attributes$renderIf,
				$elm_community$maybe_extra$Maybe$Extra$isJust(label),
				$author$project$Pyxis$Commons$Attributes$role('presentation'))
			]));
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Pyxis$Components$Divider$renderDivider = function (configuration) {
	return A2(
		$elm$html$Html$hr,
		$author$project$Pyxis$Components$Divider$commonAttributes(configuration),
		_List_Nil);
};
var $author$project$Pyxis$Commons$Render$renderMaybeText = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$html$Html$text),
	$author$project$Pyxis$Commons$Render$renderMaybe);
var $author$project$Pyxis$Components$Divider$renderDividerWithLabel = function (configuration) {
	var label = configuration.eY;
	return A2(
		$elm$html$Html$div,
		$author$project$Pyxis$Components$Divider$commonAttributes(configuration),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('divider__label')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybeText(label)
					]))
			]));
};
var $author$project$Pyxis$Components$Divider$render = function (configuration) {
	var label = configuration.eY;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(label) ? $author$project$Pyxis$Components$Divider$renderDividerWithLabel(configuration) : $author$project$Pyxis$Components$Divider$renderDivider(configuration);
};
var $author$project$Common$CoverSelection$renderSelectedCover = F4(
	function (i18n, icon, i18nDescription, grossPrice) {
		return A2(
			$author$project$Pyxis$Components$List$withItemTitle,
			i18nDescription,
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(
					A2($author$project$Common$Price$toStringSignLast, i18n, grossPrice)),
				A2(
					$author$project$Pyxis$Components$List$withItemAddonIcon,
					$author$project$Pyxis$Components$Icon$config(icon),
					$author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$CoverSelection$renderSelectedAncillary = F2(
	function (i18n, _v0) {
		var icon = _v0.ku;
		var i18nDescription = _v0.nz;
		var grossPrice = _v0.c$;
		return A4(
			$author$project$Common$CoverSelection$renderSelectedCover,
			i18n,
			icon,
			i18nDescription(i18n),
			grossPrice);
	});
var $author$project$Common$CoverSelection$renderSelectedAncillaries = A2($elm$core$Basics$composeL, $elm$core$List$map, $author$project$Common$CoverSelection$renderSelectedAncillary);
var $author$project$Pyxis$Components$IconSet$svgSteeringWheel = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0a12 12 0 1 0 0 24 12 12 0 1 0 0-24zm0 2c3.69 0 6.91 2.02 8.65 5H3.35C5.09 4.02 8.31 2 12 2zM2.2 14h2.52a3 3 0 0 1 2.94 2.41l1 5C5.4 20.25 2.91 17.45 2.2 14zm8.6 7.92l-1.18-5.9C9.16 13.69 7.1 12 4.72 12H2a9.91 9.91 0 0 1 .46-3h19.08a9.91 9.91 0 0 1 .46 3h-2.72c-2.38 0-4.44 1.69-4.9 4.02l-1.18 5.9c-.4.05-.79.08-1.2.08s-.8-.03-1.2-.08zm4.54-.5l1-5c.28-1.4 1.52-2.41 2.94-2.41h2.52c-.71 3.44-3.2 6.24-6.46 7.41z\"/><circle cx=\"12\" cy=\"12\" r=\"1.25\"/></svg>';
var $author$project$Pyxis$Components$IconSet$steeringWheel = {eY: 'steering-wheel', a: $author$project$Pyxis$Components$IconSet$svgSteeringWheel};
var $author$project$Common$CoverSelection$renderSelectedBundle = F2(
	function (i18n, _v0) {
		var bundle = _v0.f4;
		var bundleGrossPrice = _v0.f5;
		return A4(
			$author$project$Common$CoverSelection$renderSelectedCover,
			i18n,
			$author$project$Pyxis$Components$IconSet$steeringWheel,
			A2($author$project$Common$Product$bundleSlugToString, i18n, bundle),
			bundleGrossPrice);
	});
var $author$project$Common$CoverSelection$renderSelections = F3(
	function (i18n, selectedAncillaries, coverSelection) {
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withEmphasis,
				$author$project$Pyxis$Components$List$emphasisText,
				A2(
					$author$project$Pyxis$Components$List$withOrientation,
					$author$project$Pyxis$Components$List$block,
					A2(
						$author$project$Pyxis$Components$List$withItemOrientation,
						$author$project$Pyxis$Components$List$itemOrientationInline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							A2(
								$elm$core$List$cons,
								A2($author$project$Common$CoverSelection$renderSelectedBundle, i18n, coverSelection),
								A2($author$project$Common$CoverSelection$renderSelectedAncillaries, i18n, selectedAncillaries)),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $cmditch$elm_bigint$BigInt$MagnitudePair = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$sameSizeRaw = F2(
	function (xs, ys) {
		var _v0 = _Utils_Tuple2(xs, ys);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return _List_Nil;
			} else {
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys_ = _v2.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(0, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, _List_Nil, ys_));
			}
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, 0),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, _List_Nil));
			} else {
				var _v3 = _v0.a;
				var x = _v3.a;
				var xs_ = _v3.b;
				var _v4 = _v0.b;
				var y = _v4.a;
				var ys_ = _v4.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, ys_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sameSizeNotNormalized = F2(
	function (_v0, _v1) {
		var xs = _v0;
		var ys = _v1;
		return A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs, ys);
	});
var $cmditch$elm_bigint$BigInt$toPositiveSign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 2, _List_Nil);
		case 1:
			var digits = bigInt.a;
			return A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				0,
				$cmditch$elm_bigint$BigInt$reverseMagnitude(digits));
		default:
			var digits = bigInt.a;
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 0, digits);
	}
};
var $cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var _v0 = $cmditch$elm_bigint$BigInt$toPositiveSign(b);
		var mb = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$toPositiveSign(a);
		var ma = _v1.b;
		var _v2 = A2($cmditch$elm_bigint$BigInt$sameSizeNotNormalized, ma, mb);
		var pairs = _v2;
		var added = A2(
			$elm$core$List$map,
			function (_v3) {
				var a_ = _v3.a;
				var b_ = _v3.b;
				return a_ + b_;
			},
			pairs);
		return $cmditch$elm_bigint$BigInt$normalise(
			A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var $cmditch$elm_bigint$BigInt$magnitude = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var mag = bigInt.a;
			return mag;
		default:
			var mag = bigInt.a;
			return mag;
	}
};
var $cmditch$elm_bigint$BigInt$mulSingleDigit = F2(
	function (_v0, d) {
		var xs = _v0;
		return $cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$mul(d),
				xs));
	});
var $cmditch$elm_bigint$BigInt$mulMagnitudes = F2(
	function (_v0, _v1) {
		var mag1 = _v0;
		var mag2 = _v1;
		if (!mag1.b) {
			return _List_Nil;
		} else {
			if (!mag1.b.b) {
				var m = mag1.a;
				return A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
			} else {
				var m = mag1.a;
				var mx = mag1.b;
				var accum = A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
				var _v3 = A2($cmditch$elm_bigint$BigInt$mulMagnitudes, mx, mag2);
				var rest = _v3;
				var bigInt = A2(
					$cmditch$elm_bigint$BigInt$add,
					A2($cmditch$elm_bigint$BigInt$mkBigInt, 0, accum),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						0,
						A2($elm$core$List$cons, 0, rest)));
				return $cmditch$elm_bigint$BigInt$magnitude(bigInt);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return 2;
		case 0:
			return 0;
		default:
			return 1;
	}
};
var $cmditch$elm_bigint$BigInt$signProduct = F2(
	function (x, y) {
		return ((x === 2) || (y === 2)) ? 2 : (_Utils_eq(x, y) ? 0 : 1);
	});
var $cmditch$elm_bigint$BigInt$mul = F2(
	function (int1, int2) {
		return A2(
			$cmditch$elm_bigint$BigInt$mkBigInt,
			A2(
				$cmditch$elm_bigint$BigInt$signProduct,
				$cmditch$elm_bigint$BigInt$sign(int1),
				$cmditch$elm_bigint$BigInt$sign(int2)),
			A2(
				$cmditch$elm_bigint$BigInt$mulMagnitudes,
				$cmditch$elm_bigint$BigInt$magnitude(int1),
				$cmditch$elm_bigint$BigInt$magnitude(int2)));
	});
var $prikhi$decimal$Decimal$addDecimals = F2(
	function (i, _v0) {
		addDecimals:
		while (true) {
			var m = _v0.a;
			var e = _v0.b;
			var mul10 = function (x) {
				return A2(
					$cmditch$elm_bigint$BigInt$mul,
					x,
					$cmditch$elm_bigint$BigInt$fromInt(10));
			};
			if (!i) {
				return A2($prikhi$decimal$Decimal$Decimal, m, e);
			} else {
				if (i > 0) {
					var $temp$i = i - 1,
						$temp$_v0 = A2(
						$prikhi$decimal$Decimal$Decimal,
						mul10(m),
						e - 1);
					i = $temp$i;
					_v0 = $temp$_v0;
					continue addDecimals;
				} else {
					return A2($prikhi$decimal$Decimal$Decimal, m, e);
				}
			}
		}
	});
var $prikhi$decimal$Decimal$toExponent = F2(
	function (e, _v0) {
		var md = _v0.a;
		var ed = _v0.b;
		return A2(
			$prikhi$decimal$Decimal$addDecimals,
			ed - e,
			A2($prikhi$decimal$Decimal$Decimal, md, ed));
	});
var $prikhi$decimal$Decimal$toCommonExponent = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var _v1 = b;
	var mb = _v1.a;
	var eb = _v1.b;
	var _v2 = a;
	var ma = _v2.a;
	var ea = _v2.b;
	var exponent = A2($elm$core$Basics$min, ea, eb);
	return _Utils_Tuple2(
		A2($prikhi$decimal$Decimal$toExponent, exponent, a),
		A2($prikhi$decimal$Decimal$toExponent, exponent, b));
};
var $prikhi$decimal$Decimal$add = F2(
	function (a, b) {
		var _v0 = $prikhi$decimal$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var ra = _v0.a;
		var rb = _v0.b;
		var _v1 = rb;
		var mb = _v1.a;
		var eb = _v1.b;
		var _v2 = ra;
		var ma = _v2.a;
		var ea = _v2.b;
		return A2(
			$prikhi$decimal$Decimal$Decimal,
			A2($cmditch$elm_bigint$BigInt$add, ma, mb),
			ea);
	});
var $author$project$Common$Price$pickAmount = function (_v0) {
	var amount = _v0.a;
	return amount;
};
var $author$project$Common$Price$sum = F2(
	function (firstAddend, secondAddend) {
		return $author$project$Common$Price$euro(
			A2(
				$prikhi$decimal$Decimal$add,
				$author$project$Common$Price$pickAmount(firstAddend),
				$author$project$Common$Price$pickAmount(secondAddend)));
	});
var $prikhi$decimal$Decimal$zero = $prikhi$decimal$Decimal$fromInt(0);
var $author$project$Common$Price$zero = function (currency) {
	return A2($author$project$Common$Price$new, $prikhi$decimal$Decimal$zero, currency);
};
var $author$project$Common$Price$sumAll = function (prices) {
	return A3(
		$elm$core$List$foldl,
		$author$project$Common$Price$sum,
		$author$project$Common$Price$zero(0),
		prices);
};
var $author$project$Common$CoverSelection$calculateTotalPrice = function (_v0) {
	var bundleGrossPrice = _v0.f5;
	var ancillaries = _v0.mx;
	if (!ancillaries.$) {
		return bundleGrossPrice;
	} else {
		var selectedAncillaries = ancillaries.a;
		return A2(
			$author$project$Common$Price$sum,
			bundleGrossPrice,
			$author$project$Common$Price$sumAll(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.c$;
					},
					selectedAncillaries)));
	}
};
var $author$project$Pyxis$Components$Grid$Col$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Col$classList = function (classes) {
	return function (config) {
		return _Utils_update(
			config,
			{ga: classes});
	};
};
var $author$project$Translations$coversTotalPrice = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Total';
	} else {
		return 'Total';
	}
};
var $author$project$Pyxis$Components$Grid$Row = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Row$buildConfiguration = F2(
	function (options, config) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, c) {
					var mapper = _v0;
					return mapper(c);
				}),
			config,
			options);
	});
var $author$project$Pyxis$Components$Grid$Row$L = 2;
var $author$project$Pyxis$Components$Grid$Row$rowSizeL = 2;
var $author$project$Pyxis$Components$Grid$initialRowConfiguration = {a_: $author$project$Pyxis$Tokens$Breakpoint$tokenBase, ah: _List_Nil, ga: _List_Nil, aR: $author$project$Pyxis$Components$Grid$Row$rowSizeL};
var $author$project$Pyxis$Components$Grid$row = F2(
	function (options, children) {
		var configuration = A2($author$project$Pyxis$Components$Grid$Row$buildConfiguration, options, $author$project$Pyxis$Components$Grid$initialRowConfiguration);
		return {a_: configuration.a_, ah: children, ga: configuration.ga, aR: configuration.aR};
	});
var $author$project$Pyxis$Tokens$TitleSize$TitleSizeS = 5;
var $author$project$Pyxis$Tokens$TitleSize$tokenS = 5;
var $author$project$Pyxis$Components$Title$withColor = F2(
	function (color, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eg: $elm$core$Maybe$Just(color)
			});
	});
var $author$project$Pyxis$Components$Title$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Common$CoverSelection$renderTotalPrice = F2(
	function (i18n, coverSelection) {
		return A2(
			$author$project$Pyxis$Components$Grid$render,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Components$Grid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Components$Grid$col,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pyxis$Components$Title$render(
									A2(
										$author$project$Pyxis$Components$Title$withColor,
										$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
										A2(
											$author$project$Pyxis$Components$Title$withSize,
											$author$project$Pyxis$Tokens$TitleSize$tokenS,
											$author$project$Pyxis$Components$Title$config(
												$elm$html$Html$text(
													$author$project$Translations$coversTotalPrice(i18n))))))
								])),
							A2(
							$author$project$Pyxis$Components$Grid$col,
							_List_fromArray(
								[
									$author$project$Pyxis$Components$Grid$Col$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('display-grid justify-items-end', true)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Pyxis$Components$Price$render(
									A3(
										$author$project$Pyxis$Components$Price$withFormatOptions,
										$author$project$Pyxis$Commons$Locale$esLocale,
										$author$project$Pyxis$Commons$Currency$euroCurrency,
										A2(
											$author$project$Pyxis$Components$Price$withPrice,
											$author$project$Common$Price$pickAmountAsFloat(
												$author$project$Common$CoverSelection$calculateTotalPrice(coverSelection)),
											$author$project$Pyxis$Components$Price$config)))
								]))
						]))
				]));
	});
var $author$project$Common$CoverSelection$renderSelectedCovers = F3(
	function (i18n, selectedAncillaries, coverSelection) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__selected-cover-container')
				]),
			_List_fromArray(
				[
					A3($author$project$Common$CoverSelection$renderSelections, i18n, selectedAncillaries, coverSelection),
					$author$project$Pyxis$Components$Divider$render($author$project$Pyxis$Components$Divider$config),
					A2($author$project$Common$CoverSelection$renderTotalPrice, i18n, coverSelection)
				]));
	});
var $author$project$Translations$coversUpdateSelectedAncillariesButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Adding or removing additional covers';
	} else {
		return 'Agregar o quitar coberturas opcionales';
	}
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.pd;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.ng,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.lA,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.o7,
					_Utils_ap(http, url.nw)),
				url.o5)));
};
var $author$project$Common$CoverSelection$renderUpdateAncillariesButton = F2(
	function (i18n, editAncillaryCoversUrl) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$elm$url$Url$toString(editAncillaryCoversUrl)),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDataAttrList,
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'update-ancillaries')
							]),
						A2(
							$author$project$Pyxis$Components$Button$withIconAppend,
							$author$project$Pyxis$Components$IconSet$externalLink,
							A2(
								$author$project$Pyxis$Components$Button$withSize,
								$author$project$Pyxis$Components$Button$sizeM,
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$coversUpdateSelectedAncillariesButton(i18n),
									$author$project$Pyxis$Components$Button$secondary)))))
				]));
	});
var $elm_community$html_extra$Html$Extra$viewIf = F2(
	function (condition, html) {
		return condition ? html : $elm_community$html_extra$Html$Extra$nothing;
	});
var $elm_community$html_extra$Html$Extra$viewMaybe = F2(
	function (fn, maybeThing) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm_community$html_extra$Html$Extra$nothing,
			A2($elm$core$Maybe$map, fn, maybeThing));
	});
var $author$project$Common$CoverSelection$renderBody = F3(
	function (i18n, editAncillaryCoversUrl, coverSelection) {
		var ancillaries = coverSelection.mx;
		if (!ancillaries.$) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withContent,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$coversPreAncillariesDescription(i18n))
								]),
							$author$project$Pyxis$Components$Message$neutral($author$project$Pyxis$Components$Message$surfaceStrongBackground)))
					]));
		} else {
			var selectedAncillaries = ancillaries.a;
			var selectableAncillaries = ancillaries.b;
			var selectedWithOnlyReleased = A2(
				$elm$core$List$filter,
				function (a) {
					return a.eX !== 5;
				},
				selectedAncillaries);
			var selectableWithOnlyReleased = A2(
				$elm$core$List$filter,
				function (a) {
					return a.eX !== 5;
				},
				selectableAncillaries);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('covers__cover-selection-container')
					]),
				_List_fromArray(
					[
						A3($author$project$Common$CoverSelection$renderSelectedCovers, i18n, selectedWithOnlyReleased, coverSelection),
						A2($author$project$Common$CoverSelection$renderSelectableCovers, i18n, selectableWithOnlyReleased),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						$author$project$Common$CoverSelection$isUpdateAdditionalCoverButtonVisible(coverSelection),
						A2(
							$elm_community$html_extra$Html$Extra$viewMaybe,
							$author$project$Common$CoverSelection$renderUpdateAncillariesButton(i18n),
							editAncillaryCoversUrl))
					]));
		}
	});
var $author$project$Translations$coversChosenExcessSubtitle = F3(
	function (excess, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Chosen excess'),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(excess)
						]))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Franquicia seleccionada'),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(excess)
						]))
				]);
		}
	});
var $author$project$Common$CoverSelection$renderChosenExcess = F2(
	function (i18n, excess) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__chosen_excess_subtitle')
				]),
			A3(
				$author$project$Translations$coversChosenExcessSubtitle,
				A2($author$project$Common$Price$toStringSignLast, i18n, excess),
				_List_Nil,
				i18n));
	});
var $author$project$Translations$coversSelectedCoverage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover selected';
	} else {
		return 'Cobertura seleccionada';
	}
};
var $author$project$Common$CoverSelection$renderCoverSelectedBadge = function (i18n) {
	return $author$project$Pyxis$Components$Badge$render(
		A2(
			$author$project$Pyxis$Components$Badge$withText,
			$author$project$Translations$coversSelectedCoverage(i18n),
			A2($author$project$Pyxis$Components$Badge$withEmphasis, $author$project$Pyxis$Components$Badge$strong, $author$project$Pyxis$Components$Badge$brand)));
};
var $author$project$Pyxis$Components$Link$Action = 0;
var $author$project$Pyxis$Components$Link$Button = 0;
var $author$project$Pyxis$Components$Link$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Link$config = {
	d4: false,
	d5: 0,
	ga: _List_Nil,
	eg: 0,
	ep: _List_Nil,
	es: false,
	c1: $elm$core$Maybe$Nothing,
	kv: $elm$core$Maybe$Nothing,
	hT: $elm$core$Maybe$Nothing,
	fg: $elm$core$Maybe$Nothing,
	fx: $elm$core$Maybe$Nothing,
	fz: $elm$core$Maybe$Nothing,
	pK: $elm$html$Html$text(''),
	fK: $author$project$Pyxis$Tokens$FontWeight$tokenBold
};
var $author$project$Translations$coversIncludedCoversLink = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'See included covers';
	} else {
		return 'Ver coberturas incluidas';
	}
};
var $author$project$Pyxis$Components$Link$CurrentColor = 1;
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Pyxis$Components$Link$renderTag = function (buttonTag) {
	return buttonTag ? $elm$html$Html$button : $elm$html$Html$a;
};
var $author$project$Pyxis$Components$Link$typeToAttribute = function (type_) {
	switch (type_) {
		case 1:
			return $elm$html$Html$Attributes$type_('submit');
		case 2:
			return $elm$html$Html$Attributes$type_('reset');
		default:
			return $elm$html$Html$Attributes$type_('button');
	}
};
var $author$project$Pyxis$Components$Link$render = function (_v0) {
	var href = _v0.c1;
	var classList = _v0.ga;
	var dataAttrList = _v0.ep;
	var testId = _v0.fz;
	var text = _v0.pK;
	var target = _v0.fx;
	var download = _v0.es;
	var rel = _v0.fg;
	var buttonTag = _v0.d4;
	var buttonType = _v0.d5;
	var onClick = _v0.hT;
	var id = _v0.kv;
	var color = _v0.eg;
	var weight = _v0.fK;
	return A3(
		$author$project$Pyxis$Components$Link$renderTag,
		buttonTag,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$href, href),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$target, target),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$rel, rel),
					A3(
					$author$project$Pyxis$Commons$Basics$ternaryOperator,
					download,
					$elm$html$Html$Attributes$download(''),
					$author$project$Pyxis$Commons$Attributes$none),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onClick, onClick),
					A2(
					$author$project$Pyxis$Commons$Attributes$renderIf,
					buttonTag,
					$author$project$Pyxis$Components$Link$typeToAttribute(buttonType)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('link', true),
							_Utils_Tuple2('link--current-color', color === 1),
							_Utils_Tuple2(
							'link--book',
							_Utils_eq(weight, $author$project$Pyxis$Tokens$FontWeight$tokenBook))
						])),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
				])),
		_List_fromArray(
			[text]));
};
var $author$project$Pyxis$Components$Link$withButtonTag = F2(
	function (buttonTag, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{d4: buttonTag});
	});
var $author$project$Pyxis$Components$Link$withOnClick = F2(
	function (onClick, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hT: $elm$core$Maybe$Just(onClick)
			});
	});
var $author$project$Pyxis$Components$Link$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{pK: text});
	});
var $author$project$Common$CoverSelection$renderTitle = F3(
	function (i18n, openModalMsg, bundle) {
		var linkToEditCoverage = $author$project$Pyxis$Components$Text$render(
			A2(
				$author$project$Pyxis$Components$Text$withFontWeight,
				$author$project$Pyxis$Tokens$FontWeight$tokenBold,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(
						$author$project$Translations$coversIncludedCoversLink(i18n)))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('covers__title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Common$Product$bundleSlugToString, i18n, bundle)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Link$render(
							A2(
								$author$project$Pyxis$Components$Link$withOnClick,
								openModalMsg,
								A2(
									$author$project$Pyxis$Components$Link$withButtonTag,
									true,
									A2($author$project$Pyxis$Components$Link$withText, linkToEditCoverage, $author$project$Pyxis$Components$Link$config))))
						]))
				]));
	});
var $author$project$Common$CoverSelection$render = F4(
	function (i18n, editAncillaryCoversUrl, openModalMsg, coverSelection) {
		var bundle = coverSelection.f4;
		var chosenExcess = coverSelection.f7;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$CoverSelection$renderCoverSelectedBadge(i18n),
					A3($author$project$Common$CoverSelection$renderTitle, i18n, openModalMsg, bundle),
					A2(
					$author$project$Common$Render$maybe,
					$author$project$Common$CoverSelection$renderChosenExcess(i18n),
					chosenExcess),
					A3($author$project$Common$CoverSelection$renderBody, i18n, editAncillaryCoversUrl, coverSelection)
				]));
	});
var $author$project$Common$ErrorContainer$resourceNotFound = A2($author$project$Common$ErrorContainer$custom, 1, 'Resource not found');
var $author$project$Common$Portfolio$renderCoverSelection = F4(
	function (i18n, editAncillaryCoversUrl, _v0, coverSelectionRemoteData) {
		var onShowIncludedCovers = _v0.li;
		switch (coverSelectionRemoteData.$) {
			case 3:
				var coverSelection = coverSelectionRemoteData.a;
				return A4(
					$author$project$Common$CoverSelection$render,
					i18n,
					editAncillaryCoversUrl,
					onShowIncludedCovers(true),
					coverSelection);
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM);
			case 2:
				return $author$project$Common$ErrorContainer$generic;
			default:
				return $author$project$Common$ErrorContainer$resourceNotFound;
		}
	});
var $author$project$Pyxis$Components$Grid$Col$span1 = function (config) {
	return _Utils_update(
		config,
		{dD: $author$project$Pyxis$Components$Grid$SpanSize$span1});
};
var $author$project$Pyxis$Components$Grid$SpanSize$Span2 = 1;
var $author$project$Pyxis$Components$Grid$SpanSize$span2 = 1;
var $author$project$Pyxis$Components$Grid$Col$span2 = function (config) {
	return _Utils_update(
		config,
		{dD: $author$project$Pyxis$Components$Grid$SpanSize$span2});
};
var $author$project$Common$Portfolio$renderCoversTab = F3(
	function (i18n, portfolio, _v0) {
		var coverSelection = _v0.jZ;
		var coversData = _v0.j$;
		var selectedBundleSlug = _v0.lS;
		var editAncillaryCoversUrl = _v0.j8;
		return A3(
			$primait$prima_elm_extra$PrimaFunction$ifThenElse,
			$author$project$Common$CoverContinuity$hasPreviousCoverage(coversData),
			A2(
				$author$project$Pyxis$Components$Grid$render,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span1]),
								_List_fromArray(
									[
										A3($author$project$Common$CoverContinuity$render, i18n, selectedBundleSlug, coversData)
									])),
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span2]),
								_List_fromArray(
									[
										A4($author$project$Common$Portfolio$renderCoverSelection, i18n, editAncillaryCoversUrl, portfolio, coverSelection)
									]))
							]))
					])),
			A2(
				$author$project$Pyxis$Components$Grid$render,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span2]),
								_List_fromArray(
									[
										A4($author$project$Common$Portfolio$renderCoverSelection, i18n, editAncillaryCoversUrl, portfolio, coverSelection)
									])),
								A2(
								$author$project$Pyxis$Components$Grid$col,
								_List_fromArray(
									[$author$project$Pyxis$Components$Grid$Col$span1]),
								_List_fromArray(
									[
										A3($author$project$Common$CoverContinuity$render, i18n, selectedBundleSlug, coversData)
									]))
							]))
					])));
	});
var $author$project$Common$Portfolio$InnerTabsChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$detailsClaimsActionNeededLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Princing action needed';
	} else {
		return 'Acción Pricing';
	}
};
var $author$project$Translations$detailsDocumentIdLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'DNI/NIE';
	} else {
		return 'DNI/NIE';
	}
};
var $author$project$Translations$detailsSincoInfoLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'SINCO info';
	} else {
		return 'Información de SINCO';
	}
};
var $author$project$Common$ClaimHistory$genericItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Pyxis$Components$List$S = 0;
var $author$project$Pyxis$Components$List$sizeS = 0;
var $author$project$Translations$detailsPricingActionUnknownMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The information could not be retrieved';
	} else {
		return 'No se pudo recuperar la información';
	}
};
var $author$project$Common$PricingAction$toString = F2(
	function (i18n, pricingAction) {
		if (!pricingAction.$) {
			var value = pricingAction.a;
			return value;
		} else {
			return $author$project$Translations$detailsPricingActionUnknownMessage(i18n);
		}
	});
var $primait$prima_elm_extra$PrimaFunction$uncurry = F2(
	function (f, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return A2(f, x, y);
	});
var $author$project$Pyxis$Components$List$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Common$ClaimHistory$firstColumnElements = F2(
	function (i18n, claimHistory) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$ClaimHistory$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsDocumentIdLabel(i18n),
					claimHistory.kv),
					_Utils_Tuple2(
					$author$project$Translations$detailsSincoInfoLabel(i18n),
					claimHistory.lW),
					_Utils_Tuple2(
					$author$project$Translations$detailsClaimsActionNeededLabel(i18n),
					A2($author$project$Common$PricingAction$toString, i18n, claimHistory.fN))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$ColumnedDetailsBox = $elm$core$Basics$identity;
var $author$project$Common$ComponentUI$ColumnedDetailsBox$ColumnedDetailsBoxData = F4(
	function (firstColumnElements, secondColumnElements, i18n, title) {
		return {kh: firstColumnElements, ny: i18n, lN: secondColumnElements, i4: title};
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$new = F3(
	function (firstColumnElements, secondColumnElements, i18n) {
		return A4($author$project$Common$ComponentUI$ColumnedDetailsBox$ColumnedDetailsBoxData, firstColumnElements, secondColumnElements, i18n, $elm$core$Maybe$Nothing);
	});
var $author$project$Translations$detailsClaimsDeclaredBySincoLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Claims declared by SINCO';
	} else {
		return 'Siniestros declarados por SINCO';
	}
};
var $author$project$Translations$detailsClaimsDeclaredWithFaultByCustomerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'At-fault claims declared by the customer';
	} else {
		return 'Siniestros con culpa declarados por el cliente';
	}
};
var $author$project$Translations$detailsSincoNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'SINCO number';
	} else {
		return 'Últimos cinco dígitos de la póliza actual';
	}
};
var $author$project$Translations$detailsClaimsCountApproximationSuffix = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'or more';
	} else {
		return 'o más';
	}
};
var $author$project$Common$Count$toString = F2(
	function (i18n, count) {
		switch (count.$) {
			case 0:
				var n = count.a;
				return $elm$core$String$fromInt(n);
			case 1:
				var n = count.a;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							$elm$core$String$fromInt(n),
							$author$project$Translations$detailsClaimsCountApproximationSuffix(i18n)
						]));
			default:
				return '';
		}
	});
var $author$project$Common$ClaimHistory$secondColumnElements = F2(
	function (i18n, claimHistory) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$ClaimHistory$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsSincoNumberLabel(i18n),
					claimHistory.lX),
					_Utils_Tuple2(
					$author$project$Translations$detailsClaimsDeclaredWithFaultByCustomerLabel(i18n),
					A2($author$project$Common$Count$toString, i18n, claimHistory.f8)),
					_Utils_Tuple2(
					$author$project$Translations$detailsClaimsDeclaredBySincoLabel(i18n),
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '-', $elm$core$String$fromInt, claimHistory.jG))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$renderDataDetails = function (_v0) {
	var firstColumnElements = _v0.kh;
	var secondColumnElements = _v0.lN;
	return _Utils_ap(firstColumnElements, secondColumnElements);
};
var $author$project$Pyxis$Components$Title$withFontWeight = F2(
	function (fontWeight, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gG: fontWeight});
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$renderTitle = function (label) {
	return A2(
		$elm_community$html_extra$Html$Extra$viewMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$html$Html$text,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Title$config,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Title$withFontWeight($author$project$Pyxis$Tokens$FontWeight$tokenBold),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Pyxis$Components$Title$withSize($author$project$Pyxis$Tokens$TitleSize$tokenM),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pyxis$Components$Title$withClassList(
								_List_fromArray(
									[
										_Utils_Tuple2('column-info__label', true)
									])),
							$author$project$Pyxis$Components$Title$render))))),
		label);
};
var $author$project$Common$ComponentUI$ColumnedDetailsBox$view = function (_v0) {
	var columnedDetailsBoxData = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('column-info')
			]),
		A2(
			$elm$core$List$cons,
			$author$project$Common$ComponentUI$ColumnedDetailsBox$renderTitle(columnedDetailsBoxData.i4),
			$author$project$Common$ComponentUI$ColumnedDetailsBox$renderDataDetails(columnedDetailsBoxData)));
};
var $author$project$Common$ClaimHistory$view = F2(
	function (i18n, claimHistory) {
		return $author$project$Common$ComponentUI$ColumnedDetailsBox$view(
			A3(
				$author$project$Common$ComponentUI$ColumnedDetailsBox$new,
				A2($author$project$Common$ClaimHistory$firstColumnElements, i18n, claimHistory),
				A2($author$project$Common$ClaimHistory$secondColumnElements, i18n, claimHistory),
				i18n));
	});
var $author$project$Common$Portfolio$renderClaimHistoryTab = F2(
	function (i18n, remoteData) {
		switch (remoteData.$) {
			case 3:
				if (!remoteData.a.$) {
					var claimHistory = remoteData.a.a;
					return A2($author$project$Common$ClaimHistory$view, i18n, claimHistory);
				} else {
					var _v1 = remoteData.a;
					return $author$project$Common$ErrorContainer$resourceNotFound;
				}
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM);
			case 2:
				return $author$project$Common$ErrorContainer$generic;
			default:
				return $author$project$Common$ErrorContainer$resourceNotFound;
		}
	});
var $author$project$Pyxis$Components$Tabs$Tab = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tabs$tab = {bA: $elm$core$Maybe$Nothing, a0: _List_Nil, ep: _List_Nil, gt: false, ku: $elm$core$Maybe$Nothing, eY: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, pK: ''};
var $author$project$Common$Portfolio$tabContent = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('multi-info-container__tab-content')
		]));
var $author$project$Pyxis$Components$Tabs$withContent = F2(
	function (content, _v0) {
		var tab_ = _v0;
		return _Utils_update(
			tab_,
			{a0: content});
	});
var $author$project$Pyxis$Components$Tabs$withText = F2(
	function (text, _v0) {
		var tab_ = _v0;
		return _Utils_update(
			tab_,
			{pK: text});
	});
var $author$project$Common$Portfolio$tabContainer = F2(
	function (label, content) {
		return A2(
			$author$project$Pyxis$Components$Tabs$withContent,
			_List_fromArray(
				[
					$author$project$Common$Portfolio$tabContent(content)
				]),
			A2($author$project$Pyxis$Components$Tabs$withText, label, $author$project$Pyxis$Components$Tabs$tab));
	});
var $author$project$Common$Portfolio$claimHistoryTab = F3(
	function (i18n, label, claimsHistoryData) {
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A2($author$project$Common$Portfolio$renderClaimHistoryTab, i18n, claimsHistoryData)));
	});
var $author$project$Translations$detailsAdditionalDriverLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional driver';
	} else {
		return 'Conductor adicional';
	}
};
var $author$project$Translations$detailsClaimHistoryLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Claims history';
	} else {
		return 'Historial de siniestros';
	}
};
var $author$project$Translations$detailsDriversLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Drivers';
	} else {
		return 'Conductores';
	}
};
var $author$project$Translations$detailsMainDriverLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Main driver';
	} else {
		return 'Conductor principal';
	}
};
var $author$project$Translations$detailsPolicyholderLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policyholder';
	} else {
		return 'Tomador del seguro';
	}
};
var $author$project$Translations$detailsVehicleLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle';
	} else {
		return 'Coche';
	}
};
var $author$project$Translations$detailsVehicleOwnerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle Owner';
	} else {
		return 'Propietario del vehículo';
	}
};
var $author$project$Common$DefaultValues$isDefaultDate = function (value) {
	return _Utils_eq(value, $author$project$Common$DefaultValues$date);
};
var $author$project$Common$DefaultValues$string = '';
var $author$project$Common$DefaultValues$isDefaultString = function (value) {
	return _Utils_eq(value, $author$project$Common$DefaultValues$string);
};
var $author$project$Common$Person$isEmptyAdditionalDriver = function (person) {
	if (person.$ === 1) {
		var firstName = person.a.aG;
		var lastName = person.a.aM;
		var documentId = person.a.aF;
		var dateOfBirth = person.a.aD;
		return $author$project$Common$DefaultValues$isDefaultString(firstName) && ($author$project$Common$DefaultValues$isDefaultString(lastName) && ($author$project$Common$DefaultValues$isDefaultString(documentId) && $author$project$Common$DefaultValues$isDefaultDate(dateOfBirth)));
	} else {
		return false;
	}
};
var $author$project$Translations$detailsDateOfBirthLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Date of birth';
	} else {
		return 'Fecha de nacimiento';
	}
};
var $author$project$Common$Person$genericItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$Person$pickPersonData = function (person) {
	switch (person.$) {
		case 1:
			var personData = person.a;
			return personData;
		case 0:
			var personData = person.a;
			return personData;
		case 2:
			var personData = person.a;
			return personData;
		default:
			var personData = person.a;
			return personData;
	}
};
var $author$project$Common$Person$dateOfBirthItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Common$Person$genericItem(
					$author$project$Translations$detailsDateOfBirthLabel(i18n)),
				$author$project$Common$Locale$formatDate),
			function ($) {
				return $.aD;
			}),
		$author$project$Common$Person$pickPersonData);
};
var $author$project$Common$Person$documentIdItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsDocumentIdLabel(i18n)),
			function ($) {
				return $.aF;
			}),
		$author$project$Common$Person$pickPersonData);
};
var $author$project$Translations$drivingLicenseDateLessThanOneYearText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Less than 1 year old';
	} else {
		return 'Menos de 1 año';
	}
};
var $author$project$Translations$drivingLicenseDateLessThanTwoYearsText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Less than 2 years old';
	} else {
		return 'Menos de 2 años';
	}
};
var $author$project$Translations$drivingLicenseDateMoreThanTwoYearsOld = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'More than 2 years old';
	} else {
		return 'Más de 2 años';
	}
};
var $author$project$Translations$drivingLicenseDateOneToThreeYearsOld = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return '1 to 3 years old';
	} else {
		return '1 a 3 años';
	}
};
var $author$project$Common$Person$additionalDriverDrivingLicenseText = F2(
	function (i18n, drivingLicenseYears) {
		switch (drivingLicenseYears) {
			case 0:
				return $author$project$Translations$drivingLicenseDateLessThanOneYearText(i18n);
			case 1:
				return $author$project$Translations$drivingLicenseDateLessThanTwoYearsText(i18n);
			case 2:
				return $author$project$Translations$drivingLicenseDateOneToThreeYearsOld(i18n);
			default:
				return $author$project$Translations$drivingLicenseDateMoreThanTwoYearsOld(i18n);
		}
	});
var $author$project$Common$Person$mainDriverDrivingLicenseDateText = F2(
	function (i18n, data) {
		var bracketedText = data.eR ? $author$project$Translations$drivingLicenseDateMoreThanTwoYearsOld(i18n) : $author$project$Translations$drivingLicenseDateLessThanTwoYearsText(i18n);
		return data.et + (' (' + (bracketedText + ')'));
	});
var $author$project$Common$Person$drivingLicenseDataText = F2(
	function (i18n, person) {
		switch (person.$) {
			case 1:
				var drivingLicenseYears = person.b;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Common$Person$additionalDriverDrivingLicenseText(i18n),
					drivingLicenseYears);
			case 0:
				var drivingLicenseData = person.d;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Common$Person$mainDriverDrivingLicenseDateText(i18n),
					drivingLicenseData);
			case 2:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Translations$drivingLicenseDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Date of driving license';
	} else {
		return 'Fecha del carné de conducir';
	}
};
var $author$project$Common$Person$drivingLicenseDateItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Person$drivingLicenseDataText(i18n),
		$elm$core$Maybe$map(
			$author$project$Common$Person$genericItem(
				$author$project$Translations$drivingLicenseDateLabel(i18n))));
};
var $author$project$Translations$detailsFullNameLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Full name';
	} else {
		return 'Nombre completo';
	}
};
var $author$project$Common$Person$fullNameItem = function (i18n) {
	var fullName = function (_v0) {
		var firstName = _v0.aG;
		var lastName = _v0.aM;
		return firstName + (' ' + lastName);
	};
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsFullNameLabel(i18n)),
			fullName),
		$author$project$Common$Person$pickPersonData);
};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Common$Person$firstColumnElements = F2(
	function (i18n, person) {
		var items = $elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($author$project$Common$Person$fullNameItem, i18n, person)),
					$elm$core$Maybe$Just(
					A2($author$project$Common$Person$documentIdItem, i18n, person)),
					$elm$core$Maybe$Just(
					A2($author$project$Common$Person$dateOfBirthItem, i18n, person)),
					A2($author$project$Common$Person$drivingLicenseDateItem, i18n, person)
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Translations$detailsAddressLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Address';
	} else {
		return 'Dirección';
	}
};
var $author$project$Common$Person$defaultItemText = '-';
var $author$project$Common$Address$isDefaultAddress = $elm$core$Basics$eq($author$project$Common$Address$defaultAddress);
var $author$project$Common$Person$formatAddress = function (address) {
	return $author$project$Common$Address$isDefaultAddress(address) ? $author$project$Common$Person$defaultItemText : A2(
		$elm$core$String$join,
		', ',
		_List_fromArray(
			[address.pD, address.pE, address.o8, address.pe]));
};
var $author$project$Common$Person$pickAddress = function (person) {
	switch (person.$) {
		case 1:
			return $author$project$Common$Address$defaultAddress;
		case 0:
			var address = person.b;
			return address;
		case 2:
			var address = person.b;
			return address;
		default:
			var address = person.b;
			return address;
	}
};
var $author$project$Common$Person$addressItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsAddressLabel(i18n)),
			$author$project$Common$Person$formatAddress),
		$author$project$Common$Person$pickAddress);
};
var $author$project$Translations$detailsEmailAddressLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Email address';
	} else {
		return 'Correo electrónico';
	}
};
var $author$project$Pyxis$Components$List$ItemAction = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$List$itemAction = F3(
	function (icon, label, msg) {
		return {ku: icon, eY: label, hT: msg};
	});
var $author$project$Pyxis$Components$IconSet$svgPen = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M22.22 3.5L20.5 1.78a3 3 0 0 0-4.24 0L1.88 16.16c-.57.56-.88 1.32-.88 2.12V22c0 .55.45 1 1 1h3.72a2.97 2.97 0 0 0 2.12-.88L22.22 7.74a2.97 2.97 0 0 0 .88-2.12c0-.8-.32-1.55-.88-2.12zM6.43 20.71a1.05 1.05 0 0 1-.71.29H3v-2.72a1.05 1.05 0 0 1 .29-.71L14.74 6.13l3.13 3.13L6.43 20.71zM20.8 6.33l-1.52 1.52-3.13-3.13 1.52-1.52c.39-.39 1.02-.39 1.41 0l1.72 1.72a.99.99 0 0 1 .29.71c.01.26-.1.51-.29.7z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$pen = {eY: 'pen', a: $author$project$Pyxis$Components$IconSet$svgPen};
var $author$project$Pyxis$Components$List$withItemAction = F2(
	function (action, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{
				U: $elm$core$Maybe$Just(action)
			});
	});
var $author$project$Pyxis$Components$List$withItemDataAttrList = F2(
	function (attributes, _v0) {
		var itemConfig = _v0;
		return _Utils_update(
			itemConfig,
			{ep: attributes});
	});
var $author$project$Common$Person$emailItem = F3(
	function (i18n, person, changeAction) {
		var email = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Common$Person$defaultItemText,
			function ($) {
				return $.ew;
			},
			$author$project$Common$Person$pickContacts(person));
		var addActionTo = F2(
			function (item, action) {
				return A2(
					$author$project$Pyxis$Components$List$withItemDataAttrList,
					_List_fromArray(
						[
							_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'edit-policyholder-email')
						]),
					A2(
						$author$project$Pyxis$Components$List$withItemAction,
						A3(
							$author$project$Pyxis$Components$List$itemAction,
							$author$project$Pyxis$Components$IconSet$pen,
							'',
							action(email)),
						item));
			});
		var maybeAddAction = function (item) {
			return A2(
				$elm$core$Maybe$withDefault,
				item,
				A2(
					$elm$core$Maybe$map,
					addActionTo(item),
					changeAction));
		};
		return maybeAddAction(
			A2(
				$author$project$Common$Person$genericItem,
				$author$project$Translations$detailsEmailAddressLabel(i18n),
				email));
	});
var $author$project$Pyxis$Components$List$itemOrientationBlock = 0;
var $author$project$Translations$detailsPhoneNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Phone number';
	} else {
		return 'Número de teléfono';
	}
};
var $author$project$Common$Person$phoneNumberItem = function (i18n) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Common$Person$genericItem(
				$author$project$Translations$detailsPhoneNumberLabel(i18n)),
			A2(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Common$Person$defaultItemText,
				function ($) {
					return $.il;
				})),
		$author$project$Common$Person$pickContacts);
};
var $author$project$Common$Person$secondColumnElements = F4(
	function (i18n, changeEmail, additionalFields, person) {
		var additionFieldsToItems = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$Person$genericItem),
			additionalFields);
		var items = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					A2($author$project$Common$Person$addressItem, i18n, person),
					A3($author$project$Common$Person$emailItem, i18n, person, changeEmail),
					A2($author$project$Common$Person$phoneNumberItem, i18n, person)
				]),
			additionFieldsToItems);
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItemOrientation,
					$author$project$Pyxis$Components$List$itemOrientationBlock,
					A2(
						$author$project$Pyxis$Components$List$withItems,
						items,
						A2(
							$author$project$Pyxis$Components$List$withEmphasis,
							$author$project$Pyxis$Components$List$emphasisText,
							A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl))))));
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$withTitle = F2(
	function (title, _v0) {
		var columnedDetailsBoxData = _v0;
		return _Utils_update(
			columnedDetailsBoxData,
			{
				i4: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComponentUI$ColumnedDetailsBox$withMaybeTitle = F2(
	function (maybeTitle, columnedDetailsBox) {
		if (!maybeTitle.$) {
			var title = maybeTitle.a;
			return A2($author$project$Common$ComponentUI$ColumnedDetailsBox$withTitle, title, columnedDetailsBox);
		} else {
			return columnedDetailsBox;
		}
	});
var $author$project$Common$Person$render = F3(
	function (i18n, person, _v0) {
		var label = _v0.eY;
		var changeEmail = _v0.f6;
		var additionalFields = _v0.fP;
		return $author$project$Common$ComponentUI$ColumnedDetailsBox$view(
			A2(
				$author$project$Common$ComponentUI$ColumnedDetailsBox$withMaybeTitle,
				label,
				A3(
					$author$project$Common$ComponentUI$ColumnedDetailsBox$new,
					A2($author$project$Common$Person$firstColumnElements, i18n, person),
					A4($author$project$Common$Person$secondColumnElements, i18n, changeEmail, additionalFields, person),
					i18n)));
	});
var $author$project$Common$Person$ViewConfig = $elm$core$Basics$identity;
var $author$project$Common$Person$viewConfig = {fP: _List_Nil, f6: $elm$core$Maybe$Nothing, eY: $elm$core$Maybe$Nothing};
var $author$project$Common$Person$withLabel = F2(
	function (label, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eY: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Common$Portfolio$renderPersonFromTuple = F2(
	function (i18n, _v0) {
		var label = _v0.a;
		var person = _v0.b;
		return A3(
			$author$project$Common$Person$render,
			i18n,
			person,
			A2($author$project$Common$Person$withLabel, label, $author$project$Common$Person$viewConfig));
	});
var $author$project$Common$Portfolio$multiPersonTab = F2(
	function (i18n, label) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				$author$project$Common$Portfolio$renderPersonFromTuple(i18n)),
			$author$project$Common$Portfolio$tabContainer(label));
	});
var $author$project$Common$Person$withChangeEmail = F2(
	function (changeEmail, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				f6: $elm$core$Maybe$Just(changeEmail)
			});
	});
var $author$project$Common$Portfolio$personTab = F4(
	function (i18n, changeEmail, label, person) {
		var maybeAddChangeEmail = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Common$Person$withChangeEmail),
			$elm$core$Maybe$withDefault($elm$core$Basics$identity));
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A3(
					$author$project$Common$Person$render,
					i18n,
					person,
					A2(maybeAddChangeEmail, changeEmail, $author$project$Common$Person$viewConfig))));
	});
var $author$project$Translations$detailsCustomerIdLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer Id';
	} else {
		return 'ID cliente';
	}
};
var $author$project$Common$Person$withAdditionalFields = F2(
	function (additionalFields, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{fP: additionalFields});
	});
var $author$project$Common$Portfolio$policyHolderTab = F5(
	function (i18n, changeEmail, label, customerId, person) {
		var maybeAddChangeEmail = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Common$Person$withChangeEmail),
			$elm$core$Maybe$withDefault($elm$core$Basics$identity));
		var additionalFields = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$pair(
						$author$project$Translations$detailsCustomerIdLabel(i18n)),
					$elm$core$List$singleton),
				customerId));
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A3(
					$author$project$Common$Person$render,
					i18n,
					person,
					A2(
						$author$project$Common$Person$withAdditionalFields,
						additionalFields,
						A2(maybeAddChangeEmail, changeEmail, $author$project$Common$Person$viewConfig)))));
	});
var $author$project$Translations$detailsPlateNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Plate';
	} else {
		return 'Matrícula';
	}
};
var $author$project$Translations$detailsVehicleBrandLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Brand';
	} else {
		return 'Marca';
	}
};
var $author$project$Translations$detailsVehicleMileageLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Annual KM';
	} else {
		return 'Kilometraje anual';
	}
};
var $author$project$Translations$detailsVehicleRegistrationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Registration';
	} else {
		return 'Fecha 1° matriculación';
	}
};
var $author$project$Common$Vehicle$genericItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$Vehicle$pickBrand = function (_v0) {
	var vehicle = _v0;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[vehicle.ho, vehicle.hx, vehicle.jj]));
};
var $author$project$Common$Vehicle$pickMileage = function (_v0) {
	var vehicle = _v0;
	return vehicle.hu;
};
var $author$project$Common$Vehicle$pickPlateNumber = function (_v0) {
	var vehicle = _v0;
	return vehicle.$9;
};
var $author$project$Common$Vehicle$pickRegistrationDate = function (_v0) {
	var vehicle = _v0;
	return vehicle.iD;
};
var $author$project$Common$Vehicle$firstColumnElements = F2(
	function (i18n, vehicle) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$Vehicle$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsPlateNumberLabel(i18n),
					$author$project$Common$Vehicle$pickPlateNumber(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleBrandLabel(i18n),
					$author$project$Common$Vehicle$pickBrand(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleMileageLabel(i18n),
					$author$project$Common$Vehicle$pickMileage(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleRegistrationDateLabel(i18n),
					$author$project$Common$Vehicle$pickRegistrationDate(vehicle))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Translations$detailsVehicleAccessoriesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Accessories';
	} else {
		return 'Accessories';
	}
};
var $author$project$Translations$detailsVehicleEnginePowerLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Power';
	} else {
		return 'Potencia';
	}
};
var $author$project$Translations$detailsVehicleFuelTypeLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Fuel type';
	} else {
		return 'Combustible';
	}
};
var $author$project$Translations$detailsVehicleUsageLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Usage';
	} else {
		return 'Uso';
	}
};
var $author$project$Common$Vehicle$enginePowerMeasureUnit = 'CV';
var $author$project$Common$Vehicle$formatEnginePower = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$String$append, ' ' + $author$project$Common$Vehicle$enginePowerMeasureUnit));
var $author$project$Common$Vehicle$pickAccessories = function (_v0) {
	var vehicle = _v0;
	return vehicle.fL;
};
var $author$project$Common$Vehicle$pickEnginePower = function (_v0) {
	var vehicle = _v0;
	return vehicle.gB;
};
var $author$project$Common$Vehicle$pickFuelType = function (_v0) {
	var vehicle = _v0;
	return vehicle.gL;
};
var $author$project$Common$Vehicle$pickUsage = function (_v0) {
	var vehicle = _v0;
	return vehicle.i8;
};
var $author$project$Common$Vehicle$secondColumnElements = F2(
	function (i18n, vehicle) {
		var items = A2(
			$elm$core$List$map,
			$primait$prima_elm_extra$PrimaFunction$uncurry($author$project$Common$Vehicle$genericItem),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleFuelTypeLabel(i18n),
					$author$project$Common$Vehicle$pickFuelType(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleEnginePowerLabel(i18n),
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'-',
						$author$project$Common$Vehicle$formatEnginePower,
						$author$project$Common$Vehicle$pickEnginePower(vehicle))),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleUsageLabel(i18n),
					$author$project$Common$Vehicle$pickUsage(vehicle)),
					_Utils_Tuple2(
					$author$project$Translations$detailsVehicleAccessoriesLabel(i18n),
					A2(
						$elm$core$String$join,
						', ',
						$author$project$Common$Vehicle$pickAccessories(vehicle)))
				]));
		return $elm$core$List$singleton(
			$author$project$Pyxis$Components$List$render(
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$Vehicle$view = F2(
	function (i18n, vehicle) {
		return $author$project$Common$ComponentUI$ColumnedDetailsBox$view(
			A3(
				$author$project$Common$ComponentUI$ColumnedDetailsBox$new,
				A2($author$project$Common$Vehicle$firstColumnElements, i18n, vehicle),
				A2($author$project$Common$Vehicle$secondColumnElements, i18n, vehicle),
				i18n));
	});
var $author$project$Common$Portfolio$vehicleTab = F3(
	function (i18n, label, vehicle) {
		return A2(
			$author$project$Common$Portfolio$tabContainer,
			label,
			$elm$core$List$singleton(
				A2($author$project$Common$Vehicle$view, i18n, vehicle)));
	});
var $author$project$Common$Portfolio$multiInfoTabsConfig = F2(
	function (i18n, _v0) {
		var policyHolder = _v0.io;
		var customerId = _v0.gm;
		var vehicle = _v0.je;
		var vehicleOwner = _v0.me;
		var mainDriver = _v0.kP;
		var additionalDriver = _v0.jq;
		var claimsHistory = _v0.jH;
		var onChangingEmail = _v0.hS;
		var additionalDriverTab = $author$project$Common$Person$isEmptyAdditionalDriver(additionalDriver) ? A4(
			$author$project$Common$Portfolio$personTab,
			i18n,
			$elm$core$Maybe$Nothing,
			$author$project$Translations$detailsMainDriverLabel(i18n),
			mainDriver) : A3(
			$author$project$Common$Portfolio$multiPersonTab,
			i18n,
			$author$project$Translations$detailsDriversLabel(i18n),
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Translations$detailsMainDriverLabel(i18n),
					mainDriver),
					_Utils_Tuple2(
					$author$project$Translations$detailsAdditionalDriverLabel(i18n),
					additionalDriver)
				]));
		return _List_fromArray(
			[
				A5(
				$author$project$Common$Portfolio$policyHolderTab,
				i18n,
				onChangingEmail,
				$author$project$Translations$detailsPolicyholderLabel(i18n),
				customerId,
				policyHolder),
				A3(
				$author$project$Common$Portfolio$vehicleTab,
				i18n,
				$author$project$Translations$detailsVehicleLabel(i18n),
				vehicle),
				A4(
				$author$project$Common$Portfolio$personTab,
				i18n,
				$elm$core$Maybe$Nothing,
				$author$project$Translations$detailsVehicleOwnerLabel(i18n),
				vehicleOwner),
				additionalDriverTab,
				A3(
				$author$project$Common$Portfolio$claimHistoryTab,
				i18n,
				$author$project$Translations$detailsClaimHistoryLabel(i18n),
				claimsHistory)
			]);
	});
var $author$project$Pyxis$Components$Tabs$getAccessibleDescriptionId = function (id) {
	return id + '-accessible-description';
};
var $author$project$Pyxis$Components$Tabs$renderAccessibleDescription = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$text,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$span(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sr-only'),
						$elm$html$Html$Attributes$id(id)
					]))));
};
var $author$project$Pyxis$Components$Tabs$Center = 1;
var $author$project$Pyxis$Components$Tabs$Pill = 1;
var $author$project$Pyxis$Components$Tabs$Right = 2;
var $author$project$Pyxis$Components$Tabs$getTablistClasses = function (_v0) {
	var variant = _v0.jd;
	var hasBorder = _v0.gT;
	var placement = _v0.aa;
	return _List_fromArray(
		[
			_Utils_Tuple2('tabs__tablist', true),
			_Utils_Tuple2('tabs__tablist--with-pills', 1 === variant),
			_Utils_Tuple2('tabs__tablist--with-border', hasBorder),
			_Utils_Tuple2('justify-content-center', placement === 1),
			_Utils_Tuple2('justify-content-flex-end', placement === 2)
		]);
};
var $author$project$Pyxis$Components$Tabs$offsetAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append('--offset: '),
			$elm$html$Html$Attributes$attribute('style'))));
var $author$project$Pyxis$Components$Tabs$OnClick = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Tabs$OnKeyDown = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Pyxis$Components$Tabs$StopPanelAnimation = {$: 2};
var $author$project$Pyxis$Commons$Attributes$ariaSelected = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-selected'));
var $author$project$Pyxis$Components$Tabs$getEnabledIndexesFromTabs = function (tabs) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var index = _v0.a;
			var tabData = _v0.b;
			return (!tabData.gt) ? $elm$core$Maybe$Just(index) : $elm$core$Maybe$Nothing;
		},
		A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, tabs));
};
var $author$project$Pyxis$Components$Tabs$getTabPanelId = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		$elm$core$Basics$append(id + '-tabpanel-'));
};
var $author$project$Pyxis$Components$Tabs$handleKeyDown = F2(
	function (msg, key) {
		return _Utils_Tuple2(
			msg(key),
			A2(
				$elm$core$List$any,
				function (check) {
					return check(key);
				},
				_List_fromArray(
					[$author$project$Pyxis$Commons$Events$Keyboard$isArrowLeft, $author$project$Pyxis$Commons$Events$Keyboard$isArrowRight, $author$project$Pyxis$Commons$Events$Keyboard$isHome, $author$project$Pyxis$Commons$Events$Keyboard$isEnd])));
	});
var $author$project$Pyxis$Commons$Events$Keyboard$Event = $elm$core$Basics$identity;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Pyxis$Commons$Events$Keyboard$decoder = function (tagger) {
	return A6(
		$elm$json$Json$Decode$map5,
		F5(
			function (keyCode, key, ctrlKey, shiftKey, innerHtml) {
				return tagger(
					{mW: ctrlKey, ky: innerHtml, eW: key, nL: keyCode, py: shiftKey});
			}),
		A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
		A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A2($elm$json$Json$Decode$field, 'innerHTML', $elm$json$Json$Decode$string)));
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Pyxis$Commons$Events$Keyboard$onPreventDefaultOn = F2(
	function (event, tagger) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			$author$project$Pyxis$Commons$Events$Keyboard$decoder(tagger));
	});
var $author$project$Pyxis$Components$Tabs$renderTabBadge = function (badge) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tab__addon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Badge$render(badge)
			]));
};
var $author$project$Pyxis$Components$Tabs$renderTabIcon = function (icon) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tab__icon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				$author$project$Pyxis$Components$Icon$config(icon))
			]));
};
var $author$project$Pyxis$Components$Tabs$renderTabLabel = function (label) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tab__addon')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pyxis$Components$Tabs$renderTabLine = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('tab__line')
		]),
	_List_Nil);
var $author$project$Pyxis$Components$Tabs$renderTab = F5(
	function (tagger, _v0, _v1, index, _v2) {
		var activeIndex = _v0.V;
		var previousActiveIndex = _v0.du;
		var id = _v1.kv;
		var tabs = _v1.dP;
		var variant = _v1.jd;
		var tabConfig = _v2;
		var isPanelTransitioning = _Utils_eq(activeIndex, index) && $elm_community$maybe_extra$Maybe$Extra$isJust(previousActiveIndex);
		var panelTransitionEndEvent = isPanelTransitioning ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'animationend',
				$elm$json$Json$Decode$succeed($author$project$Pyxis$Components$Tabs$StopPanelAnimation)),
				A2(
				$elm$html$Html$Events$on,
				'transitionend',
				$elm$json$Json$Decode$succeed($author$project$Pyxis$Components$Tabs$StopPanelAnimation))
			]) : _List_Nil;
		var enabledTabIndexes = $author$project$Pyxis$Components$Tabs$getEnabledIndexesFromTabs(tabs);
		return A2(
			$elm$html$Html$map,
			tagger,
			A2(
				$elm$html$Html$button,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					tabConfig.ep,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Attributes$ariaSelected(
								_Utils_eq(activeIndex, index)),
								$author$project$Pyxis$Commons$Attributes$ariaControls(
								A2($author$project$Pyxis$Components$Tabs$getTabPanelId, id, index)),
								$author$project$Pyxis$Commons$Attributes$role('tab'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('tab', true),
										_Utils_Tuple2('tab--pills', variant === 1)
									])),
								$elm$html$Html$Attributes$id(
								A2($author$project$Pyxis$Components$Tabs$getTabId, id, index)),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, tabConfig.fz),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$tabindex(
								A3(
									$primait$prima_elm_extra$PrimaFunction$ifThenElse,
									_Utils_eq(activeIndex, index),
									0,
									-1)),
								$elm$html$Html$Attributes$disabled(tabConfig.gt),
								$elm$html$Html$Events$onClick(
								$author$project$Pyxis$Components$Tabs$OnClick(index)),
								A2(
								$author$project$Pyxis$Commons$Events$Keyboard$onPreventDefaultOn,
								'keydown',
								$author$project$Pyxis$Components$Tabs$handleKeyDown(
									A2($author$project$Pyxis$Components$Tabs$OnKeyDown, enabledTabIndexes, id)))
							]),
						panelTransitionEndEvent)),
				_List_fromArray(
					[
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tabs$renderTabIcon, tabConfig.ku)),
						$elm$html$Html$text(tabConfig.pK),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tabs$renderTabBadge, tabConfig.bA)),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tabs$renderTabLabel, tabConfig.eY)),
						A2($author$project$Pyxis$Commons$Render$renderIf, !variant, $author$project$Pyxis$Components$Tabs$renderTabLine)
					])));
	});
var $author$project$Pyxis$Components$Tabs$renderTabList = F3(
	function (tagger, model, config_) {
		var accessibleDescription = config_.d0;
		var customMobileOffset = config_.gl;
		var id = config_.kv;
		var tabs = config_.dP;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tabs__tablist-wrapper tabs__tablist-wrapper--mask-both-on-xs'),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Tabs$offsetAttribute, customMobileOffset)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Commons$Attributes$renderIf,
								$elm_community$maybe_extra$Maybe$Extra$isJust(accessibleDescription),
								$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
									$author$project$Pyxis$Components$Tabs$getAccessibleDescriptionId(id))),
								$author$project$Pyxis$Commons$Attributes$role('tablist'),
								$elm$html$Html$Attributes$classList(
								$author$project$Pyxis$Components$Tabs$getTablistClasses(config_))
							]),
						A2(
							$elm$core$List$indexedMap,
							A3($author$project$Pyxis$Components$Tabs$renderTab, tagger, model, config_),
							tabs))
					]))
			]);
	});
var $author$project$Pyxis$Components$Tabs$Fade = 1;
var $author$project$Pyxis$Components$Tabs$isTabPanelActive = $elm$core$Basics$eq;
var $author$project$Pyxis$Components$Tabs$isTabPanelEntering = F2(
	function (previousActiveIndex, panelIndex) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Components$Tabs$isTabPanelActive(panelIndex),
			$elm$core$Basics$and(
				$elm_community$maybe_extra$Maybe$Extra$isJust(previousActiveIndex)));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelEnteringLeftToRight = F2(
	function (previousActiveIndex, panelIndex) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pyxis$Components$Tabs$isTabPanelEntering, previousActiveIndex, panelIndex),
			$elm$core$Basics$and(
				_Utils_cmp(
					A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
					panelIndex) > 0));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelEnteringRightToLeft = F2(
	function (previousActiveIndex, panelIndex) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pyxis$Components$Tabs$isTabPanelEntering, previousActiveIndex, panelIndex),
			$elm$core$Basics$and(
				_Utils_cmp(
					A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
					panelIndex) < 0));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExiting = F2(
	function (previousActiveIndex, panelIndex) {
		return $elm_community$maybe_extra$Maybe$Extra$isJust(previousActiveIndex) && _Utils_eq(
			A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
			panelIndex);
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExitingLeftToRight = F3(
	function (previousActiveIndex, panelIndex, activeIndex) {
		return A2($author$project$Pyxis$Components$Tabs$isTabPanelExiting, previousActiveIndex, panelIndex) && (_Utils_cmp(
			A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
			activeIndex) > 0);
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExitingRightToLeft = F3(
	function (previousActiveIndex, panelIndex, activeIndex) {
		return A2($author$project$Pyxis$Components$Tabs$isTabPanelExiting, previousActiveIndex, panelIndex) && (_Utils_cmp(
			A2($elm$core$Maybe$withDefault, 0, previousActiveIndex),
			activeIndex) < 0);
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelExited = F2(
	function (previousActiveIndex, panelIndex) {
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(previousActiveIndex) || (!A2($author$project$Pyxis$Components$Tabs$isTabPanelExiting, previousActiveIndex, panelIndex));
	});
var $author$project$Pyxis$Components$Tabs$isTabPanelHidden = F4(
	function (previousActiveIndex, panelIndex, activeIndex, panelTransition) {
		return (panelTransition === 1) ? (!A2($author$project$Pyxis$Components$Tabs$isTabPanelActive, panelIndex, activeIndex)) : ((!A2($author$project$Pyxis$Components$Tabs$isTabPanelActive, panelIndex, activeIndex)) && A2($author$project$Pyxis$Components$Tabs$isTabPanelExited, previousActiveIndex, panelIndex));
	});
var $author$project$Pyxis$Components$Tabs$renderTabPanel = F4(
	function (_v0, _v1, index, _v2) {
		var activeIndex = _v0.V;
		var previousActiveIndex = _v0.du;
		var id = _v1.kv;
		var panelTransition = _v1.ih;
		var tabConfig = _v2;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
					A2($author$project$Pyxis$Components$Tabs$getTabId, id, index)),
					$author$project$Pyxis$Commons$Attributes$role('tabpanel'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('tabs__tab-panel', true),
							_Utils_Tuple2(
							'tabs__tab-panel--hidden',
							A4($author$project$Pyxis$Components$Tabs$isTabPanelHidden, previousActiveIndex, index, activeIndex, panelTransition)),
							_Utils_Tuple2(
							'tabs__tab-panel--entering-left-to-right',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelEnteringLeftToRight, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--entering-right-to-left',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelEnteringRightToLeft, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--exiting-left-to-right',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelExitingLeftToRight, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--exiting-right-to-left',
							(!panelTransition) && A3($author$project$Pyxis$Components$Tabs$isTabPanelExitingRightToLeft, previousActiveIndex, index, activeIndex)),
							_Utils_Tuple2(
							'tabs__tab-panel--fading-in',
							(panelTransition === 1) && A3($author$project$Pyxis$Components$Tabs$isTabPanelEntering, previousActiveIndex, index, activeIndex))
						])),
					$elm$html$Html$Attributes$id(
					A2($author$project$Pyxis$Components$Tabs$getTabPanelId, id, index))
				]),
			tabConfig.a0);
	});
var $author$project$Pyxis$Components$Tabs$renderTabPanelList = F2(
	function (model, config_) {
		var tabs = config_.dP;
		return A2(
			$elm$core$List$indexedMap,
			A2($author$project$Pyxis$Components$Tabs$renderTabPanel, model, config_),
			tabs);
	});
var $author$project$Pyxis$Components$Tabs$render = F3(
	function (tagger, model, config_) {
		var conf = config_;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				conf.ep,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2('tabs', true),
							conf.ga)),
						$elm$html$Html$Attributes$id(conf.kv),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, conf.fz)
					])),
			$elm$core$List$concat(
				_List_fromArray(
					[
						$elm$core$List$singleton(
						$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								$author$project$Pyxis$Components$Tabs$renderAccessibleDescription(
									$author$project$Pyxis$Components$Tabs$getAccessibleDescriptionId(conf.kv)),
								conf.d0))),
						A3($author$project$Pyxis$Components$Tabs$renderTabList, tagger, model, config_),
						A2($author$project$Pyxis$Components$Tabs$renderTabPanelList, model, config_)
					])));
	});
var $author$project$Pyxis$Components$Tabs$withBorder = F2(
	function (hasBorder, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{gT: hasBorder});
	});
var $author$project$Pyxis$Components$Tabs$withClassList = F2(
	function (classList, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{ga: classList});
	});
var $author$project$Pyxis$Components$Tabs$withTabs = F2(
	function (tabs, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{dP: tabs});
	});
var $author$project$Pyxis$Components$Tabs$withTestId = F2(
	function (id, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				fz: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Common$Portfolio$renderMultiInfo = F3(
	function (i18n, _v0, configuration) {
		var innerTabs = _v0.eK;
		var tagger = _v0.i$;
		return A3(
			$author$project$Pyxis$Components$Tabs$render,
			A2($elm$core$Basics$composeR, $author$project$Common$Portfolio$InnerTabsChanged, tagger),
			innerTabs,
			A2(
				$author$project$Pyxis$Components$Tabs$withTabs,
				A2($author$project$Common$Portfolio$multiInfoTabsConfig, i18n, configuration),
				A2(
					$author$project$Pyxis$Components$Tabs$withBorder,
					true,
					A2(
						$author$project$Pyxis$Components$Tabs$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('multi-info-container', true)
							]),
						A2(
							$author$project$Pyxis$Components$Tabs$withTestId,
							'multi-info',
							$author$project$Pyxis$Components$Tabs$config(''))))));
	});
var $author$project$Pyxis$Components$IconSet$svgShieldCheck = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 3.04c1.26 1.1 3.5 2.48 7 2.85V13v.05c0 .06.09 6.42-6.35 8.67-.21.07-.42.11-.65.11s-.44-.04-.65-.11C4.98 19.5 5 13.3 5 13.05V13l-.03-7.1C8.5 5.52 10.74 4.14 12 3.04m0-2.01a1.97 1.97 0 0 0-1.3.49c-1.09.95-2.96 2.07-5.95 2.39-1 .11-1.75.97-1.75 1.98V13s-.2 7.85 7.69 10.61c.42.15.86.22 1.31.22s.89-.07 1.31-.22C21.2 20.85 21 13 21 13V5.89c0-1.01-.75-1.87-1.75-1.98-2.98-.32-4.86-1.44-5.95-2.39a1.97 1.97 0 0 0-1.3-.49h0zM11.5 16c-.26 0-.51-.1-.71-.29l-2.29-2.3c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0l1.59 1.59L15.09 10c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-4.29 4.29c-.2.2-.45.3-.71.3z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$shieldCheck = {eY: 'shield-check', a: $author$project$Pyxis$Components$IconSet$svgShieldCheck};
var $author$project$Pyxis$Components$Tabs$withIcon = F2(
	function (icon, _v0) {
		var tab_ = _v0;
		return _Utils_update(
			tab_,
			{
				ku: $elm$core$Maybe$Just(icon)
			});
	});
var $author$project$Common$Portfolio$outerTabsConfig = F3(
	function (i18n, portfolio, configuration) {
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Tabs$withContent,
				_List_fromArray(
					[
						A3($author$project$Common$Portfolio$renderMultiInfo, i18n, portfolio, configuration)
					]),
				A2(
					$author$project$Pyxis$Components$Tabs$withIcon,
					$author$project$Pyxis$Components$IconSet$chart,
					A2(
						$author$project$Pyxis$Components$Tabs$withText,
						$author$project$Translations$detailsPortfolioDataLabel(i18n),
						$author$project$Pyxis$Components$Tabs$tab))),
				A2(
				$author$project$Pyxis$Components$Tabs$withContent,
				_List_fromArray(
					[
						A3($author$project$Common$Portfolio$renderCoversTab, i18n, portfolio, configuration)
					]),
				A2(
					$author$project$Pyxis$Components$Tabs$withIcon,
					$author$project$Pyxis$Components$IconSet$shieldCheck,
					A2(
						$author$project$Pyxis$Components$Tabs$withText,
						$author$project$Translations$detailsPortfolioCoverLabel(i18n),
						$author$project$Pyxis$Components$Tabs$tab)))
			]);
	});
var $author$project$Pyxis$Components$Tabs$pill = 1;
var $author$project$Translations$detailsPortfolioEditInformationLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Edit information';
	} else {
		return 'Edita la información';
	}
};
var $author$project$Common$Render$when = F2(
	function (condition, content) {
		return condition ? content : $author$project$Common$Render$empty;
	});
var $author$project$Common$Portfolio$renderEditButton = F3(
	function (i18n, isDataTabSelected, redirectUrl) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(redirectUrl),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Render$when,
					isDataTabSelected,
					$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withDataAttrList,
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$Tracker$customActionAttributeName, 'edit-offer-information')
								]),
							A2(
								$author$project$Pyxis$Components$Button$withIconAppend,
								$author$project$Pyxis$Components$IconSet$pen,
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeS,
									A2(
										$author$project$Pyxis$Components$Button$withClassList,
										_List_fromArray(
											[
												_Utils_Tuple2('portfolio-container__edit-button', true)
											]),
										A2(
											$author$project$Pyxis$Components$Button$withText,
											$author$project$Translations$detailsPortfolioEditInformationLabel(i18n),
											$author$project$Pyxis$Components$Button$ghost)))))))
				]));
	});
var $author$project$Translations$detailsPortfolioEditCoverageLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Edit coverage';
	} else {
		return 'Edita la cobertura';
	}
};
var $author$project$Common$Portfolio$renderEditCoverageButton = F3(
	function (i18n, isCoverageTabSelected, redirectUrl) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(redirectUrl),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Render$when,
					isCoverageTabSelected,
					$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withIconAppend,
							$author$project$Pyxis$Components$IconSet$pen,
							A2(
								$author$project$Pyxis$Components$Button$withSize,
								$author$project$Pyxis$Components$Button$sizeS,
								A2(
									$author$project$Pyxis$Components$Button$withClassList,
									_List_fromArray(
										[
											_Utils_Tuple2('portfolio-container__edit-button', true)
										]),
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$detailsPortfolioEditCoverageLabel(i18n),
										$author$project$Pyxis$Components$Button$ghost))))))
				]));
	});
var $author$project$Pyxis$Components$Tabs$withVariant = F2(
	function (variant, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{jd: variant});
	});
var $author$project$Common$Portfolio$render = F3(
	function (i18n, model, configuration) {
		var tagger = model.i$;
		var outerTabs = model.b7;
		var editRedirectUrl = model.gx;
		var editCoverageUrl = model.gw;
		var isDataTabSelected = !$author$project$Pyxis$Components$Tabs$getActiveTabIndex(outerTabs);
		var isCoverageTabSelected = $author$project$Pyxis$Components$Tabs$getActiveTabIndex(outerTabs) === 1;
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('portfolio-container padding-xl radius-xl'),
					$elm$html$Html$Attributes$id('portfolio-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Render$maybe,
					A2($author$project$Common$Portfolio$renderEditButton, i18n, isDataTabSelected),
					editRedirectUrl),
					A2(
					$author$project$Common$Render$maybe,
					A2($author$project$Common$Portfolio$renderEditCoverageButton, i18n, isCoverageTabSelected),
					editCoverageUrl),
					A3(
					$author$project$Pyxis$Components$Tabs$render,
					A2($elm$core$Basics$composeR, $author$project$Common$Portfolio$OuterTabsChanged, tagger),
					outerTabs,
					A2(
						$author$project$Pyxis$Components$Tabs$withTabs,
						A3($author$project$Common$Portfolio$outerTabsConfig, i18n, model, configuration),
						A2(
							$author$project$Pyxis$Components$Tabs$withVariant,
							$author$project$Pyxis$Components$Tabs$pill,
							A2(
								$author$project$Pyxis$Components$Tabs$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('portfolio-tabs-group', true)
									]),
								A2(
									$author$project$Pyxis$Components$Tabs$withTestId,
									'portfolio-tabs-group',
									$author$project$Pyxis$Components$Tabs$config('porfolio-tabs-group'))))))
				]));
	});
var $author$project$Pyxis$Components$Message$Alert = 2;
var $author$project$Pyxis$Components$Message$alert = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 2, style);
};
var $author$project$Translations$gliseRenewalBannerMessage = F2(
	function (bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Attention!')
						])),
					$elm$html$Html$text(' This offer is from Great Lakes Insurance SE. We cannot refer to renewal.')
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('¡Atención!')
						])),
					$elm$html$Html$text(' Esta oferta es de Great Lakes Insurance SE. No podemos hablar de renovación.')
				]);
		}
	});
var $author$project$Pyxis$Components$Message$Tint = 2;
var $author$project$Pyxis$Components$Message$tintBackground = 2;
var $author$project$Pyxis$Components$Message$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Page$OfferDetails$View$renderGreatLakesBanner = function (i18n) {
	return $author$project$Pyxis$Components$Message$render(
		A2(
			$author$project$Pyxis$Components$Message$withContent,
			A2($author$project$Translations$gliseRenewalBannerMessage, _List_Nil, i18n),
			A2(
				$author$project$Pyxis$Components$Message$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('search-result__offer__great-lakes-banner', true)
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
};
var $justinmimbs$date$Date$fromOrdinalDate = F2(
	function (y, od) {
		var daysInYear = $justinmimbs$date$Date$isLeapYear(y) ? 366 : 365;
		return $justinmimbs$date$Date$daysBeforeYear(y) + A3($elm$core$Basics$clamp, 1, daysInYear, od);
	});
var $elm_community$maybe_extra$Maybe$Extra$unpack = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default(0);
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Common$TimeHelper$tomorrow = function (currentDate) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unpack,
		function (_v0) {
			return A2($justinmimbs$date$Date$fromOrdinalDate, 1970, 1);
		},
		function (today) {
			return A3($justinmimbs$date$Date$add, 3, 1, today);
		},
		currentDate);
};
var $author$project$Common$ComponentUI$DetailsResultBox$Offer = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Common$Offer$pickIssuingCompany = function (_v0) {
	var offer = _v0;
	return offer.dx.a8;
};
var $author$project$Common$ComponentUI$DetailsResultBox$newOfferViewConfiguration = F5(
	function (i18n, currentDate, actions, offer, isCoverSelectionLoading) {
		return A2(
			$author$project$Common$ComponentUI$DetailsResultBox$Offer,
			{
				ny: i18n,
				a8: $author$project$Common$Offer$pickIssuingCompany(offer),
				bj: $author$project$Common$Offer$totalPrice(offer)
			},
			{gj: currentDate, g4: isCoverSelectionLoading, G: offer, hP: actions.hO, hW: actions.hV, h9: actions.h8});
	});
var $author$project$Pyxis$Components$Divider$orientationHorizontal = 0;
var $author$project$Pyxis$Components$Divider$thicknessS = 0;
var $author$project$Pyxis$Components$Divider$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Pyxis$Components$Divider$withOrientation = F2(
	function (orientation, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ig: orientation});
	});
var $author$project$Pyxis$Components$Divider$withThickness = F2(
	function (thickness, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{i3: thickness});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$horizontalDivider = $author$project$Pyxis$Components$Divider$render(
	A2(
		$author$project$Pyxis$Components$Divider$withClassList,
		_List_fromArray(
			[
				_Utils_Tuple2('details__divider-horizontal', true)
			]),
		A2(
			$author$project$Pyxis$Components$Divider$withOrientation,
			$author$project$Pyxis$Components$Divider$orientationHorizontal,
			A2($author$project$Pyxis$Components$Divider$withThickness, $author$project$Pyxis$Components$Divider$thicknessS, $author$project$Pyxis$Components$Divider$config))));
var $author$project$Translations$detailsAmendBoxLink = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Click here';
	} else {
		return 'Clica aquí';
	}
};
var $author$project$Translations$detailsAmendBoxMessageDateInfo = F2(
	function (tomorrow, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'change the starting date to: ' + (tomorrow + ' 00:00 CET');
		} else {
			return 'para cambiar la fecha de entrada en vigor a: ' + (tomorrow + ' 00:00 CET');
		}
	});
var $author$project$Translations$detailsAmendBoxSubMessage = F2(
	function (strongAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('If the customer prefers a start date other than tomorrow, you must go to the '),
					A3(
					$elm$html$Html$node,
					'strong',
					_Utils_ap(_List_Nil, strongAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Edit information')
						])),
					$elm$html$Html$text(' section to change it.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Si el cliente prefiere una fecha de inicio distinta a la de mañana, debes dirigirte a la sección '),
					A3(
					$elm$html$Html$node,
					'strong',
					_Utils_ap(_List_Nil, strongAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(' Editar información')
						])),
					$elm$html$Html$text('para cambiarla.')
				]);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderAmendSubMessage = function (message) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withSize,
			$author$project$Pyxis$Tokens$TextSize$tokenM,
			$author$project$Pyxis$Components$Text$config(
				A2($elm$html$Html$div, _List_Nil, message))));
};
var $author$project$Common$ComponentUI$DetailsResultBox$tomorrowString = function (today) {
	return $author$project$Common$Locale$formatDate(
		$author$project$Common$TimeHelper$tomorrow(today));
};
var $author$project$Common$ComponentUI$DetailsResultBox$amendMessageWithLink = F3(
	function (i18n, currentDate, onClickEvent) {
		return $author$project$Pyxis$Components$Message$render(
			A2(
				$author$project$Pyxis$Components$Message$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__link'),
								$elm$html$Html$Events$onClick(onClickEvent)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$detailsAmendBoxLink(i18n))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__amend-date-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								' ' + A2(
									$author$project$Translations$detailsAmendBoxMessageDateInfo,
									$author$project$Common$ComponentUI$DetailsResultBox$tomorrowString(currentDate),
									i18n))
							])),
						$author$project$Common$ComponentUI$DetailsResultBox$renderAmendSubMessage(
						A2($author$project$Translations$detailsAmendBoxSubMessage, _List_Nil, i18n))
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground)));
	});
var $author$project$Common$Offer$isAmendStartDateAction = function (action) {
	if (action.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$canBeAmended = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isAmendStartDateAction, offer.aY);
};
var $author$project$Common$ComponentUI$DetailsResultBox$isOfferAmendable = function (offer) {
	return $author$project$Common$Offer$canBeAmended(offer);
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewAmendOfferIfAmendable = function (config) {
	if (config.$ === 2) {
		var i18n = config.a.ny;
		var offer = config.b.G;
		var currentDate = config.b.gj;
		var onAmendStartDateAction = config.b.hP;
		return A2(
			$author$project$Common$Render$ifCondition,
			A3($author$project$Common$ComponentUI$DetailsResultBox$amendMessageWithLink, i18n, currentDate, onAmendStartDateAction),
			$author$project$Common$ComponentUI$DetailsResultBox$isOfferAmendable(offer));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Translations$detailsCancellationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cancellation date';
	} else {
		return 'Fecha de cancelación';
	}
};
var $author$project$Common$Locale$formatPosixDate = F2(
	function (tz, time) {
		var date = A2($justinmimbs$date$Date$fromPosix, tz, time);
		return $author$project$Common$Locale$formatDate(date);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$createPolicyInterruptionDateInfo = F3(
	function (i18n, onAmendInterruption, _v0) {
		var at = _v0.mB;
		var interruptionDateAsString = A2($author$project$Common$Locale$formatPosixDate, $author$project$Common$Locale$customerTimeZone, at);
		var dateInfo = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(interruptionDateAsString)
				]));
		var amendButton = function (onClick) {
			return $author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					onClick,
					A2(
						$author$project$Pyxis$Components$Button$withIconOnly,
						$author$project$Pyxis$Components$IconSet$pen,
						A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeS, $author$project$Pyxis$Components$Button$ghost))));
		};
		return A2(
			$elm$core$Tuple$pair,
			$author$project$Translations$detailsCancellationDateLabel(i18n),
			A2(
				$elm$core$Maybe$withDefault,
				dateInfo,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						amendButton,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$singleton,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$append(
									_List_fromArray(
										[dateInfo])),
								$elm$html$Html$div(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('details__general-info-row__cancellation-date')
										]))))),
					onAmendInterruption)));
	});
var $author$project$Translations$detailsBundleLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover selected';
	} else {
		return 'Cobertura seleccionada';
	}
};
var $author$project$Translations$detailsEndDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'End date';
	} else {
		return 'Fecha de finalización';
	}
};
var $author$project$Translations$detailsPurchaseDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase date';
	} else {
		return 'Fecha de contratación';
	}
};
var $author$project$Translations$detailsStartDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Start date';
	} else {
		return 'Fecha de inicio';
	}
};
var $author$project$Common$Policy$pickEndDate = function (_v0) {
	var policy = _v0;
	return policy.ez;
};
var $author$project$Common$Policy$pickProduct = function (_v0) {
	var policy = _v0;
	return policy.dx;
};
var $author$project$Common$Policy$pickPurchaseDate = function (_v0) {
	var policy = _v0;
	return policy.iy;
};
var $author$project$Common$Policy$pickStartDate = function (_v0) {
	var policy = _v0;
	return policy.l_;
};
var $author$project$Common$ComponentUI$DetailsResultBox$productName = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.mJ;
		},
		$author$project$Common$Product$bundleSlugToString(i18n));
};
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoForInterruptedPolicy = F4(
	function (i18n, interruption, onAmendInterruption, policy) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Translations$detailsBundleLabel(i18n),
				$elm$html$Html$text(
					A2(
						$author$project$Common$ComponentUI$DetailsResultBox$productName,
						i18n,
						$author$project$Common$Policy$pickProduct(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsPurchaseDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickPurchaseDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickStartDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsEndDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickEndDate(policy)))),
				A3($author$project$Common$ComponentUI$DetailsResultBox$createPolicyInterruptionDateInfo, i18n, onAmendInterruption, interruption)
			]);
	});
var $author$project$Translations$detailsCreationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Creation date';
	} else {
		return 'Fecha de la oferta';
	}
};
var $author$project$Common$Offer$pickCreationDate = function (_v0) {
	var offer = _v0;
	return offer.gh;
};
var $author$project$Common$Offer$pickFirstProduct = function (_v0) {
	var product = _v0.dx;
	return $elm$core$Maybe$Just(product);
};
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoForOffer = F2(
	function (i18n, offer) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Translations$detailsBundleLabel(i18n),
				$elm$html$Html$text(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$author$project$Common$ComponentUI$DetailsResultBox$productName(i18n),
						$author$project$Common$Offer$pickFirstProduct(offer)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Offer$pickStartDate(offer)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsCreationDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Offer$pickCreationDate(offer))))
			]);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoForPolicy = F2(
	function (i18n, policy) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Translations$detailsBundleLabel(i18n),
				$elm$html$Html$text(
					A2(
						$author$project$Common$ComponentUI$DetailsResultBox$productName,
						i18n,
						$author$project$Common$Policy$pickProduct(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsPurchaseDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickPurchaseDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickStartDate(policy)))),
				_Utils_Tuple2(
				$author$project$Translations$detailsEndDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Common$Policy$pickEndDate(policy))))
			]);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfo = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ny;
			var policy = config.b.l;
			return A2($author$project$Common$ComponentUI$DetailsResultBox$generalInfoForPolicy, i18n, policy);
		case 1:
			var i18n = config.a.ny;
			var policy = config.b.l;
			var interruption = config.c.c2;
			var onAmendInterruptionIconClicked = config.c.hN;
			return A4($author$project$Common$ComponentUI$DetailsResultBox$generalInfoForInterruptedPolicy, i18n, interruption, onAmendInterruptionIconClicked, policy);
		default:
			var i18n = config.a.ny;
			var offer = config.b.G;
			return A2($author$project$Common$ComponentUI$DetailsResultBox$generalInfoForOffer, i18n, offer);
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoItem = function (_v0) {
	var label = _v0.a;
	var value = _v0.b;
	return $author$project$Pyxis$Components$List$withItemAddonNone(
		A2(
			$author$project$Pyxis$Components$List$withItemText,
			value,
			A2($author$project$Pyxis$Components$List$withItemTitle, label, $author$project$Pyxis$Components$List$item)));
};
var $author$project$Common$ComponentUI$DetailsResultBox$generalInfoItems = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$ComponentUI$DetailsResultBox$generalInfo,
	$elm$core$List$map($author$project$Common$ComponentUI$DetailsResultBox$generalInfoItem));
var $author$project$Pyxis$Components$List$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewGeneralInfoRow = function (detailsInfo) {
	return $author$project$Pyxis$Components$List$render(
		A2(
			$author$project$Pyxis$Components$List$withEmphasis,
			$author$project$Pyxis$Components$List$emphasisText,
			A2(
				$author$project$Pyxis$Components$List$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('details__general-info-row', true)
					]),
				A2(
					$author$project$Pyxis$Components$List$withSize,
					$author$project$Pyxis$Components$List$sizeS,
					A2(
						$author$project$Pyxis$Components$List$withItems,
						$author$project$Common$ComponentUI$DetailsResultBox$generalInfoItems(detailsInfo),
						A2($author$project$Pyxis$Components$List$withOrientation, $author$project$Pyxis$Components$List$inline, $author$project$Pyxis$Components$List$dl))))));
};
var $author$project$Common$Offer$pickSource = function (_v0) {
	var offer = _v0;
	return offer.iO;
};
var $author$project$Common$Policy$pickSource = function (_v0) {
	var policy = _v0;
	return policy.iO;
};
var $author$project$Common$ComponentUI$DetailsResultBox$fetchSource = function (config) {
	switch (config.$) {
		case 0:
			var policy = config.b.l;
			return $author$project$Common$Policy$pickSource(policy);
		case 1:
			var policy = config.b.l;
			return $author$project$Common$Policy$pickSource(policy);
		default:
			var offer = config.b.G;
			return $author$project$Common$Offer$pickSource(offer);
	}
};
var $author$project$Common$Offer$isCompleteAction = function (action) {
	if (action.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$mayBeCompleted = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isCompleteAction, offer.aY);
};
var $author$project$Translations$detailsCompleteOfferLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Complete offer';
	} else {
		return 'Completar oferta';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewCompleteOfferButton = F2(
	function (i18n, onCompleteAction) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				onCompleteAction,
				A2(
					$author$project$Pyxis$Components$Button$withType,
					$author$project$Pyxis$Components$Button$button,
					A2(
						$author$project$Pyxis$Components$Button$withText,
						$author$project$Translations$detailsCompleteOfferLabel(i18n),
						$author$project$Pyxis$Components$Button$secondary))));
	});
var $author$project$Common$Offer$isPurchaseAction = function (action) {
	if (!action.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Offer$canBePurchased = function (_v0) {
	var offer = _v0;
	return A2($elm$core$List$any, $author$project$Common$Offer$isPurchaseAction, offer.aY);
};
var $author$project$Translations$detailsPurchaseButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase offer';
	} else {
		return 'Comprar Oferta';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewPurchaseButton = F4(
	function (i18n, onPurchasedButtonClicked, offer, isCoverSelectionLoading) {
		return A2(
			$author$project$Common$Render$ifCondition,
			$author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withLoading,
					isCoverSelectionLoading,
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						onPurchasedButtonClicked,
						A2(
							$author$project$Pyxis$Components$Button$withType,
							$author$project$Pyxis$Components$Button$button,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$detailsPurchaseButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))),
			$author$project$Common$Offer$canBePurchased(offer));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowCTA = function (config) {
	switch (config.$) {
		case 0:
			return $author$project$Common$Render$empty;
		case 1:
			return $author$project$Common$Render$empty;
		default:
			var i18n = config.a.ny;
			var offer = config.b.G;
			var onPurchaseAction = config.b.h9;
			var onCompleteAction = config.b.hW;
			var isCoverSelectionLoading = config.b.g4;
			return $author$project$Common$Offer$mayBeCompleted(offer) ? A2($author$project$Common$ComponentUI$DetailsResultBox$viewCompleteOfferButton, i18n, onCompleteAction) : ($author$project$Common$Offer$canBeAmended(offer) ? $author$project$Common$Render$empty : A4($author$project$Common$ComponentUI$DetailsResultBox$viewPurchaseButton, i18n, onPurchaseAction, offer, isCoverSelectionLoading));
	}
};
var $author$project$Translations$detailsCompleteOfferNotesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'By completing the offer you will create a new quotation';
	} else {
		return 'Al completar la oferta crearás una nueva cotización';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowNotes = function (config) {
	switch (config.$) {
		case 0:
			return $author$project$Common$Render$empty;
		case 1:
			return $author$project$Common$Render$empty;
		default:
			var i18n = config.a.ny;
			var offer = config.b.G;
			return A2(
				$author$project$Common$Render$when,
				$author$project$Common$Offer$mayBeCompleted(offer),
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__highlight-row__right-side__notes')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$detailsCompleteOfferNotesLabel(i18n))
						])));
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowValue = function (config) {
	switch (config.$) {
		case 0:
			var policy = config.b.l;
			return $author$project$Common$Policy$pickCustomerFacingId(policy);
		case 1:
			var policy = config.b.l;
			return $author$project$Common$Policy$pickCustomerFacingId(policy);
		default:
			var offer = config.b.G;
			return $author$project$Common$Offer$pickCustomerFacingId(offer);
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$issuingCompanyValue = function (config) {
	switch (config.$) {
		case 0:
			var data = config.a;
			return data.a8;
		case 1:
			var data = config.a;
			return data.a8;
		default:
			var data = config.a;
			return data.a8;
	}
};
var $author$project$Translations$detailsOfferLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Offer by';
	} else {
		return 'Oferta de';
	}
};
var $author$project$Translations$detailsPolicyLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy by';
	} else {
		return 'Póliza de';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$highlightRowLabel = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ny;
			return $author$project$Translations$detailsPolicyLabel(i18n);
		case 1:
			var i18n = config.a.ny;
			return $author$project$Translations$detailsPolicyLabel(i18n);
		default:
			var i18n = config.a.ny;
			return $author$project$Translations$detailsOfferLabel(i18n);
	}
};
var $author$project$Common$Source$isPrimaSource = function (source) {
	return source === 2;
};
var $author$project$Common$Render$emptySpace = $elm$core$String$fromChar('\u00A0');
var $author$project$Common$Render$nonBreakingSpace = $elm$html$Html$text($author$project$Common$Render$emptySpace);
var $author$project$Common$Source$toString = function (source) {
	switch (source) {
		case 0:
			return 'Acierto';
		case 1:
			return 'Check24';
		case 2:
			return 'Prima';
		default:
			return 'Rastreator';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$renderSourceInfo = F2(
	function (config, source) {
		return _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Common$ComponentUI$DetailsResultBox$highlightRowLabel(config)),
				$author$project$Common$Render$nonBreakingSpace,
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'c-brand',
								$author$project$Common$Source$isPrimaSource(source)),
								_Utils_Tuple2('text-s-bold', true)
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Common$Source$toString(source))
					]))
			]);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$pickI18N = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ny;
			return i18n;
		case 1:
			var i18n = config.a.ny;
			return i18n;
		default:
			var i18n = config.a.ny;
			return i18n;
	}
};
var $author$project$Common$Price$toPyxisCurrency = $author$project$Pyxis$Commons$Currency$euroCurrency;
var $author$project$Common$Locale$toPyxisLocal = function (i18n) {
	var _v0 = $author$project$Translations$currentLanguage(i18n);
	if (!_v0) {
		return $author$project$Pyxis$Commons$Locale$enLocale;
	} else {
		return $author$project$Pyxis$Commons$Locale$esLocale;
	}
};
var $author$project$Common$Price$commonConfiguration = F2(
	function (i18n, price) {
		return A2(
			$author$project$Pyxis$Components$Price$withPrice,
			$author$project$Common$Price$pickAmountAsFloat(price),
			A3(
				$author$project$Pyxis$Components$Price$withFormatOptions,
				$author$project$Common$Locale$toPyxisLocal(i18n),
				$author$project$Common$Price$toPyxisCurrency,
				$author$project$Pyxis$Components$Price$config));
	});
var $author$project$Pyxis$Components$Price$sizeL = 1;
var $author$project$Common$Price$toHtmlWithLargeSize = F2(
	function (i18n, price) {
		return $author$project$Pyxis$Components$Price$render(
			A2(
				$author$project$Pyxis$Components$Price$withSize,
				$author$project$Pyxis$Components$Price$sizeL,
				A2($author$project$Common$Price$commonConfiguration, i18n, price)));
	});
var $author$project$Translations$detailsNetLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Net';
	} else {
		return 'Prima neta';
	}
};
var $author$project$Translations$detailsTaxIpsLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'IPS';
	} else {
		return 'IPS';
	}
};
var $author$project$Translations$detailsTaxSurchargesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Surcharges';
	} else {
		return 'Recargos';
	}
};
var $author$project$Translations$detailsTotalAnnualPaymentLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Total annual payment';
	} else {
		return 'Pago total anual';
	}
};
var $author$project$Common$Policy$gross = function (_v0) {
	var policy = _v0;
	return policy.dx.mz.nl;
};
var $author$project$Common$Policy$net = function (_v0) {
	var policy = _v0;
	return policy.dx.mz.n8;
};
var $author$project$Common$Policy$taxIps = function (_v0) {
	var policy = _v0;
	return policy.dx.mz.pI;
};
var $author$project$Common$Policy$taxSurcharges = function (_v0) {
	var policy = _v0;
	return policy.dx.mz.pJ;
};
var $author$project$Common$Price$toHtmlWithSmallSize = F2(
	function (i18n, price) {
		return $author$project$Pyxis$Components$Price$render(
			A2(
				$author$project$Pyxis$Components$Price$withSize,
				$author$project$Pyxis$Components$Price$sizeS,
				A2($author$project$Common$Price$commonConfiguration, i18n, price)));
	});
var $author$project$Pyxis$Components$Tooltip$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tooltip$M = 1;
var $author$project$Pyxis$Components$Tooltip$Right = 4;
var $author$project$Pyxis$Components$IconSet$svgQuestionCircle = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 2a10.02 10.02 0 0 1 10 10 10.02 10.02 0 0 1-10 10A10.02 10.02 0 0 1 2 12 10.02 10.02 0 0 1 12 2m0-2a12 12 0 1 0 0 24 12 12 0 1 0 0-24h0z\"/><circle cx=\"12\" cy=\"17.37\" r=\"1.25\"/><path d=\"M13 14.37h-2v-.1c0-1.3.73-2.47 1.95-3.14.77-.42 1.16-1.25 1.02-2.12a2.03 2.03 0 0 0-1.59-1.61c-.61-.11-1.2.04-1.66.43a1.93 1.93 0 0 0-.59.85c-.15.4-.48.69-.9.69h-.15a.93.93 0 0 1-.89-1.21c.22-.71.65-1.36 1.24-1.85 1.23-1.03 3-1.25 4.53-.45a3.64 3.64 0 0 1 1.5 1.46c1.16 2.09.37 4.53-1.55 5.57-.57.31-.91.83-.91 1.38v.1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$questionCircle = {eY: 'question-circle', a: $author$project$Pyxis$Components$IconSet$svgQuestionCircle};
var $author$project$Pyxis$Components$Tooltip$config_ = F2(
	function (id, isMobile) {
		return {ga: _List_Nil, gb: 'Close', a0: $author$project$Pyxis$Commons$Render$empty, en: $elm$core$Maybe$Nothing, ep: _List_Nil, ku: $elm$core$Maybe$Nothing, kv: id, g7: isMobile, fc: 4, aR: 1, fz: $elm$core$Maybe$Nothing, i4: $elm$core$Maybe$Nothing, fD: $elm$core$Maybe$Nothing, fE: $author$project$Pyxis$Components$IconSet$questionCircle};
	});
var $author$project$Pyxis$Components$Tooltip$config = $author$project$Pyxis$Components$Tooltip$config_;
var $author$project$Pyxis$Components$Tooltip$Model = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Tooltip$init = function (id) {
	return {
		hc: false,
		bb: $author$project$Pyxis$Components$Modal$init(id),
		id: $elm$core$Maybe$Nothing
	};
};
var $author$project$Pyxis$Components$Tooltip$BottomLeft = 1;
var $author$project$Pyxis$Components$Tooltip$positionBottomLeft = 1;
var $author$project$Pyxis$Components$Tooltip$S = 0;
var $author$project$Pyxis$Components$Tooltip$getTooltipPositionClass = function (position) {
	switch (position) {
		case 0:
			return 'tooltip--bottom';
		case 1:
			return 'tooltip--bottom-left';
		case 2:
			return 'tooltip--bottom-right';
		case 3:
			return 'tooltip--left';
		case 4:
			return 'tooltip--right';
		case 5:
			return 'tooltip--top';
		case 6:
			return 'tooltip--top-left';
		default:
			return 'tooltip--top-right';
	}
};
var $author$project$Pyxis$Components$Tooltip$getClassList = F2(
	function (_v0, isTooltipOpen) {
		var position = _v0.fc;
		var classList = _v0.ga;
		var size = _v0.aR;
		return _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('tooltip', true),
					_Utils_Tuple2('tooltip--open', isTooltipOpen),
					_Utils_Tuple2('tooltip--s', !size),
					_Utils_Tuple2(
					$author$project$Pyxis$Components$Tooltip$getTooltipPositionClass(position),
					true)
				]),
			classList);
	});
var $author$project$Pyxis$Components$Tooltip$renderIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Icon$config,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeS),
		$author$project$Pyxis$Components$Icon$render));
var $author$project$Pyxis$Components$Tooltip$ShowModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Commons$Basics$applyIfJust = F2(
	function (f, a) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			A2($elm$core$Maybe$map, f, a));
	});
var $author$project$Pyxis$Components$Tooltip$renderModal = F3(
	function (tagger, modalModel, _v0) {
		var icon = _v0.ku;
		var title = _v0.i4;
		var content = _v0.a0;
		var closeButtonLabel = _v0.gb;
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			modalModel,
			A2(
				$author$project$Pyxis$Components$Modal$withContent,
				_List_fromArray(
					[content]),
				A2(
					$author$project$Pyxis$Components$Modal$withHeader,
					A3(
						$author$project$Pyxis$Commons$Basics$applyIfJust,
						$author$project$Pyxis$Components$Modal$Header$withIcon,
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Icon$config, icon),
						A3($author$project$Pyxis$Commons$Basics$applyIfJust, $author$project$Pyxis$Components$Modal$Header$withTitle, title, $author$project$Pyxis$Components$Modal$Header$config)),
					A3(
						$author$project$Pyxis$Components$Modal$withCloseMsg,
						tagger(
							$author$project$Pyxis$Components$Tooltip$ShowModal(false)),
						closeButtonLabel,
						$author$project$Pyxis$Components$Modal$config))));
	});
var $author$project$Pyxis$Components$Tooltip$renderTooltipTitle = function (toolTipTitle) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tooltip__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(toolTipTitle)
			]));
};
var $author$project$Pyxis$Components$Tooltip$ShowTooltip = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Button$withAriaLabelledBy = F2(
	function (ariaLabelledBy, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				f_: $elm$core$Maybe$Just(ariaLabelledBy)
			});
	});
var $author$project$Pyxis$Components$Button$withOnBlur = F2(
	function (onBlur, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hR: $elm$core$Maybe$Just(onBlur)
			});
	});
var $author$project$Pyxis$Components$Button$withOnFocus = F2(
	function (onFocus, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				h_: $elm$core$Maybe$Just(onFocus)
			});
	});
var $author$project$Pyxis$Components$Button$withOnMouseOut = F2(
	function (onMouseOut, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				h6: $elm$core$Maybe$Just(onMouseOut)
			});
	});
var $author$project$Pyxis$Components$Button$withOnMouseOver = F2(
	function (onMouseOver, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				h7: $elm$core$Maybe$Just(onMouseOver)
			});
	});
var $author$project$Pyxis$Components$Tooltip$renderTrigger = F2(
	function (tagger, _v0) {
		var customTrigger = _v0.en;
		var triggerIcon = _v0.fE;
		var id = _v0.kv;
		return $elm_community$maybe_extra$Maybe$Extra$isJust(customTrigger) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					tagger(
						$author$project$Pyxis$Components$Tooltip$ShowModal(true))),
					$elm$html$Html$Events$onMouseOver(
					tagger(
						$author$project$Pyxis$Components$Tooltip$ShowTooltip(true))),
					$elm$html$Html$Events$onMouseOut(
					tagger(
						$author$project$Pyxis$Components$Tooltip$ShowTooltip(false))),
					$elm$html$Html$Events$onBlur(
					tagger(
						$author$project$Pyxis$Components$Tooltip$ShowTooltip(false))),
					A2(
					$elm$html$Html$Events$on,
					'focusin',
					$elm$json$Json$Decode$succeed(
						tagger(
							$author$project$Pyxis$Components$Tooltip$ShowTooltip(true))))
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(customTrigger)
				])) : $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('tooltip-trigger', true)
					]),
				A2(
					$author$project$Pyxis$Components$Button$withIconOnly,
					triggerIcon,
					A2(
						$author$project$Pyxis$Components$Button$withOnBlur,
						tagger(
							$author$project$Pyxis$Components$Tooltip$ShowTooltip(false)),
						A2(
							$author$project$Pyxis$Components$Button$withOnFocus,
							tagger(
								$author$project$Pyxis$Components$Tooltip$ShowTooltip(true)),
							A2(
								$author$project$Pyxis$Components$Button$withOnMouseOut,
								tagger(
									$author$project$Pyxis$Components$Tooltip$ShowTooltip(false)),
								A2(
									$author$project$Pyxis$Components$Button$withOnMouseOver,
									tagger(
										$author$project$Pyxis$Components$Tooltip$ShowTooltip(true)),
									A2(
										$author$project$Pyxis$Components$Button$withOnClick,
										tagger(
											$author$project$Pyxis$Components$Tooltip$ShowModal(true)),
										A2(
											$author$project$Pyxis$Components$Button$withSize,
											$author$project$Pyxis$Components$Button$sizeS,
											A2($author$project$Pyxis$Components$Button$withAriaLabelledBy, id, $author$project$Pyxis$Components$Button$ghost))))))))));
	});
var $author$project$Pyxis$Components$Tooltip$wrapperId = function (id) {
	return id + '-wrapper';
};
var $author$project$Pyxis$Components$Tooltip$render = F3(
	function (tagger, _v0, tooltipConfig) {
		var modal = _v0.bb;
		var isTooltipOpen = _v0.hc;
		var content = tooltipConfig.a0;
		var dataAttrList = tooltipConfig.ep;
		var size = tooltipConfig.aR;
		var tooltipTitle = tooltipConfig.fD;
		var icon = tooltipConfig.ku;
		var id = tooltipConfig.kv;
		var testId = tooltipConfig.fz;
		var isMobile = tooltipConfig.g7;
		return A2(
			$elm$html$Html$span,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltip-wrapper'),
						$elm$html$Html$Attributes$id(
						$author$project$Pyxis$Components$Tooltip$wrapperId(id)),
						$author$project$Pyxis$Commons$Attributes$testId(
						$author$project$Pyxis$Components$Tooltip$wrapperId(id))
					])),
			_List_fromArray(
				[
					A2($author$project$Pyxis$Components$Tooltip$renderTrigger, tagger, tooltipConfig),
					function () {
					if (isMobile) {
						if (!size) {
							return $author$project$Pyxis$Commons$Render$empty;
						} else {
							return A3($author$project$Pyxis$Components$Tooltip$renderModal, tagger, modal, tooltipConfig);
						}
					} else {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									A2($author$project$Pyxis$Components$Tooltip$getClassList, tooltipConfig, isTooltipOpen)),
									$author$project$Pyxis$Commons$Attributes$role('tooltip'),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
									$elm$html$Html$Attributes$id(id)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Pyxis$Commons$Basics$ternaryOperator,
									size === 1,
									A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Tooltip$renderTooltipTitle, tooltipTitle),
									$elm$html$Html$text('')),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tooltip__content')
										]),
									A2(
										$elm$core$List$filter,
										function (el) {
											return !_Utils_eq(el, $author$project$Pyxis$Commons$Render$empty);
										},
										_List_fromArray(
											[
												A3(
												$author$project$Pyxis$Commons$Basics$ternaryOperator,
												!(!size),
												$author$project$Pyxis$Commons$Render$renderMaybe(
													A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Tooltip$renderIcon, icon)),
												$author$project$Pyxis$Commons$Render$empty),
												content
											])))
								]));
					}
				}()
				]));
	});
var $author$project$Pyxis$Components$Tooltip$withContent = F2(
	function (content, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{a0: content});
	});
var $author$project$Pyxis$Components$Tooltip$withPosition = F2(
	function (position, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{fc: position});
	});
var $author$project$Pyxis$Components$Tooltip$withTestId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fz: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Tooltip$withTriggerIcon = F2(
	function (triggerIcon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{fE: triggerIcon});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewTooltip = F3(
	function (id, onClickTooltip, content) {
		return A3(
			$author$project$Pyxis$Components$Tooltip$render,
			onClickTooltip,
			$author$project$Pyxis$Components$Tooltip$init(id),
			A2(
				$author$project$Pyxis$Components$Tooltip$withContent,
				content,
				A2(
					$author$project$Pyxis$Components$Tooltip$withTestId,
					id,
					A2(
						$author$project$Pyxis$Components$Tooltip$withTriggerIcon,
						$author$project$Pyxis$Components$IconSet$infoCircle,
						A2(
							$author$project$Pyxis$Components$Tooltip$withPosition,
							$author$project$Pyxis$Components$Tooltip$positionBottomLeft,
							A2($author$project$Pyxis$Components$Tooltip$config, id, false))))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPriceTooltip = F3(
	function (i18n, onClickTooltip, policy) {
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$viewTooltip,
			'payment-price-tooltip',
			onClickTooltip,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__tooltip__frame'),
						A2($elm$html$Html$Attributes$attribute, 'data-style', 'vibrant')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__tooltip__left-side')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsNetLabel(i18n))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsTaxIpsLabel(i18n))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsTaxSurchargesLabel(i18n))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tooltip__total-payment')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Translations$detailsTotalAnnualPaymentLabel(i18n))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__tooltip__right-side')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$net(policy)),
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$taxIps(policy)),
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$taxSurcharges(policy)),
								A2(
								$author$project$Common$Price$toHtmlWithSmallSize,
								i18n,
								$author$project$Common$Policy$gross(policy))
							]))
					])));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPrice = function (config) {
	var priceToShow = function (c) {
		switch (c.$) {
			case 2:
				var price = c.a.bj;
				return price;
			case 0:
				var price = c.a.bj;
				return price;
			default:
				var price = c.a.bj;
				return price;
		}
	};
	var i18n = $author$project$Common$ComponentUI$DetailsResultBox$pickI18N(config);
	var tooltip = function (c) {
		switch (c.$) {
			case 2:
				return $author$project$Common$Render$empty;
			case 0:
				var policy = c.b.l;
				var onTooltipClicked = c.b.b5;
				return A3($author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPriceTooltip, i18n, onTooltipClicked, policy);
			default:
				var policy = c.b.l;
				var onTooltipClicked = c.b.b5;
				return A3($author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPriceTooltip, i18n, onTooltipClicked, policy);
		}
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__policy-price')
			]),
		_List_fromArray(
			[
				tooltip(config),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__policy-price__amount')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__policy-price__amount__integers-text')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Common$Price$toHtmlWithLargeSize,
								i18n,
								priceToShow(config))
							]))
					]))
			]));
};
var $author$project$Translations$detailsRefundPriceAmountLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund';
	} else {
		return 'Reembolso';
	}
};
var $author$project$Translations$detailsInterruptionReasonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reason';
	} else {
		return 'Motivo';
	}
};
var $author$project$Translations$interruptionDissatisfactionDocsRequest = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Dissatisfaction docs request';
	} else {
		return 'Insatisfacción - pedido doc.';
	}
};
var $author$project$Translations$interruptionIncorrectVehicleInfo = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Incorrect vehicle info';
	} else {
		return 'Datos vehículo incorrectos';
	}
};
var $author$project$Translations$interruptionInexactDeclaration = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inexact declaration';
	} else {
		return 'Agravación de riesgo - SINCO';
	}
};
var $author$project$Translations$interruptionNoReason = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'No reason';
	} else {
		return 'Sin razón';
	}
};
var $author$project$Translations$interruptionRenewalNotProvided = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal not provided';
	} else {
		return 'Renovación no disponible a tiempo';
	}
};
var $author$project$Translations$interruptionRenewalRejected = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal rejected';
	} else {
		return 'Renovación rechazada';
	}
};
var $author$project$Translations$interruptionVehicleScrapped = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Vehicle scrapped';
	} else {
		return 'Vehículo - pérdida total';
	}
};
var $author$project$Common$InterruptionReason$reasonToString = F2(
	function (i18n, reason) {
		switch (reason) {
			case 0:
				return $author$project$Translations$interruptionChargeback(i18n);
			case 1:
				return $author$project$Translations$interruptionCompetitorOffer(i18n);
			case 2:
				return $author$project$Translations$interruptionCoverageChange(i18n);
			case 3:
				return $author$project$Translations$interruptionDeceasedPolicyHolder(i18n);
			case 4:
				return $author$project$Translations$interruptionDissatisfactionDocsRequest(i18n);
			case 5:
				return $author$project$Translations$interruptionDissatisfactionService(i18n);
			case 6:
				return $author$project$Translations$interruptionDoesNotKnow(i18n);
			case 7:
				return $author$project$Translations$interruptionFraud(i18n);
			case 8:
				return $author$project$Translations$interruptionIncorrectDataOther(i18n);
			case 9:
				return $author$project$Translations$interruptionIncorrectEffectiveDate(i18n);
			case 10:
				return $author$project$Translations$interruptionIncorrectPersonalData(i18n);
			case 11:
				return $author$project$Translations$interruptionIncorrectVehicleInfo(i18n);
			case 12:
				return $author$project$Translations$interruptionInexactDeclaration(i18n);
			case 13:
				return $author$project$Translations$interruptionInexactDeclarationDni(i18n);
			case 14:
				return $author$project$Translations$interruptionInexactDeclarationSinco(i18n);
			case 15:
				return $author$project$Translations$interruptionMovingToAnotherCountry(i18n);
			case 16:
				return $author$project$Translations$interruptionNoInsuranceWanted(i18n);
			case 17:
				return $author$project$Translations$interruptionNoReason(i18n);
			case 18:
				return $author$project$Translations$interruptionOther(i18n);
			case 19:
				return $author$project$Translations$interruptionPaymentMethodOrDate(i18n);
			case 20:
				return $author$project$Translations$interruptionPolicyHolderChange(i18n);
			case 21:
				return $author$project$Translations$interruptionProductService(i18n);
			case 22:
				return $author$project$Translations$interruptionRenewalNotProvided(i18n);
			case 23:
				return $author$project$Translations$interruptionRenewalRejected(i18n);
			case 24:
				return $author$project$Translations$interruptionRiskAggravation(i18n);
			case 25:
				return $author$project$Translations$interruptionUnderwritingRules(i18n);
			case 26:
				return $author$project$Translations$interruptionVehicleDeregistration(i18n);
			case 27:
				return $author$project$Translations$interruptionVehicleNotPurchased(i18n);
			case 28:
				return $author$project$Translations$interruptionVehicleScrapped(i18n);
			case 29:
				return $author$project$Translations$interruptionVehicleSold(i18n);
			case 30:
				return $author$project$Translations$interruptionWantsGreenCard(i18n);
			case 31:
				return $author$project$Translations$interruptionPriceIncrease(i18n);
			case 32:
				return $author$project$Translations$interruptionPhotoVericiationNotProvided(i18n);
			default:
				return $author$project$Translations$interruptionSwitchToGreatLakes(i18n);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$formatInterruptionReason = F2(
	function (i18n, interruption) {
		return _Utils_ap(
			A2($author$project$Common$InterruptionReason$reasonToString, i18n, interruption.iA),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				'',
				$elm$core$Basics$append(' - '),
				interruption.m1));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltipBlock = F2(
	function (title, value) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-tooltip__frame__block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-tooltip__frame__block__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-tooltip__frame__block__value')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltip = F3(
	function (i18n, onClickTooltip, interruption) {
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$viewTooltip,
			'refund-price',
			onClickTooltip,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__refund-tooltip__frame')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltipBlock,
						$author$project$Translations$detailsInterruptionReasonLabel(i18n),
						A2($author$project$Common$ComponentUI$DetailsResultBox$formatInterruptionReason, i18n, interruption))
					])));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewPriceForCompletedRefund = F4(
	function (i18n, onClickTooltip, interruption, refund) {
		var status = refund.b;
		if (status === 2) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__block')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price')
							]),
						_List_fromArray(
							[
								A3($author$project$Common$ComponentUI$DetailsResultBox$viewRefundPriceTooltip, i18n, onClickTooltip, interruption),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price__amount')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price__amount__label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Translations$detailsRefundPriceAmountLabel(i18n))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__refund-price__amount__value')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Common$Price$toHtmlWithSmallSize,
												i18n,
												$author$project$Common$Refund$pickPrice(refund))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Common$Render$empty;
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRefundPrice = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ny;
		var onTooltipClicked = config.b.b5;
		var interruption = config.c.c2;
		var refundResult = config.c.dy;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Common$ComponentUI$DetailsResultBox$viewPriceForCompletedRefund, i18n, onTooltipClicked, interruption),
				$krisajenkins$remotedata$RemoteData$toMaybe(refundResult)));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewHighlightRow = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__highlight-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('align-items-flex-start display-flex flex-direction-column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__left-side__offer-text')
							]),
						A2(
							$author$project$Common$ComponentUI$DetailsResultBox$renderSourceInfo,
							config,
							$author$project$Common$ComponentUI$DetailsResultBox$fetchSource(config))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('align-items-baseline gap-3xs display-flex flex-direction-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__left-side__cfid-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Common$ComponentUI$DetailsResultBox$highlightRowValue(config))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__left-side__issuing-company-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'(' + ($author$project$Common$ComponentUI$DetailsResultBox$issuingCompanyValue(config) + ')'))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__highlight-row__right-side')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('details__highlight-row__right-side__main')
							]),
						_List_fromArray(
							[
								$author$project$Common$ComponentUI$DetailsResultBox$viewRefundPrice(config),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('details__highlight-row__right-side__main__block')
									]),
								_List_fromArray(
									[
										$author$project$Common$ComponentUI$DetailsResultBox$viewPolicyPrice(config)
									])),
								$author$project$Common$ComponentUI$DetailsResultBox$highlightRowCTA(config)
							])),
						$author$project$Common$ComponentUI$DetailsResultBox$highlightRowNotes(config)
					]))
			]));
};
var $author$project$Translations$detailsRefundBoxRefundRetrievingErrorFirstLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Sorry, we are unable to access your refund details at this time due to a technical error.';
	} else {
		return 'Lo sentimos, no podemos acceder a los datos del reembolso en este momento debido a un error técnico.';
	}
};
var $author$project$Translations$detailsRefundBoxRefundRetrievingErrorSecondLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please wait a few minutes and refresh the page to try again.';
	} else {
		return 'Espera unos minutos y actualiza la página para intentarlo nuevamente.';
	}
};
var $author$project$Translations$detailsRefundBoxLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund management';
	} else {
		return 'Gestión de reembolsos';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$refundBox = F2(
	function (i18n, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box details__box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-box__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$detailsRefundBoxLabel(i18n))
						])),
					content
				]));
	});
var $author$project$Pyxis$Components$Icon$Alert = 3;
var $author$project$Pyxis$Components$Icon$alert = A2($author$project$Pyxis$Components$Icon$Boxed, 3, 0);
var $author$project$Translations$detailsReloadButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reload';
	} else {
		return 'Actualizar';
	}
};
var $author$project$Common$ComponentUI$ErrorBox$render = F3(
	function (i18n, errorMessageList, onRetryButtonClick) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('error-box')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withStyle,
						$author$project$Pyxis$Components$Icon$alert,
						$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$exclamationTriangle))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-box__alert__message')
						]),
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$html$Html$text,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$singleton,
								$elm$html$Html$div(_List_Nil))),
						errorMessageList)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-box__retry-button')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Button$render(
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								onRetryButtonClick,
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$detailsReloadButton(i18n),
									A2(
										$author$project$Pyxis$Components$Button$withType,
										$author$project$Pyxis$Components$Button$button,
										A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeM, $author$project$Pyxis$Components$Button$primary)))))
						]))
				]));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxFailure = F3(
	function (i18n, policyData, interruptedData) {
		return A2(
			$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
			i18n,
			A3(
				$author$project$Common$ComponentUI$ErrorBox$render,
				i18n,
				_List_fromArray(
					[
						$author$project$Translations$detailsRefundBoxRefundRetrievingErrorFirstLabel(i18n),
						$author$project$Translations$detailsRefundBoxRefundRetrievingErrorSecondLabel(i18n)
					]),
				interruptedData.hY(
					$author$project$Common$Policy$pickId(policyData.l))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxLoading = function (i18n) {
	return A2(
		$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
		i18n,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box__loading')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
				])));
};
var $author$project$Translations$detailsRefundBoxNotAskedLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please manage the refund manually.';
	} else {
		return 'Gestione el reembolso manualmente.';
	}
};
var $author$project$Pyxis$Components$Icon$Neutral = 0;
var $author$project$Pyxis$Components$Icon$neutral = A2($author$project$Pyxis$Components$Icon$Boxed, 0, 0);
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxNotAsked = function (i18n) {
	return A2(
		$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
		i18n,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box__not-asked')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withStyle,
						$author$project$Pyxis$Components$Icon$neutral,
						A2(
							$author$project$Pyxis$Components$Icon$withSize,
							$author$project$Pyxis$Components$Icon$sizeL,
							$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$infoCircle)))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details__refund-box__not-asked__message')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$detailsRefundBoxNotAskedLabel(i18n))
						]))
				])));
};
var $author$project$Translations$detailsRefundButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refund';
	} else {
		return 'Reembolsar';
	}
};
var $author$project$Common$Refund$isNotRequired = function (_v0) {
	var status = _v0.b;
	return status === 4;
};
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessButton = F3(
	function (i18n, refund, _v0) {
		var onIssueRefundButtonClicked = _v0.h3;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-box__info__refund_button')
				]),
			$elm$core$List$singleton(
				$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDisabled,
						$author$project$Common$Refund$isNotRequired(refund),
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							onIssueRefundButtonClicked(refund),
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$detailsRefundButton(i18n),
								A2(
									$author$project$Pyxis$Components$Button$withType,
									$author$project$Pyxis$Components$Button$button,
									A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeM, $author$project$Pyxis$Components$Button$primary))))))));
	});
var $author$project$Translations$detailsRefundBoxRefundEstimatedAmountLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Estimated amount';
	} else {
		return 'Reembolso estimado';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetailsItem = F2(
	function (label, value) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				value,
				A2($author$project$Pyxis$Components$List$withItemTitle, label, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetails = F3(
	function (i18n, refund, _v0) {
		var interruption = _v0.c2;
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withSize,
				$author$project$Pyxis$Components$List$sizeS,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withOrientation,
						$author$project$Pyxis$Components$List$inline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							_List_fromArray(
								[
									A2(
									$author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetailsItem,
									$author$project$Translations$detailsRefundBoxRefundEstimatedAmountLabel(i18n),
									A2(
										$author$project$Common$Price$toHtmlWithSmallSize,
										i18n,
										$author$project$Common$Refund$pickPrice(refund))),
									A2(
									$author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetailsItem,
									$author$project$Translations$detailsInterruptionReasonLabel(i18n),
									$elm$html$Html$text(
										A2($author$project$Common$ComponentUI$DetailsResultBox$formatInterruptionReason, i18n, interruption)))
								]),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess = F3(
	function (i18n, refund, interruptionData) {
		return A2(
			$author$project$Common$ComponentUI$DetailsResultBox$refundBox,
			i18n,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__refund-box__info')
					]),
				_List_fromArray(
					[
						A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessDetails, i18n, refund, interruptionData),
						A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccessButton, i18n, refund, interruptionData)
					])));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$interruptionInfoByRemoteData = F3(
	function (i18n, policyData, interruptionData) {
		var _v0 = interruptionData.dy;
		switch (_v0.$) {
			case 0:
				return $author$project$Common$ComponentUI$DetailsResultBox$refundBoxNotAsked(i18n);
			case 1:
				return $author$project$Common$ComponentUI$DetailsResultBox$refundBoxLoading(i18n);
			case 2:
				return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxFailure, i18n, policyData, interruptionData);
			default:
				switch (_v0.a.b) {
					case 0:
						var refund = _v0.a;
						var _v1 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					case 1:
						var refund = _v0.a;
						var _v2 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					case 4:
						var refund = _v0.a;
						var _v3 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					case 3:
						var refund = _v0.a;
						var _v4 = refund.b;
						return A3($author$project$Common$ComponentUI$DetailsResultBox$refundBoxSuccess, i18n, refund, interruptionData);
					default:
						return $author$project$Common$Render$empty;
				}
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionInfo = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ny;
		var policyData = config.b;
		var interruptionData = config.c;
		return A3($author$project$Common$ComponentUI$DetailsResultBox$interruptionInfoByRemoteData, i18n, policyData, interruptionData);
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$User$hasPermission = F2(
	function (user, permission) {
		if (!user.$) {
			return false;
		} else {
			var permissions = user.a.dk;
			return A2($elm$core$List$member, permission, permissions);
		}
	});
var $author$project$Common$User$hasInterruptPolicyPermission = function (user) {
	return A2($author$project$Common$User$hasPermission, user, 'policy:cancel');
};
var $author$project$Common$Policy$pickLastWithdrawableDay = function (_v0) {
	var policy = _v0;
	return policy.eZ;
};
var $author$project$Translations$policyCoolingOffPeriodEndDateMessage = F3(
	function (data, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Customer can withdraw from the contract until '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.mU + (' of ' + data.mT))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El cliente puede desistir del contrato hasta las ' + (data.mU + (' del día ' + data.mT)))
				]);
		}
	});
var $author$project$Translations$policyDoesNotRenewAction = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Deactivate automatic renewal';
	} else {
		return 'Desactiva la renovación automática';
	}
};
var $author$project$Pyxis$Tokens$TypographyColor$Action = 0;
var $author$project$Pyxis$Tokens$TypographyColor$tokenAction = 0;
var $author$project$Common$ComponentUI$DetailsResultBox$autoRenewalContent = F4(
	function (i18n, user, policy, detailsResultInterruptableData) {
		var withdrawMessage = function (lastWithdrawableDay) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__interruptions-row__cooling-off-period-message')
					]),
				A3(
					$author$project$Translations$policyCoolingOffPeriodEndDateMessage,
					{
						mT: $author$project$Common$Locale$formatDate(lastWithdrawableDay),
						mU: '23:59'
					},
					_List_Nil,
					i18n));
		};
		var renewalCanBeCancelled = $author$project$Common$User$hasInterruptPolicyPermission(user) && detailsResultInterruptableData.jC;
		var containerClass = 'details__interruptions-row__automatic-renewal';
		var cancelAutoRenewal = $author$project$Pyxis$Components$Text$render(
			A2(
				$author$project$Pyxis$Components$Text$withColor,
				$author$project$Pyxis$Tokens$TypographyColor$tokenAction,
				A2(
					$author$project$Pyxis$Components$Text$withFontWeight,
					$author$project$Pyxis$Tokens$FontWeight$tokenBold,
					A2(
						$author$project$Pyxis$Components$Text$withSize,
						$author$project$Pyxis$Tokens$TextSize$tokenM,
						$author$project$Pyxis$Components$Text$config(
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('does-not-renew-action'),
										$elm$html$Html$Events$onClick(
										detailsResultInterruptableData.lh(policy))
									]),
								$elm$core$List$singleton(
									$elm$html$Html$text(
										$author$project$Translations$policyDoesNotRenewAction(i18n)))))))));
		var _v0 = _Utils_Tuple2(
			$author$project$Common$Policy$pickLastWithdrawableDay(policy),
			renewalCanBeCancelled);
		if (!_v0.a.$) {
			if (_v0.b) {
				var lastWithdrawableDay = _v0.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClass)
						]),
					_List_fromArray(
						[
							withdrawMessage(lastWithdrawableDay),
							cancelAutoRenewal
						]));
			} else {
				var lastWithdrawableDay = _v0.a.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClass)
						]),
					_List_fromArray(
						[
							withdrawMessage(lastWithdrawableDay)
						]));
			}
		} else {
			if (_v0.b) {
				var _v1 = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(containerClass)
						]),
					_List_fromArray(
						[cancelAutoRenewal]));
			} else {
				var _v2 = _v0.a;
				return $author$project$Common$Render$empty;
			}
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$TerminateByCustomer = 1;
var $author$project$Common$ComponentUI$DetailsResultBox$TerminateByPrima = 2;
var $author$project$Common$ComponentUI$DetailsResultBox$Withdraw = 0;
var $author$project$Common$ComponentUI$DetailsResultBox$interruptableActions = function (_v0) {
	var canBeWithdrawn = _v0.jB;
	var canBeTerminatedByCustomer = _v0.jz;
	var canBeTerminatedByPrima = _v0.jA;
	var _v1 = _Utils_Tuple3(canBeWithdrawn, canBeTerminatedByCustomer, canBeTerminatedByPrima);
	if (_v1.a) {
		if (!_v1.c) {
			return _List_fromArray(
				[0]);
		} else {
			return _List_fromArray(
				[0, 2]);
		}
	} else {
		if (_v1.b) {
			if (!_v1.c) {
				return _List_fromArray(
					[1]);
			} else {
				return _List_fromArray(
					[1, 2]);
			}
		} else {
			if (_v1.c) {
				return _List_fromArray(
					[2]);
			} else {
				return _List_Nil;
			}
		}
	}
};
var $author$project$Translations$policyCustomerCancellationButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer cancels';
	} else {
		return 'Cliente cancela';
	}
};
var $author$project$Translations$policyPrimaCancellationButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Prima cancels';
	} else {
		return 'Prima cancela';
	}
};
var $author$project$Translations$policyWithdrawButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Withdraw';
	} else {
		return 'Desistimiento';
	}
};
var $author$project$Pyxis$Components$Button$Tertiary = 2;
var $author$project$Pyxis$Components$Button$tertiary = $author$project$Pyxis$Components$Button$config(2);
var $author$project$Common$ComponentUI$DetailsResultBox$renderButton = F3(
	function (label, id, action) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withTestId,
				id,
				A2(
					$author$project$Pyxis$Components$Button$withId,
					id,
					A2(
						$author$project$Pyxis$Components$Button$withText,
						label,
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							action,
							$author$project$Pyxis$Components$Button$sizeM(
								A2($author$project$Pyxis$Components$Button$withType, $author$project$Pyxis$Components$Button$button, $author$project$Pyxis$Components$Button$tertiary)))))));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButton = F3(
	function (i18n, onInterruptionButtonPressed, action) {
		var _v0 = function () {
			switch (action) {
				case 0:
					return {
						kv: 'withdraw',
						eL: 0,
						eY: $author$project$Translations$policyWithdrawButton(i18n)
					};
				case 1:
					return {
						kv: 'interruption',
						eL: 1,
						eY: $author$project$Translations$policyCustomerCancellationButton(i18n)
					};
				default:
					return {
						kv: 'prima-interruption',
						eL: 2,
						eY: $author$project$Translations$policyPrimaCancellationButton(i18n)
					};
			}
		}();
		var interruptionKind = _v0.eL;
		var label = _v0.eY;
		var id = _v0.kv;
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$renderButton,
			label,
			id,
			onInterruptionButtonPressed(interruptionKind));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButtons = F2(
	function (i18n, _v0) {
		var interruptionStatus = _v0.kD;
		var onInterruptionButtonClicked = _v0.k4;
		return A2(
			$elm$core$List$map,
			A2($author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButton, i18n, onInterruptionButtonClicked),
			$author$project$Common$ComponentUI$DetailsResultBox$interruptableActions(interruptionStatus));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionButtons = F2(
	function (i18n, detailsResultInterruptableData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-flex align-self-flex-end details__interruptions-row__ctas-group')
				]),
			A2($author$project$Common$ComponentUI$DetailsResultBox$renderInterruptionButtons, i18n, detailsResultInterruptableData));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionsRow = function (config) {
	switch (config.$) {
		case 2:
			return $author$project$Common$Render$empty;
		case 1:
			return $author$project$Common$Render$empty;
		default:
			var i18n = config.a.ny;
			var policy = config.b.l;
			var detailsResultInterruptableData = config.c;
			var user = config.d;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__interruptions-row')
					]),
				_List_fromArray(
					[
						A4($author$project$Common$ComponentUI$DetailsResultBox$autoRenewalContent, i18n, user, policy, detailsResultInterruptableData),
						A2(
						$author$project$Common$Render$when,
						$author$project$Common$User$hasInterruptPolicyPermission(user),
						A2($author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionButtons, i18n, detailsResultInterruptableData))
					]));
	}
};
var $author$project$Common$Policy$pickRenewalCancellation = function (_v0) {
	var policy = _v0;
	return policy.iE;
};
var $author$project$Common$Policy$pickStatus = function (_v0) {
	var policy = _v0;
	return policy.iR;
};
var $author$project$Translations$detailsRenewalCancellationForActivePolicyMessage = F3(
	function (renewalCancellationReason, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('This policy will not be renewed due to a customer request. The reason for the renewal’s cancellation is: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Esta póliza no se renovará porque el cliente así lo ha solicitado. El motivo por el cual se cancela la renovación es: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Translations$detailsRenewalCancellationForNotRenewedPolicyMessage = F3(
	function (renewalCancellationReason, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('The reason for the renewal’s cancellation is: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El motivo por el cual se cancela la renovación es: '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(renewalCancellationReason)
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renewalCancellationMessageContent = F3(
	function (i18n, policyStatus, renewalCancellation) {
		if (policyStatus === 1) {
			return A3(
				$author$project$Translations$detailsRenewalCancellationForActivePolicyMessage,
				A2($author$project$Common$InterruptionReason$reasonToString, i18n, renewalCancellation.iA),
				_List_Nil,
				i18n);
		} else {
			return A3(
				$author$project$Translations$detailsRenewalCancellationForNotRenewedPolicyMessage,
				A2($author$project$Common$InterruptionReason$reasonToString, i18n, renewalCancellation.iA),
				_List_Nil,
				i18n);
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renewalsCancellationMessage = F3(
	function (i18n, policyStatus, renewalCancellation) {
		return $author$project$Pyxis$Components$Message$render(
			A2(
				$author$project$Pyxis$Components$Message$withContent,
				A3($author$project$Common$ComponentUI$DetailsResultBox$renewalCancellationMessageContent, i18n, policyStatus, renewalCancellation),
				$author$project$Pyxis$Components$Message$neutral($author$project$Pyxis$Components$Message$surfaceStrongBackground)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsCancellationInfoBox = function (config) {
	if (!config.$) {
		var i18n = config.a.ny;
		var policy = config.b.l;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$Common$ComponentUI$DetailsResultBox$renewalsCancellationMessage,
					i18n,
					$author$project$Common$Policy$pickStatus(policy)),
				$author$project$Common$Policy$pickRenewalCancellation(policy)));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$Policy$pickRenewalPolicyId = function (_v0) {
	var policy = _v0;
	return policy.iF;
};
var $author$project$Translations$detailsRenewalsReminderLink = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'here';
	} else {
		return 'aquí';
	}
};
var $author$project$Translations$detailsRenewalsReminderMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Check if the client has a renewed policy and if he wants to cancel it as well. You can find the details of the other policy';
	} else {
		return 'Verifica si el cliente tiene una póliza renovada y si desea cancelarla también. Puedes consultar los datos de la otra póliza';
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$reminderMessage = F3(
	function (i18n, onRenewalsLinkClicked, renewlPolicyId) {
		return $author$project$Pyxis$Components$Message$render(
			A2(
				$author$project$Pyxis$Components$Message$withContent,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Translations$detailsRenewalsReminderMessage(i18n)),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message__link'),
								$elm$html$Html$Events$onClick(
								onRenewalsLinkClicked(renewlPolicyId))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$detailsRenewalsReminderLink(i18n))
							])),
						$elm$html$Html$text('.')
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsReminderInfoBox = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ny;
		var policy = config.b.l;
		var onRenewalsLinkClicked = config.c.b4;
		return A2(
			$author$project$Common$Render$maybe,
			A2($author$project$Common$ComponentUI$DetailsResultBox$reminderMessage, i18n, onRenewalsLinkClicked),
			$author$project$Common$Policy$pickRenewalPolicyId(policy));
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Common$Offer$pickVehicle = function (_v0) {
	var offer = _v0;
	return offer.je;
};
var $author$project$Common$Policy$pickVehicle = function (_v0) {
	var policy = _v0;
	return policy.je;
};
var $author$project$Common$ComponentUI$DetailsResultBox$extractVehicleInfo = F2(
	function (pickerFunction, config) {
		switch (config.$) {
			case 0:
				var policy = config.b.l;
				return pickerFunction(
					$author$project$Common$Policy$pickVehicle(policy));
			case 1:
				var policy = config.b.l;
				return pickerFunction(
					$author$project$Common$Policy$pickVehicle(policy));
			default:
				var offer = config.b.G;
				return pickerFunction(
					$author$project$Common$Offer$pickVehicle(offer));
		}
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renderVehicleInfo = function (config) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Common$ComponentUI$DetailsResultBox$extractVehicleInfo, $author$project$Common$Vehicle$pickPlateNumber, config))
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Common$ComponentUI$DetailsResultBox$extractVehicleInfo, $author$project$Common$Vehicle$pickBrand, config))
				]))
		]);
};
var $author$project$Common$ComponentUI$DetailsResultBox$infoBlock = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__status-row__info-block')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeL,
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$car))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pointed-text')
					]),
				$author$project$Common$ComponentUI$DetailsResultBox$renderVehicleInfo(config))
			]));
};
var $author$project$Pyxis$Components$Badge$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Common$Refund$renderBadge = function (customClass) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Badge$withClassList(
			_List_fromArray(
				[
					_Utils_Tuple2(customClass, true)
				])),
		$author$project$Pyxis$Components$Badge$render);
};
var $author$project$Pyxis$Components$Badge$Action = 2;
var $author$project$Pyxis$Components$Badge$action = $author$project$Pyxis$Components$Badge$config(2);
var $author$project$Translations$policyRefundStatusCompleted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Refunded';
	} else {
		return 'Reembolsado';
	}
};
var $author$project$Translations$policyRefundStatusPending = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Ready to refund';
	} else {
		return 'Listo para reembolsar';
	}
};
var $author$project$Common$Refund$statusBadge = F2(
	function (i18n, _v0) {
		var status = _v0.b;
		switch (status) {
			case 0:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$policyRefundStatusPending(i18n),
						$author$project$Pyxis$Components$Badge$action));
			case 2:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$policyRefundStatusCompleted(i18n),
						$author$project$Pyxis$Components$Badge$success));
			case 3:
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Badge$withText,
						$author$project$Translations$policyRefundStatusPending(i18n),
						$author$project$Pyxis$Components$Badge$action));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Common$Refund$renderStatusBadge = F3(
	function (customClass, i18n, refund) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm_community$html_extra$Html$Extra$nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$Refund$renderBadge(customClass),
				A2($author$project$Common$Refund$statusBadge, i18n, refund)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBadgeFromRefundData = F2(
	function (i18n, _v0) {
		var refundResult = _v0.dy;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Common$Refund$renderStatusBadge, 'align-self-flex-start', i18n),
				$krisajenkins$remotedata$RemoteData$toMaybe(refundResult)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$refundBadge = function (config) {
	if (config.$ === 1) {
		var i18n = config.a.ny;
		var interruptionData = config.c;
		return A2($author$project$Common$ComponentUI$DetailsResultBox$refundBadgeFromRefundData, i18n, interruptionData);
	} else {
		return $author$project$Common$Render$empty;
	}
};
var $author$project$Translations$offerStatusRenewal = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal';
	} else {
		return 'Renovación';
	}
};
var $author$project$Common$Offer$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Common$Offer$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Common$Offer$pickIsRenewal(offer),
			A2($author$project$Common$Offer$renewalBadge, customClass, i18n));
	});
var $author$project$Common$Policy$pickIsARenewal = function (_v0) {
	var policy = _v0;
	return policy.g3;
};
var $author$project$Common$Policy$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Common$Policy$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Common$Policy$pickIsARenewal(offer),
			A2($author$project$Common$Policy$renewalBadge, customClass, i18n));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$renewalBadge = function (config) {
	switch (config.$) {
		case 2:
			var i18n = config.a.ny;
			var offer = config.b.G;
			return A3($author$project$Common$Offer$renderRenewalBadge, 'align-self-flex-start', i18n, offer);
		case 0:
			var i18n = config.a.ny;
			var policy = config.b.l;
			return A3($author$project$Common$Policy$renderRenewalBadge, 'align-self-flex-start', i18n, policy);
		default:
			var i18n = config.a.ny;
			var policy = config.b.l;
			return A3($author$project$Common$Policy$renderRenewalBadge, 'align-self-flex-start', i18n, policy);
	}
};
var $author$project$Pyxis$Components$Badge$Alert = 5;
var $author$project$Pyxis$Components$Badge$alert = $author$project$Pyxis$Components$Badge$config(5);
var $author$project$Pyxis$Components$Badge$Error = 3;
var $author$project$Pyxis$Components$Badge$error = $author$project$Pyxis$Components$Badge$config(3);
var $author$project$Pyxis$Components$Badge$Neutral = 0;
var $author$project$Pyxis$Components$Badge$neutral = $author$project$Pyxis$Components$Badge$config(0);
var $author$project$Translations$offerStatusBlocked = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Blocked';
	} else {
		return 'No contratable';
	}
};
var $author$project$Translations$offerStatusExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired';
	} else {
		return 'Oferta caducada';
	}
};
var $author$project$Translations$offerStatusMissingDocuments = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Missing documents';
	} else {
		return 'Documentos pendientes';
	}
};
var $author$project$Translations$offerStatusNewPrice = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'New price';
	} else {
		return 'Nuevo precio';
	}
};
var $author$project$Translations$offerStatusNewProduct = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'New product';
	} else {
		return 'Nueva modalidad';
	}
};
var $author$project$Translations$offerStatusPurchasable = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Available';
	} else {
		return 'Oferta disponible';
	}
};
var $author$project$Translations$offerStatusPurchased = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchased';
	} else {
		return 'Póliza contratada';
	}
};
var $author$project$Translations$offerStatusRequoted = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Requoted';
	} else {
		return 'Cotizado nuevamente';
	}
};
var $author$project$Translations$offerStatusStartDateExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Start Date Expired';
	} else {
		return 'Fecha de inicio expirada';
	}
};
var $author$project$Common$Offer$statusBadge = F2(
	function (i18n, _v0) {
		var offer = _v0;
		var _v1 = offer.iR;
		switch (_v1) {
			case 8:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchasable(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 4:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 3:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusStartDateExpired(i18n),
					$author$project$Pyxis$Components$Badge$alert);
			case 7:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchased(i18n),
					$author$project$Pyxis$Components$Badge$brand);
			case 5:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusBlocked(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 6:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRequoted(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewPrice(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewProduct(i18n),
					$author$project$Pyxis$Components$Badge$success);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusMissingDocuments(i18n),
					$author$project$Pyxis$Components$Badge$alert);
		}
	});
var $author$project$Common$Offer$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Common$Offer$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $justinmimbs$date$Date$isBetween = F3(
	function (_v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var x = _v2;
		return A3($justinmimbs$date$Date$isBetweenInt, a, b, x);
	});
var $author$project$Translations$policyStatusActive = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Active';
	} else {
		return 'Activa';
	}
};
var $author$project$Translations$policyStatusExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired';
	} else {
		return 'Caducada';
	}
};
var $author$project$Translations$policyStatusGracePeriod = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Grace period';
	} else {
		return 'Periodo de gracia';
	}
};
var $author$project$Translations$policyStatusIssued = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Issued';
	} else {
		return 'Emitida';
	}
};
var $author$project$Translations$policyStatusNotRenewed = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Not renewed';
	} else {
		return 'No renovada';
	}
};
var $author$project$Translations$policyStatusRenewed = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewed';
	} else {
		return 'Renovada';
	}
};
var $author$project$Translations$policyStatusTerminatedByCustomer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Terminated by customer';
	} else {
		return 'Cliente cancela';
	}
};
var $author$project$Translations$policyStatusTerminatedByPrima = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Terminated by Prima';
	} else {
		return 'Prima cancela';
	}
};
var $author$project$Translations$policyStatusWithdrawn = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Withdrawn';
	} else {
		return 'Cancelada por desistimiento';
	}
};
var $author$project$Common$PolicyStatus$statusBadge = F3(
	function (i18n, isPolicyActiveAsToday, status) {
		switch (status) {
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusIssued(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusActive(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 2:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusGracePeriod(i18n),
					$author$project$Pyxis$Components$Badge$alert);
			case 3:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 4:
				var badge = isPolicyActiveAsToday ? $author$project$Pyxis$Components$Badge$success : $author$project$Pyxis$Components$Badge$neutral;
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusRenewed(i18n),
					badge);
			case 5:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusNotRenewed(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 6:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusWithdrawn(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 7:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusTerminatedByCustomer(i18n),
					$author$project$Pyxis$Components$Badge$error);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$policyStatusTerminatedByPrima(i18n),
					$author$project$Pyxis$Components$Badge$error);
		}
	});
var $author$project$Common$PolicyStatus$renderStatusBadge = F3(
	function (i18n, customClass, isPolicyActiveAsToday) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Common$PolicyStatus$statusBadge, i18n, isPolicyActiveAsToday),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Common$Policy$renderStatusBadge = F4(
	function (customClass, i18n, todayDate, _v0) {
		var policy = _v0;
		return A4(
			$author$project$Common$PolicyStatus$renderStatusBadge,
			i18n,
			customClass,
			A3($justinmimbs$date$Date$isBetween, policy.l_, policy.ez, todayDate),
			policy.iR);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$statusBadge = function (config) {
	switch (config.$) {
		case 0:
			var i18n = config.a.ny;
			var policy = config.b.l;
			var todayDate = config.b.aU;
			return A4($author$project$Common$Policy$renderStatusBadge, 'align-self-flex-start', i18n, todayDate, policy);
		case 1:
			var i18n = config.a.ny;
			var policy = config.b.l;
			var todayDate = config.b.aU;
			return A4($author$project$Common$Policy$renderStatusBadge, 'align-self-flex-start', i18n, todayDate, policy);
		default:
			var i18n = config.a.ny;
			var offer = config.b.G;
			return A3($author$project$Common$Offer$renderStatusBadge, 'align-self-flex-start', i18n, offer);
	}
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewStatus = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__status-row')
			]),
		_List_fromArray(
			[
				$author$project$Common$ComponentUI$DetailsResultBox$statusBadge(config),
				$author$project$Common$ComponentUI$DetailsResultBox$refundBadge(config),
				$author$project$Common$ComponentUI$DetailsResultBox$renewalBadge(config),
				$author$project$Common$ComponentUI$DetailsResultBox$infoBlock(config)
			]));
};
var $author$project$Common$ComponentUI$DetailsResultBox$view = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('details__result_box details__box')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('details__result_box__general_info_box')
					]),
				_List_fromArray(
					[
						$author$project$Common$ComponentUI$DetailsResultBox$viewHighlightRow(config),
						$author$project$Common$ComponentUI$DetailsResultBox$horizontalDivider,
						$author$project$Common$ComponentUI$DetailsResultBox$viewStatus(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewAmendOfferIfAmendable(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsReminderInfoBox(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewRenewalsCancellationInfoBox(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewGeneralInfoRow(config),
						$author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionInfo(config),
						$author$project$Common$ComponentUI$DetailsResultBox$horizontalDivider,
						$author$project$Common$ComponentUI$DetailsResultBox$viewInterruptionsRow(config)
					]))
			]));
};
var $author$project$Common$ComponentUI$DetailsResultBox$viewFromOffer = F5(
	function (i18n, currentDate, actions, offer, isCoverSelectionLoading) {
		return $author$project$Common$ComponentUI$DetailsResultBox$view(
			A5($author$project$Common$ComponentUI$DetailsResultBox$newOfferViewConfiguration, i18n, currentDate, actions, offer, isCoverSelectionLoading));
	});
var $author$project$Page$OfferDetails$Msg$SendEmailModalSubmitted = function (a) {
	return {$: 23, a: a};
};
var $author$project$Page$OfferDetails$Msg$SendOfferEmailCheckBoxChecked = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$OfferDetails$Msg$ShowSendEmailModal = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pyxis$Components$IconSet$svgPaperPlane = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.5 11.13L4.09 1.66c-.16-.09-.33-.14-.5-.14-.61 0-1.15.58-.97 1.26l2.4 8.96a.92.92 0 0 1 0 .52l-2.4 8.96c-.18.68.35 1.26.97 1.26.17 0 .34-.04.5-.14l16.41-9.47c.67-.39.67-1.35 0-1.74zM16.27 11H6.9L5.18 4.6 16.27 11zM6.9 13h9.37L5.18 19.4 6.9 13z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$paperPlane = {eY: 'paper-plane', a: $author$project$Pyxis$Components$IconSet$svgPaperPlane};
var $author$project$Translations$sendOfferEmailsOpenModalButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Send emails';
	} else {
		return 'Enviar emails';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderModalButton = F2(
	function (i18n, showModal) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				showModal(true),
				A2(
					$author$project$Pyxis$Components$Button$withText,
					$author$project$Translations$sendOfferEmailsOpenModalButtonLabel(i18n),
					A2(
						$author$project$Pyxis$Components$Button$withIconPrepend,
						$author$project$Pyxis$Components$IconSet$paperPlane,
						A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeM, $author$project$Pyxis$Components$Button$tertiary)))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$SendNewBusinessOfferEmail = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$CheckboxGroup$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$CheckboxGroup$Default = 2;
var $author$project$Pyxis$Components$Field$CheckboxGroup$OptionList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$config = function (name) {
	return {
		fO: $elm$core$Maybe$Nothing,
		ga: _List_Nil,
		ep: _List_Nil,
		gt: false,
		cU: $elm$core$Maybe$Nothing,
		gX: $elm$core$Maybe$Nothing,
		kv: 'id-' + name,
		c5: false,
		eY: $elm$core$Maybe$Nothing,
		c9: 2,
		kT: name,
		dj: $author$project$Pyxis$Components$Field$CheckboxGroup$OptionList(_List_Nil),
		pz: false,
		fz: $elm$core$Maybe$Nothing,
		dW: $elm$core$Maybe$Nothing
	};
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$OptionCard = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$OptionCard$AddonSizeMType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$OptionCard$addonSizeMType = $author$project$Pyxis$Components$Field$OptionCard$AddonSizeMType;
var $author$project$Pyxis$Components$Field$OptionCard$M = 0;
var $author$project$Pyxis$Components$Field$OptionCard$sizeM = 0;
var $author$project$Pyxis$Components$Field$CheckboxGroup$optionCardSizeM = function (_v0) {
	var addon = _v0.mu;
	var text = _v0.pK;
	var title = _v0.i4;
	var value = _v0.pR;
	return {
		mu: A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$OptionCard$addonSizeMType, addon),
		bA: $elm$core$Maybe$Nothing,
		gt: false,
		iG: false,
		aR: $author$project$Pyxis$Components$Field$OptionCard$sizeM,
		pK: text,
		i4: title,
		pR: value
	};
};
var $author$project$Pyxis$Components$Form$FormItem$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$FormItem$config = F2(
	function (fieldConfig, field) {
		return {fO: $elm$core$Maybe$Nothing, ga: _List_Nil, kd: field, ke: fieldConfig, eY: $elm$core$Maybe$Nothing};
	});
var $author$project$Pyxis$Components$Field$Error$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Error$idFromFieldId = function (fieldId) {
	return fieldId + '-error';
};
var $author$project$Pyxis$Components$Field$Error$config = F3(
	function (id, validationResult, showingStrategy) {
		return {
			kv: $author$project$Pyxis$Components$Field$Error$idFromFieldId(id),
			kE: false,
			nI: false,
			c5: false,
			lV: showingStrategy,
			jb: validationResult
		};
	});
var $author$project$Pyxis$Components$Field$Error$withIsBlurred = F2(
	function (isBlurred, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{kE: isBlurred});
	});
var $author$project$Pyxis$Components$Field$Error$withIsDirty = F2(
	function (isDirty, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{nI: isDirty});
	});
var $author$project$Pyxis$Components$Field$Error$withIsSubmitted = F2(
	function (isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{c5: isSubmitted});
	});
var $author$project$Pyxis$Components$Field$Error$buildErrorConfig = F4(
	function (fieldStatus, configuration, validationResult, showingStrategy) {
		return A2(
			$author$project$Pyxis$Components$Field$Error$withIsSubmitted,
			configuration.c5,
			A2(
				$author$project$Pyxis$Components$Field$Error$withIsBlurred,
				fieldStatus.kE,
				A2(
					$author$project$Pyxis$Components$Field$Error$withIsDirty,
					fieldStatus.nI,
					A3($author$project$Pyxis$Components$Field$Error$config, configuration.kv, validationResult, showingStrategy))));
	});
var $author$project$Pyxis$Components$Field$Error$OnBlur = 1;
var $author$project$Pyxis$Components$Field$Error$isOnBlurShowingStrategy = function (strategy) {
	return strategy === 1;
};
var $author$project$Pyxis$Components$Field$Error$OnInput = 0;
var $author$project$Pyxis$Components$Field$Error$isOnInputShowingStrategy = function (strategy) {
	return !strategy;
};
var $author$project$Pyxis$Components$Field$Error$OnSubmit = 2;
var $author$project$Pyxis$Components$Field$Error$isOnSubmitShowingStrategy = function (strategy) {
	return strategy === 2;
};
var $author$project$Pyxis$Commons$ValidationResult$runValidationIf = F3(
	function (shouldRun, value, validation) {
		return shouldRun ? A2(
			$elm$core$Maybe$map,
			function (val) {
				return val(value);
			},
			validation) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pyxis$Commons$Validation$generateValidationResult = F5(
	function (fieldStatus, isSubmitted, value, validation, errorShowingStrategy) {
		return ($author$project$Pyxis$Components$Field$Error$isOnSubmitShowingStrategy(errorShowingStrategy) || isSubmitted) ? A3($author$project$Pyxis$Commons$ValidationResult$runValidationIf, isSubmitted, value, validation) : ($author$project$Pyxis$Components$Field$Error$isOnInputShowingStrategy(errorShowingStrategy) ? A3($author$project$Pyxis$Commons$ValidationResult$runValidationIf, fieldStatus.nI && (!fieldStatus.kE), value, validation) : ($author$project$Pyxis$Components$Field$Error$isOnBlurShowingStrategy(errorShowingStrategy) ? A3($author$project$Pyxis$Commons$ValidationResult$runValidationIf, fieldStatus.kE, value, validation) : $elm$core$Maybe$Nothing));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.eB;
		var checkedValues = _v0.aB;
		var id = _v1.kv;
		var isSubmitted = _v1.c5;
		var validation = _v1.dW;
		var errorShowingStrategy = _v1.cU;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, checkedValues, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kv: id, c5: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Commons$ValidationResult$getErrorMessage = function (result) {
	if (!result.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var errorMessage = result.a;
		return $elm$core$Maybe$Just(errorMessage);
	}
};
var $author$project$Pyxis$Components$Field$Error$getErrorIf = F2(
	function (condition, validationResult) {
		return condition ? $author$project$Pyxis$Commons$ValidationResult$getErrorMessage(validationResult) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pyxis$Components$Field$Error$getErrorMessage = F2(
	function (_v0, validationResult) {
		var showingStrategy = _v0.lV;
		var isSubmitted = _v0.c5;
		var isDirty = _v0.nI;
		var isBlurred = _v0.kE;
		switch (showingStrategy) {
			case 0:
				return A2($author$project$Pyxis$Components$Field$Error$getErrorIf, isSubmitted || isDirty, validationResult);
			case 1:
				return A2($author$project$Pyxis$Components$Field$Error$getErrorIf, isSubmitted || isBlurred, validationResult);
			default:
				return A2($author$project$Pyxis$Components$Field$Error$getErrorIf, isSubmitted, validationResult);
		}
	});
var $author$project$Pyxis$Components$Field$Error$isVisible = function (maybeConfig) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		A2(
			$elm$core$Maybe$andThen,
			function (config_) {
				var validationResult = config_.jb;
				return A2($author$project$Pyxis$Components$Field$Error$getErrorMessage, config_, validationResult);
			},
			maybeConfig));
};
var $author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible = F2(
	function (error, fieldId) {
		return $author$project$Pyxis$Components$Field$Error$isVisible(error) ? $elm$core$Maybe$Just(
			$author$project$Pyxis$Components$Field$Error$idFromFieldId(fieldId)) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pyxis$Components$Field$Label$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Label$withFor = F2(
	function (_for, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eD: $elm$core$Maybe$Just(_for)
			});
	});
var $author$project$Pyxis$Components$Field$Label$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Form$FormItem$customizeLabel = function (configData) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Field$Label$withId(configData.kv + '-label'),
		$author$project$Pyxis$Components$Field$Label$withFor(configData.kv));
};
var $author$project$Pyxis$Components$Field$Label$pickShowAsterisk = function (_v0) {
	var showAsteriskOnRequired = _v0.pz;
	return showAsteriskOnRequired;
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Pyxis$Components$Field$Label$getFormLabelSizeClass = function (size) {
	if (!size) {
		return 'form-label--s';
	} else {
		return '';
	}
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Pyxis$Components$Field$Label$renderSubText = function (subText) {
	return A2(
		$elm$html$Html$small,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-label__sub')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(subText)
			]));
};
var $author$project$Pyxis$Components$Field$Label$wrapperId = $elm$core$Maybe$map(
	A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, '-wrapper'));
var $author$project$Pyxis$Components$Field$Label$render = function (_v0) {
	var _for = _v0.eD;
	var classList = _v0.ga;
	var dataAttrList = _v0.ep;
	var id = _v0.kv;
	var testId = _v0.fz;
	var size = _v0.aR;
	var text = _v0.pK;
	var subText = _v0.fs;
	var tooltip = _v0.fC;
	var isHidden = _v0.eO;
	return A2(
		$elm$html$Html$div,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-label-wrapper'),
					$elm$html$Html$Attributes$classList(classList),
					A2(
					$author$project$Pyxis$Commons$Attributes$maybe,
					$author$project$Pyxis$Commons$Attributes$testId,
					$author$project$Pyxis$Components$Field$Label$wrapperId(id))
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-label', true),
								_Utils_Tuple2('sr-only', isHidden),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Field$Label$getFormLabelSizeClass(size),
								true)
							])),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$for, _for),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-label__content')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Commons$Render$renderMaybeText(text),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('asterisk'),
										$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							])),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Label$renderSubText, subText))
					])),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					function (tooltipConfig) {
						return A3($author$project$Pyxis$Components$Tooltip$render, tooltipConfig.i$, tooltipConfig.hx, tooltipConfig.jQ);
					},
					tooltip))
			]));
};
var $author$project$Pyxis$Components$IconSet$svgExclamationCircleFilled = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M12 0a12 12 0 1 0 0 24 12 12 0 1 0 0-24zm-1.5 5.88a1.5 1.5 0 1 1 3 0v7a1.5 1.5 0 1 1-3 0v-7zM12 19.63a1.76 1.76 0 0 1-1.75-1.75A1.76 1.76 0 0 1 12 16.13a1.76 1.76 0 0 1 1.75 1.75A1.76 1.76 0 0 1 12 19.63z\"/></svg>\n';
var $author$project$Pyxis$Components$IconSet$exclamationCircleFilled = {eY: 'exclamation-circle-filled', a: $author$project$Pyxis$Components$IconSet$svgExclamationCircleFilled};
var $author$project$Pyxis$Components$Field$Error$renderError = F2(
	function (id, error) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-item__error-message'),
					$elm$html$Html$Attributes$id(id),
					$author$project$Pyxis$Commons$Attributes$role('alert')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Icon$render(
					A2(
						$author$project$Pyxis$Components$Icon$withSize,
						$author$project$Pyxis$Components$Icon$sizeS,
						$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$exclamationCircleFilled))),
					$elm$html$Html$text(error)
				]));
	});
var $author$project$Pyxis$Components$Field$Error$render = function (config_) {
	var id = config_.kv;
	var validationResult = config_.jb;
	return $author$project$Pyxis$Commons$Render$renderMaybe(
		A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Error$renderError(id),
			A2($author$project$Pyxis$Components$Field$Error$getErrorMessage, config_, validationResult)));
};
var $author$project$Pyxis$Components$Field$Hint$render = function (_v0) {
	var id = _v0.kv;
	var message = _v0.nZ;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-item__hint'),
				A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(message)
			]));
};
var $author$project$Pyxis$Components$Field$Hint$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Hint$toId = function (fieldId) {
	return fieldId + '-hint';
};
var $author$project$Pyxis$Components$Field$Hint$withFieldId = F2(
	function (fieldId, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kv: $elm$core$Maybe$Just(
					$author$project$Pyxis$Components$Field$Hint$toId(fieldId))
			});
	});
var $author$project$Pyxis$Components$Form$FormItem$renderErrorOrHint = F3(
	function (id, errorConfig, hintConfig) {
		return $author$project$Pyxis$Components$Field$Error$isVisible(errorConfig) ? $author$project$Pyxis$Commons$Render$renderMaybe(
			A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Error$render, errorConfig)) : $author$project$Pyxis$Commons$Render$renderMaybe(
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Hint$withFieldId(id),
					$author$project$Pyxis$Components$Field$Hint$render),
				hintConfig));
	});
var $author$project$Pyxis$Components$Form$FormItem$render = F2(
	function (error, _v0) {
		var label = _v0.eY;
		var field = _v0.kd;
		var fieldConfig = _v0.ke;
		var additionalContent = _v0.fO;
		var classList = _v0.ga;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('form-item', true),
								_Utils_Tuple2(
								'form-item--with-label-asterisk',
								function (showAsteriskOnRequired) {
									return fieldConfig.iG && showAsteriskOnRequired;
								}(
									A2(
										$elm$core$Maybe$withDefault,
										false,
										A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Label$pickShowAsterisk, label))))
							]),
						classList))
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Pyxis$Components$Form$FormItem$customizeLabel(fieldConfig),
							$author$project$Pyxis$Components$Field$Label$render),
						label)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-item__wrapper')
						]),
					_List_fromArray(
						[
							field,
							A3($author$project$Pyxis$Components$Form$FormItem$renderErrorOrHint, fieldConfig.kv, error, fieldConfig.gX)
						])),
					$author$project$Pyxis$Commons$Render$renderMaybe(additionalContent)
				]));
	});
var $author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint = F2(
	function (errorId, hintId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pyxis$Commons$Attributes$none,
			A2(
				$elm$core$Maybe$map,
				$author$project$Pyxis$Commons$Attributes$ariaDescribedBy,
				A2($elm_community$maybe_extra$Maybe$Extra$or, errorId, hintId)));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardControlLayoutClass = function (layout) {
	switch (layout) {
		case 2:
			return '';
		case 0:
			return '';
		default:
			return 'form-control-group--column';
	}
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$labelId = function (id) {
	return id + '-label';
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$CheckboxGroup$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$CheckboxGroup$OnCheck = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$config = F4(
	function (onCheck, onFocus, onBlur, value) {
		return {fV: $elm$core$Maybe$Nothing, gt: false, kv: $elm$core$Maybe$Nothing, eY: $elm$core$Maybe$Nothing, hR: onBlur, k$: onCheck, h_: onFocus, iG: false, fz: $elm$core$Maybe$Nothing, pR: value};
	});
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withDisabled = F2(
	function (isDisabled, _v0) {
		var option = _v0;
		return _Utils_update(
			option,
			{gt: isDisabled});
	});
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withLabel = F2(
	function (label, _v0) {
		var option = _v0;
		return _Utils_update(
			option,
			{
				eY: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withRequired = F2(
	function (isRequired, _v0) {
		var option = _v0;
		return _Utils_update(
			option,
			{iG: isRequired});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckboxValues = F2(
	function (tagger, _v0) {
		var optionData = _v0;
		return A2(
			$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withRequired,
			optionData.iG,
			A2(
				$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withDisabled,
				optionData.gt,
				A2(
					$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$withLabel,
					optionData.eY,
					A4(
						$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$config,
						F2(
							function (val, checked) {
								return tagger(
									A2($author$project$Pyxis$Components$Field$CheckboxGroup$OnCheck, val, checked));
							}),
						tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnFocus),
						tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnBlur),
						optionData.pR))));
	});
var $author$project$Pyxis$Commons$Attributes$ariaInvalid = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Commons$String$fromBool,
	$elm$html$Html$Attributes$attribute('aria-invalid'));
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$renderAsterisk = function (isToRenderAsterisk) {
	return A2(
		$author$project$Pyxis$Commons$Render$renderIf,
		isToRenderAsterisk,
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control__label-asterisk'),
					$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('*')
				])));
};
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$render = F4(
	function (configData, isChecked, hasError, _v0) {
		var disabled = _v0.gt;
		var value = _v0.pR;
		var label = _v0.eY;
		var ariaDescribedBy = _v0.fV;
		var required = _v0.iG;
		var onBlur = _v0.hR;
		var onFocus = _v0.h_;
		var onCheck = _v0.k$;
		var testId = _v0.fz;
		var id = _v0.kv;
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-control', true),
							_Utils_Tuple2('form-control-option--error', hasError)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						configData.ep,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('form-control__checkbox', true),
										_Utils_Tuple2('form-control--disabled', disabled || configData.gt)
									])),
								$elm$html$Html$Attributes$checked(isChecked),
								$elm$html$Html$Attributes$disabled(disabled || configData.gt),
								$elm$html$Html$Attributes$name(configData.kT),
								$elm$html$Html$Attributes$required(required),
								$elm$html$Html$Events$onCheck(
								function (checked) {
									return A2(onCheck, value, checked);
								}),
								$elm$html$Html$Events$onFocus(onFocus),
								$elm$html$Html$Events$onBlur(onBlur),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$ariaDescribedBy, ariaDescribedBy),
								$author$project$Pyxis$Commons$Attributes$ariaInvalid(hasError),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id)
							])),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control__active-indicator')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control__text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							label),
							$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$renderAsterisk(required && configData.pz)
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderCheckbox = F5(
	function (tagger, configData, checkedValues, hasError, _v0) {
		var optionValues = _v0;
		var isChecked = A2($elm$core$List$member, optionValues.pR, checkedValues);
		return A4(
			$author$project$Pyxis$Components$Field$Checkbox$CheckboxItem$render,
			configData,
			isChecked,
			hasError,
			A2($author$project$Pyxis$Components$Field$CheckboxGroup$mapCheckboxValues, tagger, optionValues));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderOptions = F5(
	function (tagger, configData, errorId, checkedValues, options) {
		var renderer = A4(
			$author$project$Pyxis$Components$Field$CheckboxGroup$renderCheckbox,
			tagger,
			configData,
			checkedValues,
			$elm_community$maybe_extra$Maybe$Extra$isJust(errorId));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-control-group', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardControlLayoutClass(configData.c9),
							true)
						])),
					$elm$html$Html$Attributes$id(configData.kv),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fz),
					A2(
					$author$project$Pyxis$Commons$Attributes$renderIf,
					$elm$core$List$length(options) > 1,
					$author$project$Pyxis$Commons$Attributes$role('group')),
					$author$project$Pyxis$Commons$Attributes$ariaDisabled(configData.gt),
					A2(
					$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
					errorId,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(
							$author$project$Pyxis$Components$Field$Hint$toId(configData.kv)),
						configData.gX)),
					$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
					$author$project$Pyxis$Components$Field$CheckboxGroup$labelId(configData.kv))
				]),
			A2($elm$core$List$map, renderer, options));
	});
var $author$project$Pyxis$Components$Field$OptionCard$Config = F5(
	function (name, fieldId, label, groupDisabled, withShowAsteriskOnRequired) {
		return {kf: fieldId, kp: groupDisabled, eY: label, kT: name, jl: withShowAsteriskOnRequired};
	});
var $author$project$Pyxis$Components$Field$OptionCard$config = $author$project$Pyxis$Components$Field$OptionCard$Config;
var $author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardGroupLayoutClass = function (layout) {
	switch (layout) {
		case 2:
			return '';
		case 1:
			return 'form-card-group--column';
		default:
			return 'form-card-group--row';
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$Checkbox = 1;
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Pyxis$Commons$String$toKebabCase = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toLower,
	A2($elm$core$String$replace, ' ', '-'));
var $author$project$Pyxis$Components$Field$OptionCard$generateOptionId = F3(
	function (_v0, _v1, index) {
		var fieldId = _v0.kf;
		var text = _v1.pK;
		var title = _v1.i4;
		return A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[
					fieldId,
					$author$project$Pyxis$Commons$String$toKebabCase(
					A2(
						$elm$core$String$left,
						25,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$String$fromInt(index),
							A2($elm_community$maybe_extra$Maybe$Extra$or, title, text)))),
					'option'
				]));
	});
var $author$project$Pyxis$Components$Field$OptionCard$getFormCardSizeClass = function (size) {
	if (size === 1) {
		return 'form-card--l';
	} else {
		return '';
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$isAsteriskToShowOnTitle = F2(
	function (showAsteriskOnrequired, required) {
		return showAsteriskOnrequired && required;
	});
var $author$project$Pyxis$Components$Field$OptionCard$isToAshowAsteriskOnText = F3(
	function (showAsteriskOnrequired, required, title) {
		return showAsteriskOnrequired && (required && (!$elm_community$maybe_extra$Maybe$Extra$isJust(title)));
	});
var $author$project$Pyxis$Components$Field$OptionCard$renderContent = F3(
	function (identifier, showAsterisk, str) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-card__' + identifier)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str),
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					showAsterisk,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control__label-asterisk'),
								$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('*')
							])))
				]));
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Pyxis$Components$Field$OptionCard$renderSizeLargePrependAddon = function (_v0) {
	var url = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-card__addon')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(url),
						$elm$html$Html$Attributes$width(72),
						$elm$html$Html$Attributes$height(72),
						$elm$html$Html$Attributes$alt(''),
						$author$project$Pyxis$Commons$Attributes$ariaHidden(true)
					]),
				_List_Nil)
			]));
};
var $author$project$Pyxis$Components$Field$OptionCard$renderSizeMediumPrependAddon = function (_v0) {
	var icon = _v0;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-card__addon form-card__addon--with-icon'),
				$author$project$Pyxis$Commons$Attributes$testId(
				$author$project$Pyxis$Components$IconSet$toLabel(icon))
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeM,
					$author$project$Pyxis$Components$Icon$config(icon)))
			]));
};
var $author$project$Pyxis$Components$Field$OptionCard$renderPrependAddon = function (addon) {
	if (!addon.$) {
		var addonSizeM = addon.a;
		return $author$project$Pyxis$Components$Field$OptionCard$renderSizeMediumPrependAddon(addonSizeM);
	} else {
		var addonSizeL = addon.a;
		return $author$project$Pyxis$Components$Field$OptionCard$renderSizeLargePrependAddon(addonSizeL);
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$toType = function (type_) {
	if (!type_) {
		return 'radio';
	} else {
		return 'checkbox';
	}
};
var $author$project$Pyxis$Components$Field$OptionCard$render = F6(
	function (type_, hasError, attributes, configData, index, option) {
		var name = configData.kT;
		var groupDisabled = configData.kp;
		var id = A3($author$project$Pyxis$Components$Field$OptionCard$generateOptionId, configData, option, index);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-card', true),
							_Utils_Tuple2(
							'form-card--with-badge',
							$elm_community$maybe_extra$Maybe$Extra$isJust(option.bA)),
							_Utils_Tuple2('form-card--error', hasError),
							_Utils_Tuple2('form-card--checked', option.nH),
							_Utils_Tuple2('form-card--disabled', option.gt || groupDisabled),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Field$OptionCard$getFormCardSizeClass(option.aR),
							true)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Pyxis$Commons$Render$maybeMapRender, $author$project$Pyxis$Components$Badge$render, option.bA),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$OptionCard$renderPrependAddon, option.mu)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-card__content-wrapper')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Pyxis$Components$Field$OptionCard$renderContent,
									'title',
									A2($author$project$Pyxis$Components$Field$OptionCard$isAsteriskToShowOnTitle, configData.jl, option.iG)),
								option.i4)),
							$author$project$Pyxis$Commons$Render$renderMaybe(
							A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Pyxis$Components$Field$OptionCard$renderContent,
									'text',
									A3($author$project$Pyxis$Components$Field$OptionCard$isToAshowAsteriskOnText, configData.jl, option.iG, option.i4)),
								option.pK))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-card__input')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							A2(
								$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
								attributes,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_(
										$author$project$Pyxis$Components$Field$OptionCard$toType(type_)),
										$elm$html$Html$Attributes$class(
										'form-control__' + $author$project$Pyxis$Components$Field$OptionCard$toType(type_)),
										$elm$html$Html$Attributes$checked(option.nH),
										$elm$html$Html$Attributes$disabled(option.gt || groupDisabled),
										$elm$html$Html$Attributes$id(id),
										$elm$html$Html$Attributes$required(option.iG),
										$author$project$Pyxis$Commons$Attributes$testId(id),
										$elm$html$Html$Attributes$name(name),
										$elm$html$Html$Events$onCheck(option.k$),
										$elm$html$Html$Events$onFocus(option.h_),
										$elm$html$Html$Events$onBlur(option.hR)
									])),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-control__active-indicator')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$OptionCard$renderCheckbox = $author$project$Pyxis$Components$Field$OptionCard$render(1);
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderOptionsCard = F3(
	function (_v0, errorId, options) {
		var name = _v0.kT;
		var layout = _v0.c9;
		var id = _v0.kv;
		var disabled = _v0.gt;
		var hint = _v0.gX;
		var testId = _v0.fz;
		var dataAttrList = _v0.ep;
		var showAsteriskOnRequired = _v0.pz;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-card-group', true),
							_Utils_Tuple2(
							$author$project$Pyxis$Components$Field$CheckboxGroup$getFormCardGroupLayoutClass(layout),
							true)
						])),
					$elm$html$Html$Attributes$id(id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					$author$project$Pyxis$Commons$Attributes$role('group'),
					$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
					$author$project$Pyxis$Components$Field$CheckboxGroup$labelId(id)),
					$author$project$Pyxis$Commons$Attributes$ariaDisabled(disabled),
					A2(
					$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
					errorId,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(
							$author$project$Pyxis$Components$Field$Hint$toId(id)),
						hint))
				]),
			A2(
				$elm$core$List$indexedMap,
				A3(
					$author$project$Pyxis$Components$Field$OptionCard$renderCheckbox,
					$elm_community$maybe_extra$Maybe$Extra$isJust(errorId),
					dataAttrList,
					A5($author$project$Pyxis$Components$Field$OptionCard$config, name, id, $elm$core$Maybe$Nothing, disabled, showAsteriskOnRequired)),
				options));
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$toInternal = F3(
	function (tagger, checkedValues, _v0) {
		var addon = _v0.mu;
		var text = _v0.pK;
		var title = _v0.i4;
		var value = _v0.pR;
		var size = _v0.aR;
		var disabled = _v0.gt;
		var required = _v0.iG;
		var badge = _v0.bA;
		var isChecked = A2($elm$core$List$member, value, checkedValues);
		return {
			mu: addon,
			bA: badge,
			gt: disabled,
			nH: isChecked,
			hR: tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnBlur),
			k$: A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Field$CheckboxGroup$OnCheck(value),
				tagger),
			h_: tagger($author$project$Pyxis$Components$Field$CheckboxGroup$OnFocus),
			iG: required,
			aR: size,
			pK: text,
			i4: title,
			pR: value
		};
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$renderControlGroup = F5(
	function (tagger, configData, errorId, checkedValues, options) {
		if (!options.$) {
			var optionSimples = options.a;
			return A5($author$project$Pyxis$Components$Field$CheckboxGroup$renderOptions, tagger, configData, errorId, checkedValues, optionSimples);
		} else {
			var optionsCard = options.a;
			return A3(
				$author$project$Pyxis$Components$Field$CheckboxGroup$renderOptionsCard,
				configData,
				errorId,
				A2(
					$elm$core$List$map,
					A2($author$project$Pyxis$Components$Field$CheckboxGroup$toInternal, tagger, checkedValues),
					optionsCard));
		}
	});
var $author$project$Pyxis$Components$Form$FormItem$withAdditionalContent = F2(
	function (additionalContent, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{fO: additionalContent});
	});
var $author$project$Pyxis$Components$Form$FormItem$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Pyxis$Components$Form$FormItem$withLabel = F2(
	function (label, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{eY: label});
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$render = F3(
	function (tagger, model, config_) {
		var checkedValues = model.aB;
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$CheckboxGroup$generateErrorConfig, model, config_);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fO,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withClassList,
					configData.ga,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withLabel,
						configData.eY,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							{gX: configData.gX, kv: configData.kv, iG: false},
							A5(
								$author$project$Pyxis$Components$Field$CheckboxGroup$renderControlGroup,
								tagger,
								configData,
								A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kv),
								checkedValues,
								configData.dj))))));
	});
var $author$project$Translations$sendOfferEmailsOfferCheckbox = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Email offer';
	} else {
		return 'Email de la oferta';
	}
};
var $author$project$Translations$sendOfferEmailsSelectionError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You need to select an email';
	} else {
		return 'Debes seleccionar un email';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$validation = F2(
	function (i18n, selected) {
		if (!selected.b) {
			return $elm$core$Result$Err(
				$author$project$Translations$sendOfferEmailsSelectionError(i18n));
		} else {
			return $elm$core$Result$Ok(selected);
		}
	});
var $author$project$Pyxis$Components$Field$CheckboxGroup$OptionCardList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Field$CheckboxGroup$withOptionsCard = F2(
	function (options, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				dj: $author$project$Pyxis$Components$Field$CheckboxGroup$OptionCardList(options)
			});
	});
var $author$project$Pyxis$Commons$ValidationResult$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Commons$ValidationResult$Valid = {$: 0};
var $author$project$Pyxis$Commons$ValidationResult$fromResult = function (result) {
	if (!result.$) {
		return $author$project$Pyxis$Commons$ValidationResult$Valid;
	} else {
		var error = result.a;
		return $author$project$Pyxis$Commons$ValidationResult$Invalid(error);
	}
};
var $author$project$Pyxis$Components$Field$Error$onSubmit = 2;
var $author$project$Pyxis$Components$Field$CheckboxGroup$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cU: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				c5: isSubmitted,
				dW: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$checkboxGroup = F4(
	function (i18n, onCheckBoxChange, offer, model) {
		return A3(
			$author$project$Pyxis$Components$Field$CheckboxGroup$render,
			onCheckBoxChange,
			model.ck,
			A2(
				$author$project$Pyxis$Components$Field$CheckboxGroup$withOptionsCard,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Field$CheckboxGroup$optionCardSizeM(
						{
							mu: $elm$core$Maybe$Nothing,
							pK: $elm$core$Maybe$Nothing,
							i4: $elm$core$Maybe$Just(
								$author$project$Translations$sendOfferEmailsOfferCheckbox(i18n)),
							pR: $author$project$Common$Offer$pickId(offer)
						})
					]),
				A3(
					$author$project$Pyxis$Components$Field$CheckboxGroup$withValidationOnSubmit,
					$author$project$Common$ComponentUI$Modal$SendOfferEmail$validation(i18n),
					model.hb,
					$author$project$Pyxis$Components$Field$CheckboxGroup$config('checkbox-name'))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$emailAddressText = function (email) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withFontWeight,
			$author$project$Pyxis$Tokens$FontWeight$tokenBold,
			A2(
				$author$project$Pyxis$Components$Text$withSize,
				$author$project$Pyxis$Tokens$TextSize$tokenL,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(email)))));
};
var $author$project$Translations$sendOfferEmailsReceiver = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Emails will be sent to';
	} else {
		return 'El email se enviará a';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$senderReceiverText = function (i18n) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withSize,
			$author$project$Pyxis$Tokens$TextSize$tokenL,
			$author$project$Pyxis$Components$Text$config(
				$elm$html$Html$text(
					$author$project$Translations$sendOfferEmailsReceiver(i18n)))));
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderReceiverBlock = F2(
	function (i18n, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('send-offer-email__receiver-block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Common$ComponentUI$Modal$SendOfferEmail$senderReceiverText(i18n)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Common$ComponentUI$Modal$SendOfferEmail$emailAddressText(model.iB)
						]))
				]));
	});
var $author$project$Translations$sendOfferEmailsWhichEmailText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Which email do you want to send to the customer?';
	} else {
		return '¿Qué email quieres enviarle al cliente?';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$whichEmailText = function (i18n) {
	return $author$project$Pyxis$Components$Text$render(
		A2(
			$author$project$Pyxis$Components$Text$withSize,
			$author$project$Pyxis$Tokens$TextSize$tokenL,
			$author$project$Pyxis$Components$Text$config(
				$elm$html$Html$text(
					$author$project$Translations$sendOfferEmailsWhichEmailText(i18n)))));
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalContent = F4(
	function (i18n, onCheckBoxChange, offer, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('send-offer-email__which-email-text')
					]),
				_List_fromArray(
					[
						$author$project$Common$ComponentUI$Modal$SendOfferEmail$whichEmailText(i18n)
					])),
				A4($author$project$Common$ComponentUI$Modal$SendOfferEmail$checkboxGroup, i18n, onCheckBoxChange, offer, model),
				A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderReceiverBlock, i18n, model)
			]);
	});
var $author$project$Translations$sendOfferEmailsBackButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderBackButton = F2(
	function (i18n, showModal) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withSize,
				$author$project$Pyxis$Components$Button$sizeL,
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					showModal(false),
					A2(
						$author$project$Pyxis$Components$Button$withText,
						$author$project$Translations$sendOfferEmailsBackButtonLabel(i18n),
						$author$project$Pyxis$Components$Button$secondary))));
	});
var $author$project$Translations$sendOfferEmailsSendButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Send emails';
	} else {
		return 'Enviar emails';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailButton = F3(
	function (i18n, onSubmit, model) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withSize,
				$author$project$Pyxis$Components$Button$sizeL,
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					onSubmit(
						$author$project$Pyxis$Components$Field$CheckboxGroup$getValue(model.ck)),
					A2(
						$author$project$Pyxis$Components$Button$withText,
						$author$project$Translations$sendOfferEmailsSendButtonLabel(i18n),
						$author$project$Pyxis$Components$Button$primary))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalFooter = F4(
	function (i18n, onSubmit, showModal, model) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderBackButton, i18n, showModal),
					A3($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailButton, i18n, onSubmit, model)
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$iconModalHeder = A2(
	$author$project$Pyxis$Components$Icon$withColor,
	$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$paperPlane));
var $author$project$Translations$sendOfferEmailsTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Set up email sending';
	} else {
		return 'Configurar el envío de emails';
	}
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalHeader = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withIcon,
		$author$project$Common$ComponentUI$Modal$SendOfferEmail$iconModalHeder,
		A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$sendOfferEmailsTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config));
};
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailModal = F6(
	function (i18n, onCheckBoxChange, onSubmit, showModal, offer, model) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			model.iu,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A4($author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalFooter, i18n, onSubmit, showModal, model),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A4($author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalContent, i18n, onCheckBoxChange, offer, model),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Common$ComponentUI$Modal$SendOfferEmail$sendEmailModalHeader(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							showModal(false),
							'Close',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Common$ComponentUI$Modal$SendOfferEmail$render = F6(
	function (i18n, showModal, onCheckBoxChange, onSubmit, offer, model) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderModalButton, i18n, showModal),
					A6($author$project$Common$ComponentUI$Modal$SendOfferEmail$renderSendEmailModal, i18n, onCheckBoxChange, onSubmit, showModal, offer, model)
				]));
	});
var $author$project$Page$OfferDetails$View$buttonWithSendEmailModal = F3(
	function (i18n, model, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('feature-flag--sendEmail')
				]),
			_List_fromArray(
				[
					A6($author$project$Common$ComponentUI$Modal$SendOfferEmail$render, i18n, $author$project$Page$OfferDetails$Msg$ShowSendEmailModal, $author$project$Page$OfferDetails$Msg$SendOfferEmailCheckBoxChecked, $author$project$Page$OfferDetails$Msg$SendEmailModalSubmitted, offer, model.C)
				]));
	});
var $author$project$Page$OfferDetails$Msg$RedirectToSearch = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$OfferDetails$View$navigateToResults = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Offer$pickPolicyHolder,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Person$pickPersonData,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aF;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$Page$Search$SearchQueryParam$DocumentId,
				A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$Page$OfferDetails$Msg$RedirectToSearch)))));
var $author$project$Common$Offer$pickComebackLink = function (_v0) {
	var offer = _v0;
	return offer.ge;
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$Config = $elm$core$Basics$identity;
var $author$project$Translations$copyComebackLinkCopiedLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Link copied!';
	} else {
		return 'Link copiado!';
	}
};
var $author$project$Translations$copyComebackLinkCopyLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Copy link of the offer';
	} else {
		return 'Copia link de la oferta';
	}
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$config = F2(
	function (i18n, copyTarget) {
		return {
			ga: _List_Nil,
			jT: $author$project$Translations$copyComebackLinkCopiedLabel(i18n),
			jU: $author$project$Translations$copyComebackLinkCopyLabel(i18n),
			jV: copyTarget
		};
	});
var $author$project$Tracker$actionName = function (name) {
	return A2($elm$html$Html$Attributes$attribute, 'data-' + $author$project$Tracker$customActionAttributeName, name);
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$render = function (_v0) {
	var configuration = _v0;
	return A3(
		$elm$html$Html$node,
		'copy-button',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-text', configuration.jU),
				A2($elm$html$Html$Attributes$attribute, 'data-text-copied', configuration.jT),
				A2($elm$html$Html$Attributes$attribute, 'data-copy', configuration.jV),
				$author$project$Tracker$actionName('copy-offer-link'),
				$elm$html$Html$Attributes$classList(configuration.ga)
			]),
		_List_Nil);
};
var $author$project$Common$ComponentUI$CustomElements$CopyButton$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Page$OfferDetails$View$buttonWithCopyComebackLink = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Common$ComponentUI$CustomElements$CopyButton$config(i18n),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$ComponentUI$CustomElements$CopyButton$withClassList(
				_List_fromArray(
					[
						_Utils_Tuple2('padding-h-xs', true)
					])),
			$author$project$Common$ComponentUI$CustomElements$CopyButton$render));
};
var $author$project$Translations$copyComebackLinkCopyLabelError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Link not available: please contact support team';
	} else {
		return 'Link no disponible: póngase en contacto con el equipo de asistencia';
	}
};
var $author$project$Pyxis$Components$Message$Error = 4;
var $author$project$Pyxis$Components$Message$error = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 4, style);
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Common$ComebackLink$toString = function (_v0) {
	var url = _v0.i7;
	var nonce = _v0.hH;
	var utmCampaign = _v0.fH;
	var utmMedium = _v0.fI;
	var utmSource = _v0.fJ;
	return $elm$url$Url$toString(
		_Utils_update(
			url,
			{
				lA: $elm$core$Maybe$Just(
					A2(
						$elm$core$String$filter,
						$elm$core$Basics$neq('?'),
						$elm$url$Url$Builder$toQuery(
							$elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										A2($elm$url$Url$Builder$string, $author$project$Common$ComebackLink$nonceQueryParamKey, nonce)),
										A2(
										$elm$core$Maybe$map,
										$elm$url$Url$Builder$string('utm_source'),
										utmSource),
										A2(
										$elm$core$Maybe$map,
										$elm$url$Url$Builder$string('utm_medium'),
										utmMedium),
										A2(
										$elm$core$Maybe$map,
										$elm$url$Url$Builder$string('utm_campaign'),
										utmCampaign)
									])))))
			}));
};
var $author$project$Pyxis$Components$Message$withTitle = F2(
	function (title, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				i4: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$ComebackLink$withUTMCampaign = F2(
	function (campaign, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				fH: $elm$core$Maybe$Just(campaign)
			});
	});
var $author$project$Common$ComebackLink$withUTMMedium = F2(
	function (medium, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				fI: $elm$core$Maybe$Just(medium)
			});
	});
var $author$project$Common$ComebackLink$withUTMSource = F2(
	function (source, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				fJ: $elm$core$Maybe$Just(source)
			});
	});
var $author$project$Page$OfferDetails$View$renderComebackLink = F2(
	function (i18n, comebackLinkStatus) {
		switch (comebackLinkStatus.$) {
			case 0:
				return $author$project$Common$Render$empty;
			case 1:
				return $author$project$Pyxis$Components$Message$render(
					A2(
						$author$project$Pyxis$Components$Message$withTitle,
						$author$project$Translations$copyComebackLinkCopyLabelError(i18n),
						$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground)));
			default:
				var comebackLink = comebackLinkStatus.a;
				return A2(
					$author$project$Page$OfferDetails$View$buttonWithCopyComebackLink,
					i18n,
					$author$project$Common$ComebackLink$toString(
						A2(
							$author$project$Common$ComebackLink$withUTMCampaign,
							'copy_link_of_the_offer',
							A2(
								$author$project$Common$ComebackLink$withUTMMedium,
								'manual_share',
								A2($author$project$Common$ComebackLink$withUTMSource, 'backoffice', comebackLink)))));
		}
	});
var $author$project$Pyxis$Components$IconSet$svgChevronLeft = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M13.59 19L7.3 12.71c-.39-.39-.39-1.02 0-1.41L13.59 5c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41L9.41 12 15 17.59c.39.39.39 1.02 0 1.41h0c-.39.39-1.02.39-1.41 0z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$chevronLeft = {eY: 'chevron-left', a: $author$project$Pyxis$Components$IconSet$svgChevronLeft};
var $author$project$Translations$detailsBackToResultsButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back to results';
	} else {
		return 'Volver a los resultados';
	}
};
var $author$project$Common$ComponentUI$BackToResults$view = F2(
	function (i18n, onClickHandler) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('back-to-results-container')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withIconPrepend,
						$author$project$Pyxis$Components$IconSet$chevronLeft,
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeM,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$detailsBackToResultsButton(i18n),
								A2($author$project$Pyxis$Components$Button$withOnClick, onClickHandler, $author$project$Pyxis$Components$Button$ghost)))))
				]));
	});
var $author$project$Page$OfferDetails$View$viewHeaderContainer = F3(
	function (i18n, model, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('offer-details-header-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$ComponentUI$BackToResults$view,
					i18n,
					$author$project$Page$OfferDetails$View$navigateToResults(offer)),
					A2(
					$author$project$Page$OfferDetails$View$renderComebackLink,
					i18n,
					$author$project$Common$Offer$pickComebackLink(offer)),
					A3($author$project$Page$OfferDetails$View$buttonWithSendEmailModal, i18n, model, offer)
				]));
	});
var $author$project$Page$OfferDetails$Msg$RetryGetPaymentMethod = function (a) {
	return {$: 19, a: a};
};
var $author$project$Translations$paymentDetailsPaymentDetailsError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The payment method information couldn’t be loaded. Please try again in a moment.';
	} else {
		return 'La información del método de pago no pudo ser cargada. Inténtalo de nuevo en un momento.';
	}
};
var $author$project$Translations$paymentDetailsPaymentMethodDetails = F2(
	function (data, _v0) {
		var lang = _v0;
		if (!lang) {
			return data.bB + (' ' + (data.cL + (' | Expire date: ' + data.cW)));
		} else {
			return data.bB + (' ' + (data.cL + (' | Caducidad: ' + data.cW)));
		}
	});
var $author$project$Common$PaymentMethod$pickName = function (brand) {
	switch (brand.$) {
		case 0:
			return 'Visa';
		case 1:
			return 'MasterCard';
		case 2:
			return 'Maestro';
		default:
			var name = brand.a;
			return name;
	}
};
var $author$project$Common$PaymentMethod$paymentMethodContent = F2(
	function (i18n, paymentMethod) {
		return $author$project$Pyxis$Components$Text$render(
			A2(
				$author$project$Pyxis$Components$Text$withColor,
				$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
				$author$project$Pyxis$Components$Text$config(
					$elm$html$Html$text(
						A2(
							$author$project$Translations$paymentDetailsPaymentMethodDetails,
							{
								bB: $author$project$Common$PaymentMethod$pickName(paymentMethod.bB),
								cL: paymentMethod.cL,
								cW: paymentMethod.cW
							},
							i18n)))));
	});
var $author$project$Pyxis$Components$Card$Header = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Card$header = {d3: _List_Nil, a0: $elm$core$Maybe$Nothing, dO: $elm$core$Maybe$Nothing, i4: $elm$core$Maybe$Nothing};
var $author$project$Translations$paymentDetailsPaymentMethodExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired card';
	} else {
		return 'Tarjeta expirada';
	}
};
var $author$project$Translations$paymentDetailsPaymentMethodTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Payment method';
	} else {
		return 'Método de pago';
	}
};
var $author$project$Common$PaymentMethod$paymentMethodTitleConfig = function (title) {
	return A2(
		$author$project$Pyxis$Components$Title$withFontWeight,
		$author$project$Pyxis$Tokens$FontWeight$tokenBold,
		A2(
			$author$project$Pyxis$Components$Title$withSize,
			$author$project$Pyxis$Tokens$TitleSize$tokenM,
			$author$project$Pyxis$Components$Title$config(
				$elm$html$Html$text(title))));
};
var $author$project$Pyxis$Tokens$TypographyColor$Error = 18;
var $author$project$Pyxis$Tokens$TypographyColor$tokenError = 18;
var $author$project$Common$PaymentMethod$paymentMethodTitle = F2(
	function (i18n, creditCardExpiration) {
		if (!creditCardExpiration) {
			return $author$project$Pyxis$Components$Title$render(
				$author$project$Common$PaymentMethod$paymentMethodTitleConfig(
					$author$project$Translations$paymentDetailsPaymentMethodTitle(i18n)));
		} else {
			return $author$project$Pyxis$Components$Title$render(
				A2(
					$author$project$Pyxis$Components$Title$withColor,
					$author$project$Pyxis$Tokens$TypographyColor$tokenError,
					$author$project$Common$PaymentMethod$paymentMethodTitleConfig(
						$author$project$Translations$paymentDetailsPaymentMethodExpired(i18n))));
		}
	});
var $author$project$Pyxis$Components$Card$withHeaderTitle = F2(
	function (title, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				i4: $elm$core$Maybe$Just(title)
			});
	});
var $author$project$Common$PaymentMethod$paymentMethodHeader = F2(
	function (i18n, paymentMethod) {
		return A2(
			$author$project$Pyxis$Components$Card$withHeaderTitle,
			A2($author$project$Common$PaymentMethod$paymentMethodTitle, i18n, paymentMethod.eb),
			$author$project$Pyxis$Components$Card$header);
	});
var $author$project$Pyxis$Components$Card$withHeader = F2(
	function (header_, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eH: $elm$core$Maybe$Just(header_)
			});
	});
var $author$project$Pyxis$Components$IconSet$svgCreditCard = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 2.5H3c-1.66 0-3 1.34-3 3v13c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3v-13c0-1.66-1.34-3-3-3zm-18 2h18c.55 0 1 .45 1 1v2H2v-2c0-.55.45-1 1-1zm18 15H3c-.55 0-1-.45-1-1v-7h20v7c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$creditCard = {eY: 'credit-card', a: $author$project$Pyxis$Components$IconSet$svgCreditCard};
var $author$project$Common$PaymentMethod$buildIconForOtherCard = A2(
	$author$project$Pyxis$Components$Icon$withSize,
	$author$project$Pyxis$Components$Icon$sizeM,
	A2(
		$author$project$Pyxis$Components$Icon$withStyle,
		$author$project$Pyxis$Components$Icon$neutral,
		$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$creditCard)));
var $author$project$Pyxis$Components$Card$IconAddon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Card$InHeader = 2;
var $author$project$Pyxis$Components$Card$withAddonIconOnHeader = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				mu: $elm$core$Maybe$Just(
					{
						aa: 2,
						bq: $author$project$Pyxis$Components$Card$IconAddon(icon)
					})
			});
	});
var $author$project$Pyxis$Components$Card$ImageAddon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Card$withAddonImageOnHeader = F2(
	function (url, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				mu: $elm$core$Maybe$Just(
					{
						aa: 2,
						bq: $author$project$Pyxis$Components$Card$ImageAddon(url)
					})
			});
	});
var $author$project$Common$PaymentMethod$withPaymentImage = F2(
	function (brand, config) {
		switch (brand.$) {
			case 0:
				return A2($author$project$Pyxis$Components$Card$withAddonImageOnHeader, '/assets/visa-s.svg', config);
			case 1:
				return A2($author$project$Pyxis$Components$Card$withAddonImageOnHeader, '/assets/mastercard-s.svg', config);
			case 2:
				return A2($author$project$Pyxis$Components$Card$withAddonImageOnHeader, '/assets/maestro-s.svg', config);
			default:
				return A2($author$project$Pyxis$Components$Card$withAddonIconOnHeader, $author$project$Common$PaymentMethod$buildIconForOtherCard, config);
		}
	});
var $author$project$Common$PaymentMethod$render = F2(
	function (i18n, paymentMethod) {
		return $author$project$Pyxis$Components$Card$render(
			A2(
				$author$project$Pyxis$Components$Card$withContent,
				A2($author$project$Common$PaymentMethod$paymentMethodContent, i18n, paymentMethod),
				A2(
					$author$project$Common$PaymentMethod$withPaymentImage,
					paymentMethod.bB,
					A2(
						$author$project$Pyxis$Components$Card$withHeader,
						A2($author$project$Common$PaymentMethod$paymentMethodHeader, i18n, paymentMethod),
						$author$project$Pyxis$Components$Card$config))));
	});
var $author$project$Common$ComponentUI$PaymentBox$viewPaymentMethodBox = F3(
	function (i18n, paymentMethodRemoteData, onRetryButtonClick) {
		switch (paymentMethodRemoteData.$) {
			case 3:
				var paymentMethod = paymentMethodRemoteData.a;
				return A2($author$project$Common$PaymentMethod$render, i18n, paymentMethod);
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('payment-container__payment-method-box__loading')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('es-fe-bo-border--neutral2 es-fe-bo-border-radius--2xl')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Common$ComponentUI$ErrorBox$render,
							i18n,
							_List_fromArray(
								[
									$author$project$Translations$paymentDetailsPaymentDetailsError(i18n)
								]),
							onRetryButtonClick)
						]));
			default:
				return $elm_community$html_extra$Html$Extra$nothing;
		}
	});
var $author$project$Common$ComponentUI$PaymentBox$view = F3(
	function (i18n, paymentMethodRemoteData, onRetryButtonClick) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('payment-container__payment-method-box')
						]),
					_List_fromArray(
						[
							A3($author$project$Common$ComponentUI$PaymentBox$viewPaymentMethodBox, i18n, paymentMethodRemoteData, onRetryButtonClick)
						]))
				]));
	});
var $author$project$Page$OfferDetails$View$viewPaymentBox = F3(
	function (i18n, model, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Common$Offer$pickIsRenewal(offer),
			A3(
				$author$project$Common$ComponentUI$PaymentBox$view,
				i18n,
				model.lq,
				$author$project$Page$OfferDetails$Msg$RetryGetPaymentMethod(
					$author$project$Common$Offer$pickId(offer))));
	});
var $author$project$Page$OfferDetails$View$viewOffer = F3(
	function (i18n, model, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('offer-details__primary-container container-responsive padding-v-3xl')
				]),
			_List_fromArray(
				[
					A3($author$project$Page$OfferDetails$View$viewHeaderContainer, i18n, model, offer),
					A2(
					$author$project$Common$Render$ifCondition,
					$author$project$Page$OfferDetails$View$renderGreatLakesBanner(i18n),
					$author$project$Common$Offer$isOfferGreatLakesRenewal(offer)),
					A5(
					$author$project$Common$ComponentUI$DetailsResultBox$viewFromOffer,
					i18n,
					model.gj,
					{
						hO: A2(
							$author$project$Page$OfferDetails$Msg$AmendOfferCoverageEffectiveDate,
							offer,
							$author$project$Common$TimeHelper$tomorrow(model.gj)),
						hV: $author$project$Page$OfferDetails$Msg$ShowCompleteOfferLegalInformationModal(true),
						h8: $author$project$Page$OfferDetails$Msg$PurchaseOfferButtonPressed(offer)
					},
					offer,
					$krisajenkins$remotedata$RemoteData$isLoading(model.jZ)),
					A3(
					$author$project$Common$Portfolio$render,
					i18n,
					model.dt,
					A2($author$project$Page$OfferDetails$View$portfolioConfig, model, offer)),
					A3($author$project$Page$OfferDetails$View$viewPaymentBox, i18n, model, offer)
				]));
	});
var $author$project$Page$OfferDetails$View$renderOfferDetails = F3(
	function (i18n, env, model) {
		var _v0 = model.G;
		switch (_v0.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('offer-details__loading')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
							]))
					]);
			case 2:
				return _List_fromArray(
					[$author$project$Common$ErrorContainer$generic]);
			default:
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					return _List_fromArray(
						[$author$project$Common$ErrorContainer$notFound]);
				} else {
					var offer = _v0.a.a;
					var chosenExcess = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Common$CoverSelection$defaultExcess,
						A2(
							$elm$core$Maybe$map,
							$author$project$Common$CoverSelection$pickExcess,
							$krisajenkins$remotedata$RemoteData$toMaybe(model.jZ)));
					return _List_fromArray(
						[
							A3($author$project$Page$OfferDetails$View$viewOffer, i18n, model, offer),
							A2(
							$author$project$Common$Render$maybe,
							function (coverSelection) {
								return A6($author$project$Common$ComponentUI$Modal$RecordingDisclaimer$render, offer, coverSelection, i18n, $author$project$Page$OfferDetails$Msg$RecordingDisclaimerDismissed, $author$project$Page$OfferDetails$Msg$RedirectToPayment, model.dE);
							},
							$krisajenkins$remotedata$RemoteData$toMaybe(model.jZ)),
							A6(
							$author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$render,
							i18n,
							$author$project$Common$Offer$pickId(offer),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentGiven(0),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentDismissed(0),
							$krisajenkins$remotedata$RemoteData$isLoading(model.dA),
							model.au),
							A6(
							$author$project$Common$ComponentUI$Modal$GreatLakesOptInConsent$render,
							i18n,
							$author$project$Common$Offer$pickId(offer),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentGiven(1),
							$author$project$Page$OfferDetails$Msg$GreatLakesOptInConsentDismissed(1),
							$krisajenkins$remotedata$RemoteData$isLoading(model.dA),
							model.bQ),
							A5(
							$author$project$Common$ComponentUI$Modal$CompleteOfferLegalInformation$render,
							offer,
							i18n,
							$author$project$ExternalUrl$FunnelOffer(env),
							$author$project$Page$OfferDetails$Msg$ShowCompleteOfferLegalInformationModal(false),
							model.eh),
							A4(
							$author$project$Common$ComponentUI$Modal$CoverPackages$render,
							i18n,
							$author$project$Common$Offer$pickSelectedBundle(offer),
							chosenExcess,
							model.ej)
						]);
				}
		}
	});
var $author$project$Pyxis$Components$Toasts$Bottom = 2;
var $author$project$Pyxis$Components$Toasts$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Toasts$config = function (id) {
	return {fZ: 'Notifications', ep: _List_Nil, kv: id, hK: $elm$core$Maybe$Nothing, hL: $elm$core$Maybe$Nothing, aa: 2, fz: $elm$core$Maybe$Nothing};
};
var $author$project$Pyxis$Components$Toasts$offsetBottomAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append('--toaster-offset-bottom: '),
			$elm$html$Html$Attributes$attribute('style'))));
var $author$project$Pyxis$Components$Toasts$offsetTopAttribute = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append('--toaster-offset-top: '),
			$elm$html$Html$Attributes$attribute('style'))));
var $author$project$Pyxis$Components$Toasts$placementToClass = function (placement) {
	switch (placement) {
		case 0:
			return 'toaster--top';
		case 2:
			return 'toaster--bottom';
		default:
			return 'toaster--top-right';
	}
};
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Pyxis$Components$Toasts$AutoRemove = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$Toasts$Hold = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pyxis$Components$Toasts$Resume = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pyxis$Components$Toasts$internalIdToAccessibleId = function (internalUuid) {
	return A2(
		$elm$core$String$join,
		'-',
		_List_fromArray(
			['toast', internalUuid]));
};
var $author$project$Pyxis$Components$Toasts$isAlertDialog = F2(
	function (maybeAction, content) {
		var _v0 = _Utils_Tuple2(maybeAction, content);
		if (!_v0.a.$) {
			return true;
		} else {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return true;
			} else {
				return false;
			}
		}
	});
var $author$project$Pyxis$Components$Toasts$prefixToastClass = function (variant) {
	return A2(
		$elm$core$String$join,
		'--',
		_List_fromArray(
			['toast', variant]));
};
var $author$project$Pyxis$Components$Toasts$Remove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Toasts$renderIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Icon$config,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM),
		$author$project$Pyxis$Components$Icon$render));
var $author$project$Pyxis$Components$Toasts$renderCloseButton = F3(
	function (tagger, id, closeButtonLabel) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast__close'),
					$elm$html$Html$Events$onClick(
					tagger(
						$author$project$Pyxis$Components$Toasts$Remove(id))),
					$author$project$Pyxis$Commons$Attributes$ariaLabel(closeButtonLabel)
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Toasts$renderIcon($author$project$Pyxis$Components$IconSet$cross)
				]));
	});
var $author$project$Pyxis$Components$Toasts$renderAction = function (_v0) {
	var label = _v0.a;
	var onClickHandler = _v0.b;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast__action')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						onClickHandler,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							label,
							A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeS, $author$project$Pyxis$Components$Button$primary))))
				]))
		]);
};
var $author$project$Pyxis$Components$Toasts$renderText = F2(
	function (toastId, text) {
		if (!text.$) {
			var string = text.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast__text'),
							$elm$html$Html$Attributes$id(
							$author$project$Pyxis$Components$Toasts$internalIdToAccessibleId(toastId))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(string)
						]))
				]);
		} else {
			var content = text.a;
			var title = text.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast__content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(
									$author$project$Pyxis$Components$Toasts$internalIdToAccessibleId(toastId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toast__text')
								]),
							_List_fromArray(
								[content]))
						]))
				]);
		}
	});
var $author$project$Pyxis$Components$Toasts$renderContentWrapper = F3(
	function (id, content, maybeCustomAction) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast__content-wrapper')
				]),
			A2(
				$elm$core$List$append,
				A2($author$project$Pyxis$Components$Toasts$renderText, id, content),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Toasts$renderAction, maybeCustomAction))));
	});
var $author$project$Pyxis$Components$Toasts$renderIconContainer = function (icon) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('toast__icon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Toasts$renderIcon(icon)
			]));
};
var $elm$svg$Svg$Attributes$color = _VirtualDom_attribute('color');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$pathLength = _VirtualDom_attribute('pathLength');
var $elm$svg$Svg$Attributes$preserveAspectRatio = _VirtualDom_attribute('preserveAspectRatio');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Pyxis$Components$Toasts$renderToastLoader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('toast__loader')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 100 2'),
					$elm$svg$Svg$Attributes$preserveAspectRatio('none'),
					$elm$svg$Svg$Attributes$class('toast__loader')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('0'),
							$elm$svg$Svg$Attributes$y1('0'),
							$elm$svg$Svg$Attributes$x2('100'),
							$elm$svg$Svg$Attributes$y2('0'),
							$elm$svg$Svg$Attributes$strokeWidth('12'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$color('transparent'),
							$elm$svg$Svg$Attributes$pathLength('1'),
							$elm$svg$Svg$Attributes$class('toast__loader__background')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('0'),
							$elm$svg$Svg$Attributes$y1('0'),
							$elm$svg$Svg$Attributes$x2('100'),
							$elm$svg$Svg$Attributes$y2('0'),
							$elm$svg$Svg$Attributes$stroke('purple'),
							$elm$svg$Svg$Attributes$strokeWidth('12'),
							$elm$svg$Svg$Attributes$strokeLinecap('round'),
							$elm$svg$Svg$Attributes$color('transparent'),
							$elm$svg$Svg$Attributes$pathLength('100'),
							$elm$svg$Svg$Attributes$class('toast__loader__line')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pyxis$Components$Toasts$toastRole = F2(
	function (maybeAction, content) {
		return A2($author$project$Pyxis$Components$Toasts$isAlertDialog, maybeAction, content) ? 'alertdialog' : 'alert';
	});
var $author$project$Pyxis$Components$Toasts$variantToString = function (variant) {
	switch (variant) {
		case 0:
			return 'neutral';
		case 1:
			return 'brand';
		case 2:
			return 'alert';
		case 3:
			return 'success';
		case 4:
			return 'error';
		default:
			return 'informative';
	}
};
var $author$project$Pyxis$Components$Toasts$ToastsHelpers$visibilityTimeAsStyleString = function (duration) {
	return A3(
		$primait$prima_elm_extra$PrimaFunction$flip,
		$elm$core$Basics$append,
		'ms',
		$elm$core$String$fromInt(duration));
};
var $author$project$Pyxis$Components$Toasts$renderToast = F2(
	function (tagger, _v0) {
		var action = _v0.U;
		var classList = _v0.ga;
		var closeButtonLabel = _v0.gb;
		var dataAttrList = _v0.ep;
		var duration = _v0.eu;
		var icon = _v0.ku;
		var id = _v0.kv;
		var isSticky = _v0.eV;
		var testId = _v0.fz;
		var text = _v0.pK;
		var variant = _v0.jd;
		var onAnimationEnd = _v0.hQ;
		return A2(
			$elm$html$Html$div,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('toast', true),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Toasts$prefixToastClass(
									$author$project$Pyxis$Components$Toasts$variantToString(variant)),
								true),
								_Utils_Tuple2(
								'toast--with-icon',
								$elm_community$maybe_extra$Maybe$Extra$isJust(icon))
							])),
						$elm$html$Html$Attributes$classList(classList),
						$author$project$Pyxis$Commons$Attributes$role(
						A2($author$project$Pyxis$Components$Toasts$toastRole, action, text)),
						A2(
						$author$project$Pyxis$Commons$Attributes$renderIf,
						A2($author$project$Pyxis$Components$Toasts$isAlertDialog, action, text),
						$author$project$Pyxis$Commons$Attributes$ariaLabelledBy(
							$author$project$Pyxis$Components$Toasts$internalIdToAccessibleId(id))),
						A2(
						$author$project$Pyxis$Commons$Attributes$maybe,
						A2(
							$elm$core$Basics$composeR,
							$elm$json$Json$Decode$succeed,
							$elm$html$Html$Events$on('transitionend')),
						onAnimationEnd),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
						A2(
						$elm$html$Html$Attributes$attribute,
						'style',
						'--toast-duration: ' + $author$project$Pyxis$Components$Toasts$ToastsHelpers$visibilityTimeAsStyleString(duration)),
						$elm$html$Html$Events$onMouseEnter(
						tagger(
							$author$project$Pyxis$Components$Toasts$Hold(id))),
						$elm$html$Html$Events$onMouseLeave(
						tagger(
							$author$project$Pyxis$Components$Toasts$Resume(id)))
					])),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Toasts$renderIconContainer, icon)),
					A3($author$project$Pyxis$Components$Toasts$renderContentWrapper, id, text, action),
					A3($author$project$Pyxis$Components$Toasts$renderCloseButton, tagger, id, closeButtonLabel),
					A2($author$project$Pyxis$Commons$Render$renderIf, !isSticky, $author$project$Pyxis$Components$Toasts$renderToastLoader)
				]));
	});
var $author$project$Pyxis$Components$Toasts$withToastAnimationEnd = F2(
	function (tagger, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hQ: $elm$core$Maybe$Just(tagger)
			});
	});
var $author$project$Pyxis$Components$Toasts$withToastClassList = F2(
	function (classes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classes});
	});
var $author$project$Pyxis$Components$Toasts$renderTimedToast = F3(
	function (tagger, id, timedToast) {
		switch (timedToast.$) {
			case 0:
				var toastElement = timedToast.b;
				return A2($author$project$Pyxis$Components$Toasts$renderToast, tagger, toastElement);
			case 1:
				var toastElement = timedToast.a;
				return A2(
					$author$project$Pyxis$Components$Toasts$renderToast,
					tagger,
					A2(
						$author$project$Pyxis$Components$Toasts$withToastAnimationEnd,
						tagger(
							$author$project$Pyxis$Components$Toasts$AutoRemove(id)),
						A2(
							$author$project$Pyxis$Components$Toasts$withToastClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('toast--fade-out', true)
								]),
							toastElement)));
			case 2:
				var toastElement = timedToast.a;
				return A2($author$project$Pyxis$Components$Toasts$renderToast, tagger, toastElement);
			default:
				var toastElement = timedToast.b;
				return A2($author$project$Pyxis$Components$Toasts$renderToast, tagger, toastElement);
		}
	});
var $author$project$Pyxis$Components$Toasts$renderToastList = F2(
	function (tagger, _v0) {
		var uuid = _v0.a;
		var timedToast = _v0.b;
		return _Utils_Tuple2(
			uuid,
			A4($elm$html$Html$Lazy$lazy3, $author$project$Pyxis$Components$Toasts$renderTimedToast, tagger, uuid, timedToast));
	});
var $author$project$Pyxis$Components$Toasts$render = F3(
	function (tagger, _v0, _v1) {
		var toasts = _v0.t;
		var ariaLabel = _v1.fZ;
		var id = _v1.kv;
		var dataAttrList = _v1.ep;
		var placement = _v1.aa;
		var offsetBottom = _v1.hK;
		var offsetTop = _v1.hL;
		var testId = _v1.fz;
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				dataAttrList,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('toaster', true),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Toasts$placementToClass(placement),
								true),
								_Utils_Tuple2(
								'toaster--with-offset',
								$elm_community$maybe_extra$Maybe$Extra$isJust(offsetTop)),
								_Utils_Tuple2(
								'toaster--with-bottom-offset',
								$elm_community$maybe_extra$Maybe$Extra$isJust(offsetBottom))
							])),
						$elm$html$Html$Attributes$id(id),
						$author$project$Pyxis$Commons$Attributes$role('region'),
						$author$project$Pyxis$Commons$Attributes$ariaLabel(ariaLabel),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Toasts$offsetBottomAttribute, offsetBottom),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Toasts$offsetTopAttribute, offsetTop),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId)
					])),
			A2(
				$elm$core$List$map,
				$author$project$Pyxis$Components$Toasts$renderToastList(tagger),
				$elm$core$Dict$toList(toasts)));
	});
var $author$project$Pyxis$Components$Toasts$TopRight = 1;
var $author$project$Pyxis$Components$Toasts$topRightPlacement = 1;
var $author$project$Pyxis$Components$Toasts$withPlacement = F2(
	function (placement, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aa: placement});
	});
var $author$project$Page$OfferDetails$View$viewToasts = function (model) {
	return A3(
		$author$project$Pyxis$Components$Toasts$render,
		$author$project$Page$OfferDetails$Msg$ToastMsg,
		model.t,
		A2(
			$author$project$Pyxis$Components$Toasts$withPlacement,
			$author$project$Pyxis$Components$Toasts$topRightPlacement,
			$author$project$Pyxis$Components$Toasts$config('offer-details-toaster')));
};
var $author$project$Page$OfferDetails$View$view = F3(
	function (i18n, env, model) {
		return A2(
			$elm$core$List$cons,
			$author$project$Page$OfferDetails$View$viewToasts(model),
			A3($author$project$Page$OfferDetails$View$renderOfferDetails, i18n, env, model));
	});
var $author$project$Page$OfferDetails$view = F3(
	function (i18n, env, model) {
		return {
			f3: A3($author$project$Page$OfferDetails$View$view, i18n, env, model),
			i4: $author$project$Translations$routeOfferDetails(i18n)
		};
	});
var $author$project$Translations$routePayment = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Payment';
	} else {
		return 'Pago';
	}
};
var $author$project$Common$ErrorContainer$productsNotFound = A2($author$project$Common$ErrorContainer$custom, 1, 'Oops! We couldn\'t find any product for this offer');
var $author$project$Translations$paymentSpinnerText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Loading checkout...';
	} else {
		return 'Procesando...';
	}
};
var $author$project$Pyxis$Components$Loaders$Loader$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				pK: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Page$Payment$View$renderLoadingPage = function (i18n) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('justify-content-center display-flex')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Loaders$Loader$render(
				A2(
					$author$project$Pyxis$Components$Loaders$Loader$withText,
					$author$project$Translations$paymentSpinnerText(i18n),
					$author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM))
			]));
};
var $author$project$Page$Payment$Msg$PaymentSubmit = {$: 6};
var $author$project$Pyxis$Components$Form$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$config = {dZ: $elm$core$Maybe$Nothing, U: $elm$core$Maybe$Nothing, f0: $elm$core$Maybe$Nothing, ga: _List_Nil, ep: _List_Nil, ey: $elm$core$Maybe$Nothing, c_: _List_Nil, kv: $elm$core$Maybe$Nothing, e1: $elm$core$Maybe$Nothing, kT: $elm$core$Maybe$Nothing, e3: $elm$core$Maybe$Nothing, lj: $elm$core$Maybe$Nothing, fx: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing};
var $author$project$Pyxis$Components$Form$Fieldset$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Form$Fieldset$L = 2;
var $author$project$Pyxis$Components$Form$Fieldset$config = {fO: _List_Nil, ga: _List_Nil, a0: _List_Nil, ep: _List_Nil, eC: _List_Nil, eH: _List_Nil, kv: $elm$core$Maybe$Nothing, eP: false, ba: $elm$core$Maybe$Nothing, da: 2};
var $elm$html$Html$Attributes$acceptCharset = $elm$html$Html$Attributes$stringProperty('acceptCharset');
var $elm$html$Html$Attributes$action = function (uri) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'action',
		_VirtualDom_noJavaScriptUri(uri));
};
var $elm$html$Html$Attributes$enctype = $elm$html$Html$Attributes$stringProperty('enctype');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$Attributes$method = $elm$html$Html$Attributes$stringProperty('method');
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $author$project$Pyxis$Components$Grid$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Gap$L = 2;
var $author$project$Pyxis$Components$Grid$Gap$sizeL = 2;
var $author$project$Pyxis$Components$Grid$gapL = function (c) {
	return _Utils_update(
		c,
		{aI: $author$project$Pyxis$Components$Grid$Gap$sizeL});
};
var $author$project$Pyxis$Components$Grid$Gap$S = 0;
var $author$project$Pyxis$Components$Grid$Gap$sizeS = 0;
var $author$project$Pyxis$Components$Grid$gapS = function (c) {
	return _Utils_update(
		c,
		{aI: $author$project$Pyxis$Components$Grid$Gap$sizeS});
};
var $author$project$Pyxis$Components$Grid$oneColRowFullWidth = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Grid$col(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pyxis$Components$Grid$row(_List_Nil)));
var $author$project$Pyxis$Components$Form$Fieldset$renderContent = function (content) {
	return _List_fromArray(
		[
			$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Components$Grid$render,
					_List_fromArray(
						[$author$project$Pyxis$Components$Grid$gapS]),
					content)
				]))
		]);
};
var $author$project$Pyxis$Components$Grid$Row$Option = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Grid$Row$sizeL = function (config) {
	return _Utils_update(
		config,
		{aR: 2});
};
var $author$project$Pyxis$Components$Grid$Row$sizeM = function (config) {
	return _Utils_update(
		config,
		{aR: 1});
};
var $author$project$Pyxis$Components$Grid$Row$sizeS = function (config) {
	return _Utils_update(
		config,
		{aR: 0});
};
var $author$project$Pyxis$Components$Form$Fieldset$getRowSize = function (rowSize) {
	switch (rowSize) {
		case 0:
			return $author$project$Pyxis$Components$Grid$Row$sizeS;
		case 1:
			return $author$project$Pyxis$Components$Grid$Row$sizeM;
		default:
			return $author$project$Pyxis$Components$Grid$Row$sizeL;
	}
};
var $author$project$Pyxis$Components$Form$Fieldset$renderLegendRow = F2(
	function (rowSize, legend) {
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Form$Fieldset$getRowSize(rowSize)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Form$Legend$render(legend)
							]))
					]))
			]);
	});
var $author$project$Pyxis$Components$Form$Fieldset$renderVisualLegend = function (rowSize) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			$author$project$Pyxis$Components$Form$Fieldset$renderLegendRow(rowSize)),
		$elm$core$Maybe$withDefault(_List_Nil));
};
var $author$project$Pyxis$Components$Form$Legend$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Pyxis$Components$Form$Fieldset$render = function (_v0) {
	var classList = _v0.ga;
	var dataAttrList = _v0.ep;
	var header = _v0.eH;
	var content = _v0.a0;
	var footer = _v0.eC;
	var legend = _v0.ba;
	var additionalContent = _v0.fO;
	var isHiddenLegend = _v0.eP;
	var legendRowSize = _v0.da;
	var id = _v0.kv;
	return A2(
		$elm$html$Html$fieldset,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, id)
				])),
		_List_fromArray(
			[
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Pyxis$Components$Form$Legend$withClassList(
							_List_fromArray(
								[
									_Utils_Tuple2('sr-only', true)
								])),
						$author$project$Pyxis$Components$Form$Legend$render),
					legend)),
				A2(
				$author$project$Pyxis$Components$Grid$render,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$gapL]),
				_Utils_ap(
					additionalContent,
					_Utils_ap(
						(!isHiddenLegend) ? A2($author$project$Pyxis$Components$Form$Fieldset$renderVisualLegend, legendRowSize, legend) : _List_Nil,
						_Utils_ap(
							header,
							_Utils_ap(
								$author$project$Pyxis$Components$Form$Fieldset$renderContent(content),
								footer)))))
			]));
};
var $author$project$Pyxis$Components$Form$render = function (_v0) {
	var onSubmit = _v0.lj;
	var dataAttrList = _v0.ep;
	var gridContent = _v0.c_;
	var classList = _v0.ga;
	var id = _v0.kv;
	var testId = _v0.fz;
	var acceptCharset = _v0.dZ;
	var action = _v0.U;
	var autocomplete = _v0.f0;
	var encType = _v0.ey;
	var method = _v0.e1;
	var name = _v0.kT;
	var noValidate = _v0.e3;
	var target = _v0.fx;
	return A2(
		$elm$html$Html$form,
		A2(
			$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
			dataAttrList,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form'),
					$elm$html$Html$Attributes$classList(classList),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$id, id),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$acceptCharset, acceptCharset),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$action, action),
					A2(
					$author$project$Pyxis$Commons$Attributes$maybe,
					$elm$html$Html$Attributes$attribute('autocomplete'),
					autocomplete),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$enctype, encType),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$method, method),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$name, name),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$novalidate, noValidate),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$target, target),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, testId),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Events$onSubmit, onSubmit)
				])),
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Pyxis$Components$Form$Fieldset$render),
			A2($elm$core$List$filter, $elm$core$Tuple$second, gridContent)));
};
var $author$project$Page$Payment$View$acceptedCardsStaticInfo = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('payment__static-info')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__credit-cards'),
					$elm$html$Html$Attributes$class('display-flex')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/visa-s.svg'),
							$elm$html$Html$Attributes$class('space-h-xs')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/mastercard-s.svg'),
							$elm$html$Html$Attributes$class('space-h-xs')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/maestro-s.svg'),
							$elm$html$Html$Attributes$class('space-h-xs')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pyxis$Components$Grid$oneColRowSizeS = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Grid$col(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pyxis$Components$Grid$row(
			_List_fromArray(
				[$author$project$Pyxis$Components$Grid$Row$sizeS]))));
var $author$project$Translations$paymentCardExpirationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expiration Date';
	} else {
		return 'Caducidad';
	}
};
var $author$project$Translations$paymentCardNumberLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card Number';
	} else {
		return 'Número de la tarjeta';
	}
};
var $author$project$Translations$paymentFetchProductsErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Couldn\'t fetch products';
	} else {
		return 'No se pudieron obtener los productos';
	}
};
var $author$project$Page$Payment$View$securePaymentStaticInfo = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('display-flex')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/secure-payment.svg')
				]),
			_List_Nil)
		]));
var $author$project$Translations$paymentTaxeslabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Including taxes';
	} else {
		return 'Incluye impuestos';
	}
};
var $author$project$Translations$paymentTotalPriceLabel = F2(
	function (refundPrice, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Total Price: ' + refundPrice;
		} else {
			return 'Precio total: ' + refundPrice;
		}
	});
var $author$project$Common$Price$toStringNoSpaceSignFirst = F2(
	function (i18n, _v0) {
		var amount = _v0.a;
		return _Utils_ap(
			$author$project$Common$Price$pickSign,
			A2($author$project$Common$Price$toAmountString, i18n, amount));
	});
var $author$project$Common$Price$zeroEuro = $author$project$Common$Price$zero(0);
var $author$project$Page$Payment$View$totalPrice = F2(
	function (i18n, _v0) {
		var gotOfferProductResult = _v0.gP;
		var sumProductsPrices = function (offerProducts) {
			return $author$project$Common$Price$sumAll(
				A2(
					$elm$core$List$map,
					function (product) {
						return product.mz.nl;
					},
					offerProducts));
		};
		var calculatedPrice = A3($krisajenkins$remotedata$RemoteData$unwrap, $author$project$Common$Price$zeroEuro, sumProductsPrices, gotOfferProductResult);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title-m-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$paymentTotalPriceLabel,
								A2($author$project$Common$Price$toStringNoSpaceSignFirst, i18n, calculatedPrice),
								i18n))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-l-book c-content-weak')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$paymentTaxeslabel(i18n))
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$Label$M = 1;
var $author$project$Pyxis$Components$Field$Label$config = {ga: _List_Nil, ep: _List_Nil, eD: $elm$core$Maybe$Nothing, kv: $elm$core$Maybe$Nothing, eO: false, pz: false, aR: 1, fs: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, pK: $elm$core$Maybe$Nothing, fC: $elm$core$Maybe$Nothing};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Pyxis$Components$Field$Label$withText = F2(
	function (text, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				pK: $elm$core$Maybe$Just(text)
			});
	});
var $author$project$Page$Payment$View$viewCardField = F2(
	function (label, _v0) {
		var id = _v0.kv;
		var isValid = _v0.bX;
		var isPristine = _v0.eS;
		return A2(
			$author$project$Pyxis$Components$Grid$col,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Field$Label$render(
					A2(
						$author$project$Pyxis$Components$Field$Label$withFor,
						id,
						A2($author$project$Pyxis$Components$Field$Label$withText, label, $author$project$Pyxis$Components$Field$Label$config))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(id),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field form-field__text', true),
									_Utils_Tuple2('form-field--error', !(isValid || isPristine))
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Payment$View$viewProduct = F2(
	function (i18n, _v0) {
		var bundleSlug = _v0.mJ;
		var annualPrice = _v0.mz;
		return A2(
			$author$project$Pyxis$Components$Grid$row,
			_List_fromArray(
				[$author$project$Pyxis$Components$Grid$Row$sizeS]),
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Components$Grid$col,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('product-card product-card--checkout product-card--selected')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('product-card__header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('/assets/motorcycle-car.svg')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('title-s-bold')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Common$Product$bundleSlugToString, i18n, bundleSlug))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('product-card__price')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Common$Price$toStringSignFirst, i18n, annualPrice.nl))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Payment$View$viewProducts = F2(
	function (i18n, offerProducts) {
		return A2(
			$elm$core$List$map,
			function (product) {
				return A2($author$project$Page$Payment$View$viewProduct, i18n, product);
			},
			offerProducts);
	});
var $author$project$Page$Payment$View$renderFormContent = F2(
	function (i18n, model) {
		var viewStaticFields = _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('display-flex justify-content-space-between align-items-center')
									]),
								_List_fromArray(
									[$author$project$Page$Payment$View$acceptedCardsStaticInfo, $author$project$Page$Payment$View$securePaymentStaticInfo]))
							]))
					]))
			]);
		var viewSelectedProductsCards = A3(
			$krisajenkins$remotedata$RemoteData$unwrap,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Grid$oneColRowSizeS(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Translations$paymentFetchProductsErrorMessage(i18n))
						]))
				]),
			function (offerProducts) {
				return A2($author$project$Page$Payment$View$viewProducts, i18n, offerProducts);
			},
			model.gP);
		var viewPaymentFields = _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$Payment$View$viewCardField,
						$author$project$Translations$paymentCardNumberLabel(i18n),
						model.ea.cL)
					])),
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$Payment$View$viewCardField,
						$author$project$Translations$paymentCardExpirationDateLabel(i18n),
						model.ea.cW)
					])),
				$author$project$Pyxis$Components$Grid$oneColRowSizeS(
				_List_fromArray(
					[
						A2($author$project$Page$Payment$View$totalPrice, i18n, model)
					]))
			]);
		return $elm$core$List$concat(
			_List_fromArray(
				[viewSelectedProductsCards, viewPaymentFields, viewStaticFields]));
	});
var $author$project$Page$Payment$Msg$GoBackToPreviousPage = {$: 2};
var $author$project$Translations$paymentBackButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Regresar';
	}
};
var $author$project$Page$Payment$View$renderBackButton = function (i18n) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('payment__back-button')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Button$render(
				A2(
					$author$project$Pyxis$Components$Button$withIconPrepend,
					$author$project$Pyxis$Components$IconSet$chevronLeft,
					A2(
						$author$project$Pyxis$Components$Button$withSize,
						$author$project$Pyxis$Components$Button$sizeM,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$paymentBackButtonText(i18n),
							A2($author$project$Pyxis$Components$Button$withOnClick, $author$project$Page$Payment$Msg$GoBackToPreviousPage, $author$project$Pyxis$Components$Button$ghost)))))
			]));
};
var $author$project$Page$Payment$Model$hasValidCreditCardField = function (fields) {
	return fields.cL.bX && fields.cW.bX;
};
var $author$project$Pyxis$Components$Button$inherit = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{dX: 2});
};
var $author$project$Page$Payment$Model$isStatusPayingWithCreditCard = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.iR;
	},
	$elm$core$Basics$eq(3));
var $author$project$Page$Payment$Model$isStatusPaymentReady = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.iR;
	},
	$elm$core$Basics$eq(1));
var $author$project$Translations$paymentPurchaseButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Pay now';
	} else {
		return 'Pagar ahora';
	}
};
var $author$project$Pyxis$Components$Button$Submit = {$: 1};
var $author$project$Pyxis$Components$Button$submit = $author$project$Pyxis$Components$Button$Submit;
var $author$project$Page$Payment$View$renderPayNowButton = F2(
	function (i18n, model) {
		var cardFields = model.ea;
		var isLoading = $author$project$Page$Payment$Model$isStatusPayingWithCreditCard(model);
		var isEnabled = $author$project$Page$Payment$Model$hasValidCreditCardField(cardFields) && $author$project$Page$Payment$Model$isStatusPaymentReady(model);
		var isDisabled = !isEnabled;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__pay-now-button')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withTestId,
						'payment-button',
						A2(
							$author$project$Pyxis$Components$Button$withId,
							'payment-button',
							A2(
								$author$project$Pyxis$Components$Button$withType,
								$author$project$Pyxis$Components$Button$submit,
								A2(
									$author$project$Pyxis$Components$Button$withWidth,
									$author$project$Pyxis$Components$Button$inherit,
									A2(
										$author$project$Pyxis$Components$Button$withSize,
										$author$project$Pyxis$Components$Button$sizeXL,
										A2(
											$author$project$Pyxis$Components$Button$withDisabled,
											isDisabled,
											A2(
												$author$project$Pyxis$Components$Button$withLoading,
												isLoading,
												A2(
													$author$project$Pyxis$Components$Button$withText,
													$author$project$Translations$paymentPurchaseButtonText(i18n),
													$author$project$Pyxis$Components$Button$primary)))))))))
				]));
	});
var $author$project$Page$Payment$View$renderFormFooter = F2(
	function (i18n, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Pyxis$Components$Grid$row,
				_List_fromArray(
					[$author$project$Pyxis$Components$Grid$Row$sizeS]),
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('display-flex justify-content-space-between align-items-center')
									]),
								_List_fromArray(
									[
										$author$project$Page$Payment$View$renderBackButton(i18n),
										A2($author$project$Page$Payment$View$renderPayNowButton, i18n, model)
									]))
							]))
					]))
			]);
	});
var $author$project$Translations$paymentCurrentRiskAlreadyCoveredLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy with current risk already covered';
	} else {
		return 'Una póliza para el mismo vehículo ya existe';
	}
};
var $author$project$Translations$paymentFailedCardCallIssuer = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined - Please try again or contact your bank';
	} else {
		return 'Transacción denegada - Inténtelo nuevamente o contactar al banco';
	}
};
var $author$project$Translations$paymentFailedCardDeclined = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined - Please contact bank';
	} else {
		return 'Transacción denegada - Por favor contactar al banco';
	}
};
var $author$project$Translations$paymentFailedCardExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card expired';
	} else {
		return 'Tarjeta expirada';
	}
};
var $author$project$Translations$paymentFailedCardInsufficientFunds = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined(insufficient funds) - Please contact your bank';
	} else {
		return 'Transacción denegada (fondos insuf.) - Contactar al banco';
	}
};
var $author$project$Translations$paymentFailedCardLimitExceeded = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined(limit exceeded) - Please contact your bank';
	} else {
		return 'Transacción denegada (límite excedido) - Contactar al banco';
	}
};
var $author$project$Page$Payment$PaymentFailed$errorMessage = F2(
	function (i18n, code) {
		switch (code) {
			case 'ALREADY_COVERED':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentCurrentRiskAlreadyCoveredLabel(i18n));
			case 'Limit Exceeded':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardLimitExceeded(i18n));
			case 'Insufficient Funds':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardInsufficientFunds(i18n));
			case 'Declined - Call Issuer':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardCallIssuer(i18n));
			case 'Do Not Honor':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardDeclined(i18n));
			case 'Processor Declined':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardDeclined(i18n));
			case 'Expired Card':
				return $elm$core$Maybe$Just(
					$author$project$Translations$paymentFailedCardExpired(i18n));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Page$Payment$PaymentFailed$jsonToErrorCode = function (json) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
			json));
};
var $author$project$Translations$paymentFailedContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Something went wrong. Purchase not available.';
	} else {
		return 'Algo ha salido mal. La compra no está disponible.';
	}
};
var $author$project$Page$Payment$PaymentFailed$content = F2(
	function (i18n, errorList) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Translations$paymentFailedContent(i18n),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Page$Payment$PaymentFailed$errorMessage(i18n),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Page$Payment$PaymentFailed$jsonToErrorCode,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$Dict$get('extensions'),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.m3;
							},
							$elm$core$List$head(errorList))))));
	});
var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Payment$Model$isStatusPaymentFailed = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.iR;
	},
	$elm$core$Basics$eq(4));
var $author$project$Pyxis$Components$Grid$oneColRowSizeM = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Grid$col(_List_Nil),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pyxis$Components$Grid$row(
			_List_fromArray(
				[$author$project$Pyxis$Components$Grid$Row$sizeM]))));
var $author$project$Translations$paymentCardDeclinedContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please re-enter your card details and try again.';
	} else {
		return 'No se ha podido realizar la operación. Inténtalo de nuevo.';
	}
};
var $author$project$Translations$paymentCardDeclinedTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Card declined';
	} else {
		return 'Tarjeta denegada';
	}
};
var $author$project$Translations$paymentFailedTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Purchase failed';
	} else {
		return 'Compra fallida';
	}
};
var $author$project$Translations$paymentFormHeader = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Make Payment';
	} else {
		return 'Pago de la póliza';
	}
};
var $author$project$Page$Payment$View$renderFormHeader = F2(
	function (i18n, model) {
		var paymentClientError = model.ij;
		var gotPolicyResult = model.gQ;
		var viewPaymentFormHead = _List_fromArray(
			[
				$author$project$Pyxis$Components$Grid$oneColRowSizeM(
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Form$Legend$render(
						A2(
							$author$project$Pyxis$Components$Form$Legend$withTitle,
							$author$project$Translations$paymentFormHeader(i18n),
							$author$project$Pyxis$Components$Form$Legend$config))
					]))
			]);
		var renderErrorMessageContainer = function () {
			var paymentFailedContent = function () {
				if (gotPolicyResult.$ === 2) {
					var payload = gotPolicyResult.a;
					if (!payload.$) {
						var errorList = payload.b;
						return A2($author$project$Page$Payment$PaymentFailed$content, i18n, errorList);
					} else {
						return $author$project$Translations$paymentFailedContent(i18n);
					}
				} else {
					return $author$project$Translations$paymentFailedContent(i18n);
				}
			}();
			var _v0 = $author$project$Page$Payment$Model$isStatusPaymentFailed(model) ? _Utils_Tuple2(
				$author$project$Translations$paymentFailedTitle(i18n),
				paymentFailedContent) : _Utils_Tuple2(
				$author$project$Translations$paymentCardDeclinedTitle(i18n),
				$author$project$Translations$paymentCardDeclinedContent(i18n));
			var title = _v0.a;
			var content = _v0.b;
			return _List_fromArray(
				[
					$author$project$Pyxis$Components$Grid$oneColRowSizeM(
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Message$render(
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								_List_fromArray(
									[
										$elm$html$Html$text(content)
									]),
								A2(
									$author$project$Pyxis$Components$Message$withTitle,
									title,
									$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground))))
						]))
				]);
		}();
		var viewErrorMessage = function () {
			var hasPaymentFailed = $krisajenkins$remotedata$RemoteData$isFailure(gotPolicyResult);
			var hasPaymentClientError = $elm_community$maybe_extra$Maybe$Extra$isJust(paymentClientError);
			return (hasPaymentClientError || hasPaymentFailed) ? renderErrorMessageContainer : _List_Nil;
		}();
		return $elm$core$List$concat(
			_List_fromArray(
				[viewErrorMessage, viewPaymentFormHead]));
	});
var $author$project$Pyxis$Components$Form$Fieldset$withContent = F2(
	function (grid, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{a0: grid});
	});
var $author$project$Pyxis$Components$Form$withFieldsets = F2(
	function (gridContent, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				c_: A2(
					$elm$core$List$map,
					A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Tuple$pair, true),
					gridContent)
			});
	});
var $author$project$Pyxis$Components$Form$Fieldset$withFooter = F2(
	function (rows, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{eC: rows});
	});
var $author$project$Pyxis$Components$Form$Fieldset$withHeader = F2(
	function (rows, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{eH: rows});
	});
var $author$project$Pyxis$Components$Form$withOnSubmit = F2(
	function (onSubmit, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				lj: $elm$core$Maybe$Just(onSubmit)
			});
	});
var $author$project$Page$Payment$View$renderPaymentForm = F2(
	function (i18n, model) {
		return $author$project$Pyxis$Components$Form$render(
			A2(
				$author$project$Pyxis$Components$Form$withFieldsets,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Components$Form$Fieldset$withFooter,
						A2($author$project$Page$Payment$View$renderFormFooter, i18n, model),
						A2(
							$author$project$Pyxis$Components$Form$Fieldset$withContent,
							A2($author$project$Page$Payment$View$renderFormContent, i18n, model),
							A2(
								$author$project$Pyxis$Components$Form$Fieldset$withHeader,
								A2($author$project$Page$Payment$View$renderFormHeader, i18n, model),
								$author$project$Pyxis$Components$Form$Fieldset$config)))
					]),
				A2($author$project$Pyxis$Components$Form$withOnSubmit, $author$project$Page$Payment$Msg$PaymentSubmit, $author$project$Pyxis$Components$Form$config)));
	});
var $author$project$Page$Payment$View$view = F2(
	function (i18n, model) {
		var viewFetchBraintreeToken = function () {
			var _v1 = model.gO;
			switch (_v1.$) {
				case 2:
					return _List_fromArray(
						[$author$project$Common$ErrorContainer$generic]);
				case 3:
					return _List_fromArray(
						[
							A2($author$project$Page$Payment$View$renderPaymentForm, i18n, model)
						]);
				default:
					return _List_fromArray(
						[
							$author$project$Page$Payment$View$renderLoadingPage(i18n)
						]);
			}
		}();
		var content = function () {
			var _v0 = model.gP;
			switch (_v0.$) {
				case 0:
					return _List_fromArray(
						[
							$author$project$Page$Payment$View$renderLoadingPage(i18n)
						]);
				case 1:
					return _List_fromArray(
						[
							$author$project$Page$Payment$View$renderLoadingPage(i18n)
						]);
				case 2:
					return _List_fromArray(
						[$author$project$Common$ErrorContainer$generic]);
				default:
					if (!_v0.a.b) {
						return _List_fromArray(
							[$author$project$Common$ErrorContainer$productsNotFound]);
					} else {
						return viewFetchBraintreeToken;
					}
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-responsive padding-v-3xl')
					]),
				content)
			]);
	});
var $author$project$Page$Payment$view = F2(
	function (i18n, model) {
		return {
			f3: A2($author$project$Page$Payment$View$view, i18n, model),
			i4: $author$project$Translations$routePayment(i18n)
		};
	});
var $author$project$Translations$routePolicyDetails = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy details';
	} else {
		return 'Detalles de Poliza';
	}
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundConfirmation = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundDismissed = {$: 25};
var $author$project$Common$Policy$pickSelectedBundle = function (_v0) {
	var policy = _v0;
	return policy.dx.mJ;
};
var $author$project$Common$Price$amountString = F2(
	function (i18n, price) {
		return A2(
			$author$project$Common$Price$toAmountString,
			i18n,
			$author$project$Common$Price$pickAmount(price));
	});
var $author$project$Common$Price$pickCurrencySign = function (_v0) {
	return $author$project$Common$Price$pickSign;
};
var $author$project$Translations$policyInterruptionModalExpectedNoRefundAmountMessage = F3(
	function (data, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Customer should not be eligible for a '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.lE + (' ' + data.lD))
						])),
					$elm$html$Html$text(' refund.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El cliente no tendría derecho a un reembolso de '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.lD + (' ' + data.lE))
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Translations$policyInterruptionModalExpectedRefundAmountMessage = F3(
	function (data, bAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					$elm$html$Html$text('Customer\'s eligible for a '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.lE + (' ' + data.lD))
						])),
					$elm$html$Html$text(' refund.')
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('El cliente tiene derecho a un reembolso de '),
					A3(
					$elm$html$Html$node,
					'b',
					_Utils_ap(_List_Nil, bAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text(data.lD + (' ' + data.lE))
						])),
					$elm$html$Html$text('.')
				]);
		}
	});
var $author$project$Translations$policyInterruptionModalExpectedRefundNotAvailableMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'The refund estimate could not be processed';
	} else {
		return 'No se pudo procesar la estimación del reembolso';
	}
};
var $author$project$Pyxis$Components$Message$Success = 3;
var $author$project$Pyxis$Components$Message$success = function (style) {
	return A2($author$project$Pyxis$Components$Message$config, 3, style);
};
var $author$project$Pyxis$Components$Loaders$Loader$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$expectedRefundMessage = F2(
	function (i18n, remoteData) {
		switch (remoteData.$) {
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render(
					A2(
						$author$project$Pyxis$Components$Loaders$Loader$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('margin-t-l es-fe-bo--full-width', true)
							]),
						$author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM));
			case 2:
				return $author$project$Pyxis$Components$Message$render(
					A2(
						$author$project$Pyxis$Components$Message$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
							]),
						A2(
							$author$project$Pyxis$Components$Message$withContent,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$policyInterruptionModalExpectedRefundNotAvailableMessage(i18n))
								]),
							$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
			default:
				if (!remoteData.a.$) {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedNoRefundAmountMessage,
									{
										lD: A2($author$project$Common$Price$amountString, i18n, price),
										lE: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground))));
				} else {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedRefundAmountMessage,
									{
										lD: A2($author$project$Common$Price$amountString, i18n, price),
										lE: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$success($author$project$Pyxis$Components$Message$tintBackground))));
				}
		}
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$formId = 'amend-policy-interruption-form';
var $primait$prima_elm_extra$PrimaFunction$ifThenMap = F3(
	function (condition, mapper, m) {
		return condition(m) ? mapper(m) : m;
	});
var $author$project$Common$ReasonDescriptionStatus$isDescriptionValid = F2(
	function (text, status) {
		return (!(!status)) || ((!_Utils_eq(text, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
			text,
			$elm$core$Maybe$Just(''))));
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Pyxis$Components$Field$Autocomplete$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Autocomplete$M = 1;
var $author$project$Pyxis$Components$Field$Autocomplete$config = function (name) {
	return {fO: $elm$core$Maybe$Nothing, ga: _List_Nil, ep: _List_Nil, gt: false, cU: $elm$core$Maybe$Nothing, gH: $elm$core$Maybe$Nothing, gX: $elm$core$Maybe$Nothing, kv: 'id-' + name, c5: false, eY: $elm$core$Maybe$Nothing, kT: name, hG: 'No results found.', im: '', iG: false, iI: 'Reset', aR: 1, fu: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, dW: $elm$core$Maybe$Nothing};
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted = function (status) {
	if (status === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Translations$policyInterruptionModalReasonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reason';
	} else {
		return 'Motivo';
	}
};
var $author$project$Translations$policyInterruptionModalReasonPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Select the reason';
	} else {
		return 'Seleccionar el motivo';
	}
};
var $author$project$Pyxis$Components$Field$Autocomplete$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.eB;
		var value = _v0.pR;
		var id = _v1.kv;
		var isSubmitted = _v1.c5;
		var validation = _v1.dW;
		var errorShowingStrategy = _v1.cU;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kv: id, c5: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$Label$sizeM = 1;
var $author$project$Pyxis$Components$Field$Label$S = 0;
var $author$project$Pyxis$Components$Field$Label$sizeS = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnMouseDown = {$: 7};
var $author$project$Pyxis$Components$Form$Dropdown$M = 1;
var $author$project$Pyxis$Components$Form$Dropdown$sizeM = 1;
var $author$project$Pyxis$Components$Form$Dropdown$S = 0;
var $author$project$Pyxis$Components$Form$Dropdown$sizeS = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$mapDropdownSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Form$Dropdown$sizeS;
	} else {
		return $author$project$Pyxis$Components$Form$Dropdown$sizeM;
	}
};
var $author$project$Pyxis$Components$Form$Dropdown$NoResult = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Form$Dropdown$noResult = $author$project$Pyxis$Components$Form$Dropdown$NoResult;
var $author$project$Pyxis$Components$Form$Dropdown$Options = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pyxis$Components$Form$Dropdown$options = $author$project$Pyxis$Components$Form$Dropdown$Options;
var $author$project$Pyxis$Commons$Events$preventDefaultOn = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (msg_) {
					return _Utils_Tuple2(msg_, true);
				},
				$elm$json$Json$Decode$succeed(msg)));
	});
var $author$project$Pyxis$Components$Form$Dropdown$renderNoResult = function (_v0) {
	var label = _v0.eY;
	var action = _v0.U;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__no-results')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label),
				$author$project$Pyxis$Commons$Render$renderMaybe(
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						$elm$html$Html$div(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-dropdown__no-results__action')
								]))),
					action))
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Pyxis$Components$Icon$config,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Pyxis$Components$Icon$withSize($author$project$Pyxis$Components$Icon$sizeM),
		A2(
			$elm$core$Basics$composeR,
			$author$project$Pyxis$Components$Icon$withClassList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-dropdown__suggestion__icon', true)
					])),
			$author$project$Pyxis$Components$Icon$render)));
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionSubtitle = function (subtitle) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__suggestion__subtitle')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(subtitle)
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionTitle = function (title) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__suggestion__title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderSuggestion = function (_v0) {
	var icon = _v0.ku;
	var title = _v0.i4;
	var subtitle = _v0.dO;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-dropdown__suggestion')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Form$Dropdown$renderSuggestionIcon(icon),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-dropdown__suggestion__wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Form$Dropdown$renderSuggestionTitle(title),
						$author$project$Pyxis$Commons$Render$renderMaybe(
						A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Dropdown$renderSuggestionSubtitle, subtitle))
					]))
			]));
};
var $author$project$Pyxis$Components$Form$Dropdown$renderContent = function (content_) {
	switch (content_.$) {
		case 1:
			var options_ = content_.a;
			return options_;
		case 0:
			var noResultData = content_.a;
			return _List_fromArray(
				[
					$author$project$Pyxis$Components$Form$Dropdown$renderNoResult(noResultData)
				]);
		default:
			var config = content_.a;
			return _List_fromArray(
				[
					$author$project$Pyxis$Components$Form$Dropdown$renderSuggestion(config)
				]);
	}
};
var $author$project$Pyxis$Components$Form$Dropdown$render = F3(
	function (id, size, content_) {
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-dropdown', true),
							_Utils_Tuple2('form-dropdown--with-animation', true),
							_Utils_Tuple2('form-dropdown--s', !size)
						])),
					$elm$html$Html$Attributes$id(id + '-dropdown-list')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, item) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(index),
							item);
					}),
				$author$project$Pyxis$Components$Form$Dropdown$renderContent(content_)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$OnHover = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnSelect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pyxis$Components$IconSet$svgCheck = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M10 18c-.26 0-.51-.1-.71-.29L4 12.41c-.39-.39-.39-1.02 0-1.41h0c.39-.39 1.02-.39 1.41 0L10 15.59 19.59 6c.39-.39 1.02-.39 1.41 0h0c.39.39.39 1.02 0 1.41l-10.29 10.3c-.2.19-.45.29-.71.29z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$check = {eY: 'check', a: $author$project$Pyxis$Components$IconSet$svgCheck};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Pyxis$Components$Field$Autocomplete$renderOptionText = F3(
	function (filteringValue, isSelected, label) {
		var _v0 = _Utils_Tuple2(
			isSelected,
			!$elm$core$String$length(filteringValue));
		if (_v0.a) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-l-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]);
		} else {
			if (_v0.b) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-book')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					]);
			} else {
				var matchStartIndex = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$List$head(
						A2(
							$elm$core$String$indexes,
							$elm$core$String$toLower(filteringValue),
							$elm$core$String$toLower(label))));
				var matchEndIndex = matchStartIndex + $elm$core$String$length(filteringValue);
				var labelStart = A3($elm$core$String$slice, 0, matchStartIndex, label);
				var labelEnd = A3(
					$elm$core$String$slice,
					matchEndIndex,
					$elm$core$String$length(label),
					label);
				var labelCenter = A3($elm$core$String$slice, matchStartIndex, matchEndIndex, label);
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelStart)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-book')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelCenter)
							])),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-l-bold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelEnd)
							]))
					]);
			}
		}
	});
var $author$project$Pyxis$Tokens$TypographyColor$ContentOnActionSurface = 5;
var $author$project$Pyxis$Tokens$TypographyColor$tokenContentOnActionSurface = 5;
var $author$project$Pyxis$Components$Field$Autocomplete$renderOptionsItem = F3(
	function (msgMapper, _v0, option_) {
		var modelData = _v0;
		var value = option_.pR;
		var label = option_.eY;
		var id = option_.kv;
		var isSelectedOption = _Utils_eq(
			modelData.pR,
			$elm$core$Maybe$Just(value));
		var isActiveOption = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pR;
						},
						$elm$core$Basics$eq(value))),
				modelData.J));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-dropdown__item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-dropdown__item--active', isSelectedOption),
							_Utils_Tuple2('form-dropdown__item--hover', isActiveOption && (!isSelectedOption))
						])),
					$elm$html$Html$Attributes$id(id),
					$author$project$Pyxis$Commons$Attributes$role('option'),
					A2(
					$author$project$Pyxis$Commons$Events$preventDefaultOn,
					'mousedown',
					msgMapper(
						$author$project$Pyxis$Components$Field$Autocomplete$OnSelect(value))),
					$elm$html$Html$Events$onMouseEnter(
					msgMapper(
						$author$project$Pyxis$Components$Field$Autocomplete$OnHover(option_)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					A3(
						$author$project$Pyxis$Components$Field$Autocomplete$renderOptionText,
						modelData.F,
						isSelectedOption,
						$elm$core$String$trim(label))),
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					isSelectedOption,
					$author$project$Pyxis$Components$Icon$render(
						A2(
							$author$project$Pyxis$Components$Icon$withColor,
							$author$project$Pyxis$Tokens$TypographyColor$tokenContentOnActionSurface,
							A2(
								$author$project$Pyxis$Components$Icon$withSize,
								$author$project$Pyxis$Components$Icon$sizeL,
								$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$check)))))
				]));
	});
var $author$project$Pyxis$Components$Form$Dropdown$Suggestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pyxis$Components$Form$Dropdown$suggestion = $author$project$Pyxis$Components$Form$Dropdown$Suggestion;
var $author$project$Pyxis$Components$Field$Autocomplete$renderDropdown = F3(
	function (msgMapper, model, _v0) {
		var modelData = model;
		var configData = _v0;
		var wrap = function (html) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$author$project$Pyxis$Commons$Events$preventDefaultOn,
						'mousedown',
						msgMapper($author$project$Pyxis$Components$Field$Autocomplete$OnMouseDown))
					]),
				_List_fromArray(
					[html]));
		};
		var renderedOptions = A2(
			$elm$core$List$map,
			A2($author$project$Pyxis$Components$Field$Autocomplete$renderOptionsItem, msgMapper, model),
			$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model));
		var noAvailableOptions = (!$elm$core$List$length(
			$author$project$Pyxis$Components$Field$Autocomplete$getOptions(model))) && $krisajenkins$remotedata$RemoteData$isSuccess(modelData.ax);
		return ($elm$core$String$isEmpty(modelData.F) && $elm$core$List$isEmpty(renderedOptions)) ? A2(
			$elm$core$Maybe$map,
			wrap,
			A2(
				$elm$core$Maybe$map,
				A2(
					$author$project$Pyxis$Components$Form$Dropdown$render,
					configData.kv,
					$author$project$Pyxis$Components$Field$Autocomplete$mapDropdownSize(configData.aR)),
				A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Form$Dropdown$suggestion, configData.fu))) : (modelData.eG ? $elm$core$Maybe$Just(
			wrap(
				A3(
					$author$project$Pyxis$Components$Form$Dropdown$render,
					configData.kv,
					$author$project$Pyxis$Components$Field$Autocomplete$mapDropdownSize(configData.aR),
					function () {
						if (noAvailableOptions) {
							return $author$project$Pyxis$Components$Form$Dropdown$noResult(
								{U: configData.gH, eY: configData.hG});
						} else {
							var _v1 = configData.fu;
							if (!_v1.$) {
								var suggestionConfig = _v1.a;
								return ((!$krisajenkins$remotedata$RemoteData$isSuccess(modelData.ax)) && $elm$core$String$isEmpty(modelData.F)) ? $author$project$Pyxis$Components$Form$Dropdown$suggestion(suggestionConfig) : $author$project$Pyxis$Components$Form$Dropdown$options(renderedOptions);
							} else {
								return $author$project$Pyxis$Components$Form$Dropdown$options(renderedOptions);
							}
						}
					}()))) : $elm$core$Maybe$Nothing);
	});
var $author$project$Pyxis$Components$Field$Autocomplete$OnBlur = {$: 0};
var $author$project$Pyxis$Components$Field$Autocomplete$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Autocomplete$OnInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnInputMouseDown = {$: 8};
var $author$project$Pyxis$Commons$Attributes$ariaActiveDescendant = $elm$html$Html$Attributes$attribute('aria-activedescendant');
var $author$project$Pyxis$Commons$Attributes$ariaAutocomplete = $elm$html$Html$Attributes$attribute('aria-autocomplete');
var $author$project$Pyxis$Commons$Attributes$ariaOwns = $elm$html$Html$Attributes$attribute('aria-owns');
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Pyxis$Components$Field$Autocomplete$getFormFieldSizeClass = function (size) {
	if (!size) {
		return 'form-field__autocomplete--s';
	} else {
		return '';
	}
};
var $author$project$Pyxis$Components$Field$Autocomplete$OnKeyDown = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pyxis$Components$Field$Autocomplete$handleSelectKeydown = function (key) {
	return _Utils_Tuple2(
		$author$project$Pyxis$Components$Field$Autocomplete$OnKeyDown(key),
		A2(
			$elm$core$List$any,
			function (check) {
				return check(key);
			},
			_List_fromArray(
				[$author$project$Pyxis$Commons$Events$Keyboard$isArrowUp, $author$project$Pyxis$Commons$Events$Keyboard$isArrowDown, $author$project$Pyxis$Commons$Events$Keyboard$isEnter])));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Pyxis$Components$Field$Autocomplete$OnReset = {$: 4};
var $author$project$Pyxis$Components$IconSet$svgMagnifyingGlass = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M23 21.59l-6.83-6.83C17.31 13.31 18 11.49 18 9.5A8.51 8.51 0 0 0 9.5 1 8.51 8.51 0 0 0 1 9.5 8.51 8.51 0 0 0 9.5 18c1.99 0 3.81-.69 5.26-1.83L21.59 23c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41zM9.5 16C5.92 16 3 13.08 3 9.5S5.92 3 9.5 3 16 5.92 16 9.5 13.08 16 9.5 16z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$magnifyingGlass = {eY: 'magnifying-glass', a: $author$project$Pyxis$Components$IconSet$svgMagnifyingGlass};
var $author$project$Pyxis$Components$Field$Autocomplete$getFieldAddonIcon = function (_v0) {
	var modelData = _v0;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(modelData.pR) ? $author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$cross) : $author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$magnifyingGlass);
};
var $author$project$Pyxis$Components$Field$Autocomplete$iconSizeByAutocompleteSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Icon$sizeS;
	} else {
		return $author$project$Pyxis$Components$Icon$sizeM;
	}
};
var $author$project$Pyxis$Commons$Events$stopPropagationOn = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$stopPropagationOn,
			event,
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2(msg, true)));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$renderFieldIconAddon = F4(
	function (size, resetLabel, disabled, model) {
		var modelData = model;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field__addon', true),
							_Utils_Tuple2('form-field__addon--append', true),
							_Utils_Tuple2(
							'form-field__addon--loading',
							$krisajenkins$remotedata$RemoteData$isLoading(modelData.ax))
						])),
					A2($author$project$Pyxis$Commons$Events$stopPropagationOn, 'mousedown', $author$project$Pyxis$Components$Field$Autocomplete$OnMouseDown)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					$elm_community$maybe_extra$Maybe$Extra$isNothing(modelData.pR),
					$author$project$Pyxis$Components$Icon$render(
						A2(
							$author$project$Pyxis$Components$Icon$withSize,
							$author$project$Pyxis$Components$Field$Autocomplete$iconSizeByAutocompleteSize(size),
							$author$project$Pyxis$Components$Field$Autocomplete$getFieldAddonIcon(model)))),
					A2(
					$author$project$Pyxis$Commons$Render$renderIf,
					$elm_community$maybe_extra$Maybe$Extra$isJust(modelData.pR) && (!disabled),
					$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withIconOnly,
							$author$project$Pyxis$Components$IconSet$cross,
							A2(
								$author$project$Pyxis$Components$Button$withOnClick,
								$author$project$Pyxis$Components$Field$Autocomplete$OnReset,
								A2(
									$author$project$Pyxis$Components$Button$withSize,
									$author$project$Pyxis$Components$Button$sizeS,
									A2($author$project$Pyxis$Components$Button$withAriaLabel, resetLabel, $author$project$Pyxis$Components$Button$ghost))))))
				]));
	});
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Pyxis$Components$Field$Autocomplete$renderField = F4(
	function (error, msgMapper, model, _v0) {
		var modelData = model;
		var configData = _v0;
		var activeOptionId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pyxis$Components$Field$Autocomplete$getOptionData,
					function ($) {
						return $.kv;
					}),
				modelData.J));
		return A2(
			$elm$html$Html$map,
			msgMapper,
			A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field__wrapper'),
						$elm$html$Html$Events$onMouseDown($author$project$Pyxis$Components$Field$Autocomplete$OnInputMouseDown)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						A2(
							$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
							configData.ep,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('form-field__autocomplete', true),
											_Utils_Tuple2(
											'form-field__autocomplete--filled',
											$elm_community$maybe_extra$Maybe$Extra$isJust(modelData.pR)),
											_Utils_Tuple2(
											$author$project$Pyxis$Components$Field$Autocomplete$getFormFieldSizeClass(configData.aR),
											true)
										])),
									A2($author$project$Pyxis$Commons$Events$Keyboard$onPreventDefaultOn, 'keydown', $author$project$Pyxis$Components$Field$Autocomplete$handleSelectKeydown),
									$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$Autocomplete$OnFocus),
									$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$Autocomplete$OnBlur),
									$elm$html$Html$Events$onInput($author$project$Pyxis$Components$Field$Autocomplete$OnInput),
									$elm$html$Html$Attributes$id(configData.kv),
									A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fz),
									$elm$html$Html$Attributes$name(configData.kT),
									$author$project$Pyxis$Commons$Attributes$ariaAutocomplete('both'),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									modelData.a7,
									$author$project$Pyxis$Commons$Attributes$ariaExpanded(true)),
									$author$project$Pyxis$Commons$Attributes$role('combobox'),
									$author$project$Pyxis$Commons$Attributes$ariaOwns(configData.kv + '-dropdown-list'),
									$author$project$Pyxis$Commons$Attributes$ariaActiveDescendant(activeOptionId),
									$elm$html$Html$Attributes$autocomplete(false),
									$elm$html$Html$Attributes$disabled(configData.gt),
									$elm$html$Html$Attributes$required(configData.iG),
									$elm$html$Html$Attributes$placeholder(configData.im),
									$elm$html$Html$Attributes$type_('text'),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									!modelData.bV,
									$elm$html$Html$Attributes$value(modelData.F)),
									A2(
									$author$project$Pyxis$Commons$Attributes$renderIf,
									modelData.bV,
									$elm$html$Html$Attributes$value(modelData.F)),
									$author$project$Pyxis$Commons$Attributes$ariaInvalid(
									$author$project$Pyxis$Components$Field$Error$isVisible(error)),
									A2(
									$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
									A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kv),
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(
											$author$project$Pyxis$Components$Field$Hint$toId(configData.kv)),
										configData.gX))
								])),
						_List_Nil),
						A4($author$project$Pyxis$Components$Field$Autocomplete$renderFieldIconAddon, configData.aR, configData.iI, configData.gt, model)
					])));
	});
var $author$project$Pyxis$Components$Field$Label$withSize = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: a});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$render = F3(
	function (msgMapper, model, config_) {
		var modelData = model;
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$Autocomplete$generateErrorConfig, model, config_);
		var dropdown = A3($author$project$Pyxis$Components$Field$Autocomplete$renderDropdown, msgMapper, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$Autocomplete$mapLabelSize(configData.aR)),
			configData.eY);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fO,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withLabel,
					customizedLabel,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withClassList,
						configData.ga,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('form-field', true),
												_Utils_Tuple2(
												'form-field--with-opened-dropdown',
												modelData.a7 && ($elm_community$maybe_extra$Maybe$Extra$isJust(dropdown) && $krisajenkins$remotedata$RemoteData$isSuccess(modelData.ax))),
												_Utils_Tuple2(
												'form-field--error',
												$author$project$Pyxis$Components$Field$Error$isVisible(error)),
												_Utils_Tuple2('form-field--disabled', configData.gt)
											]))
									]),
								_List_fromArray(
									[
										A4($author$project$Pyxis$Components$Field$Autocomplete$renderField, error, msgMapper, model, config_),
										$author$project$Pyxis$Commons$Render$renderMaybe(dropdown)
									])))))));
	});
var $author$project$Pyxis$Components$Field$Autocomplete$S = 0;
var $author$project$Pyxis$Components$Field$Autocomplete$sizeS = 0;
var $author$project$Translations$validationErrorsRequired = F2(
	function (fieldName, _v0) {
		var lang = _v0;
		if (!lang) {
			return fieldName + ' is required';
		} else {
			return fieldName + ' es obligatorio';
		}
	});
var $author$project$Functions$whenElse = F3(
	function (ifTrue, ifFalse, condition) {
		return condition ? ifTrue : ifFalse;
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withLabel = F2(
	function (label, _v0) {
		var configData = _v0;
		return _Utils_update(
			configData,
			{
				eY: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder = F2(
	function (placeholder, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{im: placeholder});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Pyxis$Components$Field$Autocomplete$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cU: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				c5: isSubmitted,
				dW: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$reasonSelect = F3(
	function (i18n, _v0, onReasonSelected) {
		var reasonInput = _v0.aQ;
		var formStatus = _v0.aH;
		var errorMessage = A2(
			$author$project$Translations$validationErrorsRequired,
			$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
			i18n);
		var reasonToValidationResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$fromMaybe(errorMessage),
			$elm$core$Result$map(
				$elm$core$Basics$always(0)));
		var validation = function (reason) {
			return A3(
				$author$project$Functions$whenElse,
				reasonToValidationResult(reason),
				$elm$core$Result$Ok(0),
				true);
		};
		return A3(
			$author$project$Pyxis$Components$Field$Autocomplete$render,
			onReasonSelected,
			reasonInput,
			A2(
				$author$project$Pyxis$Components$Field$Autocomplete$withLabel,
				A2(
					$author$project$Pyxis$Components$Field$Label$withText,
					$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
					$author$project$Pyxis$Components$Field$Label$config),
				A3(
					$author$project$Pyxis$Components$Field$Autocomplete$withValidationOnSubmit,
					validation,
					$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted(formStatus),
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$withSize,
						$author$project$Pyxis$Components$Field$Autocomplete$sizeS,
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder,
							$author$project$Translations$policyInterruptionModalReasonPlaceholder(i18n),
							$author$project$Pyxis$Components$Field$Autocomplete$config('reason-kind'))))));
	});
var $author$project$Pyxis$Components$Field$Textarea$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Textarea$M = 1;
var $author$project$Pyxis$Components$Field$Textarea$config = function (name) {
	return {fO: $elm$core$Maybe$Nothing, f0: $elm$core$Maybe$Nothing, ga: _List_Nil, ep: _List_Nil, gt: false, cU: $elm$core$Maybe$Nothing, gW: $elm$core$Maybe$Nothing, gX: $elm$core$Maybe$Nothing, kv: 'id-' + name, c5: false, eY: $elm$core$Maybe$Nothing, kT: name, im: $elm$core$Maybe$Nothing, iG: false, aR: 1, fz: $elm$core$Maybe$Nothing, dW: $elm$core$Maybe$Nothing, jc: $elm$core$Basics$identity};
};
var $author$project$Common$ReasonDescriptionStatus$descriptionIsDisabled = A2(
	$primait$prima_elm_extra$PrimaFunction$flip,
	$elm$core$List$member,
	_List_fromArray(
		[2, 3]));
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelMandatory = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (mandatory)';
	} else {
		return 'Notas adicionales (obligatório)';
	}
};
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotRequired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note is not required for this reason';
	} else {
		return 'Por este motivo, no es necesaria una nota adicional';
	}
};
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotSet = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (select the reason first)';
	} else {
		return 'Nota adicional (seleccione primero el motivo)';
	}
};
var $author$project$Translations$policyInterruptionModalReasonDescriptionLabelOptional = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (optional)';
	} else {
		return 'Notas adicionales (opcional)';
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$descriptionTextareaLabel = F2(
	function (i18n, _v0) {
		var descriptionStatus = _v0.bJ;
		switch (descriptionStatus) {
			case 0:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelMandatory(i18n);
			case 1:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelOptional(i18n);
			case 2:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotRequired(i18n);
			default:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelNotSet(i18n);
		}
	});
var $author$project$Pyxis$Components$Field$Textarea$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.eB;
		var value = _v0.pR;
		var id = _v1.kv;
		var isSubmitted = _v1.c5;
		var validation = _v1.dW;
		var errorShowingStrategy = _v1.cU;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kv: id, c5: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$Textarea$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Textarea$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$Textarea$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Textarea$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$Textarea$getFormFieldTextareaSizeClass = function (size) {
	if (!size) {
		return 'form-field__textarea--s';
	} else {
		return '';
	}
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Pyxis$Components$Field$Textarea$toTextareaHeightCssVariable = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$fromInt,
	A2(
		$elm$core$Basics$composeR,
		A2($primait$prima_elm_extra$PrimaFunction$flip, $elm$core$Basics$append, 'px'),
		$elm$core$Basics$append('--textarea-min-height: ')));
var $author$project$Pyxis$Components$Field$Textarea$renderTextarea = F3(
	function (error, _v0, _v1) {
		var modelData = _v0;
		var configData = _v1;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'form-field--error',
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							_Utils_Tuple2('form-field--disabled', configData.gt)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$textarea,
					A2(
						$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
						configData.ep,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(configData.kv),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('form-field__textarea', true),
										_Utils_Tuple2(
										$author$project$Pyxis$Components$Field$Textarea$getFormFieldTextareaSizeClass(configData.aR),
										true)
									])),
								$elm$html$Html$Attributes$disabled(configData.gt),
								$elm$html$Html$Attributes$required(configData.iG),
								$elm$html$Html$Attributes$name(configData.kT),
								$elm$html$Html$Attributes$value(modelData.pR),
								A2(
								$author$project$Pyxis$Commons$Attributes$maybe,
								$elm$html$Html$Attributes$attribute('autocomplete'),
								configData.f0),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fz),
								A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$placeholder, configData.im),
								$author$project$Pyxis$Commons$Attributes$ariaInvalid(
								$author$project$Pyxis$Components$Field$Error$isVisible(error)),
								A2(
								$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
								A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kv),
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$always(
										$author$project$Pyxis$Components$Field$Hint$toId(configData.kv)),
									configData.gX)),
								A2(
								$author$project$Pyxis$Commons$Attributes$maybe,
								$elm$html$Html$Attributes$attribute('style'),
								A2($elm$core$Maybe$map, $author$project$Pyxis$Components$Field$Textarea$toTextareaHeightCssVariable, configData.gW)),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeR, configData.jc, $author$project$Pyxis$Components$Field$Textarea$OnInput)),
								$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$Textarea$OnFocus),
								$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$Textarea$OnBlur)
							])),
					_List_Nil)
				]));
	});
var $author$project$Pyxis$Components$Field$Textarea$render = F3(
	function (tagger, model, config_) {
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$Textarea$generateErrorConfig, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$Textarea$mapLabelSize(configData.aR)),
			configData.eY);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fO,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withClassList,
					configData.ga,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withLabel,
						customizedLabel,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A2(
								$elm$html$Html$map,
								tagger,
								A3($author$project$Pyxis$Components$Field$Textarea$renderTextarea, error, model, config_)))))));
	});
var $author$project$Pyxis$Components$Field$Textarea$sizeM = 1;
var $author$project$Pyxis$Components$Field$Textarea$withDisabled = F2(
	function (isDisabled, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gt: isDisabled});
	});
var $author$project$Pyxis$Components$Field$Textarea$withLabel = F2(
	function (label, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eY: $elm$core$Maybe$Just(label)
			});
	});
var $author$project$Pyxis$Components$Field$Textarea$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Pyxis$Components$Field$Textarea$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cU: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				c5: isSubmitted,
				dW: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$renderDescriptionInput = F2(
	function (i18n, model) {
		var onDescriptionChanges = model.k3;
		var descriptionInput = model.aE;
		var descriptionStatus = model.bJ;
		var formStatus = model.aH;
		var errorMessage = A2(
			$author$project$Translations$validationErrorsRequired,
			$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
			i18n);
		var validation = function (string) {
			return A3(
				$author$project$Functions$whenElse,
				$elm$core$Result$Ok(0),
				$elm$core$Result$Err(errorMessage),
				A2(
					$author$project$Common$ReasonDescriptionStatus$isDescriptionValid,
					$elm$core$Maybe$Just(string),
					descriptionStatus));
		};
		var descriptionInputDisabled = $author$project$Common$ReasonDescriptionStatus$descriptionIsDisabled(descriptionStatus);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Textarea$render,
					onDescriptionChanges,
					descriptionInput,
					A2(
						$author$project$Pyxis$Components$Field$Textarea$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							A2($author$project$Page$PolicyDetails$AmendInterruptionModal$descriptionTextareaLabel, i18n, model),
							$author$project$Pyxis$Components$Field$Label$config),
						A3(
							$author$project$Pyxis$Components$Field$Textarea$withValidationOnSubmit,
							validation,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted(formStatus),
							A2(
								$author$project$Pyxis$Components$Field$Textarea$withDisabled,
								descriptionInputDisabled,
								A2(
									$author$project$Pyxis$Components$Field$Textarea$withSize,
									$author$project$Pyxis$Components$Field$Textarea$sizeM,
									$author$project$Pyxis$Components$Field$Textarea$config('reason-description'))))))
				]));
	});
var $author$project$Pyxis$Components$Field$DateInput$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$DateInput$M = 1;
var $author$project$Pyxis$Components$Field$DateInput$config = function (name) {
	return {fO: $elm$core$Maybe$Nothing, ga: _List_Nil, ep: _List_Nil, gt: false, cU: $elm$core$Maybe$Nothing, gX: $elm$core$Maybe$Nothing, kv: 'id-' + name, c5: false, eY: $elm$core$Maybe$Nothing, hq: $elm$core$Maybe$Nothing, hv: $elm$core$Maybe$Nothing, kT: name, iG: false, aR: 1, iS: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, dW: $elm$core$Maybe$Nothing, jc: $elm$core$Basics$identity};
};
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$Common$Locale$beforeEndOfDayAtCustomerDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Locale$midnightAtCustomerDate,
	A3($justinmimbs$time_extra$Time$Extra$add, 13, -1, $author$project$Common$Locale$customerTimeZone));
var $author$project$Common$Locale$formatPosixTime = F2(
	function (tz, time) {
		var minute = $elm$core$String$fromInt(
			A2($elm$time$Time$toMinute, tz, time));
		var hour = $elm$core$String$fromInt(
			A2($elm$time$Time$toHour, tz, time));
		return A3($elm$core$String$padLeft, 2, '0', hour) + (':' + A3($elm$core$String$padLeft, 2, '0', minute));
	});
var $author$project$Translations$policyInterruptionModalActivityLabel = F2(
	function (data, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'Policy will be active until ' + (data.mp + (' at ' + data.mq));
		} else {
			return 'Póliza en vigor hasta el ' + (data.mp + (' a las ' + data.mq));
		}
	});
var $author$project$Translations$policyInterruptionModalNoActivityLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy will never be active';
	} else {
		return 'Póliza no entrará en vigor';
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$policyActivityHint = F2(
	function (i18n, _v0) {
		var interruptionDateInput = _v0.aL;
		var policyStartDate = _v0.lu;
		var isBeforePolicyStartDate = function (posixDate) {
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(posixDate),
				$elm$time$Time$posixToMillis(policyStartDate)) < 0;
		};
		var activeUntilTime = $author$project$Common$Locale$formatPosixTime($author$project$Common$Locale$customerTimeZone);
		var activeUntilDate = $author$project$Common$Locale$formatPosixDate($author$project$Common$Locale$customerTimeZone);
		var renderActivityMessage = function (date) {
			return isBeforePolicyStartDate(date) ? $author$project$Translations$policyInterruptionModalNoActivityLabel(i18n) : A2(
				$author$project$Translations$policyInterruptionModalActivityLabel,
				{
					mp: activeUntilDate(date),
					mq: activeUntilTime(date)
				},
				i18n);
		};
		var activeUntil = A2(
			$elm$core$Maybe$map,
			$author$project$Common$Locale$beforeEndOfDayAtCustomerDate,
			$elm$core$Result$toMaybe(
				$justinmimbs$date$Date$fromIsoString(
					$author$project$Pyxis$Components$Field$DateInput$getValue(interruptionDateInput))));
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, renderActivityMessage, activeUntil));
	});
var $author$project$Translations$policyInterruptionModalCancellationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cancellation date';
	} else {
		return 'Fecha de cancelación';
	}
};
var $author$project$Translations$policyInterruptionModalInvalidCancellationDateError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Invalid cancellation date';
	} else {
		return 'Fecha de cancelación no válida';
	}
};
var $author$project$Pyxis$Components$Field$DateInput$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.eB;
		var value = _v0.pR;
		var id = _v1.kv;
		var isSubmitted = _v1.c5;
		var validation = _v1.dW;
		var errorShowingStrategy = _v1.cU;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kv: id, c5: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$DateInput$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$IconSet$svgCalendar = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4C2.34 3 1 4.34 1 6v14c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3zM4 5h1v1c0 .55.45 1 1 1s1-.45 1-1V5h10v1c0 .55.45 1 1 1s1-.45 1-1V5h1c.55 0 1 .45 1 1v2H3V6c0-.55.45-1 1-1zm16 16H4c-.55 0-1-.45-1-1V10h18v10c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$calendar = {eY: 'calendar', a: $author$project$Pyxis$Components$IconSet$svgCalendar};
var $author$project$Pyxis$Components$Field$DateInput$iconSizeByInputSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Icon$sizeS;
	} else {
		return $author$project$Pyxis$Components$Icon$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$DateInput$renderAddon = function (_v0) {
	var size = _v0.aR;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-field__addon')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Field$DateInput$iconSizeByInputSize(size),
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$calendar)))
			]));
};
var $author$project$Pyxis$Components$Field$DateInput$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$DateInput$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$DateInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$DateInput$getFormFieldDateSizeClass = function (size) {
	if (!size) {
		return 'form-field__date--s';
	} else {
		return '';
	}
};
var $elm_community$result_extra$Result$Extra$isOk = function (x) {
	if (!x.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Pyxis$Components$Field$DateInput$renderInput = F3(
	function (error, _v0, _v1) {
		var modelData = _v0;
		var configData = _v1;
		return A2(
			$elm$html$Html$input,
			A2(
				$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
				configData.ep,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(configData.kv),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-field__date', true),
								_Utils_Tuple2(
								'form-field__date--filled',
								$elm_community$result_extra$Result$Extra$isOk(
									$justinmimbs$date$Date$fromIsoString(modelData.pR))),
								_Utils_Tuple2(
								$author$project$Pyxis$Components$Field$DateInput$getFormFieldDateSizeClass(configData.aR),
								true)
							])),
						$elm$html$Html$Attributes$disabled(configData.gt),
						$elm$html$Html$Attributes$value(modelData.pR),
						$elm$html$Html$Attributes$type_('date'),
						$elm$html$Html$Attributes$required(configData.iG),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fz),
						$elm$html$Html$Attributes$name(configData.kT),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$min, configData.hv),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$max, configData.hq),
						A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$step, configData.iS),
						$author$project$Pyxis$Commons$Attributes$ariaInvalid(
						$author$project$Pyxis$Components$Field$Error$isVisible(error)),
						A2(
						$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
						A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kv),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always(
								$author$project$Pyxis$Components$Field$Hint$toId(configData.kv)),
							configData.gX)),
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeR, configData.jc, $author$project$Pyxis$Components$Field$DateInput$OnInput)),
						$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$DateInput$OnFocus),
						$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$DateInput$OnBlur)
					])),
			_List_Nil);
	});
var $author$project$Pyxis$Components$Field$DateInput$renderField = F3(
	function (error, model, configuration) {
		var disabled = configuration.gt;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'form-field--error',
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							_Utils_Tuple2('form-field--disabled', disabled),
							_Utils_Tuple2('form-field--with-prepend-icon', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field__wrapper')
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Field$DateInput$renderAddon(configuration),
							A3($author$project$Pyxis$Components$Field$DateInput$renderInput, error, model, configuration)
						]))
				]));
	});
var $author$project$Pyxis$Components$Field$DateInput$render = F3(
	function (tagger, model, config_) {
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$DateInput$generateErrorConfig, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$DateInput$mapLabelSize(configData.aR)),
			configData.eY);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fO,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withLabel,
					customizedLabel,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withClassList,
						configData.ga,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A2(
								$elm$html$Html$map,
								tagger,
								A3($author$project$Pyxis$Components$Field$DateInput$renderField, error, model, config_)))))));
	});
var $author$project$Pyxis$Components$Field$DateInput$S = 0;
var $author$project$Pyxis$Components$Field$DateInput$sizeS = 0;
var $author$project$Pyxis$Components$Field$Hint$config = function (message) {
	return {kv: $elm$core$Maybe$Nothing, nZ: message};
};
var $author$project$Pyxis$Components$Field$DateInput$withHint = F2(
	function (hintMessage, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gX: $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Field$Hint$withFieldId,
						configuration.kv,
						$author$project$Pyxis$Components$Field$Hint$config(hintMessage)))
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withLabel = F2(
	function (a, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eY: $elm$core$Maybe$Just(a)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withMax = F2(
	function (max, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hq: $elm$core$Maybe$Just(max)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withMin = F2(
	function (min, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hv: $elm$core$Maybe$Just(min)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Pyxis$Components$Field$DateInput$withStep = F2(
	function (step, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				iS: $elm$core$Maybe$Just(step)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withTestId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				fz: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Pyxis$Components$Field$DateInput$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cU: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				c5: isSubmitted,
				dW: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$viewInterruptionDateInput = F2(
	function (i18n, model) {
		var onInterruptionDateChanges = model.k5;
		var interruptionDateInput = model.aL;
		var earliestSelectableDate = model.a2;
		var formStatus = model.aH;
		var latestSelectableDate = model.a9;
		var errorMessage = $author$project$Translations$policyInterruptionModalInvalidCancellationDateError(i18n);
		var validation = A2(
			$elm$core$Basics$composeR,
			$justinmimbs$date$Date$fromIsoString,
			$elm$core$Result$andThen(
				A2(
					$elm$core$Basics$composeR,
					A2($justinmimbs$date$Date$isBetween, earliestSelectableDate, latestSelectableDate),
					A2(
						$author$project$Functions$whenElse,
						$elm$core$Result$Ok(0),
						$elm$core$Result$Err(errorMessage)))));
		return A3(
			$author$project$Pyxis$Components$Field$DateInput$render,
			onInterruptionDateChanges,
			interruptionDateInput,
			A2(
				$author$project$Pyxis$Components$Field$DateInput$withTestId,
				'interruption-date',
				A2(
					$author$project$Pyxis$Components$Field$DateInput$withHint,
					A2($author$project$Page$PolicyDetails$AmendInterruptionModal$policyActivityHint, i18n, model),
					A2(
						$author$project$Pyxis$Components$Field$DateInput$withStep,
						'1',
						A2(
							$author$project$Pyxis$Components$Field$DateInput$withMax,
							$justinmimbs$date$Date$toIsoString(latestSelectableDate),
							A2(
								$author$project$Pyxis$Components$Field$DateInput$withMin,
								$justinmimbs$date$Date$toIsoString(earliestSelectableDate),
								A3(
									$author$project$Pyxis$Components$Field$DateInput$withValidationOnSubmit,
									validation,
									$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsSubmitted(formStatus),
									A2(
										$author$project$Pyxis$Components$Field$DateInput$withLabel,
										A2(
											$author$project$Pyxis$Components$Field$Label$withText,
											$author$project$Translations$policyInterruptionModalCancellationDateLabel(i18n),
											$author$project$Pyxis$Components$Field$Label$config),
										A2(
											$author$project$Pyxis$Components$Field$DateInput$withSize,
											$author$project$Pyxis$Components$Field$DateInput$sizeS,
											$author$project$Pyxis$Components$Field$DateInput$config('interruption-date'))))))))));
	});
var $author$project$Pyxis$Components$Form$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				kv: $elm$core$Maybe$Just(id)
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$content = F2(
	function (i18n, model) {
		var onReasonChanged = model.lg;
		var expectedRefund = model.nc;
		var onSubmit = model.lj;
		var descriptionInput = model.aE;
		var descriptionStatus = model.bJ;
		var onSubmitError = model.lk;
		var initialValues = model.g0;
		var maybeReasonValue = $author$project$Page$PolicyDetails$AmendInterruptionModal$pickReasonValue(model);
		var maybeInterruptionAt = $author$project$Page$PolicyDetails$AmendInterruptionModal$pickDateValue(model);
		var maybeDescriptionValue = A3(
			$primait$prima_elm_extra$PrimaFunction$ifThenMap,
			A2($primait$prima_elm_extra$PrimaFunction$flip, $author$project$Common$ReasonDescriptionStatus$isDescriptionValid, descriptionStatus),
			$elm$core$Basics$identity,
			$elm$core$Maybe$Just(
				$author$project$Pyxis$Components$Field$Textarea$getValue(descriptionInput)));
		var hasInterruptionAtChanged = $elm$core$Maybe$Just(
			!_Utils_eq(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.g1;
					},
					initialValues),
				maybeInterruptionAt));
		var pyxisOnSubmit = A2(
			$elm$core$Maybe$withDefault,
			onSubmitError,
			A5($elm$core$Maybe$map4, onSubmit, maybeDescriptionValue, maybeInterruptionAt, maybeReasonValue, hasInterruptionAtChanged));
		return _List_fromArray(
			[
				$author$project$Pyxis$Components$Form$render(
				A2(
					$author$project$Pyxis$Components$Form$withId,
					$author$project$Page$PolicyDetails$AmendInterruptionModal$formId,
					A2(
						$author$project$Pyxis$Components$Form$withOnSubmit,
						pyxisOnSubmit,
						A2(
							$author$project$Pyxis$Components$Form$withFieldsets,
							_List_fromArray(
								[
									A2(
									$author$project$Pyxis$Components$Form$Fieldset$withContent,
									_List_fromArray(
										[
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A2($author$project$Page$PolicyDetails$AmendInterruptionModal$viewInterruptionDateInput, i18n, model)
												])),
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A3($author$project$Page$PolicyDetails$AmendInterruptionModal$reasonSelect, i18n, model, onReasonChanged)
												])),
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A2($author$project$Page$PolicyDetails$AmendInterruptionModal$renderDescriptionInput, i18n, model)
												])),
											$author$project$Pyxis$Components$Grid$oneColRowFullWidth(
											_List_fromArray(
												[
													A2($author$project$Page$PolicyDetails$AmendInterruptionModal$expectedRefundMessage, i18n, expectedRefund)
												]))
										]),
									$author$project$Pyxis$Components$Form$Fieldset$config)
								]),
							$author$project$Pyxis$Components$Form$config))))
			]);
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$formIsLoading = function (status) {
	if (status === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Translations$policyInterruptionModalCancelButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$policyInterruptionModalProceedButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm';
	} else {
		return 'Confirmar';
	}
};
var $author$project$Pyxis$Components$Button$withTargetFormId = F2(
	function (formId, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gJ: $elm$core$Maybe$Just(formId)
			});
	});
var $author$project$Page$PolicyDetails$AmendInterruptionModal$footer = F2(
	function (i18n, _v0) {
		var onDismiss = _v0.hZ;
		var formStatus = _v0.aH;
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						onDismiss,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$policyInterruptionModalCancelButton(i18n),
							$author$project$Pyxis$Components$Button$secondary))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withLoading,
						$author$project$Page$PolicyDetails$AmendInterruptionModal$formIsLoading(formStatus),
						A2(
							$author$project$Pyxis$Components$Button$withTargetFormId,
							$author$project$Page$PolicyDetails$AmendInterruptionModal$formId,
							A2(
								$author$project$Pyxis$Components$Button$withType,
								$author$project$Pyxis$Components$Button$submit,
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$policyInterruptionModalProceedButton(i18n),
									$author$project$Pyxis$Components$Button$primary)))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$policyInterruptionModalAmendTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Edit cancellation date';
	} else {
		return 'Modifica la fecha de cancelación';
	}
};
var $author$project$Page$PolicyDetails$AmendInterruptionModal$render = F2(
	function (i18n, model) {
		var onDismiss = model.hZ;
		var visibility = model.cx;
		var headerConfig = A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			$author$project$Translations$policyInterruptionModalAmendTitle(i18n),
			$author$project$Pyxis$Components$Modal$Header$config);
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			visibility,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2($author$project$Page$PolicyDetails$AmendInterruptionModal$footer, i18n, model),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A2($author$project$Page$PolicyDetails$AmendInterruptionModal$content, i18n, model),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						headerConfig,
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							onDismiss,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$ChangeEmailInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$Validate = {$: 3};
var $author$project$Pyxis$Components$Field$Input$Email = 0;
var $author$project$Pyxis$Components$Field$Input$Config = $elm$core$Basics$identity;
var $author$project$Pyxis$Components$Field$Input$M = 1;
var $author$project$Pyxis$Components$Field$Input$config = F2(
	function (inputType, name) {
		return {fO: $elm$core$Maybe$Nothing, aW: $elm$core$Maybe$Nothing, aX: $elm$core$Maybe$Nothing, f0: $elm$core$Maybe$Nothing, ga: _List_Nil, ep: _List_Nil, gt: false, cU: $elm$core$Maybe$Nothing, gX: $elm$core$Maybe$Nothing, kv: 'id-' + name, c5: false, eY: $elm$core$Maybe$Nothing, hq: $elm$core$Maybe$Nothing, hv: $elm$core$Maybe$Nothing, kT: name, im: $elm$core$Maybe$Nothing, iG: false, aR: 1, iS: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, bq: inputType, dW: $elm$core$Maybe$Nothing, jc: $elm$core$Basics$identity};
	});
var $author$project$Pyxis$Components$Field$Input$email = $author$project$Pyxis$Components$Field$Input$config(0);
var $author$project$Page$PolicyDetails$ChangeEmailModal$formId = 'change-form-email';
var $author$project$Pyxis$Components$Field$Input$generateErrorConfig = F2(
	function (_v0, _v1) {
		var fieldStatus = _v0.eB;
		var value = _v0.pR;
		var id = _v1.kv;
		var isSubmitted = _v1.c5;
		var validation = _v1.dW;
		var errorShowingStrategy = _v1.cU;
		var validationRes = A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$Pyxis$Commons$Validation$generateValidationResult, fieldStatus, isSubmitted, value, validation),
				errorShowingStrategy));
		return A3(
			$elm$core$Maybe$map2,
			A2(
				$author$project$Pyxis$Components$Field$Error$buildErrorConfig,
				fieldStatus,
				{kv: id, c5: isSubmitted}),
			validationRes,
			errorShowingStrategy);
	});
var $author$project$Pyxis$Components$Field$Input$mapLabelSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Field$Label$sizeS;
	} else {
		return $author$project$Pyxis$Components$Field$Label$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Input$addonTypeToString = function (addonType) {
	switch (addonType.$) {
		case 0:
			return 'icon';
		case 1:
			return 'text';
		default:
			return 'button';
	}
};
var $author$project$Pyxis$Components$Field$Input$placementToString = function (placement) {
	if (!placement) {
		return 'prepend';
	} else {
		return 'append';
	}
};
var $author$project$Pyxis$Components$Field$Input$addonToAttribute = function (_v0) {
	var type_ = _v0.bq;
	var placement = _v0.aa;
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[
					'form-field--with',
					$author$project$Pyxis$Components$Field$Input$placementToString(placement),
					$author$project$Pyxis$Components$Field$Input$addonTypeToString(type_)
				])));
};
var $author$project$Pyxis$Components$Field$Input$hasAddon = function (_v0) {
	var addonPrepend = _v0.aX;
	var addonAppend = _v0.aW;
	var _v1 = _Utils_Tuple2(addonPrepend, addonAppend);
	if ((_v1.a.$ === 1) && (_v1.b.$ === 1)) {
		var _v2 = _v1.a;
		var _v3 = _v1.b;
		return false;
	} else {
		return true;
	}
};
var $author$project$Pyxis$Components$Field$Input$iconSizeByInputSize = function (size) {
	if (!size) {
		return $author$project$Pyxis$Components$Icon$sizeS;
	} else {
		return $author$project$Pyxis$Components$Icon$sizeM;
	}
};
var $author$project$Pyxis$Components$Field$Input$renderAddonByType = F2(
	function (size, _v0) {
		var type_ = _v0.bq;
		var placement = _v0.aa;
		switch (type_.$) {
			case 0:
				var icon = type_.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field__addon', true),
									_Utils_Tuple2(
									'form-field__addon--' + $author$project$Pyxis$Components$Field$Input$placementToString(placement),
									true)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Icon$render(
							A2(
								$author$project$Pyxis$Components$Icon$withSize,
								$author$project$Pyxis$Components$Field$Input$iconSizeByInputSize(size),
								$author$project$Pyxis$Components$Icon$config(icon)))
						]));
			case 1:
				var str = type_.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field__addon', true),
									_Utils_Tuple2(
									'form-field__addon--' + $author$project$Pyxis$Components$Field$Input$placementToString(placement),
									true)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(str)
						]));
			default:
				var buttonConfig = type_.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field__addon', true),
									_Utils_Tuple2(
									'form-field__addon--' + $author$project$Pyxis$Components$Field$Input$placementToString(placement),
									true)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Pyxis$Components$Button$render(buttonConfig)
						]));
		}
	});
var $author$project$Pyxis$Components$Field$Input$OnBlur = {$: 2};
var $author$project$Pyxis$Components$Field$Input$OnFocus = {$: 1};
var $author$project$Pyxis$Components$Field$Input$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$Input$OnKeyDown = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pyxis$Components$Field$Input$getFormFieldTextSizeClass = function (size) {
	if (!size) {
		return 'form-field__text--s';
	} else {
		return '';
	}
};
var $author$project$Pyxis$Commons$Events$Keyboard$on = F2(
	function (event, tagger) {
		return A2(
			$elm$html$Html$Events$on,
			event,
			$author$project$Pyxis$Commons$Events$Keyboard$decoder(tagger));
	});
var $author$project$Pyxis$Components$Field$Input$typeToAttribute = function (a) {
	switch (a) {
		case 0:
			return $elm$html$Html$Attributes$type_('email');
		case 1:
			return $elm$html$Html$Attributes$type_('number');
		case 2:
			return $elm$html$Html$Attributes$type_('password');
		case 3:
			return $elm$html$Html$Attributes$type_('text');
		default:
			return $elm$html$Html$Attributes$type_('search');
	}
};
var $author$project$Pyxis$Components$Field$Input$renderInput = F4(
	function (tagger, error, _v0, _v1) {
		var modelData = _v0;
		var configData = _v1;
		return A2(
			$elm$html$Html$map,
			tagger,
			A2(
				$elm$html$Html$input,
				A2(
					$author$project$Pyxis$Commons$Attributes$appendDataAttrList,
					configData.ep,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(configData.kv),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('form-field__text', true),
									_Utils_Tuple2(
									$author$project$Pyxis$Components$Field$Input$getFormFieldTextSizeClass(configData.aR),
									true)
								])),
							$elm$html$Html$Attributes$disabled(configData.gt),
							$elm$html$Html$Attributes$value(modelData.pR),
							$author$project$Pyxis$Components$Field$Input$typeToAttribute(configData.bq),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Commons$Attributes$testId, configData.fz),
							$elm$html$Html$Attributes$name(configData.kT),
							$elm$html$Html$Attributes$required(configData.iG),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$placeholder, configData.im),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$min, configData.hv),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$max, configData.hq),
							A2($author$project$Pyxis$Commons$Attributes$maybe, $elm$html$Html$Attributes$step, configData.iS),
							A2(
							$author$project$Pyxis$Commons$Attributes$maybe,
							$elm$html$Html$Attributes$attribute('autocomplete'),
							configData.f0),
							$author$project$Pyxis$Commons$Attributes$ariaInvalid(
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							A2(
							$author$project$Pyxis$Commons$Attributes$ariaDescribedByErrorOrHint,
							A2($author$project$Pyxis$Components$Field$Error$idFromFieldIdIfVisible, error, configData.kv),
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$always(
									$author$project$Pyxis$Components$Field$Hint$toId(configData.kv)),
								configData.gX)),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeR, configData.jc, $author$project$Pyxis$Components$Field$Input$OnInput)),
							$elm$html$Html$Events$onFocus($author$project$Pyxis$Components$Field$Input$OnFocus),
							$elm$html$Html$Events$onBlur($author$project$Pyxis$Components$Field$Input$OnBlur),
							A2($author$project$Pyxis$Commons$Events$Keyboard$on, 'keydown', $author$project$Pyxis$Components$Field$Input$OnKeyDown)
						])),
				_List_Nil));
	});
var $author$project$Pyxis$Components$Field$Input$renderAddon = F4(
	function (tagger, error, model, configuration) {
		var addonPrepend = configuration.aX;
		var addonAppend = configuration.aW;
		var size = configuration.aR;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field__wrapper')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$Field$Input$renderAddonByType(size),
						addonPrepend)),
					A4($author$project$Pyxis$Components$Field$Input$renderInput, tagger, error, model, configuration),
					$author$project$Pyxis$Commons$Render$renderMaybe(
					A2(
						$elm$core$Maybe$map,
						$author$project$Pyxis$Components$Field$Input$renderAddonByType(size),
						addonAppend))
				]));
	});
var $author$project$Pyxis$Components$Field$Input$renderField = F4(
	function (tagger, error, model, configuration) {
		var disabled = configuration.gt;
		var addonPrepend = configuration.aX;
		var addonAppend = configuration.aW;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'form-field--error',
							$author$project$Pyxis$Components$Field$Error$isVisible(error)),
							_Utils_Tuple2('form-field--disabled', disabled)
						])),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Field$Input$addonToAttribute, addonPrepend),
					A2($author$project$Pyxis$Commons$Attributes$maybe, $author$project$Pyxis$Components$Field$Input$addonToAttribute, addonAppend)
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Field$Input$hasAddon(configuration) ? A4($author$project$Pyxis$Components$Field$Input$renderAddon, tagger, error, model, configuration) : A4($author$project$Pyxis$Components$Field$Input$renderInput, tagger, error, model, configuration)
				]));
	});
var $author$project$Pyxis$Components$Field$Input$render = F3(
	function (tagger, model, config_) {
		var configData = config_;
		var error = A2($author$project$Pyxis$Components$Field$Input$generateErrorConfig, model, config_);
		var customizedLabel = A2(
			$elm$core$Maybe$map,
			$author$project$Pyxis$Components$Field$Label$withSize(
				$author$project$Pyxis$Components$Field$Input$mapLabelSize(configData.aR)),
			configData.eY);
		return A2(
			$author$project$Pyxis$Components$Form$FormItem$render,
			error,
			A2(
				$author$project$Pyxis$Components$Form$FormItem$withAdditionalContent,
				configData.fO,
				A2(
					$author$project$Pyxis$Components$Form$FormItem$withLabel,
					customizedLabel,
					A2(
						$author$project$Pyxis$Components$Form$FormItem$withClassList,
						configData.ga,
						A2(
							$author$project$Pyxis$Components$Form$FormItem$config,
							configData,
							A4($author$project$Pyxis$Components$Field$Input$renderField, tagger, error, model, config_))))));
	});
var $author$project$Pyxis$Components$Grid$SpanSize$Span5 = 4;
var $author$project$Pyxis$Components$Grid$SpanSize$span5 = 4;
var $author$project$Pyxis$Components$Grid$Col$span5 = function (config) {
	return _Utils_update(
		config,
		{dD: $author$project$Pyxis$Components$Grid$SpanSize$span5});
};
var $author$project$Translations$changeEmailModalInputError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid email address.';
	} else {
		return 'Por favor, introduce una dirección de correo electrónico válida.';
	}
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$validateInputFn = F2(
	function (i18n, userInput) {
		return $author$project$Page$PolicyDetails$ChangeEmailModal$isInputValid(userInput) ? $elm$core$Result$Ok(userInput) : $elm$core$Result$Err(
			$author$project$Translations$changeEmailModalInputError(i18n));
	});
var $author$project$Pyxis$Components$Form$withNoValidate = F2(
	function (noValidate, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				e3: $elm$core$Maybe$Just(noValidate)
			});
	});
var $author$project$Pyxis$Components$Field$Input$withValidationOnSubmit = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cU: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onSubmit),
				c5: isSubmitted,
				dW: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$changeEmailFormConfiguration = F2(
	function (i18n, _v0) {
		var emailInput = _v0.a3;
		var tagger = _v0.i$;
		var isSubmitted = _v0.c5;
		return A2(
			$author$project$Pyxis$Components$Form$withOnSubmit,
			tagger($author$project$Page$PolicyDetails$ChangeEmailModal$Validate),
			A2(
				$author$project$Pyxis$Components$Form$withNoValidate,
				true,
				A2(
					$author$project$Pyxis$Components$Form$withId,
					$author$project$Page$PolicyDetails$ChangeEmailModal$formId,
					A2(
						$author$project$Pyxis$Components$Form$withFieldsets,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Form$Fieldset$withContent,
								_List_fromArray(
									[
										A2(
										$author$project$Pyxis$Components$Grid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Pyxis$Components$Grid$col,
												_List_fromArray(
													[$author$project$Pyxis$Components$Grid$Col$span5]),
												_List_fromArray(
													[
														A3(
														$author$project$Pyxis$Components$Field$Input$render,
														A2($elm$core$Basics$composeR, $author$project$Page$PolicyDetails$ChangeEmailModal$ChangeEmailInputMsg, tagger),
														emailInput,
														A3(
															$author$project$Pyxis$Components$Field$Input$withValidationOnSubmit,
															$author$project$Page$PolicyDetails$ChangeEmailModal$validateInputFn(i18n),
															isSubmitted,
															$author$project$Pyxis$Components$Field$Input$email('change-email')))
													]))
											]))
									]),
								$author$project$Pyxis$Components$Form$Fieldset$config)
							]),
						$author$project$Pyxis$Components$Form$config))));
	});
var $author$project$Page$PolicyDetails$ChangeEmailModal$content = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$PolicyDetails$ChangeEmailModal$changeEmailFormConfiguration(i18n),
		$author$project$Pyxis$Components$Form$render);
};
var $author$project$Translations$changeEmailModalBackButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$changeEmailModalConfirmButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm';
	} else {
		return 'Confirmar';
	}
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$footer = F2(
	function (i18n, tagger) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						tagger($author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$changeEmailModalBackButtonLabel(i18n),
								$author$project$Pyxis$Components$Button$secondary)))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withTargetFormId,
						$author$project$Page$PolicyDetails$ChangeEmailModal$formId,
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$changeEmailModalConfirmButtonLabel(i18n),
								A2($author$project$Pyxis$Components$Button$withType, $author$project$Pyxis$Components$Button$submit, $author$project$Pyxis$Components$Button$primary)))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$changeEmailModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Change email address';
	} else {
		return 'Cambia el dirección de email';
	}
};
var $author$project$Pyxis$Components$IconSet$svgMail = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 3H3C1.34 3 0 4.34 0 6v12c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3zM3 5h18c.55 0 1 .45 1 1v.07l-10 5.77L2 6.07V6c0-.55.45-1 1-1zm18 14H3c-.55 0-1-.45-1-1V8.38l9.5 5.48c.15.09.33.14.5.14s.35-.04.5-.13L22 8.38V18c0 .55-.45 1-1 1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$mail = {eY: 'mail', a: $author$project$Pyxis$Components$IconSet$svgMail};
var $author$project$Page$PolicyDetails$ChangeEmailModal$modalIcon = A2(
	$author$project$Pyxis$Components$Icon$withColor,
	$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$mail));
var $author$project$Page$PolicyDetails$ChangeEmailModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$changeEmailModalTitle(i18n),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withIcon,
			$author$project$Page$PolicyDetails$ChangeEmailModal$modalIcon,
			A2($author$project$Pyxis$Components$Modal$Header$withIcon, $author$project$Page$PolicyDetails$ChangeEmailModal$modalIcon, $author$project$Pyxis$Components$Modal$Header$config)));
};
var $author$project$Page$PolicyDetails$ChangeEmailModal$render = F2(
	function (i18n, model) {
		var tagger = model.i$;
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			$author$project$Page$PolicyDetails$ChangeEmailModal$modalVisibility(model),
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2($author$project$Page$PolicyDetails$ChangeEmailModal$footer, i18n, tagger),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					_List_fromArray(
						[
							A2($author$project$Page$PolicyDetails$ChangeEmailModal$content, i18n, model)
						]),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$ChangeEmailModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							tagger($author$project$Page$PolicyDetails$ChangeEmailModal$Dismiss),
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Common$Render$maybe2 = F3(
	function (fn, maybeValue1, maybeValue2) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Common$Render$empty,
			A3($elm$core$Maybe$map2, fn, maybeValue1, maybeValue2));
	});
var $author$project$Page$PolicyDetails$Msg$InterruptionDismissed = {$: 18};
var $author$project$Common$ReasonDescriptionStatus$couldDescriptionBeSet = A2(
	$primait$prima_elm_extra$PrimaFunction$flip,
	$elm$core$List$member,
	_List_fromArray(
		[1, 0]));
var $author$project$Page$PolicyDetails$InterruptionModal$Data$pickDescriptionStatus = function (data) {
	switch (data.$) {
		case 0:
			var descriptionStatus = data.a.bJ;
			return descriptionStatus;
		case 1:
			var descriptionStatus = data.a.bJ;
			return descriptionStatus;
		default:
			var descriptionStatus = data.a.bJ;
			return descriptionStatus;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$couldDescriptionBeSet = A2($elm$core$Basics$composeR, $author$project$Page$PolicyDetails$InterruptionModal$Data$pickDescriptionStatus, $author$project$Common$ReasonDescriptionStatus$couldDescriptionBeSet);
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonDescriptionChanged = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$descriptionTextareaLabel = F2(
	function (i18n, data) {
		var _v0 = $author$project$Page$PolicyDetails$InterruptionModal$Data$pickDescriptionStatus(data);
		switch (_v0) {
			case 0:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelMandatory(i18n);
			case 1:
				return $author$project$Translations$policyInterruptionModalReasonDescriptionLabelOptional(i18n);
			default:
				return '';
		}
	});
var $author$project$Pyxis$Components$Field$Textarea$S = 0;
var $author$project$Pyxis$Components$Field$Textarea$sizeS = 0;
var $author$project$Page$PolicyDetails$InterruptionModal$View$descriptionInput = F3(
	function (i18n, textAreaModel, kindData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__policy-interruption__reason-description')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Textarea$render,
					$author$project$Page$PolicyDetails$Msg$InterruptionReasonDescriptionChanged,
					textAreaModel,
					A2(
						$author$project$Pyxis$Components$Field$Textarea$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							A2($author$project$Page$PolicyDetails$InterruptionModal$View$descriptionTextareaLabel, i18n, kindData),
							$author$project$Pyxis$Components$Field$Label$config),
						A2(
							$author$project$Pyxis$Components$Field$Textarea$withSize,
							$author$project$Pyxis$Components$Field$Textarea$sizeS,
							$author$project$Pyxis$Components$Field$Textarea$config('reason-description'))))
				]));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$expectedRefundMessage = F2(
	function (i18n, remoteData) {
		switch (remoteData.$) {
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				return $author$project$Pyxis$Components$Loaders$Loader$render(
					A2(
						$author$project$Pyxis$Components$Loaders$Loader$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('margin-t-l es-fe-bo--full-width', true)
							]),
						$author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM));
			case 2:
				return $author$project$Pyxis$Components$Message$render(
					A2(
						$author$project$Pyxis$Components$Message$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
							]),
						A2(
							$author$project$Pyxis$Components$Message$withContent,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Translations$policyInterruptionModalExpectedRefundNotAvailableMessage(i18n))
								]),
							$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
			default:
				if (!remoteData.a.$) {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedNoRefundAmountMessage,
									{
										lD: A2($author$project$Common$Price$amountString, i18n, price),
										lE: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$error($author$project$Pyxis$Components$Message$tintBackground))));
				} else {
					var price = remoteData.a.a;
					return $author$project$Pyxis$Components$Message$render(
						A2(
							$author$project$Pyxis$Components$Message$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('policy-details__policy-interruption__refund-amount-message', true)
								]),
							A2(
								$author$project$Pyxis$Components$Message$withContent,
								A3(
									$author$project$Translations$policyInterruptionModalExpectedRefundAmountMessage,
									{
										lD: A2($author$project$Common$Price$amountString, i18n, price),
										lE: $author$project$Common$Price$pickCurrencySign(price)
									},
									_List_Nil,
									i18n),
								$author$project$Pyxis$Components$Message$success($author$project$Pyxis$Components$Message$tintBackground))));
				}
		}
	});
var $author$project$Page$PolicyDetails$Msg$InterruptionReasonSelected = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$reasonSelect = F2(
	function (i18n, autoCompleteModel) {
		return A3(
			$author$project$Pyxis$Components$Field$Autocomplete$render,
			$author$project$Page$PolicyDetails$Msg$InterruptionReasonSelected,
			autoCompleteModel,
			A2(
				$author$project$Pyxis$Components$Field$Autocomplete$withLabel,
				A2(
					$author$project$Pyxis$Components$Field$Label$withText,
					$author$project$Translations$policyInterruptionModalReasonLabel(i18n),
					$author$project$Pyxis$Components$Field$Label$config),
				A2(
					$author$project$Pyxis$Components$Field$Autocomplete$withSize,
					$author$project$Pyxis$Components$Field$Autocomplete$sizeS,
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder,
						$author$project$Translations$policyInterruptionModalReasonPlaceholder(i18n),
						$author$project$Pyxis$Components$Field$Autocomplete$config('reason-kind')))));
	});
var $author$project$Page$PolicyDetails$Msg$InterruptionDateChanged = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pyxis$Components$Field$Error$onInput = 0;
var $author$project$Pyxis$Components$Field$DateInput$withValidationOnInput = F3(
	function (validation, isSubmitted, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				cU: $elm$core$Maybe$Just($author$project$Pyxis$Components$Field$Error$onInput),
				c5: isSubmitted,
				dW: $elm$core$Maybe$Just(
					A2($elm$core$Basics$composeR, validation, $author$project$Pyxis$Commons$ValidationResult$fromResult))
			});
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$renderDateInput = F3(
	function (i18n, dateInputModel, _v0) {
		var minDate = _v0.hw;
		var maxDate = _v0.hr;
		var validation = function (date) {
			return A2(
				$elm$core$Result$andThen,
				function (value) {
					return A3($justinmimbs$date$Date$isBetween, minDate, maxDate, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
						$author$project$Translations$policyInterruptionModalInvalidCancellationDateError(i18n));
				},
				$justinmimbs$date$Date$fromIsoString(date));
		};
		return A3(
			$author$project$Pyxis$Components$Field$DateInput$render,
			$author$project$Page$PolicyDetails$Msg$InterruptionDateChanged,
			dateInputModel,
			A2(
				$author$project$Pyxis$Components$Field$DateInput$withTestId,
				'interruption-date',
				A2(
					$author$project$Pyxis$Components$Field$DateInput$withStep,
					'1',
					A2(
						$author$project$Pyxis$Components$Field$DateInput$withMax,
						$justinmimbs$date$Date$toIsoString(maxDate),
						A2(
							$author$project$Pyxis$Components$Field$DateInput$withMin,
							$justinmimbs$date$Date$toIsoString(minDate),
							A3(
								$author$project$Pyxis$Components$Field$DateInput$withValidationOnInput,
								validation,
								false,
								A2(
									$author$project$Pyxis$Components$Field$DateInput$withLabel,
									A2(
										$author$project$Pyxis$Components$Field$Label$withText,
										$author$project$Translations$policyInterruptionModalCancellationDateLabel(i18n),
										$author$project$Pyxis$Components$Field$Label$config),
									A2(
										$author$project$Pyxis$Components$Field$DateInput$withSize,
										$author$project$Pyxis$Components$Field$DateInput$sizeS,
										$author$project$Pyxis$Components$Field$DateInput$config('interruption-date')))))))));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$viewInterruptionDateInput = F4(
	function (i18n, policy, kind, dateInputModel) {
		var dates = function () {
			switch (kind.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						{
							hr: $author$project$Common$Policy$pickEndDate(policy),
							hw: $author$project$Common$Locale$posixToCustomerDate(
								$author$project$Common$Policy$earliestCustomerTerminationDate(policy))
						});
				default:
					return $elm$core$Maybe$Just(
						{
							hr: $author$project$Common$Policy$pickEndDate(policy),
							hw: $author$project$Common$Locale$posixToCustomerDate(
								$author$project$Common$Policy$earliestPrimaTerminationDate(policy))
						});
			}
		}();
		return A2(
			$author$project$Common$Render$maybe,
			A2($author$project$Page$PolicyDetails$InterruptionModal$View$renderDateInput, i18n, dateInputModel),
			dates);
	});
var $author$project$Common$Policy$isBeforeStartDate = F2(
	function (policy, time) {
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(time),
			$elm$time$Time$posixToMillis(
				$author$project$Common$Policy$startDateTime(policy))) < 0;
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$pickInterruptionAt = function (data) {
	switch (data.$) {
		case 0:
			var requestAt = data.a.pm;
			return requestAt;
		case 1:
			var interruptionAt = data.a.a6;
			return interruptionAt;
		default:
			var interruptionAt = data.a.a6;
			return interruptionAt;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$viewPolicyActivityRow = F3(
	function (i18n, policy, kindData) {
		var interruptionAt = $author$project$Page$PolicyDetails$InterruptionModal$Data$pickInterruptionAt(kindData);
		var activeUntil = A4($justinmimbs$time_extra$Time$Extra$add, 13, -1, $author$project$Common$Locale$customerTimeZone, interruptionAt);
		var activeUntilDate = A2($author$project$Common$Locale$formatPosixDate, $author$project$Common$Locale$customerTimeZone, activeUntil);
		var activeUntilTime = A2($author$project$Common$Locale$formatPosixTime, $author$project$Common$Locale$customerTimeZone, activeUntil);
		var activityMessage = A2($author$project$Common$Policy$isBeforeStartDate, policy, activeUntil) ? _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Translations$policyInterruptionModalNoActivityLabel(i18n))
			]) : _List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$author$project$Translations$policyInterruptionModalActivityLabel,
					{mp: activeUntilDate, mq: activeUntilTime},
					i18n))
			]);
		if (!kindData.$) {
			return $author$project$Pyxis$Commons$Render$empty;
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('policy-details__interruptions_modal__activity-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('policy-details__interruptions_modal__text')
							]),
						activityMessage)
					]));
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$content = F7(
	function (i18n, policy, kindData, expectedRefundRemote, dateInputModel, autocompleteModel, textAreaModel) {
		return _List_fromArray(
			[
				A4($author$project$Page$PolicyDetails$InterruptionModal$View$viewInterruptionDateInput, i18n, policy, kindData, dateInputModel),
				A3($author$project$Page$PolicyDetails$InterruptionModal$View$viewPolicyActivityRow, i18n, policy, kindData),
				A2($author$project$Page$PolicyDetails$InterruptionModal$View$reasonSelect, i18n, autocompleteModel),
				A2(
				$author$project$Common$Render$ifCondition,
				A3($author$project$Page$PolicyDetails$InterruptionModal$View$descriptionInput, i18n, textAreaModel, kindData),
				$author$project$Page$PolicyDetails$InterruptionModal$Data$couldDescriptionBeSet(kindData)),
				A2($author$project$Page$PolicyDetails$InterruptionModal$View$expectedRefundMessage, i18n, expectedRefundRemote)
			]);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Data$canInterrupt = F2(
	function (data, canDoAction) {
		switch (data.$) {
			case 0:
				var maybeReason = data.a.kQ;
				var description = data.a.m1;
				var descriptionStatus = data.a.bJ;
				return canDoAction && ($elm_community$maybe_extra$Maybe$Extra$isJust(maybeReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, description, descriptionStatus));
			case 1:
				var maybeReason = data.a.kQ;
				var description = data.a.m1;
				var descriptionStatus = data.a.bJ;
				return canDoAction && ($elm_community$maybe_extra$Maybe$Extra$isJust(maybeReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, description, descriptionStatus));
			default:
				var maybeReason = data.a.kQ;
				var description = data.a.m1;
				var descriptionStatus = data.a.bJ;
				return canDoAction && ($elm_community$maybe_extra$Maybe$Extra$isJust(maybeReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, description, descriptionStatus));
		}
	});
var $author$project$Common$Policy$pickCustomerTerminateAction = function (_v0) {
	var policy = _v0;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (action) {
				if (action.$ === 2) {
					var params = action.a;
					return $elm$core$Maybe$Just(params);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			policy.aY));
};
var $author$project$Common$Policy$canBeTerminatedByCustomer = function (policy) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		$author$project$Common$Policy$pickCustomerTerminateAction(policy));
};
var $author$project$Common$Policy$pickPrimaTerminateAction = function (_v0) {
	var policy = _v0;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (action) {
				if (action.$ === 3) {
					var params = action.a;
					return $elm$core$Maybe$Just(params);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			policy.aY));
};
var $author$project$Common$Policy$canBeTerminatedByPrima = function (policy) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		$author$project$Common$Policy$pickPrimaTerminateAction(policy));
};
var $author$project$Common$Policy$pickWithdrawAction = function (_v0) {
	var policy = _v0;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (action) {
				if (action.$ === 1) {
					var params = action.a;
					return $elm$core$Maybe$Just(params);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			policy.aY));
};
var $author$project$Common$Policy$canBeWithdrawn = function (policy) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		$author$project$Common$Policy$pickWithdrawAction(policy));
};
var $author$project$Page$PolicyDetails$InterruptionModal$Data$canInterruptMapper = function (data) {
	switch (data.$) {
		case 0:
			return $author$project$Common$Policy$canBeWithdrawn;
		case 1:
			return $author$project$Common$Policy$canBeTerminatedByCustomer;
		default:
			return $author$project$Common$Policy$canBeTerminatedByPrima;
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$isInterruptionButtonDisabled = F2(
	function (policy, kindData) {
		return !A2(
			$author$project$Page$PolicyDetails$InterruptionModal$Data$canInterrupt,
			kindData,
			A2($author$project$Page$PolicyDetails$InterruptionModal$Data$canInterruptMapper, kindData, policy));
	});
var $author$project$Page$PolicyDetails$Msg$CustomerTerminationConfirmationButtonPressed = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$PolicyDetails$Msg$PrimaTerminationConfirmationButtonPressed = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$PolicyDetails$Msg$WithdrawalConfirmationButtonPressed = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$onSubmit = F2(
	function (id, inputData) {
		switch (inputData.$) {
			case 0:
				var maybeReason = inputData.a.kQ;
				var requestAt = inputData.a.pm;
				var description = inputData.a.m1;
				return $author$project$Page$PolicyDetails$Msg$WithdrawalConfirmationButtonPressed(
					{
						m1: description,
						kv: id,
						iA: A2($elm$core$Maybe$withDefault, 16, maybeReason),
						i: requestAt
					});
			case 1:
				var maybeReason = inputData.a.kQ;
				var requestAt = inputData.a.pm;
				var interruptionAt = inputData.a.a6;
				var description = inputData.a.m1;
				return $author$project$Page$PolicyDetails$Msg$CustomerTerminationConfirmationButtonPressed(
					{
						m1: description,
						kv: id,
						a6: interruptionAt,
						iA: A2($elm$core$Maybe$withDefault, 19, maybeReason),
						i: requestAt
					});
			default:
				var maybeReason = inputData.a.kQ;
				var requestAt = inputData.a.pm;
				var interruptionAt = inputData.a.a6;
				var description = inputData.a.m1;
				return $author$project$Page$PolicyDetails$Msg$PrimaTerminationConfirmationButtonPressed(
					{
						m1: description,
						kv: id,
						a6: interruptionAt,
						iA: A2($elm$core$Maybe$withDefault, 4, maybeReason),
						i: requestAt
					});
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$footer = F3(
	function (i18n, policy, kindData) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						$author$project$Page$PolicyDetails$Msg$InterruptionDismissed,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$policyInterruptionModalCancelButton(i18n),
							$author$project$Pyxis$Components$Button$secondary))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDisabled,
						A2($author$project$Page$PolicyDetails$InterruptionModal$View$isInterruptionButtonDisabled, policy, kindData),
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							A2(
								$author$project$Page$PolicyDetails$InterruptionModal$View$onSubmit,
								$author$project$Common$Policy$pickId(policy),
								kindData),
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$policyInterruptionModalProceedButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$policyInterruptionModalCancellationByCompanyTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy cancellation by Prima';
	} else {
		return 'Prima cancela póliza';
	}
};
var $author$project$Translations$policyInterruptionModalCancellationByCustomerTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy cancellation by customer';
	} else {
		return 'Cliente cancela póliza';
	}
};
var $author$project$Translations$policyInterruptionModalWithdrawTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm Policy Withdraw';
	} else {
		return 'Confirmar Desistimiento';
	}
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$headerTitle = F2(
	function (i18n, kindData) {
		switch (kindData.$) {
			case 0:
				return $author$project$Translations$policyInterruptionModalWithdrawTitle(i18n);
			case 1:
				return $author$project$Translations$policyInterruptionModalCancellationByCustomerTitle(i18n);
			default:
				return $author$project$Translations$policyInterruptionModalCancellationByCompanyTitle(i18n);
		}
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$header = F2(
	function (i18n, kindData) {
		return A2(
			$author$project$Pyxis$Components$Modal$Header$withTitle,
			A2($author$project$Page$PolicyDetails$InterruptionModal$View$headerTitle, i18n, kindData),
			$author$project$Pyxis$Components$Modal$Header$config);
	});
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickDateInput = function (_v0) {
	var model = _v0;
	return model.aL;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickDescriptionInput = function (_v0) {
	var model = _v0;
	return model.aE;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickExpectedRefund = function (_v0) {
	var model = _v0;
	return model.nc;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickReasonInput = function (_v0) {
	var model = _v0;
	return model.aQ;
};
var $author$project$Page$PolicyDetails$InterruptionModal$Model$pickVisibilityState = function (_v0) {
	var model = _v0;
	return model.cx;
};
var $author$project$Page$PolicyDetails$InterruptionModal$View$renderModal = F4(
	function (i18n, model, policy, kindData) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickVisibilityState(model),
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A3($author$project$Page$PolicyDetails$InterruptionModal$View$footer, i18n, policy, kindData),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A7(
						$author$project$Page$PolicyDetails$InterruptionModal$View$content,
						i18n,
						policy,
						kindData,
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickExpectedRefund(model),
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickDateInput(model),
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickReasonInput(model),
						$author$project$Page$PolicyDetails$InterruptionModal$Model$pickDescriptionInput(model)),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						A2($author$project$Page$PolicyDetails$InterruptionModal$View$header, i18n, kindData),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							$author$project$Page$PolicyDetails$Msg$InterruptionDismissed,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$InterruptionModal$View$render = F2(
	function (i18n, modalState) {
		return A3(
			$author$project$Common$Render$maybe2,
			A2($author$project$Page$PolicyDetails$InterruptionModal$View$renderModal, i18n, modalState),
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickPolicy(modalState),
			$author$project$Page$PolicyDetails$InterruptionModal$Model$pickKindData(modalState));
	});
var $author$project$Translations$refundIssuingModalContent = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'By confirming, you cannot undo this action.';
	} else {
		return 'Al confirmar, no podrás deshacer esta acción.';
	}
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$content = function (i18n) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('details__refund-modal')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$refundIssuingModalContent(i18n))
				]))
		]);
};
var $author$project$Translations$refundIssuingModalNoButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'No';
	} else {
		return 'No';
	}
};
var $author$project$Translations$refundIssuingModalYesButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Yes';
	} else {
		return 'Sí';
	}
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$footer = F4(
	function (i18n, dismissMsg, confirmMsg, refund) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						dismissMsg,
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$refundIssuingModalNoButton(i18n),
								$author$project$Pyxis$Components$Button$secondary)))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						confirmMsg(refund),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$refundIssuingModalYesButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$refundIssuingModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Do you want to proceed with the refund?';
	} else {
		return '¿Quieres proceder con el reembolso?';
	}
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$refundIssuingModalTitle(i18n),
		$author$project$Pyxis$Components$Modal$Header$config);
};
var $author$project$Page$PolicyDetails$RefundIssuingModal$renderModal = F5(
	function (i18n, dismissMsg, confirmMsg, visibility, refund) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			visibility,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A4($author$project$Page$PolicyDetails$RefundIssuingModal$footer, i18n, dismissMsg, confirmMsg, refund),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					$author$project$Page$PolicyDetails$RefundIssuingModal$content(i18n),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$RefundIssuingModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							dismissMsg,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$RefundIssuingModal$render = F4(
	function (i18n, dismissMsg, confirmMsg, _v0) {
		var visibility = _v0.cx;
		var refund = _v0.pk;
		return A2(
			$author$project$Common$Render$maybe,
			A4($author$project$Page$PolicyDetails$RefundIssuingModal$renderModal, i18n, dismissMsg, confirmMsg, visibility),
			refund);
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$pickPolicy = function (_v0) {
	var model = _v0;
	return model.l;
};
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationDismissed = {$: 32};
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonDescriptionChanged = function (a) {
	return {$: 34, a: a};
};
var $author$project$Translations$renewalCancellationModalReasonDescriptionLabelMandatory = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (mandatory)';
	} else {
		return 'Notas adicionales (obligatório)';
	}
};
var $author$project$Translations$renewalCancellationModalReasonDescriptionLabelOptional = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Additional note (optional)';
	} else {
		return 'Notas adicionales (opcional)';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionTextareaLabel = F2(
	function (i18n, status) {
		switch (status) {
			case 0:
				return $author$project$Translations$renewalCancellationModalReasonDescriptionLabelMandatory(i18n);
			case 1:
				return $author$project$Translations$renewalCancellationModalReasonDescriptionLabelOptional(i18n);
			default:
				return '';
		}
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionInput = F2(
	function (i18n, _v0) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__renewal-cancellation__additional-notes')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Textarea$render,
					$author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonDescriptionChanged,
					model.aE,
					A2(
						$author$project$Pyxis$Components$Field$Textarea$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							A2($author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionTextareaLabel, i18n, model.bJ),
							$author$project$Pyxis$Components$Field$Label$config),
						A2(
							$author$project$Pyxis$Components$Field$Textarea$withSize,
							$author$project$Pyxis$Components$Field$Textarea$sizeS,
							$author$project$Pyxis$Components$Field$Textarea$config('additional-notes'))))
				]));
	});
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonSelected = function (a) {
	return {$: 33, a: a};
};
var $author$project$Translations$renewalCancellationModalReasonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Reason';
	} else {
		return 'Motivo';
	}
};
var $author$project$Translations$renewalCancellationModalReasonPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Select the reason';
	} else {
		return 'Seleccionar el motivo';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$reasonSelect = F2(
	function (i18n, _v0) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__renewal-cancellation__reason')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Pyxis$Components$Field$Autocomplete$render,
					$author$project$Page$PolicyDetails$Msg$RenewalCancellationReasonSelected,
					model.aQ,
					A2(
						$author$project$Pyxis$Components$Field$Autocomplete$withLabel,
						A2(
							$author$project$Pyxis$Components$Field$Label$withText,
							$author$project$Translations$renewalCancellationModalReasonLabel(i18n),
							$author$project$Pyxis$Components$Field$Label$config),
						A2(
							$author$project$Pyxis$Components$Field$Autocomplete$withSize,
							$author$project$Pyxis$Components$Field$Autocomplete$sizeS,
							A2(
								$author$project$Pyxis$Components$Field$Autocomplete$withPlaceholder,
								$author$project$Translations$renewalCancellationModalReasonPlaceholder(i18n),
								$author$project$Pyxis$Components$Field$Autocomplete$config('reason-kind')))))
				]));
	});
var $author$project$Translations$renewalCancellationModalDescriptionLabel = F2(
	function (expiryDate, _v0) {
		var lang = _v0;
		if (!lang) {
			return 'The cancellation date corresponds to the original expiry date of the policy: ' + (expiryDate + '.');
		} else {
			return 'La fecha de cancelación corresponde a la fecha de vencimiento original de la póliza: ' + (expiryDate + '.');
		}
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$content = F3(
	function (i18n, model, policy) {
		var isDescriptionEditable = function (_v0) {
			var descriptionStatus = _v0.bJ;
			return $author$project$Common$ReasonDescriptionStatus$couldDescriptionBeSet(descriptionStatus);
		};
		var descriptionLabel = A2(
			$author$project$Translations$renewalCancellationModalDescriptionLabel,
			$author$project$Common$Locale$formatDate(
				$author$project$Common$Policy$pickEndDate(policy)),
			i18n);
		return _List_fromArray(
			[
				$elm$html$Html$text(descriptionLabel),
				A2($author$project$Page$PolicyDetails$RenewalCancellationModal$reasonSelect, i18n, model),
				A2(
				$author$project$Common$Render$ifCondition,
				A2($author$project$Page$PolicyDetails$RenewalCancellationModal$descriptionInput, i18n, model),
				isDescriptionEditable(model))
			]);
	});
var $author$project$Common$Policy$pickCancelRenewalAction = function (_v0) {
	var policy = _v0;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filterMap,
			function (action) {
				if (action.$ === 4) {
					var params = action.a;
					return $elm$core$Maybe$Just(params);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			policy.aY));
};
var $author$project$Common$Policy$canRenewalBeCancelled = function (policy) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		$author$project$Common$Policy$pickCancelRenewalAction(policy));
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$isDataInputValid = function (_v0) {
	var selectedReason = _v0.fo;
	var additionalNotes = _v0.mt;
	var descriptionStatus = _v0.bJ;
	return $elm_community$maybe_extra$Maybe$Extra$isJust(selectedReason) && A2($author$project$Common$ReasonDescriptionStatus$isDescriptionValid, additionalNotes, descriptionStatus);
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$isConfirmButtonDisabled = F2(
	function (model, policy) {
		return !($author$project$Common$Policy$canRenewalBeCancelled(policy) && $author$project$Page$PolicyDetails$RenewalCancellationModal$isDataInputValid(model));
	});
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationConfirmationButtonPressed = function (a) {
	return {$: 35, a: a};
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$onSubmit = F2(
	function (policy, _v0) {
		var selectedReason = _v0.fo;
		var additionalNotes = _v0.mt;
		return $author$project$Page$PolicyDetails$Msg$RenewalCancellationConfirmationButtonPressed(
			{
				mt: additionalNotes,
				kv: $author$project$Common$Policy$pickId(policy),
				iA: A2($elm$core$Maybe$withDefault, 19, selectedReason),
				i: $author$project$Common$Locale$midnightAtCustomerDate(
					$author$project$Common$Policy$pickEndDate(policy))
			});
	});
var $author$project$Translations$renewalCancellationModalBackButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$renewalCancellationModalConfirmButton = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Confirm';
	} else {
		return 'Confirmar';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$footer = F3(
	function (i18n, model, policy) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						$author$project$Page$PolicyDetails$Msg$RenewalCancellationDismissed,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$renewalCancellationModalBackButton(i18n),
							$author$project$Pyxis$Components$Button$secondary))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withDisabled,
						A2($author$project$Page$PolicyDetails$RenewalCancellationModal$isConfirmButtonDisabled, model, policy),
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							A2($author$project$Page$PolicyDetails$RenewalCancellationModal$onSubmit, policy, model),
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$renewalCancellationModalConfirmButton(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Translations$renewalCancellationModalHeaderTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Renewal’s cancellation';
	} else {
		return 'Cancelación de la renovación';
	}
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$renewalCancellationModalHeaderTitle(i18n),
		$author$project$Pyxis$Components$Modal$Header$config);
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$pickVisibilityState = function (_v0) {
	var model = _v0;
	return model.cx;
};
var $author$project$Page$PolicyDetails$RenewalCancellationModal$renderModal = F3(
	function (i18n, model, policy) {
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			$author$project$Page$PolicyDetails$RenewalCancellationModal$pickVisibilityState(model),
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A3($author$project$Page$PolicyDetails$RenewalCancellationModal$footer, i18n, model, policy),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A3($author$project$Page$PolicyDetails$RenewalCancellationModal$content, i18n, model, policy),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$RenewalCancellationModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							$author$project$Page$PolicyDetails$Msg$RenewalCancellationDismissed,
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$RenewalCancellationModal$render = F2(
	function (i18n, modalState) {
		return A2(
			$author$project$Common$Render$maybe,
			A2($author$project$Page$PolicyDetails$RenewalCancellationModal$renderModal, i18n, modalState),
			$author$project$Page$PolicyDetails$RenewalCancellationModal$pickPolicy(modalState));
	});
var $author$project$Page$PolicyDetails$SendEmailModal$ModalDismissed = {$: 1};
var $author$project$Page$PolicyDetails$SendEmailModal$CheckboxGroupUpdate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$PolicyDetails$SendEmailModal$PolicyContract = 0;
var $author$project$Translations$sendPolicyEmailModalPolicyContractEmailLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy documents';
	} else {
		return 'Documentos de la póliza';
	}
};
var $author$project$Translations$sendPolicyEmailModalSelectionErrorMessage = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You need to select an email';
	} else {
		return 'Debes seleccionar un email';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$validation = F2(
	function (i18n, selected) {
		if (!selected.b) {
			return $elm$core$Result$Err(
				$author$project$Translations$sendPolicyEmailModalSelectionErrorMessage(i18n));
		} else {
			return $elm$core$Result$Ok(selected);
		}
	});
var $author$project$Page$PolicyDetails$SendEmailModal$emailCheckBoxGroup = F3(
	function (i18n, tagger, _v0) {
		var isSubmitted = _v0.c5;
		var checkboxModel = _v0.a$;
		return A3(
			$author$project$Pyxis$Components$Field$CheckboxGroup$render,
			A2($elm$core$Basics$composeL, tagger, $author$project$Page$PolicyDetails$SendEmailModal$CheckboxGroupUpdate),
			checkboxModel,
			A2(
				$author$project$Pyxis$Components$Field$CheckboxGroup$withOptionsCard,
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Field$CheckboxGroup$optionCardSizeM(
						{
							mu: $elm$core$Maybe$Nothing,
							pK: $elm$core$Maybe$Nothing,
							i4: $elm$core$Maybe$Just(
								$author$project$Translations$sendPolicyEmailModalPolicyContractEmailLabel(i18n)),
							pR: 0
						})
					]),
				A3(
					$author$project$Pyxis$Components$Field$CheckboxGroup$withValidationOnSubmit,
					$author$project$Page$PolicyDetails$SendEmailModal$validation(i18n),
					isSubmitted,
					$author$project$Pyxis$Components$Field$CheckboxGroup$config('policy-email-selection'))));
	});
var $author$project$Page$PolicyDetails$SendEmailModal$emailRecipientText = function (email) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-l-bold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(email)
			]));
};
var $author$project$Translations$sendPolicyEmailModalEmailRecipientLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Emails will be sent to';
	} else {
		return 'El email se enviará a';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$emailRecipientBlock = F2(
	function (i18n, emailRecipient) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('send-policy-email-modal__receiver-block')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Translations$sendPolicyEmailModalEmailRecipientLabel(i18n)),
					A2($author$project$Common$Render$maybe, $author$project$Page$PolicyDetails$SendEmailModal$emailRecipientText, emailRecipient)
				]));
	});
var $author$project$Translations$sendPolicyEmailModalCheckboxSelectionTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Which email do you want to send to the customer?';
	} else {
		return '¿Qué email quieres enviarle al cliente?';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$content = F3(
	function (i18n, tagger, model) {
		var emailRecipient = model.gy;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('send-policy-email-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('send-policy-email-modal__which-email-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Translations$sendPolicyEmailModalCheckboxSelectionTitle(i18n))
							])),
						A3($author$project$Page$PolicyDetails$SendEmailModal$emailCheckBoxGroup, i18n, tagger, model),
						A2($author$project$Page$PolicyDetails$SendEmailModal$emailRecipientBlock, i18n, emailRecipient)
					]))
			]);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$Validate = {$: 2};
var $author$project$Translations$sendPolicyEmailModalDismissButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Back';
	} else {
		return 'Atrás';
	}
};
var $author$project$Translations$sendPolicyEmailModalSubmitButtonText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Send email';
	} else {
		return 'Enviar email';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$footer = F2(
	function (i18n, tagger) {
		return A2(
			$author$project$Pyxis$Components$Modal$Footer$withButtons,
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						tagger($author$project$Page$PolicyDetails$SendEmailModal$ModalDismissed),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$sendPolicyEmailModalDismissButtonText(i18n),
								$author$project$Pyxis$Components$Button$secondary)))),
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withOnClick,
						tagger($author$project$Page$PolicyDetails$SendEmailModal$Validate),
						A2(
							$author$project$Pyxis$Components$Button$withWidth,
							$author$project$Pyxis$Components$Button$inherit,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$sendPolicyEmailModalSubmitButtonText(i18n),
								$author$project$Pyxis$Components$Button$primary))))
				]),
			$author$project$Pyxis$Components$Modal$Footer$config);
	});
var $author$project$Page$PolicyDetails$SendEmailModal$modalIcon = A2(
	$author$project$Pyxis$Components$Icon$withColor,
	$author$project$Pyxis$Tokens$TypographyColor$tokenBrand,
	$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$paperPlane));
var $author$project$Translations$sendPolicyEmailModalTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Set up email sending';
	} else {
		return 'Configurar el envío de emails';
	}
};
var $author$project$Page$PolicyDetails$SendEmailModal$header = function (i18n) {
	return A2(
		$author$project$Pyxis$Components$Modal$Header$withTitle,
		$author$project$Translations$sendPolicyEmailModalTitle(i18n),
		A2(
			$author$project$Pyxis$Components$Modal$Header$withIcon,
			$author$project$Page$PolicyDetails$SendEmailModal$modalIcon,
			A2($author$project$Pyxis$Components$Modal$Header$withIcon, $author$project$Page$PolicyDetails$SendEmailModal$modalIcon, $author$project$Pyxis$Components$Modal$Header$config)));
};
var $author$project$Page$PolicyDetails$SendEmailModal$render = F2(
	function (i18n, model) {
		var visibility = model.cx;
		var tagger = model.i$;
		return A2(
			$author$project$Pyxis$Components$Modal$render,
			visibility,
			A2(
				$author$project$Pyxis$Components$Modal$withFooter,
				A2($author$project$Page$PolicyDetails$SendEmailModal$footer, i18n, tagger),
				A2(
					$author$project$Pyxis$Components$Modal$withContent,
					A3($author$project$Page$PolicyDetails$SendEmailModal$content, i18n, tagger, model),
					A2(
						$author$project$Pyxis$Components$Modal$withHeader,
						$author$project$Page$PolicyDetails$SendEmailModal$header(i18n),
						A3(
							$author$project$Pyxis$Components$Modal$withCloseMsg,
							tagger($author$project$Page$PolicyDetails$SendEmailModal$ModalDismissed),
							'',
							A2($author$project$Pyxis$Components$Modal$withSize, $author$project$Pyxis$Components$Modal$sizeS, $author$project$Pyxis$Components$Modal$config))))));
	});
var $author$project$Page$PolicyDetails$Msg$CreateRefundButtonPressed = function (a) {
	return {$: 23, a: a};
};
var $author$project$Page$PolicyDetails$Msg$InterruptionButtonPressed = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$PolicyDetails$Msg$IssueRefundRequest = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$PolicyDetails$Msg$OpenAmendModal = function (a) {
	return {$: 50, a: a};
};
var $author$project$Page$PolicyDetails$Msg$RenewalCancellationButtonPressed = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$PolicyDetails$Msg$RenewalsLinkClicked = function (a) {
	return {$: 37, a: a};
};
var $author$project$Page$PolicyDetails$Msg$RetryGetPaymentMethod = function (a) {
	return {$: 40, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ShowTooltip = function (a) {
	return {$: 6, a: a};
};
var $author$project$Common$CoverContinuity$PreviousInsuranceInfo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$PolicyDetails$Msg$ChangeEmail = function (a) {
	return {$: 46, a: a};
};
var $author$project$Common$User$hasChangeEmailPermission = function (user) {
	return A2($author$project$Common$User$hasPermission, user, 'policy:update');
};
var $author$project$Common$Portfolio$withOnChangeEmailAction = F2(
	function (action, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				hS: $elm$core$Maybe$Just(action)
			});
	});
var $author$project$Page$PolicyDetails$View$maybeAddChangeEmailActionToPortfolioConfig = F2(
	function (user, conf) {
		return $author$project$Common$User$hasChangeEmailPermission(user) ? A2($author$project$Common$Portfolio$withOnChangeEmailAction, $author$project$Page$PolicyDetails$Msg$ChangeEmail, conf) : conf;
	});
var $author$project$Page$PolicyDetails$Model$pickCustomerId = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.gm;
	},
	A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$toMaybe, $elm_community$maybe_extra$Maybe$Extra$join));
var $author$project$Common$Policy$pickData = function (_v0) {
	var policy = _v0;
	return policy;
};
var $author$project$Page$PolicyDetails$View$portfolioConfig = F3(
	function (user, policy, model) {
		var _v0 = $author$project$Common$Policy$pickData(policy);
		var vehicleOwner = _v0.me;
		var mainDriver = _v0.kP;
		var additionalDriver = _v0.jq;
		var policyHolder = _v0.io;
		var vehicle = _v0.je;
		var coverContinuity = _v0.jX;
		var product = _v0.dx;
		return A2(
			$author$project$Page$PolicyDetails$View$maybeAddChangeEmailActionToPortfolioConfig,
			user,
			$author$project$Common$Portfolio$config(vehicleOwner)(mainDriver)(additionalDriver)(policyHolder)(vehicle)(model.cM)(
				$author$project$Common$CoverContinuity$PreviousInsuranceInfo(coverContinuity))(product.mJ)(
				$author$project$Page$PolicyDetails$Model$pickCustomerId(model))(model.jZ)($elm$core$Maybe$Nothing));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$InterruptedPolicy = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Common$Policy$pickIssuingCompany = function (_v0) {
	var policy = _v0;
	return $author$project$Common$IssuingCompany$toString(policy.dx.a8);
};
var $author$project$Common$ComponentUI$DetailsResultBox$newInterruptedPolicyConfiguration = F6(
	function (i18n, actions, refundData, todayDate, policy, interruption) {
		return A3(
			$author$project$Common$ComponentUI$DetailsResultBox$InterruptedPolicy,
			{
				ny: i18n,
				a8: $author$project$Common$Policy$pickIssuingCompany(policy),
				bj: $author$project$Common$Policy$gross(policy)
			},
			{b5: actions.e7, l: policy, aU: todayDate},
			{c2: interruption, hN: actions.e4, hY: actions.hX, h3: actions.h2, b4: actions.b4, dy: refundData});
	});
var $author$project$Common$ComponentUI$DetailsResultBox$DetailsResultInterruptableData = F4(
	function (onInterruptionButtonClicked, interruptionStatus, onRenewalCancellationButtonClicked, canRenewalBeCancelled) {
		return {jC: canRenewalBeCancelled, kD: interruptionStatus, k4: onInterruptionButtonClicked, lh: onRenewalCancellationButtonClicked};
	});
var $author$project$Common$ComponentUI$DetailsResultBox$Policy = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Common$ComponentUI$DetailsResultBox$InterruptionStatus = F3(
	function (canBeWithdrawn, canBeTerminatedByCustomer, canBeTerminatedByPrima) {
		return {jz: canBeTerminatedByCustomer, jA: canBeTerminatedByPrima, jB: canBeWithdrawn};
	});
var $author$project$Common$ComponentUI$DetailsResultBox$newInterruptionStatus = function (policy) {
	return A3(
		$author$project$Common$ComponentUI$DetailsResultBox$InterruptionStatus,
		$author$project$Common$Policy$canBeWithdrawn(policy),
		$author$project$Common$Policy$canBeTerminatedByCustomer(policy),
		$author$project$Common$Policy$canBeTerminatedByPrima(policy));
};
var $author$project$Common$ComponentUI$DetailsResultBox$newPolicyConfiguration = F5(
	function (i18n, actions, user, todayDate, policy) {
		return A4(
			$author$project$Common$ComponentUI$DetailsResultBox$Policy,
			{
				ny: i18n,
				a8: $author$project$Common$Policy$pickIssuingCompany(policy),
				bj: $author$project$Common$Policy$gross(policy)
			},
			{b5: actions.e7, l: policy, aU: todayDate},
			A4(
				$author$project$Common$ComponentUI$DetailsResultBox$DetailsResultInterruptableData,
				actions.h1,
				$author$project$Common$ComponentUI$DetailsResultBox$newInterruptionStatus(policy),
				actions.ia,
				$author$project$Common$Policy$canRenewalBeCancelled(policy)),
			user);
	});
var $author$project$Common$ComponentUI$DetailsResultBox$newPolicyViewConfiguration = F6(
	function (i18n, actions, user, todayDate, refundData, policy) {
		return A2(
			$elm$core$Maybe$withDefault,
			A5($author$project$Common$ComponentUI$DetailsResultBox$newPolicyConfiguration, i18n, actions, user, todayDate, policy),
			A2(
				$elm$core$Maybe$map,
				A5($author$project$Common$ComponentUI$DetailsResultBox$newInterruptedPolicyConfiguration, i18n, actions, refundData, todayDate, policy),
				$author$project$Common$Policy$pickInterruption(policy)));
	});
var $author$project$Common$ComponentUI$DetailsResultBox$viewFromPolicy = F6(
	function (i18n, actions, user, todayDate, refundData, policy) {
		return $author$project$Common$ComponentUI$DetailsResultBox$view(
			A6($author$project$Common$ComponentUI$DetailsResultBox$newPolicyViewConfiguration, i18n, actions, user, todayDate, refundData, policy));
	});
var $author$project$Page$PolicyDetails$Msg$SendEmailButtonClicked = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Page$PolicyDetails$View$emailSendButton = F3(
	function (i18n, policyId, email) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withOnClick,
				A2($author$project$Page$PolicyDetails$Msg$SendEmailButtonClicked, policyId, email),
				A2(
					$author$project$Pyxis$Components$Button$withIconPrepend,
					$author$project$Pyxis$Components$IconSet$paperPlane,
					A2(
						$author$project$Pyxis$Components$Button$withSize,
						$author$project$Pyxis$Components$Button$sizeM,
						A2(
							$author$project$Pyxis$Components$Button$withText,
							$author$project$Translations$sendPolicyEmailModalSubmitButtonText(i18n),
							$author$project$Pyxis$Components$Button$tertiary)))));
	});
var $author$project$Page$PolicyDetails$Msg$RedirectToSearch = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$PolicyDetails$View$navigateToResults = A2(
	$elm$core$Basics$composeR,
	$author$project$Common$Policy$pickPolicyHolder,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Common$Person$pickPersonData,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aF;
			},
			A2($elm$core$Basics$composeR, $author$project$Page$Search$SearchQueryParam$DocumentId, $author$project$Page$PolicyDetails$Msg$RedirectToSearch))));
var $author$project$Page$PolicyDetails$View$viewHeaderContainer = F3(
	function (i18n, model, policy) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details-header-container')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$ComponentUI$BackToResults$view,
					i18n,
					$author$project$Page$PolicyDetails$View$navigateToResults(policy)),
					A3(
					$author$project$Page$PolicyDetails$View$emailSendButton,
					i18n,
					$author$project$Common$Policy$pickId(policy),
					$author$project$Page$PolicyDetails$Model$pickEmailRecipient(model))
				]));
	});
var $author$project$Page$PolicyDetails$View$viewPolicy = F4(
	function (i18n, user, model, policy) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-details__primary-container container-responsive padding-v-3xl')
				]),
			_List_fromArray(
				[
					A3($author$project$Page$PolicyDetails$View$viewHeaderContainer, i18n, model, policy),
					A6(
					$author$project$Common$ComponentUI$DetailsResultBox$viewFromPolicy,
					i18n,
					{
						e4: A2(
							$elm$core$Maybe$map,
							$author$project$Page$PolicyDetails$Msg$OpenAmendModal,
							$author$project$Common$Policy$pickAmendTerminationAction(policy)),
						hX: $author$project$Page$PolicyDetails$Msg$CreateRefundButtonPressed,
						e7: $author$project$Page$PolicyDetails$Msg$ShowTooltip,
						h1: $author$project$Page$PolicyDetails$Msg$InterruptionButtonPressed,
						h2: $author$project$Page$PolicyDetails$Msg$IssueRefundRequest,
						ia: $author$project$Page$PolicyDetails$Msg$RenewalCancellationButtonPressed,
						b4: $author$project$Page$PolicyDetails$Msg$RenewalsLinkClicked
					},
					user,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Common$Locale$defaultDate,
						A2($elm$core$Maybe$map, $author$project$Common$Locale$posixToCustomerDate, model.gk)),
					model.pk,
					policy),
					A3(
					$author$project$Common$Portfolio$render,
					i18n,
					model.dt,
					A3($author$project$Page$PolicyDetails$View$portfolioConfig, user, policy, model)),
					A3(
					$author$project$Common$ComponentUI$PaymentBox$view,
					i18n,
					model.lq,
					$author$project$Page$PolicyDetails$Msg$RetryGetPaymentMethod(
						$author$project$Common$Policy$pickId(policy)))
				]));
	});
var $author$project$Page$PolicyDetails$View$viewToasts = function (model) {
	return A3(
		$author$project$Pyxis$Components$Toasts$render,
		$author$project$Page$PolicyDetails$Msg$ToastMsg,
		model.t,
		A2(
			$author$project$Pyxis$Components$Toasts$withPlacement,
			$author$project$Pyxis$Components$Toasts$topRightPlacement,
			$author$project$Pyxis$Components$Toasts$config('policy-details-toaster')));
};
var $author$project$Page$PolicyDetails$View$view = F3(
	function (i18n, user, model) {
		var _v0 = model.l;
		switch (_v0.$) {
			case 3:
				var policy = _v0.a;
				var chosenExcess = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Common$CoverSelection$defaultExcess,
					A2(
						$elm$core$Maybe$map,
						$author$project$Common$CoverSelection$pickExcess,
						$krisajenkins$remotedata$RemoteData$toMaybe(model.jZ)));
				return _List_fromArray(
					[
						$author$project$Page$PolicyDetails$View$viewToasts(model),
						A4($author$project$Page$PolicyDetails$View$viewPolicy, i18n, user, model, policy),
						A2($author$project$Page$PolicyDetails$InterruptionModal$View$render, i18n, model.q),
						A2($author$project$Page$PolicyDetails$RenewalCancellationModal$render, i18n, model.ap),
						A2($author$project$Page$PolicyDetails$SendEmailModal$render, i18n, model.cl),
						A4($author$project$Page$PolicyDetails$RefundIssuingModal$render, i18n, $author$project$Page$PolicyDetails$Msg$IssueRefundDismissed, $author$project$Page$PolicyDetails$Msg$IssueRefundConfirmation, model.cg),
						A2($author$project$Page$PolicyDetails$ChangeEmailModal$render, i18n, model.bD),
						A4(
						$author$project$Common$ComponentUI$Modal$CoverPackages$render,
						i18n,
						$author$project$Common$Policy$pickSelectedBundle(policy),
						chosenExcess,
						model.ej),
						A2(
						$author$project$Common$Render$maybe,
						$author$project$Page$PolicyDetails$AmendInterruptionModal$render(i18n),
						model.W)
					]);
			case 2:
				return _List_fromArray(
					[$author$project$Common$ErrorContainer$generic]);
			default:
				return _List_fromArray(
					[
						$author$project$Page$PolicyDetails$View$viewToasts(model),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('policy-details__loading')
							]),
						_List_fromArray(
							[
								$author$project$Pyxis$Components$Loaders$Loader$render($author$project$Pyxis$Components$Loaders$Loader$spinnerSizeM)
							]))
					]);
		}
	});
var $author$project$Page$PolicyDetails$view = F3(
	function (i18n, user, model) {
		return {
			f3: A3($author$project$Page$PolicyDetails$View$view, i18n, user, model),
			i4: $author$project$Translations$routePolicyDetails(i18n)
		};
	});
var $author$project$Translations$routeSearch = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Search';
	} else {
		return 'Busqueda';
	}
};
var $author$project$Common$User$canSearchByCustomerId = function (user) {
	return A2($author$project$Common$User$hasPermission, user, 'offer:searchbycustomerid') && A2($author$project$Common$User$hasPermission, user, 'policy:searchbycustomerid');
};
var $author$project$Page$Search$Msg$Submitted = {$: 0};
var $author$project$Pyxis$Components$Form$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Page$Search$SearchBar$formContainer = F3(
	function (searchInput, onSubmit, isButtonLoading) {
		return $author$project$Pyxis$Components$Form$render(
			A2(
				$author$project$Pyxis$Components$Form$withOnSubmit,
				onSubmit,
				A2(
					$author$project$Pyxis$Components$Form$withFieldsets,
					_List_fromArray(
						[
							A2(
							$author$project$Pyxis$Components$Form$Fieldset$withContent,
							_List_fromArray(
								[
									A2(
									$author$project$Pyxis$Components$Grid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Pyxis$Components$Grid$col,
											_List_fromArray(
												[$author$project$Pyxis$Components$Grid$Col$span5]),
											_List_fromArray(
												[searchInput])),
											A2(
											$author$project$Pyxis$Components$Grid$col,
											_List_fromArray(
												[$author$project$Pyxis$Components$Grid$Col$span1]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('search-bar__button-container')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('search-bar__button-spacer')
																]),
															_List_Nil),
															$author$project$Pyxis$Components$Button$render(
															A2(
																$author$project$Pyxis$Components$Button$withLoading,
																isButtonLoading,
																A2(
																	$author$project$Pyxis$Components$Button$withType,
																	$author$project$Pyxis$Components$Button$submit,
																	A2(
																		$author$project$Pyxis$Components$Button$withSize,
																		$author$project$Pyxis$Components$Button$sizeL,
																		A2($author$project$Pyxis$Components$Button$withIconOnly, $author$project$Pyxis$Components$IconSet$magnifyingGlass, $author$project$Pyxis$Components$Button$primary)))))
														]))
												]))
										]))
								]),
							$author$project$Pyxis$Components$Form$Fieldset$config)
						]),
					A2(
						$author$project$Pyxis$Components$Form$withClassList,
						_List_fromArray(
							[
								_Utils_Tuple2('es-fe-bo--full-width', true)
							]),
						$author$project$Pyxis$Components$Form$config))));
	});
var $author$project$Page$Search$Msg$ChangedPersonalIdNumber = function (a) {
	return {$: 1, a: a};
};
var $author$project$Translations$searchBarInputCustomerIDError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid Customer ID';
	} else {
		return 'Por favor, introduce un ID Cliente válido.';
	}
};
var $author$project$Translations$searchBarInputDniError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid DNI/NIE';
	} else {
		return 'Por favor, introduce un DNI/NIE válido.';
	}
};
var $author$project$Translations$searchBarInputEmailError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid email address.';
	} else {
		return 'Por favor, introduce una dirección de correo electrónico válida.';
	}
};
var $author$project$Translations$searchBarInputGenericError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid value and search again.';
	} else {
		return 'Por favor, introduce un valor válido y busca de nuevo.';
	}
};
var $author$project$Translations$searchBarInputOfferError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid offer ID.';
	} else {
		return 'Por favor, introduce un número de oferta válido.';
	}
};
var $author$project$Translations$searchBarInputPhoneError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid phone number.';
	} else {
		return 'Por favor, introduce un número de teléfono válido.';
	}
};
var $author$project$Translations$searchBarInputPlateNumberError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid plate number.';
	} else {
		return 'Por favor, introduce un número de matrícula válido.';
	}
};
var $author$project$Translations$searchBarInputPolicyError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid policy ID.';
	} else {
		return 'Por favor, introduce un número de póliza válido.';
	}
};
var $author$project$Translations$searchBarInputQuoteError = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Please enter a valid quote ID.';
	} else {
		return 'Por favor, introduce un número de presupuesto válido.';
	}
};
var $author$project$Page$Search$SearchBar$validationErrorMessage = F2(
	function (i18n, error) {
		switch (error.$) {
			case 1:
				return $author$project$Translations$searchBarInputPolicyError(i18n);
			case 2:
				return $author$project$Translations$searchBarInputOfferError(i18n);
			case 3:
				return $author$project$Translations$searchBarInputQuoteError(i18n);
			case 0:
				return $author$project$Translations$searchBarInputGenericError(i18n);
			case 4:
				return $author$project$Translations$searchBarInputEmailError(i18n);
			case 5:
				return $author$project$Translations$searchBarInputDniError(i18n);
			case 6:
				return $author$project$Translations$searchBarInputPlateNumberError(i18n);
			case 7:
				return $author$project$Translations$searchBarInputPhoneError(i18n);
			case 9:
				return $author$project$Translations$searchBarInputGenericError(i18n);
			case 10:
				return $author$project$Translations$searchBarInputGenericError(i18n);
			default:
				return $author$project$Translations$searchBarInputCustomerIDError(i18n);
		}
	});
var $author$project$Page$Search$SearchBar$inputFieldValidations = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$SearchQueryParam$validateSearchInput,
			$elm$core$Result$mapError(
				$author$project$Page$Search$SearchBar$validationErrorMessage(i18n))));
};
var $author$project$Translations$searchBarInputHint = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You can search for: DNI/NIE, policy, offer, quote, email, phone or registration number';
	} else {
		return 'Puedes buscar por: DNI/NIE, póliza, oferta, presupuesto, email, teléfono o matrícula';
	}
};
var $author$project$Translations$searchBarInputPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Enter the customer\'s details to start searching';
	} else {
		return 'Ingresa los datos del cliente para empezar la búsqueda';
	}
};
var $author$project$Pyxis$Components$IconSet$svgDocumentSigned = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M20.12 7.12L13.88.88C13.32.32 12.55 0 11.76 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V9.24c0-.79-.32-1.56-.88-2.12zM14 3.83L17.17 7H14V3.83zM19 21c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5.76c.08 0 .16.03.24.05V7c0 1.1.9 2 2 2h4.95c.02.08.05.16.05.24V21zm-3-3h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm0-3h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$documentSigned = {eY: 'document-signed', a: $author$project$Pyxis$Components$IconSet$svgDocumentSigned};
var $author$project$Pyxis$Components$IconSet$svgKey = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M8 19a3.01 3.01 0 0 1-3-3 3.01 3.01 0 0 1 3-3 3.01 3.01 0 0 1 3 3 3.01 3.01 0 0 1-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 8a7.01 7.01 0 0 1-7-7 7.01 7.01 0 0 1 7-7c.76 0 1.5.12 2.22.36l8.07-8.07c.19-.18.44-.29.71-.29h3c.55 0 1 .45 1 1v3c0 .27-.11.52-.29.71l-1 1c-.19.18-.44.29-.71.29h-1v1c0 .27-.11.52-.29.71l-1 1c-.19.18-.44.29-.71.29h-1v1c0 .27-.11.52-.29.71l-2.07 2.07c.24.72.36 1.46.36 2.22a7.01 7.01 0 0 1-7 7zm0-12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5c0-.71-.15-1.4-.45-2.05a1.01 1.01 0 0 1 .2-1.12L15 10.59V9c0-.55.45-1 1-1h1.59l.41-.41V6c0-.55.45-1 1-1h1.59l.41-.41V3h-1.59l-8.24 8.24a.99.99 0 0 1-1.12.2C9.4 11.15 8.71 11 8 11z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$key = {eY: 'key', a: $author$project$Pyxis$Components$IconSet$svgKey};
var $author$project$Pyxis$Components$IconSet$svgPlate = '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path d=\"M21 5c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h18m0-2H3C1.34 3 0 4.34 0 6v12c0 1.66 1.34 3 3 3h18c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3h0zM3.98 9.95c.98-.02 1.49-.49 1.63-1.19h1.53v6.49H5.3v-4.04H3.98V9.95zm4.29 0c.98-.02 1.49-.49 1.63-1.19h1.53v6.49H9.59v-4.04H8.27V9.95zm4.33 3.18v-1.59h3.09v1.59H12.6zm4.27-3.18c.98-.02 1.49-.49 1.63-1.19h1.53v6.49h-1.84v-4.04h-1.32V9.95z\"/></svg>';
var $author$project$Pyxis$Components$IconSet$plate = {eY: 'plate', a: $author$project$Pyxis$Components$IconSet$svgPlate};
var $author$project$Page$Search$SearchQueryParam$searchInputToIcon = function (searchInput) {
	switch (searchInput.$) {
		case 0:
			return $author$project$Pyxis$Components$IconSet$user;
		case 1:
			return $author$project$Pyxis$Components$IconSet$documentSigned;
		case 2:
			return $author$project$Pyxis$Components$IconSet$mail;
		case 3:
			return $author$project$Pyxis$Components$IconSet$magnifyingGlass;
		case 4:
			return $author$project$Pyxis$Components$IconSet$plate;
		case 5:
			return $author$project$Pyxis$Components$IconSet$phone;
		default:
			return $author$project$Pyxis$Components$IconSet$key;
	}
};
var $author$project$Page$Search$SearchQueryParam$searchInputIcon = A2($elm$core$Basics$composeR, $author$project$Page$Search$SearchQueryParam$fromStringInputToSearchInput, $author$project$Page$Search$SearchQueryParam$searchInputToIcon);
var $author$project$Pyxis$Components$Field$Input$sizeM = 1;
var $author$project$Pyxis$Components$Field$Input$Text = 3;
var $author$project$Pyxis$Components$Field$Input$text = $author$project$Pyxis$Components$Field$Input$config(3);
var $author$project$Pyxis$Components$Field$Input$withClassList = F2(
	function (classes, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classes});
	});
var $author$project$Pyxis$Components$Field$Input$withHint = F2(
	function (hintMessage, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				gX: $elm$core$Maybe$Just(
					A2(
						$author$project$Pyxis$Components$Field$Hint$withFieldId,
						configuration.kv,
						$author$project$Pyxis$Components$Field$Hint$config(hintMessage)))
			});
	});
var $author$project$Pyxis$Components$Field$Input$IconAddon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pyxis$Components$Field$Input$Prepend = 0;
var $author$project$Pyxis$Components$Field$Input$withIconPrepend = F2(
	function (icon, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				aX: $elm$core$Maybe$Just(
					{
						aa: 0,
						bq: $author$project$Pyxis$Components$Field$Input$IconAddon(icon)
					})
			});
	});
var $author$project$Pyxis$Components$Field$Input$withId = F2(
	function (id, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{kv: id});
	});
var $author$project$Pyxis$Components$Field$Input$withPlaceholder = F2(
	function (placeholder, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				im: $elm$core$Maybe$Just(placeholder)
			});
	});
var $author$project$Pyxis$Components$Field$Input$withSize = F2(
	function (size, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{aR: size});
	});
var $author$project$Page$Search$SearchBar$searchField = F2(
	function (i18n, model) {
		return A3(
			$author$project$Pyxis$Components$Field$Input$render,
			$author$project$Page$Search$Msg$ChangedPersonalIdNumber,
			model.dB,
			A2(
				$author$project$Pyxis$Components$Field$Input$withHint,
				$author$project$Translations$searchBarInputHint(i18n),
				A2(
					$author$project$Pyxis$Components$Field$Input$withSize,
					$author$project$Pyxis$Components$Field$Input$sizeM,
					A3(
						$author$project$Pyxis$Components$Field$Input$withValidationOnSubmit,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$trim,
							$author$project$Page$Search$SearchBar$inputFieldValidations(i18n)),
						model.eT,
						A2(
							$author$project$Pyxis$Components$Field$Input$withPlaceholder,
							$author$project$Translations$searchBarInputPlaceholder(i18n),
							A2(
								$author$project$Pyxis$Components$Field$Input$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('search-bar__input', true)
									]),
								A2(
									$author$project$Pyxis$Components$Field$Input$withIconPrepend,
									$author$project$Page$Search$SearchQueryParam$searchInputIcon(
										$author$project$Pyxis$Components$Field$Input$getValue(model.dB)),
									A2(
										$author$project$Pyxis$Components$Field$Input$withId,
										model.lL,
										$author$project$Pyxis$Components$Field$Input$text('')))))))));
	});
var $author$project$Page$Search$SearchBar$genericSearchConfiguration = F2(
	function (i18n, model) {
		return A3(
			$author$project$Page$Search$SearchBar$formContainer,
			A2($author$project$Page$Search$SearchBar$searchField, i18n, model),
			$author$project$Page$Search$Msg$Submitted,
			$krisajenkins$remotedata$RemoteData$isLoading(model.kX));
	});
var $author$project$Page$Search$SearchBar$render = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$SearchBar$genericSearchConfiguration(i18n),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-bar')
					]))));
};
var $author$project$Page$Search$View$renderEmptyTitle = function (title) {
	return $author$project$Pyxis$Components$Title$render(
		A2(
			$author$project$Pyxis$Components$Title$withFontWeight,
			$author$project$Pyxis$Tokens$FontWeight$tokenBold,
			A2(
				$author$project$Pyxis$Components$Title$withSize,
				$author$project$Pyxis$Tokens$TitleSize$tokenM,
				$author$project$Pyxis$Components$Title$config(
					A2($elm$html$Html$div, _List_Nil, title)))));
};
var $author$project$Translations$searchResultsBeforeSearchText = F2(
	function (divAttrs, _v0) {
		var lang = _v0;
		if (!lang) {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Hey, it\'s a bit empty here.')
						])),
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Ready to change that?')
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('Oye, esto está algo vacío.')
						])),
					A3(
					$elm$html$Html$node,
					'div',
					_Utils_ap(_List_Nil, divAttrs),
					_List_fromArray(
						[
							$elm$html$Html$text('¿Te apetece transformarlo?')
						]))
				]);
		}
	});
var $author$project$Page$Search$View$renderBeforeSearch = function (i18n) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-result__no-search-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/assets/bag.svg'),
						$elm$html$Html$Attributes$class('search-result-status-image')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-result__no-search-text')
					]),
				_List_fromArray(
					[
						$author$project$Page$Search$View$renderEmptyTitle(
						A2($author$project$Translations$searchResultsBeforeSearchText, _List_Nil, i18n))
					]))
			]));
};
var $author$project$Page$Search$Msg$ResetSearch = {$: 9};
var $author$project$Translations$searchResultsClearSearchButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Clear search';
	} else {
		return 'Buscar nuevamente';
	}
};
var $author$project$Translations$searchResultsNoResultsText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'We couldn’t find any result. Try again.';
	} else {
		return 'No hemos encontrado ningun resultado con que coincida con esos datos. Asegúrate de que son correctos y busca de nuevo.';
	}
};
var $author$project$Translations$searchResultsNoResultsTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Sorry, no results!';
	} else {
		return 'Lo siento, no hay resultados a la vista.';
	}
};
var $author$project$Pyxis$Components$Text$withClassList = F2(
	function (classList, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{ga: classList});
	});
var $author$project$Page$Search$View$renderNoResults = function (i18n) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-result__no-results-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/assets/box.svg'),
						$elm$html$Html$Attributes$class('search-result-status-image')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-result__no-results-info')
					]),
				_List_fromArray(
					[
						$author$project$Pyxis$Components$Title$render(
						A2(
							$author$project$Pyxis$Components$Title$withFontWeight,
							$author$project$Pyxis$Tokens$FontWeight$tokenBold,
							A2(
								$author$project$Pyxis$Components$Title$withSize,
								$author$project$Pyxis$Tokens$TitleSize$tokenM,
								A2(
									$author$project$Pyxis$Components$Title$withClassList,
									_List_fromArray(
										[
											_Utils_Tuple2('no-results-info-typo', true)
										]),
									$author$project$Pyxis$Components$Title$config(
										$elm$html$Html$text(
											$author$project$Translations$searchResultsNoResultsTitle(i18n))))))),
						$author$project$Pyxis$Components$Text$render(
						A2(
							$author$project$Pyxis$Components$Text$withFontWeight,
							$author$project$Pyxis$Tokens$FontWeight$tokenBook,
							A2(
								$author$project$Pyxis$Components$Text$withSize,
								$author$project$Pyxis$Tokens$TextSize$tokenL,
								A2(
									$author$project$Pyxis$Components$Text$withClassList,
									_List_fromArray(
										[
											_Utils_Tuple2('no-results-info-typo', true)
										]),
									A2(
										$author$project$Pyxis$Components$Text$withColor,
										$author$project$Pyxis$Tokens$TypographyColor$tokenContentWeak,
										$author$project$Pyxis$Components$Text$config(
											$elm$html$Html$text(
												$author$project$Translations$searchResultsNoResultsText(i18n)))))))),
						$author$project$Pyxis$Components$Button$render(
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							$author$project$Page$Search$Msg$ResetSearch,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$searchResultsClearSearchButtonLabel(i18n),
								A2($author$project$Pyxis$Components$Button$withSize, $author$project$Pyxis$Components$Button$sizeL, $author$project$Pyxis$Components$Button$ghost))))
					]))
			]));
};
var $author$project$Page$Search$Msg$RedirectToOfferDetails = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$Search$OfferSearchResult$pickCustomerFacingId = function (_v0) {
	var offer = _v0;
	return offer.mY;
};
var $author$project$Page$Search$OfferSearchResult$pickBundleSlug = function (_v0) {
	var offer = _v0;
	return offer.mJ;
};
var $author$project$Page$Search$OfferResults$coverageName = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$OfferSearchResult$pickBundleSlug,
		$author$project$Common$Product$bundleSlugToString(i18n));
};
var $author$project$Page$Search$OfferResults$offerSourceLabel = function (source) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('text-l-bold', true),
						_Utils_Tuple2(
						'c-brand',
						$author$project$Common$Source$isPrimaSource(source))
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Common$Source$toString(source))
			]));
};
var $author$project$Page$Search$OfferSearchResult$pickCreationDate = function (_v0) {
	var offer = _v0;
	return offer.gh;
};
var $author$project$Page$Search$OfferSearchResult$pickOfferBy = function (_v0) {
	var offer = _v0;
	return offer.hJ;
};
var $author$project$Page$Search$OfferSearchResult$pickStartDate = function (_v0) {
	var offer = _v0;
	return offer.l_;
};
var $author$project$Page$Search$OfferResults$renderBottomRowItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				text,
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Pyxis$Components$Button$Min = 0;
var $author$project$Pyxis$Components$Button$min = function (_v0) {
	var configuration = _v0;
	return _Utils_update(
		configuration,
		{dX: 0});
};
var $author$project$Translations$searchResultsViewOfferButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'View offer';
	} else {
		return 'Ver oferta';
	}
};
var $author$project$Page$Search$OfferResults$renderViewButton = F2(
	function (i18n, actions) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withWidth,
				$author$project$Pyxis$Components$Button$min,
				A2(
					$author$project$Pyxis$Components$Button$withOnClick,
					actions.fa,
					A2(
						$author$project$Pyxis$Components$Button$withSize,
						$author$project$Pyxis$Components$Button$sizeM,
						A2(
							$author$project$Pyxis$Components$Button$withType,
							$author$project$Pyxis$Components$Button$button,
							A2(
								$author$project$Pyxis$Components$Button$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('search-result__offer__bottomrow__buttons__cta', true)
									]),
								A2(
									$author$project$Pyxis$Components$Button$withText,
									$author$project$Translations$searchResultsViewOfferButtonLabel(i18n),
									$author$project$Pyxis$Components$Button$tertiary)))))));
	});
var $author$project$Page$Search$OfferResults$renderButtons = F2(
	function (i18n, actions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__bottomrow__cell search-result__offer__bottomrow__buttons')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$renderViewButton, i18n, actions)
				]));
	});
var $author$project$Translations$searchResultsCoverTitle = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Cover selected';
	} else {
		return 'Cobertura seleccionada';
	}
};
var $author$project$Translations$searchResultsCreationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Creation date';
	} else {
		return 'Fecha de la oferta';
	}
};
var $author$project$Translations$searchResultsOfferSourceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Offer by';
	} else {
		return 'Oferta de';
	}
};
var $author$project$Translations$searchResultsStartDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Start date';
	} else {
		return 'Fecha de inicio';
	}
};
var $author$project$Pyxis$Components$List$withDivider = F2(
	function (divider, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{gv: divider});
	});
var $author$project$Page$Search$OfferResults$bottomRow = F3(
	function (i18n, actions, offer) {
		var items = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsCoverTitle(i18n),
				$elm$html$Html$text(
					A2($author$project$Page$Search$OfferResults$coverageName, i18n, offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsOfferSourceLabel(i18n),
				$author$project$Page$Search$OfferResults$offerSourceLabel(
					$author$project$Page$Search$OfferSearchResult$pickOfferBy(offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$OfferSearchResult$pickStartDate(offer)))),
				A2(
				$author$project$Page$Search$OfferResults$renderBottomRowItem,
				$author$project$Translations$searchResultsCreationDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$OfferSearchResult$pickCreationDate(offer))))
			]);
		var list = $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withItems,
				items,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withDivider,
						true,
						A2(
							$author$project$Pyxis$Components$List$withItemOrientation,
							$author$project$Pyxis$Components$List$itemOrientationBlock,
							A2(
								$author$project$Pyxis$Components$List$withOrientation,
								$author$project$Pyxis$Components$List$inline,
								A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-flex search-result__bottomrow')
				]),
			_List_fromArray(
				[
					list,
					A2($author$project$Page$Search$OfferResults$renderButtons, i18n, actions)
				]));
	});
var $author$project$Page$Search$OfferResults$renderCustomerFacingIdLabel = A2($elm$core$Basics$composeL, $elm$html$Html$text, $author$project$Page$Search$OfferSearchResult$pickCustomerFacingId);
var $author$project$Page$Search$OfferSearchResult$pickVehicleMake = function (_v0) {
	var offer = _v0;
	return offer.jf;
};
var $author$project$Page$Search$OfferSearchResult$pickVehicleModel = function (_v0) {
	var offer = _v0;
	return offer.jh;
};
var $author$project$Page$Search$OfferSearchResult$pickVehiclePlateNumber = function (_v0) {
	var offer = _v0;
	return offer.ji;
};
var $author$project$Page$Search$OfferResults$renderVehicleInfo = function (offer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pointed-text')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Page$Search$OfferSearchResult$pickVehiclePlateNumber(offer)))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									$author$project$Page$Search$OfferSearchResult$pickVehicleMake(offer),
									$author$project$Page$Search$OfferSearchResult$pickVehicleModel(offer)
								])))
					]))
			]));
};
var $author$project$Page$Search$OfferResults$renderInfoBlock = function (offer) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-results__offer__info-block')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeL,
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$car))),
				$author$project$Page$Search$OfferResults$renderVehicleInfo(offer)
			]));
};
var $author$project$Page$Search$OfferSearchResult$pickIsARenewal = function (_v0) {
	var offer = _v0;
	return offer.g3;
};
var $author$project$Page$Search$OfferSearchResult$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Page$Search$OfferSearchResult$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Page$Search$OfferSearchResult$pickIsARenewal(offer),
			A2($author$project$Page$Search$OfferSearchResult$renewalBadge, customClass, i18n));
	});
var $author$project$Page$Search$OfferSearchResult$statusBadge = F2(
	function (i18n, _v0) {
		var offer = _v0;
		var _v1 = offer.iR;
		switch (_v1) {
			case 8:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchasable(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 4:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			case 3:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusStartDateExpired(i18n),
					$author$project$Pyxis$Components$Badge$alert);
			case 7:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusPurchased(i18n),
					$author$project$Pyxis$Components$Badge$brand);
			case 5:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusBlocked(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 6:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRequoted(i18n),
					$author$project$Pyxis$Components$Badge$error);
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewPrice(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusNewProduct(i18n),
					$author$project$Pyxis$Components$Badge$success);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusMissingDocuments(i18n),
					$author$project$Pyxis$Components$Badge$alert);
		}
	});
var $author$project$Page$Search$OfferSearchResult$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$OfferSearchResult$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Page$Search$OfferResults$identifierRow = F2(
	function (i18n, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__identifier-row')
				]),
			_List_fromArray(
				[
					$author$project$Page$Search$OfferResults$renderCustomerFacingIdLabel(offer),
					A3($author$project$Page$Search$OfferSearchResult$renderStatusBadge, 'search-results__offer__status-badge', i18n, offer),
					A3($author$project$Page$Search$OfferSearchResult$renderRenewalBadge, 'search-results__offer__status-badge', i18n, offer),
					$author$project$Page$Search$OfferResults$renderInfoBlock(offer)
				]));
	});
var $author$project$Page$Search$OfferSearchResult$pickMainDriverBirthDate = function (_v0) {
	var offer = _v0;
	return offer.hl;
};
var $author$project$Page$Search$OfferSearchResult$pickMainDriverProvince = function (_v0) {
	var offer = _v0;
	return offer.hm;
};
var $author$project$Page$Search$OfferSearchResult$pickMainDriverRecentInsuranceCompanyName = function (_v0) {
	var offer = _v0;
	return offer.hn;
};
var $author$project$Page$Search$OfferSearchResult$pickPolicyholderDni = function (_v0) {
	var offer = _v0;
	return offer.iq;
};
var $author$project$Page$Search$OfferResults$renderSecondaryRowItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Translations$searchResultsCurrentInsuranceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Current insurance';
	} else {
		return 'Aseguradora actual';
	}
};
var $author$project$Translations$searchResultsDateOfBirthLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Driver date of birth';
	} else {
		return 'Fecha de nacimiento del cliente';
	}
};
var $author$project$Translations$searchResultsDocumentLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'DNI/NIE';
	} else {
		return 'DNI/NIE';
	}
};
var $author$project$Translations$searchResultsProvinceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Province';
	} else {
		return 'Provincia';
	}
};
var $author$project$Page$Search$OfferResults$secondaryRow = F2(
	function (i18n, offer) {
		var items = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsDocumentLabel(i18n),
				$author$project$Page$Search$OfferSearchResult$pickPolicyholderDni(offer)),
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsDateOfBirthLabel(i18n),
				$author$project$Common$Locale$formatDate(
					$author$project$Page$Search$OfferSearchResult$pickMainDriverBirthDate(offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsCurrentInsuranceLabel(i18n),
				A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Page$Search$OfferSearchResult$pickMainDriverRecentInsuranceCompanyName(offer))),
				A2(
				$author$project$Page$Search$OfferResults$renderSecondaryRowItem,
				$author$project$Translations$searchResultsProvinceLabel(i18n),
				$author$project$Page$Search$OfferSearchResult$pickMainDriverProvince(offer))
			]);
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withItemOrientation,
				$author$project$Pyxis$Components$List$itemOrientationInline,
				A2(
					$author$project$Pyxis$Components$List$withItems,
					items,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2(
							$author$project$Pyxis$Components$List$withOrientation,
							$author$project$Pyxis$Components$List$inline,
							A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl))))));
	});
var $author$project$Page$Search$OfferResults$detailsColumn = F2(
	function (i18n, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__details-column')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$identifierRow, i18n, offer),
					A2($author$project$Page$Search$OfferResults$secondaryRow, i18n, offer)
				]));
	});
var $author$project$Page$Search$OfferSearchResult$pickGrossPrice = function (_v0) {
	var offer = _v0;
	return offer.c$;
};
var $author$project$Page$Search$OfferResults$priceColumn = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$OfferSearchResult$pickGrossPrice,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$Price$toHtmlWithLargeSize(i18n),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$elm$html$Html$div(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-result__offer__price-column')
						])))));
};
var $author$project$Page$Search$OfferResults$detailsAndPriceRow = F2(
	function (i18n, offer) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__offer__details-and-price-row')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$detailsColumn, i18n, offer),
					A2($author$project$Page$Search$OfferResults$priceColumn, i18n, offer)
				]));
	});
var $author$project$Page$Search$OfferSearchResult$pickStatus = function (_v0) {
	var offer = _v0;
	return offer.iR;
};
var $author$project$Page$Search$OfferSearchResult$pickIsCustomerInformationComplete = function (_v0) {
	var offer = _v0;
	return offer.g5;
};
var $author$project$Translations$searchResultsCustomerInformationMissing = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer information missing';
	} else {
		return 'Información del cliente pendiente';
	}
};
var $author$project$Page$Search$OfferResults$renderBadgeForIncompleteCustomerInfo = function (i18n) {
	return $author$project$Pyxis$Components$Badge$render(
		A2(
			$author$project$Pyxis$Components$Badge$withClassList,
			_List_fromArray(
				[
					_Utils_Tuple2('search-result__offer-tag-missing-row', true)
				]),
			A2(
				$author$project$Pyxis$Components$Badge$withText,
				$author$project$Translations$searchResultsCustomerInformationMissing(i18n),
				$author$project$Pyxis$Components$Badge$error)));
};
var $author$project$Page$Search$OfferResults$renderOfferInfoTag = F2(
	function (i18n, offer) {
		return A2(
			$author$project$Pyxis$Commons$Render$renderIf,
			$author$project$Page$Search$OfferSearchResult$pickIsCustomerInformationComplete(offer),
			$author$project$Page$Search$OfferResults$renderBadgeForIncompleteCustomerInfo(i18n));
	});
var $author$project$Page$Search$OfferResults$labelRow = F2(
	function (i18n, offer) {
		var _v0 = $author$project$Page$Search$OfferSearchResult$pickStatus(offer);
		switch (_v0) {
			case 8:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			case 4:
				return $author$project$Pyxis$Commons$Render$empty;
			case 3:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			case 7:
				return $author$project$Pyxis$Commons$Render$empty;
			case 5:
				return $author$project$Pyxis$Commons$Render$empty;
			case 6:
				return $author$project$Pyxis$Commons$Render$empty;
			case 0:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			case 1:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
			default:
				return A2($author$project$Page$Search$OfferResults$renderOfferInfoTag, i18n, offer);
		}
	});
var $author$project$Page$Search$OfferSearchResult$pickIsAGreatLakesRenewal = function (_v0) {
	var offer = _v0;
	return offer.g2;
};
var $author$project$Page$Search$OfferResults$renderGreatLakesBanner = function (i18n) {
	return $author$project$Pyxis$Components$Message$render(
		A2(
			$author$project$Pyxis$Components$Message$withContent,
			A2($author$project$Translations$gliseRenewalBannerMessage, _List_Nil, i18n),
			A2(
				$author$project$Pyxis$Components$Message$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('search-result__offer__great-lakes-banner', true)
					]),
				$author$project$Pyxis$Components$Message$alert($author$project$Pyxis$Components$Message$tintBackground))));
};
var $author$project$Page$Search$OfferResults$viewResult = F3(
	function (i18n, actions, offer) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results__offer-result radius-xl padding-h-m padding-v-xs')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Search$OfferResults$labelRow, i18n, offer),
					A2($author$project$Page$Search$OfferResults$detailsAndPriceRow, i18n, offer),
					A2(
					$author$project$Common$Render$ifCondition,
					$author$project$Page$Search$OfferResults$renderGreatLakesBanner(i18n),
					$author$project$Page$Search$OfferSearchResult$pickIsAGreatLakesRenewal(offer)),
					A3($author$project$Page$Search$OfferResults$bottomRow, i18n, actions, offer)
				]));
	});
var $author$project$Page$Search$OfferResults$toOfferResult = F2(
	function (i18n, offer) {
		return A3(
			$author$project$Page$Search$OfferResults$viewResult,
			i18n,
			{
				fa: $author$project$Page$Search$Msg$RedirectToOfferDetails(
					$author$project$Page$Search$OfferSearchResult$pickCustomerFacingId(offer))
			},
			offer);
	});
var $author$project$Page$Search$OfferResults$view = F2(
	function (i18n, offers) {
		return A2(
			$elm$core$List$map,
			$author$project$Page$Search$OfferResults$toOfferResult(i18n),
			offers);
	});
var $author$project$Page$Search$Msg$OnViewPolicyClicked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Search$PolicySearchResult$pickId = function (_v0) {
	var policy = _v0;
	return policy.kv;
};
var $author$project$Page$Search$PolicyResults$onClickViewPolicy = function (policy) {
	return $author$project$Page$Search$Msg$OnViewPolicyClicked(
		$author$project$Page$Search$PolicySearchResult$pickId(policy));
};
var $author$project$Page$Search$PolicySearchResult$pickBundleSlug = function (_v0) {
	var policy = _v0;
	return policy.mJ;
};
var $author$project$Page$Search$PolicySearchResult$pickCustomerFacingId = function (_v0) {
	var policy = _v0;
	return policy.mY;
};
var $author$project$Page$Search$PolicySearchResult$pickEndDate = function (_v0) {
	var policy = _v0;
	return policy.ez;
};
var $author$project$Page$Search$PolicySearchResult$pickGrossPrice = function (_v0) {
	var policy = _v0;
	return policy.c$;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderDateOfBirth = function (_v0) {
	var policy = _v0;
	return policy.ip;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderDni = function (_v0) {
	var policy = _v0;
	return policy.iq;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderFirstName = function (_v0) {
	var policy = _v0;
	return policy.is;
};
var $author$project$Page$Search$PolicySearchResult$pickPolicyholderLastName = function (_v0) {
	var policy = _v0;
	return policy.it;
};
var $author$project$Page$Search$PolicySearchResult$pickSource = function (_v0) {
	var policy = _v0;
	return policy.iO;
};
var $author$project$Page$Search$PolicySearchResult$pickStartDate = function (_v0) {
	var policy = _v0;
	return policy.l_;
};
var $author$project$Page$Search$PolicyResults$policySourceLabel = function (source) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('text-l-bold', true),
						_Utils_Tuple2(
						'c-brand',
						$author$project$Common$Source$isPrimaSource(source))
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Common$Source$toString(source))
			]));
};
var $author$project$Page$Search$PolicySearchResult$pickIsARenewal = function (_v0) {
	var policy = _v0;
	return policy.g3;
};
var $author$project$Page$Search$PolicySearchResult$renewalBadge = F2(
	function (customClass, i18n) {
		return $author$project$Pyxis$Components$Badge$render(
			A2(
				$author$project$Pyxis$Components$Badge$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2(customClass, true)
					]),
				A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$offerStatusRenewal(i18n),
					$author$project$Pyxis$Components$Badge$brand)));
	});
var $author$project$Page$Search$PolicySearchResult$renderRenewalBadge = F3(
	function (customClass, i18n, offer) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			$author$project$Page$Search$PolicySearchResult$pickIsARenewal(offer),
			A2($author$project$Page$Search$PolicySearchResult$renewalBadge, customClass, i18n));
	});
var $author$project$Page$Search$PolicySearchResult$renderStatusBadge = F4(
	function (customClass, i18n, todayDate, _v0) {
		var policy = _v0;
		return A4(
			$author$project$Common$PolicyStatus$renderStatusBadge,
			i18n,
			customClass,
			A3($justinmimbs$date$Date$isBetween, policy.l_, policy.ez, todayDate),
			policy.iR);
	});
var $author$project$Translations$searchResultsEndDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'End date';
	} else {
		return 'Fecha de finalización';
	}
};
var $author$project$Translations$searchResultsPolicySourceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy by';
	} else {
		return 'Póliza de';
	}
};
var $author$project$Translations$searchResultsPolicyholderDateOfBirthLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Customer date of birth';
	} else {
		return 'Fecha de nacimiento del cliente';
	}
};
var $author$project$Translations$searchResultsPolicyholderName = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy holder name ';
	} else {
		return 'Nombre del tomador';
	}
};
var $author$project$Page$Search$PolicyResults$viewBottomRowItem = F2(
	function (title, value) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				value,
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Page$Search$PolicySearchResult$pickVehicleMaker = function (_v0) {
	var policy = _v0;
	return policy.jg;
};
var $author$project$Page$Search$PolicySearchResult$pickVehicleModel = function (_v0) {
	var policy = _v0;
	return policy.jh;
};
var $author$project$Page$Search$PolicySearchResult$pickVehiclePlateNumber = function (_v0) {
	var policy = _v0;
	return policy.ji;
};
var $author$project$Page$Search$PolicyResults$renderVehicleInfo = function (vehicle) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pointed-text')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Page$Search$PolicySearchResult$pickVehiclePlateNumber(vehicle))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									$author$project$Page$Search$PolicySearchResult$pickVehicleMaker(vehicle),
									$author$project$Page$Search$PolicySearchResult$pickVehicleModel(vehicle)
								])))
					]))
			]));
};
var $author$project$Page$Search$PolicyResults$viewInfoBlock = function (policy) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-results__policy__info-block')
			]),
		_List_fromArray(
			[
				$author$project$Pyxis$Components$Icon$render(
				A2(
					$author$project$Pyxis$Components$Icon$withSize,
					$author$project$Pyxis$Components$Icon$sizeL,
					$author$project$Pyxis$Components$Icon$config($author$project$Pyxis$Components$IconSet$car))),
				$author$project$Page$Search$PolicyResults$renderVehicleInfo(policy)
			]));
};
var $author$project$Translations$searchResultsViewPolicyButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'View policy';
	} else {
		return 'Ver póliza';
	}
};
var $author$project$Page$Search$PolicyResults$viewPolicyButton = F2(
	function (i18n, action) {
		return $author$project$Pyxis$Components$Button$render(
			A2(
				$author$project$Pyxis$Components$Button$withWidth,
				$author$project$Pyxis$Components$Button$min,
				A2(
					$author$project$Pyxis$Components$Button$withTestId,
					'view-policy',
					A2(
						$author$project$Pyxis$Components$Button$withId,
						'view-policy',
						A2(
							$author$project$Pyxis$Components$Button$withOnClick,
							action.fb,
							A2(
								$author$project$Pyxis$Components$Button$withSize,
								$author$project$Pyxis$Components$Button$sizeM,
								A2(
									$author$project$Pyxis$Components$Button$withType,
									$author$project$Pyxis$Components$Button$button,
									A2(
										$author$project$Pyxis$Components$Button$withText,
										$author$project$Translations$searchResultsViewPolicyButtonLabel(i18n),
										$author$project$Pyxis$Components$Button$tertiary))))))));
	});
var $author$project$Translations$searchResultsPolicyBadgeText = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Policy';
	} else {
		return 'Póliza';
	}
};
var $author$project$Page$Search$PolicyResults$viewPolicyTag = function (i18n) {
	return $author$project$Pyxis$Components$Badge$render(
		A2(
			$author$project$Pyxis$Components$Badge$withClassList,
			_List_fromArray(
				[
					_Utils_Tuple2('search-result__tag-policy-row', true)
				]),
			A2(
				$author$project$Pyxis$Components$Badge$withText,
				$author$project$Translations$searchResultsPolicyBadgeText(i18n),
				A2($author$project$Pyxis$Components$Badge$withEmphasis, $author$project$Pyxis$Components$Badge$strong, $author$project$Pyxis$Components$Badge$brand))));
};
var $author$project$Page$Search$PolicyResults$viewSecondaryRowItem = F2(
	function (title, value) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(value),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Page$Search$PolicyResults$viewResult = F4(
	function (i18n, todayDate, action, policy) {
		var secondaryRowItems = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$PolicyResults$viewSecondaryRowItem,
				$author$project$Translations$searchResultsDocumentLabel(i18n),
				$author$project$Page$Search$PolicySearchResult$pickPolicyholderDni(policy)),
				A2(
				$author$project$Page$Search$PolicyResults$viewSecondaryRowItem,
				$author$project$Translations$searchResultsPolicyholderDateOfBirthLabel(i18n),
				$author$project$Common$Locale$formatDate(
					$author$project$Page$Search$PolicySearchResult$pickPolicyholderDateOfBirth(policy))),
				A2(
				$author$project$Page$Search$PolicyResults$viewSecondaryRowItem,
				$author$project$Translations$searchResultsPolicyholderName(i18n),
				$author$project$Page$Search$PolicySearchResult$pickPolicyholderFirstName(policy) + (' ' + $author$project$Page$Search$PolicySearchResult$pickPolicyholderLastName(policy)))
			]);
		var secondaryRow = $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withClassList,
				_List_fromArray(
					[
						_Utils_Tuple2('search-result__policy__secondary-row', true)
					]),
				A2(
					$author$project$Pyxis$Components$List$withItems,
					secondaryRowItems,
					A2(
						$author$project$Pyxis$Components$List$withEmphasis,
						$author$project$Pyxis$Components$List$emphasisText,
						A2(
							$author$project$Pyxis$Components$List$withItemOrientation,
							$author$project$Pyxis$Components$List$itemOrientationInline,
							A2(
								$author$project$Pyxis$Components$List$withOrientation,
								$author$project$Pyxis$Components$List$inline,
								A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))))));
		var labelRow = $author$project$Page$Search$PolicyResults$viewPolicyTag(i18n);
		var identifierRow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__policy__identifier-row')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Page$Search$PolicySearchResult$pickCustomerFacingId(policy)),
					A4($author$project$Page$Search$PolicySearchResult$renderStatusBadge, 'search-results__policy__status-badge', i18n, todayDate, policy),
					A3($author$project$Page$Search$PolicySearchResult$renderRenewalBadge, 'search-results__policy__status-badge', i18n, policy),
					$author$project$Page$Search$PolicyResults$viewInfoBlock(policy),
					secondaryRow
				]));
		var topRow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-result__policy__top-row')
				]),
			_List_fromArray(
				[
					identifierRow,
					A2(
					$author$project$Common$Price$toHtmlWithLargeSize,
					i18n,
					$author$project$Page$Search$PolicySearchResult$pickGrossPrice(policy))
				]));
		var bottomRowItems = _List_fromArray(
			[
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsCoverTitle(i18n),
				$elm$html$Html$text(
					A2(
						$author$project$Common$Product$bundleSlugToString,
						i18n,
						$author$project$Page$Search$PolicySearchResult$pickBundleSlug(policy)))),
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsPolicySourceLabel(i18n),
				$author$project$Page$Search$PolicyResults$policySourceLabel(
					$author$project$Page$Search$PolicySearchResult$pickSource(policy))),
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsStartDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$PolicySearchResult$pickStartDate(policy)))),
				A2(
				$author$project$Page$Search$PolicyResults$viewBottomRowItem,
				$author$project$Translations$searchResultsEndDateLabel(i18n),
				$elm$html$Html$text(
					$author$project$Common$Locale$formatDate(
						$author$project$Page$Search$PolicySearchResult$pickEndDate(policy))))
			]);
		var bottomRowList = $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withItems,
				bottomRowItems,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withDivider,
						true,
						A2(
							$author$project$Pyxis$Components$List$withItemOrientation,
							$author$project$Pyxis$Components$List$itemOrientationBlock,
							A2(
								$author$project$Pyxis$Components$List$withOrientation,
								$author$project$Pyxis$Components$List$inline,
								A2($author$project$Pyxis$Components$List$withSize, $author$project$Pyxis$Components$List$sizeS, $author$project$Pyxis$Components$List$dl)))))));
		var bottomRow = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-flex align-items-flex-end')
				]),
			_List_fromArray(
				[
					bottomRowList,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-result__bottomrow__cell display-flex')
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Search$PolicyResults$viewPolicyButton, i18n, action)
						]))
				]));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results__policy-result radius-xl padding-xl')
				]),
			_List_fromArray(
				[labelRow, topRow, bottomRow]));
	});
var $author$project$Page$Search$PolicyResults$toPolicyResult = F3(
	function (i18n, todayDate, policy) {
		return A4(
			$author$project$Page$Search$PolicyResults$viewResult,
			i18n,
			todayDate,
			{
				fb: $author$project$Page$Search$PolicyResults$onClickViewPolicy(policy)
			},
			policy);
	});
var $author$project$Page$Search$PolicyResults$view = F3(
	function (i18n, todayDate, results) {
		return A2(
			$elm$core$List$map,
			A2($author$project$Page$Search$PolicyResults$toPolicyResult, i18n, todayDate),
			results);
	});
var $author$project$Page$Search$View$renderOffersAndPoliciesResults = F4(
	function (i18n, todayDate, policies, offers) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results display-grid')
				]),
			A2(
				$elm$core$List$append,
				A3($author$project$Page$Search$PolicyResults$view, i18n, todayDate, policies),
				A2($author$project$Page$Search$OfferResults$view, i18n, offers)));
	});
var $author$project$Page$Search$QuoteSearchResult$isActive = function (_v0) {
	var quote = _v0;
	var _v1 = quote.iR;
	if (!_v1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Search$QuoteSearchResult$pickFunnelGuaranteeSelectionUrl = function (_v0) {
	var quote = _v0;
	return quote.gM;
};
var $author$project$Translations$searchResultsCreateOfferButtonLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Create offer';
	} else {
		return 'Crear oferta';
	}
};
var $author$project$Page$Search$QuoteResults$createOfferButton = F2(
	function (i18n, quote) {
		return $author$project$Page$Search$QuoteSearchResult$isActive(quote) ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$author$project$Page$Search$QuoteSearchResult$pickFunnelGuaranteeSelectionUrl(quote)),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$author$project$Pyxis$Components$Button$render(
					A2(
						$author$project$Pyxis$Components$Button$withIconAppend,
						$author$project$Pyxis$Components$IconSet$externalLink,
						A2(
							$author$project$Pyxis$Components$Button$withSize,
							$author$project$Pyxis$Components$Button$sizeM,
							A2(
								$author$project$Pyxis$Components$Button$withText,
								$author$project$Translations$searchResultsCreateOfferButtonLabel(i18n),
								$author$project$Pyxis$Components$Button$tertiary))))
				])) : $author$project$Common$Render$empty;
	});
var $author$project$Page$Search$QuoteResults$listItem = F2(
	function (title, text) {
		return $author$project$Pyxis$Components$List$withItemAddonNone(
			A2(
				$author$project$Pyxis$Components$List$withItemText,
				$elm$html$Html$text(text),
				A2($author$project$Pyxis$Components$List$withItemTitle, title, $author$project$Pyxis$Components$List$item)));
	});
var $author$project$Page$Search$QuoteSearchResult$pickCreationDate = function (_v0) {
	var quote = _v0;
	return quote.go;
};
var $author$project$Page$Search$QuoteSearchResult$pickPolicyholderEmail = function (_v0) {
	var quote = _v0;
	return quote.ir;
};
var $author$project$Page$Search$QuoteSearchResult$pickSource = function (_v0) {
	var quote = _v0;
	return quote.iO;
};
var $author$project$Page$Search$QuoteSearchResult$pickValidUntil = function (_v0) {
	var quote = _v0;
	return quote.ja;
};
var $author$project$Translations$searchResultsQuoteCreationDateLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Creation date';
	} else {
		return 'Fecha del presupuesto';
	}
};
var $author$project$Translations$searchResultsQuoteEmailLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Email';
	} else {
		return 'Email';
	}
};
var $author$project$Translations$searchResultsQuoteEndLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'End date';
	} else {
		return 'Fecha de finalización';
	}
};
var $author$project$Translations$searchResultsQuoteSourceLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Source by';
	} else {
		return 'Presupuesto de';
	}
};
var $author$project$Page$Search$QuoteResults$quoteDetailsContentList = F2(
	function (i18n, quote) {
		return $author$project$Pyxis$Components$List$render(
			A2(
				$author$project$Pyxis$Components$List$withSize,
				$author$project$Pyxis$Components$List$sizeS,
				A2(
					$author$project$Pyxis$Components$List$withEmphasis,
					$author$project$Pyxis$Components$List$emphasisText,
					A2(
						$author$project$Pyxis$Components$List$withItemOrientation,
						$author$project$Pyxis$Components$List$itemOrientationInline,
						A2(
							$author$project$Pyxis$Components$List$withItems,
							_List_fromArray(
								[
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteSourceLabel(i18n),
									$author$project$Common$Source$toString(
										$author$project$Page$Search$QuoteSearchResult$pickSource(quote))),
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteCreationDateLabel(i18n),
									$author$project$Common$Locale$formatDate(
										$author$project$Page$Search$QuoteSearchResult$pickCreationDate(quote))),
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteEndLabel(i18n),
									$author$project$Common$Locale$formatDate(
										$author$project$Page$Search$QuoteSearchResult$pickValidUntil(quote))),
									A2(
									$author$project$Page$Search$QuoteResults$listItem,
									$author$project$Translations$searchResultsQuoteEmailLabel(i18n),
									A2(
										$elm$core$Maybe$withDefault,
										'-',
										$author$project$Page$Search$QuoteSearchResult$pickPolicyholderEmail(quote)))
								]),
							$author$project$Pyxis$Components$List$dl)))));
	});
var $author$project$Page$Search$QuoteSearchResult$pickCustomerFacingId = function (_v0) {
	var quote = _v0;
	return quote.mY;
};
var $author$project$Page$Search$QuoteResults$quoteIdentifier = function (quote) {
	return $author$project$Pyxis$Components$Title$render(
		A2(
			$author$project$Pyxis$Components$Title$withSize,
			$author$project$Pyxis$Tokens$TitleSize$tokenS,
			A2(
				$author$project$Pyxis$Components$Title$withFontWeight,
				$author$project$Pyxis$Tokens$FontWeight$tokenBold,
				$author$project$Pyxis$Components$Title$config(
					A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Page$Search$QuoteSearchResult$pickCustomerFacingId(quote))
							]))))));
};
var $author$project$Translations$quoteStatusActive = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Active';
	} else {
		return 'Disponible';
	}
};
var $author$project$Translations$quoteStatusBlocked = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Blocked';
	} else {
		return 'No contratable';
	}
};
var $author$project$Translations$quoteStatusExpired = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Expired';
	} else {
		return 'Caducado';
	}
};
var $author$project$Page$Search$QuoteSearchResult$statusBadge = F2(
	function (i18n, _v0) {
		var quote = _v0;
		var _v1 = quote.iR;
		switch (_v1) {
			case 0:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$quoteStatusActive(i18n),
					$author$project$Pyxis$Components$Badge$success);
			case 1:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$quoteStatusExpired(i18n),
					$author$project$Pyxis$Components$Badge$neutral);
			default:
				return A2(
					$author$project$Pyxis$Components$Badge$withText,
					$author$project$Translations$quoteStatusBlocked(i18n),
					$author$project$Pyxis$Components$Badge$error);
		}
	});
var $author$project$Page$Search$QuoteSearchResult$renderStatusBadge = F2(
	function (customClass, i18n) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$QuoteSearchResult$statusBadge(i18n),
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pyxis$Components$Badge$withClassList(
					_List_fromArray(
						[
							_Utils_Tuple2(customClass, true)
						])),
				$author$project$Pyxis$Components$Badge$render));
	});
var $author$project$Page$Search$QuoteResults$generalInfo = F2(
	function (i18n, quote) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-results__quote-result__header__general-info')
				]),
			_List_fromArray(
				[
					A3($author$project$Page$Search$QuoteSearchResult$renderStatusBadge, '', i18n, quote),
					$author$project$Page$Search$QuoteResults$quoteIdentifier(quote)
				]));
	});
var $author$project$Page$Search$QuoteSearchResult$pickVehicleMake = function (_v0) {
	var quote = _v0;
	return quote.jf;
};
var $author$project$Page$Search$QuoteSearchResult$pickVehicleModel = function (_v0) {
	var quote = _v0;
	return quote.jh;
};
var $author$project$Page$Search$QuoteSearchResult$pickVehiclePlateNumber = function (_v0) {
	var quote = _v0;
	return quote.ji;
};
var $author$project$Page$Search$QuoteResults$infoBlock = function (quote) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-results__quote-result__content__vehicle-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pointed-text')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'-',
									$author$project$Page$Search$QuoteSearchResult$pickVehiclePlateNumber(quote)))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									$author$project$Page$Search$QuoteSearchResult$pickVehicleMake(quote),
									$author$project$Page$Search$QuoteSearchResult$pickVehicleModel(quote)
								])))
					]))
			]));
};
var $author$project$Page$Search$QuoteResults$quoteDetailsHeader = F2(
	function (i18n, quote) {
		return A2(
			$author$project$Pyxis$Components$Card$withHeaderTitle,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Page$Search$QuoteResults$generalInfo, i18n, quote),
						$author$project$Page$Search$QuoteResults$infoBlock(quote)
					])),
			$author$project$Pyxis$Components$Card$header);
	});
var $author$project$Pyxis$Components$Card$withFooter = F2(
	function (footer, _v0) {
		var configuration = _v0;
		return _Utils_update(
			configuration,
			{
				eC: $elm$core$Maybe$Just(footer)
			});
	});
var $author$project$Page$Search$QuoteResults$viewQuoteDetails = F2(
	function (i18n, quote) {
		return $author$project$Pyxis$Components$Card$render(
			A2(
				$author$project$Pyxis$Components$Card$withFooter,
				A2($author$project$Page$Search$QuoteResults$createOfferButton, i18n, quote),
				A2(
					$author$project$Pyxis$Components$Card$withContent,
					A2($author$project$Page$Search$QuoteResults$quoteDetailsContentList, i18n, quote),
					A2(
						$author$project$Pyxis$Components$Card$withHeader,
						A2($author$project$Page$Search$QuoteResults$quoteDetailsHeader, i18n, quote),
						A2(
							$author$project$Pyxis$Components$Card$withClassList,
							_List_fromArray(
								[
									_Utils_Tuple2('search-results__quote-result', true)
								]),
							$author$project$Pyxis$Components$Card$config)))));
	});
var $author$project$Page$Search$QuoteResults$view = function (i18n) {
	return $elm$core$List$map(
		$author$project$Page$Search$QuoteResults$viewQuoteDetails(i18n));
};
var $author$project$Page$Search$View$renderResults = F2(
	function (i18n, model) {
		var _v0 = model.kX;
		switch (_v0.$) {
			case 3:
				var policies = _v0.a.lt;
				var offers = _v0.a.k_;
				var quotes = _v0.a.lB;
				return ($elm$core$List$isEmpty(offers) && ($elm$core$List$isEmpty(policies) && $elm$core$List$isEmpty(quotes))) ? $author$project$Page$Search$View$renderNoResults(i18n) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container-responsive search-results-container')
						]),
					A2(
						$elm$core$List$append,
						A2($author$project$Page$Search$QuoteResults$view, i18n, quotes),
						_List_fromArray(
							[
								A4(
								$author$project$Page$Search$View$renderOffersAndPoliciesResults,
								i18n,
								A2(
									$elm$core$Maybe$withDefault,
									A3($justinmimbs$date$Date$fromCalendarDate, 1970, 0, 1),
									model.gj),
								policies,
								offers)
							])));
			case 1:
				return $author$project$Common$Render$empty;
			case 0:
				return $author$project$Page$Search$View$renderBeforeSearch(i18n);
			default:
				return $author$project$Common$Render$empty;
		}
	});
var $author$project$Page$Search$Msg$AdminSearchBar = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Search$Msg$DisputesSearchSubmitted = {$: 12};
var $author$project$Page$Search$Msg$DisputeSearchChanged = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$Search$SearchQueryParam$paymentDisputeIcon = A2(
	$elm$core$Basics$composeR,
	$author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute,
	A2($elm_community$result_extra$Result$Extra$unwrap, $author$project$Pyxis$Components$IconSet$questionCircle, $author$project$Page$Search$SearchQueryParam$searchInputToIcon));
var $author$project$Page$Search$SearchBar$paymentDisputedValidations = function (i18n) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Search$SearchQueryParam$fromStringInputToPaymentDispute,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Page$Search$SearchQueryParam$validatePaymentDisputes,
			$elm$core$Result$mapError(
				$author$project$Page$Search$SearchBar$validationErrorMessage(i18n))));
};
var $author$project$Translations$searchBarPaymentDisputesHint = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'You can search for: email or Customer ID';
	} else {
		return 'Puedes buscar por email o ID cliente';
	}
};
var $author$project$Translations$searchBarPaymentDisputesPlaceholder = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Enter the payment dispute\'s details to start searching';
	} else {
		return 'Ingresa los datos de las disputa para empezar la búsqueda';
	}
};
var $author$project$Page$Search$SearchBar$disputesSearchField = F2(
	function (i18n, model) {
		return A3(
			$author$project$Pyxis$Components$Field$Input$render,
			$author$project$Page$Search$Msg$DisputeSearchChanged,
			model.ik,
			A2(
				$author$project$Pyxis$Components$Field$Input$withHint,
				$author$project$Translations$searchBarPaymentDisputesHint(i18n),
				A2(
					$author$project$Pyxis$Components$Field$Input$withSize,
					$author$project$Pyxis$Components$Field$Input$sizeM,
					A3(
						$author$project$Pyxis$Components$Field$Input$withValidationOnSubmit,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$trim,
							$author$project$Page$Search$SearchBar$paymentDisputedValidations(i18n)),
						model.g9,
						A2(
							$author$project$Pyxis$Components$Field$Input$withPlaceholder,
							$author$project$Translations$searchBarPaymentDisputesPlaceholder(i18n),
							A2(
								$author$project$Pyxis$Components$Field$Input$withClassList,
								_List_fromArray(
									[
										_Utils_Tuple2('search-bar__input', true)
									]),
								A2(
									$author$project$Pyxis$Components$Field$Input$withIconPrepend,
									$author$project$Page$Search$SearchQueryParam$paymentDisputeIcon(
										$author$project$Pyxis$Components$Field$Input$getValue(model.ik)),
									A2(
										$author$project$Pyxis$Components$Field$Input$withId,
										model.lp,
										$author$project$Pyxis$Components$Field$Input$text('')))))))));
	});
var $author$project$Page$Search$SearchBar$paymentDisputesSearchConfiguration = F2(
	function (i18n, model) {
		return A3(
			$author$project$Page$Search$SearchBar$formContainer,
			A2($author$project$Page$Search$SearchBar$disputesSearchField, i18n, model),
			$author$project$Page$Search$Msg$DisputesSearchSubmitted,
			$krisajenkins$remotedata$RemoteData$isLoading(model.kX));
	});
var $author$project$Translations$searchBarTabDisputesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Disputes';
	} else {
		return 'Disputas';
	}
};
var $author$project$Translations$searchBarTabInquiriesLabel = function (_v0) {
	var lang = _v0;
	if (!lang) {
		return 'Inquiries';
	} else {
		return 'Consultas';
	}
};
var $author$project$Page$Search$SearchBar$renderTabbed = F2(
	function (i18n, model) {
		return A3(
			$author$project$Pyxis$Components$Tabs$render,
			$author$project$Page$Search$Msg$AdminSearchBar,
			model.fQ,
			A2(
				$author$project$Pyxis$Components$Tabs$withVariant,
				$author$project$Pyxis$Components$Tabs$pill,
				A2(
					$author$project$Pyxis$Components$Tabs$withClassList,
					_List_fromArray(
						[
							_Utils_Tuple2('search-bar-tabbed', true)
						]),
					A2(
						$author$project$Pyxis$Components$Tabs$withTabs,
						_List_fromArray(
							[
								A2(
								$author$project$Pyxis$Components$Tabs$withContent,
								_List_fromArray(
									[
										A2($author$project$Page$Search$SearchBar$genericSearchConfiguration, i18n, model)
									]),
								A2(
									$author$project$Pyxis$Components$Tabs$withText,
									$author$project$Translations$searchBarTabInquiriesLabel(i18n),
									$author$project$Pyxis$Components$Tabs$tab)),
								A2(
								$author$project$Pyxis$Components$Tabs$withContent,
								_List_fromArray(
									[
										A2($author$project$Page$Search$SearchBar$paymentDisputesSearchConfiguration, i18n, model)
									]),
								A2(
									$author$project$Pyxis$Components$Tabs$withText,
									$author$project$Translations$searchBarTabDisputesLabel(i18n),
									$author$project$Pyxis$Components$Tabs$tab))
							]),
						$author$project$Pyxis$Components$Tabs$config('admin-search-bar')))));
	});
var $author$project$Page$Search$View$view = F3(
	function (i18n, user, model) {
		var searchBarSection = $author$project$Common$User$canSearchByCustomerId(user) ? A2($author$project$Page$Search$SearchBar$renderTabbed, i18n, model) : A2($author$project$Page$Search$SearchBar$render, i18n, model);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container-responsive padding-v-3xl search-page')
					]),
				_List_fromArray(
					[
						searchBarSection,
						A2($author$project$Page$Search$View$renderResults, i18n, model),
						A3(
						$author$project$Pyxis$Components$Toasts$render,
						$author$project$Page$Search$Msg$ToastMsg,
						model.t,
						A2(
							$author$project$Pyxis$Components$Toasts$withPlacement,
							$author$project$Pyxis$Components$Toasts$topRightPlacement,
							$author$project$Pyxis$Components$Toasts$config('search-page-toaster')))
					]))
			]);
	});
var $author$project$Page$Search$view = F3(
	function (i18n, user, model) {
		return {
			f3: A3($author$project$Page$Search$View$view, i18n, user, model),
			i4: $author$project$Translations$routeSearch(i18n)
		};
	});
var $author$project$Main$view = function (model) {
	var i18n = model.ny;
	var user = model.fG;
	var env = model.m8;
	var _v0 = model.o4;
	switch (_v0.$) {
		case 0:
			return A2(
				$author$project$Main$mapDocument,
				$author$project$Msg$NotFound,
				$author$project$Page$NotFound$view(i18n));
		case 1:
			return A2(
				$author$project$Main$mapDocument,
				$author$project$Msg$NotAuthorized,
				$author$project$Page$NotAuthorized$view(i18n));
		case 2:
			var loginModel = _v0.a;
			return A2(
				$author$project$Main$mapDocument,
				$author$project$Msg$Login,
				A3($author$project$Page$Login$view, i18n, env, loginModel));
		case 3:
			var searchModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$Search,
					A3($author$project$Page$Search$view, i18n, user, searchModel)));
		case 4:
			var paymentModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$Payment,
					A2($author$project$Page$Payment$view, i18n, paymentModel)));
		case 5:
			var policyModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$PolicyDetails,
					A3($author$project$Page$PolicyDetails$view, i18n, user, policyModel)));
		default:
			var offerDetailsModel = _v0.a;
			return A2(
				$author$project$Main$addHeaderToBody,
				model,
				A2(
					$author$project$Main$mapDocument,
					$author$project$Msg$OfferDetails,
					A3($author$project$Page$OfferDetails$view, i18n, env, offerDetailsModel)));
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{nB: $author$project$Main$init, oZ: $author$project$Msg$OnUrlChange, o_: $author$project$Msg$OnUrlRequest, pF: $author$project$Main$subscriptions, pQ: $author$project$Main$handle, pS: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (newApiUrl) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (logoutPath) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (loginPath) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (localTimeZone) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (languages) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (funnelUrl) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (externalApiUrl) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (env) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (apiUrl) {
																			return $elm$json$Json$Decode$succeed(
																				{cF: apiUrl, m8: env, cX: externalApiUrl, cZ: funnelUrl, hg: languages, db: localTimeZone, dc: loginPath, dd: logoutPath, df: newApiUrl});
																		},
																		A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'env', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'externalApiUrl', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'funnelUrl', $elm$json$Json$Decode$string));
										},
										A2(
											$elm$json$Json$Decode$field,
											'languages',
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
								},
								A2($elm$json$Json$Decode$field, 'localTimeZone', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'loginPath', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'logoutPath', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'newApiUrl', $elm$json$Json$Decode$string)))(0)}});}(this));